import * as React from 'react';
import React__default, { useState, useEffect, useCallback, lazy, Suspense, useRef, createContext, useContext, useImperativeHandle, Fragment, forwardRef, useLayoutEffect } from 'react';
import styled, { keyframes, css, useTheme, ThemeContext, ThemeProvider, createGlobalStyle } from 'styled-components';
import { up as up$1, down as down$1, between as between$1, only as only$1 } from 'styled-breakpoints';
import { motion, AnimatePresence, useMotionValue, animate, AnimateSharedLayout } from 'framer-motion';
import Slider$1 from 'react-slick';
import debounce from 'lodash/debounce';
import DOMPurify from 'isomorphic-dompurify';
import ContentLoader from 'react-content-loader';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import ReactSelect, { components } from 'react-select';
import isEmpty from 'lodash/isEmpty';
import Autosuggest from 'react-autosuggest';
import { useController, useFormContext, useForm, FormProvider } from 'react-hook-form';
import fill from 'lodash/fill';
import isNaN from 'lodash/isNaN';
import repeat from 'lodash/repeat';
import InputMask from 'react-input-mask';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { format } from 'date-fns';
import { enNZ } from 'date-fns/locale';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline$3 from '@tiptap/extension-underline';
import { ResizableBox } from 'react-resizable';
import { Bold, Italic, Underline as Underline$2, Strikethrough, Heading2, Heading3, Heading4, Heading5, Heading6, List as List$2, ListOrdered, Redo, Undo } from 'lucide-react';
import { zodResolver } from '@hookform/resolvers/zod';
import noop from 'lodash/noop';
import throttle from 'lodash/throttle';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { Accordion as Accordion$1, AccordionItem as AccordionItem$1, AccordionItemButton } from 'react-accessible-accordion';
import SwipeableBottomSheet from 'react-swipeable-bottom-sheet';
import Shielded from 'react-shielded';
import { Popover as Popover$4 } from 'react-tiny-popover';
import { normalize } from 'styled-normalize';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const StyledSvg = styled.svg `
  display: flex;
  align-items: center;
  path {
    fill: ${({ fill }) => fill};
  }
`;
const SvgIcon = (_a) => {
    var { component, id, width = 24, height = 24, fill, className } = _a, props = __rest(_a, ["component", "id", "width", "height", "fill", "className"]);
    const heightWithPx = `${height}px`;
    const widthWithPx = `${width}px`;
    return (React__default.createElement(StyledSvg, Object.assign({}, props, { as: component, height: heightWithPx, id: id, width: widthWithPx, fill: fill, className: className })));
};

var _path$2l, _path2$1b;
function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }
function SvgActivityHistoryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2l || (_path$2l = /*#__PURE__*/React.createElement("path", {
    d: "M16 2a8.002 8.002 0 00-7.423 5.013 7 7 0 00-2.248 13.46 1 1 0 10.84-1.812L7 18.583a5.001 5.001 0 012.24-9.578 1 1 0 001.007-.715A6 6 0 0122 10.086a1 1 0 001.198.994A4 4 0 0125 18.874s-.003.003-.007.004a1 1 0 00.223 1.987.742.742 0 00.136-.018A6 6 0 0023.939 9 8.001 8.001 0 0016 2z"
  })), _path2$1b || (_path2$1b = /*#__PURE__*/React.createElement("path", {
    d: "M15 16a1 1 0 10-2 0v8.06l-2.207-2.87a1 1 0 10-1.586 1.22L15 29.94V16zM18 30a1 1 0 01-1-1V15.06l5.793 7.53a1 1 0 11-1.586 1.22L19 20.94V29a1 1 0 01-1 1z"
  })));
}

var _rect$g, _path$2k;
function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }
function SvgAmexLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$g || (_rect$g = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#fff",
    stroke: "#DADADA"
  })), _path$2k || (_path$2k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.181 12L2 19.247h3.808l.472-1.156h1.08l.472 1.156h4.191v-.882l.374.882h2.168l.374-.9v.9h8.718l1.06-1.126.992 1.126 4.478.01-3.191-3.613L30.186 12H25.78l-1.032 1.105L23.785 12h-9.483l-.815 1.87-.833-1.87h-3.8v.852L8.43 12H5.18zm.737 1.029h1.856l2.11 4.914V13.03h2.034l1.63 3.523 1.502-3.523h2.023v5.2h-1.231l-.01-4.075-1.795 4.075h-1.102l-1.805-4.075v4.075H8.598l-.48-1.166H5.523l-.479 1.165H3.687l2.231-5.199zm17.288 0h-5.007v5.197h4.929l1.589-1.722 1.53 1.722h1.601l-2.326-2.583 2.326-2.614h-1.53l-1.581 1.703-1.531-1.703zm-16.385.88l-.855 2.077h1.709l-.854-2.077zm12.615 1.146v-.95h3.123l1.363 1.518-1.423 1.526h-3.063v-1.036h2.73v-1.058h-2.73z",
    fill: "#006FCF"
  })));
}

var _rect$f, _path$2j;
function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }
function SvgAnzLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$f || (_rect$f = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#007DBA"
  })), _path$2j || (_path$2j = /*#__PURE__*/React.createElement("path", {
    d: "M17.13 10.287c0-.62-.6-1.07-1.13-1.07-.53 0-1.13.45-1.131 1.07 0 .35.114.62.28.866.109.157.191.338.224.469.035.147.115.505-.331.511-.29.008-1.005-.24-1.584-.923a3.16 3.16 0 01-.71-2.001C12.749 7.437 14.205 6 16.002 6c1.796 0 3.249 1.437 3.249 3.209 0 .758-.264 1.453-.709 2.001-.578.683-1.293.93-1.584.923-.447-.006-.367-.364-.33-.511.033-.131.115-.312.222-.47a1.48 1.48 0 00.281-.865zM20.902 12.123c.48.072.713.23.846.338.216.175.369.486.134.81-.239.327-2.441 2.88-3.023 3.54a.531.531 0 01-.493.18c-.289-.061-.618-.397-.743-.638a2.052 2.052 0 01-.219-.572c-.21-.897.01-1.758.431-2.328.4-.54.98-.954 1.45-1.136a3.258 3.258 0 011.617-.194zM12.716 12.317a3.256 3.256 0 00-1.617-.194c-.48.072-.715.23-.847.338-.215.175-.37.486-.134.81.238.327 2.44 2.88 3.021 3.54a.532.532 0 00.494.18c.29-.061.619-.397.743-.638.097-.177.16-.32.221-.572.209-.897-.013-1.758-.431-2.328-.4-.54-.98-.954-1.45-1.136zM12.49 20.288c-.034-.193-.166-.288-.337-.288h-.606c-.63 0-1.187.333-1.498.835 0 0-.579.92-1.227 1.955h4.114l-.446-2.502zM24.694 24.36H22.55l.88-1.153h-2.382l-.849 1.11c-.317.441-.348.886-.348 1.195v.175c0 .201.126.311.313.311h4.53c.183 0 .306-.1.306-.305v-1.027c0-.206-.123-.306-.306-.306zM18.958 20c.184 0 .307.1.307.305v2.487H17.51l.235.415h1.521v2.486c0 .205-.123.307-.307.307h-.903c-.456-.01-.85-.156-1.082-.54l-1.18-2.107v2.34c0 .205-.12.307-.304.307h-1.237c-.18 0-.305-.102-.305-.307v-2.486h1.768l-.235-.415h-1.533v-2.487c0-.205.124-.305.305-.305h.912c.459.009.852.155 1.086.54l1.169 2.091v-2.326c0-.205.123-.305.306-.305h1.233zM13.009 23.207h-2.032c.035.188.213 1.182.334 1.862l.115.645c.035.19.153.286.327.286h1.398c.128 0 .192-.04.252-.113.041-.05.058-.127.04-.24l-.434-2.44zM7.023 25.881c-.034-.064-.034-.163.022-.257.014-.02.427-.68.942-1.501l.574-.916h2.173l-1.602 2.548a.517.517 0 01-.438.245H7.242c-.093 0-.18-.044-.219-.119zM20.204 21.637h2.043l-.881 1.153h2.38l.87-1.136c.268-.352.33-.666.33-.945v-.395c0-.203-.124-.314-.312-.314h-4.43c-.183 0-.305.1-.305.305v1.027c0 .204.122.305.305.305z",
    fill: "#fff"
  })));
}

var _path$2i;
function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }
function SvgAppleLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2i || (_path$2i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.64 5.195C21.728 3.848 22.553 1.944 22.254 0c-1.778.119-3.857 1.21-5.07 2.632-1.106 1.29-2.014 3.207-1.66 5.067 1.945.059 3.952-1.059 5.116-2.504zm9.61 18.283c-.778 1.663-1.152 2.407-2.155 3.88-1.398 2.056-3.37 4.617-5.815 4.636-2.17.023-2.73-1.364-5.677-1.347-2.947.015-3.56 1.373-5.735 1.353-2.444-.02-4.312-2.331-5.71-4.388C1.246 21.866.834 15.12 3.247 11.532c1.716-2.548 4.422-4.038 6.965-4.038 2.588 0 4.217 1.37 6.36 1.37 2.079 0 3.344-1.373 6.338-1.373 2.266 0 4.666 1.19 6.375 3.245-5.601 2.962-4.694 10.678.965 12.742z",
    fill: "#000"
  })));
}

var _rect$e, _path$2h;
function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }
function SvgApplePayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$e || (_rect$e = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 32,
    height: 22,
    rx: 3,
    fill: "#000"
  })), _path$2h || (_path$2h = /*#__PURE__*/React.createElement("path", {
    d: "M7.63 12.341c-.297.352-.772.629-1.248.59-.059-.476.174-.98.446-1.292.297-.362.816-.62 1.237-.639.05.495-.143.98-.435 1.341zm.43.683c-.688-.04-1.277.391-1.603.391-.332 0-.832-.371-1.376-.361-.708.01-1.366.41-1.728 1.05-.742 1.276-.193 3.167.525 4.206.351.515.772 1.079 1.326 1.06.525-.02.733-.342 1.366-.342.639 0 .822.341 1.376.331.574-.01.936-.514 1.287-1.03.401-.583.564-1.152.574-1.182-.01-.01-1.108-.43-1.118-1.698-.01-1.059.866-1.564.905-1.593-.494-.733-1.267-.812-1.534-.832zm3.974-1.435v7.716h1.198v-2.638h1.658c1.515 0 2.579-1.04 2.579-2.544 0-1.505-1.045-2.534-2.54-2.534h-2.895zm1.198 1.01h1.381c1.04 0 1.633.554 1.633 1.529 0 .975-.594 1.534-1.638 1.534h-1.376V12.6zm6.424 6.765c.753 0 1.45-.38 1.767-.985h.025v.926h1.108v-3.84c0-1.114-.89-1.832-2.261-1.832-1.272 0-2.213.728-2.247 1.727h1.079c.089-.475.53-.787 1.133-.787.733 0 1.143.342 1.143.97v.426l-1.494.09c-1.391.083-2.143.652-2.143 1.642 0 1 .777 1.663 1.89 1.663zm.322-.915c-.639 0-1.044-.307-1.044-.777 0-.485.39-.768 1.138-.812l1.331-.084v.435c0 .723-.613 1.238-1.425 1.238zm4.058 2.954c1.168 0 1.718-.445 2.198-1.796l2.103-5.9H27.12l-1.41 4.558h-.026l-1.41-4.558h-1.252l2.029 5.618-.109.341c-.183.58-.48.802-1.01.802-.094 0-.277-.01-.351-.02v.926c.07.02.366.03.455.03z",
    fill: "#fff"
  })));
}

var _rect$d, _path$2g, _path2$1a;
function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }
function SvgAsbLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$d || (_rect$d = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#FFB800"
  })), _path$2g || (_path$2g = /*#__PURE__*/React.createElement("path", {
    d: "M17.58 14.553h1.75c.14 0 .196-.108.196-.195 0-.855-.9-1.358-1.598-1.358h-3.606c-.888 0-1.622.636-1.622 1.288v.684c0 .905 1.01 1.425 1.774 1.425h2.76c.583 0 .6.307.6.449 0 .13-.03.46-.62.46H15.15c-.492 0-.575-.299-.575-.448h-1.743c-.06-.016-.17.051-.17.177 0 .473.3 1.515 1.945 1.515h3.492c.905 0 1.641-.63 1.641-1.382v-.802c0-.88-1.044-1.339-1.633-1.339h-3.02a.424.424 0 01-.41-.423c0-.27.177-.417.454-.417h1.989c.21 0 .46.069.46.366zM4 13.219v2.83c0 .036.035.126.107 0l1.536-2.821.006-.01c.037-.062.128-.214-.184-.214H4.223A.213.213 0 004 13.22z",
    fill: "#000"
  })), _path2$1a || (_path2$1a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.896 13.208c.078-.134.131-.201.247-.201h1.869c.205 0 .229.038.297.15l.001.001.024.038 2.841 5.152c.073.127-.01.215-.094.215h-1.699l-.543-.991H6.411l-.506.99L4.2 18.55c-.144 0-.143-.1-.107-.164l2.803-5.178zm3.186 1.688h-2.83a.213.213 0 00-.215.223v1.242c0 .312.152.221.214.184l.01-.005 2.821-1.536c.126-.073.036-.108 0-.108zM20.896 13.196c0-.052.104-.186.177-.186h4.843c.845 0 1.894.094 1.894 1.474 0 .633-.193 1.036-.775 1.238.042.032.11.05.192.07.3.076.773.197.773 1.28 0 .487-.138 1.479-1.528 1.479h-5.406c-.066.003-.164-.112-.164-.17l-.006-5.185zm4.56.978H22.81v.88h2.706c.28 0 .387-.306.387-.45 0-.321-.31-.43-.447-.43zm.076 2.178h-2.723v.958h2.755a.473.473 0 00.485-.457c0-.403-.38-.5-.517-.5z",
    fill: "#000"
  })));
}

var _path$2f, _path2$19;
function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }
function SvgBankAccountLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2f || (_path$2f = /*#__PURE__*/React.createElement("path", {
    d: "M10 9h2v1h2v2h-3.5a.5.5 0 000 1h1c1.379 0 2.5 1.122 2.5 2.5 0 1.208-.86 2.218-2 2.45V19h-2v-1H8v-2h3.5a.5.5 0 000-1h-1A2.503 2.503 0 018 12.5c0-1.207.86-2.217 2-2.449V9zM21.078 18.647L19 13l5.647 2.077-1.36 1.361 1.713 1.7-.863.862-1.699-1.713-1.36 1.36z"
  })), _path2$19 || (_path2$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4a5 5 0 00-5 5v10a5 5 0 005 5h8v2h-5a1 1 0 100 2h12a1 1 0 100-2h-5v-2h8a5 5 0 005-5V9a5 5 0 00-5-5H7zM4 9a3 3 0 013-3h18a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V9z"
  })));
}

var _rect$c, _path$2e;
function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }
function SvgBankOfChinaLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$c || (_rect$c = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#B30738"
  })), _path$2e || (_path$2e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 6C10.477 6 6 10.476 6 16c0 5.523 4.477 10 10 10s10-4.477 10-10c0-5.524-4.477-10-10-10zM8.15 16a7.848 7.848 0 016.67-7.758v3.672l-1.635.006c-1.23 0-1.975.903-1.975 2.131v3.85c0 1.228 1.007 2.176 2.236 2.176h1.368l.006 3.688A7.856 7.856 0 018.15 16zm5.436 1.924s-.11-.01-.164-.105c-.053-.094-.039-.143-.039-.143v-3.34s-.005-.118.06-.19c.06-.068.173-.07.173-.07h4.721s.075-.011.162.037c.075.04.117.197.117.197v3.427s-.042.095-.082.128c-.038.033-.116.059-.116.059l-1.249.002-3.583-.002zm3.563 5.847l-.008-3.719h1.474c1.229 0 2.132-.923 2.132-2.151v-3.85c0-1.228-.98-2.125-2.208-2.125l-1.398.001V8.232A7.851 7.851 0 0123.85 16a7.851 7.851 0 01-6.701 7.771z",
    fill: "#fff"
  })));
}

var _path$2d;
function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }
function SvgBenefitsLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2d || (_path$2d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3h16l6 9.565L16 29 2 12.6 8 3zm19.5 9.3L22.9 5H9.1l-4.6 7.3L16 26l11.5-13.7zm-8.432-4.033a.483.483 0 01.864 0l.934 1.867 1.867.934a.483.483 0 010 .864l-1.867.934-.934 1.867a.483.483 0 01-.864 0l-.934-1.867-1.867-.934a.483.483 0 010-.864l1.867-.934.934-1.867z"
  })));
}

var _rect$b, _path$2c, _path2$18;
function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }
function SvgBnzLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$b || (_rect$b = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#002766"
  })), _path$2c || (_path$2c = /*#__PURE__*/React.createElement("path", {
    d: "M6.005 20.207c.18.052.224.053.457.053.833 0 1.41-.792 1.41-1.898 0-.507-.236-.7-.642-.7-.355 0-.797.316-.859.447l-.366 2.098zm.593-3.398c.293-.332.876-.555 1.372-.535 1.095.042 1.78.647 1.78 1.834 0 2.273-1.35 3.552-3.359 3.552-.786 0-1.69-.17-2.391-.438l1.169-6.583c.091-.538.303-.75.963-.75l.98.001-.514 2.92zM15.595 21.38c.06.129.212.265.562.262.399 0 .847-.063 1.337-.063.767 0 1.037.05 2.035.065.393.006.601-.134.691-.548.053-.243.107-.528.166-.93a7.133 7.133 0 01-1.128-.008c-.465-.03-.959-.057-1.348-.027.177-.273.468-.635.955-1.092.23-.216.644-.565 1.085-1.044.44-.48.95-1.036.794-1.746-.488.032-.833.048-1.48.048-.794 0-1.787-.047-2.317-.047-.452 0-.666.15-.75.513-.072.31-.196.984-.196.984.078-.023.433-.044.734-.043.301.002 1.11.023 1.281.045-.073.228-.79.758-1.237 1.254-.28.31-.749.842-.987 1.241-.62.33-.972.23-.915-.248l.255-1.434c.027-.275.101-.573.087-.837-.051-.932-.649-1.503-1.675-1.503-.561 0-.969.285-1.275.548 0 0-.078-.432-.657-.462l-.998-.002-.807 4.574c-.112.6.099.685.632.685l1.017.002.615-3.433c.076-.165.434-.517.884-.517.29 0 .542.14.48.516l-.313 1.848c-.081.595.122 1.07.323 1.25.264.275.639.398 1.015.413.433.017.902-.083 1.135-.264z",
    fill: "#fff"
  })), _path2$18 || (_path2$18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.727 10l.13.83c.012.08.08.135.161.135h.874l-.793.513c-.076.049-.12.14-.108.217l.13.832h-.002l-.619-.513c-.059-.05-.155-.049-.229-.002l-.794.514.41-.83c.04-.079.025-.17-.033-.218l-.62-.513h.874c.083 0 .17-.057.208-.134l.41-.831zM22.01 11.72l.13.829c.012.08.08.135.161.135h.874l-.792.513c-.076.05-.12.14-.109.218l.13.83h-.001l-.62-.512c-.059-.05-.155-.049-.228-.001l-.794.514.41-.83c.039-.08.024-.17-.034-.218l-.62-.514h.874c.084 0 .17-.056.209-.134l.41-.83zM26.835 11.72l.129.829c.013.08.08.135.162.135H28l-.793.513c-.076.05-.12.14-.108.218l.13.83h-.002l-.619-.512c-.059-.05-.155-.049-.229-.001l-.794.514.41-.83c.04-.08.025-.17-.033-.218l-.62-.514h.873c.084 0 .171-.056.21-.134l.41-.83zM23.73 15.29l.129.83c.012.08.08.136.162.136h.874l-.793.513c-.076.049-.12.14-.108.217l.13.831h-.002l-.62-.513c-.058-.05-.154-.048-.228 0l-.794.513.41-.83c.04-.079.025-.17-.033-.218l-.62-.513h.873c.084 0 .17-.057.21-.134l.41-.831z",
    fill: "#F5A300"
  })));
}

var _path$2b, _path2$17;
function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }
function SvgBroadbandLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2b || (_path$2b = /*#__PURE__*/React.createElement("path", {
    d: "M9.667 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM18.5 23a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2$17 || (_path2$17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5a1 1 0 112 0v10h22v8a5 5 0 01-5 5H7a5 5 0 01-5-5v-8h4V5zM4 23v-6h24v6a3 3 0 01-3 3H7a3 3 0 01-3-3z"
  })));
}

var _path$2a, _path2$16;
function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }
function SvgCalendarLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2a || (_path$2a = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM17.5 21.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM22.5 23a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2$16 || (_path2$16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a1 1 0 00-1 1v2H2v20a5 5 0 005 5h18a5 5 0 005-5V5h-6V3a1 1 0 10-2 0v2H10V3a1 1 0 00-1-1zm13 6V7H10v1a1 1 0 01-2 0V7H4v6h24V7h-4v1a1 1 0 11-2 0zM4 25V15h24v10a3 3 0 01-3 3H7a3 3 0 01-3-3z"
  })));
}

var _path$29;
function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }
function SvgCheckLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$29 || (_path$29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.625 7.22a1 1 0 01.156 1.405L13.113 26l-8.789-8.263a1 1 0 011.352-1.474l7.211 6.777L26.22 7.375a1 1 0 011.406-.156z"
  })));
}

var _rect$a, _path$28, _path2$15;
function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }
function SvgChinaConstructionBankLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$a || (_rect$a = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#0066B3"
  })), _path$28 || (_path$28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.862 14.374l-5.412-5.41a3.423 3.423 0 00-2.949-.976A8.983 8.983 0 007 16.855c0 4.964 4.015 8.987 8.967 8.987 4.836 0 8.776-3.866 8.96-8.669.002-.055-.018-.22-.134-.295-.144-.09-.429-.056-.429-.056h-3.469s-.33 0-.432.047c-.067.031-.16.102-.16.102l-4.227 4.237a.177.177 0 01-.25 0l-4.251-4.26a.176.176 0 010-.251l4.25-4.26a.175.175 0 01.25 0l3.9 3.909s.204.182.396.232c.177.046.44-.134.44-.134l2.051-2.07z",
    fill: "#fff"
  })), _path2$15 || (_path2$15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.839 11.597L21.935 8.7c-3.243-3.133-6.99-.976-6.99-.976s1.593-.857 3.628 1.291l4.797 4.828 1.415-1.404s.17-.213.21-.408c.037-.18-.156-.434-.156-.434z",
    fill: "#fff"
  })));
}

var _rect$9, _path$27, _path2$14;
function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }
function SvgCitibankLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$9 || (_rect$9 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#003B70"
  })), _path$27 || (_path$27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.208 7.534c2.992 0 5.933 1.497 7.703 4.005l.09.129h-2.23l-.024-.027c-1.52-1.566-3.501-2.394-5.54-2.394-2.037 0-4.018.828-5.535 2.394l-.025.027h-2.23l.091-.13c1.768-2.507 4.71-4.004 7.7-4.004z",
    fill: "#fff"
  })), _path2$14 || (_path2$14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.787 21.076c.431 0 .911-.157 1.428-.472l.114-.07-.466 1.821-.018.014c-.32.19-.845.45-1.717.433-1.284-.026-2.145-1.018-2.145-2.47v-5.33h-1.635v-1.779h1.635v-1.924l1.896-1.014v2.938h1.97v1.778h-1.97v5.01c0 .736.283 1.065.908 1.065zM11.502 19.88l-.043.041c-.684.697-1.475 1.066-2.291 1.066-1.703 0-2.939-1.277-2.939-3.04 0-1.759 1.236-3.038 2.939-3.038.816 0 1.607.371 2.291 1.07l.043.042 1.095-1.324-.03-.036c-.91-1.076-2.003-1.6-3.346-1.6-1.348 0-2.58.454-3.468 1.272-.965.886-1.475 2.135-1.475 3.615 0 1.478.51 2.73 1.475 3.617.888.822 2.12 1.273 3.468 1.273 1.343 0 2.436-.524 3.346-1.6l.03-.034-1.095-1.324zM13.703 22.658h1.934v-9.444h-1.934v9.444zM24.817 22.658h1.936v-9.444h-1.936v9.444z",
    fill: "#fff"
  })));
}

var _path$26, _path2$13;
function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }
function SvgClockLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$26 || (_path$26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.288 21.702a.997.997 0 001.414 0 .999.999 0 000-1.414l-4.706-4.705V6.999a1 1 0 00-2 0v8.998c0 .13.028.26.078.381.05.123 3.123 3.233 3.215 3.325l2 2zM6.999 16.996a1 1 0 100-2 1 1 0 000 2zM25.994 15.996a1 1 0 11-2 0 1 1 0 012 0zM15.996 25.994a1 1 0 100-2 1 1 0 000 2z"
  })), _path2$13 || (_path2$13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.623 29.516c7.466-2 11.897-9.675 9.897-17.142C27.519 4.907 19.844.476 12.377 2.477 4.911 4.477.48 12.152 2.48 19.619c2.001 7.467 9.676 11.898 17.143 9.897zm-.518-1.931c6.4-1.715 10.198-8.294 8.483-14.694-1.715-6.4-8.293-10.198-14.693-8.483-6.4 1.715-10.198 8.294-8.483 14.694 1.715 6.4 8.293 10.198 14.693 8.483z"
  })));
}

var _path$25;
function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }
function SvgCreditCardLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$25 || (_path$25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6a5 5 0 00-5 5v10a5 5 0 005 5h18a5 5 0 005-5V11a5 5 0 00-5-5H7zm-3 5a3 3 0 013-3h18a3 3 0 013 3v1H4v-1zm0 5v5a3 3 0 003 3h18a3 3 0 003-3v-5H4z"
  })));
}

var _path$24;
function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }
function SvgCrossLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$24 || (_path$24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.707 25.293a1 1 0 01-1.414 1.414L16 17.414l-9.293 9.293a1 1 0 01-1.414-1.414L14.586 16 5.293 6.707a1 1 0 011.414-1.414L16 14.586l9.293-9.293a1 1 0 111.414 1.414L17.414 16l9.293 9.293z"
  })));
}

var _path$23, _path2$12;
function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }
function SvgDataHistoryLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$23 || (_path$23 = /*#__PURE__*/React.createElement("path", {
    d: "M28 30a1 1 0 100-2H5V3a1 1 0 00-2 0v27h25z"
  })), _path2$12 || (_path2$12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3a3 3 0 000 6h9a3 3 0 100-6h-9zm9 2h-9a1 1 0 100 2h9a1 1 0 100-2zM11 11a3 3 0 100 6h4a3 3 0 100-6h-4zm4 2h-4a1 1 0 100 2h4a1 1 0 100-2zM11 19a3 3 0 100 6h15a3 3 0 100-6H11zm15 2H11a1 1 0 100 2h15a1 1 0 100-2z"
  })));
}

var _path$22, _path2$11;
function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }
function SvgDeviceBigLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$22 || (_path$22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22h-5l-.5 2h6l-.5-2z"
  })), _path2$11 || (_path2$11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7.5v12.1l-1.481 3.554C1.559 25.459 3.252 28 5.749 28h20.5c2.498 0 4.192-2.54 3.232-4.846L28 19.6V7.5A3.5 3.5 0 0024.5 4h-17A3.5 3.5 0 004 7.5zm22 0V18H6V7.5A1.5 1.5 0 017.5 6h17A1.5 1.5 0 0126 7.5zM4.365 23.923L6 20h20l1.634 3.923A1.5 1.5 0 0126.25 26H5.75a1.5 1.5 0 01-1.385-2.077z"
  })));
}

var _path$21;
function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }
function SvgDeviceHugeLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$21 || (_path$21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4h18a5 5 0 015 5v10a5 5 0 01-5 5h-8v2h5a1 1 0 110 2H10a1 1 0 110-2h5v-2H7a5 5 0 01-5-5V9a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h18a3 3 0 003-3V9a3 3 0 00-3-3H7z"
  })));
}

var _path$20, _path2$10;
function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }
function SvgDeviceLittleLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$20 || (_path$20 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24a1 1 0 100 2h2a1 1 0 100-2h-2z"
  })), _path2$10 || (_path2$10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2h-6a5 5 0 00-5 5v18a5 5 0 005 5h6a5 5 0 005-5V7a5 5 0 00-5-5zm-9 5a3 3 0 013-3h6a3 3 0 013 3v18a3 3 0 01-3 3h-6a3 3 0 01-3-3V7z"
  })));
}

var _path$1$, _path2$$;
function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }
function SvgDeviceSlimLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1$ || (_path$1$ = /*#__PURE__*/React.createElement("path", {
    d: "M16 26a1 1 0 100-2 1 1 0 000 2z"
  })), _path2$$ || (_path2$$ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2H10a5 5 0 00-5 5v18a5 5 0 005 5h12a5 5 0 005-5V7a5 5 0 00-5-5zM7 7a3 3 0 013-3h12a3 3 0 013 3v18a3 3 0 01-3 3H10a3 3 0 01-3-3V7z"
  })));
}

var _rect$8, _path$1_, _path2$_;
function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }
function SvgDinersLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$8 || (_rect$8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#fff",
    stroke: "#DADADA"
  })), _path$1_ || (_path$1_ = /*#__PURE__*/React.createElement("path", {
    d: "M15.187 20.219v-7.96c2.203.565 3.588 2.758 3.022 4.952a4.09 4.09 0 01-3.022 3.008zM10.34 15.205A4.118 4.118 0 0013.3 20.22v-7.96a4.13 4.13 0 00-2.959 2.946z",
    fill: "#0079BE"
  })), _path2$_ || (_path2$_ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.054 23.415h2.581c4.029 0 7.24-3.196 7.365-7.144v-.063c-.063-4.01-3.336-7.27-7.365-7.207h-2.896c-3.84.125-6.861 3.384-6.735 7.27 0 3.885 3.147 7.081 7.05 7.144zm-5.791-7.207c0-3.259 2.707-5.954 5.98-5.954 3.273 0 5.98 2.695 5.98 5.954s-2.707 5.954-5.98 5.954c-3.273 0-5.98-2.695-5.98-5.954z",
    fill: "#0079BE"
  })));
}

var _path$1Z, _path2$Z;
function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }
function SvgFacebookLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Z || (_path$1Z = /*#__PURE__*/React.createElement("path", {
    d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16c0 7.986 5.85 14.605 13.5 15.806V20.625H9.437V16H13.5v-3.525c0-4.01 2.389-6.225 6.043-6.225 1.751 0 3.582.313 3.582.313V10.5h-2.017c-1.988 0-2.608 1.233-2.608 2.499V16h4.438l-.71 4.625H18.5v11.18C26.15 30.606 32 23.986 32 16z",
    fill: "#1877F2"
  })), _path2$Z || (_path2$Z = /*#__PURE__*/React.createElement("path", {
    d: "M22.228 20.625l.71-4.625H18.5v-3.001c0-1.266.62-2.499 2.608-2.499h2.017V6.562s-1.83-.312-3.582-.312c-3.654 0-6.043 2.215-6.043 6.225V16H9.437v4.625H13.5v11.18a16.121 16.121 0 005 0v-11.18h3.728z",
    fill: "#fff"
  })));
}

var _path$1Y, _path2$Y;
function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }
function SvgFibreBoxLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Y || (_path$1Y = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM24.5 12a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2$Y || (_path2$Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5a5 5 0 00-5 5v12a5 5 0 005 5h18a5 5 0 005-5V10a5 5 0 00-5-5H7zm-3 5a3 3 0 013-3h18a3 3 0 013 3v12a3 3 0 01-3 3H7a3.001 3.001 0 01-2.83-2H6a1 1 0 100-2H4v-2h2a1 1 0 100-2H4v-2h2a1 1 0 100-2H4v-3z"
  })));
}

var _path$1X;
function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }
function SvgFibreNetworkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1X || (_path$1X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6a4.002 4.002 0 01-3 3.874V22h2c.009-1.002.09-2.182.31-3.498a18.252 18.252 0 011.675-5.116 16.526 16.526 0 011.01-1.746 4 4 0 111.653 1.126c-.044.064-.1.148-.163.248a16.25 16.25 0 00-2.202 5.817A20.45 20.45 0 0021 22H26v4h3v4h-2v-2h-3v-4H8v4H5v2H3v-4h3v-4h5a20.45 20.45 0 00-.283-3.169 16.253 16.253 0 00-1.491-4.55 14.54 14.54 0 00-.873-1.516 4 4 0 111.653-1.126 16.526 16.526 0 011.01 1.747 18.252 18.252 0 011.674 5.116c.22 1.316.301 2.497.31 3.498h2V9.874A4.002 4.002 0 0116 2a4 4 0 014 4zm-4 2a2 2 0 100-4 2 2 0 000 4zM9 9a2 2 0 11-4 0 2 2 0 014 0zm16 2a2 2 0 100-4 2 2 0 000 4z"
  })));
}

var _path$1W, _path2$X, _path3$e, _path4$5;
function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }
function SvgGoogleLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1W || (_path$1W = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.895 16c0-1.04.172-2.036.48-2.97L1.983 8.912A15.993 15.993 0 00.34 16c0 2.548.591 4.95 1.64 7.083l5.39-4.126A9.467 9.467 0 016.895 16z",
    fill: "#FBBC05"
  })), _path2$X || (_path2$X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.363 6.545c2.258 0 4.297.8 5.9 2.11L26.922 4c-2.84-2.473-6.482-4-10.56-4a15.975 15.975 0 00-14.38 8.912l5.393 4.118a9.442 9.442 0 018.987-6.485z",
    fill: "#EB4335"
  })), _path3$e || (_path3$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.363 25.454a9.442 9.442 0 01-8.987-6.484l-5.393 4.117A15.975 15.975 0 0016.363 32c3.908 0 7.64-1.388 10.44-3.988l-5.12-3.957c-1.443.91-3.262 1.4-5.32 1.4z",
    fill: "#34A853"
  })), _path4$5 || (_path4$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.657 16c0-.945-.146-1.964-.364-2.91h-14.93v6.183h8.594c-.43 2.107-1.6 3.728-3.273 4.782l5.118 3.957c2.942-2.73 4.855-6.797 4.855-12.012z",
    fill: "#4285F4"
  })));
}

var _rect$7, _path$1V, _path2$W, _path3$d, _path4$4, _path5$1;
function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }
function SvgGooglePayLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$7 || (_rect$7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#fff",
    stroke: "#DADADA"
  })), _path$1V || (_path$1V = /*#__PURE__*/React.createElement("path", {
    d: "M15.296 16.044v3.026h-.96v-7.473h2.546a2.304 2.304 0 011.65.647 2.08 2.08 0 01.688 1.577 2.07 2.07 0 01-.689 1.586c-.445.425-.994.637-1.648.637h-1.587zm0-3.527v2.609h1.61a1.268 1.268 0 00.95-.387 1.274 1.274 0 000-1.826 1.253 1.253 0 00-.95-.397h-1.61zM21.433 13.79c.71 0 1.27.19 1.68.569.41.38.616.9.615 1.56v3.151h-.918v-.71h-.042c-.397.585-.926.877-1.586.877-.563 0-1.035-.166-1.414-.5a1.599 1.599 0 01-.569-1.253c0-.529.2-.95.6-1.262.4-.313.934-.47 1.602-.47.57 0 1.04.104 1.408.313v-.22a1.093 1.093 0 00-.396-.85 1.36 1.36 0 00-.927-.35c-.536 0-.96.227-1.273.68l-.846-.533c.465-.668 1.154-1.002 2.066-1.002zm-1.243 3.715a.768.768 0 00.319.626c.212.167.476.256.746.25.405 0 .793-.161 1.08-.448.318-.3.477-.65.477-1.053-.3-.239-.717-.358-1.253-.358-.39 0-.715.094-.975.282-.263.19-.394.423-.394.701zM29 13.957l-3.206 7.368h-.99l1.189-2.578-2.108-4.79h1.043l1.524 3.673h.02l1.483-3.673H29z",
    fill: "#5F6368"
  })), _path2$W || (_path2$W = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 15.392a5.12 5.12 0 00-.073-.873h-4.05v1.653h2.32a1.988 1.988 0 01-.858 1.305v1.073h1.384c.81-.747 1.277-1.852 1.277-3.158z",
    fill: "#4285F4"
  })), _path3$d || (_path3$d = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 19.587c1.159 0 2.135-.38 2.846-1.036l-1.384-1.073c-.385.26-.882.41-1.462.41-1.12 0-2.07-.755-2.41-1.772H3.457v1.106a4.293 4.293 0 003.836 2.365z",
    fill: "#34A853"
  })), _path4$4 || (_path4$4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.883 16.116a2.573 2.573 0 010-1.644v-1.106H3.457a4.293 4.293 0 000 3.856l1.426-1.106z",
    fill: "#FBBC04"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.293 12.7a2.331 2.331 0 011.647.644l1.226-1.226A4.125 4.125 0 007.293 11a4.294 4.294 0 00-3.836 2.366l1.426 1.106c.34-1.017 1.29-1.772 2.41-1.772z",
    fill: "#EA4335"
  })));
}

var _path$1U, _path2$V;
function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }
function SvgHelpLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1U || (_path$1U = /*#__PURE__*/React.createElement("path", {
    d: "M7 11a1 1 0 011-1h16a1 1 0 110 2H8a1 1 0 01-1-1zM8 15a1 1 0 100 2h8a1 1 0 100-2H8z"
  })), _path2$V || (_path2$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8a5 5 0 015-5h18a5 5 0 015 5v11a5 5 0 01-5 5h-5.465L16 29l-3.535-5H7a5 5 0 01-5-5V8zm5-3a3 3 0 00-3 3v11a3 3 0 003 3h5.465a2 2 0 011.664.89L16 25.395l1.871-2.503A2 2 0 0119.535 22H25a3 3 0 003-3V8a3 3 0 00-3-3H7z"
  })));
}

var _path$1T;
function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }
function SvgHomeLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1T || (_path$1T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2l12.63 8.175a3.001 3.001 0 011.37 2.52v12.303A5 5 0 0125 30h-6v-6.002a3 3 0 10-6 0V30H7a5 5 0 01-5-5.002V12.695c0-1.018.516-1.967 1.37-2.52L16 2zm0 2.383L4.457 11.855a1 1 0 00-.457.84v12.303A3 3 0 007 28h4v-4a5 5 0 1110 0v4h4a3 3 0 003-3V12.694a1 1 0 00-.457-.84L16 4.383z"
  })));
}

var _rect$6, _g$2, _defs;
function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }
function SvgHsbcLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$6 || (_rect$6 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#DADADA"
  })), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hsbc_large_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 10H10v12h12V10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 16l-5.997-6v12L28 16zM16 16l6.003-6H10l6 6zM4 16l6 6V10l-6 6zM16 16l-6 6h12.003L16 16z",
    fill: "#DB0011"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hsbc_large_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 10)",
    d: "M0 0h24v12H0z"
  })))));
}

var _rect$5, _path$1S, _path2$U, _path3$c, _path4$3;
function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }
function SvgIcbcLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$5 || (_rect$5 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#F0F0F0"
  })), _path$1S || (_path$1S = /*#__PURE__*/React.createElement("path", {
    d: "M16.244 13.293v.927h2.976v-2.757h-1.83v-.926h1.83V7.78h-2.976v.903h2.049v.927h-1.83v2.78h1.83v.903h-2.05z",
    fill: "#CB0202"
  })), _path2$U || (_path2$U = /*#__PURE__*/React.createElement("path", {
    d: "M16 5c-3.317 0-6 2.683-6 6s2.683 6 6 6 6-2.683 6-6c-.024-3.341-2.707-6-6-6zm0 11.049a5.07 5.07 0 01-5.073-5.073A5.07 5.07 0 0116 5.902a5.07 5.07 0 015.073 5.074C21.05 13.78 18.78 16.049 16 16.049z",
    fill: "#CB0202"
  })), _path3$c || (_path3$c = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 8.683V7.78h-3v2.757h1.83v.926h-1.83v2.757h3v-.927h-2.073v-.927h1.83V9.61h-1.83v-.927",
    fill: "#CB0202"
  })), _path4$3 || (_path4$3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.756 23.126l1.93-.02c.169 0 .423.02.635.162.191.122.297.305.297.528 0 .183-.042.325-.148.427-.191.182-.509.182-.763.182h-1.951v-1.279zm0-.994v-1.117h1.76c.318 0 .827 0 .827.589 0 .223-.106.365-.297.467-.17.08-.382.08-.53.08l-1.76-.02zm1.993 3.268c.678 0 1.166-.162 1.505-.467.34-.325.403-.73.403-1.015 0-.63-.276-1.056-.806-1.3h-.02l.02-.02c.234-.121.573-.365.573-1.116 0-.406-.17-.771-.445-1.035-.318-.285-.785-.447-1.357-.447h-2.926v5.38M8.102 20H7v5.38h1.102V20zM9.014 22.66c0 .527.085.953.276 1.319.148.305.381.548.7.812.487.386 1.187.568 2.077.568h1.527v-1.015h-1.442c-.806 0-1.378-.182-1.717-.568-.255-.264-.36-.63-.382-1.076 0-.487.127-.853.403-1.137.339-.345.911-.507 1.675-.507h1.441V20.04H12.11c-.488 0-.912.04-1.273.142-.36.101-.657.243-.89.446-.34.284-.933.934-.933 2.03zM20.336 22.66c0 .527.085.974.275 1.36.17.324.403.609.7.852.466.366 1.124.528 2.078.528H25v-1.015h-1.526c-.806 0-1.379-.203-1.718-.589-.254-.284-.36-.65-.381-1.096 0-.487.148-.873.424-1.157.339-.345.911-.508 1.675-.508H25V20.02h-1.548c-.487 0-.911.04-1.272.142-.36.102-.657.244-.89.447-.297.223-.954.873-.954 2.05z",
    fill: "#201E1D"
  })));
}

var _path$1R, _path2$T;
function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }
function SvgInfoLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1R || (_path$1R = /*#__PURE__*/React.createElement("path", {
    d: "M14.522 9.495c0 .828.662 1.5 1.478 1.5a1.49 1.49 0 001.478-1.5c0-.83-.662-1.5-1.478-1.5a1.49 1.49 0 00-1.478 1.5zM15.014 13.981a.986.986 0 011.971 0v8.033a.986.986 0 01-1.97 0V13.98z"
  })), _path2$T || (_path2$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16c0 7.18-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3s13 5.82 13 13zm-2 0c0 6.075-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5s11 4.925 11 11z"
  })));
}

var _path$1Q, _path2$S;
function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }
function SvgInsightsEventsLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1Q || (_path$1Q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3a1 1 0 012 0v2h12V3a1 1 0 112 0v2h6v20a5 5 0 01-5 5H7a5 5 0 01-5-5V5h6V3zm14 4v1a1 1 0 102 0V7h4v18a3 3 0 01-3 3H7a3 3 0 01-3-3V7h4v1a1 1 0 002 0V7h12z",
    fill: "#1D1D1D"
  })), _path2$S || (_path2$S = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.707 13.293a1 1 0 010 1.414L19.414 20a2 2 0 01-2.828 0L14 17.414l-5.293 5.293a1 1 0 01-1.414-1.414L12.586 16a2 2 0 012.828 0L18 18.586l5.293-5.293a1 1 0 011.414 0z",
    fill: "#1D1D1D"
  })));
}

var _rect$4, _path$1P;
function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }
function SvgKiwibankLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#76C801"
  })), _path$1P || (_path$1P = /*#__PURE__*/React.createElement("path", {
    d: "M22.324 13.346h-1.455v5.242h1.455v-5.242zm.129-1.514c0-.48-.4-.832-.856-.832-.47 0-.868.352-.868.832 0 .493.399.833.868.833.457 0 .856-.34.856-.832zm-7.208 15.592h1.454v-3.32a.953.953 0 01.95-.727c.574 0 .856.375.856.927v3.12h1.454v-3.425c0-1.161-.669-1.935-1.853-1.935-.61 0-1.126.27-1.407.598v-.481h-1.455v5.243zm8.439-2.839l2.181-2.404H24.12l-1.795 2.076V19.8h-1.455v7.624h1.455v-2.416l1.888 2.416h1.7l-2.228-2.839zm2.486 1.982c0 .528.4.939.915.939.516 0 .915-.41.915-.939a.904.904 0 00-.915-.926.904.904 0 00-.915.926zm-14.12-4.503c-.692 0-1.373.199-1.748.433v1.255c.41-.27.903-.422 1.431-.422.739 0 1.173.317 1.173.821v.294c-.211-.153-.715-.305-1.173-.305-1.15 0-2.029.68-2.029 1.677 0 1.09.88 1.7 1.935 1.7.575 0 1.091-.2 1.267-.375v.282h1.396V24.08c0-1.279-.81-2.017-2.252-2.017zm.856 3.928c-.129.282-.516.458-.927.458-.457 0-.926-.188-.926-.645 0-.446.469-.645.926-.645.41 0 .798.176.927.457v.375zM6.78 22.064c-.563 0-1.079.27-1.314.55V19.8H4v7.624h1.466v-.434c.235.28.75.55 1.314.55 1.525 0 2.38-1.23 2.38-2.732 0-1.501-.855-2.744-2.38-2.744zm-.328 4.21c-.434 0-.822-.246-.986-.61V23.94a1.11 1.11 0 01.986-.61c.785 0 1.255.634 1.255 1.478 0 .833-.47 1.466-1.255 1.466zm-.95-14.887H4v7.201h1.501v-3.26l2.698 3.26h1.841l-3.096-3.753 2.99-3.448H8.13L5.5 14.483v-3.096zm6.58 1.959h-1.455v5.242h1.454v-5.242zm.128-1.513c0-.481-.399-.833-.856-.833-.47 0-.868.352-.868.833 0 .492.399.832.868.832.457 0 .856-.34.856-.832zm4.844 1.513h-1.115l-.855 3.342-.939-3.342h-1.454l1.595 5.242h1.337l.856-3.214.856 3.214h1.337l1.595-5.242H18.86l-.938 3.342-.868-3.342z",
    fill: "#fff"
  })));
}

var _rect$3, _path$1O, _path2$R, _path3$b;
function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }
function SvgMastercardLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#fff",
    stroke: "#DADADA"
  })), _path$1O || (_path$1O = /*#__PURE__*/React.createElement("path", {
    d: "M19.274 10.654h-6.546v10.69h6.546v-10.69z",
    fill: "#FF5F00"
  })), _path2$R || (_path2$R = /*#__PURE__*/React.createElement("path", {
    d: "M13.403 16a6.788 6.788 0 012.596-5.344 6.799 6.799 0 100 10.691 6.789 6.789 0 01-2.596-5.346z",
    fill: "#EB001B"
  })), _path3$b || (_path3$b = /*#__PURE__*/React.createElement("path", {
    d: "M27 16a6.799 6.799 0 01-11 5.345 6.799 6.799 0 000-10.691 6.799 6.799 0 0111 5.345V16z",
    fill: "#F79E1B"
  })));
}

var _path$1N;
function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }
function SvgMeLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1N || (_path$1N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3a7 7 0 100 14 7 7 0 000-14zm-5 7a5 5 0 1110 0 5 5 0 01-10 0zM12 20a7 7 0 00-7 7v2h22v-2a7 7 0 00-7-7h-8zm-5 7a5 5 0 015-5h8a5 5 0 015 5H7z"
  })));
}

var _path$1M, _path2$Q, _path3$a;
function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }
function SvgNewsLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1M || (_path$1M = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 7H7v8h13V7zM9 13V9h9v4H9z"
  })), _path2$Q || (_path2$Q = /*#__PURE__*/React.createElement("path", {
    d: "M8 18a1 1 0 100 2h11a1 1 0 100-2H8zM7 24a1 1 0 011-1h8a1 1 0 110 2H8a1 1 0 01-1-1z"
  })), _path3$a || (_path3$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 2H2v23a5 5 0 005 5h20v-.035a3.501 3.501 0 003-3.465V6h-5V2zm3 24.5a1.5 1.5 0 01-3 0V8h3v18.5zM23 4H4v21a3 3 0 003 3h16V4z"
  })));
}

var _path$1L, _path2$P;
function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }
function SvgPinLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1L || (_path$1L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.523 23.006C23.013 19.712 25 15.852 25 12.769 25 7.99 20.986 4 16 4s-9 3.99-9 8.77c0 3.082 1.987 6.942 4.477 10.236 1.208 1.598 2.453 2.956 3.467 3.894a12.5 12.5 0 001.056.89 12.5 12.5 0 001.056-.89c1.014-.938 2.26-2.296 3.467-3.894zm-4.96 5.065c-.02.009-.017.006.005-.003l-.005.003zm.869-.003c.022.009.025.012.005.003l-.005-.003zM16 30c1.65 0 11-9.692 11-17.23C27 6.845 22.05 2 16 2S5 6.846 5 12.77C5 20.307 14.35 30 16 30z"
  })), _path2$P || (_path2$P = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8z"
  })));
}

var _path$1K;
function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }
function SvgPlusLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1K || (_path$1K = /*#__PURE__*/React.createElement("path", {
    d: "M16 4a1 1 0 00-1 1v10H5a1 1 0 100 2h10v10a1 1 0 102 0V17h10a1 1 0 100-2H17V5a1 1 0 00-1-1z"
  })));
}

var _path$1J, _path2$O;
function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }
function SvgPrepaidLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1J || (_path$1J = /*#__PURE__*/React.createElement("path", {
    d: "M27 10a9 9 0 00-9-9 1 1 0 100 2 7 7 0 017 7 1 1 0 102 0zM14 6a1 1 0 00-1-1h-2a5 5 0 00-5 5v16a5 5 0 005 5h7a5 5 0 005-5V15a1 1 0 10-2 0v11a3 3 0 01-3 3h-7a3 3 0 01-3-3V10a3 3 0 013-3h2a1 1 0 001-1z"
  })), _path2$O || (_path2$O = /*#__PURE__*/React.createElement("path", {
    d: "M18 7a1 1 0 110-2 5 5 0 015 5 1 1 0 11-2 0 3 3 0 00-3-3zM16 25.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })));
}

var _path$1I, _path2$N, _path3$9;
function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }
function SvgProductsSolutionsLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1I || (_path$1I = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.99 8.557A8.861 8.861 0 0116 7c1.786 0 3.53.543 5.01 1.557a9.16 9.16 0 013.308 4.131 9.392 9.392 0 01.51 5.303 9.267 9.267 0 01-2.455 4.707 1 1 0 01-1.432-1.396 7.267 7.267 0 001.924-3.692 7.392 7.392 0 00-.401-4.173 7.162 7.162 0 00-2.584-3.23A6.862 6.862 0 0016 9a6.861 6.861 0 00-3.88 1.207 7.161 7.161 0 00-2.584 3.23 7.392 7.392 0 00-.4 4.173 7.267 7.267 0 001.923 3.692 1 1 0 01-1.432 1.396 9.267 9.267 0 01-2.455-4.707 9.392 9.392 0 01.51-5.303 9.16 9.16 0 013.308-4.13z",
    fill: "#1D1D1D"
  })), _path2$N || (_path2$N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.222 4.36A14 14 0 0125.9 25.9a1 1 0 01-1.415-1.415 12 12 0 10-16.97 0A1 1 0 116.1 25.9 14 14 0 018.222 4.36z",
    fill: "#1D1D1D"
  })), _path3$9 || (_path3$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z",
    fill: "#1D1D1D"
  })));
}

var _path$1H, _path2$M;
function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }
function SvgRolloverLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1H || (_path$1H = /*#__PURE__*/React.createElement("path", {
    d: "M13 3a5 5 0 00-4.997 4.819c-.525.12-1.023.253-1.49.397-1.23.378-2.297.85-3.08 1.418C2.673 10.188 2 10.974 2 12s.673 1.812 1.433 2.366c.783.569 1.85 1.04 3.08 1.418 2.262.696 5.263 1.136 8.562 1.206l-1.332 1.293a1 1 0 101.393 1.435l3.867-3.753-3.873-3.69a1 1 0 10-1.38 1.45l1.33 1.265c-3.146-.07-5.942-.49-7.978-1.117-1.123-.346-1.959-.737-2.492-1.125C4.055 12.345 4 12.08 4 12c0-.079.055-.345.61-.748.533-.388 1.369-.78 2.492-1.125.285-.087.584-.171.898-.25V12a1 1 0 102 0V8a2 2 0 01.084-.575l-.03.005A3.001 3.001 0 0113 5h6a3.001 3.001 0 012.946 2.43l-.03-.005A2 2 0 0122 8v4a1 1 0 102 0V9.877c.314.079.613.163.898.25 1.123.346 1.959.737 2.492 1.125.555.403.61.669.61.748 0 .058-.023.204-.252.443-.234.243-.626.52-1.207.8-1.156.56-2.868 1.044-4.97 1.361a1 1 0 10.298 1.978c2.21-.334 4.138-.858 5.543-1.538.701-.339 1.32-.74 1.778-1.216.462-.48.81-1.097.81-1.828 0-1.025-.673-1.812-1.433-2.366-.783-.569-1.85-1.04-3.08-1.418a21.32 21.32 0 00-1.49-.397A5 5 0 0019 3h-6zM24 23a1 1 0 10-2 0v1a3 3 0 01-3 3h-6a3 3 0 01-3-3v-1a1 1 0 10-2 0v1a5 5 0 005 5h6a5 5 0 005-5v-1z"
  })), _path2$M || (_path2$M = /*#__PURE__*/React.createElement("path", {
    d: "M16 25a1 1 0 100-2 1 1 0 000 2z"
  })));
}

var _path$1G;
function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }
function SvgSearchLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1G || (_path$1G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C8.477 4 4 8.477 4 14s4.477 10 10 10 10-4.477 10-10S19.523 4 14 4zM2 14C2 7.373 7.373 2 14 2s12 5.373 12 12c0 2.954-1.067 5.658-2.837 7.749l5.544 5.544a1 1 0 01-1.414 1.414l-5.544-5.544A11.952 11.952 0 0114 26C7.373 26 2 20.627 2 14zm12-6a6 6 0 00-6 6 1 1 0 11-2 0 8 8 0 018-8 1 1 0 110 2z"
  })));
}

var _path$1F;
function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }
function SvgShopLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1F || (_path$1F = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7a5 5 0 0110 0v4h7l-1.698 14.584C26.009 28.102 23.897 30 21.387 30H10.613c-2.51 0-4.622-1.898-4.915-4.416L4 11h7V7zm8 0v4h-6V7a3 3 0 116 0zM6.808 18l.856 7.35A2.98 2.98 0 0010.613 28h10.774a2.98 2.98 0 002.949-2.65l.856-7.35H6.808zm-.233-2h18.85l.349-3H6.226l.35 3z"
  })));
}

var _path$1E, _path2$L;
function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }
function SvgSocialiserLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1E || (_path$1E = /*#__PURE__*/React.createElement("path", {
    d: "M9.196 11.057a1 1 0 10-1 1.732l2.598 1.5-1.5 2.598a1 1 0 101.732 1l2.5-4.33-4.33-2.5zM19.421 8.317a1 1 0 111.732 1l-1.5 2.598 2.598 1.5a1 1 0 01-1 1.732l-4.33-2.5 2.5-4.33zM18.07 23.727a6.002 6.002 0 01-7.009-3.298l11.43-3.063a6.002 6.002 0 01-4.42 6.361z"
  })), _path2$L || (_path2$L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.623 29.523c7.469-2.001 11.901-9.678 9.9-17.146-2.001-7.469-9.678-11.901-17.146-9.9-7.469 2.001-11.901 9.678-9.9 17.146 2.001 7.469 9.678 11.901 17.146 9.9zm-.517-1.932c6.401-1.715 10.2-8.295 8.485-14.697-1.715-6.401-8.295-10.2-14.697-8.485-6.401 1.715-10.2 8.295-8.485 14.697 1.715 6.401 8.295 10.2 14.697 8.485z"
  })));
}

var _path$1D, _path2$K;
function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }
function SvgSparkBillLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1D || (_path$1D = /*#__PURE__*/React.createElement("path", {
    d: "M14 7h-2v1.051c-1.14.232-2 1.242-2 2.449 0 1.378 1.122 2.5 2.5 2.5h1a.5.5 0 010 1H10v2h2v1h2v-1.05c1.14-.232 2-1.242 2-2.45 0-1.378-1.121-2.5-2.5-2.5h-1a.5.5 0 010-1H16V8h-2V7zM9 21a1 1 0 011-1h12a1 1 0 110 2H10a1 1 0 01-1-1zM9 25a1 1 0 011-1h9a1 1 0 110 2h-9a1 1 0 01-1-1z"
  })), _path2$K || (_path2$K = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 2H5v23a5 5 0 005 5h12a5 5 0 005-5V2zM7 25V4h18v21a3 3 0 01-3 3H10a3 3 0 01-3-3z"
  })));
}

var _rect$2, _path$1C, _path2$J, _path3$8;
function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }
function SvgTsbLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#1A1C45"
  })), _path$1C || (_path$1C = /*#__PURE__*/React.createElement("path", {
    d: "M8.736 20.454H7v-1.338h5.35v1.338h-1.737v5.43H8.736v-5.43zM13.292 24.216c.485.252 1.161.446 1.938.446.596 0 1.161-.116 1.161-.66 0-1.26-3.33-.465-3.33-2.927 0-1.629 1.654-2.075 3.067-2.075.677 0 1.343.097 1.817.252l.003 1.396c-.485-.213-1.153-.31-1.688-.31-.475 0-1.262.039-1.262.63 0 1.096 3.33.359 3.33 2.802 0 1.755-1.533 2.23-3.098 2.23a6.874 6.874 0 01-1.984-.29l.046-1.494zM19.287 19.116h3.24c1.312 0 2.291.553 2.291 1.717 0 .853-.454 1.328-1.241 1.58v.02c.938.183 1.423.668 1.423 1.492 0 1.62-1.484 1.959-2.745 1.959h-2.968v-6.768zm1.878 2.676h.525c.615 0 1.251-.145 1.251-.717 0-.62-.605-.679-1.231-.679h-.546v1.396zm0 2.812h.555c.686 0 1.403-.097 1.403-.786 0-.736-.737-.804-1.383-.804h-.575v1.59z",
    fill: "#fff"
  })), _path2$J || (_path2$J = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.752V5a13.716 13.716 0 01-10 6.033 13.714 13.714 0 0110 6.033v-5.752c-2.509.001-4.96-.122-7.346-.281 2.387-.16 4.837-.283 7.346-.281z",
    fill: "#0B794B"
  })), _path3$8 || (_path3$8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.752V5a13.717 13.717 0 0010 6.033 13.715 13.715 0 00-10 6.033v-5.752c2.509.001 4.96-.122 7.346-.281-2.387-.16-4.837-.283-7.346-.281z",
    fill: "#29B58B"
  })));
}

var _path$1B, _path2$I, _path3$7;
function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
function SvgUnlimitedLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1B || (_path$1B = /*#__PURE__*/React.createElement("path", {
    d: "M5 8a5 5 0 015-5h7a5 5 0 015 5v2a1 1 0 11-2 0V8a3 3 0 00-3-3h-7a3 3 0 00-3 3v16a3 3 0 003 3h7a3 3 0 003-3v-1a1 1 0 112 0v1a5 5 0 01-5 5h-7a5 5 0 01-5-5V8z"
  })), _path2$I || (_path2$I = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.997 16.538C27.933 18.257 26.613 20 24.317 20c-1.603 0-2.636-.86-3.381-1.777-.24.27-.498.531-.776.763-.685.572-1.541 1.014-2.62 1.014-1.112 0-2.023-.42-2.647-1.11-.609-.675-.893-1.547-.893-2.39 0-.842.284-1.715.893-2.39.624-.69 1.535-1.11 2.648-1.11 1.674 0 2.726.94 3.48 1.9.254-.305.526-.604.817-.864.634-.567 1.443-1.036 2.478-1.036 1.174 0 2.135.397 2.793 1.096.647.687.92 1.583.888 2.442zm-5.777.066c.663.909 1.206 1.396 2.096 1.396 1.091 0 1.654-.757 1.683-1.538.015-.391-.111-.745-.347-.995-.224-.239-.627-.467-1.336-.467-.376 0-.73.156-1.144.526-.319.286-.62.649-.953 1.078zm-2.48-.064c-.712-1.002-1.263-1.54-2.2-1.54-.58 0-.94.205-1.163.452-.238.263-.377.64-.377 1.048 0 .407.139.785.377 1.048.223.247.583.452 1.164.452.482 0 .9-.183 1.337-.549.295-.246.573-.554.863-.91z"
  })), _path3$7 || (_path3$7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })));
}

var _path$1A, _path2$H;
function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }
function SvgViewOnlyLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1A || (_path$1A = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10a6 6 0 100 12 6 6 0 000-12zm-4 6a4 4 0 118 0 4 4 0 01-8 0z"
  })), _path2$H || (_path2$H = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.852 16.372v.001l-.002.003-.003.008-.011.028-.04.095a19.838 19.838 0 01-.757 1.537c-.536.98-1.35 2.29-2.46 3.604C24.365 24.266 20.88 27 16 27c-4.88 0-8.365-2.734-10.579-5.352a21.983 21.983 0 01-3.063-4.797 13.23 13.23 0 01-.194-.44l-.011-.027-.003-.008-.002-.003v-.002l.923-.37-.923.37L2 16l.148-.372.923.372-.923-.372v-.001l.002-.003.003-.008.011-.028.04-.095a19.86 19.86 0 01.757-1.537c.536-.98 1.35-2.29 2.46-3.604C7.635 7.734 11.12 5 16 5c4.88 0 8.365 2.734 10.579 5.352a21.975 21.975 0 013.063 4.797 13.161 13.161 0 01.194.44l.011.027.003.008.002.003L30 16l-.148.372zm-25.148.709a17.855 17.855 0 01-.542-1.072L4.158 16l.004-.009a19.981 19.981 0 012.775-4.344C8.95 9.268 11.93 7 16 7s7.05 2.266 9.063 4.648a19.98 19.98 0 012.775 4.343l.004.009-.004.009a19.98 19.98 0 01-2.775 4.344C23.05 22.732 20.07 25 16 25s-7.05-2.266-9.063-4.648a19.981 19.981 0 01-2.233-3.271z"
  })));
}

var _rect$1, _path$1z;
function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }
function SvgVisaLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.5,
    width: 31,
    height: 23,
    rx: 3.5,
    fill: "#fff",
    stroke: "#DADADA"
  })), _path$1z || (_path$1z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.447 14.684c-.015 1.17 1.042 1.822 1.838 2.21.818.399 1.093.654 1.09 1.01-.006.545-.653.785-1.258.795-1.055.016-1.669-.285-2.157-.513l-.38 1.779c.49.226 1.396.422 2.336.431 2.206 0 3.65-1.09 3.658-2.778.008-2.143-2.965-2.262-2.945-3.22.008-.29.285-.6.892-.679.3-.04 1.13-.07 2.071.363l.37-1.721A5.63 5.63 0 0019.996 12c-2.077 0-3.538 1.104-3.55 2.684zm9.063-2.536a.958.958 0 00-.894.596l-3.152 7.526h2.205l.439-1.213h2.694l.255 1.213H29l-1.696-8.122H25.51zm.308 2.194l.637 3.05h-1.743l1.107-3.05zm-12.045-2.194l-1.737 8.122h2.1l1.738-8.122h-2.1zm-3.108 0l-2.187 5.528-.884-4.7c-.104-.525-.514-.828-.97-.828H3.05l-.05.236c.734.16 1.568.416 2.073.691.309.168.397.315.499.714l1.675 6.48h2.22l3.405-8.12h-2.207z",
    fill: "#1A1F71"
  })));
}

var _path$1y, _path2$G;
function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }
function SvgVoucherLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1y || (_path$1y = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h2v1h2v2h-3.5a.5.5 0 000 1h1c1.379 0 2.5 1.122 2.5 2.5 0 1.208-.86 2.218-2 2.45V21h-2v-1h-2v-2h3.5a.5.5 0 000-1h-1a2.503 2.503 0 01-2.5-2.5c0-1.207.86-2.217 2-2.449V11zM10 15a1 1 0 112 0v2a1 1 0 11-2 0v-2z"
  })), _path2$G || (_path2$G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6h23a5 5 0 015 5v10a5 5 0 01-5 5H2v-7.05a2.5 2.5 0 000-4.9V6zm2 6.758c1.206.807 2 2.182 2 3.742s-.794 2.935-2 3.742V24h6v-2a1 1 0 112 0v2h13a3 3 0 003-3V11a3 3 0 00-3-3H12v2a1 1 0 11-2 0V8H4v4.758z"
  })));
}

var _path$1x, _path2$F;
function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
function SvgWalletLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1x || (_path$1x = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2$F || (_path2$F = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5a5 5 0 00-5 5v12a5 5 0 005 5h18a5 5 0 005-5v-7a5 5 0 00-5-5h-1a5 5 0 00-5-5H7zM4 22V12h21a3 3 0 013 3v7a3 3 0 01-3 3H7a3 3 0 01-3-3zm18-12H4a3 3 0 013-3h12a3 3 0 013 3z"
  })));
}

var _path$1w, _path2$E;
function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }
function SvgWarningLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1w || (_path$1w = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.997a.986.986 0 01-.986-.985V10.98a.986.986 0 011.971 0v8.032a.985.985 0 01-.985.985zM16 21.998a1.49 1.49 0 00-1.478 1.5c0 .83.662 1.501 1.478 1.501a1.49 1.49 0 001.478-1.5c0-.83-.662-1.5-1.478-1.5z"
  })), _path2$E || (_path2$E = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.562 4.503a2.935 2.935 0 00-5.124 0L2.398 24.502C1.265 26.502 2.688 29 4.962 29H27.04c2.274 0 3.697-2.498 2.562-4.498L18.562 4.503zm-3.416.999a.978.978 0 011.708 0L27.893 25.5c.378.667-.096 1.5-.854 1.5H4.96c-.758 0-1.232-.833-.854-1.5L15.146 5.502z"
  })));
}

var _path$1v, _path2$D, _path3$6;
function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }
function SvgWearableLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1v || (_path$1v = /*#__PURE__*/React.createElement("path", {
    d: "M20 17a1 1 0 100-2h-3v-4a1 1 0 10-2 0v6h5z"
  })), _path2$D || (_path2$D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.22 2h11.56l1.091 4.362A5.002 5.002 0 0126 11v10c0 2.1-1.294 3.897-3.129 4.638L21.781 30H10.219l-1.09-4.362A5.002 5.002 0 016 21V11c0-2.1 1.294-3.897 3.129-4.638L10.219 2zM8 21a3 3 0 003 3h10a3 3 0 003-3V11a3 3 0 00-3-3H11a3 3 0 00-3 3v10zm3.28 5l.5 2h8.44l.5-2h-9.44zm8.94-22l.5 2h-9.44l.5-2h8.44z"
  })), _path3$6 || (_path3$6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14a1 1 0 112 0v4a1 1 0 11-2 0v-4z"
  })));
}

var _rect, _path$1u;
function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }
function SvgWestpacLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ED1A3A"
  })), _path$1u || (_path$1u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.622 11.31c-.867 0-1.424.315-1.76 1.43l-2.364 7.31s-.36.978-.7 1.038h4.636c.863 0 1.63-.483 1.878-1.404l2.114-7.35s.23-.881.574-.998l-4.378-.026zM4 11.31c.342.145.564.999.564.999l2.09 7.374c.244.924 1.016 1.405 1.877 1.405h4.663c-.332-.06-.7-1.038-.7-1.038l-2.346-7.31c-.339-1.117-.908-1.43-1.747-1.43H4zm9.431 9.775V11.36l5.16.003v9.722h-5.16z",
    fill: "#fff"
  })));
}

var _path$1t, _path2$C;
function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }
function SvgWhySparkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1t || (_path$1t = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.618 4.214a1 1 0 01.168 1.404L16.11 20.478l-5.796-5.47a1 1 0 011.373-1.455l4.203 3.968L26.214 4.382a1 1 0 011.404-.168z",
    fill: "#1D1D1D"
  })), _path2$C || (_path2$C = /*#__PURE__*/React.createElement("path", {
    d: "M22.235 4.59A12.942 12.942 0 0016 3C8.82 3 3 8.82 3 16s5.82 13 13 13 13-5.82 13-13c0-1.971-.439-3.84-1.224-5.514L26.36 12.29A10.98 10.98 0 0127 16c0 6.075-4.925 11-11 11S5 22.075 5 16 9.925 5 16 5c1.792 0 3.484.429 4.979 1.189l1.256-1.599z",
    fill: "#1D1D1D"
  })));
}

var _path$1s, _path2$B;
function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }
function SvgWifiLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 32,
    height: 32,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1s || (_path$1s = /*#__PURE__*/React.createElement("path", {
    d: "M8.914 9.092C10.764 8.252 13.2 7.5 16 7.5c1.727 0 3.315.285 4.715.702a18.848 18.848 0 014.388 1.958c.52.317.923.598 1.192.798a10.172 10.172 0 01.372.288l.016.014a1 1 0 001.301-1.52h-.002l-.003-.003-.008-.008-.028-.023a12.158 12.158 0 00-.458-.356c-.311-.23-.764-.546-1.341-.898a20.852 20.852 0 00-4.858-2.167A18.505 18.505 0 0016 5.5c-3.157 0-5.879.846-7.914 1.772a20.669 20.669 0 00-2.963 1.65 15.85 15.85 0 00-1.021.748 5.95 5.95 0 00-.06.049l-.017.014-.006.005-.002.002h-.001a1 1 0 001.3 1.52l.009-.007.04-.032c.036-.03.094-.077.172-.137.156-.12.393-.295.703-.503.62-.418 1.53-.969 2.674-1.489z"
  })), _path2$B || (_path2$B = /*#__PURE__*/React.createElement("path", {
    d: "M7.96 14.46l.001-.002s-.001-.016.005-.005l.011-.01a3.49 3.49 0 01.15-.138c.097-.087.237-.206.417-.346.361-.28.887-.644 1.569-1.008A12.456 12.456 0 0116 11.5c1.446 0 2.72.237 3.8.576a12.05 12.05 0 013.103 1.485c.357.24.633.456.823.616a6.702 6.702 0 01.284.253l.02.019.006.006.002.003h.002v.002a1 1 0 01-1.411 1.416l-.004-.004a7.725 7.725 0 00-.838-.653 10.054 10.054 0 00-2.587-1.235A10.635 10.635 0 0016 13.5c-2.137 0-3.81.61-4.946 1.216-.569.303-1 .604-1.286.825a6.07 6.07 0 00-.383.323l-.013.012A1 1 0 017.96 14.46zM15.137 19.607a3.588 3.588 0 012.266.175 4.37 4.37 0 011.188.727l.036.032.004.004a1 1 0 001.41-1.42h-.002l-.001-.001-.003-.004-.009-.008-.025-.024a5.253 5.253 0 00-.356-.302 6.337 6.337 0 00-1.49-.856 5.88 5.88 0 00-1.207-.348 5.543 5.543 0 00-2.292.083 6.02 6.02 0 00-1.533.613 6.395 6.395 0 00-1.033.727 3.668 3.668 0 00-.115.106l-.009.009-.003.003-.002.002-.001.001a1 1 0 001.41 1.419l.005-.005a3.329 3.329 0 01.23-.192 4.396 4.396 0 01.853-.506 4.02 4.02 0 01.679-.235zM16 26.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })));
}

var _path$1r, _path2$A;
function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }
function SvgLinkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1r || (_path$1r = /*#__PURE__*/React.createElement("path", {
    d: "M21.612 13.543a.986.986 0 011.394 0l4.034 4.034a6.691 6.691 0 01-9.463 9.463l-4.034-4.034a.986.986 0 011.394-1.394l4.034 4.034a4.72 4.72 0 106.675-6.675l-4.034-4.034a.986.986 0 010-1.394zM17.063 10.388a.986.986 0 001.394-1.394L14.423 4.96a6.691 6.691 0 10-9.463 9.463l4.034 4.034a.986.986 0 101.394-1.394L6.354 13.03a4.72 4.72 0 016.675-6.675l4.034 4.034z",
    fill: "#1D1D1D"
  })), _path2$A || (_path2$A = /*#__PURE__*/React.createElement("path", {
    d: "M10.707 10.707a1 1 0 011.414 0l8.486 8.485a1 1 0 01-1.415 1.415l-8.485-8.486a1 1 0 010-1.414z",
    fill: "#1D1D1D"
  })));
}

var _path$1q;
function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }
function SvgUnlinkLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1q || (_path$1q = /*#__PURE__*/React.createElement("path", {
    d: "M21.612 13.543a.986.986 0 011.394 0l4.034 4.034a6.691 6.691 0 01-9.463 9.463l-4.034-4.034a.986.986 0 011.394-1.394l4.034 4.034a4.72 4.72 0 106.675-6.675l-4.034-4.034a.986.986 0 010-1.394zM17.063 10.388a.986.986 0 001.394-1.394L14.423 4.96a6.691 6.691 0 10-9.463 9.463l4.034 4.034a.986.986 0 101.394-1.394L6.354 13.03a4.72 4.72 0 016.675-6.675l4.034 4.034z",
    fill: "#1D1D1D"
  })));
}

const NAME_TO_LARGE_SVG_MAP = {
    activity_history_large: SvgActivityHistoryLarge,
    amex_large: SvgAmexLarge,
    anz_large: SvgAnzLarge,
    apple_large: SvgAppleLarge,
    apple_pay_large: SvgApplePayLarge,
    asb_large: SvgAsbLarge,
    bank_account_large: SvgBankAccountLarge,
    bank_of_china_large: SvgBankOfChinaLarge,
    benefits_large: SvgBenefitsLarge,
    bnz_large: SvgBnzLarge,
    broadband_large: SvgBroadbandLarge,
    calendar_large: SvgCalendarLarge,
    check_large: SvgCheckLarge,
    china_construction_bank_large: SvgChinaConstructionBankLarge,
    citibank_large: SvgCitibankLarge,
    clock_large: SvgClockLarge,
    credit_card_large: SvgCreditCardLarge,
    cross_large: SvgCrossLarge,
    data_history_large: SvgDataHistoryLarge,
    device_big_large: SvgDeviceBigLarge,
    device_huge_large: SvgDeviceHugeLarge,
    device_little_large: SvgDeviceLittleLarge,
    device_slim_large: SvgDeviceSlimLarge,
    diners_large: SvgDinersLarge,
    facebook_large: SvgFacebookLarge,
    fibre_box_large: SvgFibreBoxLarge,
    fibre_network_large: SvgFibreNetworkLarge,
    google_large: SvgGoogleLarge,
    google_pay_large: SvgGooglePayLarge,
    help_large: SvgHelpLarge,
    home_large: SvgHomeLarge,
    hsbc_large: SvgHsbcLarge,
    icbc_large: SvgIcbcLarge,
    info_large: SvgInfoLarge,
    kiwibank_large: SvgKiwibankLarge,
    mastercard_large: SvgMastercardLarge,
    me_large: SvgMeLarge,
    news_large: SvgNewsLarge,
    pin_large: SvgPinLarge,
    plus_large: SvgPlusLarge,
    prepaid_large: SvgPrepaidLarge,
    rollover_large: SvgRolloverLarge,
    search_large: SvgSearchLarge,
    shop_large: SvgShopLarge,
    socialiser_large: SvgSocialiserLarge,
    spark_bill_large: SvgSparkBillLarge,
    tsb_large: SvgTsbLarge,
    unlimited_large: SvgUnlimitedLarge,
    view_only_large: SvgViewOnlyLarge,
    visa_large: SvgVisaLarge,
    voucher_large: SvgVoucherLarge,
    wallet_large: SvgWalletLarge,
    warning_large: SvgWarningLarge,
    wearable_large: SvgWearableLarge,
    westpac_large: SvgWestpacLarge,
    wifi_large: SvgWifiLarge,
    products_solutions_large: SvgProductsSolutionsLarge,
    why_spark_large: SvgWhySparkLarge,
    insights_events_large: SvgInsightsEventsLarge,
    link_large: SvgLinkLarge,
    unlink_large: SvgUnlinkLarge,
};

var _path$1p, _path2$z;
function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }
function SvgActivityHistorySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1p || (_path$1p = /*#__PURE__*/React.createElement("path", {
    d: "M6.261 5.771a6.25 6.25 0 0111.91 1.482 4.75 4.75 0 011.73 9.101 1 1 0 01-.801-1.832 2.75 2.75 0 00-1.652-5.217A1 1 0 0116.25 8.25a4.25 4.25 0 00-8.325-1.21 1 1 0 01-1.006.714 3.5 3.5 0 00-2.178 6.362 1 1 0 01-1.15 1.636 5.5 5.5 0 012.67-9.981z"
  })), _path2$z || (_path2$z = /*#__PURE__*/React.createElement("path", {
    d: "M14 23.19a1 1 0 01-1-1V11.294a.1.1 0 01.18-.06l4.613 5.996a1 1 0 11-1.586 1.22L15 16.88v5.31a1 1 0 01-1 1zM11 12a1 1 0 10-2 0v5.31l-1.207-1.57a1 1 0 10-1.586 1.22l4.614 5.997a.1.1 0 00.179-.06V12z"
  })));
}

var _path$1o;
function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }
function SvgAppleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1o || (_path$1o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.337 3.896C16.12 2.886 16.714 1.458 16.5 0c-1.28.089-2.775.907-3.647 1.974-.796.967-1.45 2.405-1.194 3.8 1.399.044 2.842-.794 3.68-1.878zM22.25 17.61c-.56 1.247-.829 1.804-1.55 2.91-1.006 1.542-2.424 3.463-4.183 3.477-1.561.017-1.964-1.023-4.083-1.01-2.12.01-2.562 1.03-4.126 1.014-1.757-.016-3.101-1.749-4.107-3.291-2.814-4.31-3.11-9.369-1.375-12.06 1.235-1.91 3.182-3.028 5.011-3.028 1.861 0 3.033 1.027 4.574 1.027 1.496 0 2.406-1.03 4.56-1.03 1.63 0 3.356.893 4.585 2.434-4.029 2.221-3.377 8.009.694 9.557z",
    fill: "#000"
  })));
}

var _path$1n;
function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }
function SvgArrowDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1n || (_path$1n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.636 11.155a1 1 0 01.136 1.408L12 22l-7.772-9.437a1 1 0 011.544-1.272L11 17.64V3a1 1 0 112 0v14.64l5.228-6.349a1 1 0 011.408-.136z"
  })));
}

var _path$1m;
function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }
function SvgArrowLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1m || (_path$1m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.845 4.364a1 1 0 00-1.408-.136L2 12l9.437 7.772a1 1 0 001.272-1.544L6.36 13H21a1 1 0 100-2H6.36l6.349-5.228a1 1 0 00.136-1.408z"
  })));
}

var _path$1l;
function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }
function SvgArrowRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1l || (_path$1l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.155 4.364a1 1 0 011.408-.136L22 12l-9.437 7.772a1 1 0 11-1.272-1.544L17.64 13H3a1 1 0 110-2h14.64L11.29 5.772a1 1 0 01-.136-1.408z"
  })));
}

var _path$1k;
function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }
function SvgArrowUpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1k || (_path$1k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.636 12.845a1 1 0 00.136-1.408L12 2l-7.772 9.437a1 1 0 001.544 1.272L11 6.36V21a1 1 0 102 0V6.36l5.228 6.349a1 1 0 001.408.136z"
  })));
}

var _path$1j;
function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }
function SvgBroadbandSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3a1 1 0 00-1 1v7H1v5a5 5 0 005 5h12a5 5 0 005-5v-5H7V4a1 1 0 00-1-1zm0 10H3v3a3 3 0 003 3h12a3 3 0 003-3v-3H6zm0 4a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0z"
  })));
}

var _path$1i;
function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }
function SvgCalendarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3a1 1 0 012 0v1h8V3a1 1 0 112 0v1h4v15a3 3 0 01-3 3H5a3 3 0 01-3-3V4h4V3zM4 9V6h16v3H4zm0 2v8a1 1 0 001 1h14a1 1 0 001-1v-8H4z",
    fill: "#1D1D1D"
  })));
}

var _path$1h, _path2$y;
function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }
function SvgCameraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
  })), _path2$y || (_path2$y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2h8v4h10v13a3 3 0 01-3 3H5a3 3 0 01-3-3V6h2V2zm6 2v2H6V4h4zM4 19V8h16v11a1 1 0 01-1 1H5a1 1 0 01-1-1z"
  })));
}

var _path$1g, _path2$x;
function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }
function SvgCameraSolidSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    d: "M4 2h8v2H4V2zM12 16a2 2 0 100-4 2 2 0 000 4z"
  })), _path2$x || (_path2$x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6v13a3 3 0 003 3h14a3 3 0 003-3V6H2zm10 12a4 4 0 100-8 4 4 0 000 8z"
  })));
}

var _path$1f, _path2$w;
function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }
function SvgCartNotificationSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M20.787 11.97l-.602 1.892A3 3 0 0117.312 16h-7.75a3 3 0 01-2.91-2.272L4.218 4H2a1 1 0 010-2h3.78l.75 3h3.928c.22.703.517 1.373.88 2H7.03l1.56 6.242a1 1 0 00.97.758h7.75a1 1 0 00.959-.713l.445-1.369a10.08 10.08 0 002.072.052z",
    fill: "#1D1D1D"
  })), _path2$w || (_path2$w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 23a3 3 0 100-6 3 3 0 000 6zm-1-3a1 1 0 112 0 1 1 0 01-2 0zM21 20a3 3 0 11-6 0 3 3 0 016 0zm-3-1a1 1 0 100 2 1 1 0 000-2z",
    fill: "#1D1D1D"
  })));
}

var _path$1e;
function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }
function SvgCartSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2a1 1 0 000 2h2.22l2.431 9.728A3 3 0 009.561 16h7.75a3 3 0 002.874-2.138L23 5H6.53l-.75-3H2zm5.03 5l1.561 6.242a1 1 0 00.97.758h7.75a1 1 0 00.959-.713L20.312 7H7.03zM9 23a3 3 0 100-6 3 3 0 000 6zm-1-3a1 1 0 112 0 1 1 0 01-2 0zM18 23a3 3 0 100-6 3 3 0 000 6zm-1-3a1 1 0 112 0 1 1 0 01-2 0z",
    fill: "#1D1D1D"
  })));
}

var _path$1d, _path2$v;
function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }
function SvgCheckContainedSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c1.805 0 3.499.478 4.96 1.315L15.729 4.92a8 8 0 103.925 4.74l1.426-1.857A9.963 9.963 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z"
  })), _path2$v || (_path2$v = /*#__PURE__*/React.createElement("path", {
    d: "M21.238 4.625a1 1 0 00-1.562-1.25l-7.613 9.54-3.387-3.04a1 1 0 10-1.352 1.475l4.964 4.525 8.95-11.25z"
  })));
}

var _path$1c;
function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }
function SvgCheckSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.625 5.22a1 1 0 01.156 1.405L10.113 20l-6.789-6.263a1 1 0 011.352-1.474l5.211 4.777L19.22 5.375a1 1 0 011.406-.156z"
  })));
}

var _path$1b;
function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }
function SvgChevronDownSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    viewBox: "0 0 24 24",
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.342 6.247a1 1 0 00-.095 1.412L12 18 20.753 7.66a1 1 0 00-1.506-1.317L12 15 4.753 6.342a1 1 0 00-1.411-.095z"
  })));
}

var _path$1a;
function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }
function SvgChevronLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.753 3.342a1 1 0 00-1.412-.095L5 12l10.341 8.753a1 1 0 101.318-1.506L8 12l8.659-7.247a1 1 0 00.094-1.411z",
    fill: "#1D1D1D"
  })));
}

var _path$19;
function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }
function SvgChevronRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    viewBox: "0 0 24 24",
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.247 20.659a1 1 0 001.411.094L18 12 7.659 3.247A1 1 0 106.34 4.753L15 12l-8.659 7.247a1 1 0 00-.094 1.412z"
  })));
}

var _path$18;
function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }
function SvgChevronUpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    viewBox: "0 0 24 24",
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.342 17.753a1 1 0 01-.095-1.412L12 6l8.753 10.341a1 1 0 01-1.506 1.317L12 9l-7.247 8.659a1 1 0 01-1.411.094z"
  })));
}

var _path$17, _path2$u;
function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }
function SvgClockSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.293 15.707a.997.997 0 001.414 0 .999.999 0 000-1.414L13 11.586V7a1 1 0 00-2 0v5a1.01 1.01 0 00.293.707l3 3z"
  })), _path2$u || (_path2$u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 11-16 0 8 8 0 0116 0z"
  })));
}

var _path$16;
function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }
function SvgCrossSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.293 5.707a1 1 0 011.414-1.414L12 10.586l6.293-6.293a1 1 0 111.414 1.414L13.414 12l6.293 6.293a1 1 0 01-1.414 1.414L12 13.414l-6.293 6.293a1 1 0 01-1.414-1.414L10.586 12 4.293 5.707z"
  })));
}

var _path$15, _path2$t;
function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }
function SvgDataHistorySmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22a1 1 0 100-2H4V3a1 1 0 00-2 0v19h19z"
  })), _path2$t || (_path2$t = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4a2 2 0 012-2h7a2 2 0 110 4H8a2 2 0 01-2-2zm2-.5h7a.5.5 0 010 1H8a.5.5 0 010-1zM8 8a2 2 0 100 4h3a2 2 0 100-4H8zm3 1.5H8a.5.5 0 000 1h3a.5.5 0 000-1zM6 16a2 2 0 012-2h12a2 2 0 110 4H8a2 2 0 01-2-2zm2-.5h12a.5.5 0 010 1H8a.5.5 0 010-1z"
  })));
}

var _path$14, _path2$s;
function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }
function SvgDeleteSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3a1 1 0 112 0v1h7a1 1 0 110 2H4a1 1 0 010-2h7V3z"
  })), _path2$s || (_path2$s = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.861 19.23l-.94-12.255H20.08l-.941 12.255A3 3 0 0116.148 22H7.852a3 3 0 01-2.99-2.77zM6.08 8.975l.775 10.101a1 1 0 00.997.924h8.296a1 1 0 00.997-.924l.775-10.101H6.08z"
  })));
}

var _path$13, _path2$r;
function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }
function SvgDeviceBigSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    viewBox: "0 0 24 24",
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6 17h-3.2l-.4 1h4l-.4-1z"
  })), _path2$r || (_path2$r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5a3 3 0 013-3h14a3 3 0 013 3v8.837l1.071 3.214A3 3 0 0120.225 21H3.775a3 3 0 01-2.846-3.949L2 13.838V5zm1.72 10h16.56l.894 2.684A1 1 0 0120.225 19H3.775a1 1 0 01-.949-1.316L3.721 15zM20 5v8H4V5a1 1 0 011-1h14a1 1 0 011 1z"
  })));
}

var _path$12;
function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }
function SvgDeviceHugeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5h-.5v3H16a.5.5 0 010 1H8a.5.5 0 010-1h3.5v-3H4A2.5 2.5 0 011.5 15V5A2.5 2.5 0 014 2.5h16A2.5 2.5 0 0122.5 5v10a2.5 2.5 0 01-2.5 2.5h-7zm-9-14A1.5 1.5 0 002.5 5v10A1.5 1.5 0 004 16.5h16a1.5 1.5 0 001.5-1.5V5A1.5 1.5 0 0020 3.5H4z",
    stroke: "#1D1D1D"
  })));
}

var _path$11, _path2$q;
function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }
function SvgDeviceSlimSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    viewBox: "0 0 24 24",
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19a1 1 0 100-2 1 1 0 000 2z"
  })), _path2$q || (_path2$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1a3 3 0 00-3 3v16a3 3 0 003 3h12a3 3 0 003-3V4a3 3 0 00-3-3H6zM5 4a1 1 0 011-1h12a1 1 0 011 1v16a1 1 0 01-1 1H6a1 1 0 01-1-1V4z"
  })));
}

var _path$10, _path2$p;
function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }
function SvgDeviceLittleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-3-3H9zM8 5a1 1 0 011-1h6a1 1 0 011 1v14a1 1 0 01-1 1H9a1 1 0 01-1-1V5z"
  })), _path2$p || (_path2$p = /*#__PURE__*/React.createElement("path", {
    d: "M11 17a1 1 0 100 2h2a1 1 0 100-2h-2z"
  })));
}

var _path$$, _path2$o;
function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }
function SvgDownloadSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    d: "M16.808 9.6a1 1 0 00-1.543-1.272L13.036 11.5V3a1 1 0 10-2 0v8.5L8.809 8.328a1 1 0 00-1.543 1.271l4.772 6.438 4.771-6.438z"
  })), _path2$o || (_path2$o = /*#__PURE__*/React.createElement("path", {
    d: "M4 10a1 1 0 00-2 0v9a3 3 0 003 3h14a3 3 0 003-3v-9a1 1 0 10-2 0v9a1 1 0 01-1 1H5a1 1 0 01-1-1v-9z"
  })));
}

var _path$_;
function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }
function SvgEditSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21v-5.65L14.473 3.879a2.996 2.996 0 014.237 0l1.412 1.412a2.996 2.996 0 010 4.237L8.65 21H3zm4.822-1.997L18.71 8.115a.999.999 0 000-1.413L17.298 5.29a.999.999 0 00-1.413 0L4.997 16.178v2.825h2.825z"
  })));
}

var _path$Z;
function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }
function SvgEmailSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3H2v15a3 3 0 003 3h14a3 3 0 003-3V3zM4 6.414V18a1 1 0 001 1h14a1 1 0 001-1V6.414l-8 8-8-8zM18.586 5H5.414L12 11.586 18.586 5z",
    fill: "#1D1D1D"
  })));
}

var _path$Y, _path2$n, _path3$5;
function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }
function SvgExternalLinkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.172 3.828a1 1 0 010 1.415l-9 9a1 1 0 11-1.415-1.415l9-9a1 1 0 011.415 0z"
  })), _path2$n || (_path2$n = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 3a1 1 0 01-1 1h-8a1 1 0 110-2h8a1 1 0 011 1z"
  })), _path3$5 || (_path3$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 2a1 1 0 011 1v8a1 1 0 11-2 0V3a1 1 0 011-1zM2 7a3 3 0 013-3h3a1 1 0 010 2H5a1 1 0 00-1 1v12a1 1 0 001 1h12a1 1 0 001-1v-3a1 1 0 112 0v3a3 3 0 01-3 3H5a3 3 0 01-3-3V7z"
  })));
}

var _path$X, _path2$m;
function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }
function SvgFacebookSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12c0 5.99 4.388 10.954 10.125 11.854V15.47H7.078V12h3.047V9.356c0-3.007 1.792-4.668 4.533-4.668 1.313 0 2.686.234 2.686.234v2.953H15.83c-1.491 0-1.956.925-1.956 1.874V12h3.328l-.532 3.469h-2.796v8.385C19.612 22.954 24 17.99 24 12z",
    fill: "#1877F2"
  })), _path2$m || (_path2$m = /*#__PURE__*/React.createElement("path", {
    d: "M16.671 15.469L17.203 12h-3.328V9.75c0-.95.465-1.875 1.956-1.875h1.513V4.922s-1.374-.234-2.686-.234c-2.741 0-4.533 1.66-4.533 4.668V12H7.078v3.469h3.047v8.385a12.084 12.084 0 003.75 0V15.47h2.796z",
    fill: "#fff"
  })));
}

var _path$W, _path2$l;
function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }
function SvgFibreBoxSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    d: "M19 8a1 1 0 100-2 1 1 0 000 2zM17 7a1 1 0 11-2 0 1 1 0 012 0z"
  })), _path2$l || (_path2$l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3a4 4 0 00-4 4v10a4 4 0 004 4h14a4 4 0 004-4V7a4 4 0 00-4-4H5zM3 17v-1h1a1 1 0 100-2H3v-1h1a1 1 0 100-2H3V7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2z"
  })));
}

var _path$V;
function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }
function SvgFibreNetworkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.83a3.001 3.001 0 10-2 0V15H9.988a17.262 17.262 0 00-.224-2.164 13.94 13.94 0 00-1.352-4.052 3 3 0 10-1.673 1.124c.394.805.83 1.926 1.052 3.256.112.671.17 1.287.195 1.836H5v8h2v-6h10v6h2v-8h-3.208c.024-.549.083-1.165.194-1.836.227-1.36.68-2.503 1.081-3.312A3 3 0 1015.462 8.6a13.94 13.94 0 00-1.449 4.235c-.131.791-.198 1.518-.223 2.165H13V6.83zM12 5a1 1 0 100-2 1 1 0 000 2zM7 7a1 1 0 11-2 0 1 1 0 012 0zm11 1a1 1 0 100-2 1 1 0 000 2z",
    fill: "#1D1D1D"
  })));
}

var _path$U;
function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }
function SvgFilterSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    d: "M2 7a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM5 12a1 1 0 011-1h12a1 1 0 110 2H6a1 1 0 01-1-1zM9 16a1 1 0 100 2h6a1 1 0 100-2H9z"
  })));
}

var _path$T, _path2$k, _path3$4, _path4$2;
function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }
function SvgGoogleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.172 12c0-.78.13-1.527.36-2.228L1.489 6.684A11.994 11.994 0 00.256 12c0 1.91.444 3.713 1.23 5.312l4.043-3.094A7.1 7.1 0 015.172 12z",
    fill: "#FBBC05"
  })), _path2$k || (_path2$k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.273 4.91c1.694 0 3.223.6 4.425 1.58L20.194 3c-2.13-1.855-4.862-3-7.92-3-4.75 0-8.831 2.716-10.785 6.684l4.044 3.088a7.082 7.082 0 016.74-4.863z",
    fill: "#EB4335"
  })), _path3$4 || (_path3$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.273 19.09a7.082 7.082 0 01-6.74-4.862l-4.044 3.087A11.98 11.98 0 0012.273 24c2.931 0 5.73-1.04 7.83-2.99l-3.839-2.969c-1.083.683-2.447 1.05-3.99 1.05z",
    fill: "#34A853"
  })), _path4$2 || (_path4$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.744 12c0-.71-.11-1.473-.273-2.182H12.273v4.636h6.445c-.322 1.581-1.2 2.796-2.454 3.587l3.839 2.968c2.206-2.047 3.64-5.098 3.64-9.009z",
    fill: "#4285F4"
  })));
}

var _path$S;
function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }
function SvgHelpSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6a3 3 0 013-3h14a3 3 0 013 3v8a3 3 0 01-3 3h-3.994L12 21l-3.006-4H5a3 3 0 01-3-3V6zm3-1a1 1 0 00-1 1v8a1 1 0 001 1h3.994a2 2 0 011.611.815L12 17.624l1.395-1.809a2 2 0 011.61-.815H19a1 1 0 001-1V6a1 1 0 00-1-1H5z",
    fill: "#1D1D1D"
  })));
}

var _path$R;
function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }
function SvgHomeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2l9.105 5.832A2 2 0 0122 9.499V19a3 3 0 01-3 3h-5v-4a2 2 0 00-4 0v4H5a3 3 0 01-3-3V9.5a2 2 0 01.895-1.668L12 2zm0 2.399L4 9.5V19a1 1 0 001 1h3v-2a4 4 0 118 0v2h3a1 1 0 001-1V9.5l-8-5.101z"
  })));
}

var _path$Q, _path2$j;
function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }
function SvgInfoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM12 18a1 1 0 001-1v-5a1 1 0 10-2 0v5a1 1 0 001 1z"
  })), _path2$j || (_path2$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
  })));
}

var _path$P, _path2$i;
function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }
function SvgInternetSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    d: "M5.481 14L4.5 10h1l.493 1.951L6.472 10H7.5l.493 1.951L8.472 10H9.5l-1 3.958.011.042h-1.03l-.488-1.992-.493 1.95.011.042h-1.03zM14.499 10l-.999 3.96.01.04h-1.029l-.489-1.992-.492 1.952.01.04h-1.029L9.5 10h1l.492 1.951.479-1.951h1.028l.493 1.951.479-1.951h1.028zM14.499 10l.982 4h1.029l-.01-.04.492-1.952.489 1.992h1.029l-.01-.04.999-3.96h-1.028l-.479 1.951L17.499 10h-1.028l-.479 1.951L15.499 10h-1z"
  })), _path2$i || (_path2$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15a3 3 0 003 3 9.983 9.983 0 008 4 9.985 9.985 0 008-4 3 3 0 003-3V9a3 3 0 00-3-3 9.983 9.983 0 00-8-4 9.985 9.985 0 00-8 4 3 3 0 00-3 3v6zm16.292 3A7.97 7.97 0 0112 20a7.97 7.97 0 01-5.292-2h10.584zM12 4a7.97 7.97 0 015.292 2H6.708A7.97 7.97 0 0112 4zm8 4H4a1 1 0 00-1 1v6a1 1 0 001 1h16a1 1 0 001-1V9a1 1 0 00-1-1z"
  })));
}

var _path$O;
function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }
function SvgLandlineSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    d: "M5.933 4.222c.067.99.234 1.956.5 2.878L5.1 8.433a16.473 16.473 0 01-.844-4.21h1.677zM16.89 17.578c.944.266 1.911.433 2.889.5v1.655a17.142 17.142 0 01-4.222-.833l1.333-1.322zM7 2H3.111C2.5 2 2 2.5 2 3.111 2 13.544 10.456 22 20.889 22 21.5 22 22 21.5 22 20.889V17.01c0-.611-.5-1.111-1.111-1.111-1.378 0-2.722-.222-3.967-.633a.931.931 0 00-.344-.056c-.29 0-.567.111-.79.322l-2.444 2.445a16.832 16.832 0 01-7.322-7.322L8.467 8.21c.31-.311.4-.744.277-1.133a12.623 12.623 0 01-.633-3.967C8.111 2.5 7.611 2 7 2z"
  })));
}

var _path$N;
function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }
function SvgLocationSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    d: "M20.94 11A8.994 8.994 0 0013 3.06V2a1 1 0 10-2 0v1.06A8.994 8.994 0 003.06 11H2a1 1 0 100 2h1.06A8.994 8.994 0 0011 20.94V22a1 1 0 102 0v-1.06A8.994 8.994 0 0020.94 13H22a1 1 0 100-2h-1.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
  })));
}

var _path$M;
function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }
function SvgMeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2a5 5 0 100 10 5 5 0 000-10zM9 7a3 3 0 116 0 3 3 0 01-6 0zM9 14a5 5 0 00-5 5v3h16v-3a5 5 0 00-5-5H9zm-3 5a3 3 0 013-3h6a3 3 0 013 3v1H6v-1z"
  })));
}

var _path$L;
function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }
function SvgMinusSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    d: "M4 11a1 1 0 100 2h16a1 1 0 100-2H4z"
  })));
}

var _path$K;
function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }
function SvgMoreHorizontalSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM13.5 12a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM18 13.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })));
}

var _path$J;
function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }
function SvgMoreVerticalSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM12 13.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zM10.5 18a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z"
  })));
}

var _path$I, _path2$h;
function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }
function SvgNewsSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M6 9a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zM7 12a1 1 0 100 2h6a1 1 0 100-2H7zM6 17a1 1 0 011-1h3a1 1 0 110 2H7a1 1 0 01-1-1z"
  })), _path2$h || (_path2$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2H2v15a5 5 0 005 5h12a3 3 0 003-3V4h-4V2zm1 18a1 1 0 001-1V6h-2v13a1 1 0 001 1zm-3 0V4H4v13a3 3 0 003 3h9z"
  })));
}

var _path$H;
function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }
function SvgOfficeSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5a3 3 0 013-3h7a3 3 0 013 3v2h4a3 3 0 013 3v12H2V5zm13 10v-2h2v-2h-2V9h4a1 1 0 011 1v10h-5v-3h2v-2h-2zM13 5v15h-3v-3H7v3H4V5a1 1 0 011-1h7a1 1 0 011 1zM5.56 6h2v2h-2V6zm4 0h2v2h-2V6zm-2 4h-2v2h2v-2zm4 0h-2v2h2v-2z"
  })));
}

var _path$G;
function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }
function SvgPasswordHiddenSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    d: "M21.963 12.269a1 1 0 00-1.926-.539l-.002.007a7.662 7.662 0 01-.076.233 10.67 10.67 0 01-1.604 2.914C17.121 16.46 15.137 18 12 18c-3.137 0-5.121-1.539-6.355-3.116a10.666 10.666 0 01-1.604-2.914 5.931 5.931 0 01-.076-.233l-.002-.007a1 1 0 00-1.926.54l.001.004.002.007.007.022.022.074c.02.061.048.148.085.255.075.214.19.513.348.87.118.264.262.561.435.88L1.2 15.384a1 1 0 101 1.732l1.826-1.054.043.054c.786 1.005 1.849 2.02 3.242 2.76l-.666 2.488a1 1 0 101.932.517l.604-2.256c.847.238 1.784.375 2.818.375 1.035 0 1.972-.137 2.818-.375l.604 2.256a1 1 0 101.932-.517l-.666-2.487c1.393-.74 2.456-1.756 3.242-2.76l.043-.055 1.826 1.054a1 1 0 101-1.732l-1.736-1.002c.173-.319.317-.616.435-.88a11.465 11.465 0 00.433-1.125c.01-.03.017-.056.022-.074l.007-.022.002-.008v-.002l.001-.002z"
  })));
}

var _path$F, _path2$g;
function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }
function SvgPasswordVisibleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 12a4 4 0 11-8 0 4 4 0 018 0zm-2 0a2 2 0 11-4 0 2 2 0 014 0z"
  })), _path2$g || (_path2$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.96 11.723l.08.277-.08.277v.003l-.002.007-.007.022a5.372 5.372 0 01-.109.328 12.815 12.815 0 01-1.93 3.48C18.402 18.038 15.887 20 12 20s-6.403-1.963-7.911-3.882a12.814 12.814 0 01-1.931-3.48 7.884 7.884 0 01-.11-.329l-.006-.022-.002-.008-.001-.002v-.002L1.96 12l.079-.276v-.004l.003-.007.007-.022a7.884 7.884 0 01.11-.328 12.815 12.815 0 011.93-3.48C5.597 5.962 8.112 4 12 4s6.403 1.963 7.911 3.882a12.816 12.816 0 011.931 3.48 7.914 7.914 0 01.11.329l.006.022.002.008v.002zm-17.627.959A9.664 9.664 0 014.054 12a10.816 10.816 0 011.607-2.882C6.903 7.538 8.888 6 12 6c3.112 0 5.097 1.537 6.339 3.118A10.813 10.813 0 0119.946 12a10.815 10.815 0 01-1.607 2.882C17.097 16.462 15.112 18 12 18c-3.112 0-5.097-1.537-6.339-3.118a10.817 10.817 0 01-1.328-2.2z"
  })));
}

var _path$E, _path2$f;
function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }
function SvgPhotoSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
  })), _path2$f || (_path2$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3h20v15a3 3 0 01-3 3H5a3 3 0 01-3-3V3zm2 2v10l4.959-6.612 5.108 6.13 3.016-3.015L20 15.149V5H4zm1 14a1 1 0 01-.96-.72l5.001-6.668 4.892 5.87 2.984-2.985 3.039 3.798A1 1 0 0119 19H5z"
  })));
}

var _path$D, _path2$e;
function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }
function SvgPinSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.865 16.646C16.662 14.31 18 11.686 18 9.692 18 6.64 15.37 4 12 4S6 6.64 6 9.692c0 1.995 1.338 4.619 3.135 6.954.86 1.117 1.743 2.062 2.454 2.709.151.137.288.255.411.356.123-.1.26-.22.41-.356.712-.647 1.595-1.592 2.455-2.71zM12 22c1.2 0 8-6.923 8-12.308C20 5.462 16.4 2 12 2S4 5.462 4 9.692C4 15.077 10.8 22 12 22z"
  })), _path2$e || (_path2$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 100-6 3 3 0 000 6z"
  })));
}

var _path$C;
function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }
function SvgPlusSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a1 1 0 00-1 1v7H4a1 1 0 100 2h7v7a1 1 0 102 0v-7h7a1 1 0 100-2h-7V4a1 1 0 00-1-1z"
  })));
}

var _path$B, _path2$d;
function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }
function SvgPrepaidSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    d: "M15 3a1 1 0 110-2 5 5 0 015 5 1 1 0 11-2 0 3 3 0 00-3-3zM12 18a1 1 0 11-2 0 1 1 0 012 0z"
  })), _path2$d || (_path2$d = /*#__PURE__*/React.createElement("path", {
    d: "M10 4a1 1 0 110 2H8a1 1 0 00-1 1v13a1 1 0 001 1h6a1 1 0 001-1v-9a1 1 0 112 0v9a3 3 0 01-3 3H8a3 3 0 01-3-3V7a3 3 0 013-3h2zM13 5a1 1 0 001 1 1 1 0 011 1 1 1 0 102 0 3 3 0 00-3-3 1 1 0 00-1 1z"
  })));
}

var _path$A;
function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }
function SvgSearchSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11a7 7 0 1114 0 7 7 0 01-14 0zm7-9a9 9 0 105.633 16.02c.036.053.077.104.124.152l3.536 3.535a1 1 0 001.414-1.414l-3.535-3.536a1.005 1.005 0 00-.152-.124A9 9 0 0011 2z"
  })));
}

var _path$z;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
function SvgShareSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.672 9.845a1 1 0 00.136-1.408L12.037 2 7.264 8.437A1 1 0 008.808 9.71l2.229-3.172v8.5a1 1 0 002 0v-8.5l2.228 3.172a1 1 0 001.407.136zM3 9a1 1 0 011 1v9a1 1 0 001 1h14a1 1 0 001-1v-9a1 1 0 112 0v9a3 3 0 01-3 3H5a3 3 0 01-3-3v-9a1 1 0 011-1z"
  })));
}

var _path$y;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
function SvgShopSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.057 2a4 4 0 00-4 4v2H3l1.306 11.361A3 3 0 007.284 22h9.546a3 3 0 002.978-2.639L21 8h-4.943V6a4 4 0 00-4-4zm2 6V6a2 2 0 00-4 0v2h4zM6.291 19.12L5.257 10h13.486l-.92 9.12a1 1 0 01-.993.88H7.284a1 1 0 01-.993-.88z"
  })));
}

var _path$x, _path2$c;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
function SvgSpendSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 6H3v10a2 2 0 002 2h16V8a2 2 0 00-2-2zM1 4v12a4 4 0 004 4h18V8a4 4 0 00-4-4H1z",
    fill: "#1D1D1D"
  })), _path2$c || (_path2$c = /*#__PURE__*/React.createElement("path", {
    d: "M11 7h2v1h2v2h-3.5a.5.5 0 000 1h1c1.379 0 2.5 1.122 2.5 2.5 0 1.208-.86 2.218-2 2.45V17h-2v-1H9v-2h3.5a.5.5 0 000-1h-1A2.503 2.503 0 019 10.5c0-1.207.86-2.217 2-2.449V7zM19 12a1 1 0 11-2 0 1 1 0 012 0zM7 12a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "#1D1D1D"
  })));
}

var _path$w, _path2$b, _path3$3;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
function SvgUnlimitedSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M7 3a3 3 0 00-3 3v13a3 3 0 003 3h6a3 3 0 003-3v-1a1 1 0 10-2 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1V6a1 1 0 011-1h6a1 1 0 011 1 1 1 0 102 0 3 3 0 00-3-3H7z"
  })), _path2$b || (_path2$b = /*#__PURE__*/React.createElement("path", {
    d: "M10 18a1 1 0 100-2 1 1 0 000 2z"
  })), _path3$3 || (_path3$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.08 15c.936 0 1.702-.376 2.215-.984.494-.584.71-1.325.705-2.023-.005-.697-.23-1.433-.722-2.011C19.768 9.38 19.01 9 18.081 9c-.94 0-1.662.387-2.215.887-.123.111-.24.23-.35.353C14.936 9.582 14.13 9 12.94 9c-.935 0-1.701.375-2.218.979C10.223 10.56 10 11.299 10 12c0 .7.223 1.44.722 2.021.517.604 1.283.979 2.218.979.924 0 1.622-.405 2.147-.903.137-.129.266-.268.388-.412C16.05 14.37 16.862 15 18.08 15zm0-2c-.532 0-.862-.292-1.37-1.038.176-.24.344-.438.521-.599.277-.25.532-.363.85-.363.33 0 .521.119.648.268.146.172.245.436.248.739.002.302-.094.561-.234.727-.12.142-.312.266-.662.266zm-5.14-2c.532 0 .872.273 1.338.934-.206.293-.391.53-.59.719-.267.252-.489.347-.748.347-.35 0-.549-.125-.674-.271a1.13 1.13 0 01-.243-.729c0-.3.098-.56.243-.729.125-.146.323-.271.674-.271z"
  })));
}

var _path$v;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
function SvgVoucherSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4H2v6a2 2 0 110 4v6h16a4 4 0 004-4V8a4 4 0 00-4-4H3zm3 8c0-1.48-.804-2.773-2-3.465V6h14a2 2 0 012 2v8a2 2 0 01-2 2H4v-2.535A3.998 3.998 0 006 12zm4-3a1 1 0 100-2 1 1 0 000 2zm0 4a1 1 0 100-2 1 1 0 000 2zm1 3a1 1 0 11-2 0 1 1 0 012 0z"
  })));
}

var _path$u;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
function SvgWaitingSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 20.125h-.313v-2.5c0-.64-.24-1.224-.636-1.666l-2.796-3.126a1.247 1.247 0 010-1.666l2.797-3.126a2.491 2.491 0 00.636-1.666v-2.5h.312a.938.938 0 000-1.875H5.75a.938.938 0 000 1.875h.313v2.5c0 .64.24 1.224.636 1.666l2.796 3.127c.197.22.317.512.317.832 0 .32-.12.612-.318.833L6.698 15.96a2.495 2.495 0 00-.636 1.666v2.5H5.75a.938.938 0 000 1.875h12.5a.938.938 0 000-1.875zm-2.188 0H7.938v-2.5c0-.198.087-.336.159-.416l2.796-3.127a3.122 3.122 0 000-4.165L8.096 6.79a.617.617 0 01-.159-.416v-2.5h8.125v2.5a.617.617 0 01-.158.416l-2.797 3.127a3.12 3.12 0 00.001 4.165l2.796 3.125a.62.62 0 01.159.417v2.5z"
  })));
}

var _path$t, _path2$a;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
function SvgWarningSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    d: "M12 13a1 1 0 01-1-1V8a1 1 0 112 0v4a1 1 0 01-1 1zM12 15a1.5 1.5 0 100 3 1.5 1.5 0 000-3z",
    fill: "#1D1D1D"
  })), _path2$a || (_path2$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6 2.511c-1.154-2.004-4.046-2.004-5.2 0L1.2 16.503C.047 18.503 1.49 21 3.8 21h16.4c2.309 0 3.752-2.497 2.6-4.497L14.6 2.511zm-3.467.998a1 1 0 011.734 0l8.2 13.992A1 1 0 0120.201 19H3.799a1 1 0 01-.866-1.499l8.2-13.992z",
    fill: "#1D1D1D"
  })));
}

var _path$s;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
function SvgWifiSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 24,
    height: 24,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M12 17a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0-4.5c.845 0 1.62.238 2.309.632.413.236.715.477.898.66a1 1 0 01-1.414 1.415 2.493 2.493 0 00-.477-.339A2.644 2.644 0 0012 14.5c-.467 0-.91.137-1.316.368-.244.14-.41.273-.477.34a1 1 0 01-1.414-1.415c.183-.184.486-.425.898-.661A4.615 4.615 0 0112 12.5zM12 8c1.704 0 3.223.419 4.533 1.118.797.425 1.359.86 1.674 1.175a1 1 0 01-1.32 1.497l-.217-.192-.15-.12a6.577 6.577 0 00-.928-.596A7.546 7.546 0 0012 10a7.547 7.547 0 00-3.592.882c-.269.144-.51.294-.724.445l-.286.216-.123.102-.068.062a1 1 0 01-1.414-1.414c.315-.316.877-.75 1.674-1.175A9.536 9.536 0 0112 8zm0-4.5c.89 0 1.767.088 2.63.255.953.184 1.874.462 2.758.817.407.164.802.343 1.184.534 1.205.602 2.083 1.21 2.579 1.635a1 1 0 01-1.302 1.518l-.096-.078-.234-.176-.213-.152a13.997 13.997 0 00-2.664-1.426c-.77-.308-1.569-.55-2.392-.709A11.833 11.833 0 0012 5.5c-.646 0-1.287.054-1.92.159-.94.155-1.849.418-2.722.769a14.01 14.01 0 00-2.563 1.357l-.227.157-.265.196-.152.121a1 1 0 11-1.302-1.518c.388-.333 1.079-.825 2.033-1.35.545-.299 1.123-.575 1.73-.819a14.94 14.94 0 013.142-.886c.74-.122 1.489-.186 2.246-.186z"
  })));
}

var _path$r, _path2$9;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
function SvgWhySparkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    d: "M12 2c1.805 0 3.499.478 4.96 1.315L15.729 4.92a8 8 0 103.925 4.74l1.426-1.857A9.963 9.963 0 0122 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2z",
    fill: "#1D1D1D"
  })), _path2$9 || (_path2$9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.238 4.625a1 1 0 00-1.562-1.25l-7.613 9.54-3.387-3.04a1 1 0 10-1.352 1.475l4.964 4.525 8.95-11.25z",
    fill: "#1D1D1D"
  })));
}

var _path$q;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
function SvgUnlinkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.586 9.929a1 1 0 011.414 0l2.528 2.528a5 5 0 11-7.071 7.07L9.929 17a1 1 0 111.414-1.414l2.528 2.527a3 3 0 104.243-4.242l-2.528-2.528a1 1 0 010-1.414zm-2.919-1.505a1 1 0 101.414-1.414l-2.528-2.528a5 5 0 00-7.07 7.071l2.527 2.528a1 1 0 001.414-1.414l-2.527-2.528a3 3 0 014.242-4.243l2.528 2.528z",
    fill: "#1D1D1D"
  })));
}

var _path$p, _path2$8;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
function SvgLinkSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.586 9.929a1 1 0 011.414 0l2.528 2.528a5 5 0 11-7.071 7.07L9.929 17a1 1 0 111.414-1.414l2.528 2.527a3 3 0 104.243-4.242l-2.528-2.528a1 1 0 010-1.414zm-2.919-1.505a1 1 0 101.414-1.414l-2.528-2.528a5 5 0 00-7.07 7.071l2.527 2.528a1 1 0 001.414-1.414l-2.527-2.528a3 3 0 014.242-4.243l2.528 2.528z",
    fill: "#1D1D1D"
  })), _path2$8 || (_path2$8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.464 8.414a1 1 0 011.415 0l5.657 5.657a1 1 0 01-1.415 1.414L8.464 9.828a1 1 0 010-1.414z",
    fill: "#1D1D1D"
  })));
}

var _path$o;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17 6A3.026 3.026 0 016 5c0-.7.244-1.44.787-2.021.564-.604 1.4-.979 2.42-.979 1.299 0 2.179.582 2.81 1.24.12-.123.248-.242.382-.353.604-.5 1.39-.887 2.416-.887 1.013 0 1.84.381 2.398.982A3.033 3.033 0 0117.837 6H22v12.375A3.626 3.626 0 0118.374 22H5.626A3.626 3.626 0 012 18.375V6h4.17zm8.645 0c.382 0 .591-.124.723-.266.152-.166.257-.425.255-.727a1.105 1.105 0 00-.27-.739C15.384 4.12 15.175 4 14.815 4c-.347 0-.624.113-.926.363-.194.16-.377.36-.57.599.555.746.915 1.038 1.496 1.038zM9.207 6c.283 0 .525-.095.817-.347.216-.188.418-.426.643-.719-.509-.661-.88-.934-1.46-.934-.383 0-.598.125-.735.271A1.07 1.07 0 008.207 5c0 .3.107.56.265.729.137.146.352.271.735.271zm.379 2l-3.293 3.293 1.414 1.414L11 9.414V20H5.626A1.626 1.626 0 014 18.375V8h5.586zM13 20V9.414l3.293 3.293 1.414-1.414L14.414 8H20v10.375c0 .897-.728 1.625-1.626 1.625H13z",
    fill: "#F12BA3"
  })));
}

var _path$n, _path2$7, _path3$2, _path4$1, _path5, _path6, _path7, _path8, _path9;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
function SvgBurgerSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M4 17a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#1D1D1D"
  })), _path2$7 || (_path2$7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path3$2 || (_path3$2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path4$1 || (_path4$1 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#1D1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#1D1D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.2
  })));
}

const NAME_TO_SMALL_SVG_MAP = {
    activity_history_small: SvgActivityHistorySmall,
    apple_small: SvgAppleSmall,
    arrow_down_small: SvgArrowDownSmall,
    arrow_left_small: SvgArrowLeftSmall,
    arrow_right_small: SvgArrowRightSmall,
    arrow_up_small: SvgArrowUpSmall,
    broadband_small: SvgBroadbandSmall,
    burger_small: SvgBurgerSmall,
    calendar_small: SvgCalendarSmall,
    camera_small: SvgCameraSmall,
    camera_solid_small: SvgCameraSolidSmall,
    cart_notification_small: SvgCartNotificationSmall,
    cart_small: SvgCartSmall,
    check_contained_small: SvgCheckContainedSmall,
    check_small: SvgCheckSmall,
    chevron_down_small: SvgChevronDownSmall,
    chevron_left_small: SvgChevronLeftSmall,
    chevron_right_small: SvgChevronRightSmall,
    chevron_up_small: SvgChevronUpSmall,
    clock_small: SvgClockSmall,
    cross_small: SvgCrossSmall,
    data_history_small: SvgDataHistorySmall,
    delete_small: SvgDeleteSmall,
    device_big_small: SvgDeviceBigSmall,
    device_huge_small: SvgDeviceHugeSmall,
    device_slim_small: SvgDeviceSlimSmall,
    device_little_small: SvgDeviceLittleSmall,
    download_small: SvgDownloadSmall,
    edit_small: SvgEditSmall,
    email_small: SvgEmailSmall,
    external_link_small: SvgExternalLinkSmall,
    facebook_small: SvgFacebookSmall,
    fibre_box_small: SvgFibreBoxSmall,
    fibre_network_small: SvgFibreNetworkSmall,
    filter_small: SvgFilterSmall,
    google_small: SvgGoogleSmall,
    help_small: SvgHelpSmall,
    home_small: SvgHomeSmall,
    info_small: SvgInfoSmall,
    internet_small: SvgInternetSmall,
    landline_small: SvgLandlineSmall,
    location_small: SvgLocationSmall,
    me_small: SvgMeSmall,
    minus_small: SvgMinusSmall,
    more_horizontal_small: SvgMoreHorizontalSmall,
    more_vertical_small: SvgMoreVerticalSmall,
    news_small: SvgNewsSmall,
    office_small: SvgOfficeSmall,
    password_hidden_small: SvgPasswordHiddenSmall,
    password_visible_small: SvgPasswordVisibleSmall,
    photo_small: SvgPhotoSmall,
    pin_small: SvgPinSmall,
    plus_small: SvgPlusSmall,
    prepaid_small: SvgPrepaidSmall,
    search_small: SvgSearchSmall,
    share_small: SvgShareSmall,
    shop_small: SvgShopSmall,
    spend_small: SvgSpendSmall,
    unlimited_small: SvgUnlimitedSmall,
    voucher_small: SvgVoucherSmall,
    waiting_small: SvgWaitingSmall,
    warning_small: SvgWarningSmall,
    wifi_small: SvgWifiSmall,
    why_spark_small: SvgWhySparkSmall,
    unlink_small: SvgUnlinkSmall,
    link_small: SvgLinkSmall,
    gift_small: SvgGift,
};

var _path$m, _path2$6;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
function SvgSmileAverageExtraLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 48,
    height: 48,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    d: "M34 24a2 2 0 100-4 2 2 0 000 4zM16 22a2 2 0 11-4 0 2 2 0 014 0zM20.5 27a1.5 1.5 0 000 3h7a1.5 1.5 0 000-3h-7z"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20zm-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17z"
  })));
}

var _path$l, _path2$5;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
function SvgSmileBadExtraLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 48,
    height: 48,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    d: "M24 26.5c-2.052 0-3.572.59-4.599 1.223a6.838 6.838 0 00-1.15.882 5.135 5.135 0 00-.4.43l-.03.038-.012.015-.005.006-.002.003-.001.002S17.8 29.1 19 30l-1.2-.9a1.5 1.5 0 002.4 1.802c.021-.024.064-.07.128-.132.128-.124.342-.305.646-.492.598-.369 1.578-.778 3.026-.778 1.448 0 2.428.41 3.026.777.304.188.518.37.646.493.064.061.107.108.128.132l.01.01.004.006A1.5 1.5 0 0030.2 29.1L29 30c1.2-.9 1.199-.901 1.199-.901l-.001-.002-.002-.003-.005-.006-.012-.015-.03-.038a5.135 5.135 0 00-.4-.43 6.842 6.842 0 00-1.15-.882C27.572 27.09 26.052 26.5 24 26.5zM36 22a2 2 0 11-4 0 2 2 0 014 0zM14 24a2 2 0 100-4 2 2 0 000 4z"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24 12.954 4 24 4s20 8.954 20 20zm-3 0c0 9.389-7.611 17-17 17S7 33.389 7 24 14.611 7 24 7s17 7.611 17 17z"
  })));
}

var _path$k, _path2$4;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
function SvgSmileGreatExtraLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 48,
    height: 48,
    fill: "#1D1D1D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M14 24a2 2 0 100-4 2 2 0 000 4zM36 22a2 2 0 11-4 0 2 2 0 014 0zM28.599 30.277C27.572 30.91 26.052 31.5 24 31.5s-3.572-.59-4.599-1.223a6.84 6.84 0 01-1.15-.882 5.133 5.133 0 01-.43-.468l-.012-.015-.005-.006-.002-.003-.001-.002 1.199-.9-1.2.9a1.5 1.5 0 012.386-1.82l.005.006.01.011c.02.025.063.071.127.133.128.123.341.304.646.492.598.368 1.578.777 3.026.777 1.448 0 2.428-.41 3.026-.777.304-.188.518-.37.646-.492.064-.062.107-.108.128-.133l.014-.016A1.5 1.5 0 0130.2 28.9L29 28c1.2.9 1.199.901 1.199.901l-.001.002-.002.003-.005.006-.012.015a2.176 2.176 0 01-.121.147 5.133 5.133 0 01-.308.32 6.84 6.84 0 01-1.151.884z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4 4 12.954 4 24s8.954 20 20 20zm0-3c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17z"
  })));
}

const NAME_TO_EXTRA_LARGE_SVG_MAP = {
    smile_average_extra_large: SvgSmileAverageExtraLarge,
    smile_bad_extra_large: SvgSmileBadExtraLarge,
    smile_great_extra_large: SvgSmileGreatExtraLarge,
};

var _path$j;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
function SvgCheckExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.958 3.22a1 1 0 01.156 1.405L6.78 13.793l-4.788-4.39A1 1 0 013.342 7.93l3.212 2.943 5.998-7.498a1 1 0 011.406-.156z",
    fill: "#1D1D1D"
  })));
}

var _path$i;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
function SvgChevronDownExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.713 6.095A1.019 1.019 0 013.22 4.724L8 9.974l4.78-5.25a1.019 1.019 0 111.507 1.371L8 13 1.713 6.095z",
    fill: "#1D1D1D"
  })));
}

var _path$h;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
function SvgChevronLeftExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.237 1.824a1 1 0 01-.061 1.413L5.98 8l5.196 4.763a1 1 0 01-1.352 1.474L3 8l6.824-6.237a1 1 0 011.413.061z",
    fill: "#1D1D1D"
  })));
}

var _path$g;
function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }
function SvgChevronRightExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.763 14.176a1 1 0 01.061-1.413L10.02 8 4.824 3.237a1 1 0 011.352-1.474L13 8l-6.824 6.237a1 1 0 01-1.413-.061z",
    fill: "#1D1D1D"
  })));
}

var _path$f;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
function SvgCrossExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    d: "M.293 1.707A1 1 0 011.707.293L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707z",
    fill: "#772BCB"
  })));
}

var _path$e;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
function SvgBrandFacebookExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 7,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    d: "M4.544 14V7.612h2.063l.31-2.49H4.544V3.534c0-.723.19-1.211 1.19-1.211H7V.099C6.78.068 6.025 0 5.15 0 3.32 0 2.07 1.162 2.07 3.287v1.835H0v2.49h2.07V14h2.474z",
    fill: "#1D1D1D"
  })));
}

var _path$d, _path2$3;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
function SvgBrandInstagramExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    d: "M9.927 0H4.073C1.834 0 0 1.785 0 3.965v6.07C0 12.216 1.834 14 4.073 14h5.854C12.166 14 14 12.215 14 10.036V3.965C14 1.785 12.169 0 9.927 0zm2.998 10.036c0 .774-.312 1.504-.882 2.06-.57.554-1.32.858-2.116.858H4.073a3.015 3.015 0 01-2.116-.859 2.856 2.856 0 01-.882-2.06v-6.07c0-.775.312-1.505.882-2.06a3.015 3.015 0 012.116-.86h5.854c.795 0 1.546.305 2.116.86.57.555.882 1.285.882 2.06v6.07z",
    fill: "#1D1D1D"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02 3.193c-2.127 0-3.853 1.68-3.853 3.75 0 2.072 1.726 3.752 3.854 3.752s3.854-1.68 3.854-3.751c.003-2.072-1.723-3.751-3.854-3.751zm-.017 6.214c-1.393 0-2.525-1.102-2.525-2.457 0-1.356 1.132-2.457 2.525-2.457S9.527 5.594 9.527 6.95c0 1.355-1.128 2.457-2.524 2.457zM10.938 4.023a.9.9 0 00.913-.889.9.9 0 00-.913-.888.9.9 0 00-.912.888.9.9 0 00.912.889z",
    fill: "#1D1D1D"
  })));
}

var _path$c, _path2$2;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function SvgJumpToExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3 0a1 1 0 011 1v9h9a1 1 0 110 2H3a1 1 0 01-1-1V1a1 1 0 011-1z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M9.828 6.793a1 1 0 011.415 0l4.242 4.243-4.242 4.242a1 1 0 01-1.415-1.414l2.829-2.829-2.829-2.828a1 1 0 010-1.414z"
  })));
}

var _path$b;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function SvgMeExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6a2 2 0 100-4 2 2 0 000 4zm0 2a4 4 0 100-8 4 4 0 000 8zM11 11H5a2 2 0 00-2 2v1h10v-1a2 2 0 00-2-2zM5 9a4 4 0 00-4 4v3h14v-3a4 4 0 00-4-4H5z",
    fill: "#1D1D1D"
  })));
}

var _path$a;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function SvgBrandYoutubeExtraSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 16,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.688 1.719A2.063 2.063 0 0014.25.307C13 0 8 0 8 0S3 0 1.75.307A2.063 2.063 0 00.312 1.719C0 2.946 0 5.586 0 5.586s0 2.64.313 3.867c.187.675.75 1.227 1.437 1.412C3 11.17 8 11.17 8 11.17s5 0 6.25-.306a2.063 2.063 0 001.438-1.412C16 8.225 16 5.586 16 5.586s0-2.64-.313-3.867zM6.5 8.286v-4.91l4 2.455-4 2.455z",
    fill: "#1D1D1D"
  })));
}

const NAME_TO_EXTRA_SMALL_SVG_MAP = {
    check_extra_small: SvgCheckExtraSmall,
    chevron_down_extra_small: SvgChevronDownExtraSmall,
    chevron_left_extra_small: SvgChevronLeftExtraSmall,
    chevron_right_extra_small: SvgChevronRightExtraSmall,
    cross_extra_small: SvgCrossExtraSmall,
    facebook_extra_small: SvgBrandFacebookExtraSmall,
    instagram_extra_small: SvgBrandInstagramExtraSmall,
    jump_to_extra_small: SvgJumpToExtraSmall,
    me_extra_small: SvgMeExtraSmall,
    youtube_extra_small: SvgBrandYoutubeExtraSmall,
};

var _path$9;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    viewBox: "0 0 18 18",
    fill: "#772BCB",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9a9 9 0 109.055-9v1.923A7.077 7.077 0 111.923 9H0z"
  })));
}

var _circle$2, _mask$1, _g$1;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function SvgMagicButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })), _mask$1 || (_mask$1 = /*#__PURE__*/React.createElement("mask", {
    id: "magic_button_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  }))), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#magic_button_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.344,
    cy: 27.344,
    r: 14.219,
    fill: "#FF8E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.219,
    cy: 49.219,
    r: 24.063,
    fill: "#FF8E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.734,
    cy: 15.859,
    r: 24.609,
    fill: "#F12BA3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 44.844,
    r: 39.375,
    fill: "#772BCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    fill: "#fff",
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99 31.504h2.364l2.207 6.036h.037l2.184-6.036h2.375V40h-1.5v-6.828h-.023L21.053 40h-1.056l-2.545-6.828h-.023V40h-1.44v-8.496zm12.239 0h5.628v1.32H29.74v2.16h3.9v1.272h-3.9v2.4h4.332V40h-5.844v-8.496zm8.524 0h2.004l3.948 6.36h.024v-6.36h1.512V40h-1.92l-4.032-6.564h-.024V40h-1.512v-8.496zm17.331 5.376c0 .512-.088.976-.264 1.392a3.122 3.122 0 01-.72 1.044 3.244 3.244 0 01-1.08.672 3.922 3.922 0 01-1.356.228c-.488 0-.94-.076-1.356-.228a3.382 3.382 0 01-1.092-.672 3.122 3.122 0 01-.72-1.044 3.687 3.687 0 01-.252-1.392v-5.376h1.512v5.316c0 .248.032.496.096.744.064.24.168.456.312.648.152.192.348.348.588.468.248.12.552.18.912.18s.66-.06.9-.18c.248-.12.444-.276.588-.468.152-.192.26-.408.324-.648.064-.248.096-.496.096-.744v-5.316h1.512v5.376z",
    fill: "#5A12AA"
  }))));
}

var _path$8, _path2$1, _path3$1;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function SvgMagicButtonWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.468 7.32a8.294 8.294 0 00-4.097 1.425A15.949 15.949 0 0136 20c0 8.837-7.164 16-16 16-1.33 0-2.622-.162-3.857-.468a14.186 14.186 0 004.078 4.467C31.165 39.88 40 30.972 40 20c0-4.813-1.7-9.228-4.532-12.68z",
    fill: "#FF8E26"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.069 3.947a14.407 14.407 0 00-.874 4.956c0 .477.023.947.068 1.412A15.975 15.975 0 0120 4c6.861 0 12.714 4.319 14.987 10.386a14.393 14.393 0 001.053-6.334C32.394 3.164 26.566 0 20 0A19.91 19.91 0 008.069 3.947z",
    fill: "#F12BA3"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.108 39.76c-1.013.158-2.05.24-3.108.24C8.954 40 0 31.046 0 20 0 12.982 3.615 6.807 9.085 3.238c1.877.367 3.673.962 5.358 1.754C8.346 7.25 4 13.117 4 20c0 8.837 7.163 16 16 16 2.091 0 4.089-.401 5.92-1.13a23.068 23.068 0 01-2.812 4.89z",
    fill: "#772BCB"
  })));
}

var _circle$1, _mask, _g;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function SvgRoundCloseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "round_close_button_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#round_close_button_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62.344,
    cy: 27.344,
    r: 14.219,
    fill: "#FF8E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.219,
    cy: 49.219,
    r: 24.063,
    fill: "#FF8E26"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.734,
    cy: 15.859,
    r: 24.609,
    fill: "#F12BA3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.75,
    cy: 44.844,
    r: 39.375,
    fill: "#772BCB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 34,
    fill: "#fff",
    stroke: "#772BCB",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.007 28.287a.977.977 0 01-.033 1.381L29.388 41.661a.977.977 0 01-1.348-1.414l12.586-11.993a.977.977 0 011.381.033z",
    fill: "#772BCB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7 27.89a.977.977 0 00.02 1.38L40.18 41.393a.977.977 0 001.362-1.4L29.081 27.87a.977.977 0 00-1.38.02z",
    fill: "#772BCB"
  }))));
}

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function SvgSparkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    viewBox: "0 0 40 40",
    fill: "#5A12AA",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M.782 19.186c0 .046 0 .046 0 0 .046.046.091.046.091.046.59.182 1.224.364 1.814.546h.045a45.578 45.578 0 01-1.95-.592zm37.955 5.101c-1.723-.273-6.167-.273-8.888-.273-.136-.091-.272-.137-.453-.228-1.179-.546-2.313-1.093-3.492-1.64.182-.182.408-.364.59-.546 1.723.638 4.398 1.548 6.122 2.14.136.046.408-.182.498-.546.091-.364.046-.683-.045-.729 0 0-3.945-1.366-5.442-1.913.771-.728 1.633-1.366 2.404-2.05.816-.682 1.587-1.365 2.449-2.049.408-.318.816-.683 1.224-1.002.816-.683 1.678-1.32 2.54-1.958.226-.137.453-.319.68-.455.136-.091.317-.183.453-.274l.272-.136s-.045 0 0 0c0 0 .045 0 .045-.046 0-.045.046-.182 0-.228-.045 0-.09.046-.136.046v-.046a4.547 4.547 0 01-.68.32c-.045 0-.09.045-.136.045h-.045c-.318.136-.635.319-.953.455-.272.137-.589.319-.861.456-.272.136-.59.318-.862.455-1.179.638-2.312 1.23-3.446 1.867.136-.09.272-.227.408-.273.136-.09.272-.182.454-.228.861-.5 1.723-.956 2.63-1.457.59-.319 1.179-.638 1.813-.956a17.12 17.12 0 011.588-.775c.09-.045.181-.09.272-.09h.045c.045 0 .045.045.09.045.046.045.046.182.046.273 0 .046-.045.046-.045.046l-.046.045s-.045.046-.09.046c-.136.09-.318.182-.454.273l-.816.546c-.09.046-.181.137-.272.183-.544.364-1.043.774-1.587 1.184-.363.273-.726.592-1.043.865-.09.046-.136.137-.227.182a86.703 86.703 0 00-2.267 1.959c-.499.41-.998.865-1.497 1.275a256.095 256.095 0 013.628-3.006c-.997.82-1.95 1.685-2.947 2.505.136-.091.226-.228.362-.273-.362.364-.77.728-1.179 1.093-.317.273-.59.546-.907.82-.09.09-.181.182-.272.227 0 0-.045.046 0 .046.136-.091.227-.182.318-.273.544-.456 1.043-.911 1.587-1.367.408-.364.861-.728 1.27-1.093.226-.182.408-.364.634-.546l.046-.046c.408-.319.816-.683 1.224-1.002.635-.546 1.315-1.047 1.95-1.594.317-.273.68-.5.998-.774.136-.091.226-.182.362-.228.363-.228.68-.455 1.089-.683.136-.091.272-.137.362-.273.091-.137.137-.274.091-.456-.045-.182-.09-.273-.227-.364.091.045.136.136.182.228.045.09.09.182.045.318 0 .046-.045.091-.045.137-.046.091-.09.182-.182.228-.045.045-.09.045-.09.09l-.272.138c-.272.136-.5.273-.726.41-.181.09-.317.227-.499.273a9.388 9.388 0 011.089-.775c.09-.045.181-.09.317-.182a.548.548 0 00.227-.228.635.635 0 000-.41.548.548 0 00-.227-.227c.136-.091.318-.182.454-.273.09-.046.226-.137.317-.228l.09-.091c.046-.046.091-.137.137-.228.045-.091.045-.182.09-.273 0-.091-.045-.182-.045-.273-.045-.091-.045-.137-.136-.228a.66.66 0 00-.408-.273c-.09 0-.181-.046-.272-.046-.862.091-1.587.364-2.313.638.136-.046.318-.137.499-.137-.499.182-.998.364-1.451.592-.272.137-.544.273-.771.456.227-.183.453-.365.635-.593.227-.227.408-.455.544-.683.09-.09.181-.227.272-.364.09-.137.181-.273.181-.41 0-.091.046-.228 0-.273 0-.091-.09-.137-.136-.182-.045-.046-.09-.091-.181-.137a.345.345 0 00-.227-.091h-.136a1.51 1.51 0 00-.544.228c-.045.045-.136.09-.181.136-.5.365-.907.729-1.36 1.139-.68.592-1.316 1.184-1.996 1.73-.635.547-1.27 1.14-1.905 1.686l-.09.09c-.907.775-1.769 1.55-2.676 2.324-.68.592-1.315 1.184-1.995 1.776.499-.456.952-.957 1.451-1.412l.363-.364c.136-.091.227-.228.363-.365l.363-.364.362-.364 2.857-2.87c1.18-1.184 2.403-2.368 3.537-3.598.181-.182.363-.364.499-.546l.181-.183a.921.921 0 00.136-.5V7.07c0-.136-.09-.227-.181-.319 0-.045-.045-.045-.09-.045-.091-.046-.137-.091-.273-.091-.09 0-.227 0-.317.045-.182.046-.318.137-.499.228 0 0-.181.137-.272.182.045-.045.136-.136.227-.182.181-.182.226-.455.09-.592-.136-.182-.408-.137-.635.046l-.136.136c-.317.319-.59.638-.952 1.002l-.272.273c-.272.274-.59.501-.861.775-.182.182-.409.319-.59.5-.181.183-.408.32-.59.502-.272.273-.589.5-.861.774l-.272.273c.227-.182.499-.364.725-.546-.408.364-.861.728-1.27 1.138-.453.365-.86.774-1.269 1.139-.862.729-1.678 1.503-2.54 2.232l-.045.045c0-.592 0-1.685-.045-1.73 0-.092-.136-.137-.363-.137h-.136c0-.866.046-1.685.046-2.505 0-.182-.227-.319-.5-.319h-.271s-.046 0-.046.046c0 0-.045 0-.045.045l-.046.046-.045.045s0 .046-.045.046V13.812a1.363 1.363 0 00-.182-.364c0-.046-.045-.092-.045-.137 0-.228 0-.456-.045-.683 0-.228-.046-.456-.046-.684-.045-.455-.045-.91-.09-1.411-.046-1.276-.136-2.55-.182-3.872V6.48v-.182c.136-1.275.408-3.917.408-3.962 0-.501-.226-.957-.59-.957-.362 0-.634.41-.68.911 0 .091.091 1.913.137 2.87v.227c0 .137-.046.273-.046.41-.09-.683-.226-1.412-.317-2.095-.136-.683-.272-1.32-.408-2.004A3.875 3.875 0 0019.42.695c-.182-.319-.454-.592-.816-.683-.318-.046-.59.045-.726.182a1.363 1.363 0 00-.454.774c-.045.365 0 .729.046 1.048.136.82.181 1.64.317 2.505.046.455.136.91.182 1.412-.136-.228-.227-.456-.318-.684-.77-1.64-1.496-3.279-2.267-4.918.317.728.68 1.457.998 2.231A47.731 47.731 0 0115.339.376c-.227.091-.409.182-.635.273.907 2.141 1.859 4.236 2.766 6.377.272.683.59 1.32.861 2.004 0 .045.046.09.046.136-.726-1.594-1.451-3.142-2.177-4.69.544 1.183 1.043 2.368 1.587 3.552 0 .045.046.09.046.09-.68-1.411-1.36-2.869-2.04-4.28v-.046c-.046 0-.092.046-.137.046A106.404 106.404 0 0014.341.695c-.227-.455-.635-.729-.952-.592-.363.137-.454.592-.363.956.045.274.181.501.272.775.09.273.181.546.318.774.045.091.045.137.09.228.046.045.046.182.09.227-.18-.273-.453-.364-.634-.318-.227.09-.317.5-.227.956-.181-.228-.408-.364-.59-.319-.271.091-.317.547-.135 1.002v.046c0 .045.045.09.045.136.181.501.363.957.544 1.458-.136-.228-.272-.501-.453-.775-.046-.045-.046-.09-.09-.136-.092-.091-.228-.137-.364-.046a.308.308 0 00-.181.274c0 .09.045.136.045.182 0 .045.046.09.09.182.273.683.59 1.366.863 2.05.589 1.366 1.178 2.732 1.768 4.053.363.865.726 1.685 1.134 2.505.045.045.045.09.09.182a76.753 76.753 0 00-1.315-2.778c.545 1.23 1.089 2.505 1.633 3.734 0 .046.045.092.045.092-.09 0-.136-.046-.227-.091-.09-.046-.136-.046-.226-.092-.046-.045-1.633-.82-1.724-.865-.408-.228-5.35-2.323-5.577-2.414-.045 0-.045 0-.09-.045-.59-.274-.772.318-.726.5-.227-.09-.408-.136-.635-.227-.227-.091-.635-.228-.635-.228-.09-.045-.227.091-.317.273-.046.091-.046.228-.046.32-.272-.046-.499-.137-.725-.229l-.408-.136a1.335 1.335 0 00-.454-.091c-.136-.046-.317-.046-.499-.046a.691.691 0 00-.453.182c-.136.137-.136.32-.09.501.044.183.135.32.226.456.045.045.045.091.09.136l.091.092c.408 1.23.454 1.275.5 1.32.044.046.09.091.18.137.046.046.136.091.182.137.09.045.136.09.227.136a.99.99 0 01.226.137c.091.045.182.091.272.091.091.046.227.091.318.091.045 0 .045 0 .09.046-.09 0-.226-.046-.317-.046-.09.273-.181.683-.181.683s4.761 2.05 7.164 3.006c-1.405-.455-2.811-.865-4.217-1.32-.453-.137-.952-.32-1.406-.456-.952-.273-1.95-.547-2.992-.683-.272-.046-.545-.046-.862-.091-.136 0-.272-.046-.408-.046-.136 0-.272-.045-.408-.045-.09 0-.136 0-.182-.046-.045 0-.136-.046-.181-.046-.272-.09-.59-.182-.862-.273-.18-.09-.226-.09-.317-.09H.42c-.182-.046-.363.136-.408.41-.046.272.045.5.226.546H.33c.408.045.862.09 1.27.182.09 0 .181.045.317.09.272.092.59.183.862.274l-.136.41c-.046.091-.046.228-.091.319v.045l.952.274c2.268.683 4.49 1.32 6.757 2.004-.046.182-.136.41-.182.592-.68-.228-1.405-.501-2.085-.729-.363-.137-.68-.228-1.043-.364-.726-.228-1.452-.501-2.132-.73 0 0-.09-.045-.045 0 .045 0 .09.046.136.046.59.228 1.179.41 1.814.638.317.091.59.228.907.319.045 0 .09.045.09.045a6.026 6.026 0 01-.861-.227c-.544-.182-1.134-.365-1.678-.547l-.816-.273c-.318-.091-.635-.228-.907-.319-.136-.045-.454-.137-.771-.273a27.738 27.738 0 00-1.451-.501c-.045 0-.045-.046-.09-.046-.137-.045-.318.091-.409.32-.045.227 0 .409.136.455h.045c.046 0 .091 0 .137.045 1.179.319 2.312.638 3.446 1.002.136.046.227.046.363.091.59.182 1.179.41 1.723.638-.272-.091-.59-.137-.862-.228.363.091.726.182 1.089.319.18.045.362.137.498.182.182.046.363.137.544.182.68.228 1.406.501 2.086.729.68.228 1.406.501 2.086.729.68.227 1.406.5 2.086.728-1.723 1.595-3.446 3.143-4.988 4.874-.272.319-.59.683-.816 1.002-.045.045-.045.09-.09.136-.091.046-.137.137-.227.183 0 0-.363.273-.454.364-.09.09.045.319.227.455.181.137.408.182.499.091.09-.182.226-.364.317-.546.045-.046.045-.091.09-.137.046-.045.091-.045.137-.09a.987.987 0 00.226-.183c2.268-1.822 4.49-3.598 6.712-5.42.045-.045.09-.091.136-.091 0 0 .045 0 .09.046.091.045.136.045.227.09a55.756 55.756 0 00-1.587 1.777 4.093 4.093 0 00-.408.455c-.272.274-.544.592-.816.866a3.184 3.184 0 00-.363.455c.045 0 .09-.045.09-.091-.952 1.002-2.902 3.006-2.902 3.006l.136.137c-.453.41-.906.865-1.36 1.275l.136.136c-.181.137-.363.32-.544.456l-.09.091c-.091.091 0 .364.18.592.182.182.363.319.5.273-.318.32-.726.684-.998 1.002l-.136.137c-.09.137-.182.456-.09.638 0 .045.045.136.09.182-.272.227-.499.41-.771.637l-.045.046c-.046.091-.046.228.09.41.136.182.318.273.408.182 0 .091 0 .182.046.273.09.137.227.182.317.182h.046l.045-.045c.861-.683 1.768-1.412 2.63-2.095.317-.228.59-.501.907-.729-.272.41-.544.775-.816 1.184l-.091.091-.363.365c-.227.227-.499.455-.725.729l-.59.592-.09.09c-.182.228-.182.547 0 .73h.68s.045 0 .045-.046c0 0 .045 0 .045-.046l.046-.045.045-.046v-.045-.046-.045-.046l.045-.046s0-.045.046-.045c0 0 0-.046.045-.046 0 0 0-.045.045-.045 0 0 0-.046.046-.046l.045-.045.045-.046.046-.045.045-.046.046-.045.045-.046.045-.045.046-.046.045-.046.045-.045.046-.046.045-.045.045-.046.046-.045.045-.046.045-.045.046-.046.045-.045.045-.046.046-.046.045-.045.045-.046.046-.045.045-.046.045-.045.046-.046.045-.045.045-.046s0-.046.046-.046c.09-.136.181-.273.317-.364.136-.09.227-.228.363-.364.363-.364.68-.683 1.043-1.002.363-.364.725-.683 1.043-1.002.136-.137.227-.228.363-.319l.68-.683c.136-.137.227-.228.363-.319l.68-.683c.363-.319.68-.683 1.043-1.002.045-.046.136-.091.181-.182.182-.183.363-.32.544-.501l.363-.365c.046-.045.136-.09.182-.136.362-.32.77-.638 1.133-.911a33.66 33.66 0 001.315-1.093 1831.88 1831.88 0 00-9.296 9.7l-.045.046 2.585-2.596c.544-.546 1.088-1.093 1.587-1.64.317-.318.635-.637.952-1.001.453-.41.862-.866 1.27-1.321l2.584-2.596 1.225-1.23.045-.045c0 .09.046.136.09.182 0 .045.046.136.046.182.046.182.046.319.09.501.182 1.412.409 3.461.409 3.643.09.547.136 1.094.227 1.64.181 1.275 1.088 6.285 1.224 6.65.09.182.227.319.408.364.182 0 .408-.182.454-.364.045-.274-.091-.501-.091-.775V36.95v-.593c0-.364-.045-.683-.045-1.047-.046-.729-.182-1.412-.272-2.095 0-.182-.136-1.32-.136-1.458 1.088 2.187 3.31 6.559 3.31 6.559.045.09.227.09.453 0 .227-.091.363-.228.318-.319-.907-2.232-1.769-4.418-2.676-6.604.59.774 1.18 1.594 1.769 2.368.045.046.09.092.09.137.046.046.046.137.091.182.363.865.726 1.685 1.134 2.505a34.496 34.496 0 01-1.27-2.596c.227.592.454 1.23.726 1.822.272.592.544 1.139.861 1.685.136.228.318.501.5.774.135.183.316.32.453.501.136.137.453.274.725.182a.706.706 0 00.363-.273.921.921 0 00.136-.5c0-.183-.046-.365-.136-.547.181-.091.363-.182.544-.228.045 0 .045 0 .09-.046a49.186 49.186 0 01-1.042-2.231 49.244 49.244 0 01-1.043-2.232 49.29 49.29 0 01-1.043-2.232c-.363-.728-.726-1.457-1.088-2.231l.408.136c1.587 3.234 3.128 6.513 4.761 9.701-1.496-3.188-2.993-6.421-4.49-9.61 1.678.547 3.356 1.094 5.08 1.64-.862-.319-1.724-.592-2.585-.91-.862-.32-1.723-.593-2.585-.912-.09-.182-.181-.41-.272-.592.77.228 1.542.501 2.313.729.09.045.226.09.317.09 1.088.32 2.222.684 3.356 1.003.226.046.453.137.635.228.453.136.861.273 1.314.41.454.136.862.273 1.27.455.318.137.635.228.953.364.09.046.226.137.226.137h.045c.227 0 .545-.41.68-.956.182-.592.137-1.185-.09-1.23l-.136-.046c.045-.273.045-.455-.136-.5 0 0-3.628-1.185-5.396-1.731-.272-.091-.499-.137-.771-.228l-2.993-.956h.317c.182.045 1.588.5 1.996.637.725.228 1.405.456 2.131.683l2.04.683h.046c.045-.045.136-.09.136-.227.045-.137.045-.228 0-.274l-.045-.045h-.046c-.181-.091-.408-.137-.59-.182-.68-.228-1.314-.456-1.995-.683-.453-.137-.906-.32-1.314-.456-.137-.046-.318-.091-.454-.182 4.126-.683 8.797-1.002 6.983-1.32zM9.852 21.782c-.272-.045-.5-.137-.726-.228.046 0 .136.046.182.046l.408.137c.045 0 .136.045.181.045h-.045zM21.188 12.4c0-.091 0-.228.046-.319 0-.136.045-.319.045-.455.045.41.09.774.181 1.184 0 .091.046.228.046.364-.091-.182-.182-.41-.272-.592 0-.045-.046-.045-.046-.09V12.4zm-.136.956c0-.09.046-.182.046-.273.136.273.272.547.362.82 0 .045.046.091.046.091V14.541c-.136-.32-.318-.684-.5-1.048.046 0 .046-.046.046-.137zm-.181-4.099c-.045.228-.045.456-.09.684a7.47 7.47 0 00-.091 1.002c.09-.592.136-1.185.226-1.731.046.09 0 .228 0 .364-.045.638-.136 1.321-.181 1.959-.046-.046-.046-.137-.09-.183l-.046-.045v-.137c.09-.728.181-1.503.272-2.186.045.046.045.182 0 .273zm-1.27 1.094c0-.137-.045-.32-.045-.456.317.638.59 1.275.907 1.913 0 .091-.046.228-.046.319l-.816-1.777zm.771 2.231v.182c-.181-.41-.363-.82-.544-1.275 0-.046-.045-.046-.045-.091 0-.046 0-.137-.046-.182.227.455.408.91.635 1.366zm-1.043-2.277c.09.182.136.319.227.5v.138c-.09-.183-.136-.365-.227-.547v-.091zm.09-.729c0 .137.046.273.046.41l-.272-.546c0-.137-.045-.274-.045-.41.09.227.181.41.272.546zm-.317-1.23c0-.136-.045-.273-.045-.41.09.183.181.41.272.593 0 .09.045.227.045.319-.136-.137-.18-.32-.272-.501zm.318.456c.181.41.363.865.544 1.275a.995.995 0 01-.136-.228c-.09-.182-.227-.41-.317-.637 0-.046-.046-.091-.046-.137V8.94c-.045-.046-.045-.091-.045-.137zm.997 3.962c.046.091.091.183.136.228v.182c-.045-.09-.09-.182-.09-.273-.046-.046-.046-.091-.046-.137zm.091-.455l-.045-.046v-.136-.183c.045.092.09.183.136.228 0 .091-.046.228-.046.32.046-.047 0-.138-.045-.183zM15.293 1.834s0-.046-.045-.091c0-.046-.045-.046 0-.046v.046c.045.09.09.182.09.273.273.683.59 1.412.862 2.095-.272-.774-.59-1.503-.907-2.277zm1.043 1.32c-.136-.273-.226-.546-.362-.82-.091-.227-.227-.5-.318-.728V1.56v-.045c.045.045.045.045.045.09.318.73.68 1.458 1.043 2.233.454 1.002.953 2.05 1.451 3.097.091.227.227.455.318.683 0 .045.045.045.045.09V7.8c0 .091.046.182.046.273-.771-1.64-1.497-3.279-2.268-4.919zm2.313 1.048c0 .045 0 .091.045.182 0-.137-.045-.228-.045-.364-.046-.501-.136-1.002-.181-1.503 0-.182 0-.365.09-.501.09-.137.227-.228.363-.228.272 0 .499.364.544.547l.136.41.136.41c.182.546.318 1.138.454 1.776.136.592.226 1.23.362 1.867l.273 1.64c0 .09.045.182.045.227v.183c-.09.774-.181 1.594-.272 2.368-.363-.729-.726-1.549-1.088-2.323-.046-.046-.046-.091-.091-.137 0-.09 0-.182-.046-.273-.09-.592-.136-1.184-.226-1.776l-.272-2.05c0 .183.045.32.045.456.136 1.138.272 2.232.363 3.37-.09-.136-.136-.319-.227-.5 0-.046-.045-.046-.045-.092v-.137c-.046-.546-.136-1.138-.182-1.73-.045-.592-.136-1.23-.181-1.822zM17.062 8.71a.49.49 0 01.09.273c.59 1.458 1.225 2.96 1.814 4.418.091.182.182.41.227.592 0 .046.045.046.045.091v.182c-.725-1.822-1.496-3.643-2.222-5.465.046-.046.046-.046.046-.091-.046 0-.046 0 0 0zm.997 14.62c.046-.091.136-.137.227-.228.045 0 .09.045.181.045v.046l-.272.273c-.045 0-.09-.045-.136-.045-.045-.046-.045-.091 0-.091zm-.181 0c-.045 0 0 0 0 0a.547.547 0 01.227-.228l-.227.228zm-.862-14.62s0-.046-.045-.046c.045 0 .045 0 .045.046zm0-.091s-.045 0 0 0zm0 0c-.045 0-.045 0 0 0-.045-.046-.045 0 0 0zm-.045-.046s0-.045 0 0c0-.045 0-.045 0 0zm0-.045s-.045-.046 0 0c0-.046 0 0 0 0zm-.045-.091c0 .045 0 0 0 0zm.498 4.372l.68 1.64c-.135-.274-.271-.502-.362-.775-.136-.273-.227-.546-.318-.82l-.68-1.64a9.9 9.9 0 00.68 1.595zm-.589.5c.136.274.227.547.363.82.136.274.226.547.363.866a38.387 38.387 0 01-1.316-2.323c-.09-.136-.136-.273-.226-.41-.09-.136-.136-.273-.182-.41-.453-1.138-.952-2.277-1.405-3.415 0 0 0 .045.045.045.272.501.499 1.048.77 1.549l.817 1.64c.227.546.499 1.092.771 1.639zM14.16 2.153c.181.41.317.82.498 1.185.046.045.046.136.091.182a17.465 17.465 0 00-.499-1.412h.046c.453 1.002.907 2.004 1.315 3.051-.136.046-.182.046-.272.091-.182-.364-.318-.774-.5-1.138l-.135-.41c-.09-.273-.227-.501-.318-.729-.136-.273-.226-.5-.226-.82zm-.182.046l1.225 2.87c0 .045.045.09.045.136 0 0 0 .045 0 0h-.045c-.046-.046-.046-.137-.046-.137-.363-.91-.77-1.913-1.179-2.869zm-.77 5.875s.045.046.045.091c.09.183.226.365.272.592.09.228.181.456.272.73a13.116 13.116 0 00-.59-1.413zm.408.729c0-.046 0 0 0 0 .271.5.544 1.002.816 1.457.045.091.09.183.136.228.816 2.004 1.678 4.1 2.585 6.057.09.183.136.32.226.502 0 0-.045 0-.09-.046a224.183 224.183 0 01-3.674-8.198zm.68 9.109c.136.045.272.136.408.182.816.364 1.632.774 2.494 1.139l-.726.455a.992.992 0 01-.227-.137c-.272-.136-.589-.273-.861-.41-.181-.09-.408-.182-.59-.273-.589-.273-1.178-.546-1.723-.82-.136.046-.272 0-.408-.045-.363-.137-.68-.319-.952-.455-.045 0-.045-.046-.09-.046-.273-.137-.59-.319-.862-.456-.091-.045-.227-.09-.318-.136 1.18.228 2.313.5 3.446.82.091.09.227.136.409.182zm2.675 2.55c-.09-.045-.227-.09-.317-.136-.091-.046-.182-.046-.227-.091 0 0 .045 0 .045-.046.136.091.318.182.5.273zm-5.532-4.554c.045 0 .09.046.136.046.045 0 .09.045.136.045.045 0 .045.046.09.046.091.045.137.136.227.182-.226-.091-.453-.228-.725-.32h.136zm-2.177-.319c.182.091.408.182.59.273l1.768.82c-.952-.182-1.995-.364-2.993-.592-.045 0-.136 0-.181-.045-.045 0-.045-.046-.09-.046l2.085.182s-1.088-.546-2.358-1.047c.09.045.182.045.272.09.091.046.227.046.318.092.226.09.408.182.59.273zm-2.267-1.685c.544.182 1.088.364 1.587.546-.045 0-.136-.045-.227-.045-.226-.046-.453-.137-.635-.182-.09 0-.136-.046-.181-.046-.09 0-.181 0-.272-.045-.09 0-.136-.046-.227-.091-.045 0-.09-.046-.09-.046-.091-.046-.182-.091-.318-.137-.09-.045-.181-.045-.227-.09.227 0 .454.09.59.136zm3.356 3.917c.18.09.362.182.544.319-.363-.137-.726-.32-1.089-.456-1.088-.455-2.176-.956-3.31-1.412.09 0 .136 0 .227.046l.77.182c.137.046.273.137.409.182.09.046.227.046.363.046.09 0 .226 0 .317.045l.862.592.09.046 1.814.774 1.995.911c-.997-.41-2.04-.82-3.038-1.23 0-.045.046-.045.046-.045zm1.27 3.325c.09 0 .135.045.226.045.227.046.453.137.635.182a5.683 5.683 0 00-.454-.136c-.136 0-.272-.046-.408-.091zm.453.182c1.133.318 2.267.637 3.355.956a.627.627 0 01-.181.137c-1.043-.365-2.131-.729-3.174-1.093zm1.133 1.594c.409.09.771.227 1.18.319 0 .045-.046.045-.046.045a8.275 8.275 0 01-1.134-.364zm1.905.956c-1.315 1.048-2.63 2.14-3.945 3.234.453-.41.861-.866 1.315-1.275l.227-.228.226-.228c.272-.319.59-.592.862-.865.227-.228.453-.41.635-.638l.226-.227c.136.136.318.182.454.227.045 0 0 0 0 0zm.272-.182c-.181-.046-.318-.137-.499-.182 0-.046.046-.046.09-.091l.545.136-.136.137zm-.363-2.778c-1.496-.456-2.993-.957-4.49-1.412 1.996.592 3.991 1.184 5.941 1.822-.045.045-.045.045-.09.045-.091-.045-.182-.045-.273-.09-.362-.092-.725-.229-1.088-.365zm.771 1.73l.045-.045.136-.137c.227.046.454.137.68.183-.09.09-.18.136-.271.182-.182-.046-.363-.137-.59-.182zm.318 1.276c.045-.046.09-.091.18-.137.092.046.137.046.228.091l-.136.137c-.137 0-.182-.046-.273-.091zm-7.8 12.115c.408-.365.816-.683 1.224-1.048 1.406-1.184 2.766-2.414 4.172-3.644-.09.183-.227.32-.363.502 0 .045-.045.045-.045.09l-.09.092c-.5.41-.998.82-1.452 1.23.09-.046.136-.092.227-.137-.317.273-.635.546-.952.774-.953.774-1.905 1.549-2.902 2.277.045-.045.136-.09.18-.136zm.635-.365c-.408.365-.816.729-1.27 1.048 0 0-.045 0-.045.045v-.09l.045-.046c.045-.046.045-.046.09-.046.046 0 .046-.045.091-.09.409-.32.862-.684 1.27-1.003-.045.091-.136.137-.181.182zm.181-.182c0 .046.046 0 0 0zm2.766-2.05c-.317.274-.68.593-1.043.866-.453.364-.907.774-1.405 1.139a.628.628 0 01.181-.137l.544-.41c.227-.182.454-.41.68-.592.227-.182.454-.41.68-.592.227-.182.454-.365.726-.547a2.514 2.514 0 00-.363.274zm-.045-.045c0-.046.045-.046.045-.046.182-.136.318-.273.5-.41.18-.136.362-.273.498-.41 0 .046-.045.046-.09.092-.273.227-.636.5-.953.774zm.952.228c.046-.091.136-.182.227-.32.045-.045.045-.09.045-.09l.091-.091c.181-.137.408-.319.59-.501-.318.364-.635.683-.953 1.002zm.726-5.739l-.09.091c-.046 0 .044-.045.09-.09.09-.092.226-.229.317-.365l.227-.228c.272-.319.59-.592.861-.865.363-.365.726-.729 1.043-1.093l.227-.228.227-.228.317-.319c.046-.045.046-.09.091-.09h.045c-.181.227-.408.455-.59.683l.681-.684c.045 0 .09.046.136.046l-.68.683-.045.046-.046.045-.09.091c-.953.866-1.86 1.685-2.721 2.505zm3.854-5.01c-.045.091-.136.137-.227.228h-.09c.136-.091.272-.182.317-.228.045 0 .045 0 0 0 .045 0 .045 0 0 0zm.045 1.276s0 .045-.045.045l-.136.137c-.045 0-.09-.046-.136-.046l.136-.136c.09-.046.136 0 .181 0zm-.271-.092h.045c-.046.046-.09.137-.182.183h-.045l.045-.046.137-.137zM15.61 29.98l-.136.137c-.136.136-.318.273-.454.41.045-.046.045-.091.09-.137 0 0 0-.046.046-.046.046-.045.09-.045.136-.09.091-.137.227-.183.318-.274zm1.813-1.184c-.906.729-1.813 1.457-2.766 2.186.046-.09.136-.182.227-.273.318-.273.59-.547.907-.774.09-.091.227-.182.318-.274.498-.318.997-.683 1.45-1.002 0 .046-.09.091-.136.137zm.318-7.014c-.272-.09-.499-.137-.726-.228 0 0 0-.045.046-.045.226.091.453.136.68.273 0-.045 0-.045 0 0zm0-1.594s-.045 0-.09-.045c-.228-.046-.409-.137-.636-.228.227-.091.454-.228.68-.319.046.137.137.273.182.41 0 .046-.045.046-.09.091.045.046 0 .091-.046.091zm.045 7.697c.091-.091.182-.137.272-.228.227-.182.5-.41.726-.592a.626.626 0 01-.181.137c.59-.501 1.224-1.048 1.859-1.549.09.046.181.046.272.091-.998.73-1.995 1.458-2.948 2.141zm3.401-2.55l-.272.273c-.09-.046-.181-.046-.272-.091.09-.091.227-.182.318-.273.09 0 .18.045.226.09.046 0 0 0 0 0zm-.181-11.022c0-.046-.045-.091-.045-.091v-.137-.137c.226.456.408.866.634 1.321 0 .137 0 .32.046.456-.227-.456-.408-.957-.635-1.412zm2.313 13.754v.456c-.227-.456-.5-.957-.726-1.412.045.045.045.091.09.091.227.319.409.592.636.865zm-.68-2.323c.045.092.045.137.09.228-.045-.09-.136-.182-.181-.273 0 0 .045.045.09.045zm-.5-10.748c.091.137.137.273.227.455v.137c-.09-.136-.136-.319-.226-.455v-.137zm.091.957c0-.046-.045-.092-.045-.137v-.182-.41c.045.09.09.227.181.319 0 .045.046.09.046.136v.319c0 .046-.046.046-.091.091-.045-.045-.09-.091-.09-.136zm.091 10.794l.045.045.046.046s0 .045.045.09c.045.092.045.137.09.228a1.844 1.844 0 01-.226-.41zm.59 2.869a10.655 10.655 0 01-.318-.866c-.045-.136-.045-.318-.09-.455.226.455.498 1.002.77 1.457.046.046.09.137.09.228v.501c-.18-.364-.362-.729-.453-.865zm6.121 6.148c.09.091.136.228.227.32.227.272.408.591.635.864.09.137.227.32.272.456l-.046-.046a5.242 5.242 0 01-.634-.774c-.227-.319-.363-.638-.544-.956.045.09.045.136.09.136zm-2.947-11.568l1.088.273-.045.046c-.318-.091-.68-.228-1.043-.319zm.59 1.776c-.137-.045-.318-.09-.454-.136-.046-.137-.136-.228-.182-.365.136.046.318.091.454.137.045.136.136.228.181.364zm.045-2.368c0 .046 0 .046 0 0-.363-.091-.68-.228-1.043-.319-.046-.045-.046-.137-.091-.182.045 0 .09.045.136.045.317.183.68.32.998.456zm-.726-1.776l-.272.273c-.272-.137-.499-.228-.771-.364l-.272-.547.136-.137c.499.183.952.365 1.451.547-.09.045-.181.137-.272.228zm-.635 1.366a.839.839 0 00-.317-.091l.181-.182h.046c0 .09.045.182.09.273zm-.453-.41l-.091.091-.045.046c-.046-.091-.091-.182-.091-.228.09.046.136.091.227.091zm1.814-1.594c-.5-.182-.998-.319-1.497-.5v-.047l.046-.045c.498.182.997.364 1.45.547.091 0 .046 0 0 .045zm1.859.501c1.043.364 3.038 1.048 4.08 1.412.046 0 .046.045.092.045.045 0 .09 0 .09.046-.045.046-.09.046-.136 0-.045 0-.045-.046-.09-.046a396.464 396.464 0 00-4.036-1.457zm3.764 1.412c.045 0 .09.045.136.045.09.046.226.092.362.137.046 0 .046 0 .091.046l-2.177-.729a116.99 116.99 0 00-3.673-1.275l.046-.046c1.36.456 3.763 1.321 5.214 1.822zm3.264-9.337c-.09.091-.181.137-.272.182-.634.456-1.224.957-1.859 1.458-1.406 1.093-2.72 2.277-4.081 3.416-.635.546-1.315 1.138-1.95 1.685l-.045.045c-.5-.182-.998-.364-1.497-.5v-.046c.091-.091.136-.137.227-.182l.816-.683c.182-.137.363-.32.544-.456.091-.091.182-.182.273-.228.453-.364.906-.728 1.36-1.138a.73.73 0 01.317-.182c2.04-1.23 4.127-2.278 6.167-3.37zm.771-1.047c-.68.364-1.405.729-2.086 1.093-.09.045-.181.09-.272.182l-1.768.957c.045-.046.09-.046.09-.092.59-.41 1.225-.774 1.905-1.138l.544-.274c.182-.09.363-.182.544-.273.272-.136.68-.273 1.043-.455zm1.36-2.277c.046 0 .137-.046.182-.046H38.465c.046 0 .09.046.136.091.091.091.136.137.227.273.045.046.045.091.09.183v.227c-.09.41-.407.592-.725.774-.045 0-.045.046-.09.046-.046 0-.091.046-.091.046-.046.045-.136.045-.136.09-.046 0-.091-.045-.136 0 .045 0 .136-.09.181-.09.272-.137.499-.32.726-.501a.578.578 0 00.181-.41c0-.182-.09-.32-.227-.456l-.09-.09c-.046-.046-.137-.046-.182-.092-.181-.045-.408 0-.59.046-.362.09-.68.182-.997.273a10.42 10.42 0 00-1.27.455c.68-.364 1.497-.637 2.268-.82zm-3.491 2.231l.09-.09-.09-.092c.272-.182.544-.319.816-.455.318-.137.635-.228.953-.365.453-.182.952-.319 1.45-.455.137-.046.227-.091.363-.091h.182c-.09.09-.272.136-.408.227-.272.137-.59.274-.862.41-.136.091-.317.137-.453.182-.136.046-.318.137-.454.183-.453.182-1.27.592-1.36.637-.318.183-.635.32-.953.501.091-.09.273-.227.409-.364.136 0 .226-.137.317-.228zm-9.205 5.784c.136-.09.227-.227.363-.318.453-.41.906-.82 1.36-1.185.136-.09.227-.182.363-.273.317-.319.68-.592.997-.91.907-.82 1.769-1.64 2.721-2.46l1.36-1.23c.68-.592 1.36-1.23 2.086-1.776.227-.182.5-.41.771-.547-.408.684-.952 1.185-1.541 1.686-.137.09-.227.182-.363.318-.408.365-.862.73-1.27 1.093 0 0-.045 0-.045.046-.227.228-.5.41-.726.638-.453.41-.952.774-1.36 1.184-.454.41-.907.82-1.36 1.184-.227.182-.454.41-.68.592-.454.41-.908.774-1.361 1.184a69.783 69.783 0 01-2.086 1.73c-.045 0-.136-.045-.136-.045l.045-.045c.227-.32.544-.592.862-.866zm-.5 3.097c-.09-.045-.135-.09-.226-.09.046-.046.09-.046.136-.092.046.046.09.091.09.182zm.5-4.144c-.318.319-.635.683-.998 1.002l-.045.045s0 .046-.046 0v-.045l.046-.046c.68-.683 1.405-1.366 2.086-2.05-.318.365-.726.73-1.043 1.094zm-1.451-1.594v-.137c0-.045.045-.045.09-.09l.272-.274c.409-.364.771-.683 1.18-1.048.136-.136.271-.227.407-.364l.182-.182c.317-.274.635-.592.998-.866-.5.547-1.043 1.093-1.542 1.64-.408.41-.771.82-1.18 1.23l-.407.41v-.32zm0 1.822c0-.046.09-.091.136-.183.362-.364.68-.728.997-1.093.136-.136.272-.318.454-.455.227-.273.499-.501.725-.774.318-.365.68-.73.998-1.093l.136-.137c.363-.41.816-.82 1.179-1.184l.59-.592c.589-.592 1.224-1.184 1.813-1.777.091-.09.227-.182.318-.273.317-.273.635-.592.952-.865.227-.182.453-.364.635-.547l.68-.546c-1.179 1.23-2.403 2.46-3.582 3.689l-.907.91-.136.137-.09.091-4.309 4.327-.453.456-.091.09s0 .046-.045.046c.045-.09 0-.136 0-.227zm.317 8.607l.363.502a3.111 3.111 0 00-.363-.137v-.364zm1.86 7.105s0-.045 0 0a16.632 16.632 0 01-.454-.865c-.136-.273-.318-.592-.454-.865a20.744 20.744 0 00-.907-1.73v-.912c.635 1.458 1.225 2.915 1.814 4.372zm.725-2.186c-.182-.227-.363-.5-.544-.774a73.014 73.014 0 00-1.678-2.277c-.045-.046-.09-.182-.136-.273-.046-.183-.136-.32-.182-.501 0-.046-.045-.091-.045-.091v-.228-.228c.181.046.363.137.544.182l1.542 2.277c.181.684.317 1.321.499 1.913 0 0 .045 0 0 0 .045.046 0 0 0 0zm-.136-5.055c.09 0 .226.045.363.045.045 0 .09 0 .09.046-.181 0-.317-.046-.453-.091zm2.358 7.925a48.589 48.589 0 01-1.225-1.594l-.09-.091c0-.046-.046-.092-.046-.137a13.72 13.72 0 01-.498-1.458l1.859 3.28zm-1.134-6.149l-.408-.137c-.09-.182-.181-.41-.272-.592l.408.137c.09.228.181.41.272.592zm10.657 1.139c.045-.046.045-.046.09-.046v.228c0 .091-.045.182-.09.182-.046 0-.136 0-.182-.045-.861-.228-1.768-.456-2.63-.73-.68-.181-1.406-.41-2.086-.591-1.86-.501-3.718-1.048-5.578-1.549-.18-.045-.362-.09-.544-.182-.045 0-.09 0-.136-.091.227.046.454.137.68.182.68.182 1.36.364 2.086.547.907.227 1.86.5 2.767.728.907.228 1.859.501 2.766.73.226.045.453.136.68.181.363.091.68.182 1.043.274.136.045.227.045.363.09.226.092.453.137.634.228.046 0 .046-.045.046-.09 0-.046-.046-.046-.136-.092.045.137.136.091.227.046zm-.273.045s.046 0 0 0zm-1.45-.455a.34.34 0 00.18.045c.409.137.817.228 1.225.365-.09 0-.136 0-.227-.046-.045 0-.09-.045-.136-.045-.317-.137-.68-.228-.997-.32.09.046.181.046.272.092a.642.642 0 01-.272-.091l-1.769-.547c-.68-.227-1.36-.41-2.04-.637 1.27.455 2.539.82 3.763 1.184zm-6.984-2.095c.09.045.181.045.272.09.454.137.862.32 1.315.456 1.451.456 2.902.911 4.308 1.367-2.811-.775-5.668-1.594-8.48-2.369-.045 0-.045-.045-.045-.09l-.136-.274c.363.091.725.228 1.088.319.59.182 1.134.319 1.678.5zm1.27-1.822c0-.091-.046-.137-.091-.182 2.04-.046 5.487-.137 6.167-.091.726.045-3.628.182-6.076.273z"
  })));
}

var _path$6, _path2, _path3, _path4, _circle;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function SvgSuccessCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.755 4.66c12.26 6.52 20.726 19.235 21.222 33.97a21.122 21.122 0 01-4.048 3.656C75.976 41.53 76 40.768 76 40c0-15.033-9.214-27.914-22.303-33.303a20.865 20.865 0 015.058-2.037z",
    fill: "#00A851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 4c9.692 0 18.49 3.83 24.962 10.06a26.997 26.997 0 00-1.032-6.115A39.822 39.822 0 0040 0C27.504 0 16.347 5.73 9.011 14.706a27.16 27.16 0 00.513 6.121C15.9 10.717 27.166 4 40 4z",
    fill: "#F12BA3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.725 79.046C66.621 75.064 80 59.095 80 40c0-.861-.027-1.716-.08-2.564a28.134 28.134 0 00-4.953-6.034A36.087 36.087 0 0176 40c0 19.374-15.304 35.173-34.482 35.969a27.84 27.84 0 007.207 3.077z",
    fill: "#FF8E26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.34 78.65A40.06 40.06 0 0140 80C17.909 80 0 62.091 0 40 0 26.962 6.238 15.381 15.892 8.079a43.158 43.158 0 017.144.16C11.707 14.303 4 26.251 4 40c0 19.882 16.118 36 36 36a35.873 35.873 0 0014.62-3.093 42.654 42.654 0 01-4.28 5.743z",
    fill: "#772BCB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    fill: "#fff"
  })));
}

const EXTRA_ICON_NAME_TO_SVG_MAP = {
    loading: SvgLoading,
    magic_button: SvgMagicButton,
    magic_button_web: SvgMagicButtonWeb,
    round_close_button: SvgRoundCloseButton,
    spark_icon: SvgSparkIcon,
    success_circle: SvgSuccessCircle,
    gift: SvgGift,
};
const NAME_TO_SVG_MAP = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, EXTRA_ICON_NAME_TO_SVG_MAP), NAME_TO_EXTRA_LARGE_SVG_MAP), NAME_TO_LARGE_SVG_MAP), NAME_TO_SMALL_SVG_MAP), NAME_TO_EXTRA_SMALL_SVG_MAP);
const defineSizeFromName = (name) => {
    if (name.includes('_extra_small')) {
        return 16;
    }
    if (name.includes('_small')) {
        return 24;
    }
    if (name.includes('_extra_large')) {
        return 48;
    }
    if (name.includes('_large')) {
        return 32;
    }
    return undefined;
};
/**
 * Developer Note:
 * size prop requires svg to NOT have height or width attributes (keep viewBox)
 * fill prop requires svg to have fill attribute matching path fill attribute
 */
const Icon = (_a) => {
    var { name, id, size: requestedSize, fill, className } = _a, props = __rest(_a, ["name", "id", "size", "fill", "className"]);
    const svg = NAME_TO_SVG_MAP[name];
    const size = requestedSize || defineSizeFromName(name);
    return svg ? (React__default.createElement(SvgIcon, Object.assign({}, props, { id: id, width: size, height: size, component: svg, className: className, fill: fill }))) : null;
};

const colors = {
    newZealandBlackDarkMode: '#121212',
    newZealandBlack: '#1d1d1d',
    newZealandBlackOpacity64: 'rgba(29, 29, 29, 0.64)',
    greyLynn: '#303030',
    greymouth: '#444444',
    mawheranui: '#767676',
    moeraki: '#BABABA',
    alto: '#dadada',
    onepu: '#f0f0f0',
    wairua: '#ffffff',
    poroporo: '#430e7d',
    sparkPurple: '#5a12aa',
    lupin: '#772bcb',
    pukaki: '#f4eefb',
    wanaka: '#e9ddf7',
    benLomond: '#c691ff',
    lupinDarkMode: '#a168df',
    lupinOpacity50: 'rgba(119, 43, 203, 0.5)',
    wairuaOpacity12: 'rgba(255, 255, 255, 0.12)',
    wairuaOpacity40: 'rgba(255, 255, 255, 0.4)',
    wairuaOpacity8: 'rgba(255, 255, 255, 0.08)',
    darkPink: '#b70e74',
    sparkPink: '#d5258f',
    sparkPinkOpacity6: 'rgba(213, 37, 143, 0.06)',
    mawhero: '#f12ba3',
    mawheroOpacity6: 'rgba(241, 43, 163, 0.06)',
    aotearoa: '#007136',
    sparkGreen: '#008841',
    kiwi: '#00a851',
    kiwiOpacity20: 'rgba(0, 168, 81, 0.2)',
    darkOrange: '#BA2900',
    karaka: '#C92d00',
    marangai: '#da3d00',
    sparkOrange: '#eb7019',
    kowhai: '#ff8e26',
    kowhaiOpacity20: '#ffe8d4', // temporary until designers come up with a better name/structure
};

const rotate = keyframes `
    from {
        transform: rotate(0deg);
    }
    to{
        transform: rotate(360deg);
    }
`;
const RotatingDiv = styled.div `
  ${({ size }) => css `
    animation: ${rotate} 1s linear infinite;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    height: ${size}px;
  `}
`;
const LoadingSpinner = ({ size = 18, fill = colors.lupin, }) => (React__default.createElement(RotatingDiv, { size: size },
    React__default.createElement(Icon, { name: "loading", size: size, fill: fill })));

const MediaQuery = styled.div.withConfig({
    shouldForwardProp: (props) => !['min', 'max'].includes(props),
}) `
  ${({ theme: { media }, min, max }) => {
    if (min && max) {
        return css `
        display: none;
        ${media.between(min, max)} {
          display: block;
        }
      `;
    }
    if (min) {
        return css `
        display: none;
        ${media.up(min)} {
          display: block;
        }
      `;
    }
    if (max) {
        return css `
        display: none;
        ${media.down(max)} {
          display: block;
        }
      `;
    }
    return css `
      display: block;
    `;
}}
`;

const up = (x, y) => up$1(x, y);
const down = (x, y) => down$1(x, y);
const between = (a, b, y) => between$1(a, b, y);
const only = (x, y) => only$1(x, y);
const media = {
    up,
    down,
    between,
    only,
};

function getQuery({ min, max }) {
    if (min && max) {
        return media.between(min, max);
    }
    if (min) {
        return media.up(min);
    }
    if (max) {
        return media.down(max);
    }
    return media.up('lil');
}
function useMediaQuery(props) {
    const [isVisible, setVisible] = useState(false);
    const theme = useTheme();
    useEffect(() => {
        let query = getQuery(props)({ theme });
        // Change to format that matchMedia likes
        query = query.replace('@media ', '');
        const mql = window.matchMedia(query);
        if (mql.matches !== isVisible) {
            setVisible(mql.matches);
        }
        const listener = () => {
            setVisible(mql.matches);
        };
        try {
            mql.addEventListener('change', listener);
            return () => mql.removeEventListener('change', listener);
        }
        catch (e1) {
            try {
                // For Support of Safari 12
                mql.addListener(listener);
                return () => mql.removeListener(listener);
            }
            catch (e2) {
                // eslint-disable-next-line no-console
                console.error(e2);
                return () => { };
            }
        }
    }, [props]);
    return isVisible;
}

const getResponsiveSpacing = (values) => {
    if (values === 0) {
        return 0;
    }
    const lil = useMediaQuery({ max: 'lil' });
    const slim = useMediaQuery({ max: 'slim' });
    const { spacing } = useTheme();
    let responsiveValues;
    if (typeof values === 'string') {
        const singleValue = values;
        responsiveValues = [singleValue];
    }
    else {
        responsiveValues = [...values];
    }
    if (lil) {
        return spacing[responsiveValues[0]];
    }
    if (slim) {
        return spacing[responsiveValues[1]] || spacing[responsiveValues[0]];
    }
    return (spacing[responsiveValues[2]] ||
        spacing[responsiveValues[1]] ||
        spacing[responsiveValues[0]]);
};
function getResponsiveValue(values) {
    let responsiveValues;
    if (Array.isArray(values)) {
        responsiveValues = [...values];
    }
    else {
        responsiveValues = [values];
    }
    const lil = useMediaQuery({ max: 'lil' });
    const slim = useMediaQuery({ max: 'slim' });
    if (lil) {
        return responsiveValues[0];
    }
    if (slim) {
        return responsiveValues[1] || responsiveValues[0];
    }
    return responsiveValues[2] || responsiveValues[1] || responsiveValues[0];
}

const BaseStyle$5 = styled.p `
  ${({ theme: { palette }, color, mb }) => css `
    padding: 0;
    margin: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    ${mb &&
    css `
      margin-bottom: ${getResponsiveSpacing(mb)};
    `}
    text-decoration: none;
    color: ${color || palette.textColor};
  `}
`;
function responsive$1(breakpoint, fontSize, lineHeight) {
    return css `
    ${({ theme: { media } }) => css `
      ${media.up(breakpoint)} {
        font-size: ${fontSize};
        line-height: ${lineHeight};
      }
    `}
  `;
}
const Display = styled(BaseStyle$5) `
  letter-spacing: -1px;
  font-weight: 600;
  font-size: 48px;
  line-height: 56px;
  ${responsive$1('slim', '72px', '80px')};
  ${responsive$1('big', '100px', '108px')};
`;
const headingLStyle = css `
  letter-spacing: -0.5px;
  font-weight: 600;
  font-size: 40px;
  line-height: 48px;

  ${responsive$1('slim', '52px', '60px')};
  ${responsive$1('big', '60px', '68px')};
`;
const HeadingL = styled(BaseStyle$5) `
  ${headingLStyle}
`;
const headingMStyle = css `
  font-size: 32px;
  line-height: 40px;
  letter-spacing: -0.5px;
  font-weight: 600;

  ${responsive$1('slim', '38px', '46px')};
  ${responsive$1('big', '50px', '58px')};
`;
const HeadingM = styled(BaseStyle$5) `
  ${headingMStyle}
`;
const headingSStyle = css `
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.5px;
  font-weight: 600;

  ${responsive$1('slim', '28px', '36px')};
  ${responsive$1('big', '40px', '48px')};
`;
const HeadingS = styled(BaseStyle$5) `
  ${headingSStyle}
`;
const subheadingLStyle = css `
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.5px;
  font-weight: 600;

  ${responsive$1('slim', '24px', '32px')};
  ${responsive$1('big', '32px', '40px')};
`;
const SubheadingL = styled(BaseStyle$5) `
  ${subheadingLStyle}
`;
const subheadingMStyle = css `
  font-size: 20px;
  line-height: 28px;
  letter-spacing: -0.5px;
  font-weight: 600;

  ${responsive$1('slim', '22px', '30px')};
  ${responsive$1('big', '24px', '32px')};
`;
const SubheadingM = styled(BaseStyle$5) `
  ${subheadingMStyle}
`;
const bodyMDemiStyle = css `
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  font-weight: 600;

  ${responsive$1('slim', '18px', '26px')};
  ${responsive$1('big', '20px', '28px')};
`;
const BodyMDemi = styled(BaseStyle$5) `
  ${bodyMDemiStyle}
`;
const bodyMMediumStyle = css `
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  font-weight: 500;

  ${responsive$1('slim', '18px', '26px')};
  ${responsive$1('big', '20px', '28px')};
`;
const BodyMMedium = styled(BaseStyle$5) `
  ${bodyMMediumStyle}
`;
const bodySDemiStyle = css `
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  font-weight: 600;

  ${responsive$1('slim', '16px', '24px')};
  ${responsive$1('big', '16px', '24px')};
`;
const BodySDemi = styled(BaseStyle$5) `
  ${bodySDemiStyle}
`;
const bodySMediumStyle = css `
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  font-weight: 500;

  ${responsive$1('slim', '16px', '24px')};
  ${responsive$1('big', '16px', '24px')};
`;
const BodySMedium = styled(BaseStyle$5) `
  ${bodySMediumStyle}
`;
const footNoteDemiStyle = css `
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  font-weight: 600;

  ${responsive$1('slim', '14px', '20px')};
  ${responsive$1('big', '14px', '20px')};
`;
const FootNoteDemi = styled(BaseStyle$5) `
  ${footNoteDemiStyle}
`;
const footNoteMediumStyle = css `
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0px;
  font-weight: 500;

  ${responsive$1('slim', '14px', '20px')};
  ${responsive$1('big', '14px', '20px')};
`;
const FootNoteMedium = styled(BaseStyle$5) `
  ${footNoteMediumStyle}
`;
const codeSnippetStyle = css `
  font-family: Courier, monospace;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  font-weight: normal;
  ${({ theme: { palette, spacing, borderRadius } }) => css `
    background-color: ${palette.baseColors.greyLynn};
    padding: 5px ${spacing.s1};
    border-radius: ${borderRadius.rHalf};
  `}
`;
const CodeSnippet = styled(BaseStyle$5) `
  ${codeSnippetStyle}
`;
const TextVariantMap = {
    display: Display,
    headingL: HeadingL,
    headingM: HeadingM,
    headingS: HeadingS,
    subheadingL: SubheadingL,
    subheadingM: SubheadingM,
    bodyMDemi: BodyMDemi,
    bodyMMedium: BodyMMedium,
    bodySDemi: BodySDemi,
    bodySMedium: BodySMedium,
    footnoteDemi: FootNoteDemi,
    footnoteMedium: FootNoteMedium,
    codeSnippet: CodeSnippet,
};
const TextComponentMap = {
    display: 'h2',
    headingL: 'h1',
    headingM: 'h2',
    headingS: 'h3',
    subheadingL: 'h4',
    subheadingM: 'h5',
    bodyMDemi: 'p',
    bodyMMedium: 'p',
    bodySDemi: 'p',
    bodySMedium: 'p',
    footnoteDemi: 'p',
    footnoteMedium: 'p',
    codeSnippet: 'p',
};
const Text = React__default.forwardRef(({ id, variant, className, component, children, color, title, mb, }, ref) => {
    const StyledTypography = TextVariantMap[variant] || TextVariantMap.bodySMedium;
    return (React__default.createElement(StyledTypography, { id: id, className: className, as: component || TextComponentMap[variant], variant: variant, ref: ref, color: color, title: title, mb: mb }, children));
});

const DefaultButtonHoverStyle = css `
  ${({ theme }) => css `
    border-color: ${theme.palette.baseColors.sparkPurple};
    background: linear-gradient(
        0deg,
        ${theme.palette.baseColors.pukaki},
        ${theme.palette.baseColors.pukaki}
      ),
      ${theme.palette.baseColors.wairua};
  `}
`;
const DefaultButtonActiveStyle = css `
  ${({ theme }) => css `
    border-color: ${theme.palette.baseColors.poroporo};
    background: linear-gradient(
        0deg,
        ${theme.palette.baseColors.wanaka},
        ${theme.palette.baseColors.wanaka}
      ),
      ${theme.palette.baseColors.wairua};
  `}
`;
const DefaultButtonFocusedStyle = css `
  ${({ theme: { palette } }) => css `
    outline: 2px solid ${palette.baseColors.lupin};
    outline-offset: 2px;
  `}
`;
const DefaultButtonDisabledStyle = css `
  ${({ theme: { palette } }) => css `
    border-color: ${palette.disabledButtonColor};
    background: ${palette.disabledDefaultButtonColor};
  `}
`;
const DefaultButtonLoadingStyle = css `
  ${({ theme: { palette } }) => css `
    border-color: ${palette.baseColors.lupin};
  `}
`;
const DefaultButtonStandardStyle = css `
  ${({ theme: { palette } }) => css `
    border: 2px solid ${palette.baseColors.lupin};
    transition: border-color 0.1s ease;
  `}
`;
const DefaultButtonDisabledContentStyle = css `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.moeraki};
    fill: ${palette.baseColors.moeraki};
  `}
`;
const PrimaryButtonHoverStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.sparkPurple};
    border-color: ${palette.baseColors.sparkPurple};
  `}
`;
const PrimaryButtonActiveStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.poroporo};
    border-color: ${palette.baseColors.poroporo};
  `}
`;
const PrimaryButtonFocusedStyle = css `
  ${({ theme: { palette } }) => css `
    outline: 2px solid ${palette.baseColors.lupin};
    outline-offset: 2px;
  `}
`;
const PrimaryButtonDisabledStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.disabledButtonColor};
    border-color: ${palette.disabledButtonColor};
  `}
`;
const PrimaryButtonLoadingStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.lupin};
    border-color: ${palette.baseColors.lupin};
  `}
`;
const PrimaryButtonStandardStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.lupin};
    border: 2px solid ${palette.baseColors.lupin};
  `}
`;
const DestructiveButtonHoverStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.karaka};
    border-color: ${palette.baseColors.karaka};
  `}
`;
const DestructiveButtonActiveStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.darkOrange};
    border-color: ${palette.baseColors.darkOrange};
  `}
`;
const DestructiveButtonFocusedStyle = css `
  ${({ theme: { palette } }) => css `
    outline: 2px solid ${palette.baseColors.marangai};
    outline-offset: 2px;
  `}
`;
const DestructiveButtonDisabledStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.disabledButtonColor};
    border-color: ${palette.disabledButtonColor};
  `}
`;
const DestructiveButtonLoadingStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.marangai};
    border-color: ${palette.baseColors.marangai};
  `}
`;
const DestructiveButtonStandardStyle = css `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.marangai};
    border: 2px solid ${palette.baseColors.marangai};
  `}
`;

var ButtonStyles = /*#__PURE__*/Object.freeze({
    __proto__: null,
    DefaultButtonHoverStyle: DefaultButtonHoverStyle,
    DefaultButtonActiveStyle: DefaultButtonActiveStyle,
    DefaultButtonFocusedStyle: DefaultButtonFocusedStyle,
    DefaultButtonDisabledStyle: DefaultButtonDisabledStyle,
    DefaultButtonLoadingStyle: DefaultButtonLoadingStyle,
    DefaultButtonStandardStyle: DefaultButtonStandardStyle,
    DefaultButtonDisabledContentStyle: DefaultButtonDisabledContentStyle,
    PrimaryButtonHoverStyle: PrimaryButtonHoverStyle,
    PrimaryButtonActiveStyle: PrimaryButtonActiveStyle,
    PrimaryButtonFocusedStyle: PrimaryButtonFocusedStyle,
    PrimaryButtonDisabledStyle: PrimaryButtonDisabledStyle,
    PrimaryButtonLoadingStyle: PrimaryButtonLoadingStyle,
    PrimaryButtonStandardStyle: PrimaryButtonStandardStyle,
    DestructiveButtonHoverStyle: DestructiveButtonHoverStyle,
    DestructiveButtonActiveStyle: DestructiveButtonActiveStyle,
    DestructiveButtonFocusedStyle: DestructiveButtonFocusedStyle,
    DestructiveButtonDisabledStyle: DestructiveButtonDisabledStyle,
    DestructiveButtonLoadingStyle: DestructiveButtonLoadingStyle,
    DestructiveButtonStandardStyle: DestructiveButtonStandardStyle
});

const withForcedHover = `&:hover, .spark-forced-hover &`;
const withForcedActive = `&:active, .spark-forced-active &`;
const withForcedFocus = `&:focus-visible, .spark-forced-focus &`;

const BaseStyle$4 = styled.button `
  ${({ theme: { palette, spacing, media }, disabled, fullWidth, isLoading, mb, }) => css `
    text-decoration: none;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    ${bodySDemiStyle};
    height: 48px;
    padding: ${spacing.s1_5} ${spacing.s4};
    box-sizing: border-box;
    background-color: ${palette.baseColors.wairua};
    border-radius: 6px;
    display: inline-flex;
    ${mb &&
    css `
      margin-bottom: ${getResponsiveSpacing(mb)};
    `}
    /** needed for the :after effects for focused state styles */
    position: relative;
    width: 100%;
    transition:
      border-color 0.1s ease,
      background-color 0.1s ease;

    ${media.up('slim')} {
      width: ${fullWidth ? '100%' : 'auto'};
    }

    cursor: pointer;
    ${isLoading && 'cursor: wait;'}
    ${disabled && !isLoading && 'cursor: not-allowed;'}
  `}
`;
const Default = styled(BaseStyle$4) `
  ${({ disabled, isLoading, theme: { palette } }) => css `
    ${DefaultButtonStandardStyle}

    &:hover {
      ${DefaultButtonHoverStyle};
      ${disabled && DefaultButtonDisabledStyle}
    }
    &:active {
      ${DefaultButtonActiveStyle}
      ${disabled && DefaultButtonDisabledStyle}
    }
    &:focus-visible {
      ${DefaultButtonFocusedStyle};
    }

    ${isLoading && DefaultButtonLoadingStyle}

    ${disabled && !isLoading && DefaultButtonDisabledStyle}

    & > * {
      color: ${palette.baseColors.lupin};
      fill: ${palette.baseColors.lupin};
      ${disabled &&
    !isLoading &&
    DefaultButtonDisabledContentStyle}

      &:hover {
        color: ${palette.baseColors.sparkPurple};
        fill: ${palette.baseColors.sparkPurple};
        ${disabled &&
    !isLoading &&
    DefaultButtonDisabledContentStyle}
      }

      &:active {
        color: ${palette.baseColors.poroporo};
        fill: ${palette.baseColors.sparkPurple};
        ${disabled &&
    !isLoading &&
    DefaultButtonDisabledContentStyle}
      }
    }
  `}
`;
const Primary = styled(BaseStyle$4) `
  ${({ disabled, isLoading, theme: { palette } }) => css `
    ${PrimaryButtonStandardStyle}

    &:hover {
      ${PrimaryButtonHoverStyle};
      ${disabled && !isLoading && PrimaryButtonDisabledStyle}
    }

    &:active {
      ${PrimaryButtonActiveStyle};
      ${disabled && !isLoading && PrimaryButtonDisabledStyle}
    }
    &:focus-visible {
      ${PrimaryButtonFocusedStyle};
    }

    ${isLoading && PrimaryButtonLoadingStyle}

    ${disabled && !isLoading && PrimaryButtonDisabledStyle}

    & > * {
      color: ${palette.baseColors.wairua};
      fill: ${palette.baseColors.wairua};

      color: ${disabled && palette.primaryButtonDisabledTextColor};
      fill: ${disabled && palette.primaryButtonDisabledTextColor};
    }
     {
    }
  `}
`;
const Destructive = styled(BaseStyle$4) `
  ${({ disabled, isLoading, theme: { palette } }) => css `
    ${DestructiveButtonStandardStyle}

    &:hover {
      ${DestructiveButtonHoverStyle};
      ${disabled && !isLoading && DestructiveButtonDisabledStyle}
    }

    &:active {
      ${DestructiveButtonActiveStyle};
      ${disabled && !isLoading && DestructiveButtonDisabledStyle}
    }

    &:focus-visible {
      ${DestructiveButtonFocusedStyle}
    }

    ${isLoading && DestructiveButtonLoadingStyle}

    ${disabled && !isLoading && DestructiveButtonDisabledStyle}

    & > * {
      color: ${palette.baseColors.wairua};
      fill: ${palette.baseColors.wairua};
    }
  `}
`;
const TextButton = styled.button `
  ${({ theme: { palette, borderRadius }, disabled, textStyle, isDarkMode, }) => css `
    transition: background-color 0.1s ease;
    ${bodySDemiStyle}
    ${textStyle === 'bodyMDemi' && bodyMDemiStyle};
    ${textStyle === 'bodySMedium' && bodySMediumStyle};
    ${textStyle === 'footNoteDemi' && footNoteDemiStyle};
    text-decoration: none;
    white-space: nowrap;
    /** Needed to stop this item flexing to full width inside flex box */
    align-self: flex-start;
    min-width: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0);
    padding: 0;
    border: none;
    ${withForcedHover} {
      cursor: pointer;
    }

    & > * {
      color: ${palette.interactiveMain};
      fill: ${palette.interactiveMain};
      ${disabled && DefaultButtonDisabledContentStyle}

      ${withForcedHover} {
        color: ${palette.baseColors.sparkPurple};
        fill: ${palette.baseColors.sparkPurple};
        ${disabled && DefaultButtonDisabledContentStyle}
        color: ${isDarkMode && palette.baseColors.wanaka};
        fill: ${isDarkMode && palette.baseColors.wanaka};
      }

      ${withForcedActive} {
        color: ${palette.baseColors.poroporo};
        fill: ${palette.baseColors.sparkPurple};
        ${disabled && DefaultButtonDisabledContentStyle}
        color: ${isDarkMode && palette.baseColors.pukaki};
        fill: ${isDarkMode && palette.baseColors.pukaki};
      }
    }

    ${withForcedFocus} {
      outline-width: 0px;
      border-radius: ${borderRadius.rHalf};
      border: 2px solid
        ${disabled ? palette.baseColors.moeraki : palette.interactiveMain};
      margin: -2px;
      /** alternative to box-sizing: border-box; as this has variable width */
      padding: 0 6px;
    }

    ${disabled && DefaultButtonDisabledContentStyle}
  `}
`;
const HideChildren = styled.div `
  ${({ theme: { media }, isLoading, hasSideContent }) => css `
    display: flex;
    width: 100%;
    justify-content: ${hasSideContent ? 'space-between' : 'center'};

    ${isLoading &&
    css `
      visibility: hidden;
    `}

    ${media.up('slim')} {
      width: unset;
    }
  `}
`;
const Content$2 = styled.span `
  ${({ theme: { media, spacing }, isLeft }) => css `
    display: flex;
    align-items: center;

    ${media.up('slim')} {
      ${isLeft ? `margin-right: ${spacing.s1}` : `margin-left: ${spacing.s1}`}
    }
  `}
`;
const ButtonVariantMap = {
    default: Default,
    primary: Primary,
    destructive: Destructive,
    textbutton: TextButton,
};
const Button$2 = React__default.forwardRef((_a, ref) => {
    var { variant, onClick, href, target, disabled = false, isLoading = false, children, leftContent, rightContent, component, className, type, mb, textStyle, isDarkMode, fullWidth, tabIndex } = _a, elementProps = __rest(_a, ["variant", "onClick", "href", "target", "disabled", "isLoading", "children", "leftContent", "rightContent", "component", "className", "type", "mb", "textStyle", "isDarkMode", "fullWidth", "tabIndex"]);
    const { palette } = useTheme();
    const StyledButton = ButtonVariantMap[variant] || ButtonVariantMap.default;
    return (React__default.createElement(StyledButton, Object.assign({ variant: variant, onClick: onClick, href: href, target: target, textStyle: textStyle || 'bodySDemi', as: component || 'button', disabled: disabled || isLoading, isLoading: isLoading || undefined, className: className, ref: ref, type: type, mb: mb, isDarkMode: isDarkMode || false, fullWidth: fullWidth, rel: target === '_blank' ? 'noopener' : '', tabIndex: tabIndex }, elementProps),
        isLoading && (React__default.createElement(LoadingSpinner, { fill: variant === 'default' || variant === 'textbutton'
                ? palette.baseColors.lupin
                : palette.baseColors.wairua })),
        React__default.createElement(HideChildren, { isLoading: isLoading || false, hasSideContent: !!leftContent || !!rightContent },
            leftContent ? React__default.createElement(Content$2, { isLeft: true }, leftContent) : null,
            children,
            rightContent ? React__default.createElement(Content$2, null, rightContent) : null)));
});

const BaseLinkStyle = css `
  ${bodySDemiStyle};
  text-decoration: underline;
  &:visited {
    text-decoration: underline;
  }
  &:hover &:active {
    text-decoration: none;
  }
`;
const LinkStyle = css `
  ${({ theme: { palette } }) => css `
    ${BaseLinkStyle}
    color: ${palette.linkMain};

    &:hover,
    &:active {
      color: ${palette.baseColors.poroporo};
    }
  `}
`;
const InverseModeLinkStyle = css `
  ${({ theme: { palette } }) => css `
    ${BaseLinkStyle}
    color: ${palette.interactiveMainInverse};
    &:visited {
      color: ${palette.interactiveMain};
      background-color: transparent;
    }
    &:hover {
      color: ${palette.grayScale8};
      background-color: ${palette.interactiveMainInverse};
    }
    &:active {
      color: ${palette.grayScale8};
      background-color: ${palette.interactiveTertiary};
    }
  `}
`;
const InverseAlternateLinkStyle = css `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.wairua};
    background-color: transparent;
    &:visited {
      background-color: transparent;
    }
    &:hover {
      background-color: transparent;
    }
    &:active {
      background-color: transparent;
    }
  `}
`;
const StyledLink$2 = styled.a `
  ${({ isInverse, linkVariant }) => {
    if (linkVariant === 'standard') {
        if (isInverse) {
            return InverseModeLinkStyle;
        }
        return LinkStyle;
    }
    return InverseAlternateLinkStyle;
}}
`;
const Link$1 = React__default.forwardRef((_a, ref) => {
    var { children, className, isInverse = false, linkVariant = 'standard' } = _a, anchorProps = __rest(_a, ["children", "className", "isInverse", "linkVariant"]);
    return (React__default.createElement(StyledLink$2, Object.assign({ ref: ref, className: className, isInverse: isInverse, linkVariant: linkVariant }, anchorProps), children));
});

const BaseIconButtonElement = styled.button `
  ${({ theme: { borderRadius, palette }, $size }) => css `
    padding: 0;
    align-items: center;
    border: none;
    border-radius: ${borderRadius.round};
    cursor: pointer;
    display: flex;
    height: ${$size === 'small' ? '32px' : '48px'};
    justify-content: center;
    position: relative;
    transform-origin: center center;
    background-position: center;
    background: ${palette.baseColors.wairua};
    transition:
      background 0.2s,
      transform 0.2s;

    width: ${$size === 'small' ? '32px' : '48px'};

    &:hover {
      background: ${palette.baseColors.pukaki}
        radial-gradient(circle, transparent 1%, ${palette.baseColors.pukaki} 1%)
        center/15000%;
      transition:
        background 0.1s,
        transform 0.1s;
    }

    &:active {
      background-color: ${palette.baseColors.wanaka};
      background-size: 100%;
      transition: background 0s;
      transform: scale(0.96);
      transition:
        background 0.2s,
        transform 0.2s;

      svg {
        transform: scale(1.04);
      }
    }

    &:focus-within {
      outline: none;
    }

    &:focus-within:before {
      border: ${palette.baseColors.lupin} solid 2px;
      border-radius: inherit;
      content: '';
      height: calc(100% + 10px);
      position: absolute;
      width: calc(100% + 10px);
    }

    :disabled {
      background: ${palette.baseColors.wairua};
      border-color: ${palette.baseColors.alto};
      cursor: not-allowed;
      transform: none;
    }
  `}
`;
const PrimaryIconButtonElement = styled(BaseIconButtonElement) `
  ${({ theme: { media, palette } }) => css `
    ${media.up('slim')} {
      border: ${palette.baseColors.lupin} solid 2px;

      :disabled {
        background: ${palette.baseColors.wairua};
      }
    }
  `}
`;
const SecondaryIconButtonElement = styled(BaseIconButtonElement) `
  ${({ theme: { palette } }) => css `
    border: ${palette.baseColors.moeraki} solid 2px;

    &:hover,
    &:active,
    &:focus-within {
      border-color: ${palette.baseColors.lupin};
    }

    :disabled {
      background: none;
      border-color: ${palette.baseColors.alto};
    }
  `}
`;
const DefaultIconButtonElement = styled(BaseIconButtonElement) `
  ${({ theme: { palette } }) => css `
    &:hover,
    &:active,
    &:focus-within {
      border-color: ${palette.baseColors.lupin};
    }

    :disabled {
      background: none;
      border-color: ${palette.baseColors.alto};
    }
  `}
`;
const IconButtonVariantMap = {
    primary: PrimaryIconButtonElement,
    secondary: SecondaryIconButtonElement,
    default: DefaultIconButtonElement,
};
const IconButton$5 = React__default.forwardRef((_a, ref) => {
    var { disabled, icon, onClick = () => { }, title, variant = 'default', size = 'standard', type = 'button', href, component = 'button', iconFillColor } = _a, buttonProps = __rest(_a, ["disabled", "icon", "onClick", "title", "variant", "size", "type", "href", "component", "iconFillColor"]);
    const theme = useTheme();
    const fillColor = disabled
        ? theme.palette.baseColors.alto
        : iconFillColor || theme.palette.baseColors.lupin;
    const ButtonElement = IconButtonVariantMap[variant] || IconButtonVariantMap.primary;
    return (React__default.createElement(ButtonElement, Object.assign({}, buttonProps, { disabled: disabled, onClick: onClick, title: title, "$size": size, type: type, ref: ref, as: component, href: href }),
        React__default.createElement(Icon, { fill: fillColor, name: icon })));
});

const variants$3 = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 20 },
};
const FloatUp = ({ children, delay = 0, show = true, }) => {
    const transition = {
        duration: 0.3,
        delay,
        bounce: 0,
    };
    return (React__default.createElement(motion.div, { variants: variants$3, initial: "hidden", animate: show ? 'visible' : 'hidden', transition: transition }, children));
};

/**
 * Coverting the css file from 'slick-carousel/slick/slick.css' and 'slick-carousel/slick/slick-theme.css';
 * slick-carousel version 1.8.1
 */
const slickCarouselStyles = css `
  /* slick-carousel/slick/slick.css */

  /* Slider */
  .slick-slider {
    position: relative;
    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }
  .slick-list {
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }
  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;
    content: '';
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;
    height: 100%;
    min-height: 1px;
  }
  [dir='rtl'] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;
    height: auto;
    border: 1px solid transparent;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }

  /* Slider */
  .slick-loading .slick-list {
    background: #fff url('./ajax-loader.gif') center center no-repeat;
  }

  /* slick-carousel/slick/slick-theme.css */

  /* Icons */
  @font-face {
    font-family: 'slick';
    font-weight: normal;
    font-style: normal;
    src: url('./fonts/slick.eot');
    src:
      url('./fonts/slick.eot?#iefix') format('embedded-opentype'),
      url('./fonts/slick.woff') format('woff'),
      url('./fonts/slick.ttf') format('truetype'),
      url('./fonts/slick.svg#slick') format('svg');
  }
  /* Arrows */
  .slick-prev,
  .slick-next {
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    width: 20px;
    height: 20px;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: transparent;
    outline: none;
    background: transparent;
  }
  .slick-prev:hover:before,
  .slick-prev:focus:before,
  .slick-next:hover:before,
  .slick-next:focus:before {
    opacity: 1;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.25;
  }
  .slick-prev:before,
  .slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-prev {
    left: -25px;
  }
  .slick-next {
    right: -25px;
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }
  .slick-dots {
    position: absolute;
    bottom: -25px;
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    text-align: center;
  }
  .slick-dots li {
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    margin: 0 5px;
    padding: 0;
    cursor: pointer;
  }
  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 6px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: black;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: black;
  }
`;

const CarouselWrapper = styled.div `
  ${slickCarouselStyles}
`;
const ArrowWrapper = styled.div `
  ${({ theme: { zIndex, media } }) => css `
    display: none;

    ${media.up('slim')} {
      display: block;
      position: absolute;
      top: calc((100% - 48px) / 2);
      z-index: ${zIndex.dropdown};
    }
  `}
`;
const PreviousArrowWrapper = styled(ArrowWrapper) `
  ${({ theme: { media }, controlButtonOffset }) => css `
    ${media.up('slim')} {
      left: ${controlButtonOffset !== null && controlButtonOffset !== void 0 ? controlButtonOffset : 32}px;
    }

    ${media.up('big')} {
      left: ${controlButtonOffset !== null && controlButtonOffset !== void 0 ? controlButtonOffset : 120}px;
    }
  `}
`;
const NextArrowWrapper = styled(ArrowWrapper) `
  ${({ theme: { media }, controlButtonOffset }) => css `
    ${media.up('slim')} {
      right: ${controlButtonOffset !== null && controlButtonOffset !== void 0 ? controlButtonOffset : 32}px;
    }
    ${media.up('big')} {
      right: ${controlButtonOffset !== null && controlButtonOffset !== void 0 ? controlButtonOffset : 120}px;
    }
  `}
`;
const CarouselPrevButton = ({ onClick, controlButtonOffset, onClickPrev, title = 'prev', }) => {
    return (React__default.createElement(PreviousArrowWrapper, { onClick: (e) => {
            if (onClick)
                onClick(e);
            if (onClickPrev)
                onClickPrev(e);
        }, controlButtonOffset: controlButtonOffset },
        React__default.createElement(IconButton$5, { title: title, icon: "chevron_left_small", variant: "secondary" })));
};
const CarouselNextButton = ({ onClick, controlButtonOffset, onClickNext, title = 'next', }) => {
    return (React__default.createElement(NextArrowWrapper, { onClick: (e) => {
            if (onClick)
                onClick(e);
            if (onClickNext)
                onClickNext(e);
        }, controlButtonOffset: controlButtonOffset },
        React__default.createElement(IconButton$5, { title: title, icon: "chevron_right_small", variant: "secondary" })));
};
const Carousel = React__default.forwardRef(({ className, children, settings, showPrevButton = true, showNextButton = true, controlButtonOffset, dynamicTargetValue = '', }, ref) => {
    const sliderSetting = Object.assign({ dots: false, infinite: false, swipeToSlide: true, slidesToScroll: 1, slidesToShow: 1, prevArrow: showPrevButton ? (React__default.createElement(CarouselPrevButton, { controlButtonOffset: controlButtonOffset })) : (React__default.createElement(React__default.Fragment, null)), nextArrow: showNextButton ? (React__default.createElement(CarouselNextButton, { controlButtonOffset: controlButtonOffset })) : (React__default.createElement(React__default.Fragment, null)) }, settings);
    const componentName = 'Carousel';
    return (React__default.createElement(CarouselWrapper, { className: className, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(Slider$1, Object.assign({ ref: ref }, sliderSetting), children)));
});

const IconContainer$5 = styled.div `
  ${({ theme: { borderRadius, palette, media } }) => css `
    width: 36px;
    height: 36px;
    position: absolute;
    background: ${palette.baseColors.lupin};
    border-radius: ${borderRadius.round};
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    ${media.up('slim')} {
      width: 48px;
      height: 48px;
    }
  `}
`;
const DotSizeByAvatarSizeMap = {
    small: {
        lil: '16px',
        slim: '16px',
        big: '16px',
    },
    medium: {
        lil: '28px',
        slim: '28px',
        big: '28px',
    },
    large: {
        lil: '38px',
        slim: '46px',
        big: '56px',
    },
};
const DotBorderWidthByAvatarSizeMap = {
    small: {
        lil: '2px',
        slim: '2px',
        big: '2px',
    },
    medium: {
        lil: '3px',
        slim: '3px',
        big: '3px',
    },
    large: {
        lil: '4px',
        slim: '5px',
        big: '6px',
    },
};
const NotificationDot$2 = styled.div `
  ${({ theme: { borderRadius, palette, media }, avatarSize, color }) => css `
    width: ${DotSizeByAvatarSizeMap[avatarSize].lil};
    height: ${DotSizeByAvatarSizeMap[avatarSize].lil};
    position: absolute;
    background: ${color || palette.baseColors.kowhai};
    border: solid ${palette.baseColors.wairua};
    border-radius: ${borderRadius.round};
    border-width: ${DotBorderWidthByAvatarSizeMap[avatarSize].lil};
    right: 0;
    top: 0;
    ${media.up('slim')} {
      right: 0;
      top: 0;
      width: ${DotSizeByAvatarSizeMap[avatarSize].slim};
      height: ${DotSizeByAvatarSizeMap[avatarSize].slim};
      border-width: ${DotBorderWidthByAvatarSizeMap[avatarSize].slim};
    }
    ${media.up('big')} {
      right: 0;
      top: 0;
      width: ${DotSizeByAvatarSizeMap[avatarSize].big};
      height: ${DotSizeByAvatarSizeMap[avatarSize].big};
      border-width: ${DotBorderWidthByAvatarSizeMap[avatarSize].big};
    }
  `}
`;
const Container$g = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    margin: ${spacing.s1};
    cursor: pointer;
  `}
`;
const SmallContainer = styled(Container$g) `
  width: 32px;
  height: 32px;
`;
const MediumContainer = styled(Container$g) `
  width: 80px;
  height: 80px;
`;
const LargeContainer = styled(Container$g) `
  ${({ theme: { media } }) => css `
    width: 110px;
    height: 110px;
    ${media.up('slim')} {
      width: 130px;
      height: 130px;
    }
    ${media.up('big')} {
      width: 160px;
      height: 160px;
    }
  `}
`;
const AvatarSizeMap = {
    small: SmallContainer,
    medium: MediumContainer,
    large: LargeContainer,
};
const common = css `
  ${({ theme: { borderRadius } }) => css `
    border-radius: ${borderRadius.round};
    width: 100%;
    height: 100%;
  `}
`;
const AvatarWithImage = styled.img `
  ${common}
`;
const AvatarWithInitials = styled.div `
  ${common}

  ${({ theme: { palette }, color }) => css `
    justify-content: center;
    align-items: center;
    display: flex;
    background: ${color || palette.baseColors.mawhero};
  `}
`;
const AvatarWithIcon = styled.div `
  ${common}
  ${({ theme: { palette } }) => css `
    justify-content: center;
    align-items: center;
    display: flex;
    border: solid ${palette.baseColors.lupin};
  `}
`;
const Initials = styled(Text) `
  color: ${({ theme: { palette } }) => palette.baseColors.wairua};
`;
const InitialsVariantBySizeMap = {
    small: 'footnoteDemi',
    medium: 'subheadingM',
    large: 'headingM',
};
function getFirstChar(name) {
    return name.length > 0 ? name.charAt(0) : '';
}
const Avatar = ({ src, firstName = '', lastName = '', color, className, onClick, showIcon, showAvatarWithPlusIcon, size, showNotificationDot, notificationDotColor, }) => {
    const theme = useTheme();
    const alt = `${firstName} ${lastName}`.trim();
    const initials = `${getFirstChar(firstName)}${getFirstChar(lastName)}`.trim();
    const iconColor = theme.palette.baseColors.wairua;
    let avatar = null;
    if (src) {
        avatar = React__default.createElement(AvatarWithImage, { src: src, alt: alt, title: alt, size: size });
    }
    else if (showAvatarWithPlusIcon) {
        avatar = (React__default.createElement(AvatarWithIcon, { size: size },
            React__default.createElement(Icon, { name: "plus_large", fill: theme.palette.baseColors.lupin })));
    }
    else {
        avatar = (React__default.createElement(AvatarWithInitials, { title: alt, color: color, size: size },
            React__default.createElement(Initials, { variant: InitialsVariantBySizeMap[size], component: "span" }, initials)));
    }
    const AvatarContainer = AvatarSizeMap[size];
    return (React__default.createElement(AvatarContainer, { onClick: onClick && onClick, className: className },
        avatar,
        showIcon && (React__default.createElement(IconContainer$5, null,
            React__default.createElement(Icon, { name: "camera_small", fill: iconColor }))),
        showNotificationDot && (React__default.createElement(NotificationDot$2, { "aria-label": "notification dot", role: "status", avatarSize: size, color: notificationDotColor }))));
};

const Box = styled.div `
  ${({ theme: { borderRadius, palette: { baseColors }, }, position, pt, pb, pl, pr, px, py, rad, mb, ml, mr, mx, bg, flexDirection, borderWidth, borderColor, gap, justifyContent, alignItems, flexWrap, flexGrow, }) => css `
    ${position &&
    css `
      position: ${position};
    `}

    ${pt &&
    css `
      padding-top: ${getResponsiveSpacing(pt)};
    `}

    ${pr &&
    css `
      padding-right: ${getResponsiveSpacing(pr)};
    `}

    ${pb &&
    css `
      padding-bottom: ${getResponsiveSpacing(pb)};
    `}

    ${pl &&
    css `
      padding-left: ${getResponsiveSpacing(pl)};
    `}

    ${px &&
    css `
      padding-left: ${getResponsiveSpacing(px)};
      padding-right: ${getResponsiveSpacing(px)};
    `}

    ${py &&
    css `
      padding-top: ${getResponsiveSpacing(py)};
      padding-bottom: ${getResponsiveSpacing(py)};
    `}

    ${rad &&
    css `
      border-radius: ${borderRadius[rad]};
    `}

    ${mb &&
    css `
      margin-bottom: ${getResponsiveSpacing(mb)};
    `}

    ${ml &&
    css `
      margin-left: ${getResponsiveSpacing(ml)};
    `}

    ${mr &&
    css `
      margin-right: ${getResponsiveSpacing(mr)};
    `}

    ${mx &&
    css `
      margin-left: ${getResponsiveSpacing(mx)};
      margin-right: ${getResponsiveSpacing(mx)};
    `}

    ${bg &&
    css `
      background: ${baseColors[bg]};
    `}

    ${flexDirection &&
    css `
      display: flex;
      flex-direction: ${getResponsiveValue(flexDirection)};
    `}

    ${borderWidth !== undefined &&
    css `
      border-width: ${borderWidth};
    `}

    ${borderColor &&
    css `
      border-color: ${borderColor};
    `}

    ${gap &&
    css `
      gap: ${getResponsiveSpacing(gap)};
    `}

    ${justifyContent &&
    css `
      justify-content: ${justifyContent};
    `}

    ${alignItems &&
    css `
      align-items: ${alignItems};
    `}

    ${flexWrap &&
    css `
      flex-wrap: ${flexWrap};
    `}

    ${flexGrow &&
    css `
      flex-grow: ${flexGrow};
    `}
  `}
`;

const getHeight = (orientation, height) => {
    if (height)
        return height;
    if (orientation === 'horizontal')
        return '0px';
    return '100%';
};
const getWidth = (orientation, width) => {
    if (width)
        return width;
    if (orientation === 'horizontal')
        return '100%';
    return '1px';
};
const Divider$1 = styled.hr `
  ${({ theme: { palette, spacing }, color = palette.baseColors.alto, height, width, orientation = 'horizontal', }) => css `
    border: 0;
    border-top: ${orientation === 'horizontal' ? `1px solid ${color}` : '0'};
    background-color: ${orientation === 'horizontal' ? `transparent` : color};
    height: ${getHeight(orientation, height)};
    margin: 0 ${orientation === 'horizontal' ? '0' : spacing.s1_5};
    width: ${getWidth(orientation, width)};
    padding: 0;
  `}
`;

const CardHeaderText = styled.div `
  ${({ theme: { spacing, media } }) => css `
    margin-bottom: ${spacing.s2};

    ${media.up('slim')} {
      margin-bottom: ${spacing.s3};
    }

    ${media.up('big')} {
      margin-bottom: ${spacing.s4};
    }
  `}
`;
const HeaderDivider = styled(Divider$1) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s3};
  `}
`;
const CardHeader = ({ title, subtitle, children }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CardHeaderText, null,
            React__default.createElement(Text, { variant: "subheadingM" }, title),
            subtitle && React__default.createElement(Text, { variant: "bodyMMedium" }, subtitle),
            children),
        React__default.createElement(HeaderDivider, null)));
};

const Card = styled.div `
  ${({ theme: { palette, borderRadius, spacing, media } }) => css `
    padding: ${spacing.s2};
    background: ${palette.baseColors.wairua};

    ${media.up('slim')} {
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r3};
      padding: ${spacing.s4};
    }

    ${media.up('big')} {
      padding: ${spacing.s6};
    }
  `}
`;

const Clickable = styled.button `
  ${({ theme: { borderRadius, palette: { baseColors }, }, disabled, hasRoundedFocus, }) => css `
    padding: 0;
    border: 0;
    background: transparent;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};

    &&:focus-visible {
      outline: 2px solid ${baseColors.lupin};
      border-radius: ${hasRoundedFocus && borderRadius.round};
    }
  `}
`;

const FilterContainer = styled.div `
  align-items: center;
  display: ${(props) => (props.isExpanded ? 'flex' : 'none')};
  transition: width 0.2s ease;
  width: ${(props) => (props.isExpanded ? '100%' : '40px')};
  flex-direction: row;
  border-radius: 40px;
  height: 48px;
  border: 2px solid ${colors.alto};
  box-sizing: border-box;
  background-color: ${colors.wairua};
  padding-right: 20px;

  ${({ theme }) => theme.media.up('big')} {
    height: 40px;
    display: flex;
  }

  svg {
    box-sizing: border-box;
    margin-left: 16px;
    flex: 0 0 auto;
    margin-right: 6px;

    ${({ theme }) => theme.media.up('big')} {
      margin-left: 6px;
    }
  }
`;
const TextInput$2 = styled.input `
  flex: 1 1 auto;
  width: 100%;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${colors.newZealandBlack};
  border: 0px;
  display: ${(props) => (props.isExpanded ? 'auto' : 'none')};

  /* Following fixes are FF specific as inputs have default min width and bg color */
  background-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  min-width: 0;

  &::placeholder {
    color: ${colors.mawheranui};
  }
`;
const Filter = ({ onFilter, isExpanded, placeHolderText, }) => {
    const [filterText, setFilterText] = useState('');
    const filterChange = () => {
        onFilter(filterText);
    };
    const delayedFilterChange = useCallback(debounce(filterChange, 300), [
        filterText,
    ]);
    useEffect(() => {
        if (!isExpanded) {
            setFilterText('');
        }
        delayedFilterChange();
        return delayedFilterChange.cancel;
    }, [filterText, delayedFilterChange, isExpanded]);
    const handleChange = (event) => {
        var _a;
        const text = (_a = event.target.value) !== null && _a !== void 0 ? _a : '';
        setFilterText(text);
    };
    return (React__default.createElement(FilterContainer, { isExpanded: isExpanded !== null && isExpanded !== void 0 ? isExpanded : false },
        React__default.createElement(Icon, { name: "filter_small", fill: colors.lupin }),
        React__default.createElement(TextInput$2, { isExpanded: isExpanded !== null && isExpanded !== void 0 ? isExpanded : false, type: "text", onChange: handleChange, value: filterText, placeholder: placeHolderText })));
};
Filter.defaultProps = {
    isExpanded: true,
    placeHolderText: 'Filter',
};

const zIndex = {
    negative: -1,
    default: 1,
    dropdown: 200,
    sticky: 400,
    popover: 600,
    navigation: 700,
    overlay: 800,
    belowModal: 999,
    modal: 1000,
    aboveModal: 1001,
    snackbar: 1200,
    spinner: 1400,
};

const s0 = '0px';
/**
 * @deprecated please hardcode this value where it is used as 2px
 */
const sQuarter = '2px';
const s0_5 = '4px';
/**
 * @deprecated please use s0_5 instead
 */
const sHalf = '4px';
const s1 = '8px';
const s1_5 = '12px';
/**
 * @deprecated please use s1_5 instead
 */
const s1Half = '12px';
const s2 = '16px';
const s3 = '24px';
const s4 = '32px';
const s5 = '40px';
const s6 = '48px';
const s7 = '56px';
const s8 = '64px';
const s9 = '80px';
const s10 = '160px';
const auto = 'auto';

var spacing = /*#__PURE__*/Object.freeze({
    __proto__: null,
    s0: s0,
    sQuarter: sQuarter,
    s0_5: s0_5,
    sHalf: sHalf,
    s1: s1,
    s1_5: s1_5,
    s1Half: s1Half,
    s2: s2,
    s3: s3,
    s4: s4,
    s5: s5,
    s6: s6,
    s7: s7,
    s8: s8,
    s9: s9,
    s10: s10,
    auto: auto
});

const rQuarter = '2px';
const rHalf = '4px';
// eslint-disable-next-line @typescript-eslint/naming-convention
const r0_75 = '6px';
const r1 = '8px';
const r2 = '16px';
const r3 = '24px';
const r4 = '32px';
const r5 = '40px';
const round = '50%';

var borderRadius = /*#__PURE__*/Object.freeze({
    __proto__: null,
    rQuarter: rQuarter,
    rHalf: rHalf,
    r0_75: r0_75,
    r1: r1,
    r2: r2,
    r3: r3,
    r4: r4,
    r5: r5,
    round: round
});

const cardHover = '-4px -4px 20px rgba(0, 0, 0, 0.08), 4px 4px 20px rgba(0, 0, 0, 0.08)';
const drawer = '0px 4px 10px rgba(0, 0, 0, 0.12)';
const elevation1 = '0px 2px 8px 0px rgba(29, 29, 29, 0.28)';
const elevation2 = '0px 12px 17px rgba(0, 0, 0, 0.1), 0px 7px 8px rgba(0, 0, 0, 0.1)';
const elevation3 = '0px 8px 10px 0px rgba(0,0,0,0.1), 0px 6px 30px 0px rgba(0,0,0,0.1), 0px 16px 24px 0px rgba(0,0,0,0.1)';
const elevation4 = '0px 24px 38px rgba(0, 0, 0, 0.1), 0px 11px 15px rgba(0, 0, 0, 0.1)';
const headerElevation = '0px 4px 4px 0px rgba(0,0,0,0.05), 0px 12px 10px 0px rgba(0,0,0,0.02), 0px 30px 24px 0px rgba(0,0,0,0.02), 0px 100px 80px 0px rgba(0,0,0,0.02)';
const menuDropdown = '0px 4px 15px rgba(0, 0, 0, 0.1), 0px 8px 38px rgba(0, 0, 0, 0.12)';
const topShadow = '0px -4px 4px 0px rgba(0,0,0,0.02), 0px -12px 10px 0px rgba(0, 0, 0, 0.02), 0px -30px 24px 0px rgba(0, 0, 0, 0.01), 0px -40px 80px 0px rgba(0, 0, 0, 0.02)';

var elevation = /*#__PURE__*/Object.freeze({
    __proto__: null,
    cardHover: cardHover,
    drawer: drawer,
    elevation1: elevation1,
    elevation2: elevation2,
    elevation3: elevation3,
    elevation4: elevation4,
    headerElevation: headerElevation,
    menuDropdown: menuDropdown,
    topShadow: topShadow
});

const breakpoints = {
    lil: 599,
    slim: 600,
    big: 1200,
    huge: 1500,
};

const StyledImg$1 = styled.img `
  ${({ theme: { palette }, imagePath, disabled, iconColor, hasFullColor }) => {
    if (disabled) {
        return css `
        mask: url(${imagePath}) no-repeat center / contain;
        -webkit-mask: url(${imagePath}) no-repeat center / contain;
        background-color: ${palette.baseColors.wairua};
      `;
    }
    if (iconColor && !hasFullColor) {
        return css `
        mask: url(${imagePath}) no-repeat center / contain;
        -webkit-mask: url(${imagePath}) no-repeat center / contain;
        background-color: ${iconColor
            ? colors[iconColor]
            : palette.baseColors.newZealandBlack};
      `;
    }
    return css `
      mask: url(${imagePath}) no-repeat center / contain;
      -webkit-mask: url(${imagePath}) no-repeat center / contain;
    `;
}}
`;
const IconFromDam = ({ imagePath, disabled, hasFullColor, iconColor, height = 48, width = 48, }) => (React__default.createElement(StyledImg$1, { imagePath: imagePath, height: height, width: width, iconColor: iconColor, hasFullColor: hasFullColor, disabled: disabled, src: hasFullColor ? imagePath : undefined }));

const basePath = 'https://www.spark.co.nz/content/dam';
const baseIconPath = `${basePath}/spark/images/icons/svg`;
const DAM_SVG_ICON_CHEVRON_RIGHT = `${baseIconPath}/chevron_right_small.svg`;
const DAM_SVG_ICON_CHEVRON_LEFT = `${baseIconPath}/chevron_left_small.svg`;
const DAM_SVG_ICON_CHEVRON_DOWN = `${baseIconPath}/chevron_down_small.svg`;
const DAM_SVG_ICON_EXTERNAL_LINK = `${baseIconPath}/external_link_small.svg`;
const baseLogoPath = `${basePath}/sparkdigital/images/logo`;
const DAM_SPARK_PURPLE_LOGO = `${baseLogoPath}/purple.svg`;

const StyledImage$1 = styled.img `
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
const Image = ({ width = 'auto', height = 'auto', src, onClick, alt, className, dynamicTargetValue = '', }) => {
    const componentName = 'Image';
    return (React__default.createElement(StyledImage$1, { className: className, width: width, height: height, src: src, onClick: onClick, alt: alt, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" }));
};

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function SvgHorizontalLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    viewBox: "0 0 224 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.725 37.426c4.4 1.3 7.3 3.4 7.3 8 0 5.5-5.1 9-10.4 9-4.6 0-9-1.9-11.6-5.3l3.3-3.9c2.5 3 5.3 4.3 8.4 4.3 2.6 0 4.8-1.2 4.8-3.6 0-1.9-1-2.8-3.4-3.5l-4.9-1.5c-4.1-1.2-6.8-3.3-6.8-7.7 0-4.7 4.2-8.6 10-8.6 4.3 0 7.8 1.6 10.2 4.1l-3.1 4.1c-2-2.1-4.3-3.3-7.1-3.3-2.6 0-4.4 1.4-4.4 3.3 0 1.7 1.1 2.5 3.1 3.1l4.6 1.5zM130.425 37.726c1-1.6 3.1-3 5.8-3 5.1 0 9.1 4.1 9.1 9.9 0 5.8-4 9.9-9.1 9.9-2.7 0-4.8-1.5-5.7-3h-.1v10h-5.3v-26.4h5.3v2.6zm4.8 12.1c3 0 4.9-2.5 4.9-5.2 0-2.8-2-5.2-4.9-5.2-3 0-4.9 2.5-4.9 5.2s1.9 5.2 4.9 5.2zM155.125 42.726l4.4-.4c0-1.9-1.3-3.1-4-3.1-2 0-4.1.9-5.5 1.9l-1.8-3.9c1.7-1.2 4.9-2.6 8.2-2.6 5.3 0 8.2 3.1 8.2 7.9v11.5h-5.1v-2.4h-.1c-.6 1.2-2.8 2.9-5.5 2.9-3.7 0-6.6-2.1-6.6-5.8.1-3.8 3.9-5.7 7.8-6zm4.5 3.1l-3.5.3c-2.3.2-3.7.8-3.7 2.4 0 1.3 1.3 2.1 2.9 2.1 2.4 0 4.4-1.5 4.4-4.2v-.6h-.1zM173.925 44.426v9.6h-5.3v-18.9h5.3v3.2h.1c.7-2 2.7-3.5 4.8-3.5.4 0 .9 0 1.3.1v5.4c-.6-.2-1.3-.4-2-.4-2.5.1-4.2 1.8-4.2 4.5zM188.525 44.326v9.7h-5.2v-28.7h5.2v18.1l7.4-8.3h6.1l-7.9 8.7 8.1 10.2h-6.3l-7.4-9.7zM221.725 43.726v-1.7h-4.9l4.6-4.9v-1.9h-7v1.7h4.4l-4.6 5v1.8h7.5zm-14.5 0v-4.7c0-.3 0-.6.1-.8.1-.3.2-.5.4-.7.2-.2.4-.4.6-.5.2-.1.5-.2.9-.2.3 0 .6.1.8.2.2.1.4.3.5.5.1.2.2.5.2.7 0 .3.1.5.1.8v4.8h2.1v-5.4c0-.4-.1-.9-.2-1.3s-.3-.8-.6-1.1c-.3-.3-.6-.6-1-.8-.4-.2-.9-.3-1.4-.3-.6 0-1.2.2-1.7.5s-.8.7-1 1.1v-1.4h-2v8.6h2.2zM63.81 41.967s.01-.01 0 0c.019-.01.01-.01 0 0zM3.63 41.55c-.039.066.009.066.047.085.038.019.104.029.123.038 1.253.36 2.58.74 3.814 1.091.038.01.076.038.124.028-1.367-.417-2.742-.815-4.109-1.242zm79.402 10.645c-3.634-.607-12.884-.598-18.558-.532-.313-.142-.617-.294-.92-.436-2.42-1.129-4.858-2.258-7.258-3.396.408-.37.806-.75 1.233-1.11.01 0 .01.009.019.009 3.577 1.328 9.165 3.254 12.827 4.497h.02c.255.057.806-.398 1.024-1.12.218-.72.123-1.423-.114-1.517 0 0-8.245-2.885-11.376-3.995 1.66-1.48 3.387-2.865 5.076-4.298 1.69-1.432 3.369-2.874 5.086-4.288.854-.702 1.708-1.414 2.58-2.106 1.737-1.395 3.473-2.78 5.304-4.061.455-.323.92-.645 1.404-.94.304-.19.617-.388.92-.54.2-.105.418-.171.617-.275.01 0 .01-.01.02-.01 0-.038-.048-.01-.03-.047.03-.02.067-.038.096-.067.019-.123.085-.341-.01-.436-.123-.029-.209.066-.313.076-.019-.029.01-.038.019-.057-.455.247-.92.484-1.385.702-.076.038-.2.076-.266.114-.028.019-.057.028-.095.047-.654.332-1.319.655-1.983.987-.616.313-1.233.617-1.84.94-.608.331-1.224.625-1.831.948-2.43 1.29-4.858 2.562-7.24 3.909.266-.209.522-.436.826-.607.303-.171.617-.332.92-.503 1.84-1.025 3.653-2.03 5.541-3.036 1.233-.655 2.476-1.3 3.748-1.964 1.072-.55 2.2-1.139 3.349-1.651.152-.066.36-.19.56-.161.019 0 .066.019.104.038.095.028.142.056.18.113.067.105.133.427.057.608-.038.076-.076.076-.133.113-.028.02-.038.038-.066.058-.047.028-.105.056-.152.094-.323.18-.617.351-.91.541-.589.38-1.177.778-1.746 1.167-.19.133-.38.275-.57.408a72.356 72.356 0 00-3.31 2.514c-.741.589-1.49 1.196-2.193 1.813-.151.132-.313.256-.465.389-1.584 1.337-3.15 2.694-4.705 4.032-1.044.901-2.078 1.812-3.131 2.704-.01.019-.01.019.01.01a396.136 396.136 0 017.59-6.253 459.283 459.283 0 00-6.14 5.247c-.009.028.03-.01.03-.01.246-.2.502-.427.768-.588-.778.806-1.642 1.556-2.486 2.315a82.585 82.585 0 00-1.879 1.727c-.17.17-.38.341-.53.512-.02.019-.067.076-.039.085.237-.17.446-.37.674-.56 1.1-.958 2.2-1.907 3.311-2.855l2.666-2.268c.446-.38.901-.75 1.347-1.12.01-.009.02-.028.038-.037.048-.038.086-.076.124-.105.844-.711 1.688-1.404 2.533-2.096 1.338-1.11 2.742-2.211 4.117-3.283.703-.541 1.405-1.063 2.116-1.585.237-.17.475-.341.721-.512.75-.522 1.47-.968 2.287-1.414.284-.151.56-.284.711-.521.162-.247.276-.617.219-.978-.057-.332-.2-.588-.484-.74.142.114.256.266.332.456.076.17.142.417.104.683-.01.095-.057.199-.095.303-.085.2-.17.342-.332.465-.076.057-.152.133-.237.171-.17.095-.351.18-.531.275-.532.266-1.034.588-1.518.883-.342.208-.655.436-.996.616a16.107 16.107 0 012.324-1.632c.2-.113.417-.237.626-.36.209-.123.38-.294.465-.512a1.057 1.057 0 00-.028-.816.999.999 0 00-.503-.484c.332-.162.654-.342.968-.532.227-.142.464-.284.635-.465.067-.066.142-.123.19-.19.104-.132.17-.284.247-.445.076-.152.132-.351.142-.541.019-.209-.047-.389-.114-.57a1.355 1.355 0 00-.247-.445 1.481 1.481 0 00-.844-.531 1.649 1.649 0 00-.617-.057c-1.83.227-3.358.787-4.867 1.318.294-.066.693-.246 1.006-.313-1.025.37-2.06.797-3.027 1.215-.588.246-1.1.616-1.622.93.474-.399.93-.797 1.366-1.234.427-.436.816-.92 1.186-1.414.17-.227.36-.474.54-.75.181-.265.342-.55.409-.891.038-.18.057-.436.019-.588-.038-.152-.152-.285-.256-.399-.095-.104-.228-.199-.361-.294-.133-.085-.285-.19-.455-.199-.086 0-.18.028-.276.047-.483.076-.806.294-1.12.503-.132.095-.255.19-.379.275-1.034.75-1.945 1.537-2.884 2.344-1.413 1.214-2.79 2.438-4.184 3.653a754.532 754.532 0 00-4.004 3.51c-.057.047-.123.095-.18.152-1.87 1.622-3.72 3.273-5.579 4.886-1.404 1.215-2.79 2.457-4.174 3.672 1.015-.968 2.011-1.964 3.026-2.932.256-.237.503-.484.76-.721.255-.237.493-.503.749-.74.265-.237.503-.493.759-.73.256-.238.512-.484.759-.731 1.983-1.983 3.985-3.966 5.968-5.949 2.485-2.486 4.98-4.953 7.419-7.476.37-.38.73-.769 1.082-1.148a2.79 2.79 0 00.332-.418c.199-.303.303-.645.303-1.015 0-.114 0-.228-.01-.341-.018-.247-.18-.484-.36-.655a1.014 1.014 0 00-.152-.133 1.014 1.014 0 00-.53-.209c-.229-.038-.437 0-.665.057-.398.105-.674.285-1.015.475 0 0-.39.246-.56.38.123-.134.313-.285.474-.418 0-.02-.01-.029-.019-.038 0 0 0-.01.01-.01.36-.38.446-.91.161-1.224-.294-.332-.882-.294-1.31.095-.066.067-.17.171-.246.266-.673.711-1.252 1.366-1.945 2.059-.19.19-.36.389-.569.569l-1.831 1.603c-.408.36-.816.712-1.224 1.073-.408.36-.816.711-1.224 1.062-.607.531-1.205 1.082-1.812 1.613-.2.17-.408.342-.598.531.493-.37 1.006-.73 1.509-1.09-.892.777-1.794 1.555-2.704 2.333-.911.778-1.794 1.575-2.695 2.353-1.774 1.528-3.53 3.103-5.275 4.659a.23.23 0 01-.095.057c-.01-1.196-.047-3.473-.057-3.587 0-.161-.322-.294-.711-.294-.114 0-.219.01-.314.029.038-1.756.076-3.51.124-5.257v-.01c-.01-.379-.465-.692-1.044-.692-.028 0-.057 0-.085.01-.029 0-.057.01-.086.01-.056.009-.104.009-.16.018-.048.01-.096.02-.153.038-.047.01-.094.038-.133.057-.047.02-.085.048-.123.067a.423.423 0 00-.104.075c-.029.029-.057.057-.086.095a.254.254 0 00-.056.095c-.02.038-.029.076-.038.114-.01.038-.01.076-.02.123V24.301c0 .019 0 .048.01.066v.076c0 .029 0 .048.01.076v.161c0 .029 0 .058.01.086v.095l.009.095c0 .028 0 .066.009.095v.104c0 .038 0 .066.01.104v.105c0 .038 0 .075.009.113v.114l.01.114c0 .038 0 .076.009.114v.123c0 .038 0 .076.01.124 0 .038 0 .085.009.123v.123c0 .038.01.086.01.124v.133c0 .038.009.085.009.132 0 .048.01.086.01.133 0 .048.009.086.009.133l.01.133c0 .047.009.095.009.133l.01.133c0 .038.009.085.009.132l.01.133c0 .048.009.095.009.142 0 .048.01.095.01.143l.009.142c0 .048.01.095.01.143 0 .047 0 .094.009.142 0 .047.01.095.01.142 0 .047 0 .095.009.142 0 .048 0 .095.01.143 0 .047.009.095.009.142 0 .047 0 .095.01.142 0 .048.009.095.009.143.01.047.01.095.01.142 0 .047.009.095.009.142.01.048.01.095.01.143 0 .047.009.095.009.142 0 .047.01.095.01.142l.009.143c0 .047 0 .094.01.142 0 .047.009.095.009.142 0 .048.01.095.01.142 0 .048.009.095.009.133 0 .048.01.086.01.133 0 .048 0 .095.009.133 0 .038 0 .085.009.133 0 .047 0 .085.01.133 0 .038 0 .085.009.133 0 .047.01.085.01.132 0 .038 0 .086.009.124 0 .038 0 .085.01.123 0 .038 0 .085.009.123 0 .038 0 .086.01.124v.123c0 .038.009.076.009.123v.238c0 .038.01.075.01.113 0 .038.009.076.009.114v.105c-.114-.247-.237-.484-.342-.712-.038-.085-.104-.209-.104-.294-.038-.484-.038-.968-.066-1.452a1301.8 1301.8 0 01-.086-1.46c-.057-.969-.114-1.936-.161-2.913-.133-2.686-.323-5.333-.418-8.027 0-.124-.019-.247-.019-.36 0-.114.029-.238.038-.352.294-2.694.892-8.121.892-8.254.029-1.072-.522-1.954-1.233-1.983-.721-.028-1.328.825-1.376 1.888-.01.218.237 4.004.332 5.958.01.152.038.304.029.456-.02.294-.086.579-.114.863a96.817 96.817 0 00-.712-4.355c-.265-1.404-.54-2.799-.854-4.184a7.352 7.352 0 00-.816-2.097c-.37-.626-.93-1.252-1.679-1.404a1.975 1.975 0 00-1.565.37c-.532.323-.911 1.006-1.025 1.566-.142.72.019 1.49.123 2.21.256 1.727.39 3.463.627 5.19.132.968.237 1.945.36 2.913-.237-.474-.465-.968-.693-1.442-1.565-3.425-3.169-6.831-4.734-10.247-.038-.028-.019-.019-.028-.019l-.01.01c.674 1.518 1.404 3.064 2.059 4.63-.769-1.49-1.47-3.046-2.21-4.564-.466.228-.883.389-1.348.617.038-.01-.019.01.019 0 1.916 4.43 3.89 8.833 5.788 13.264.588 1.385 1.195 2.78 1.783 4.174.038.095.095.17.105.275-1.518-3.273-3.036-6.556-4.564-9.82 0-.009-.01-.009-.01 0a510.98 510.98 0 013.274 7.363c.028.076.066.152.095.237-1.414-2.979-2.837-5.94-4.25-8.918-.02-.048-.03-.057-.039-.076-.114.038-.18.095-.275.114-.901-2.173-2.638-6.348-2.723-6.528-.436-.949-1.319-1.499-2.04-1.224-.787.294-.93 1.272-.797 1.983.105.56.332 1.072.541 1.604.209.55.418 1.1.636 1.65.047.133.104.295.17.446.048.133.086.342.171.456-.417-.532-.939-.807-1.356-.645-.522.208-.693 1.043-.437 1.944-.389-.512-.882-.777-1.271-.626-.541.219-.664 1.148-.285 2.097.01.029.029.057.038.085.047.095.085.162.114.238.389 1.005.787 2.002 1.176 3.007-.313-.521-.597-1.081-.91-1.613a1.663 1.663 0 00-.228-.284.685.685 0 00-.76-.114.67.67 0 00-.398.617c0 .151.057.284.095.408.048.123.105.237.152.35.588 1.462 1.195 2.819 1.803 4.27a570.67 570.67 0 003.662 8.482c.768 1.765 1.556 3.53 2.334 5.266.057.114.114.227.142.341-.901-1.926-1.793-3.861-2.704-5.787 1.13 2.59 2.24 5.237 3.387 7.799.038.076.076.151.095.237-.17-.038-.322-.095-.484-.152-.16-.057-.322-.095-.474-.161a646.104 646.104 0 01-3.653-1.822c-.844-.446-11.214-4.886-11.632-5.038-.047-.019-.094-.047-.142-.066-1.233-.55-1.594.692-1.47 1.006a52.392 52.392 0 00-1.3-.475c-.437-.152-1.32-.474-1.32-.474-.208-.076-.502.19-.654.588-.085.228-.104.455-.066.617a16.524 16.524 0 01-1.566-.437c-.275-.095-.55-.199-.844-.284a8.934 8.934 0 00-.901-.228c-.323-.066-.684-.123-1.016-.085-.35.037-.73.151-.967.426-.257.295-.294.693-.2 1.054.095.36.276.664.484.967.067.095.133.18.209.266.076.085.152.161.228.237.095.086.19.18.294.266.104.095.218.18.341.256.124.085.257.161.38.237.152.086.294.171.446.247.161.085.332.17.503.237.19.085.38.152.569.228.218.076.427.152.645.218.057.019.104.038.161.047a15.4 15.4 0 01-.702-.123c-.161.57-.408 1.404-.408 1.433l.01.01s9.924 4.23 14.943 6.299c-2.922-.949-5.91-1.84-8.852-2.78-.987-.313-1.974-.617-2.96-.92-1.955-.598-4.042-1.148-6.3-1.452-.588-.085-1.186-.123-1.774-.161-.294-.019-.579-.067-.873-.095-.294-.038-.579-.076-.864-.104-.142-.02-.284-.029-.417-.067l-.37-.114c-.598-.199-1.243-.407-1.84-.588a2.33 2.33 0 00-.323-.085.072.072 0 00-.048-.02c-.389-.075-.797.304-.901.855-.104.54.114 1.034.503 1.129.028.01.057.01.066.019.029.01.057.01.086.01.901.113 1.783.227 2.666.331.218.029.417.114.626.171.617.19 1.252.37 1.84.57-.123.265-.18.569-.275.863-.066.218-.132.436-.199.645l-.038.133c.674.18 1.338.389 2.002.588 4.706 1.404 9.412 2.79 14.108 4.203-.133.408-.256.816-.389 1.224-1.451-.494-2.903-1.015-4.364-1.5-.73-.246-1.452-.512-2.173-.749-1.499-.493-3.045-1.062-4.506-1.537-.01 0-.152-.057-.067-.019.076.038.18.067.275.095 1.281.456 2.515.883 3.786 1.347.626.228 1.262.446 1.86.693.075.038.17.057.237.114-.608-.142-1.205-.323-1.803-.503-1.176-.36-2.343-.74-3.52-1.091-.598-.18-1.167-.389-1.736-.579-.645-.218-1.29-.446-1.936-.664-.303-.114-.939-.332-1.632-.57-1.024-.36-2.068-.71-3.074-1.071-.066-.029-.132-.067-.199-.095-.322-.095-.683.19-.806.636-.133.436.019.863.322.967.048.02.114.029.114.029.095.019.162.038.256.066 2.43.655 4.849 1.366 7.24 2.04.256.076.502.142.749.228 1.205.417 2.429.863 3.615 1.28-.607-.151-1.196-.303-1.803-.464-.01 0-.01.01.01.01.778.217 1.546.417 2.305.635.37.104.721.256 1.082.38.37.132.73.246 1.09.379 1.462.512 2.914.996 4.365 1.508a339 339 0 004.364 1.509c1.462.484 2.904 1.006 4.374 1.499-3.614 3.283-7.248 6.537-10.474 10.19a41.527 41.527 0 00-1.755 2.115c-.067.086-.114.18-.19.247-.152.133-.323.247-.484.38 0 0-.797.588-.94.797-.142.208.067.645.485.939.417.294.882.36 1.043.142 0 0 0-.01.01-.01s.01-.009.01-.018c.198-.408.445-.75.692-1.11.066-.095.114-.19.2-.266.075-.066.16-.142.255-.209.171-.133.342-.275.513-.408 4.705-3.766 9.392-7.542 14.07-11.337.076-.067.228-.2.275-.2.038 0 .104.038.152.057.161.057.313.114.474.152-1.1 1.233-2.239 2.429-3.34 3.653-.275.303-.56.607-.834.91-.56.617-1.11 1.234-1.66 1.841-.276.304-.551.617-.798.959.076 0 .152-.124.21-.143-1.984 2.125-6.111 6.224-6.102 6.234.124.114.19.19.304.303-.968.902-1.926 1.803-2.894 2.695.095.085.18.19.276.284a64.01 64.01 0 01-1.348 1.148c-.209.18-.047.721.37 1.215.351.417.76.654 1.006.617.01 0 .01.009.019.009-.636.645-1.47 1.376-2.116 2.04-.076.076-.275.266-.294.294-.228.247-.341.94-.2 1.31.03.075.096.265.2.35-.55.475-1.063.883-1.622 1.357-.057.047-.105.104-.124.114-.142.19-.085.512.171.854.275.36.664.531.863.38l.02-.02a.757.757 0 00.142.541c.17.266.436.408.616.351.038-.01.048-.019.067-.028.038-.02.057-.048.085-.086 1.831-1.451 3.653-2.922 5.475-4.374.616-.493 1.233-.996 1.86-1.48-.589.816-1.13 1.632-1.7 2.42-.056.076-.113.133-.18.199-.246.247-.502.493-.758.75-.503.502-1.025.977-1.528 1.47-.417.418-.863.835-1.28 1.252-.086.086-.238.228-.238.228-.408.446-.398 1.139.01 1.5.01.009.019.009.028.018a.13.13 0 00.038.029c.019.019.047.028.066.047.02.01.048.029.067.038.019.01.047.02.066.029.029.009.048.019.076.028.029.01.048.019.076.019.029.01.057.01.076.019.028 0 .057.01.076.01h.085c.029 0 .057 0 .086-.01.028-.01.057-.01.085-.019.028 0 .057-.01.085-.019l.086-.028.085-.029c.029-.01.048-.028.076-.038.029-.01.048-.028.076-.038l.076-.047c.028-.02.047-.038.076-.057.019-.02.047-.038.066-.067.029-.028.057-.047.086-.075.01-.01.01-.02.019-.02a.075.075 0 01.038-.037.074.074 0 01.038-.038c.009-.02.018-.038.037-.048.01-.019.029-.038.038-.057.02-.019.029-.038.048-.057.019-.019.028-.038.047-.066a.29.29 0 00.048-.067c.019-.028.038-.047.057-.075l.056-.086c.02-.028.048-.057.067-.085.019-.029.047-.057.066-.095a.658.658 0 01.076-.095l.076-.104c.029-.038.048-.067.076-.105.029-.038.057-.076.076-.114l.085-.113c.029-.038.057-.086.086-.124.028-.038.057-.076.085-.123.029-.038.057-.085.085-.123.029-.038.057-.086.095-.124.029-.038.057-.085.095-.123l.095-.123c.029-.048.067-.086.095-.133.028-.038.066-.086.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.037.066-.085.094-.132.029-.038.067-.086.095-.133a.608.608 0 01.095-.124c.029-.037.057-.085.095-.123.028-.038.057-.085.085-.123.029-.038.057-.086.086-.124l.085-.113c.029-.038.057-.076.076-.114l.086-.114c.028-.038.047-.076.075-.114a.423.423 0 01.076-.104c.029-.038.048-.076.076-.105l.076-.104c.2-.285.39-.579.636-.806.247-.228.484-.475.72-.712.722-.721 1.472-1.414 2.192-2.135.722-.72 1.471-1.423 2.192-2.135.237-.237.494-.464.73-.711.485-.474.988-.94 1.462-1.414.246-.237.493-.465.73-.702.484-.484.978-.949 1.462-1.414.74-.702 1.451-1.432 2.2-2.115.124-.114.247-.237.361-.351.36-.36.74-.702 1.1-1.063.238-.237.475-.484.722-.712.123-.113.265-.208.398-.322.797-.645 1.594-1.3 2.382-1.945.93-.76 1.869-1.509 2.79-2.258-6.51 6.708-13.018 13.434-19.47 20.2-.028.028-.047.056-.085.085-.01.019-.029.028-.038.047.019-.01.029-.028.047-.038a581.15 581.15 0 005.437-5.38c1.129-1.129 2.248-2.267 3.358-3.387.674-.673 1.338-1.366 2.012-2.04.901-.9 1.774-1.83 2.675-2.732 1.803-1.803 3.568-3.643 5.37-5.446l2.581-2.58a.81.81 0 01.133-.105c.047.142.142.237.18.37.038.123.048.275.076.408.066.332.123.674.18 1.006.342 2.96.826 7.21.873 7.552.162 1.148.332 2.305.494 3.454.38 2.628 2.239 13.13 2.58 13.852.162.35.484.702.892.74.408.037.883-.38.93-.788.066-.531-.142-1.053-.142-1.584v-3.957c0-.408 0-.816-.01-1.224-.019-.73-.057-1.47-.114-2.2-.114-1.48-.341-2.923-.531-4.394a90.661 90.661 0 01-.266-3.055c2.325 4.545 6.964 13.653 6.964 13.653.105.152.494.142.902-.028.436-.18.711-.484.635-.664v-.01c-1.85-4.601-3.69-9.212-5.578-13.785a350.654 350.654 0 013.68 4.933c.077.114.162.2.228.313.076.114.105.237.162.38.73 1.783 1.546 3.53 2.343 5.19-.977-1.699-1.84-3.52-2.647-5.399 0-.01-.01-.01-.01.01.504 1.27.987 2.542 1.538 3.776.54 1.223 1.167 2.4 1.85 3.481.322.522.673 1.063 1.081 1.576.285.35.645.711.987 1.015.332.284.94.55 1.509.398.332-.085.569-.285.768-.56.19-.265.304-.616.285-1.024a3.667 3.667 0 00-.247-1.091c.37-.162.75-.342 1.1-.513.048-.019.115-.038.152-.076-.73-1.556-1.499-3.093-2.22-4.658-.72-1.556-1.499-3.093-2.22-4.658-.73-1.566-1.49-3.103-2.22-4.659-.74-1.547-1.527-3.074-2.249-4.62.285.104.598.18.873.294 3.274 6.764 6.566 13.52 9.934 20.199.01.019.028.019.01 0-3.112-6.68-6.272-13.368-9.384-20.02 3.52 1.158 7.059 2.297 10.607 3.435.02 0 .02-.01 0-.01-1.783-.654-3.586-1.26-5.38-1.897a449.786 449.786 0 00-5.398-1.888c0-.01-.01-.01-.019-.019-.18-.427-.408-.853-.578-1.252 1.584.512 3.216 1.025 4.81 1.518.228.066.455.152.683.218 2.325.702 4.64 1.423 6.992 2.06.465.122.92.293 1.376.435.911.285 1.822.598 2.723.892.901.304 1.803.608 2.685.93.664.247 1.338.474 1.983.75l.465.265c.038.01.085.02.133.01.474-.02 1.1-.854 1.442-1.983.38-1.233.275-2.438-.218-2.58 0 0-.285-.048-.304-.058.114-.54.057-.967-.256-1.062-.028-.01-7.571-2.43-11.243-3.587-.531-.17-1.063-.332-1.603-.503-2.088-.654-4.166-1.309-6.262-1.954.227 0 .455-.01.692-.01.408.133 3.321 1.063 4.222 1.348 1.509.474 2.97.92 4.45 1.395 1.414.455 4.279 1.385 4.298 1.385 0 0 .047.019.095-.01.114-.057.247-.218.313-.427.066-.237.057-.465 0-.569 0 0-.019-.047-.076-.066-.038-.01-.066-.02-.095-.029-.408-.142-.806-.284-1.205-.427-1.404-.474-2.799-.94-4.184-1.423-.92-.323-1.85-.636-2.78-.949-.332-.104-.664-.227-.986-.341 9.108-.313 18.87-1.025 15.123-1.651zM22.605 46.92c-.541-.124-1.063-.323-1.566-.484.143.01.275.076.418.114.275.085.56.17.854.246.133.038.284.067.398.124-.019.038-.066.01-.104 0zm23.7-19.555c.029-.218.047-.455.066-.673.038-.323.086-.626.114-.92.133.806.228 1.641.37 2.447.038.228.086.522.095.807-.19-.399-.389-.825-.588-1.243-.029-.066-.076-.133-.076-.18-.019-.076.01-.152.02-.238zm-.256 2.06c.019-.162.057-.4.076-.55.266.54.54 1.11.806 1.669.038.085.095.152.114.228.02.085.01.19.02.284.018.266.028.55.047.845-.323-.683-.674-1.433-1.016-2.145-.057-.123-.066-.16-.047-.332zm-.36-8.559c-.048.475-.114.987-.162 1.462-.076.702-.152 1.394-.218 2.058.161-1.214.303-2.447.474-3.643.057.228.01.522-.019.788-.114 1.347-.275 2.742-.408 4.08-.066-.134-.133-.257-.199-.4a.886.886 0 01-.057-.141c-.01-.086.02-.2.038-.304.18-1.518.37-3.121.55-4.592.076.2.02.455 0 .692zm-2.676 2.268c-.038-.332-.085-.645-.123-.977.645 1.31 1.261 2.637 1.907 3.947-.029.218-.057.436-.076.664-.58-1.205-1.13-2.42-1.708-3.634zm1.575 4.659a4.136 4.136 0 00-.048.36c-.398-.873-.759-1.755-1.157-2.647-.029-.057-.067-.114-.086-.17-.037-.134-.018-.285-.056-.409.464.949.891 1.917 1.347 2.866zm-2.192-4.725c.17.341.323.702.484 1.043.01.105.028.19.028.304-.17-.37-.332-.76-.502-1.12.01-.095-.02-.152-.01-.227zm.209-1.518c.028.303.066.588.095.882-.18-.36-.342-.75-.522-1.11-.028-.294-.066-.579-.095-.863.18.36.342.74.522 1.09zm-.712-2.59c-.028-.285-.066-.55-.095-.835.2.398.37.816.56 1.223.029.228.048.446.076.684-.18-.352-.351-.721-.54-1.073zm.693.9c.398.883.806 1.756 1.167 2.676-.029.029-.029-.019-.038-.028-.095-.123-.17-.294-.247-.446a81.71 81.71 0 01-.673-1.3c-.048-.085-.114-.17-.133-.256-.029-.085-.029-.209-.038-.313 0-.114-.029-.218-.038-.332zm2.144 8.265c.095.16.161.341.247.502 0 .152-.038.276-.048.418-.085-.17-.151-.351-.237-.522.01-.142.038-.256.038-.398zm.2-.902c-.02-.038-.058-.085-.067-.123-.01-.076.028-.228.038-.323.019-.123.028-.246.047-.341.095.161.162.341.257.503-.029.227-.067.436-.086.673-.076-.114-.133-.256-.19-.389zM33.98 5.402c-.018-.038-.037-.114-.066-.162-.019-.047-.057-.095.029-.114.028-.01.038.038.047.057.076.171.152.36.228.541.588 1.433 1.205 2.922 1.802 4.374-.683-1.547-1.356-3.14-2.04-4.696zm2.183 2.789c-.247-.55-.503-1.12-.769-1.708-.199-.436-.446-1.006-.673-1.49 0-.028-.029-.075-.038-.113-.038-.105-.048-.076.038-.105.057.048.066.133.095.2.702 1.527 1.432 3.083 2.153 4.62.996 2.135 2.002 4.26 3.008 6.414.209.446.436.93.664 1.404.028.066.085.133.095.19.019.057.01.132.019.199.019.18.057.389.076.579-1.585-3.359-3.112-6.774-4.668-10.19zm4.857 2.135c.038.095.048.227.067.35-.01-.255-.057-.521-.086-.777a152.393 152.393 0 01-.341-3.15c-.038-.351-.02-.76.18-1.063.161-.247.493-.493.797-.484.55.02 1.006.712 1.177 1.158.114.265.227.56.313.844.085.285.151.57.246.864.36 1.186.646 2.41.902 3.652.256 1.243.503 2.553.711 3.852.19 1.158.36 2.258.55 3.435.02.17.067.341.067.503 0 .104-.029.218-.038.332-.19 1.603-.417 3.33-.607 4.924-.73-1.556-1.5-3.207-2.249-4.8-.047-.105-.114-.22-.142-.314-.047-.152-.047-.341-.076-.522-.161-1.224-.313-2.429-.474-3.662-.2-1.452-.37-2.856-.56-4.317.01.332.066.664.104.996.275 2.325.522 4.678.788 7.03-.162-.331-.332-.683-.494-1.034-.019-.047-.057-.104-.066-.142-.019-.066-.019-.161-.029-.247-.132-1.176-.246-2.419-.37-3.586-.132-1.3-.275-2.571-.37-3.842zm-3.387 9.43c.076.133.171.39.228.522 1.271 3.065 2.533 6.13 3.824 9.194.17.398.341.825.512 1.243.028.057.057.114.076.17.028.124.019.228.038.37-1.566-3.842-3.103-7.6-4.64-11.394a.594.594 0 00-.038-.086c-.01-.019-.038-.075 0-.019zm2.107 30.408c.142-.142.284-.313.436-.455.114.038.237.066.342.104.028.01-.029.057-.048.067-.161.17-.36.37-.54.531a2.415 2.415 0 00-.314-.104c0-.048.076-.095.124-.143zm-.323-.009c-.019.019-.038.057-.066.057-.038-.02.028-.048.047-.067.152-.16.332-.35.484-.502-.123.133-.304.35-.465.512zm-1.803-30.456c-.028.01-.038-.085-.057-.113-.01 0-.01-.01-.01-.02.03.039.039.096.067.134zm-.085-.18c.01.01.01.02.019.029 0 .019-.019-.02-.019-.029zm0-.019c-.01.02-.019-.01-.019-.028.01.01.01.019.019.028zm-.048-.104c0 .019-.019-.02-.019-.029.01 0 .02.02.02.029zm-.028-.076c.01.01.01.019.019.028-.01.02-.028-.018-.019-.028zm0-.019c-.01.019-.019-.019-.019-.028 0 .009.01.018.02.028zm-.047-.104c0 .019-.02-.01-.02-.029.01.01.01.02.02.029zm.019.038c0 .019-.02-.02-.02-.029.01.01.01.02.02.029zm.996 9.05c.522 1.092.92 2.25 1.395 3.388-.257-.531-.55-1.053-.797-1.594-.247-.56-.465-1.129-.703-1.689-.474-1.12-.939-2.258-1.404-3.377.522 1.081.996 2.182 1.509 3.273zm-1.272.997c.285.57.522 1.167.778 1.755.257.588.513 1.167.76 1.765-.94-1.566-1.86-3.188-2.761-4.81-.152-.275-.304-.541-.456-.816-.152-.275-.275-.57-.398-.864a465.694 465.694 0 01-2.942-7.153c0-.038.048.047.057.066.541 1.082 1.082 2.182 1.632 3.264.57 1.129 1.1 2.267 1.66 3.387.57 1.139 1.11 2.277 1.67 3.406zM31.59 6.037c.342.826.674 1.68 1.016 2.505.047.123.085.247.161.351-.322-.987-.683-1.945-1.043-2.903l.047-.02c.94 2.098 1.85 4.223 2.76 6.348-.142.057-.293.114-.426.19-.351-.807-.683-1.594-1.025-2.4-.114-.266-.218-.541-.322-.817-.219-.54-.465-1.043-.702-1.574-.228-.503-.437-1.035-.484-1.68h.019zm-.37.133l.03-.01c.834 2.002 1.697 4.014 2.551 6.025.029.067.095.2.124.304 0-.01.028.047.028.047 0 .038-.01.029-.038.038-.038.02-.047 0-.066-.047a2.17 2.17 0 01-.114-.313c-.816-2.03-1.68-4.033-2.514-6.044zm-1.574 12.22c.047.038.057.104.095.152.208.38.436.768.616 1.195.2.484.408.978.588 1.48-.455-.92-.863-1.887-1.3-2.827zm.806 1.5c0-.039.01 0 .02 0 .54 1.014 1.09 2.049 1.64 3.064.095.17.2.332.276.512 1.755 4.222 3.52 8.501 5.427 12.59.151.332.322.655.474 1.006 0 .01.047.038.01.047-.038-.019-.095-.038-.143-.056-2.656-5.636-5.209-11.376-7.704-17.164zm1.404 19.013c.294.113.589.246.883.389 1.698.797 3.453 1.584 5.18 2.381l-1.48.958a8.503 8.503 0 01-.513-.246c-.588-.295-1.223-.56-1.84-.826-.418-.17-.825-.36-1.243-.54-1.224-.541-2.467-1.12-3.596-1.746-.303.047-.588-.029-.835-.114-.72-.247-1.385-.617-2.03-.959a1.436 1.436 0 01-.161-.094 79.947 79.947 0 00-1.803-.93c-.228-.114-.446-.228-.693-.313 0-.01 0-.01.01-.01 2.467.503 4.867 1.072 7.201 1.718.304.085.607.218.92.332zm5.598 5.275c-.218-.057-.427-.162-.645-.247l-.512-.2c.038-.018.066-.037.104-.047.37.152.721.314 1.053.494zm-11.528-9.46c.076.01.162.057.247.095.086.038.18.057.247.095.047.029.104.086.152.124.142.123.313.265.455.38-.484-.19-.987-.447-1.49-.655.133-.01.257-.057.39-.038zm-4.544-.635c.408.19.825.389 1.233.57 1.234.54 2.448 1.147 3.7 1.697-2.04-.427-4.136-.806-6.233-1.205-.142-.028-.294-.038-.408-.085-.057-.019-.114-.066-.17-.104l4.345.341s-2.306-1.09-4.962-2.182c.199.066.398.123.588.18.237.067.474.105.683.21.417.189.806.388 1.224.578zm-4.753-3.52c1.12.398 2.239.787 3.32 1.167a6.502 6.502 0 01-.465-.114c-.455-.123-.92-.266-1.366-.398.038-.02-.01 0 .048 0-.18-.048-.247-.076-.427-.105-.18-.028-.37-.038-.541-.095-.142-.038-.285-.133-.437-.199-.076-.038-.151-.057-.227-.085-.209-.095-.408-.2-.646-.304-.16-.066-.341-.114-.445-.228.417.038.854.247 1.186.36zm7.03 8.15c.36.209.768.427 1.139.636-.76-.314-1.519-.646-2.278-.978a649.908 649.908 0 00-6.888-2.922c.152 0 .294.038.446.067h.01l1.584.341c.266.133.56.275.854.36.218.067.475.086.721.086.228 0 .465.01.645.076l1.765 1.195.19.086 3.833 1.613 4.222 1.935c-2.125-.863-4.28-1.708-6.395-2.59.057.028.104.066.152.095zm2.619 6.926c.151.019.303.076.455.123.446.133.92.275 1.376.408-.02.02-.029.01-.048 0-.303-.066-.607-.161-.91-.247-.314-.075-.598-.19-.873-.284zm.958.332c2.353.683 4.706 1.347 7.05 2.03.028.01-.02.038-.02.048-.095.095-.237.199-.341.294-2.23-.788-4.47-1.556-6.69-2.372-.009 0-.009.01 0 0zm2.372 3.397c.816.218 1.613.455 2.429.664a.406.406 0 01-.133.123c-.74-.266-1.556-.522-2.296-.788zm4.004 1.982c-2.77 2.23-5.532 4.46-8.293 6.699-.019.01-.019.01-.01-.01.912-.882 1.803-1.783 2.752-2.637.152-.143.294-.304.456-.446.152-.143.313-.285.455-.437.579-.616 1.205-1.195 1.803-1.793.446-.446.92-.873 1.375-1.319.152-.151.304-.294.475-.427l1.005.342c.02 0-.018.019-.018.028zm.521-.436c-.35-.123-.702-.247-1.062-.36.01-.067.123-.114.161-.18.398.104.778.217 1.176.322-.094.076-.17.161-.275.218zm-.74-5.74c-3.121-.987-6.271-1.955-9.355-2.96 4.156 1.271 8.35 2.514 12.467 3.823-.047.067-.095.076-.17.057-.19-.047-.399-.123-.589-.18-.787-.237-1.584-.493-2.353-.74zm1.651 3.558c0-.048.048-.076.086-.105.094-.085.199-.18.294-.275 0-.01.019-.01.019-.019.474.124.93.266 1.394.399-.17.142-.35.285-.521.427-.427-.133-.845-.294-1.272-.427zm.598 2.704c.114-.105.228-.2.351-.294l.484.142c-.095.114-.19.228-.294.323-.18-.048-.36-.124-.541-.171zM19.37 76.626c.844-.721 1.717-1.452 2.57-2.183 2.913-2.495 5.807-5.047 8.71-7.561-.218.35-.474.692-.72 1.043-.039.048-.067.114-.096.152-.047.057-.142.114-.208.171-1.016.835-2.06 1.727-3.065 2.571.162-.095.313-.209.465-.313-.636.56-1.28 1.1-1.954 1.632-2.002 1.594-4.033 3.188-6.035 4.782.076-.105.21-.19.332-.294zm1.3-.73c-.864.72-1.746 1.48-2.61 2.21-.028.019-.047.047-.076.066 0-.047-.01-.095-.019-.152.029-.038.057-.066.086-.094.066-.058.133-.086.209-.124.056-.038.113-.095.17-.142.864-.693 1.774-1.404 2.628-2.106-.113.123-.256.227-.389.341zm.436-.37c-.067.047.019-.01 0 0zm5.711-4.28c-.702.607-1.442 1.205-2.172 1.812-.968.797-1.945 1.604-2.932 2.382.104-.114.228-.2.351-.294.37-.295.74-.589 1.091-.892.474-.408.949-.816 1.423-1.234.475-.408.93-.844 1.423-1.224.494-.389.987-.778 1.5-1.148-.19.219-.447.399-.684.598zm-.066-.123a.585.585 0 01.133-.133c.332-.294.673-.607 1.043-.892.36-.284.721-.57 1.073-.854-.01.086-.105.124-.18.19-.674.54-1.395 1.129-2.07 1.689zm1.964.531c.133-.209.285-.408.436-.626.048-.067.095-.152.143-.209.057-.057.123-.095.19-.142.417-.332.853-.693 1.261-1.034-.635.673-1.357 1.338-2.03 2.011zm1.508-11.973c-.056.047-.16.17-.18.17-.01 0 .086-.094.105-.113.256-.276.53-.55.768-.816.142-.162.313-.294.446-.456.57-.617 1.186-1.214 1.774-1.84.721-.769 1.49-1.537 2.22-2.296.152-.152.304-.304.446-.465.142-.152.294-.304.446-.465.218-.237.437-.456.664-.683.076-.076.133-.171.228-.219.028.02.066.029.104.038-.408.484-.854.94-1.271 1.423.465-.455.91-.939 1.385-1.385.105.038.209.076.323.105-.456.503-.949.958-1.414 1.46l-.104.105c-.029.038-.048.086-.076.114-.057.057-.133.114-.19.17-1.898 1.728-3.785 3.416-5.674 5.153zm8.16-10.418c-.123.152-.304.313-.446.465-.057-.01-.095-.028-.142-.047.19-.171.398-.323.597-.494.01 0 .01.01.02.01.028.019-.02.047-.03.066zm.076 2.619c0 .038-.038.066-.067.095-.085.095-.199.19-.294.284a1.531 1.531 0 01-.313-.114c-.038-.01.02-.028.02-.038.084-.094.208-.227.303-.322.133.019.227.076.35.095zm-.589-.171c.029.01.067.019.095.028a4.174 4.174 0 01-.332.37c-.038-.009-.057-.028-.095-.028-.009-.038.048-.066.076-.095.086-.076.171-.19.257-.275zm-3.235 12.315c-.085.104-.199.18-.303.275-.313.266-.646.54-.959.816.057-.104.143-.209.219-.313.028-.038.047-.085.066-.114a1.14 1.14 0 01.247-.17c.237-.162.502-.323.73-.494zm3.786-2.495c-1.917 1.499-3.843 3.045-5.76 4.554.143-.2.266-.39.456-.55.626-.541 1.272-1.101 1.898-1.66.227-.2.455-.409.702-.58 1.034-.683 2.059-1.385 3.074-2.077a2.921 2.921 0 01-.37.313zm.664-14.611c-.522-.152-1.044-.304-1.547-.465-.037-.01.038-.057.057-.076.522.152 1.035.323 1.556.474-.019.038-.047.048-.066.067zm.047-3.283c-.019 0-.104-.038-.17-.057a26.486 26.486 0 01-1.31-.455c.484-.219.977-.437 1.386-.636.132.285.275.579.408.863-.029.067-.086.095-.143.152-.047.047-.114.133-.17.133zM39.19 59.7c-.01-.02.02-.029.029-.038.161-.143.332-.285.503-.427a39.532 39.532 0 011.537-1.224 3.52 3.52 0 01-.342.313c1.262-1.053 2.562-2.163 3.843-3.245.18.066.36.123.54.18-2.02 1.49-4.08 2.951-6.11 4.44zm7.116-5.352c-.17.171-.36.38-.55.541-.19-.057-.36-.123-.541-.18.218-.2.455-.389.674-.579.16.038.313.095.483.133.01.038-.047.057-.066.086zm-.37-22.988c-.028-.066-.076-.152-.076-.2-.01-.075.02-.16.029-.246l.028-.266c.437.911.854 1.84 1.29 2.752.02.322.038.645.057.968-.446-.987-.882-1.993-1.328-3.008zm4.82 28.72l.028.976c-.512-.986-1.015-1.992-1.527-2.979.066.067.133.152.19.237.426.58.882 1.177 1.309 1.765zm-1.452-4.896c.057.17.123.313.18.483a7.45 7.45 0 01-.407-.55c.075.019.142.047.227.067zM48.27 32.82c.152.294.285.607.446.901.01.105.01.209.019.313-.152-.322-.294-.664-.456-.986.01-.095-.009-.152-.009-.228zm.218 2.002c-.038-.086-.104-.17-.123-.266-.02-.085-.01-.218-.02-.332-.018-.266-.028-.57-.047-.863.086.17.228.474.333.683.047.085.104.18.113.275.02.123.01.313.02.465 0 .047.018.114.009.142-.02.076-.105.114-.17.162a2.77 2.77 0 00-.115-.266zm.143 22.42c.047.028.075.085.113.123.029.047.086.085.105.142.019.047.038.114.057.161.057.143.133.313.18.465-.161-.285-.294-.598-.455-.892zm1.29 5.995c-.114-.227-.37-.91-.674-1.764-.066-.313-.114-.626-.17-.94.521.959 1.034 2.069 1.574 3.075.076.142.162.294.219.446v.018c.028.133.019.314.019.465 0 .2.01.399.019.598a89.041 89.041 0 01-.987-1.897zm12.77 12.866c.162.218.332.455.494.683.446.598.901 1.186 1.338 1.803.218.303.445.616.578.986-.01.038-.066-.047-.095-.076a15.839 15.839 0 01-1.318-1.622c-.437-.626-.797-1.31-1.177-1.973.076.056.123.123.18.199zM56.6 51.986c.758.2 1.517.399 2.276.588l-.095.086c-.73-.228-1.46-.456-2.182-.674zm1.157 3.662c-.313-.085-.627-.18-.94-.265-.123-.257-.256-.494-.38-.75.324.104.646.2.978.285.114.246.228.484.342.73zm.114-4.857c0 .01.037.019 0 .019a147.73 147.73 0 00-2.192-.693c-.076-.123-.123-.275-.2-.398.105.018.2.085.304.123.683.313 1.395.636 2.088.949zm-1.5-3.729c-.199.18-.398.36-.607.531-.55-.246-1.081-.512-1.632-.759-.17-.389-.36-.778-.54-1.157.095-.114.208-.19.313-.285 1.034.37 2.03.769 3.064 1.13-.19.189-.398.36-.598.54zm-1.375 2.827c-.228-.076-.446-.152-.674-.218.104-.123.228-.228.351-.332.038 0 .048.019.086.029.066.17.16.341.237.521zm-.883-.816c-.066.076-.151.152-.237.228-.028.02-.047.057-.085.057-.066-.18-.152-.341-.218-.512.199.066.36.161.54.227zm3.805-3.377c-1.044-.36-2.087-.702-3.13-1.063-.039-.01.028-.047.047-.066.038-.029.066-.067.104-.095 1.034.37 2.05.75 3.083 1.11 0 .038-.075.076-.104.114zm3.89 1.043c2.173.76 6.338 2.202 8.548 2.932l.219.086c.066.019.16.028.19.094-.058.057-.21.048-.295.02a.381.381 0 01-.152-.096c-2.21-.768-6.356-2.22-8.51-3.036-.019 0-.019.01 0 0zm7.818 2.989c.085.029.17.047.246.076.228.085.475.18.712.266.047.019.114.028.142.075-.863-.303-3.69-1.261-4.554-1.565-2.561-.901-5.133-1.803-7.723-2.704.029-.038.067-.066.095-.095 3.036 1.091 8.055 2.846 11.082 3.947zm6.897-19.526c-.16.152-.36.266-.55.418-1.3.977-2.58 2.002-3.852 3.007-2.903 2.315-5.73 4.735-8.539 7.164-1.357 1.176-2.713 2.353-4.08 3.53-.038.037-.075.075-.132.084-1.034-.35-2.06-.72-3.103-1.072-.028-.028.029-.057.038-.066.142-.142.332-.285.484-.427.54-.484 1.11-.977 1.66-1.461.37-.323.75-.655 1.11-.977.19-.162.36-.342.55-.494.95-.778 1.917-1.565 2.885-2.334.19-.151.427-.265.655-.398 4.155-2.439 8.529-4.697 12.874-6.974zm1.537-2.106c-1.442.797-2.94 1.528-4.402 2.296-.209.105-.408.228-.617.332-1.242.655-2.504 1.319-3.728 2.012.066-.076.151-.114.227-.171 1.234-.845 2.581-1.613 3.947-2.344.36-.199.75-.37 1.12-.56.37-.19.759-.36 1.138-.53.76-.361 1.537-.703 2.306-1.044.047 0 .01 0 .01.01zm2.904-4.8c.123-.03.246-.058.37-.077.256-.038.512-.047.768.01.057.01.105.028.161.038.057.01.124.01.171.028.095.029.209.124.285.2.18.16.313.332.446.53a.942.942 0 01.152.361c.028.152 0 .352-.029.494-.161.854-.892 1.233-1.537 1.613l-.161.104c-.057.028-.142.066-.171.085-.095.057-.237.133-.266.152-.076-.019-.16-.066-.265-.038.095-.047.322-.151.427-.199a9.567 9.567 0 001.556-1.063c.19-.18.332-.502.332-.872 0-.399-.237-.703-.456-.93-.076-.076-.151-.171-.237-.218a1.444 1.444 0 00-.398-.152c-.38-.086-.835-.01-1.205.066-.73.142-1.433.342-2.107.55-.93.285-1.812.608-2.647.902a30.098 30.098 0 014.81-1.585zm-7.325 4.715l.218-.171c-.019-.029-.066-.085-.142-.18.55-.351 1.1-.702 1.717-.978.617-.275 1.29-.483 1.964-.72.987-.361 1.993-.684 3.065-.968.246-.067.484-.143.75-.19.113-.02.237-.038.36-.038.028.01 0 .028-.01.038-.227.17-.531.322-.806.465-.588.313-1.186.607-1.812.892-.313.142-.645.256-.968.389-.323.132-.645.256-.968.389-.939.398-2.656 1.224-2.799 1.309-.692.341-1.366.711-2.02 1.081.227-.237.53-.483.844-.749.17-.17.389-.38.607-.57zM54.332 40.05c.246-.219.512-.446.711-.627a294.06 294.06 0 012.894-2.476c.247-.209.493-.408.73-.617.712-.626 1.405-1.28 2.107-1.916 1.888-1.708 3.738-3.387 5.645-5.085.949-.845 1.898-1.699 2.837-2.534 1.423-1.233 2.846-2.523 4.336-3.719.512-.408 1.034-.816 1.584-1.148-.806 1.385-1.973 2.467-3.207 3.473-.246.199-.474.417-.711.626-.902.778-1.784 1.546-2.695 2.315-.028.028-.066.047-.095.076-.493.427-1.024.863-1.527 1.3-.958.825-1.945 1.622-2.894 2.447-.949.835-1.897 1.66-2.856 2.486l-1.432 1.233-2.856 2.486c-1.423 1.243-2.913 2.42-4.355 3.653-.057-.028-.275-.057-.323-.104-.028-.038-.028-.01 0-.038a.71.71 0 01.133-.114c.664-.57 1.329-1.148 1.974-1.717zm-.959 6.423c-.16-.067-.303-.143-.465-.209.076-.085.171-.142.247-.228.01 0 .02 0 .02.01.056.142.132.275.198.427zm.959-8.634c-.702.702-1.376 1.404-2.088 2.116-.01.01-.047.038-.066.066-.028.029-.028.057-.066.038-.02-.01-.038-.066-.029-.095 0 .01.067-.057.076-.066 1.47-1.414 2.922-2.875 4.383-4.289-.702.702-1.46 1.49-2.21 2.23zm-3.046-3.359c0-.095-.019-.208 0-.294.01-.057.123-.123.2-.19.199-.18.407-.38.607-.54.825-.721 1.64-1.443 2.447-2.164.276-.237.56-.474.826-.711.142-.123.275-.237.408-.36.673-.589 1.366-1.196 2.04-1.784-1.063 1.148-2.163 2.296-3.255 3.453-.816.864-1.631 1.727-2.438 2.61-.266.284-.531.578-.816.844 0-.256-.019-.58-.019-.864zm.066 3.862c.01-.076.21-.237.304-.332.721-.74 1.423-1.528 2.125-2.268.304-.322.598-.654.902-.986.493-.532 1.015-1.082 1.508-1.613.702-.769 1.423-1.509 2.125-2.268.095-.114.21-.209.304-.323.797-.873 1.68-1.67 2.514-2.504.418-.418.854-.816 1.281-1.243 1.253-1.253 2.552-2.467 3.843-3.69l.654-.599c.655-.588 1.3-1.205 1.983-1.783.456-.39.911-.769 1.367-1.148.464-.38.93-.76 1.404-1.12.01-.01.019 0 .01 0-2.458 2.6-5 5.123-7.506 7.685-.626.645-1.252 1.271-1.888 1.907-.104.105-.218.2-.322.304-.057.057-.095.123-.142.17l-9.014 9.014c-.322.313-.645.626-.958.94-.076.075-.152.16-.237.236-.029.02-.048.057-.086.048-.047-.143-.152-.237-.161-.418v-.01h-.01zm.636 17.875l.74 1.062c-.237-.085-.474-.161-.711-.246-.02-.266-.02-.541-.029-.816zm3.9 14.829c-.01.038-.038-.057-.057-.085-.294-.55-.589-1.139-.873-1.699-.304-.607-.617-1.214-.92-1.812-.608-1.214-1.243-2.42-1.85-3.615-.01-.626-.038-1.243-.048-1.878a491.542 491.542 0 013.748 9.089zm1.556-4.526c-.408-.522-.797-1.072-1.186-1.613-1.148-1.584-2.306-3.15-3.463-4.734-.095-.133-.171-.351-.247-.522-.142-.35-.285-.692-.427-1.053-.028-.066-.076-.152-.085-.209-.02-.142 0-.303-.01-.455-.01-.152-.01-.304-.019-.446.37.123.73.247 1.1.36l3.264 4.725c.38 1.329.703 2.647 1.073 3.947.01.01.01.01.019.01 0 .01-.02 0-.02-.01zM57.13 56c-.018-.019-.018-.047-.037-.066 0-.01.01 0 .01 0 .236.066.502.133.758.2.067.018.18.037.19.132-.313-.085-.607-.18-.92-.266zm4.944 16.433c-.845-1.082-1.718-2.182-2.572-3.292-.056-.076-.142-.152-.18-.218-.047-.086-.066-.21-.104-.304-.38-.977-.73-1.973-1.072-2.998l3.928 6.812zM59.72 59.7c-.285-.076-.598-.2-.883-.294-.199-.408-.408-.816-.607-1.234.304.095.588.2.883.275.199.418.389.845.607 1.253zm22.21 2.334c.067-.067.133-.067.19-.067.038.133.038.351.01.513-.02.151-.067.341-.18.379-.086.029-.247-.029-.39-.066-1.84-.465-3.68-.987-5.484-1.49-1.47-.398-2.912-.806-4.373-1.205-3.88-1.063-7.752-2.163-11.632-3.254-.37-.105-.788-.209-1.177-.332-.01-.01-.028-.01-.047-.02-.105-.047-.228-.018-.247-.151.01 0 .01 0 .01.01.483.123.958.265 1.432.388 1.433.37 2.875.769 4.327 1.158 1.926.512 3.87 1.006 5.806 1.499 1.936.493 3.862 1.006 5.788 1.518.474.133.939.275 1.413.408.721.2 1.442.38 2.182.56.247.057.494.114.722.19.464.151.91.313 1.366.455.057-.047.095-.114.085-.18-.01-.105-.133-.143-.246-.171.151.028.303-.029.445-.142zm-.55.104c.02.01.038.019.067.028h.019c-.029-.01-.058-.01-.086-.019v-.01zm-2.998-.91c.17.047.275.084.398.122.845.266 1.708.522 2.562.788a2.4 2.4 0 01-.446-.066c-.095-.029-.199-.076-.294-.114a41.71 41.71 0 00-2.097-.683c.18.066.37.132.55.199-.18-.029-.36-.086-.54-.142-1.234-.37-2.496-.76-3.729-1.158-1.413-.455-2.837-.873-4.25-1.338 2.637.788 5.237 1.585 7.846 2.391zm-14.62-4.422c.18.057.37.123.55.19.901.322 1.85.635 2.77.93 3.017.948 6.044 1.859 9.023 2.827-5.93-1.623-11.84-3.273-17.742-4.934-.057-.038-.057-.114-.085-.17-.086-.171-.18-.352-.257-.541.769.227 1.537.446 2.296.683 1.158.341 2.296.664 3.444 1.015zm2.646-3.824a.763.763 0 00-.151-.398c4.25-.123 11.48-.304 12.931-.162 1.509.143-7.675.418-12.78.56z",
    fill: "#5A12AA"
  })));
}

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function SvgHorizontalLogoReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    viewBox: "0 0 224 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.725 37.426c4.4 1.3 7.3 3.4 7.3 8 0 5.5-5.1 9-10.4 9-4.6 0-9-1.9-11.6-5.3l3.3-3.9c2.5 3 5.3 4.3 8.4 4.3 2.6 0 4.8-1.2 4.8-3.6 0-1.9-1-2.8-3.4-3.5l-4.9-1.5c-4.1-1.2-6.8-3.3-6.8-7.7 0-4.7 4.2-8.6 10-8.6 4.3 0 7.8 1.6 10.2 4.1l-3.1 4.1c-2-2.1-4.3-3.3-7.1-3.3-2.6 0-4.4 1.4-4.4 3.3 0 1.7 1.1 2.5 3.1 3.1l4.6 1.5zM130.425 37.726c1-1.6 3.1-3 5.8-3 5.1 0 9.1 4.1 9.1 9.9 0 5.8-4 9.9-9.1 9.9-2.7 0-4.8-1.5-5.7-3h-.1v10h-5.3v-26.4h5.3v2.6zm4.8 12.1c3 0 4.9-2.5 4.9-5.2 0-2.8-2-5.2-4.9-5.2-3 0-4.9 2.5-4.9 5.2s1.9 5.2 4.9 5.2zM155.125 42.726l4.4-.4c0-1.9-1.3-3.1-4-3.1-2 0-4.1.9-5.5 1.9l-1.8-3.9c1.7-1.2 4.9-2.6 8.2-2.6 5.3 0 8.2 3.1 8.2 7.9v11.5h-5.1v-2.4h-.1c-.6 1.2-2.8 2.9-5.5 2.9-3.7 0-6.6-2.1-6.6-5.8.1-3.8 3.9-5.7 7.8-6zm4.5 3.1l-3.5.3c-2.3.2-3.7.8-3.7 2.4 0 1.3 1.3 2.1 2.9 2.1 2.4 0 4.4-1.5 4.4-4.2v-.6h-.1zM173.925 44.426v9.6h-5.3v-18.9h5.3v3.2h.1c.7-2 2.7-3.5 4.8-3.5.4 0 .9 0 1.3.1v5.4c-.6-.2-1.3-.4-2-.4-2.5.1-4.2 1.8-4.2 4.5zM188.525 44.326v9.7h-5.2v-28.7h5.2v18.1l7.4-8.3h6.1l-7.9 8.7 8.1 10.2h-6.3l-7.4-9.7zM221.725 43.726v-1.7h-4.9l4.6-4.9v-1.9h-7v1.7h4.4l-4.6 5v1.8h7.5zm-14.5 0v-4.7c0-.3 0-.6.1-.8.1-.3.2-.5.4-.7.2-.2.4-.4.6-.5.2-.1.5-.2.9-.2.3 0 .6.1.8.2.2.1.4.3.5.5.1.2.2.5.2.7 0 .3.1.5.1.8v4.8h2.1v-5.4c0-.4-.1-.9-.2-1.3s-.3-.8-.6-1.1c-.3-.3-.6-.6-1-.8-.4-.2-.9-.3-1.4-.3-.6 0-1.2.2-1.7.5s-.8.7-1 1.1v-1.4h-2v8.6h2.2zM63.81 41.967s.01-.01 0 0c.019-.01.01-.01 0 0zM3.63 41.55c-.039.066.009.066.047.085.038.019.104.029.123.038 1.253.36 2.58.74 3.814 1.091.038.01.076.038.124.028-1.367-.417-2.742-.815-4.109-1.242zm79.402 10.645c-3.634-.607-12.884-.598-18.558-.532-.313-.142-.617-.294-.92-.436-2.42-1.129-4.858-2.258-7.258-3.396.408-.37.806-.75 1.233-1.11.01 0 .01.009.019.009 3.577 1.328 9.165 3.254 12.827 4.497h.02c.255.057.806-.398 1.024-1.12.218-.72.123-1.423-.114-1.517 0 0-8.245-2.885-11.376-3.995 1.66-1.48 3.387-2.865 5.076-4.298 1.69-1.432 3.369-2.874 5.086-4.288.854-.702 1.708-1.414 2.58-2.106 1.737-1.395 3.473-2.78 5.304-4.061.455-.323.92-.645 1.404-.94.304-.19.617-.388.92-.54.2-.105.418-.171.617-.275.01 0 .01-.01.02-.01 0-.038-.048-.01-.03-.047.03-.02.067-.038.096-.067.019-.123.085-.341-.01-.436-.123-.029-.209.066-.313.076-.019-.029.01-.038.019-.057-.455.247-.92.484-1.385.702-.076.038-.2.076-.266.114-.028.019-.057.028-.095.047-.654.332-1.319.655-1.983.987-.616.313-1.233.617-1.84.94-.608.331-1.224.625-1.831.948-2.43 1.29-4.858 2.562-7.24 3.909.266-.209.522-.436.826-.607.303-.171.617-.332.92-.503 1.84-1.025 3.653-2.03 5.541-3.036 1.233-.655 2.476-1.3 3.748-1.964 1.072-.55 2.2-1.139 3.349-1.651.152-.066.36-.19.56-.161.019 0 .066.019.104.038.095.028.142.056.18.113.067.105.133.427.057.608-.038.076-.076.076-.133.113-.028.02-.038.038-.066.058-.047.028-.105.056-.152.094-.323.18-.617.351-.91.541-.589.38-1.177.778-1.746 1.167-.19.133-.38.275-.57.408a72.356 72.356 0 00-3.31 2.514c-.741.589-1.49 1.196-2.193 1.813-.151.132-.313.256-.465.389-1.584 1.337-3.15 2.694-4.705 4.032-1.044.901-2.078 1.812-3.131 2.704-.01.019-.01.019.01.01a396.136 396.136 0 017.59-6.253 459.283 459.283 0 00-6.14 5.247c-.009.028.03-.01.03-.01.246-.2.502-.427.768-.588-.778.806-1.642 1.556-2.486 2.315a82.585 82.585 0 00-1.879 1.727c-.17.17-.38.341-.53.512-.02.019-.067.076-.039.085.237-.17.446-.37.674-.56 1.1-.958 2.2-1.907 3.311-2.855l2.666-2.268c.446-.38.901-.75 1.347-1.12.01-.009.02-.028.038-.037.048-.038.086-.076.124-.105.844-.711 1.688-1.404 2.533-2.096 1.338-1.11 2.742-2.211 4.117-3.283.703-.541 1.405-1.063 2.116-1.585.237-.17.475-.341.721-.512.75-.522 1.47-.968 2.287-1.414.284-.151.56-.284.711-.521.162-.247.276-.617.219-.978-.057-.332-.2-.588-.484-.74.142.114.256.266.332.456.076.17.142.417.104.683-.01.095-.057.199-.095.303-.085.2-.17.342-.332.465-.076.057-.152.133-.237.171-.17.095-.351.18-.531.275-.532.266-1.034.588-1.518.883-.342.208-.655.436-.996.616a16.107 16.107 0 012.324-1.632c.2-.113.417-.237.626-.36.209-.123.38-.294.465-.512a1.057 1.057 0 00-.028-.816.999.999 0 00-.503-.484c.332-.162.654-.342.968-.532.227-.142.464-.284.635-.465.067-.066.142-.123.19-.19.104-.132.17-.284.247-.445.076-.152.132-.351.142-.541.019-.209-.047-.389-.114-.57a1.355 1.355 0 00-.247-.445 1.481 1.481 0 00-.844-.531 1.649 1.649 0 00-.617-.057c-1.83.227-3.358.787-4.867 1.318.294-.066.693-.246 1.006-.313-1.025.37-2.06.797-3.027 1.215-.588.246-1.1.616-1.622.93.474-.399.93-.797 1.366-1.234.427-.436.816-.92 1.186-1.414.17-.227.36-.474.54-.75.181-.265.342-.55.409-.891.038-.18.057-.436.019-.588-.038-.152-.152-.285-.256-.399-.095-.104-.228-.199-.361-.294-.133-.085-.285-.19-.455-.199-.086 0-.18.028-.276.047-.483.076-.806.294-1.12.503-.132.095-.255.19-.379.275-1.034.75-1.945 1.537-2.884 2.344-1.413 1.214-2.79 2.438-4.184 3.653a754.532 754.532 0 00-4.004 3.51c-.057.047-.123.095-.18.152-1.87 1.622-3.72 3.273-5.579 4.886-1.404 1.215-2.79 2.457-4.174 3.672 1.015-.968 2.011-1.964 3.026-2.932.256-.237.503-.484.76-.721.255-.237.493-.503.749-.74.265-.237.503-.493.759-.73.256-.238.512-.484.759-.731 1.983-1.983 3.985-3.966 5.968-5.949 2.485-2.486 4.98-4.953 7.419-7.476.37-.38.73-.769 1.082-1.148a2.79 2.79 0 00.332-.418c.199-.303.303-.645.303-1.015 0-.114 0-.228-.01-.341-.018-.247-.18-.484-.36-.655a1.014 1.014 0 00-.152-.133 1.014 1.014 0 00-.53-.209c-.229-.038-.437 0-.665.057-.398.105-.674.285-1.015.475 0 0-.39.246-.56.38.123-.134.313-.285.474-.418 0-.02-.01-.029-.019-.038 0 0 0-.01.01-.01.36-.38.446-.91.161-1.224-.294-.332-.882-.294-1.31.095-.066.067-.17.171-.246.266-.673.711-1.252 1.366-1.945 2.059-.19.19-.36.389-.569.569l-1.831 1.603c-.408.36-.816.712-1.224 1.073-.408.36-.816.711-1.224 1.062-.607.531-1.205 1.082-1.812 1.613-.2.17-.408.342-.598.531.493-.37 1.006-.73 1.509-1.09-.892.777-1.794 1.555-2.704 2.333-.911.778-1.794 1.575-2.695 2.353-1.774 1.528-3.53 3.103-5.275 4.659a.23.23 0 01-.095.057c-.01-1.196-.047-3.473-.057-3.587 0-.161-.322-.294-.711-.294-.114 0-.219.01-.314.029.038-1.756.076-3.51.124-5.257v-.01c-.01-.379-.465-.692-1.044-.692-.028 0-.057 0-.085.01-.029 0-.057.01-.086.01-.056.009-.104.009-.16.018-.048.01-.096.02-.153.038-.047.01-.094.038-.133.057-.047.02-.085.048-.123.067a.423.423 0 00-.104.075c-.029.029-.057.057-.086.095a.254.254 0 00-.056.095c-.02.038-.029.076-.038.114-.01.038-.01.076-.02.123V24.301c0 .019 0 .048.01.066v.076c0 .029 0 .048.01.076v.161c0 .029 0 .058.01.086v.095l.009.095c0 .028 0 .066.009.095v.104c0 .038 0 .066.01.104v.105c0 .038 0 .075.009.113v.114l.01.114c0 .038 0 .076.009.114v.123c0 .038 0 .076.01.124 0 .038 0 .085.009.123v.123c0 .038.01.086.01.124v.133c0 .038.009.085.009.132 0 .048.01.086.01.133 0 .048.009.086.009.133l.01.133c0 .047.009.095.009.133l.01.133c0 .038.009.085.009.132l.01.133c0 .048.009.095.009.142 0 .048.01.095.01.143l.009.142c0 .048.01.095.01.143 0 .047 0 .094.009.142 0 .047.01.095.01.142 0 .047 0 .095.009.142 0 .048 0 .095.01.143 0 .047.009.095.009.142 0 .047 0 .095.01.142 0 .048.009.095.009.143.01.047.01.095.01.142 0 .047.009.095.009.142.01.048.01.095.01.143 0 .047.009.095.009.142 0 .047.01.095.01.142l.009.143c0 .047 0 .094.01.142 0 .047.009.095.009.142 0 .048.01.095.01.142 0 .048.009.095.009.133 0 .048.01.086.01.133 0 .048 0 .095.009.133 0 .038 0 .085.009.133 0 .047 0 .085.01.133 0 .038 0 .085.009.133 0 .047.01.085.01.132 0 .038 0 .086.009.124 0 .038 0 .085.01.123 0 .038 0 .085.009.123 0 .038 0 .086.01.124v.123c0 .038.009.076.009.123v.238c0 .038.01.075.01.113 0 .038.009.076.009.114v.105c-.114-.247-.237-.484-.342-.712-.038-.085-.104-.209-.104-.294-.038-.484-.038-.968-.066-1.452a1301.8 1301.8 0 01-.086-1.46c-.057-.969-.114-1.936-.161-2.913-.133-2.686-.323-5.333-.418-8.027 0-.124-.019-.247-.019-.36 0-.114.029-.238.038-.352.294-2.694.892-8.121.892-8.254.029-1.072-.522-1.954-1.233-1.983-.721-.028-1.328.825-1.376 1.888-.01.218.237 4.004.332 5.958.01.152.038.304.029.456-.02.294-.086.579-.114.863a96.817 96.817 0 00-.712-4.355c-.265-1.404-.54-2.799-.854-4.184a7.352 7.352 0 00-.816-2.097c-.37-.626-.93-1.252-1.679-1.404a1.975 1.975 0 00-1.565.37c-.532.323-.911 1.006-1.025 1.566-.142.72.019 1.49.123 2.21.256 1.727.39 3.463.627 5.19.132.968.237 1.945.36 2.913-.237-.474-.465-.968-.693-1.442-1.565-3.425-3.169-6.831-4.734-10.247-.038-.028-.019-.019-.028-.019l-.01.01c.674 1.518 1.404 3.064 2.059 4.63-.769-1.49-1.47-3.046-2.21-4.564-.466.228-.883.389-1.348.617.038-.01-.019.01.019 0 1.916 4.43 3.89 8.833 5.788 13.264.588 1.385 1.195 2.78 1.783 4.174.038.095.095.17.105.275-1.518-3.273-3.036-6.556-4.564-9.82 0-.009-.01-.009-.01 0a510.98 510.98 0 013.274 7.363c.028.076.066.152.095.237-1.414-2.979-2.837-5.94-4.25-8.918-.02-.048-.03-.057-.039-.076-.114.038-.18.095-.275.114-.901-2.173-2.638-6.348-2.723-6.528-.436-.949-1.319-1.499-2.04-1.224-.787.294-.93 1.272-.797 1.983.105.56.332 1.072.541 1.604.209.55.418 1.1.636 1.65.047.133.104.295.17.446.048.133.086.342.171.456-.417-.532-.939-.807-1.356-.645-.522.208-.693 1.043-.437 1.944-.389-.512-.882-.777-1.271-.626-.541.219-.664 1.148-.285 2.097.01.029.029.057.038.085.047.095.085.162.114.238.389 1.005.787 2.002 1.176 3.007-.313-.521-.597-1.081-.91-1.613a1.663 1.663 0 00-.228-.284.685.685 0 00-.76-.114.67.67 0 00-.398.617c0 .151.057.284.095.408.048.123.105.237.152.35.588 1.462 1.195 2.819 1.803 4.27a570.67 570.67 0 003.662 8.482c.768 1.765 1.556 3.53 2.334 5.266.057.114.114.227.142.341-.901-1.926-1.793-3.861-2.704-5.787 1.13 2.59 2.24 5.237 3.387 7.799.038.076.076.151.095.237-.17-.038-.322-.095-.484-.152-.16-.057-.322-.095-.474-.161a646.104 646.104 0 01-3.653-1.822c-.844-.446-11.214-4.886-11.632-5.038-.047-.019-.094-.047-.142-.066-1.233-.55-1.594.692-1.47 1.006a52.392 52.392 0 00-1.3-.475c-.437-.152-1.32-.474-1.32-.474-.208-.076-.502.19-.654.588-.085.228-.104.455-.066.617a16.524 16.524 0 01-1.566-.437c-.275-.095-.55-.199-.844-.284a8.934 8.934 0 00-.901-.228c-.323-.066-.684-.123-1.016-.085-.35.037-.73.151-.967.426-.257.295-.294.693-.2 1.054.095.36.276.664.484.967.067.095.133.18.209.266.076.085.152.161.228.237.095.086.19.18.294.266.104.095.218.18.341.256.124.085.257.161.38.237.152.086.294.171.446.247.161.085.332.17.503.237.19.085.38.152.569.228.218.076.427.152.645.218.057.019.104.038.161.047a15.4 15.4 0 01-.702-.123c-.161.57-.408 1.404-.408 1.433l.01.01s9.924 4.23 14.943 6.299c-2.922-.949-5.91-1.84-8.852-2.78-.987-.313-1.974-.617-2.96-.92-1.955-.598-4.042-1.148-6.3-1.452-.588-.085-1.186-.123-1.774-.161-.294-.019-.579-.067-.873-.095-.294-.038-.579-.076-.864-.104-.142-.02-.284-.029-.417-.067l-.37-.114c-.598-.199-1.243-.407-1.84-.588a2.33 2.33 0 00-.323-.085.072.072 0 00-.048-.02c-.389-.075-.797.304-.901.855-.104.54.114 1.034.503 1.129.028.01.057.01.066.019.029.01.057.01.086.01.901.113 1.783.227 2.666.331.218.029.417.114.626.171.617.19 1.252.37 1.84.57-.123.265-.18.569-.275.863-.066.218-.132.436-.199.645l-.038.133c.674.18 1.338.389 2.002.588 4.706 1.404 9.412 2.79 14.108 4.203-.133.408-.256.816-.389 1.224-1.451-.494-2.903-1.015-4.364-1.5-.73-.246-1.452-.512-2.173-.749-1.499-.493-3.045-1.062-4.506-1.537-.01 0-.152-.057-.067-.019.076.038.18.067.275.095 1.281.456 2.515.883 3.786 1.347.626.228 1.262.446 1.86.693.075.038.17.057.237.114-.608-.142-1.205-.323-1.803-.503-1.176-.36-2.343-.74-3.52-1.091-.598-.18-1.167-.389-1.736-.579-.645-.218-1.29-.446-1.936-.664-.303-.114-.939-.332-1.632-.57-1.024-.36-2.068-.71-3.074-1.071-.066-.029-.132-.067-.199-.095-.322-.095-.683.19-.806.636-.133.436.019.863.322.967.048.02.114.029.114.029.095.019.162.038.256.066 2.43.655 4.849 1.366 7.24 2.04.256.076.502.142.749.228 1.205.417 2.429.863 3.615 1.28-.607-.151-1.196-.303-1.803-.464-.01 0-.01.01.01.01.778.217 1.546.417 2.305.635.37.104.721.256 1.082.38.37.132.73.246 1.09.379 1.462.512 2.914.996 4.365 1.508a339 339 0 004.364 1.509c1.462.484 2.904 1.006 4.374 1.499-3.614 3.283-7.248 6.537-10.474 10.19a41.527 41.527 0 00-1.755 2.115c-.067.086-.114.18-.19.247-.152.133-.323.247-.484.38 0 0-.797.588-.94.797-.142.208.067.645.485.939.417.294.882.36 1.043.142 0 0 0-.01.01-.01s.01-.009.01-.018c.198-.408.445-.75.692-1.11.066-.095.114-.19.2-.266.075-.066.16-.142.255-.209.171-.133.342-.275.513-.408 4.705-3.766 9.392-7.542 14.07-11.337.076-.067.228-.2.275-.2.038 0 .104.038.152.057.161.057.313.114.474.152-1.1 1.233-2.239 2.429-3.34 3.653-.275.303-.56.607-.834.91-.56.617-1.11 1.234-1.66 1.841-.276.304-.551.617-.798.959.076 0 .152-.124.21-.143-1.984 2.125-6.111 6.224-6.102 6.234.124.114.19.19.304.303-.968.902-1.926 1.803-2.894 2.695.095.085.18.19.276.284a64.01 64.01 0 01-1.348 1.148c-.209.18-.047.721.37 1.215.351.417.76.654 1.006.617.01 0 .01.009.019.009-.636.645-1.47 1.376-2.116 2.04-.076.076-.275.266-.294.294-.228.247-.341.94-.2 1.31.03.075.096.265.2.35-.55.475-1.063.883-1.622 1.357-.057.047-.105.104-.124.114-.142.19-.085.512.171.854.275.36.664.531.863.38l.02-.02a.757.757 0 00.142.541c.17.266.436.408.616.351.038-.01.048-.019.067-.028.038-.02.057-.048.085-.086 1.831-1.451 3.653-2.922 5.475-4.374.616-.493 1.233-.996 1.86-1.48-.589.816-1.13 1.632-1.7 2.42-.056.076-.113.133-.18.199-.246.247-.502.493-.758.75-.503.502-1.025.977-1.528 1.47-.417.418-.863.835-1.28 1.252-.086.086-.238.228-.238.228-.408.446-.398 1.139.01 1.5.01.009.019.009.028.018a.13.13 0 00.038.029c.019.019.047.028.066.047.02.01.048.029.067.038.019.01.047.02.066.029.029.009.048.019.076.028.029.01.048.019.076.019.029.01.057.01.076.019.028 0 .057.01.076.01h.085c.029 0 .057 0 .086-.01.028-.01.057-.01.085-.019.028 0 .057-.01.085-.019l.086-.028.085-.029c.029-.01.048-.028.076-.038.029-.01.048-.028.076-.038l.076-.047c.028-.02.047-.038.076-.057.019-.02.047-.038.066-.067.029-.028.057-.047.086-.075.01-.01.01-.02.019-.02a.075.075 0 01.038-.037.074.074 0 01.038-.038c.009-.02.018-.038.037-.048.01-.019.029-.038.038-.057.02-.019.029-.038.048-.057.019-.019.028-.038.047-.066a.29.29 0 00.048-.067c.019-.028.038-.047.057-.075l.056-.086c.02-.028.048-.057.067-.085.019-.029.047-.057.066-.095a.658.658 0 01.076-.095l.076-.104c.029-.038.048-.067.076-.105.029-.038.057-.076.076-.114l.085-.113c.029-.038.057-.086.086-.124.028-.038.057-.076.085-.123.029-.038.057-.085.085-.123.029-.038.057-.086.095-.124.029-.038.057-.085.095-.123l.095-.123c.029-.048.067-.086.095-.133.028-.038.066-.086.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.037.066-.085.094-.132.029-.038.067-.086.095-.133a.608.608 0 01.095-.124c.029-.037.057-.085.095-.123.028-.038.057-.085.085-.123.029-.038.057-.086.086-.124l.085-.113c.029-.038.057-.076.076-.114l.086-.114c.028-.038.047-.076.075-.114a.423.423 0 01.076-.104c.029-.038.048-.076.076-.105l.076-.104c.2-.285.39-.579.636-.806.247-.228.484-.475.72-.712.722-.721 1.472-1.414 2.192-2.135.722-.72 1.471-1.423 2.192-2.135.237-.237.494-.464.73-.711.485-.474.988-.94 1.462-1.414.246-.237.493-.465.73-.702.484-.484.978-.949 1.462-1.414.74-.702 1.451-1.432 2.2-2.115.124-.114.247-.237.361-.351.36-.36.74-.702 1.1-1.063.238-.237.475-.484.722-.712.123-.113.265-.208.398-.322.797-.645 1.594-1.3 2.382-1.945.93-.76 1.869-1.509 2.79-2.258-6.51 6.708-13.018 13.434-19.47 20.2-.028.028-.047.056-.085.085-.01.019-.029.028-.038.047.019-.01.029-.028.047-.038a581.15 581.15 0 005.437-5.38c1.129-1.129 2.248-2.267 3.358-3.387.674-.673 1.338-1.366 2.012-2.04.901-.9 1.774-1.83 2.675-2.732 1.803-1.803 3.568-3.643 5.37-5.446l2.581-2.58a.81.81 0 01.133-.105c.047.142.142.237.18.37.038.123.048.275.076.408.066.332.123.674.18 1.006.342 2.96.826 7.21.873 7.552.162 1.148.332 2.305.494 3.454.38 2.628 2.239 13.13 2.58 13.852.162.35.484.702.892.74.408.037.883-.38.93-.788.066-.531-.142-1.053-.142-1.584v-3.957c0-.408 0-.816-.01-1.224-.019-.73-.057-1.47-.114-2.2-.114-1.48-.341-2.923-.531-4.394a90.661 90.661 0 01-.266-3.055c2.325 4.545 6.964 13.653 6.964 13.653.105.152.494.142.902-.028.436-.18.711-.484.635-.664v-.01c-1.85-4.601-3.69-9.212-5.578-13.785a350.654 350.654 0 013.68 4.933c.077.114.162.2.228.313.076.114.105.237.162.38.73 1.783 1.546 3.53 2.343 5.19-.977-1.699-1.84-3.52-2.647-5.399 0-.01-.01-.01-.01.01.504 1.27.987 2.542 1.538 3.776.54 1.223 1.167 2.4 1.85 3.481.322.522.673 1.063 1.081 1.576.285.35.645.711.987 1.015.332.284.94.55 1.509.398.332-.085.569-.285.768-.56.19-.265.304-.616.285-1.024a3.667 3.667 0 00-.247-1.091c.37-.162.75-.342 1.1-.513.048-.019.115-.038.152-.076-.73-1.556-1.499-3.093-2.22-4.658-.72-1.556-1.499-3.093-2.22-4.658-.73-1.566-1.49-3.103-2.22-4.659-.74-1.547-1.527-3.074-2.249-4.62.285.104.598.18.873.294 3.274 6.764 6.566 13.52 9.934 20.199.01.019.028.019.01 0-3.112-6.68-6.272-13.368-9.384-20.02 3.52 1.158 7.059 2.297 10.607 3.435.02 0 .02-.01 0-.01-1.783-.654-3.586-1.26-5.38-1.897a449.786 449.786 0 00-5.398-1.888c0-.01-.01-.01-.019-.019-.18-.427-.408-.853-.578-1.252 1.584.512 3.216 1.025 4.81 1.518.228.066.455.152.683.218 2.325.702 4.64 1.423 6.992 2.06.465.122.92.293 1.376.435.911.285 1.822.598 2.723.892.901.304 1.803.608 2.685.93.664.247 1.338.474 1.983.75l.465.265c.038.01.085.02.133.01.474-.02 1.1-.854 1.442-1.983.38-1.233.275-2.438-.218-2.58 0 0-.285-.048-.304-.058.114-.54.057-.967-.256-1.062-.028-.01-7.571-2.43-11.243-3.587-.531-.17-1.063-.332-1.603-.503-2.088-.654-4.166-1.309-6.262-1.954.227 0 .455-.01.692-.01.408.133 3.321 1.063 4.222 1.348 1.509.474 2.97.92 4.45 1.395 1.414.455 4.279 1.385 4.298 1.385 0 0 .047.019.095-.01.114-.057.247-.218.313-.427.066-.237.057-.465 0-.569 0 0-.019-.047-.076-.066-.038-.01-.066-.02-.095-.029-.408-.142-.806-.284-1.205-.427-1.404-.474-2.799-.94-4.184-1.423-.92-.323-1.85-.636-2.78-.949-.332-.104-.664-.227-.986-.341 9.108-.313 18.87-1.025 15.123-1.651zM22.605 46.92c-.541-.124-1.063-.323-1.566-.484.143.01.275.076.418.114.275.085.56.17.854.246.133.038.284.067.398.124-.019.038-.066.01-.104 0zm23.7-19.555c.029-.218.047-.455.066-.673.038-.323.086-.626.114-.92.133.806.228 1.641.37 2.447.038.228.086.522.095.807-.19-.399-.389-.825-.588-1.243-.029-.066-.076-.133-.076-.18-.019-.076.01-.152.02-.238zm-.256 2.06c.019-.162.057-.4.076-.55.266.54.54 1.11.806 1.669.038.085.095.152.114.228.02.085.01.19.02.284.018.266.028.55.047.845-.323-.683-.674-1.433-1.016-2.145-.057-.123-.066-.16-.047-.332zm-.36-8.559c-.048.475-.114.987-.162 1.462-.076.702-.152 1.394-.218 2.058.161-1.214.303-2.447.474-3.643.057.228.01.522-.019.788-.114 1.347-.275 2.742-.408 4.08-.066-.134-.133-.257-.199-.4a.886.886 0 01-.057-.141c-.01-.086.02-.2.038-.304.18-1.518.37-3.121.55-4.592.076.2.02.455 0 .692zm-2.676 2.268c-.038-.332-.085-.645-.123-.977.645 1.31 1.261 2.637 1.907 3.947-.029.218-.057.436-.076.664-.58-1.205-1.13-2.42-1.708-3.634zm1.575 4.659a4.136 4.136 0 00-.048.36c-.398-.873-.759-1.755-1.157-2.647-.029-.057-.067-.114-.086-.17-.037-.134-.018-.285-.056-.409.464.949.891 1.917 1.347 2.866zm-2.192-4.725c.17.341.323.702.484 1.043.01.105.028.19.028.304-.17-.37-.332-.76-.502-1.12.01-.095-.02-.152-.01-.227zm.209-1.518c.028.303.066.588.095.882-.18-.36-.342-.75-.522-1.11-.028-.294-.066-.579-.095-.863.18.36.342.74.522 1.09zm-.712-2.59c-.028-.285-.066-.55-.095-.835.2.398.37.816.56 1.223.029.228.048.446.076.684-.18-.352-.351-.721-.54-1.073zm.693.9c.398.883.806 1.756 1.167 2.676-.029.029-.029-.019-.038-.028-.095-.123-.17-.294-.247-.446a81.71 81.71 0 01-.673-1.3c-.048-.085-.114-.17-.133-.256-.029-.085-.029-.209-.038-.313 0-.114-.029-.218-.038-.332zm2.144 8.265c.095.16.161.341.247.502 0 .152-.038.276-.048.418-.085-.17-.151-.351-.237-.522.01-.142.038-.256.038-.398zm.2-.902c-.02-.038-.058-.085-.067-.123-.01-.076.028-.228.038-.323.019-.123.028-.246.047-.341.095.161.162.341.257.503-.029.227-.067.436-.086.673-.076-.114-.133-.256-.19-.389zM33.98 5.402c-.018-.038-.037-.114-.066-.162-.019-.047-.057-.095.029-.114.028-.01.038.038.047.057.076.171.152.36.228.541.588 1.433 1.205 2.922 1.802 4.374-.683-1.547-1.356-3.14-2.04-4.696zm2.183 2.789c-.247-.55-.503-1.12-.769-1.708-.199-.436-.446-1.006-.673-1.49 0-.028-.029-.075-.038-.113-.038-.105-.048-.076.038-.105.057.048.066.133.095.2.702 1.527 1.432 3.083 2.153 4.62.996 2.135 2.002 4.26 3.008 6.414.209.446.436.93.664 1.404.028.066.085.133.095.19.019.057.01.132.019.199.019.18.057.389.076.579-1.585-3.359-3.112-6.774-4.668-10.19zm4.857 2.135c.038.095.048.227.067.35-.01-.255-.057-.521-.086-.777a152.393 152.393 0 01-.341-3.15c-.038-.351-.02-.76.18-1.063.161-.247.493-.493.797-.484.55.02 1.006.712 1.177 1.158.114.265.227.56.313.844.085.285.151.57.246.864.36 1.186.646 2.41.902 3.652.256 1.243.503 2.553.711 3.852.19 1.158.36 2.258.55 3.435.02.17.067.341.067.503 0 .104-.029.218-.038.332-.19 1.603-.417 3.33-.607 4.924-.73-1.556-1.5-3.207-2.249-4.8-.047-.105-.114-.22-.142-.314-.047-.152-.047-.341-.076-.522-.161-1.224-.313-2.429-.474-3.662-.2-1.452-.37-2.856-.56-4.317.01.332.066.664.104.996.275 2.325.522 4.678.788 7.03-.162-.331-.332-.683-.494-1.034-.019-.047-.057-.104-.066-.142-.019-.066-.019-.161-.029-.247-.132-1.176-.246-2.419-.37-3.586-.132-1.3-.275-2.571-.37-3.842zm-3.387 9.43c.076.133.171.39.228.522 1.271 3.065 2.533 6.13 3.824 9.194.17.398.341.825.512 1.243.028.057.057.114.076.17.028.124.019.228.038.37-1.566-3.842-3.103-7.6-4.64-11.394a.594.594 0 00-.038-.086c-.01-.019-.038-.075 0-.019zm2.107 30.408c.142-.142.284-.313.436-.455.114.038.237.066.342.104.028.01-.029.057-.048.067-.161.17-.36.37-.54.531a2.415 2.415 0 00-.314-.104c0-.048.076-.095.124-.143zm-.323-.009c-.019.019-.038.057-.066.057-.038-.02.028-.048.047-.067.152-.16.332-.35.484-.502-.123.133-.304.35-.465.512zm-1.803-30.456c-.028.01-.038-.085-.057-.113-.01 0-.01-.01-.01-.02.03.039.039.096.067.134zm-.085-.18c.01.01.01.02.019.029 0 .019-.019-.02-.019-.029zm0-.019c-.01.02-.019-.01-.019-.028.01.01.01.019.019.028zm-.048-.104c0 .019-.019-.02-.019-.029.01 0 .02.02.02.029zm-.028-.076c.01.01.01.019.019.028-.01.02-.028-.018-.019-.028zm0-.019c-.01.019-.019-.019-.019-.028 0 .009.01.018.02.028zm-.047-.104c0 .019-.02-.01-.02-.029.01.01.01.02.02.029zm.019.038c0 .019-.02-.02-.02-.029.01.01.01.02.02.029zm.996 9.05c.522 1.092.92 2.25 1.395 3.388-.257-.531-.55-1.053-.797-1.594-.247-.56-.465-1.129-.703-1.689-.474-1.12-.939-2.258-1.404-3.377.522 1.081.996 2.182 1.509 3.273zm-1.272.997c.285.57.522 1.167.778 1.755.257.588.513 1.167.76 1.765-.94-1.566-1.86-3.188-2.761-4.81-.152-.275-.304-.541-.456-.816-.152-.275-.275-.57-.398-.864a465.694 465.694 0 01-2.942-7.153c0-.038.048.047.057.066.541 1.082 1.082 2.182 1.632 3.264.57 1.129 1.1 2.267 1.66 3.387.57 1.139 1.11 2.277 1.67 3.406zM31.59 6.037c.342.826.674 1.68 1.016 2.505.047.123.085.247.161.351-.322-.987-.683-1.945-1.043-2.903l.047-.02c.94 2.098 1.85 4.223 2.76 6.348-.142.057-.293.114-.426.19-.351-.807-.683-1.594-1.025-2.4-.114-.266-.218-.541-.322-.817-.219-.54-.465-1.043-.702-1.574-.228-.503-.437-1.035-.484-1.68h.019zm-.37.133l.03-.01c.834 2.002 1.697 4.014 2.551 6.025.029.067.095.2.124.304 0-.01.028.047.028.047 0 .038-.01.029-.038.038-.038.02-.047 0-.066-.047a2.17 2.17 0 01-.114-.313c-.816-2.03-1.68-4.033-2.514-6.044zm-1.574 12.22c.047.038.057.104.095.152.208.38.436.768.616 1.195.2.484.408.978.588 1.48-.455-.92-.863-1.887-1.3-2.827zm.806 1.5c0-.039.01 0 .02 0 .54 1.014 1.09 2.049 1.64 3.064.095.17.2.332.276.512 1.755 4.222 3.52 8.501 5.427 12.59.151.332.322.655.474 1.006 0 .01.047.038.01.047-.038-.019-.095-.038-.143-.056-2.656-5.636-5.209-11.376-7.704-17.164zm1.404 19.013c.294.113.589.246.883.389 1.698.797 3.453 1.584 5.18 2.381l-1.48.958a8.503 8.503 0 01-.513-.246c-.588-.295-1.223-.56-1.84-.826-.418-.17-.825-.36-1.243-.54-1.224-.541-2.467-1.12-3.596-1.746-.303.047-.588-.029-.835-.114-.72-.247-1.385-.617-2.03-.959a1.436 1.436 0 01-.161-.094 79.947 79.947 0 00-1.803-.93c-.228-.114-.446-.228-.693-.313 0-.01 0-.01.01-.01 2.467.503 4.867 1.072 7.201 1.718.304.085.607.218.92.332zm5.598 5.275c-.218-.057-.427-.162-.645-.247l-.512-.2c.038-.018.066-.037.104-.047.37.152.721.314 1.053.494zm-11.528-9.46c.076.01.162.057.247.095.086.038.18.057.247.095.047.029.104.086.152.124.142.123.313.265.455.38-.484-.19-.987-.447-1.49-.655.133-.01.257-.057.39-.038zm-4.544-.635c.408.19.825.389 1.233.57 1.234.54 2.448 1.147 3.7 1.697-2.04-.427-4.136-.806-6.233-1.205-.142-.028-.294-.038-.408-.085-.057-.019-.114-.066-.17-.104l4.345.341s-2.306-1.09-4.962-2.182c.199.066.398.123.588.18.237.067.474.105.683.21.417.189.806.388 1.224.578zm-4.753-3.52c1.12.398 2.239.787 3.32 1.167a6.502 6.502 0 01-.465-.114c-.455-.123-.92-.266-1.366-.398.038-.02-.01 0 .048 0-.18-.048-.247-.076-.427-.105-.18-.028-.37-.038-.541-.095-.142-.038-.285-.133-.437-.199-.076-.038-.151-.057-.227-.085-.209-.095-.408-.2-.646-.304-.16-.066-.341-.114-.445-.228.417.038.854.247 1.186.36zm7.03 8.15c.36.209.768.427 1.139.636-.76-.314-1.519-.646-2.278-.978a649.908 649.908 0 00-6.888-2.922c.152 0 .294.038.446.067h.01l1.584.341c.266.133.56.275.854.36.218.067.475.086.721.086.228 0 .465.01.645.076l1.765 1.195.19.086 3.833 1.613 4.222 1.935c-2.125-.863-4.28-1.708-6.395-2.59.057.028.104.066.152.095zm2.619 6.926c.151.019.303.076.455.123.446.133.92.275 1.376.408-.02.02-.029.01-.048 0-.303-.066-.607-.161-.91-.247-.314-.075-.598-.19-.873-.284zm.958.332c2.353.683 4.706 1.347 7.05 2.03.028.01-.02.038-.02.048-.095.095-.237.199-.341.294-2.23-.788-4.47-1.556-6.69-2.372-.009.01-.009 0 0 0zm2.372 3.397c.816.218 1.613.455 2.429.664a.406.406 0 01-.133.123c-.74-.266-1.556-.522-2.296-.788zm4.004 1.982c-2.77 2.23-5.532 4.46-8.293 6.699-.019.01-.019.01-.01-.01.912-.882 1.803-1.783 2.752-2.637.152-.143.294-.304.456-.446.152-.143.313-.285.455-.437.579-.616 1.205-1.195 1.803-1.793.446-.446.92-.873 1.375-1.319.152-.151.304-.294.475-.427l1.005.342c.02 0-.018.019-.018.028zm.521-.436c-.35-.123-.702-.247-1.062-.36.01-.067.123-.114.161-.18.398.104.778.217 1.176.322-.094.076-.17.161-.275.218zm-.74-5.74c-3.121-.987-6.271-1.955-9.355-2.96 4.156 1.271 8.35 2.514 12.467 3.823-.047.067-.095.076-.17.057-.19-.047-.399-.123-.589-.18-.787-.237-1.584-.493-2.353-.74zm1.651 3.558c0-.048.048-.076.086-.105.094-.085.199-.18.294-.275 0-.01.019-.01.019-.019.474.124.93.266 1.394.399-.17.142-.35.285-.521.427-.427-.133-.845-.294-1.272-.427zm.598 2.704c.114-.105.228-.2.351-.294l.484.142c-.095.114-.19.228-.294.323-.18-.048-.36-.124-.541-.171zM19.37 76.626c.844-.721 1.717-1.452 2.57-2.183 2.913-2.495 5.807-5.047 8.71-7.561-.218.35-.474.692-.72 1.043-.039.048-.067.114-.096.152-.047.057-.142.114-.208.171-1.016.835-2.06 1.727-3.065 2.571.162-.095.313-.209.465-.313-.636.56-1.28 1.1-1.954 1.632-2.002 1.594-4.033 3.188-6.035 4.782.076-.105.21-.19.332-.294zm1.3-.73c-.864.72-1.746 1.48-2.61 2.21-.028.019-.047.047-.076.066 0-.047-.01-.095-.019-.152.029-.038.057-.066.086-.094.066-.058.133-.086.209-.124.056-.038.113-.095.17-.142.864-.693 1.774-1.404 2.628-2.106-.113.123-.256.227-.389.341zm.436-.37c-.067.047.019-.01 0 0zm5.711-4.28c-.702.607-1.442 1.205-2.172 1.812-.968.797-1.945 1.604-2.932 2.382.104-.114.228-.2.351-.294.37-.295.74-.589 1.091-.892.474-.408.949-.816 1.423-1.234.475-.408.93-.844 1.423-1.224.494-.389.987-.778 1.5-1.148-.19.219-.447.399-.684.598zm-.066-.123a.585.585 0 01.133-.133c.332-.294.673-.607 1.043-.892.36-.284.721-.57 1.073-.854-.01.086-.105.124-.18.19-.674.54-1.395 1.129-2.07 1.689zm1.964.531c.133-.209.285-.408.436-.626.048-.067.095-.152.143-.209.057-.057.123-.095.19-.142.417-.332.853-.693 1.261-1.034-.635.673-1.357 1.338-2.03 2.011zm1.508-11.973c-.056.047-.16.17-.18.17-.01 0 .086-.094.105-.113.256-.276.53-.55.768-.816.142-.162.313-.294.446-.456.57-.617 1.186-1.214 1.774-1.84.721-.769 1.49-1.537 2.22-2.296.152-.152.304-.304.446-.465.142-.152.294-.304.446-.465.218-.237.437-.456.664-.683.076-.076.133-.171.228-.219.028.02.066.029.104.038-.408.484-.854.94-1.271 1.423.465-.455.91-.939 1.385-1.385.105.038.209.076.323.105-.456.503-.949.958-1.414 1.46l-.104.105c-.029.038-.048.086-.076.114-.057.057-.133.114-.19.17-1.898 1.728-3.785 3.416-5.674 5.153zm8.16-10.418c-.123.152-.304.313-.446.465-.057-.01-.095-.028-.142-.047.19-.171.398-.323.597-.494.01 0 .01.01.02.01.028.019-.02.047-.03.066zm.076 2.619c0 .038-.038.066-.067.095-.085.095-.199.19-.294.284a1.531 1.531 0 01-.313-.114c-.038-.01.02-.028.02-.038.084-.094.208-.227.303-.322.133.019.227.076.35.095zm-.589-.171c.029.01.067.019.095.028a4.174 4.174 0 01-.332.37c-.038-.009-.057-.028-.095-.028-.009-.038.048-.066.076-.095.086-.076.171-.19.257-.275zm-3.235 12.315c-.085.104-.199.18-.303.275-.313.266-.646.54-.959.816.057-.104.143-.209.219-.313.028-.038.047-.085.066-.114a1.14 1.14 0 01.247-.17c.237-.162.502-.323.73-.494zm3.786-2.495c-1.917 1.499-3.843 3.045-5.76 4.554.143-.2.266-.39.456-.55.626-.541 1.272-1.101 1.898-1.66.227-.2.455-.409.702-.58 1.034-.683 2.059-1.385 3.074-2.077a2.921 2.921 0 01-.37.313zm.664-14.611c-.522-.152-1.044-.304-1.547-.465-.037-.01.038-.057.057-.076.522.152 1.035.323 1.556.474-.019.038-.047.048-.066.067zm.047-3.283c-.019 0-.104-.038-.17-.057a26.486 26.486 0 01-1.31-.455c.484-.219.977-.437 1.386-.636.132.285.275.579.408.863-.029.067-.086.095-.143.152-.047.047-.114.133-.17.133zM39.19 59.7c-.01-.02.02-.029.029-.038.161-.143.332-.285.503-.427a39.532 39.532 0 011.537-1.224 3.52 3.52 0 01-.342.313c1.262-1.053 2.562-2.163 3.843-3.245.18.066.36.123.54.18-2.02 1.49-4.08 2.951-6.11 4.44zm7.116-5.352c-.17.171-.36.38-.55.541-.19-.057-.36-.123-.541-.18.218-.2.455-.389.674-.579.16.038.313.095.483.133.01.038-.047.057-.066.086zm-.37-22.988c-.028-.066-.076-.152-.076-.2-.01-.075.02-.16.029-.246l.028-.266c.437.911.854 1.84 1.29 2.752.02.322.038.645.057.968-.446-.987-.882-1.993-1.328-3.008zm4.82 28.72l.028.976c-.512-.986-1.015-1.992-1.527-2.979.066.067.133.152.19.237.426.58.882 1.177 1.309 1.765zm-1.452-4.896c.057.17.123.313.18.483a7.45 7.45 0 01-.407-.55c.075.019.142.047.227.067zM48.27 32.82c.152.294.285.607.446.901.01.105.01.209.019.313-.152-.322-.294-.664-.456-.986.01-.095-.009-.152-.009-.228zm.218 2.002c-.038-.086-.104-.17-.123-.266-.02-.085-.01-.218-.02-.332-.018-.266-.028-.57-.047-.863.086.17.228.474.333.683.047.085.104.18.113.275.02.123.01.313.02.465 0 .047.018.114.009.142-.02.076-.105.114-.17.162a2.77 2.77 0 00-.115-.266zm.143 22.42c.047.028.075.085.113.123.029.047.086.085.105.142.019.047.038.114.057.161.057.143.133.313.18.465-.161-.285-.294-.598-.455-.892zm1.29 5.995c-.114-.227-.37-.91-.674-1.764-.066-.313-.114-.626-.17-.94.521.959 1.034 2.069 1.574 3.075.076.142.162.294.219.446v.018c.028.133.019.314.019.465 0 .2.01.399.019.598a89.041 89.041 0 01-.987-1.897zm12.77 12.866c.162.218.332.455.494.683.446.598.901 1.186 1.338 1.803.218.303.445.616.578.986-.01.038-.066-.047-.095-.076a15.839 15.839 0 01-1.318-1.622c-.437-.626-.797-1.31-1.177-1.973.076.056.123.123.18.199zM56.6 51.986c.758.2 1.517.399 2.276.588l-.095.086c-.73-.228-1.46-.456-2.182-.674zm1.157 3.662c-.313-.085-.627-.18-.94-.265-.123-.257-.256-.494-.38-.75.324.104.646.2.978.285.114.246.228.484.342.73zm.114-4.857c0 .01.037.019 0 .019a147.73 147.73 0 00-2.192-.693c-.076-.123-.123-.275-.2-.398.105.018.2.085.304.123.683.313 1.395.636 2.088.949zm-1.5-3.729c-.199.18-.398.36-.607.531-.55-.246-1.081-.512-1.632-.759-.17-.389-.36-.778-.54-1.157.095-.114.208-.19.313-.285 1.034.37 2.03.769 3.064 1.13-.19.189-.398.36-.598.54zm-1.375 2.827c-.228-.076-.446-.152-.674-.218.104-.123.228-.228.351-.332.038 0 .048.019.086.029.066.17.16.341.237.521zm-.883-.816c-.066.076-.151.152-.237.228-.028.02-.047.057-.085.057-.066-.18-.152-.341-.218-.512.199.066.36.161.54.227zm3.805-3.377c-1.044-.36-2.087-.702-3.13-1.063-.039-.01.028-.047.047-.066.038-.029.066-.067.104-.095 1.034.37 2.05.75 3.083 1.11 0 .038-.075.076-.104.114zm3.89 1.043c2.173.76 6.338 2.202 8.548 2.932l.219.086c.066.019.16.028.19.094-.058.057-.21.048-.295.02a.381.381 0 01-.152-.096c-2.21-.768-6.356-2.22-8.51-3.036-.019.01-.019 0 0 0zm7.818 2.989c.085.029.17.047.246.076.228.085.475.18.712.266.047.019.114.028.142.075-.863-.303-3.69-1.261-4.554-1.565-2.561-.901-5.133-1.803-7.723-2.704.029-.038.067-.066.095-.095 3.036 1.091 8.055 2.846 11.082 3.947zm6.897-19.526c-.16.152-.36.266-.55.418-1.3.977-2.58 2.002-3.852 3.007-2.903 2.315-5.73 4.735-8.539 7.164-1.357 1.176-2.713 2.353-4.08 3.53-.038.037-.075.075-.132.084-1.034-.35-2.06-.72-3.103-1.072-.028-.028.029-.057.038-.066.142-.142.332-.285.484-.427.54-.484 1.11-.977 1.66-1.461.37-.323.75-.655 1.11-.977.19-.162.36-.342.55-.494.95-.778 1.917-1.565 2.885-2.334.19-.151.427-.265.655-.398 4.155-2.439 8.529-4.697 12.874-6.974zm1.537-2.106c-1.442.797-2.94 1.528-4.402 2.296-.209.105-.408.228-.617.332-1.242.655-2.504 1.319-3.728 2.012.066-.076.151-.114.227-.171 1.234-.845 2.581-1.613 3.947-2.344.36-.199.75-.37 1.12-.56.37-.19.759-.36 1.138-.53.76-.361 1.537-.703 2.306-1.044.047 0 .01 0 .01.01zm2.904-4.8c.123-.03.246-.058.37-.077.256-.038.512-.047.768.01.057.01.105.028.161.038.057.01.124.01.171.028.095.029.209.124.285.2.18.16.313.332.446.53a.942.942 0 01.152.361c.028.152 0 .352-.029.494-.161.854-.892 1.233-1.537 1.613l-.161.104c-.057.028-.142.066-.171.085-.095.057-.237.133-.266.152-.076-.019-.16-.066-.265-.038.095-.047.322-.151.427-.199a9.567 9.567 0 001.556-1.063c.19-.18.332-.502.332-.872 0-.399-.237-.703-.456-.93-.076-.076-.151-.171-.237-.218a1.444 1.444 0 00-.398-.152c-.38-.086-.835-.01-1.205.066-.73.142-1.433.342-2.107.55-.93.285-1.812.608-2.647.902a30.098 30.098 0 014.81-1.585zm-7.325 4.715l.218-.171c-.019-.029-.066-.085-.142-.18.55-.351 1.1-.702 1.717-.978.617-.275 1.29-.483 1.964-.72.987-.361 1.993-.684 3.065-.968.246-.067.484-.143.75-.19.113-.02.237-.038.36-.038.028.01 0 .028-.01.038-.227.17-.531.322-.806.465-.588.313-1.186.607-1.812.892-.313.142-.645.256-.968.389-.323.132-.645.256-.968.389-.939.398-2.656 1.224-2.799 1.309-.692.341-1.366.711-2.02 1.081.227-.237.53-.483.844-.749.17-.17.389-.38.607-.57zM54.332 40.05c.246-.219.512-.446.711-.627a294.06 294.06 0 012.894-2.476c.247-.209.493-.408.73-.617.712-.626 1.405-1.28 2.107-1.916 1.888-1.708 3.738-3.387 5.645-5.085.949-.845 1.898-1.699 2.837-2.534 1.423-1.233 2.846-2.523 4.336-3.719.512-.408 1.034-.816 1.584-1.148-.806 1.385-1.973 2.467-3.207 3.473-.246.199-.474.417-.711.626-.902.778-1.784 1.546-2.695 2.315-.028.028-.066.047-.095.076-.493.427-1.024.863-1.527 1.3-.958.825-1.945 1.622-2.894 2.447-.949.835-1.897 1.66-2.856 2.486l-1.432 1.233-2.856 2.486c-1.423 1.243-2.913 2.42-4.355 3.653-.057-.028-.275-.057-.323-.104-.028-.038-.028-.01 0-.038a.71.71 0 01.133-.114c.664-.57 1.329-1.148 1.974-1.717zm-.959 6.423c-.16-.067-.303-.143-.465-.209.076-.085.171-.142.247-.228.01 0 .02 0 .02.01.056.142.132.275.198.427zm.959-8.634c-.702.702-1.376 1.404-2.088 2.116-.01.01-.047.038-.066.066-.028.029-.028.057-.066.038-.02-.01-.038-.066-.029-.095 0 .01.067-.057.076-.066 1.47-1.414 2.922-2.875 4.383-4.289-.702.702-1.46 1.49-2.21 2.23zm-3.046-3.359c0-.095-.019-.208 0-.294.01-.057.123-.123.2-.19.199-.18.407-.38.607-.54.825-.721 1.64-1.443 2.447-2.164.276-.237.56-.474.826-.711.142-.123.275-.237.408-.36.673-.589 1.366-1.196 2.04-1.784-1.063 1.148-2.163 2.296-3.255 3.453-.816.864-1.631 1.727-2.438 2.61-.266.284-.531.578-.816.844 0-.256-.019-.58-.019-.864zm.066 3.862c.01-.076.21-.237.304-.332.721-.74 1.423-1.528 2.125-2.268.304-.322.598-.654.902-.986.493-.532 1.015-1.082 1.508-1.613.702-.769 1.423-1.509 2.125-2.268.095-.114.21-.209.304-.323.797-.873 1.68-1.67 2.514-2.504.418-.418.854-.816 1.281-1.243 1.253-1.253 2.552-2.467 3.843-3.69l.654-.599c.655-.588 1.3-1.205 1.983-1.783.456-.39.911-.769 1.367-1.148.464-.38.93-.76 1.404-1.12.01-.01.019 0 .01 0-2.458 2.6-5 5.123-7.506 7.685-.626.645-1.252 1.271-1.888 1.907-.104.105-.218.2-.322.304-.057.057-.095.123-.142.17l-9.014 9.014c-.322.313-.645.626-.958.94-.076.075-.152.16-.237.236-.029.02-.048.057-.086.048-.047-.143-.152-.237-.161-.418v-.01h-.01zm.636 17.875l.74 1.062c-.237-.085-.474-.161-.711-.246-.02-.266-.02-.541-.029-.816zm3.9 14.829c-.01.038-.038-.057-.057-.085-.294-.55-.589-1.139-.873-1.699-.304-.607-.617-1.214-.92-1.812-.608-1.214-1.243-2.42-1.85-3.615-.01-.626-.038-1.243-.048-1.878a491.542 491.542 0 013.748 9.089zm1.556-4.526c-.408-.522-.797-1.072-1.186-1.613-1.148-1.584-2.306-3.15-3.463-4.734-.095-.133-.171-.351-.247-.522-.142-.35-.285-.692-.427-1.053-.028-.066-.076-.152-.085-.209-.02-.142 0-.303-.01-.455-.01-.152-.01-.304-.019-.446.37.123.73.247 1.1.36l3.264 4.725c.38 1.329.703 2.647 1.073 3.947.01.01.01.01.019.01 0 .01-.02 0-.02-.01zM57.13 56c-.018-.019-.018-.047-.037-.066 0-.01.01 0 .01 0 .236.066.502.133.758.2.067.018.18.037.19.132-.313-.085-.607-.18-.92-.266zm4.944 16.433c-.845-1.082-1.718-2.182-2.572-3.292-.056-.076-.142-.152-.18-.218-.047-.086-.066-.21-.104-.304-.38-.977-.73-1.973-1.072-2.998l3.928 6.812zM59.72 59.7c-.285-.076-.598-.2-.883-.294-.199-.408-.408-.816-.607-1.234.304.095.588.2.883.275.199.418.389.845.607 1.253zm22.21 2.334c.067-.067.133-.067.19-.067.038.133.038.351.01.513-.02.151-.067.341-.18.379-.086.029-.247-.029-.39-.066-1.84-.465-3.68-.987-5.484-1.49-1.47-.398-2.912-.806-4.373-1.205-3.88-1.063-7.752-2.163-11.632-3.254-.37-.105-.788-.209-1.177-.332-.01-.01-.028-.01-.047-.02-.105-.047-.228-.018-.247-.151.01 0 .01 0 .01.01.483.123.958.265 1.432.388 1.433.37 2.875.769 4.327 1.158 1.926.512 3.87 1.006 5.806 1.499 1.936.493 3.862 1.006 5.788 1.518.474.133.939.275 1.413.408.721.2 1.442.38 2.182.56.247.057.494.114.722.19.464.151.91.313 1.366.455.057-.047.095-.114.085-.18-.01-.105-.133-.143-.246-.171.151.028.303-.029.445-.142zm-.55.104c.02.01.038.019.067.028h.019c-.029-.01-.058-.01-.086-.019v-.01zm-2.998-.91c.17.047.275.084.398.122.845.266 1.708.522 2.562.788a2.4 2.4 0 01-.446-.066c-.095-.029-.199-.076-.294-.114a41.71 41.71 0 00-2.097-.683c.18.066.37.132.55.199-.18-.029-.36-.086-.54-.142-1.234-.37-2.496-.76-3.729-1.158-1.413-.455-2.837-.873-4.25-1.338 2.637.788 5.237 1.585 7.846 2.391zm-14.62-4.422c.18.057.37.123.55.19.901.322 1.85.635 2.77.93 3.017.948 6.044 1.859 9.023 2.827-5.93-1.623-11.84-3.273-17.742-4.934-.057-.038-.057-.114-.085-.17-.086-.171-.18-.352-.257-.541.769.227 1.537.446 2.296.683 1.158.341 2.296.664 3.444 1.015zm2.646-3.824a.763.763 0 00-.151-.398c4.25-.123 11.48-.304 12.931-.162 1.509.143-7.675.418-12.78.56z",
    fill: "#fff"
  })));
}

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function SvgVerticalLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 88 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.81 41.965c.009-.01.018-.01 0 0zm-60.178-.417c-.038.066.01.066.047.085.038.02.105.028.124.038 1.252.36 2.58.74 3.813 1.091.038.01.076.038.124.029-1.366-.418-2.742-.816-4.108-1.243zM83.03 52.192c-3.633-.607-12.883-.597-18.557-.53-.313-.143-.617-.295-.92-.437-2.42-1.13-4.857-2.258-7.258-3.397.408-.37.807-.75 1.234-1.11.01 0 .01.01.019.01 3.576 1.328 9.164 3.254 12.826 4.497h.02c.255.057.806-.399 1.024-1.12.218-.72.123-1.423-.114-1.518 0 0-8.244-2.884-11.375-3.994 1.66-1.48 3.387-2.865 5.075-4.298 1.69-1.432 3.368-2.874 5.086-4.288.853-.702 1.707-1.413 2.58-2.106 1.736-1.395 3.472-2.78 5.303-4.06a24.1 24.1 0 011.405-.94c.303-.19.616-.389.92-.54.2-.105.417-.171.617-.276.009 0 .009-.01.018-.01 0-.037-.047-.009-.028-.047.028-.018.067-.037.095-.066.019-.123.085-.341-.01-.436-.123-.029-.208.066-.313.076-.019-.029.01-.038.02-.057-.456.246-.92.483-1.386.702-.076.038-.199.076-.265.113-.029.02-.057.029-.095.048-.655.332-1.319.654-1.983.987-.617.313-1.234.616-1.84.939-.608.332-1.225.626-1.832.948-2.428 1.29-4.857 2.562-7.238 3.91.265-.21.521-.437.825-.608.304-.17.617-.332.92-.503 1.84-1.024 3.653-2.03 5.54-3.036 1.234-.654 2.477-1.3 3.748-1.964 1.072-.55 2.201-1.138 3.35-1.65.151-.067.36-.19.559-.162.019 0 .066.02.104.038.095.029.143.057.18.114.067.105.133.427.057.607-.037.076-.075.076-.132.114-.029.02-.038.038-.067.057-.047.029-.104.057-.152.095-.322.18-.616.351-.91.54-.588.38-1.177.779-1.746 1.168-.19.133-.38.275-.57.408a72.222 72.222 0 00-3.31 2.514c-.74.588-1.49 1.195-2.192 1.812-.152.133-.313.256-.465.389-1.584 1.338-3.15 2.694-4.705 4.032-1.044.901-2.078 1.812-3.131 2.704-.01.019-.01.019.01.01a395.352 395.352 0 017.59-6.253 459.244 459.244 0 00-6.14 5.247c-.009.028.03-.01.03-.01.246-.2.502-.427.768-.588-.778.806-1.641 1.556-2.486 2.315a82.789 82.789 0 00-1.878 1.727c-.171.17-.38.341-.531.512-.02.019-.067.076-.038.085.237-.17.445-.37.673-.56 1.1-.958 2.201-1.906 3.311-2.855l2.666-2.268c.446-.38.901-.75 1.347-1.12.01-.009.02-.028.038-.037.048-.038.086-.076.124-.105.844-.711 1.688-1.404 2.533-2.096 1.337-1.11 2.741-2.21 4.117-3.283.702-.54 1.404-1.062 2.116-1.584.237-.17.474-.342.72-.512.75-.522 1.471-.968 2.287-1.414.285-.152.56-.285.712-.522.161-.246.275-.616.218-.977-.057-.332-.2-.588-.484-.74.142.114.256.266.332.455.076.171.142.418.104.683-.009.095-.056.2-.094.304-.086.2-.171.342-.332.465-.076.057-.152.133-.238.17-.17.096-.35.181-.531.276-.531.265-1.034.588-1.518.882-.341.209-.654.437-.996.617a16.099 16.099 0 012.324-1.632c.2-.114.418-.237.626-.36.21-.124.38-.295.465-.513a1.057 1.057 0 00-.028-.816.999.999 0 00-.503-.483c.332-.162.655-.342.968-.532.227-.142.465-.284.635-.465.067-.066.143-.123.19-.19.105-.132.17-.284.247-.445.076-.152.133-.351.142-.541.02-.209-.047-.39-.114-.57a1.354 1.354 0 00-.246-.445 1.481 1.481 0 00-.845-.532 1.648 1.648 0 00-.616-.056c-1.831.227-3.359.787-4.867 1.318.294-.066.692-.246 1.005-.313-1.024.37-2.058.797-3.026 1.215-.588.246-1.1.616-1.623.93.475-.4.93-.798 1.367-1.234.427-.436.816-.92 1.186-1.414.17-.227.36-.474.54-.75.18-.265.342-.55.408-.89.038-.181.057-.437.02-.59-.039-.15-.153-.284-.257-.398-.095-.104-.228-.199-.36-.294-.133-.085-.285-.19-.456-.199-.085 0-.18.029-.275.047-.484.076-.806.295-1.12.503-.132.095-.255.19-.379.275-1.034.75-1.945 1.537-2.884 2.344-1.414 1.214-2.79 2.438-4.184 3.652a749.954 749.954 0 00-4.003 3.51c-.057.048-.124.096-.18.152-1.87 1.623-3.72 3.274-5.58 4.886-1.403 1.215-2.788 2.458-4.174 3.672 1.016-.968 2.012-1.964 3.027-2.932.256-.237.503-.483.759-.72.256-.238.493-.504.75-.74.265-.238.502-.494.758-.731s.513-.484.76-.73c1.982-1.983 3.984-3.966 5.967-5.95 2.485-2.485 4.98-4.951 7.419-7.475.37-.38.73-.768 1.081-1.148.124-.133.237-.266.332-.418.2-.303.304-.645.304-1.015 0-.113 0-.227-.01-.341-.019-.247-.18-.484-.36-.655a1.01 1.01 0 00-.152-.133 1.016 1.016 0 00-.531-.208c-.228-.038-.437 0-.664.057-.399.104-.674.284-1.015.474 0 0-.39.247-.56.38.123-.133.313-.285.474-.418 0-.019-.01-.028-.019-.038 0 0 0-.01.01-.01.36-.379.446-.91.161-1.223-.294-.332-.882-.294-1.31.095-.066.066-.17.17-.246.265-.674.712-1.252 1.366-1.945 2.059-.19.19-.36.389-.569.57l-1.831 1.603c-.408.36-.816.711-1.224 1.072-.408.36-.816.711-1.224 1.062-.607.532-1.205 1.082-1.812 1.613-.199.17-.408.342-.598.531.494-.37 1.006-.73 1.509-1.09-.892.777-1.793 1.555-2.704 2.333-.91.778-1.793 1.575-2.694 2.353-1.774 1.527-3.53 3.102-5.275 4.658a.23.23 0 01-.095.057c-.01-1.195-.047-3.472-.057-3.586 0-.161-.322-.294-.711-.294-.114 0-.219.01-.314.028.038-1.755.076-3.51.124-5.256v-.01c-.01-.379-.465-.692-1.044-.692-.028 0-.057 0-.085.01-.029 0-.057.01-.086.01-.056.009-.104.009-.16.018-.048.01-.096.02-.153.038-.047.01-.094.038-.132.057-.048.02-.086.048-.124.067a.418.418 0 00-.104.076.843.843 0 00-.085.094.251.251 0 00-.057.095c-.02.038-.029.076-.038.114-.01.038-.01.076-.02.123V24.3c0 .019 0 .047.01.066v.076c0 .029 0 .048.01.076v.161c0 .029 0 .057.01.086v.095l.009.095c0 .028 0 .066.01.095v.104c0 .038 0 .066.009.104v.105c0 .038 0 .075.009.113v.114l.01.114c0 .038 0 .076.009.114v.123c0 .038 0 .076.01.124 0 .037 0 .085.009.123v.123c0 .038.01.086.01.124v.132c0 .038.009.086.009.133 0 .048.01.086.01.133 0 .048.009.085.009.133l.01.133c0 .047.009.095.009.133l.01.132c0 .038.009.086.009.133l.01.133c0 .047.009.095.009.142 0 .048.01.095.01.143l.009.142c0 .047.01.095.01.142 0 .048 0 .095.009.142 0 .048.01.095.01.143 0 .047 0 .095.009.142 0 .048 0 .095.01.142 0 .048.009.095.009.143 0 .047 0 .095.01.142 0 .047.009.095.009.142.01.048.01.095.01.143 0 .047.009.095.009.142.01.047.01.095.01.142 0 .048.009.095.009.143 0 .047.01.095.01.142l.009.142c0 .048 0 .095.01.143 0 .047.009.094.009.142 0 .047.01.095.01.142 0 .048.009.095.009.133 0 .047.01.085.01.133 0 .047 0 .095.009.133 0 .038 0 .085.01.132 0 .048 0 .086.009.133 0 .038 0 .086.009.133 0 .047.01.085.01.133 0 .038 0 .085.009.123 0 .038 0 .086.01.123 0 .038 0 .086.009.124 0 .038 0 .085.01.123v.124c0 .037.009.075.009.123v.237c0 .038.01.076.01.114 0 .038.009.076.009.114v.105c-.114-.248-.237-.485-.342-.712-.038-.086-.104-.21-.104-.294-.038-.484-.038-.968-.066-1.452l-.086-1.461c-.057-.968-.114-1.936-.161-2.913-.133-2.684-.323-5.332-.418-8.026 0-.123-.018-.247-.018-.36 0-.114.028-.238.038-.351.294-2.695.891-8.121.891-8.254.029-1.072-.522-1.955-1.233-1.983-.721-.029-1.328.825-1.376 1.888-.01.218.237 4.004.332 5.958.01.152.038.303.029.455-.02.294-.086.579-.114.864a96.644 96.644 0 00-.712-4.355c-.265-1.404-.54-2.799-.853-4.184a7.351 7.351 0 00-.816-2.097c-.37-.626-.93-1.252-1.68-1.404a1.975 1.975 0 00-1.565.37c-.531.323-.91 1.006-1.024 1.566-.143.72.018 1.49.123 2.21.256 1.727.389 3.463.626 5.19.133.967.237 1.945.36 2.912-.237-.474-.464-.967-.692-1.442-1.566-3.425-3.169-6.83-4.734-10.246-.038-.028-.02-.019-.029-.019l-.01.01c.674 1.518 1.405 3.064 2.06 4.63-.769-1.49-1.471-3.046-2.211-4.564-.465.228-.882.389-1.347.617.038-.01-.02.01.019 0 1.916 4.43 3.89 8.832 5.787 13.263.588 1.385 1.195 2.78 1.784 4.174.038.095.094.17.104.275-1.518-3.273-3.036-6.555-4.563-9.819 0-.01-.01-.01-.01 0a509.834 509.834 0 013.273 7.362c.029.076.067.152.095.237-1.413-2.979-2.837-5.939-4.25-8.918-.02-.047-.029-.057-.038-.076-.114.038-.18.095-.275.114-.901-2.172-2.638-6.347-2.723-6.527-.437-.949-1.319-1.499-2.04-1.224-.787.294-.93 1.271-.797 1.983.105.56.332 1.072.541 1.603.209.55.418 1.1.636 1.651.047.133.104.294.17.446.048.133.086.341.171.455-.417-.53-.939-.806-1.357-.645-.521.209-.692 1.044-.436 1.945-.389-.512-.882-.778-1.271-.626-.54.218-.664 1.148-.285 2.097.01.028.029.057.038.085.048.095.086.161.114.237.389 1.006.787 2.002 1.176 3.008-.313-.522-.597-1.082-.91-1.613a1.667 1.667 0 00-.228-.285.685.685 0 00-.759-.114.67.67 0 00-.399.617c0 .152.058.285.095.408.048.123.105.237.152.351.588 1.461 1.196 2.818 1.803 4.27a570.003 570.003 0 003.662 8.48c.768 1.765 1.556 3.53 2.334 5.266.057.114.113.228.142.342-.901-1.926-1.793-3.861-2.704-5.787 1.13 2.59 2.24 5.237 3.387 7.798.038.076.076.152.095.237-.17-.038-.323-.095-.484-.152-.161-.056-.323-.094-.474-.16a642.773 642.773 0 01-3.653-1.822c-.844-.446-11.214-4.886-11.631-5.038-.048-.02-.095-.048-.143-.067-1.233-.55-1.593.693-1.47 1.006a52.79 52.79 0 00-1.3-.474c-.436-.152-1.318-.475-1.318-.475-.21-.076-.503.19-.655.589-.085.227-.104.455-.066.616a16.53 16.53 0 01-1.566-.436c-.275-.095-.55-.2-.844-.285a8.928 8.928 0 00-.902-.227c-.322-.067-.683-.124-1.015-.086-.35.038-.73.152-.967.427-.256.294-.294.693-.2 1.053.095.36.276.664.484.968.067.095.133.18.209.265.076.086.152.162.228.238.095.085.19.18.294.265.104.095.218.18.341.257.124.085.256.16.38.237.152.085.294.17.446.246.161.086.332.171.502.238.19.085.38.151.57.227.218.076.427.152.645.218.057.02.104.038.161.048-.237-.038-.474-.076-.702-.123-.161.569-.408 1.404-.408 1.432l.01.01s9.923 4.23 14.942 6.3c-2.922-.95-5.91-1.841-8.851-2.78-.987-.314-1.974-.617-2.96-.92-1.955-.599-4.042-1.149-6.3-1.453-.588-.085-1.186-.123-1.774-.16-.294-.02-.579-.067-.873-.096-.294-.038-.579-.075-.863-.104-.143-.019-.285-.028-.418-.066l-.37-.114c-.597-.2-1.243-.408-1.84-.588a2.315 2.315 0 00-.323-.086.072.072 0 00-.047-.019c-.39-.076-.797.304-.902.854-.104.54.114 1.034.503 1.129.029.01.057.01.067.019.028.01.057.01.085.01.901.113 1.784.227 2.666.332.218.028.417.113.626.17.617.19 1.252.37 1.84.57-.123.265-.18.569-.274.863-.067.218-.133.436-.2.645l-.038.133c.674.18 1.338.389 2.002.588 4.706 1.404 9.411 2.79 14.108 4.203-.133.408-.257.816-.39 1.224-1.45-.494-2.902-1.015-4.363-1.5-.731-.246-1.452-.512-2.173-.749-1.499-.493-3.045-1.062-4.506-1.537-.01 0-.152-.057-.067-.019.076.038.18.067.275.095 1.281.456 2.514.883 3.786 1.347.626.228 1.261.446 1.86.693.075.038.17.057.236.114-.607-.143-1.205-.323-1.802-.503-1.177-.36-2.344-.74-3.52-1.091-.598-.18-1.167-.389-1.736-.579-.645-.218-1.29-.446-1.936-.664a83.18 83.18 0 00-1.631-.57c-1.025-.36-2.069-.71-3.074-1.071-.067-.029-.133-.067-.2-.095-.322-.095-.683.19-.806.636-.133.436.02.863.323.967.047.02.114.029.114.029.094.019.16.038.256.066 2.428.655 4.848 1.366 7.238 2.04.257.076.503.142.75.228 1.205.417 2.429.863 3.615 1.28-.608-.151-1.196-.303-1.803-.464-.01 0-.01.009.01.009.777.218 1.546.418 2.305.636.37.104.72.256 1.081.38.37.132.73.246 1.091.379 1.462.512 2.913.996 4.364 1.508 1.452.512 2.904 1.015 4.365 1.509 1.46.483 2.903 1.005 4.373 1.498-3.614 3.283-7.248 6.537-10.474 10.19a41.467 41.467 0 00-1.755 2.115c-.066.086-.114.18-.19.247-.151.133-.322.247-.483.38 0 0-.797.588-.94.797-.142.208.067.645.484.939.418.294.883.36 1.044.142 0 0 0-.01.01-.01.009 0 .009-.009.009-.018.2-.408.446-.75.692-1.11.067-.095.114-.19.2-.266.075-.066.16-.142.256-.209.17-.133.341-.275.512-.408 4.706-3.766 9.392-7.542 14.07-11.337.075-.066.227-.2.275-.2.038 0 .104.039.152.058.16.057.313.114.474.152-1.1 1.233-2.24 2.428-3.34 3.652-.275.304-.56.607-.835.91-.56.618-1.11 1.234-1.66 1.841-.275.304-.55.617-.797.959.076 0 .152-.124.21-.143-1.984 2.126-6.11 6.224-6.101 6.233.123.114.19.19.303.304-.967.901-1.925 1.803-2.893 2.694.095.086.18.19.275.285-.38.332-.769.664-1.167.996-.047.038-.18.152-.18.152-.209.18-.048.721.37 1.214.35.418.759.655 1.005.617.01 0 .01.01.02.01-.636.645-1.471 1.375-2.116 2.04-.076.075-.275.265-.294.293-.228.247-.342.94-.2 1.31.029.076.095.265.2.35-.55.475-1.063.883-1.623 1.357-.057.048-.104.105-.123.114-.142.19-.085.512.17.854.276.36.665.531.864.38l.019-.02a.757.757 0 00.142.541c.171.266.437.408.617.351.038-.01.048-.019.066-.028.038-.02.057-.048.086-.086 1.83-1.451 3.652-2.922 5.474-4.373.617-.493 1.233-.996 1.86-1.48-.589.816-1.13 1.632-1.699 2.419a1.796 1.796 0 01-.18.2c-.247.246-.503.493-.759.749-.503.503-1.025.977-1.527 1.47-.418.418-.864.835-1.281 1.253-.086.085-.237.227-.237.227-.408.446-.399 1.139.01 1.5.009.009.018.009.027.018.01.01.02.02.039.029.018.019.047.028.066.047.019.01.047.029.066.038.02.01.048.02.067.028.028.01.047.02.076.029.028.01.047.019.076.019.028.01.056.01.075.019.029 0 .057.01.076.01h.086c.028 0 .057 0 .085-.01.028-.01.057-.01.085-.019.029 0 .057-.01.086-.019l.085-.028.086-.029c.028-.01.047-.028.075-.038.029-.01.048-.028.076-.038.029-.019.048-.028.076-.047.029-.02.048-.038.076-.057.02-.02.048-.038.067-.067.028-.028.056-.047.085-.076.01-.009.01-.019.019-.019a.075.075 0 01.038-.037.074.074 0 01.038-.038c.01-.02.019-.038.038-.048.01-.019.028-.038.038-.057.019-.019.028-.038.047-.057.02-.019.029-.038.048-.066a.289.289 0 00.047-.066c.02-.029.038-.048.057-.076l.057-.086c.019-.028.047-.057.066-.085.02-.029.048-.057.067-.095a.663.663 0 01.076-.095l.075-.104c.029-.038.048-.067.076-.105a.782.782 0 00.076-.113l.086-.114c.028-.038.057-.086.085-.124.029-.038.057-.075.085-.123.029-.038.057-.085.086-.123.028-.038.057-.086.095-.124.028-.038.057-.085.095-.123.028-.038.066-.085.095-.123.028-.048.066-.086.094-.133.029-.038.067-.085.095-.133.029-.038.067-.085.095-.133.029-.038.067-.085.095-.133.028-.037.066-.085.095-.132.028-.038.066-.086.095-.133.028-.038.066-.086.095-.133a.609.609 0 01.095-.123c.028-.038.056-.086.094-.124.029-.038.057-.085.086-.123.028-.038.057-.085.085-.123l.085-.114a.79.79 0 00.076-.114l.086-.114c.028-.038.047-.076.076-.114a.42.42 0 01.076-.104c.028-.038.047-.076.076-.105.028-.037.047-.066.075-.104.2-.284.39-.579.636-.806.247-.228.484-.475.721-.712.721-.72 1.47-1.413 2.192-2.134.72-.721 1.47-1.424 2.191-2.135.237-.237.494-.465.73-.712.484-.474.987-.939 1.462-1.413.246-.237.493-.465.73-.702.484-.484.977-.949 1.461-1.414.74-.702 1.452-1.432 2.201-2.115.124-.114.247-.238.36-.352.361-.36.74-.701 1.101-1.062.238-.237.475-.484.721-.712.124-.113.266-.208.399-.322.797-.645 1.594-1.3 2.381-1.945.93-.759 1.869-1.508 2.79-2.258-6.509 6.708-13.017 13.434-19.468 20.198-.029.029-.048.057-.086.086-.01.019-.028.028-.038.047.02-.01.029-.028.048-.038a581.087 581.087 0 005.436-5.38c1.129-1.128 2.248-2.267 3.358-3.386.674-.674 1.338-1.366 2.012-2.04.9-.901 1.774-1.83 2.675-2.732 1.803-1.803 3.567-3.643 5.37-5.446l2.58-2.58a.815.815 0 01.133-.105c.047.143.142.238.18.37.038.124.048.276.076.408.067.332.124.674.18 1.006.342 2.96.826 7.21.873 7.552.162 1.148.332 2.305.494 3.453.38 2.628 2.239 13.13 2.58 13.851.161.352.484.703.892.74.408.038.882-.379.93-.787.066-.531-.143-1.053-.143-1.584v-3.957c0-.408 0-.815-.01-1.223-.018-.73-.056-1.47-.113-2.201-.114-1.48-.341-2.922-.531-4.393a90.656 90.656 0 01-.266-3.055c2.325 4.544 6.964 13.652 6.964 13.652.104.152.493.143.901-.028.436-.18.712-.484.636-.664v-.01c-1.85-4.601-3.69-9.212-5.579-13.785a351.195 351.195 0 013.681 4.934c.076.114.161.199.228.313.076.114.104.237.161.38.73 1.783 1.547 3.528 2.343 5.189-.977-1.698-1.84-3.52-2.646-5.398 0-.01-.01-.01-.01.009.503 1.271.987 2.542 1.537 3.776.54 1.224 1.167 2.4 1.85 3.482.323.522.674 1.062 1.082 1.575.284.35.645.711.986 1.015.332.284.94.55 1.509.398.332-.085.569-.284.768-.56.19-.265.304-.616.285-1.024a3.664 3.664 0 00-.247-1.091c.37-.162.75-.342 1.1-.513.048-.019.115-.037.153-.075-.731-1.556-1.5-3.093-2.22-4.659-.722-1.556-1.5-3.093-2.22-4.658-.731-1.565-1.49-3.102-2.22-4.658-.74-1.547-1.528-3.074-2.249-4.62.285.104.598.18.873.294 3.273 6.764 6.565 13.519 9.933 20.198.01.019.028.019.01 0-3.112-6.679-6.272-13.368-9.383-20.018 3.52 1.157 7.058 2.296 10.606 3.434.02 0 .02-.01 0-.01-1.783-.654-3.586-1.26-5.379-1.897-1.793-.635-3.586-1.27-5.398-1.888 0-.009-.01-.009-.02-.019-.18-.426-.407-.853-.578-1.252 1.584.512 3.216 1.025 4.81 1.518.228.066.456.152.683.218 2.325.702 4.64 1.423 6.992 2.06.465.122.92.293 1.376.435.91.285 1.821.598 2.723.892.901.304 1.802.607 2.685.93.664.247 1.337.474 1.982.75l.465.265c.038.01.086.02.133.01.475-.02 1.1-.854 1.442-1.983.38-1.233.275-2.438-.218-2.58 0 0-.285-.048-.304-.058.114-.54.057-.967-.256-1.062-.028-.01-7.57-2.429-11.242-3.586-.531-.171-1.063-.332-1.603-.503-2.088-.655-4.165-1.31-6.262-1.955.228 0 .455-.009.692-.009.408.133 3.321 1.063 4.222 1.347 1.509.474 2.97.92 4.45 1.395 1.413.455 4.279 1.385 4.298 1.385 0 0 .047.019.094-.01.114-.056.247-.218.314-.426.066-.238.056-.465 0-.57 0 0-.02-.047-.076-.066-.038-.01-.067-.02-.095-.029-.408-.142-.807-.284-1.205-.426-1.404-.475-2.799-.94-4.184-1.424-.92-.322-1.85-.635-2.78-.948-.332-.105-.664-.228-.986-.342 9.107-.313 18.87-1.025 15.122-1.65zm-60.424-5.275c-.54-.123-1.062-.322-1.565-.483.142.01.275.076.417.114.275.085.56.17.854.246.133.038.285.067.398.123-.018.038-.066.01-.104 0zm23.7-19.553c.028-.218.047-.455.066-.673.038-.323.085-.626.114-.92.132.806.227 1.64.37 2.447.037.228.085.522.094.807-.19-.399-.389-.826-.588-1.243-.028-.067-.076-.133-.076-.18-.019-.076.01-.152.02-.238zm-.257 2.06c.019-.162.057-.4.076-.551.266.54.54 1.11.806 1.67.038.085.095.151.114.227.02.086.01.19.02.285.018.265.028.55.047.844-.323-.683-.674-1.432-1.016-2.144-.056-.123-.066-.161-.047-.332zm-.36-8.558c-.048.474-.114.986-.162 1.46-.076.703-.151 1.395-.218 2.06.161-1.215.304-2.448.474-3.644.057.228.01.522-.019.788-.113 1.347-.275 2.741-.408 4.08-.066-.134-.132-.257-.199-.4a.886.886 0 01-.057-.142c-.01-.085.02-.199.038-.303.18-1.518.37-3.121.55-4.592.076.2.02.455 0 .693zm-2.676 2.267c-.038-.332-.085-.645-.123-.977.645 1.31 1.262 2.637 1.907 3.947-.029.218-.057.436-.076.664-.579-1.205-1.13-2.42-1.708-3.634zm1.575 4.658a4.17 4.17 0 00-.047.36c-.399-.872-.76-1.754-1.158-2.646-.028-.057-.066-.114-.085-.17-.038-.134-.02-.286-.057-.409.465.949.892 1.917 1.347 2.865zm-2.191-4.724c.17.341.322.702.483 1.043.01.105.029.19.029.304-.171-.37-.332-.76-.503-1.12.01-.095-.019-.152-.01-.227zm.208-1.518c.029.303.067.588.095.882-.18-.36-.342-.75-.522-1.11-.028-.294-.066-.579-.095-.863.18.36.342.74.522 1.09zm-.711-2.59c-.029-.285-.067-.55-.095-.835.199.398.37.816.56 1.224.028.227.047.446.075.683-.18-.351-.35-.721-.54-1.072zm.692.901c.399.882.807 1.755 1.167 2.675-.028.029-.028-.019-.038-.028-.095-.123-.17-.294-.247-.446a80.897 80.897 0 01-.673-1.3c-.047-.085-.114-.17-.133-.256-.028-.085-.028-.209-.038-.313 0-.114-.028-.218-.038-.332zm2.144 8.263c.095.162.162.342.247.503 0 .152-.038.275-.047.418-.086-.171-.152-.352-.238-.522.01-.142.038-.256.038-.399zm.2-.901c-.02-.038-.057-.085-.067-.123-.01-.076.029-.228.038-.323.02-.123.029-.247.047-.341.095.16.162.341.257.502-.029.228-.067.437-.086.674-.076-.114-.133-.256-.19-.389zM33.98 5.402c-.019-.038-.038-.114-.066-.162-.019-.047-.057-.095.028-.114.029-.01.038.038.048.057.076.171.152.36.227.541.589 1.433 1.205 2.922 1.803 4.374-.683-1.547-1.357-3.14-2.04-4.697zm2.182 2.789c-.246-.55-.502-1.12-.768-1.708-.2-.436-.446-1.006-.674-1.49 0-.028-.028-.075-.038-.113-.038-.105-.047-.076.038-.105.057.048.067.133.095.2.702 1.527 1.433 3.083 2.154 4.62.996 2.134 2.002 4.26 3.007 6.413.209.446.437.93.664 1.404.029.067.086.133.095.19.02.057.01.133.02.2.018.18.056.388.075.578-1.584-3.358-3.112-6.774-4.668-10.19zm4.858 2.134c.038.095.047.228.066.351-.01-.256-.057-.521-.085-.778a152.375 152.375 0 01-.342-3.15c-.038-.35-.019-.758.18-1.062.162-.247.494-.493.797-.484.55.02 1.006.712 1.177 1.158.114.265.228.56.313.844.085.285.152.57.247.863.36 1.186.645 2.41.901 3.653.256 1.243.503 2.552.712 3.852.19 1.157.36 2.258.55 3.434.019.17.066.342.066.503 0 .104-.028.218-.038.332-.19 1.603-.417 3.33-.607 4.924-.73-1.556-1.499-3.207-2.248-4.8-.048-.105-.114-.219-.143-.314-.047-.152-.047-.341-.076-.522-.16-1.223-.313-2.428-.474-3.662-.2-1.451-.37-2.855-.56-4.316.01.332.067.664.105.996.275 2.324.521 4.677.787 7.03-.161-.332-.332-.683-.493-1.034-.02-.048-.057-.105-.067-.143-.019-.066-.019-.16-.028-.246-.133-1.177-.247-2.42-.37-3.586-.133-1.3-.275-2.571-.37-3.843zm-3.387 9.43c.076.133.17.39.228.522 1.27 3.065 2.533 6.13 3.823 9.194.17.398.341.825.512 1.242.029.057.057.114.076.171.029.123.02.228.038.37-1.565-3.842-3.102-7.6-4.64-11.394a.594.594 0 00-.037-.085c-.01-.02-.038-.076 0-.02zm2.106 30.407c.142-.142.285-.313.436-.455.114.038.238.066.342.104.029.01-.028.057-.047.066-.162.171-.36.37-.541.532a2.417 2.417 0 00-.313-.105c0-.047.076-.095.123-.142zm-.323-.01c-.019.02-.037.057-.066.057-.038-.019.029-.047.047-.066.152-.161.333-.35.484-.503-.123.133-.303.351-.465.513zM37.615 19.7c-.029.01-.038-.086-.057-.114-.01 0-.01-.01-.01-.02.029.039.038.096.067.134zm-.085-.18c.009.009.009.018.018.028 0 .019-.018-.02-.018-.029zm0-.02c-.01.02-.02-.009-.02-.028.01.01.01.019.02.028zm-.048-.104c0 .02-.019-.019-.019-.028.01 0 .02.019.02.028zm-.028-.076c.01.01.01.02.019.029-.01.019-.029-.02-.02-.029zm0-.019c-.01.02-.02-.019-.02-.028 0 .01.01.019.02.028zm-.048-.104c0 .019-.019-.01-.019-.029.01.01.01.02.02.029zm.02.038c0 .019-.02-.02-.02-.029.01.01.01.02.02.029zm.995 9.05c.522 1.092.92 2.25 1.395 3.388-.256-.532-.55-1.054-.797-1.594-.247-.56-.465-1.13-.702-1.689-.474-1.12-.94-2.258-1.404-3.377.522 1.081.996 2.182 1.508 3.273zm-1.27.997c.284.569.52 1.167.777 1.755.256.588.512 1.167.759 1.764a167.55 167.55 0 01-2.76-4.81c-.153-.275-.304-.54-.456-.815a8.911 8.911 0 01-.399-.864c-.986-2.362-1.973-4.724-2.94-7.153 0-.038.047.047.056.066.541 1.082 1.082 2.182 1.632 3.264.57 1.129 1.1 2.267 1.66 3.387.57 1.138 1.11 2.277 1.67 3.406zM31.59 6.037c.341.825.673 1.68 1.015 2.505.047.123.085.246.161.35a70.042 70.042 0 00-1.044-2.902l.048-.02c.94 2.097 1.85 4.223 2.76 6.348-.142.057-.294.114-.426.19-.351-.807-.683-1.594-1.025-2.4-.114-.267-.218-.542-.322-.817-.219-.54-.465-1.043-.703-1.575-.227-.502-.436-1.034-.483-1.679h.019zm-.37.133l.028-.01c.835 2.002 1.698 4.014 2.552 6.025.029.066.095.199.123.303 0-.01.029.048.029.048 0 .038-.01.028-.038.038-.038.019-.047 0-.066-.048a2.165 2.165 0 01-.114-.313c-.816-2.03-1.68-4.032-2.514-6.043zm-1.575 12.22c.047.037.057.104.095.151.208.38.436.769.616 1.196.2.484.408.977.588 1.48-.455-.92-.863-1.888-1.3-2.828zm.806 1.498c0-.038.01 0 .02 0 .54 1.015 1.09 2.05 1.64 3.065.095.17.2.332.276.512 1.755 4.222 3.52 8.5 5.426 12.59.152.332.323.654.474 1.005 0 .01.048.038.01.048-.038-.02-.095-.038-.142-.057-2.657-5.636-5.209-11.375-7.704-17.163zm1.404 19.013c.294.114.588.246.883.389 1.698.797 3.453 1.584 5.18 2.381l-1.48.958a8.529 8.529 0 01-.513-.246c-.588-.294-1.224-.56-1.84-.826-.418-.17-.826-.36-1.243-.54-1.224-.541-2.467-1.12-3.596-1.746-.303.047-.588-.029-.835-.114-.72-.247-1.385-.617-2.03-.958a1.412 1.412 0 01-.161-.095 80.362 80.362 0 00-1.803-.93c-.227-.114-.446-.228-.692-.313 0-.01 0-.01.01-.01 2.466.503 4.866 1.073 7.2 1.718.303.085.607.218.92.332zm5.598 5.275c-.218-.057-.427-.162-.645-.247l-.513-.2c.038-.018.067-.037.105-.047.37.152.72.313 1.053.494zm-11.527-9.46c.076.01.161.058.246.096.086.038.18.057.247.095.047.028.104.085.152.123.142.123.313.266.455.38-.484-.19-.986-.446-1.49-.655.134-.01.257-.057.39-.038zm-4.545-.635c.408.19.826.39 1.234.57 1.233.54 2.447 1.147 3.7 1.698-2.04-.427-4.137-.807-6.233-1.205-.143-.029-.294-.038-.408-.085-.057-.02-.114-.067-.171-.105l4.345.342s-2.305-1.091-4.962-2.182c.2.066.399.123.588.18.238.066.475.104.683.209.418.19.807.389 1.224.578zm-4.753-3.52c1.12.399 2.24.788 3.32 1.167a6.524 6.524 0 01-.464-.113c-.456-.124-.92-.266-1.366-.399.038-.019-.01 0 .047 0-.18-.047-.247-.076-.427-.104-.18-.029-.37-.038-.54-.095-.143-.038-.285-.133-.437-.2-.076-.037-.152-.056-.228-.085-.208-.095-.408-.199-.645-.303-.161-.067-.341-.114-.446-.228.418.038.854.247 1.186.36zm7.03 8.15c.36.209.769.427 1.139.636-.76-.313-1.518-.645-2.277-.977a651.942 651.942 0 00-6.888-2.923c.152 0 .294.038.446.067h.01l1.584.341c.266.133.56.276.854.36.218.067.474.086.72.086.228 0 .466.01.646.076l1.764 1.196.19.085 3.833 1.613 4.222 1.935c-2.125-.863-4.279-1.708-6.395-2.59.057.029.105.067.152.095zm2.619 6.926c.152.019.303.076.455.123.446.133.92.275 1.376.408-.02.019-.029.01-.048 0-.303-.066-.607-.161-.91-.247-.314-.076-.598-.19-.873-.284zm.958.332c2.353.683 4.706 1.347 7.049 2.03.028.01-.019.038-.019.047-.095.095-.237.2-.342.294-2.23-.787-4.468-1.555-6.688-2.371-.01 0-.01.01 0 0zm2.372 3.396c.816.218 1.613.456 2.428.664a.406.406 0 01-.132.124c-.74-.266-1.556-.522-2.296-.788zm4.003 1.983c-2.77 2.23-5.53 4.459-8.291 6.698-.02.01-.02.01-.01-.01.91-.882 1.803-1.783 2.751-2.637.152-.142.294-.304.456-.446.152-.142.313-.285.455-.436.579-.617 1.205-1.196 1.803-1.793.446-.446.92-.873 1.375-1.32.152-.15.304-.293.475-.426.332.114.673.228 1.005.341.02 0-.019.02-.019.029zm.522-.436a34.557 34.557 0 00-1.062-.36c.01-.067.123-.115.16-.181.4.104.779.218 1.177.322-.095.076-.17.162-.275.219zm-.74-5.74c-3.121-.987-6.27-1.955-9.354-2.96 4.155 1.271 8.349 2.514 12.466 3.823-.047.067-.095.076-.17.057-.19-.047-.4-.123-.589-.18-.788-.237-1.584-.493-2.353-.74zm1.65 3.558c0-.048.048-.076.086-.105.095-.085.2-.18.294-.275 0-.01.02-.01.02-.019.474.123.93.266 1.394.398-.17.143-.351.285-.522.427-.427-.132-.844-.294-1.271-.426zm.599 2.703c.113-.104.227-.199.35-.294l.485.143c-.095.113-.19.227-.295.322-.18-.047-.36-.123-.54-.17zM19.37 76.622c.844-.721 1.717-1.452 2.571-2.182 2.913-2.495 5.806-5.047 8.71-7.561-.219.35-.475.692-.722 1.043-.038.048-.066.114-.095.152-.047.057-.142.114-.208.17-1.015.836-2.059 1.727-3.065 2.572.162-.095.313-.209.465-.313-.635.56-1.28 1.1-1.954 1.631-2.002 1.594-4.032 3.188-6.034 4.782.076-.104.209-.19.332-.294zm1.3-.73c-.863.72-1.746 1.48-2.61 2.21-.028.019-.047.047-.075.066 0-.047-.01-.095-.02-.152.03-.037.058-.066.086-.094.067-.057.133-.086.209-.124.057-.038.114-.095.17-.142.864-.693 1.775-1.404 2.629-2.106-.114.123-.256.228-.39.341zm.436-.37c.02-.01-.066.047 0 0zm5.712-4.28c-.703.608-1.442 1.206-2.173 1.813-.968.797-1.945 1.603-2.932 2.381.105-.114.228-.2.351-.294.37-.294.74-.588 1.091-.892.475-.408.95-.816 1.424-1.233.474-.408.93-.845 1.423-1.224.493-.39.986-.778 1.499-1.148-.19.218-.446.398-.683.598zm-.067-.123a.589.589 0 01.133-.132c.332-.295.673-.608 1.043-.892.361-.285.721-.57 1.073-.854-.01.085-.105.123-.18.19-.674.54-1.395 1.129-2.069 1.688zm1.964.532c.133-.21.285-.408.436-.627.048-.066.095-.151.143-.208.057-.057.123-.095.19-.143.417-.332.853-.692 1.261-1.034-.635.674-1.356 1.338-2.03 2.012zm1.508-11.973c-.056.047-.16.17-.18.17a.94.94 0 01.104-.113c.257-.276.532-.55.769-.816.142-.161.313-.294.446-.456.57-.616 1.186-1.214 1.774-1.84.721-.769 1.49-1.537 2.22-2.296.152-.152.304-.304.446-.465.142-.152.294-.303.446-.465.218-.237.436-.455.664-.683.076-.076.133-.17.228-.218.028.019.066.028.104.038-.408.484-.854.94-1.271 1.423.465-.455.91-.94 1.385-1.385.104.038.209.076.322.104-.455.503-.948.958-1.413 1.461l-.105.105c-.028.038-.047.085-.075.113-.057.057-.133.114-.19.171-1.898 1.727-3.786 3.416-5.674 5.152zm8.16-10.417c-.124.152-.304.313-.447.465-.056-.01-.094-.029-.142-.048.19-.17.399-.322.598-.493.01 0 .01.01.019.01.028.018-.02.047-.029.066zm.075 2.618c0 .038-.038.067-.066.095-.086.095-.2.19-.294.285a1.529 1.529 0 01-.313-.114c-.038-.01.019-.029.019-.038.085-.095.208-.228.303-.323.133.02.228.076.351.095zm-.588-.17c.029.009.066.018.095.028a4.187 4.187 0 01-.332.37c-.038-.01-.057-.029-.095-.029-.01-.038.047-.066.076-.094.085-.076.17-.19.256-.276zm-3.235 12.314c-.085.104-.2.18-.304.275-.313.266-.645.54-.958.816.057-.105.142-.209.218-.313.029-.038.048-.085.067-.114.066-.066.161-.123.246-.17.238-.162.503-.323.731-.494zm3.785-2.495c-1.916 1.499-3.842 3.045-5.758 4.554.142-.2.265-.39.455-.55.626-.541 1.271-1.101 1.897-1.66.228-.2.456-.409.703-.58 1.034-.683 2.058-1.385 3.073-2.077a2.936 2.936 0 01-.37.313zm.665-14.61a59.789 59.789 0 01-1.547-.465c-.038-.01.038-.057.057-.076.522.151 1.034.322 1.556.474-.02.038-.048.047-.066.066zm.047-3.283c-.02 0-.105-.038-.17-.057a26.483 26.483 0 01-1.31-.455c.484-.219.977-.437 1.385-.636.133.285.275.579.408.863-.029.067-.085.095-.142.152-.048.047-.114.133-.171.133zm.057 16.062c-.01-.02.019-.029.028-.038a39.546 39.546 0 012.04-1.65 3.52 3.52 0 01-.341.312c1.261-1.053 2.561-2.163 3.842-3.244.18.066.36.123.54.18-2.02 1.49-4.079 2.95-6.11 4.44zm7.115-5.351c-.17.17-.36.38-.55.54-.19-.056-.36-.123-.54-.18.217-.199.455-.389.673-.578.161.038.313.095.484.133.01.037-.048.056-.067.085zm-.37-22.988c-.028-.066-.076-.151-.076-.199-.01-.076.02-.161.029-.246.01-.105.019-.18.028-.266.437.91.854 1.84 1.29 2.751l.057.968c-.445-.987-.882-1.992-1.328-3.008zm4.82 28.718l.028.977c-.512-.986-1.015-1.992-1.527-2.979.066.067.133.152.19.238.426.578.882 1.176 1.309 1.764zm-1.452-4.895c.057.17.123.313.18.484a7.501 7.501 0 01-.407-.55c.075.018.142.047.227.066zM48.27 32.82c.152.294.285.607.446.9.01.105.01.21.019.314-.152-.323-.294-.664-.455-.987.009-.095-.01-.152-.01-.227zm.218 2.001c-.038-.085-.104-.17-.123-.265-.019-.086-.01-.219-.019-.332-.019-.266-.029-.57-.047-.864.085.171.227.475.332.683.047.086.104.18.113.276.02.123.01.313.02.464 0 .048.018.114.009.143-.02.075-.105.113-.17.16a2.768 2.768 0 00-.115-.265zm.143 22.419c.047.028.075.085.113.123.029.047.086.085.105.142.019.048.038.114.057.161.057.143.133.314.18.465-.161-.284-.294-.597-.455-.892zm1.29 5.995c-.114-.227-.37-.91-.674-1.764-.066-.313-.114-.626-.17-.94.521.959 1.034 2.069 1.574 3.074.076.143.162.295.219.446v.02c.028.132.019.312.019.464 0 .2.009.399.019.598a88.851 88.851 0 01-.987-1.898zM62.69 76.1c.16.218.332.456.493.683.446.598.901 1.186 1.338 1.803.218.303.446.616.578.986-.01.038-.066-.047-.095-.076a15.834 15.834 0 01-1.318-1.622c-.437-.626-.797-1.309-1.177-1.973.076.057.124.123.18.2zm-6.091-24.116c.759.199 1.518.398 2.277.588l-.095.085c-.73-.227-1.461-.455-2.182-.673zm1.157 3.662c-.313-.086-.626-.18-.939-.266-.123-.256-.256-.493-.38-.75.323.105.646.2.978.285.114.247.227.484.341.73zm.114-4.858c0 .01.038.02 0 .02-.73-.238-1.451-.466-2.191-.693-.076-.124-.124-.276-.2-.399.105.02.2.086.304.123.683.314 1.395.636 2.087.95zm-1.499-3.728c-.2.18-.398.36-.607.531-.55-.247-1.082-.512-1.632-.759-.17-.389-.36-.778-.54-1.157.094-.114.208-.19.313-.285 1.034.37 2.03.768 3.064 1.129-.19.19-.399.36-.598.54zm-1.376 2.827c-.227-.076-.445-.152-.673-.218.104-.124.228-.228.35-.332.039 0 .048.019.086.028.067.17.162.342.237.522zm-.882-.816c-.066.076-.152.152-.237.228-.029.019-.047.057-.085.057-.067-.18-.152-.342-.219-.513.2.067.36.162.541.228zm3.805-3.377c-1.044-.36-2.088-.702-3.131-1.063-.038-.01.028-.047.047-.066.038-.029.067-.067.105-.095 1.034.37 2.049.75 3.083 1.11 0 .038-.076.076-.104.114zm3.89 1.043c2.172.76 6.337 2.201 8.547 2.932.076.028.143.057.218.085.067.02.162.029.19.095-.057.057-.209.047-.294.019a.38.38 0 01-.152-.095c-2.21-.768-6.356-2.22-8.51-3.036-.019 0-.019.01 0 0zm7.817 2.989c.085.028.17.047.246.076.228.085.475.18.712.265.047.02.114.029.142.076-.863-.303-3.69-1.262-4.554-1.565-2.561-.902-5.132-1.803-7.722-2.704.028-.038.066-.067.095-.095 3.036 1.091 8.054 2.846 11.08 3.947zM76.522 30.2c-.161.152-.36.266-.55.417-1.3.978-2.58 2.002-3.852 3.008-2.903 2.315-5.73 4.734-8.539 7.163a1563.078 1563.078 0 01-4.08 3.529c-.037.038-.075.076-.132.085-1.034-.35-2.059-.72-3.102-1.072-.029-.028.028-.057.038-.066.142-.142.332-.285.484-.427.54-.484 1.11-.977 1.66-1.461.37-.323.75-.655 1.11-.977.19-.161.36-.342.55-.494.949-.777 1.916-1.565 2.884-2.333.19-.152.427-.266.655-.399 4.155-2.438 8.529-4.696 12.874-6.973zm1.537-2.106c-1.442.797-2.941 1.527-4.402 2.296-.209.104-.408.227-.617.332-1.243.654-2.505 1.319-3.728 2.011.066-.076.151-.114.227-.17 1.234-.845 2.58-1.613 3.947-2.344.36-.2.75-.37 1.12-.56.37-.19.759-.36 1.138-.531.759-.36 1.537-.702 2.305-1.044.048 0 .01 0 .01.01zm2.903-4.8c.123-.03.247-.058.37-.077.256-.038.512-.047.768.01.057.01.105.028.162.038.057.01.123.01.17.028.095.029.21.124.285.2.18.16.313.332.446.53a.942.942 0 01.152.361c.028.152 0 .351-.029.494-.16.854-.892 1.233-1.537 1.612-.056.038-.104.067-.16.105-.058.028-.143.066-.172.085-.094.057-.237.133-.265.152-.076-.019-.162-.066-.266-.038.095-.047.323-.152.427-.2a9.566 9.566 0 001.556-1.062c.19-.18.332-.503.332-.873 0-.398-.237-.702-.455-.93-.076-.075-.152-.17-.238-.218a1.446 1.446 0 00-.398-.151c-.38-.086-.835-.01-1.205.066-.73.143-1.433.342-2.106.55-.93.285-1.812.608-2.647.902a30.099 30.099 0 014.81-1.585zm-7.324 4.714c.038-.028.218-.17.218-.17-.019-.029-.066-.086-.142-.18.55-.352 1.1-.703 1.717-.978s1.29-.484 1.964-.72c.987-.361 1.992-.684 3.064-.968.247-.067.484-.143.75-.19.114-.02.237-.038.36-.038.029.01 0 .028-.01.038-.227.17-.53.322-.806.465-.588.313-1.186.607-1.812.892-.313.142-.645.256-.968.388-.322.133-.645.257-.967.39-.94.398-2.657 1.223-2.799 1.309-.692.341-1.366.711-2.02 1.081.227-.237.53-.484.844-.75.17-.17.389-.379.607-.569zM54.33 40.05c.247-.218.513-.446.712-.626.977-.845 1.935-1.67 2.894-2.477.246-.208.493-.407.73-.616.712-.626 1.404-1.281 2.106-1.917 1.888-1.707 3.738-3.387 5.645-5.085.949-.844 1.897-1.698 2.837-2.533 1.423-1.233 2.846-2.524 4.335-3.719.513-.408 1.034-.816 1.585-1.148-.807 1.385-1.974 2.467-3.207 3.473-.247.199-.474.417-.711.626-.902.778-1.784 1.546-2.695 2.314-.028.029-.066.048-.095.076-.493.427-1.024.864-1.527 1.3-.958.826-1.945 1.623-2.894 2.448-.948.835-1.897 1.66-2.855 2.486-.475.407-.959.825-1.433 1.233l-2.856 2.486c-1.423 1.242-2.912 2.419-4.354 3.652-.057-.028-.275-.057-.323-.104-.028-.038-.028-.01 0-.038a.709.709 0 01.133-.114 181.77 181.77 0 001.973-1.717zm-.958 6.423c-.161-.067-.303-.143-.465-.21.076-.084.171-.142.247-.227.01 0 .019 0 .019.01.057.142.133.275.2.427zm.958-8.634c-.702.702-1.375 1.404-2.087 2.116-.01.01-.047.038-.066.066-.029.029-.029.057-.067.038-.019-.01-.038-.066-.028-.095 0 .01.066-.057.076-.066 1.47-1.414 2.922-2.875 4.383-4.288-.702.702-1.461 1.49-2.21 2.23zm-3.045-3.358c0-.095-.019-.209 0-.294.01-.057.123-.124.2-.19.199-.18.407-.38.606-.54.826-.722 1.642-1.443 2.448-2.164.275-.237.56-.474.825-.712.143-.123.276-.237.408-.36.674-.588 1.367-1.195 2.04-1.784-1.062 1.148-2.163 2.296-3.254 3.454-.816.863-1.632 1.726-2.438 2.609-.266.284-.531.578-.816.844 0-.256-.019-.579-.019-.863zm.066 3.861c.01-.076.21-.237.304-.332.721-.74 1.423-1.528 2.125-2.267.304-.323.598-.655.901-.987.494-.531 1.015-1.082 1.509-1.613.702-.768 1.423-1.508 2.125-2.267.095-.114.209-.21.304-.323.797-.873 1.679-1.67 2.514-2.505.417-.417.854-.816 1.28-1.242 1.253-1.253 2.553-2.467 3.843-3.69l.654-.599c.655-.588 1.3-1.204 1.983-1.783.456-.39.911-.769 1.366-1.148.465-.38.93-.76 1.404-1.12.01-.01.02 0 .01 0-2.457 2.6-5 5.123-7.504 7.685-.627.645-1.253 1.271-1.888 1.907-.105.104-.218.2-.323.303-.057.057-.095.124-.142.171l-9.013 9.013c-.323.313-.645.626-.958.94-.076.075-.152.16-.237.236-.029.02-.048.057-.086.048-.047-.142-.152-.237-.161-.418v-.009h-.01zm.636 17.874l.74 1.063c-.237-.086-.474-.162-.712-.247-.018-.266-.018-.541-.028-.816zm3.9 14.828c-.01.038-.039-.056-.058-.085-.294-.55-.588-1.138-.872-1.698-.304-.607-.617-1.215-.92-1.812-.608-1.215-1.243-2.42-1.85-3.615-.01-.626-.039-1.243-.048-1.878a490.797 490.797 0 013.747 9.088zm1.555-4.525c-.408-.522-.797-1.072-1.186-1.613-1.148-1.584-2.305-3.15-3.462-4.734-.095-.133-.171-.35-.247-.522-.142-.35-.285-.692-.427-1.053-.029-.066-.076-.152-.086-.208-.018-.143 0-.304-.009-.456-.01-.152-.01-.303-.019-.446.37.123.73.247 1.1.36l3.264 4.725c.38 1.329.702 2.647 1.072 3.947.01.01.01.01.02.01 0 .009-.02 0-.02-.01zm-.313-10.521c-.019-.02-.019-.048-.038-.067 0-.01.01 0 .01 0 .237.067.503.133.759.2.066.018.18.037.19.132-.314-.085-.608-.18-.92-.265zm4.943 16.432c-.844-1.082-1.717-2.183-2.571-3.293-.057-.075-.142-.151-.18-.218-.048-.085-.067-.208-.105-.303a65.39 65.39 0 01-1.072-2.998l3.928 6.812zM59.72 59.697c-.285-.076-.598-.2-.882-.294-.2-.408-.408-.816-.607-1.234.303.095.588.2.882.275.2.418.389.845.607 1.253zm22.21 2.334c.066-.067.132-.067.19-.067.037.133.037.351.009.513-.02.151-.067.341-.18.379-.086.028-.247-.029-.39-.067-1.84-.464-3.68-.986-5.483-1.489-1.47-.398-2.912-.806-4.373-1.205-3.88-1.062-7.752-2.163-11.632-3.254-.37-.104-.787-.209-1.176-.332-.01-.01-.029-.01-.048-.019-.104-.047-.227-.019-.246-.152.01 0 .01 0 .01.01.483.123.957.265 1.432.389 1.432.37 2.874.768 4.326 1.157 1.926.513 3.87 1.006 5.806 1.5 1.935.492 3.861 1.005 5.787 1.517.475.133.94.275 1.414.408.72.2 1.442.38 2.182.56.246.057.493.114.72.19.466.151.912.313 1.367.455.057-.047.095-.114.085-.18-.01-.105-.132-.143-.246-.171.152.028.303-.029.446-.142zm-.55.104c.018.01.037.019.066.028h.019c-.029-.01-.057-.01-.086-.019v-.01zm-2.998-.91c.17.047.275.084.398.122.844.266 1.708.522 2.561.788a2.408 2.408 0 01-.445-.066c-.095-.029-.2-.076-.294-.114a41.739 41.739 0 00-2.097-.683c.18.066.37.132.55.199-.18-.029-.36-.086-.54-.142a187.11 187.11 0 01-3.73-1.158c-1.413-.455-2.836-.873-4.25-1.338 2.638.788 5.237 1.585 7.847 2.391zm-14.62-4.422c.18.057.37.123.55.19.901.322 1.85.636 2.77.93 3.017.948 6.044 1.86 9.023 2.827-5.93-1.623-11.84-3.273-17.742-4.934-.056-.038-.056-.113-.085-.17-.085-.171-.18-.351-.256-.541.768.228 1.537.446 2.296.683 1.157.342 2.296.664 3.444 1.015zm2.647-3.823a.763.763 0 00-.152-.399c4.25-.123 11.48-.303 12.93-.161 1.51.142-7.674.417-12.778.56zM23.906 94.534c2.305.702 3.823 1.783 3.823 4.174 0 2.856-2.647 4.725-5.445 4.725-2.43 0-4.706-1.006-6.063-2.752l1.746-2.03c1.319 1.566 2.751 2.258 4.373 2.258 1.338 0 2.524-.636 2.524-1.869 0-.987-.531-1.48-1.793-1.85l-2.543-.759c-2.134-.635-3.576-1.707-3.576-4.003 0-2.448 2.2-4.497 5.218-4.497 2.239 0 4.07.844 5.303 2.115l-1.641 2.163c-1.025-1.09-2.258-1.745-3.7-1.745-1.357 0-2.277.72-2.277 1.745 0 .864.598 1.32 1.641 1.623l2.41.702zM32.131 94.657h.038c.475-.825 1.604-1.584 2.998-1.584 2.647 0 4.744 2.134 4.744 5.18 0 3.045-2.097 5.18-4.744 5.18-1.394 0-2.533-.759-2.998-1.585h-.038v5.237H29.38V93.329h2.751v1.328zm2.486 6.328c1.537 0 2.571-1.29 2.571-2.732 0-1.442-1.025-2.733-2.571-2.733-1.537 0-2.571 1.3-2.571 2.733 0 1.442 1.025 2.732 2.571 2.732zM45.034 97.266l2.324-.18c0-1.006-.702-1.623-2.077-1.623-1.025 0-2.116.494-2.856 1.006l-.949-2.03c.864-.636 2.552-1.357 4.279-1.357 2.751 0 4.288 1.623 4.288 4.156v5.958h-2.647v-1.253h-.038c-.313.636-1.46 1.499-2.893 1.499-1.936 0-3.454-1.091-3.454-3.036-.01-1.945 1.964-2.97 4.023-3.14zm2.324 1.65l-1.85.172c-1.186.104-1.926.408-1.926 1.233 0 .702.693 1.091 1.5 1.091 1.252 0 2.276-.797 2.276-2.201v-.294zM54.853 98.177v5.019h-2.751v-9.867h2.751v1.689h.038c.39-1.025 1.395-1.85 2.524-1.85.227 0 .474.019.654.066v2.837a3.156 3.156 0 00-1.072-.18c-1.261-.02-2.144.882-2.144 2.286zM62.48 98.158v5.028h-2.76v-15h2.76v9.47l3.824-4.327h3.197l-4.108 4.516 4.232 5.341h-3.302l-3.842-5.028zM76 97.854h3.88v-.92h-2.552l2.439-2.59v-.996h-3.662v.901h2.314L76 96.86v.995zm-4.829 0h1.13v-2.476c0-.152.018-.294.066-.446.037-.152.104-.275.19-.389a.908.908 0 01.322-.275.91.91 0 01.465-.104c.18 0 .332.038.436.114.114.075.2.17.256.284.057.114.105.247.124.39.019.142.028.284.028.407v2.495h1.13v-2.817c0-.228-.03-.456-.096-.674a1.667 1.667 0 00-.294-.579 1.459 1.459 0 00-.512-.408c-.209-.104-.465-.151-.76-.151-.34 0-.625.085-.872.256-.247.17-.417.37-.522.597h-.019v-.72h-1.072v4.496z",
    fill: "#5A12AA"
  })));
}

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function SvgVerticalLogoReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 88 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.81 41.965c.009-.01.018-.01 0 0zm-60.178-.417c-.038.066.01.066.047.085.038.02.105.028.124.038 1.252.36 2.58.74 3.813 1.091.038.01.076.038.124.029-1.366-.418-2.742-.816-4.108-1.243zM83.03 52.192c-3.633-.607-12.883-.597-18.557-.53-.313-.143-.617-.295-.92-.437-2.42-1.13-4.857-2.258-7.258-3.397.408-.37.807-.75 1.234-1.11.01 0 .01.01.019.01 3.576 1.328 9.164 3.254 12.826 4.497h.02c.255.057.806-.399 1.024-1.12.218-.72.123-1.423-.114-1.518 0 0-8.244-2.884-11.375-3.994 1.66-1.48 3.387-2.865 5.075-4.298 1.69-1.432 3.368-2.874 5.086-4.288.853-.702 1.707-1.413 2.58-2.106 1.736-1.395 3.472-2.78 5.303-4.06a24.1 24.1 0 011.405-.94c.303-.19.616-.389.92-.54.2-.105.417-.171.617-.276.009 0 .009-.01.018-.01 0-.037-.047-.009-.028-.047.028-.018.067-.037.095-.066.019-.123.085-.341-.01-.436-.123-.029-.208.066-.313.076-.019-.029.01-.038.02-.057-.456.246-.92.483-1.386.702-.076.038-.199.076-.265.113-.029.02-.057.029-.095.048-.655.332-1.319.654-1.983.987-.617.313-1.234.616-1.84.939-.608.332-1.225.626-1.832.948-2.428 1.29-4.857 2.562-7.238 3.91.265-.21.521-.437.825-.608.304-.17.617-.332.92-.503 1.84-1.024 3.653-2.03 5.54-3.036 1.234-.654 2.477-1.3 3.748-1.964 1.072-.55 2.201-1.138 3.35-1.65.151-.067.36-.19.559-.162.019 0 .066.02.104.038.095.029.143.057.18.114.067.105.133.427.057.607-.037.076-.075.076-.132.114-.029.02-.038.038-.067.057-.047.029-.104.057-.152.095-.322.18-.616.351-.91.54-.588.38-1.177.779-1.746 1.168-.19.133-.38.275-.57.408a72.222 72.222 0 00-3.31 2.514c-.74.588-1.49 1.195-2.192 1.812-.152.133-.313.256-.465.389-1.584 1.338-3.15 2.694-4.705 4.032-1.044.901-2.078 1.812-3.131 2.704-.01.019-.01.019.01.01a395.352 395.352 0 017.59-6.253 459.244 459.244 0 00-6.14 5.247c-.009.028.03-.01.03-.01.246-.2.502-.427.768-.588-.778.806-1.641 1.556-2.486 2.315a82.789 82.789 0 00-1.878 1.727c-.171.17-.38.341-.531.512-.02.019-.067.076-.038.085.237-.17.445-.37.673-.56 1.1-.958 2.201-1.906 3.311-2.855l2.666-2.268c.446-.38.901-.75 1.347-1.12.01-.009.02-.028.038-.037.048-.038.086-.076.124-.105.844-.711 1.688-1.404 2.533-2.096 1.337-1.11 2.741-2.21 4.117-3.283.702-.54 1.404-1.062 2.116-1.584.237-.17.474-.342.72-.512.75-.522 1.471-.968 2.287-1.414.285-.152.56-.285.712-.522.161-.246.275-.616.218-.977-.057-.332-.2-.588-.484-.74.142.114.256.266.332.455.076.171.142.418.104.683-.009.095-.056.2-.094.304-.086.2-.171.342-.332.465-.076.057-.152.133-.238.17-.17.096-.35.181-.531.276-.531.265-1.034.588-1.518.882-.341.209-.654.437-.996.617a16.099 16.099 0 012.324-1.632c.2-.114.418-.237.626-.36.21-.124.38-.295.465-.513a1.057 1.057 0 00-.028-.816.999.999 0 00-.503-.483c.332-.162.655-.342.968-.532.227-.142.465-.284.635-.465.067-.066.143-.123.19-.19.105-.132.17-.284.247-.445.076-.152.133-.351.142-.541.02-.209-.047-.39-.114-.57a1.354 1.354 0 00-.246-.445 1.481 1.481 0 00-.845-.532 1.648 1.648 0 00-.616-.056c-1.831.227-3.359.787-4.867 1.318.294-.066.692-.246 1.005-.313-1.024.37-2.058.797-3.026 1.215-.588.246-1.1.616-1.623.93.475-.4.93-.798 1.367-1.234.427-.436.816-.92 1.186-1.414.17-.227.36-.474.54-.75.18-.265.342-.55.408-.89.038-.181.057-.437.02-.59-.039-.15-.153-.284-.257-.398-.095-.104-.228-.199-.36-.294-.133-.085-.285-.19-.456-.199-.085 0-.18.029-.275.047-.484.076-.806.295-1.12.503-.132.095-.255.19-.379.275-1.034.75-1.945 1.537-2.884 2.344-1.414 1.214-2.79 2.438-4.184 3.652a749.954 749.954 0 00-4.003 3.51c-.057.048-.124.096-.18.152-1.87 1.623-3.72 3.274-5.58 4.886-1.403 1.215-2.788 2.458-4.174 3.672 1.016-.968 2.012-1.964 3.027-2.932.256-.237.503-.483.759-.72.256-.238.493-.504.75-.74.265-.238.502-.494.758-.731s.513-.484.76-.73c1.982-1.983 3.984-3.966 5.967-5.95 2.485-2.485 4.98-4.951 7.419-7.475.37-.38.73-.768 1.081-1.148.124-.133.237-.266.332-.418.2-.303.304-.645.304-1.015 0-.113 0-.227-.01-.341-.019-.247-.18-.484-.36-.655a1.01 1.01 0 00-.152-.133 1.016 1.016 0 00-.531-.208c-.228-.038-.437 0-.664.057-.399.104-.674.284-1.015.474 0 0-.39.247-.56.38.123-.133.313-.285.474-.418 0-.019-.01-.028-.019-.038 0 0 0-.01.01-.01.36-.379.446-.91.161-1.223-.294-.332-.882-.294-1.31.095-.066.066-.17.17-.246.265-.674.712-1.252 1.366-1.945 2.059-.19.19-.36.389-.569.57l-1.831 1.603c-.408.36-.816.711-1.224 1.072-.408.36-.816.711-1.224 1.062-.607.532-1.205 1.082-1.812 1.613-.199.17-.408.342-.598.531.494-.37 1.006-.73 1.509-1.09-.892.777-1.793 1.555-2.704 2.333-.91.778-1.793 1.575-2.694 2.353-1.774 1.527-3.53 3.102-5.275 4.658a.23.23 0 01-.095.057c-.01-1.195-.047-3.472-.057-3.586 0-.161-.322-.294-.711-.294-.114 0-.219.01-.314.028.038-1.755.076-3.51.124-5.256v-.01c-.01-.379-.465-.692-1.044-.692-.028 0-.057 0-.085.01-.029 0-.057.01-.086.01-.056.009-.104.009-.16.018-.048.01-.096.02-.153.038-.047.01-.094.038-.132.057-.048.02-.086.048-.124.067a.418.418 0 00-.104.076.843.843 0 00-.085.094.251.251 0 00-.057.095c-.02.038-.029.076-.038.114-.01.038-.01.076-.02.123V24.3c0 .019 0 .047.01.066v.076c0 .029 0 .048.01.076v.161c0 .029 0 .057.01.086v.095l.009.095c0 .028 0 .066.01.095v.104c0 .038 0 .066.009.104v.105c0 .038 0 .075.009.113v.114l.01.114c0 .038 0 .076.009.114v.123c0 .038 0 .076.01.124 0 .037 0 .085.009.123v.123c0 .038.01.086.01.124v.132c0 .038.009.086.009.133 0 .048.01.086.01.133 0 .048.009.085.009.133l.01.133c0 .047.009.095.009.133l.01.132c0 .038.009.086.009.133l.01.133c0 .047.009.095.009.142 0 .048.01.095.01.143l.009.142c0 .047.01.095.01.142 0 .048 0 .095.009.142 0 .048.01.095.01.143 0 .047 0 .095.009.142 0 .048 0 .095.01.142 0 .048.009.095.009.143 0 .047 0 .095.01.142 0 .047.009.095.009.142.01.048.01.095.01.143 0 .047.009.095.009.142.01.047.01.095.01.142 0 .048.009.095.009.143 0 .047.01.095.01.142l.009.142c0 .048 0 .095.01.143 0 .047.009.094.009.142 0 .047.01.095.01.142 0 .048.009.095.009.133 0 .047.01.085.01.133 0 .047 0 .095.009.133 0 .038 0 .085.01.132 0 .048 0 .086.009.133 0 .038 0 .086.009.133 0 .047.01.085.01.133 0 .038 0 .085.009.123 0 .038 0 .086.01.123 0 .038 0 .086.009.124 0 .038 0 .085.01.123v.124c0 .037.009.075.009.123v.237c0 .038.01.076.01.114 0 .038.009.076.009.114v.105c-.114-.248-.237-.485-.342-.712-.038-.086-.104-.21-.104-.294-.038-.484-.038-.968-.066-1.452l-.086-1.461c-.057-.968-.114-1.936-.161-2.913-.133-2.684-.323-5.332-.418-8.026 0-.123-.018-.247-.018-.36 0-.114.028-.238.038-.351.294-2.695.891-8.121.891-8.254.029-1.072-.522-1.955-1.233-1.983-.721-.029-1.328.825-1.376 1.888-.01.218.237 4.004.332 5.958.01.152.038.303.029.455-.02.294-.086.579-.114.864a96.644 96.644 0 00-.712-4.355c-.265-1.404-.54-2.799-.853-4.184a7.351 7.351 0 00-.816-2.097c-.37-.626-.93-1.252-1.68-1.404a1.975 1.975 0 00-1.565.37c-.531.323-.91 1.006-1.024 1.566-.143.72.018 1.49.123 2.21.256 1.727.389 3.463.626 5.19.133.967.237 1.945.36 2.912-.237-.474-.464-.967-.692-1.442-1.566-3.425-3.169-6.83-4.734-10.246-.038-.028-.02-.019-.029-.019l-.01.01c.674 1.518 1.405 3.064 2.06 4.63-.769-1.49-1.471-3.046-2.211-4.564-.465.228-.882.389-1.347.617.038-.01-.02.01.019 0 1.916 4.43 3.89 8.832 5.787 13.263.588 1.385 1.195 2.78 1.784 4.174.038.095.094.17.104.275-1.518-3.273-3.036-6.555-4.563-9.819 0-.01-.01-.01-.01 0a509.834 509.834 0 013.273 7.362c.029.076.067.152.095.237-1.413-2.979-2.837-5.939-4.25-8.918-.02-.047-.029-.057-.038-.076-.114.038-.18.095-.275.114-.901-2.172-2.638-6.347-2.723-6.527-.437-.949-1.319-1.499-2.04-1.224-.787.294-.93 1.271-.797 1.983.105.56.332 1.072.541 1.603.209.55.418 1.1.636 1.651.047.133.104.294.17.446.048.133.086.341.171.455-.417-.53-.939-.806-1.357-.645-.521.209-.692 1.044-.436 1.945-.389-.512-.882-.778-1.271-.626-.54.218-.664 1.148-.285 2.097.01.028.029.057.038.085.048.095.086.161.114.237.389 1.006.787 2.002 1.176 3.008-.313-.522-.597-1.082-.91-1.613a1.667 1.667 0 00-.228-.285.685.685 0 00-.759-.114.67.67 0 00-.399.617c0 .152.058.285.095.408.048.123.105.237.152.351.588 1.461 1.196 2.818 1.803 4.27a570.003 570.003 0 003.662 8.48c.768 1.765 1.556 3.53 2.334 5.266.057.114.113.228.142.342-.901-1.926-1.793-3.861-2.704-5.787 1.13 2.59 2.24 5.237 3.387 7.798.038.076.076.152.095.237-.17-.038-.323-.095-.484-.152-.161-.056-.323-.094-.474-.16a642.773 642.773 0 01-3.653-1.822c-.844-.446-11.214-4.886-11.631-5.038-.048-.02-.095-.048-.143-.067-1.233-.55-1.593.693-1.47 1.006a52.79 52.79 0 00-1.3-.474c-.436-.152-1.318-.475-1.318-.475-.21-.076-.503.19-.655.589-.085.227-.104.455-.066.616a16.53 16.53 0 01-1.566-.436c-.275-.095-.55-.2-.844-.285a8.928 8.928 0 00-.902-.227c-.322-.067-.683-.124-1.015-.086-.35.038-.73.152-.967.427-.256.294-.294.693-.2 1.053.095.36.276.664.484.968.067.095.133.18.209.265.076.086.152.162.228.238.095.085.19.18.294.265.104.095.218.18.341.257.124.085.256.16.38.237.152.085.294.17.446.246.161.086.332.171.502.238.19.085.38.151.57.227.218.076.427.152.645.218.057.02.104.038.161.048-.237-.038-.474-.076-.702-.123-.161.569-.408 1.404-.408 1.432l.01.01s9.923 4.23 14.942 6.3c-2.922-.95-5.91-1.841-8.851-2.78-.987-.314-1.974-.617-2.96-.92-1.955-.599-4.042-1.149-6.3-1.453-.588-.085-1.186-.123-1.774-.16-.294-.02-.579-.067-.873-.096-.294-.038-.579-.075-.863-.104-.143-.019-.285-.028-.418-.066l-.37-.114c-.597-.2-1.243-.408-1.84-.588a2.315 2.315 0 00-.323-.086.072.072 0 00-.047-.019c-.39-.076-.797.304-.902.854-.104.54.114 1.034.503 1.129.029.01.057.01.067.019.028.01.057.01.085.01.901.113 1.784.227 2.666.332.218.028.417.113.626.17.617.19 1.252.37 1.84.57-.123.265-.18.569-.274.863-.067.218-.133.436-.2.645l-.038.133c.674.18 1.338.389 2.002.588 4.706 1.404 9.411 2.79 14.108 4.203-.133.408-.257.816-.39 1.224-1.45-.494-2.902-1.015-4.363-1.5-.731-.246-1.452-.512-2.173-.749-1.499-.493-3.045-1.062-4.506-1.537-.01 0-.152-.057-.067-.019.076.038.18.067.275.095 1.281.456 2.514.883 3.786 1.347.626.228 1.261.446 1.86.693.075.038.17.057.236.114-.607-.143-1.205-.323-1.802-.503-1.177-.36-2.344-.74-3.52-1.091-.598-.18-1.167-.389-1.736-.579-.645-.218-1.29-.446-1.936-.664a83.18 83.18 0 00-1.631-.57c-1.025-.36-2.069-.71-3.074-1.071-.067-.029-.133-.067-.2-.095-.322-.095-.683.19-.806.636-.133.436.02.863.323.967.047.02.114.029.114.029.094.019.16.038.256.066 2.428.655 4.848 1.366 7.238 2.04.257.076.503.142.75.228 1.205.417 2.429.863 3.615 1.28-.608-.151-1.196-.303-1.803-.464-.01 0-.01.009.01.009.777.218 1.546.418 2.305.636.37.104.72.256 1.081.38.37.132.73.246 1.091.379 1.462.512 2.913.996 4.364 1.508 1.452.512 2.904 1.015 4.365 1.509 1.46.483 2.903 1.005 4.373 1.498-3.614 3.283-7.248 6.537-10.474 10.19a41.467 41.467 0 00-1.755 2.115c-.066.086-.114.18-.19.247-.151.133-.322.247-.483.38 0 0-.797.588-.94.797-.142.208.067.645.484.939.418.294.883.36 1.044.142 0 0 0-.01.01-.01.009 0 .009-.009.009-.018.2-.408.446-.75.692-1.11.067-.095.114-.19.2-.266.075-.066.16-.142.256-.209.17-.133.341-.275.512-.408 4.706-3.766 9.392-7.542 14.07-11.337.075-.066.227-.2.275-.2.038 0 .104.039.152.058.16.057.313.114.474.152-1.1 1.233-2.24 2.428-3.34 3.652-.275.304-.56.607-.835.91-.56.618-1.11 1.234-1.66 1.841-.275.304-.55.617-.797.959.076 0 .152-.124.21-.143-1.984 2.126-6.11 6.224-6.101 6.233.123.114.19.19.303.304-.967.901-1.925 1.803-2.893 2.694.095.086.18.19.275.285-.38.332-.769.664-1.167.996-.047.038-.18.152-.18.152-.209.18-.048.721.37 1.214.35.418.759.655 1.005.617.01 0 .01.01.02.01-.636.645-1.471 1.375-2.116 2.04-.076.075-.275.265-.294.293-.228.247-.342.94-.2 1.31.029.076.095.265.2.35-.55.475-1.063.883-1.623 1.357-.057.048-.104.105-.123.114-.142.19-.085.512.17.854.276.36.665.531.864.38l.019-.02a.757.757 0 00.142.541c.171.266.437.408.617.351.038-.01.048-.019.066-.028.038-.02.057-.048.086-.086 1.83-1.451 3.652-2.922 5.474-4.373.617-.493 1.233-.996 1.86-1.48-.589.816-1.13 1.632-1.699 2.419a1.796 1.796 0 01-.18.2c-.247.246-.503.493-.759.749-.503.503-1.025.977-1.527 1.47-.418.418-.864.835-1.281 1.253-.086.085-.237.227-.237.227-.408.446-.399 1.139.01 1.5.009.009.018.009.027.018.01.01.02.02.039.029.018.019.047.028.066.047.019.01.047.029.066.038.02.01.048.02.067.028.028.01.047.02.076.029.028.01.047.019.076.019.028.01.056.01.075.019.029 0 .057.01.076.01h.086c.028 0 .057 0 .085-.01.028-.01.057-.01.085-.019.029 0 .057-.01.086-.019l.085-.028.086-.029c.028-.01.047-.028.075-.038.029-.01.048-.028.076-.038.029-.019.048-.028.076-.047.029-.02.048-.038.076-.057.02-.02.048-.038.067-.067.028-.028.056-.047.085-.076.01-.009.01-.019.019-.019a.075.075 0 01.038-.037.074.074 0 01.038-.038c.01-.02.019-.038.038-.048.01-.019.028-.038.038-.057.019-.019.028-.038.047-.057.02-.019.029-.038.048-.066a.289.289 0 00.047-.066c.02-.029.038-.048.057-.076l.057-.086c.019-.028.047-.057.066-.085.02-.029.048-.057.067-.095a.663.663 0 01.076-.095l.075-.104c.029-.038.048-.067.076-.105a.782.782 0 00.076-.113l.086-.114c.028-.038.057-.086.085-.124.029-.038.057-.075.085-.123.029-.038.057-.085.086-.123.028-.038.057-.086.095-.124.028-.038.057-.085.095-.123.028-.038.066-.085.095-.123.028-.048.066-.086.094-.133.029-.038.067-.085.095-.133.029-.038.067-.085.095-.133.029-.038.067-.085.095-.133.028-.037.066-.085.095-.132.028-.038.066-.086.095-.133.028-.038.066-.086.095-.133a.609.609 0 01.095-.123c.028-.038.056-.086.094-.124.029-.038.057-.085.086-.123.028-.038.057-.085.085-.123l.085-.114a.79.79 0 00.076-.114l.086-.114c.028-.038.047-.076.076-.114a.42.42 0 01.076-.104c.028-.038.047-.076.076-.105.028-.037.047-.066.075-.104.2-.284.39-.579.636-.806.247-.228.484-.475.721-.712.721-.72 1.47-1.413 2.192-2.134.72-.721 1.47-1.424 2.191-2.135.237-.237.494-.465.73-.712.484-.474.987-.939 1.462-1.413.246-.237.493-.465.73-.702.484-.484.977-.949 1.461-1.414.74-.702 1.452-1.432 2.201-2.115.124-.114.247-.238.36-.352.361-.36.74-.701 1.101-1.062.238-.237.475-.484.721-.712.124-.113.266-.208.399-.322.797-.645 1.594-1.3 2.381-1.945.93-.759 1.869-1.508 2.79-2.258-6.509 6.708-13.017 13.434-19.468 20.198-.029.029-.048.057-.086.086-.01.019-.028.028-.038.047.02-.01.029-.028.048-.038a581.087 581.087 0 005.436-5.38c1.129-1.128 2.248-2.267 3.358-3.386.674-.674 1.338-1.366 2.012-2.04.9-.901 1.774-1.83 2.675-2.732 1.803-1.803 3.567-3.643 5.37-5.446l2.58-2.58a.815.815 0 01.133-.105c.047.143.142.238.18.37.038.124.048.276.076.408.067.332.124.674.18 1.006.342 2.96.826 7.21.873 7.552.162 1.148.332 2.305.494 3.453.38 2.628 2.239 13.13 2.58 13.851.161.352.484.703.892.74.408.038.882-.379.93-.787.066-.531-.143-1.053-.143-1.584v-3.957c0-.408 0-.815-.01-1.223-.018-.73-.056-1.47-.113-2.201-.114-1.48-.341-2.922-.531-4.393a90.656 90.656 0 01-.266-3.055c2.325 4.544 6.964 13.652 6.964 13.652.104.152.493.143.901-.028.436-.18.712-.484.636-.664v-.01c-1.85-4.601-3.69-9.212-5.579-13.785a351.195 351.195 0 013.681 4.934c.076.114.161.199.228.313.076.114.104.237.161.38.73 1.783 1.547 3.528 2.343 5.189-.977-1.698-1.84-3.52-2.646-5.398 0-.01-.01-.01-.01.009.503 1.271.987 2.542 1.537 3.776.54 1.224 1.167 2.4 1.85 3.482.323.522.674 1.062 1.082 1.575.284.35.645.711.986 1.015.332.284.94.55 1.509.398.332-.085.569-.284.768-.56.19-.265.304-.616.285-1.024a3.664 3.664 0 00-.247-1.091c.37-.162.75-.342 1.1-.513.048-.019.115-.037.153-.075-.731-1.556-1.5-3.093-2.22-4.659-.722-1.556-1.5-3.093-2.22-4.658-.731-1.565-1.49-3.102-2.22-4.658-.74-1.547-1.528-3.074-2.249-4.62.285.104.598.18.873.294 3.273 6.764 6.565 13.519 9.933 20.198.01.019.028.019.01 0-3.112-6.679-6.272-13.368-9.383-20.018 3.52 1.157 7.058 2.296 10.606 3.434.02 0 .02-.01 0-.01-1.783-.654-3.586-1.26-5.379-1.897-1.793-.635-3.586-1.27-5.398-1.888 0-.009-.01-.009-.02-.019-.18-.426-.407-.853-.578-1.252 1.584.512 3.216 1.025 4.81 1.518.228.066.456.152.683.218 2.325.702 4.64 1.423 6.992 2.06.465.122.92.293 1.376.435.91.285 1.821.598 2.723.892.901.304 1.802.607 2.685.93.664.247 1.337.474 1.982.75l.465.265c.038.01.086.02.133.01.475-.02 1.1-.854 1.442-1.983.38-1.233.275-2.438-.218-2.58 0 0-.285-.048-.304-.058.114-.54.057-.967-.256-1.062-.028-.01-7.57-2.429-11.242-3.586-.531-.171-1.063-.332-1.603-.503-2.088-.655-4.165-1.31-6.262-1.955.228 0 .455-.009.692-.009.408.133 3.321 1.063 4.222 1.347 1.509.474 2.97.92 4.45 1.395 1.413.455 4.279 1.385 4.298 1.385 0 0 .047.019.094-.01.114-.056.247-.218.314-.426.066-.238.056-.465 0-.57 0 0-.02-.047-.076-.066-.038-.01-.067-.02-.095-.029-.408-.142-.807-.284-1.205-.426-1.404-.475-2.799-.94-4.184-1.424-.92-.322-1.85-.635-2.78-.948-.332-.105-.664-.228-.986-.342 9.107-.313 18.87-1.025 15.122-1.65zm-60.424-5.275c-.54-.123-1.062-.322-1.565-.483.142.01.275.076.417.114.275.085.56.17.854.246.133.038.285.067.398.123-.018.038-.066.01-.104 0zm23.7-19.553c.028-.218.047-.455.066-.673.038-.323.085-.626.114-.92.132.806.227 1.64.37 2.447.037.228.085.522.094.807-.19-.399-.389-.826-.588-1.243-.028-.067-.076-.133-.076-.18-.019-.076.01-.152.02-.238zm-.257 2.06c.019-.162.057-.4.076-.551.266.54.54 1.11.806 1.67.038.085.095.151.114.227.02.086.01.19.02.285.018.265.028.55.047.844-.323-.683-.674-1.432-1.016-2.144-.056-.123-.066-.161-.047-.332zm-.36-8.558c-.048.474-.114.986-.162 1.46-.076.703-.151 1.395-.218 2.06.161-1.215.304-2.448.474-3.644.057.228.01.522-.019.788-.113 1.347-.275 2.741-.408 4.08-.066-.134-.132-.257-.199-.4a.886.886 0 01-.057-.142c-.01-.085.02-.199.038-.303.18-1.518.37-3.121.55-4.592.076.2.02.455 0 .693zm-2.676 2.267c-.038-.332-.085-.645-.123-.977.645 1.31 1.262 2.637 1.907 3.947-.029.218-.057.436-.076.664-.579-1.205-1.13-2.42-1.708-3.634zm1.575 4.658a4.17 4.17 0 00-.047.36c-.399-.872-.76-1.754-1.158-2.646-.028-.057-.066-.114-.085-.17-.038-.134-.02-.286-.057-.409.465.949.892 1.917 1.347 2.865zm-2.191-4.724c.17.341.322.702.483 1.043.01.105.029.19.029.304-.171-.37-.332-.76-.503-1.12.01-.095-.019-.152-.01-.227zm.208-1.518c.029.303.067.588.095.882-.18-.36-.342-.75-.522-1.11-.028-.294-.066-.579-.095-.863.18.36.342.74.522 1.09zm-.711-2.59c-.029-.285-.067-.55-.095-.835.199.398.37.816.56 1.224.028.227.047.446.075.683-.18-.351-.35-.721-.54-1.072zm.692.901c.399.882.807 1.755 1.167 2.675-.028.029-.028-.019-.038-.028-.095-.123-.17-.294-.247-.446a80.897 80.897 0 01-.673-1.3c-.047-.085-.114-.17-.133-.256-.028-.085-.028-.209-.038-.313 0-.114-.028-.218-.038-.332zm2.144 8.263c.095.162.162.342.247.503 0 .152-.038.275-.047.418-.086-.171-.152-.352-.238-.522.01-.142.038-.256.038-.399zm.2-.901c-.02-.038-.057-.085-.067-.123-.01-.076.029-.228.038-.323.02-.123.029-.247.047-.341.095.16.162.341.257.502-.029.228-.067.437-.086.674-.076-.114-.133-.256-.19-.389zM33.98 5.402c-.019-.038-.038-.114-.066-.162-.019-.047-.057-.095.028-.114.029-.01.038.038.048.057.076.171.152.36.227.541.589 1.433 1.205 2.922 1.803 4.374-.683-1.547-1.357-3.14-2.04-4.697zm2.182 2.789c-.246-.55-.502-1.12-.768-1.708-.2-.436-.446-1.006-.674-1.49 0-.028-.028-.075-.038-.113-.038-.105-.047-.076.038-.105.057.048.067.133.095.2.702 1.527 1.433 3.083 2.154 4.62.996 2.134 2.002 4.26 3.007 6.413.209.446.437.93.664 1.404.029.067.086.133.095.19.02.057.01.133.02.2.018.18.056.388.075.578-1.584-3.358-3.112-6.774-4.668-10.19zm4.858 2.134c.038.095.047.228.066.351-.01-.256-.057-.521-.085-.778a152.375 152.375 0 01-.342-3.15c-.038-.35-.019-.758.18-1.062.162-.247.494-.493.797-.484.55.02 1.006.712 1.177 1.158.114.265.228.56.313.844.085.285.152.57.247.863.36 1.186.645 2.41.901 3.653.256 1.243.503 2.552.712 3.852.19 1.157.36 2.258.55 3.434.019.17.066.342.066.503 0 .104-.028.218-.038.332-.19 1.603-.417 3.33-.607 4.924-.73-1.556-1.499-3.207-2.248-4.8-.048-.105-.114-.219-.143-.314-.047-.152-.047-.341-.076-.522-.16-1.223-.313-2.428-.474-3.662-.2-1.451-.37-2.855-.56-4.316.01.332.067.664.105.996.275 2.324.521 4.677.787 7.03-.161-.332-.332-.683-.493-1.034-.02-.048-.057-.105-.067-.143-.019-.066-.019-.16-.028-.246-.133-1.177-.247-2.42-.37-3.586-.133-1.3-.275-2.571-.37-3.843zm-3.387 9.43c.076.133.17.39.228.522 1.27 3.065 2.533 6.13 3.823 9.194.17.398.341.825.512 1.242.029.057.057.114.076.171.029.123.02.228.038.37-1.565-3.842-3.102-7.6-4.64-11.394a.594.594 0 00-.037-.085c-.01-.02-.038-.076 0-.02zm2.106 30.407c.142-.142.285-.313.436-.455.114.038.238.066.342.104.029.01-.028.057-.047.066-.162.171-.36.37-.541.532a2.417 2.417 0 00-.313-.105c0-.047.076-.095.123-.142zm-.323-.01c-.019.02-.037.057-.066.057-.038-.019.029-.047.047-.066.152-.161.333-.35.484-.503-.123.133-.303.351-.465.513zM37.615 19.7c-.029.01-.038-.086-.057-.114-.01 0-.01-.01-.01-.02.029.039.038.096.067.134zm-.085-.18c.009.009.009.018.018.028 0 .019-.018-.02-.018-.029zm0-.02c-.01.02-.02-.009-.02-.028.01.01.01.019.02.028zm-.048-.104c0 .02-.019-.019-.019-.028.01 0 .02.019.02.028zm-.028-.076c.01.01.01.02.019.029-.01.019-.029-.02-.02-.029zm0-.019c-.01.02-.02-.019-.02-.028 0 .01.01.019.02.028zm-.048-.104c0 .019-.019-.01-.019-.029.01.01.01.02.02.029zm.02.038c0 .019-.02-.02-.02-.029.01.01.01.02.02.029zm.995 9.05c.522 1.092.92 2.25 1.395 3.388-.256-.532-.55-1.054-.797-1.594-.247-.56-.465-1.13-.702-1.689-.474-1.12-.94-2.258-1.404-3.377.522 1.081.996 2.182 1.508 3.273zm-1.27.997c.284.569.52 1.167.777 1.755.256.588.512 1.167.759 1.764a167.55 167.55 0 01-2.76-4.81c-.153-.275-.304-.54-.456-.815a8.911 8.911 0 01-.399-.864c-.986-2.362-1.973-4.724-2.94-7.153 0-.038.047.047.056.066.541 1.082 1.082 2.182 1.632 3.264.57 1.129 1.1 2.267 1.66 3.387.57 1.138 1.11 2.277 1.67 3.406zM31.59 6.037c.341.825.673 1.68 1.015 2.505.047.123.085.246.161.35a70.042 70.042 0 00-1.044-2.902l.048-.02c.94 2.097 1.85 4.223 2.76 6.348-.142.057-.294.114-.426.19-.351-.807-.683-1.594-1.025-2.4-.114-.267-.218-.542-.322-.817-.219-.54-.465-1.043-.703-1.575-.227-.502-.436-1.034-.483-1.679h.019zm-.37.133l.028-.01c.835 2.002 1.698 4.014 2.552 6.025.029.066.095.199.123.303 0-.01.029.048.029.048 0 .038-.01.028-.038.038-.038.019-.047 0-.066-.048a2.165 2.165 0 01-.114-.313c-.816-2.03-1.68-4.032-2.514-6.043zm-1.575 12.22c.047.037.057.104.095.151.208.38.436.769.616 1.196.2.484.408.977.588 1.48-.455-.92-.863-1.888-1.3-2.828zm.806 1.498c0-.038.01 0 .02 0 .54 1.015 1.09 2.05 1.64 3.065.095.17.2.332.276.512 1.755 4.222 3.52 8.5 5.426 12.59.152.332.323.654.474 1.005 0 .01.048.038.01.048-.038-.02-.095-.038-.142-.057-2.657-5.636-5.209-11.375-7.704-17.163zm1.404 19.013c.294.114.588.246.883.389 1.698.797 3.453 1.584 5.18 2.381l-1.48.958a8.529 8.529 0 01-.513-.246c-.588-.294-1.224-.56-1.84-.826-.418-.17-.826-.36-1.243-.54-1.224-.541-2.467-1.12-3.596-1.746-.303.047-.588-.029-.835-.114-.72-.247-1.385-.617-2.03-.958a1.412 1.412 0 01-.161-.095 80.362 80.362 0 00-1.803-.93c-.227-.114-.446-.228-.692-.313 0-.01 0-.01.01-.01 2.466.503 4.866 1.073 7.2 1.718.303.085.607.218.92.332zm5.598 5.275c-.218-.057-.427-.162-.645-.247l-.513-.2c.038-.018.067-.037.105-.047.37.152.72.313 1.053.494zm-11.527-9.46c.076.01.161.058.246.096.086.038.18.057.247.095.047.028.104.085.152.123.142.123.313.266.455.38-.484-.19-.986-.446-1.49-.655.134-.01.257-.057.39-.038zm-4.545-.635c.408.19.826.39 1.234.57 1.233.54 2.447 1.147 3.7 1.698-2.04-.427-4.137-.807-6.233-1.205-.143-.029-.294-.038-.408-.085-.057-.02-.114-.067-.171-.105l4.345.342s-2.305-1.091-4.962-2.182c.2.066.399.123.588.18.238.066.475.104.683.209.418.19.807.389 1.224.578zm-4.753-3.52c1.12.399 2.24.788 3.32 1.167a6.524 6.524 0 01-.464-.113c-.456-.124-.92-.266-1.366-.399.038-.019-.01 0 .047 0-.18-.047-.247-.076-.427-.104-.18-.029-.37-.038-.54-.095-.143-.038-.285-.133-.437-.2-.076-.037-.152-.056-.228-.085-.208-.095-.408-.199-.645-.303-.161-.067-.341-.114-.446-.228.418.038.854.247 1.186.36zm7.03 8.15c.36.209.769.427 1.139.636-.76-.313-1.518-.645-2.277-.977a651.942 651.942 0 00-6.888-2.923c.152 0 .294.038.446.067h.01l1.584.341c.266.133.56.276.854.36.218.067.474.086.72.086.228 0 .466.01.646.076l1.764 1.196.19.085 3.833 1.613 4.222 1.935c-2.125-.863-4.279-1.708-6.395-2.59.057.029.105.067.152.095zm2.619 6.926c.152.019.303.076.455.123.446.133.92.275 1.376.408-.02.019-.029.01-.048 0-.303-.066-.607-.161-.91-.247-.314-.076-.598-.19-.873-.284zm.958.332c2.353.683 4.706 1.347 7.049 2.03.028.01-.019.038-.019.047-.095.095-.237.2-.342.294-2.23-.787-4.468-1.555-6.688-2.371-.01 0-.01.01 0 0zm2.372 3.396c.816.218 1.613.456 2.428.664a.406.406 0 01-.132.124c-.74-.266-1.556-.522-2.296-.788zm4.003 1.983c-2.77 2.23-5.53 4.459-8.291 6.698-.02.01-.02.01-.01-.01.91-.882 1.803-1.783 2.751-2.637.152-.142.294-.304.456-.446.152-.142.313-.285.455-.436.579-.617 1.205-1.196 1.803-1.793.446-.446.92-.873 1.375-1.32.152-.15.304-.293.475-.426.332.114.673.228 1.005.341.02 0-.019.02-.019.029zm.522-.436a34.557 34.557 0 00-1.062-.36c.01-.067.123-.115.16-.181.4.104.779.218 1.177.322-.095.076-.17.162-.275.219zm-.74-5.74c-3.121-.987-6.27-1.955-9.354-2.96 4.155 1.271 8.349 2.514 12.466 3.823-.047.067-.095.076-.17.057-.19-.047-.4-.123-.589-.18-.788-.237-1.584-.493-2.353-.74zm1.65 3.558c0-.048.048-.076.086-.105.095-.085.2-.18.294-.275 0-.01.02-.01.02-.019.474.123.93.266 1.394.398-.17.143-.351.285-.522.427-.427-.132-.844-.294-1.271-.426zm.599 2.703c.113-.104.227-.199.35-.294l.485.143c-.095.113-.19.227-.295.322-.18-.047-.36-.123-.54-.17zM19.37 76.622c.844-.721 1.717-1.452 2.571-2.182 2.913-2.495 5.806-5.047 8.71-7.561-.219.35-.475.692-.722 1.043-.038.048-.066.114-.095.152-.047.057-.142.114-.208.17-1.015.836-2.059 1.727-3.065 2.572.162-.095.313-.209.465-.313-.635.56-1.28 1.1-1.954 1.631-2.002 1.594-4.032 3.188-6.034 4.782.076-.104.209-.19.332-.294zm1.3-.73c-.863.72-1.746 1.48-2.61 2.21-.028.019-.047.047-.075.066 0-.047-.01-.095-.02-.152.03-.037.058-.066.086-.094.067-.057.133-.086.209-.124.057-.038.114-.095.17-.142.864-.693 1.775-1.404 2.629-2.106-.114.123-.256.228-.39.341zm.436-.37c.02-.01-.066.047 0 0zm5.712-4.28c-.703.608-1.442 1.206-2.173 1.813-.968.797-1.945 1.603-2.932 2.381.105-.114.228-.2.351-.294.37-.294.74-.588 1.091-.892.475-.408.95-.816 1.424-1.233.474-.408.93-.845 1.423-1.224.493-.39.986-.778 1.499-1.148-.19.218-.446.398-.683.598zm-.067-.123a.589.589 0 01.133-.132c.332-.295.673-.608 1.043-.892.361-.285.721-.57 1.073-.854-.01.085-.105.123-.18.19-.674.54-1.395 1.129-2.069 1.688zm1.964.532c.133-.21.285-.408.436-.627.048-.066.095-.151.143-.208.057-.057.123-.095.19-.143.417-.332.853-.692 1.261-1.034-.635.674-1.356 1.338-2.03 2.012zm1.508-11.973c-.056.047-.16.17-.18.17a.94.94 0 01.104-.113c.257-.276.532-.55.769-.816.142-.161.313-.294.446-.456.57-.616 1.186-1.214 1.774-1.84.721-.769 1.49-1.537 2.22-2.296.152-.152.304-.304.446-.465.142-.152.294-.303.446-.465.218-.237.436-.455.664-.683.076-.076.133-.17.228-.218.028.019.066.028.104.038-.408.484-.854.94-1.271 1.423.465-.455.91-.94 1.385-1.385.104.038.209.076.322.104-.455.503-.948.958-1.413 1.461l-.105.105c-.028.038-.047.085-.075.113-.057.057-.133.114-.19.171-1.898 1.727-3.786 3.416-5.674 5.152zm8.16-10.417c-.124.152-.304.313-.447.465-.056-.01-.094-.029-.142-.048.19-.17.399-.322.598-.493.01 0 .01.01.019.01.028.018-.02.047-.029.066zm.075 2.618c0 .038-.038.067-.066.095-.086.095-.2.19-.294.285a1.529 1.529 0 01-.313-.114c-.038-.01.019-.029.019-.038.085-.095.208-.228.303-.323.133.02.228.076.351.095zm-.588-.17c.029.009.066.018.095.028a4.187 4.187 0 01-.332.37c-.038-.01-.057-.029-.095-.029-.01-.038.047-.066.076-.094.085-.076.17-.19.256-.276zm-3.235 12.314c-.085.104-.2.18-.304.275-.313.266-.645.54-.958.816.057-.105.142-.209.218-.313.029-.038.048-.085.067-.114.066-.066.161-.123.246-.17.238-.162.503-.323.731-.494zm3.785-2.495c-1.916 1.499-3.842 3.045-5.758 4.554.142-.2.265-.39.455-.55.626-.541 1.271-1.101 1.897-1.66.228-.2.456-.409.703-.58 1.034-.683 2.058-1.385 3.073-2.077a2.936 2.936 0 01-.37.313zm.665-14.61a59.789 59.789 0 01-1.547-.465c-.038-.01.038-.057.057-.076.522.151 1.034.322 1.556.474-.02.038-.048.047-.066.066zm.047-3.283c-.02 0-.105-.038-.17-.057a26.483 26.483 0 01-1.31-.455c.484-.219.977-.437 1.385-.636.133.285.275.579.408.863-.029.067-.085.095-.142.152-.048.047-.114.133-.171.133zm.057 16.062c-.01-.02.019-.029.028-.038a39.546 39.546 0 012.04-1.65 3.52 3.52 0 01-.341.312c1.261-1.053 2.561-2.163 3.842-3.244.18.066.36.123.54.18-2.02 1.49-4.079 2.95-6.11 4.44zm7.115-5.351c-.17.17-.36.38-.55.54-.19-.056-.36-.123-.54-.18.217-.199.455-.389.673-.578.161.038.313.095.484.133.01.037-.048.056-.067.085zm-.37-22.988c-.028-.066-.076-.151-.076-.199-.01-.076.02-.161.029-.246.01-.105.019-.18.028-.266.437.91.854 1.84 1.29 2.751l.057.968c-.445-.987-.882-1.992-1.328-3.008zm4.82 28.718l.028.977c-.512-.986-1.015-1.992-1.527-2.979.066.067.133.152.19.238.426.578.882 1.176 1.309 1.764zm-1.452-4.895c.057.17.123.313.18.484a7.501 7.501 0 01-.407-.55c.075.018.142.047.227.066zM48.27 32.82c.152.294.285.607.446.9.01.105.01.21.019.314-.152-.323-.294-.664-.455-.987.009-.095-.01-.152-.01-.227zm.218 2.001c-.038-.085-.104-.17-.123-.265-.019-.086-.01-.219-.019-.332-.019-.266-.029-.57-.047-.864.085.171.227.475.332.683.047.086.104.18.113.276.02.123.01.313.02.464 0 .048.018.114.009.143-.02.075-.105.113-.17.16a2.768 2.768 0 00-.115-.265zm.143 22.419c.047.028.075.085.113.123.029.047.086.085.105.142.019.048.038.114.057.161.057.143.133.314.18.465-.161-.284-.294-.597-.455-.892zm1.29 5.995c-.114-.227-.37-.91-.674-1.764-.066-.313-.114-.626-.17-.94.521.959 1.034 2.069 1.574 3.074.076.143.162.295.219.446v.02c.028.132.019.312.019.464 0 .2.009.399.019.598a88.851 88.851 0 01-.987-1.898zM62.69 76.1c.16.218.332.456.493.683.446.598.901 1.186 1.338 1.803.218.303.446.616.578.986-.01.038-.066-.047-.095-.076a15.834 15.834 0 01-1.318-1.622c-.437-.626-.797-1.309-1.177-1.973.076.057.124.123.18.2zm-6.091-24.116c.759.199 1.518.398 2.277.588l-.095.085c-.73-.227-1.461-.455-2.182-.673zm1.157 3.662c-.313-.086-.626-.18-.939-.266-.123-.256-.256-.493-.38-.75.323.105.646.2.978.285.114.247.227.484.341.73zm.114-4.858c0 .01.038.02 0 .02-.73-.238-1.451-.466-2.191-.693-.076-.124-.124-.276-.2-.399.105.02.2.086.304.123.683.314 1.395.636 2.087.95zm-1.499-3.728c-.2.18-.398.36-.607.531-.55-.247-1.082-.512-1.632-.759-.17-.389-.36-.778-.54-1.157.094-.114.208-.19.313-.285 1.034.37 2.03.768 3.064 1.129-.19.19-.399.36-.598.54zm-1.376 2.827c-.227-.076-.445-.152-.673-.218.104-.124.228-.228.35-.332.039 0 .048.019.086.028.067.17.162.342.237.522zm-.882-.816c-.066.076-.152.152-.237.228-.029.019-.047.057-.085.057-.067-.18-.152-.342-.219-.513.2.067.36.162.541.228zm3.805-3.377c-1.044-.36-2.088-.702-3.131-1.063-.038-.01.028-.047.047-.066.038-.029.067-.067.105-.095 1.034.37 2.049.75 3.083 1.11 0 .038-.076.076-.104.114zm3.89 1.043c2.172.76 6.337 2.201 8.547 2.932.076.028.143.057.218.085.067.02.162.029.19.095-.057.057-.209.047-.294.019a.38.38 0 01-.152-.095c-2.21-.768-6.356-2.22-8.51-3.036-.019 0-.019.01 0 0zm7.817 2.989c.085.028.17.047.246.076.228.085.475.18.712.265.047.02.114.029.142.076-.863-.303-3.69-1.262-4.554-1.565-2.561-.902-5.132-1.803-7.722-2.704.028-.038.066-.067.095-.095 3.036 1.091 8.054 2.846 11.08 3.947zM76.522 30.2c-.161.152-.36.266-.55.417-1.3.978-2.58 2.002-3.852 3.008-2.903 2.315-5.73 4.734-8.539 7.163a1563.078 1563.078 0 01-4.08 3.529c-.037.038-.075.076-.132.085-1.034-.35-2.059-.72-3.102-1.072-.029-.028.028-.057.038-.066.142-.142.332-.285.484-.427.54-.484 1.11-.977 1.66-1.461.37-.323.75-.655 1.11-.977.19-.161.36-.342.55-.494.949-.777 1.916-1.565 2.884-2.333.19-.152.427-.266.655-.399 4.155-2.438 8.529-4.696 12.874-6.973zm1.537-2.106c-1.442.797-2.941 1.527-4.402 2.296-.209.104-.408.227-.617.332-1.243.654-2.505 1.319-3.728 2.011.066-.076.151-.114.227-.17 1.234-.845 2.58-1.613 3.947-2.344.36-.2.75-.37 1.12-.56.37-.19.759-.36 1.138-.531.759-.36 1.537-.702 2.305-1.044.048 0 .01 0 .01.01zm2.903-4.8c.123-.03.247-.058.37-.077.256-.038.512-.047.768.01.057.01.105.028.162.038.057.01.123.01.17.028.095.029.21.124.285.2.18.16.313.332.446.53a.942.942 0 01.152.361c.028.152 0 .351-.029.494-.16.854-.892 1.233-1.537 1.612-.056.038-.104.067-.16.105-.058.028-.143.066-.172.085-.094.057-.237.133-.265.152-.076-.019-.162-.066-.266-.038.095-.047.323-.152.427-.2a9.566 9.566 0 001.556-1.062c.19-.18.332-.503.332-.873 0-.398-.237-.702-.455-.93-.076-.075-.152-.17-.238-.218a1.446 1.446 0 00-.398-.151c-.38-.086-.835-.01-1.205.066-.73.143-1.433.342-2.106.55-.93.285-1.812.608-2.647.902a30.099 30.099 0 014.81-1.585zm-7.324 4.714c.038-.028.218-.17.218-.17-.019-.029-.066-.086-.142-.18.55-.352 1.1-.703 1.717-.978s1.29-.484 1.964-.72c.987-.361 1.992-.684 3.064-.968.247-.067.484-.143.75-.19.114-.02.237-.038.36-.038.029.01 0 .028-.01.038-.227.17-.53.322-.806.465-.588.313-1.186.607-1.812.892-.313.142-.645.256-.968.388-.322.133-.645.257-.967.39-.94.398-2.657 1.223-2.799 1.309-.692.341-1.366.711-2.02 1.081.227-.237.53-.484.844-.75.17-.17.389-.379.607-.569zM54.33 40.05c.247-.218.513-.446.712-.626.977-.845 1.935-1.67 2.894-2.477.246-.208.493-.407.73-.616.712-.626 1.404-1.281 2.106-1.917 1.888-1.707 3.738-3.387 5.645-5.085.949-.844 1.897-1.698 2.837-2.533 1.423-1.233 2.846-2.524 4.335-3.719.513-.408 1.034-.816 1.585-1.148-.807 1.385-1.974 2.467-3.207 3.473-.247.199-.474.417-.711.626-.902.778-1.784 1.546-2.695 2.314-.028.029-.066.048-.095.076-.493.427-1.024.864-1.527 1.3-.958.826-1.945 1.623-2.894 2.448-.948.835-1.897 1.66-2.855 2.486-.475.407-.959.825-1.433 1.233l-2.856 2.486c-1.423 1.242-2.912 2.419-4.354 3.652-.057-.028-.275-.057-.323-.104-.028-.038-.028-.01 0-.038a.709.709 0 01.133-.114 181.77 181.77 0 001.973-1.717zm-.958 6.423c-.161-.067-.303-.143-.465-.21.076-.084.171-.142.247-.227.01 0 .019 0 .019.01.057.142.133.275.2.427zm.958-8.634c-.702.702-1.375 1.404-2.087 2.116-.01.01-.047.038-.066.066-.029.029-.029.057-.067.038-.019-.01-.038-.066-.028-.095 0 .01.066-.057.076-.066 1.47-1.414 2.922-2.875 4.383-4.288-.702.702-1.461 1.49-2.21 2.23zm-3.045-3.358c0-.095-.019-.209 0-.294.01-.057.123-.124.2-.19.199-.18.407-.38.606-.54.826-.722 1.642-1.443 2.448-2.164.275-.237.56-.474.825-.712.143-.123.276-.237.408-.36.674-.588 1.367-1.195 2.04-1.784-1.062 1.148-2.163 2.296-3.254 3.454-.816.863-1.632 1.726-2.438 2.609-.266.284-.531.578-.816.844 0-.256-.019-.579-.019-.863zm.066 3.861c.01-.076.21-.237.304-.332.721-.74 1.423-1.528 2.125-2.267.304-.323.598-.655.901-.987.494-.531 1.015-1.082 1.509-1.613.702-.768 1.423-1.508 2.125-2.267.095-.114.209-.21.304-.323.797-.873 1.679-1.67 2.514-2.505.417-.417.854-.816 1.28-1.242 1.253-1.253 2.553-2.467 3.843-3.69l.654-.599c.655-.588 1.3-1.204 1.983-1.783.456-.39.911-.769 1.366-1.148.465-.38.93-.76 1.404-1.12.01-.01.02 0 .01 0-2.457 2.6-5 5.123-7.504 7.685-.627.645-1.253 1.271-1.888 1.907-.105.104-.218.2-.323.303-.057.057-.095.124-.142.171l-9.013 9.013c-.323.313-.645.626-.958.94-.076.075-.152.16-.237.236-.029.02-.048.057-.086.048-.047-.142-.152-.237-.161-.418v-.009h-.01zm.636 17.874l.74 1.063c-.237-.086-.474-.162-.712-.247-.018-.266-.018-.541-.028-.816zm3.9 14.828c-.01.038-.039-.056-.058-.085-.294-.55-.588-1.138-.872-1.698-.304-.607-.617-1.215-.92-1.812-.608-1.215-1.243-2.42-1.85-3.615-.01-.626-.039-1.243-.048-1.878a490.797 490.797 0 013.747 9.088zm1.555-4.525c-.408-.522-.797-1.072-1.186-1.613-1.148-1.584-2.305-3.15-3.462-4.734-.095-.133-.171-.35-.247-.522-.142-.35-.285-.692-.427-1.053-.029-.066-.076-.152-.086-.208-.018-.143 0-.304-.009-.456-.01-.152-.01-.303-.019-.446.37.123.73.247 1.1.36l3.264 4.725c.38 1.329.702 2.647 1.072 3.947.01.01.01.01.02.01 0 .009-.02 0-.02-.01zm-.313-10.521c-.019-.02-.019-.048-.038-.067 0-.01.01 0 .01 0 .237.067.503.133.759.2.066.018.18.037.19.132-.314-.085-.608-.18-.92-.265zm4.943 16.432c-.844-1.082-1.717-2.183-2.571-3.293-.057-.075-.142-.151-.18-.218-.048-.085-.067-.208-.105-.303a65.39 65.39 0 01-1.072-2.998l3.928 6.812zM59.72 59.697c-.285-.076-.598-.2-.882-.294-.2-.408-.408-.816-.607-1.234.303.095.588.2.882.275.2.418.389.845.607 1.253zm22.21 2.334c.066-.067.132-.067.19-.067.037.133.037.351.009.513-.02.151-.067.341-.18.379-.086.028-.247-.029-.39-.067-1.84-.464-3.68-.986-5.483-1.489-1.47-.398-2.912-.806-4.373-1.205-3.88-1.062-7.752-2.163-11.632-3.254-.37-.104-.787-.209-1.176-.332-.01-.01-.029-.01-.048-.019-.104-.047-.227-.019-.246-.152.01 0 .01 0 .01.01.483.123.957.265 1.432.389 1.432.37 2.874.768 4.326 1.157 1.926.513 3.87 1.006 5.806 1.5 1.935.492 3.861 1.005 5.787 1.517.475.133.94.275 1.414.408.72.2 1.442.38 2.182.56.246.057.493.114.72.19.466.151.912.313 1.367.455.057-.047.095-.114.085-.18-.01-.105-.132-.143-.246-.171.152.028.303-.029.446-.142zm-.55.104c.018.01.037.019.066.028h.019c-.029-.01-.057-.01-.086-.019v-.01zm-2.998-.91c.17.047.275.084.398.122.844.266 1.708.522 2.561.788a2.408 2.408 0 01-.445-.066c-.095-.029-.2-.076-.294-.114a41.739 41.739 0 00-2.097-.683c.18.066.37.132.55.199-.18-.029-.36-.086-.54-.142a187.11 187.11 0 01-3.73-1.158c-1.413-.455-2.836-.873-4.25-1.338 2.638.788 5.237 1.585 7.847 2.391zm-14.62-4.422c.18.057.37.123.55.19.901.322 1.85.636 2.77.93 3.017.948 6.044 1.86 9.023 2.827-5.93-1.623-11.84-3.273-17.742-4.934-.056-.038-.056-.113-.085-.17-.085-.171-.18-.351-.256-.541.768.228 1.537.446 2.296.683 1.157.342 2.296.664 3.444 1.015zm2.647-3.823a.763.763 0 00-.152-.399c4.25-.123 11.48-.303 12.93-.161 1.51.142-7.674.417-12.778.56zM23.906 94.534c2.305.702 3.823 1.783 3.823 4.174 0 2.856-2.647 4.725-5.445 4.725-2.43 0-4.706-1.006-6.063-2.752l1.746-2.03c1.319 1.566 2.751 2.258 4.373 2.258 1.338 0 2.524-.636 2.524-1.869 0-.987-.531-1.48-1.793-1.85l-2.543-.759c-2.134-.635-3.576-1.707-3.576-4.003 0-2.448 2.2-4.497 5.218-4.497 2.239 0 4.07.844 5.303 2.115l-1.641 2.163c-1.025-1.09-2.258-1.745-3.7-1.745-1.357 0-2.277.72-2.277 1.745 0 .864.598 1.32 1.641 1.623l2.41.702zM32.131 94.657h.038c.475-.825 1.604-1.584 2.998-1.584 2.647 0 4.744 2.134 4.744 5.18 0 3.045-2.097 5.18-4.744 5.18-1.394 0-2.533-.759-2.998-1.585h-.038v5.237H29.38V93.329h2.751v1.328zm2.486 6.328c1.537 0 2.571-1.29 2.571-2.732 0-1.442-1.025-2.733-2.571-2.733-1.537 0-2.571 1.3-2.571 2.733 0 1.442 1.025 2.732 2.571 2.732zM45.034 97.266l2.324-.18c0-1.006-.702-1.623-2.077-1.623-1.025 0-2.116.494-2.856 1.006l-.949-2.03c.864-.636 2.552-1.357 4.279-1.357 2.751 0 4.288 1.623 4.288 4.156v5.958h-2.647v-1.253h-.038c-.313.636-1.46 1.499-2.893 1.499-1.936 0-3.454-1.091-3.454-3.036-.01-1.945 1.964-2.97 4.023-3.14zm2.324 1.65l-1.85.172c-1.186.104-1.926.408-1.926 1.233 0 .702.693 1.091 1.5 1.091 1.252 0 2.276-.797 2.276-2.201v-.294zM54.853 98.177v5.019h-2.751v-9.867h2.751v1.689h.038c.39-1.025 1.395-1.85 2.524-1.85.227 0 .474.019.654.066v2.837a3.156 3.156 0 00-1.072-.18c-1.261-.02-2.144.882-2.144 2.286zM62.48 98.158v5.028h-2.76v-15h2.76v9.47l3.824-4.327h3.197l-4.108 4.516 4.232 5.341h-3.302l-3.842-5.028zM76 97.854h3.88v-.92h-2.552l2.439-2.59v-.996h-3.662v.901h2.314L76 96.86v.995zm-4.829 0h1.13v-2.476c0-.152.018-.294.066-.446.037-.152.104-.275.19-.389a.908.908 0 01.322-.275.91.91 0 01.465-.104c.18 0 .332.038.436.114.114.075.2.17.256.284.057.114.105.247.124.39.019.142.028.284.028.407v2.495h1.13v-2.817c0-.228-.03-.456-.096-.674a1.667 1.667 0 00-.294-.579 1.459 1.459 0 00-.512-.408c-.209-.104-.465-.151-.76-.151-.34 0-.625.085-.872.256-.247.17-.417.37-.522.597h-.019v-.72h-1.072v4.496z",
    fill: "#fff"
  })));
}

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgAsteriskLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.725 37.426c4.4 1.3 7.3 3.4 7.3 8 0 5.5-5.1 9-10.4 9-4.6 0-9-1.9-11.6-5.3l3.3-3.9c2.5 3 5.3 4.3 8.4 4.3 2.6 0 4.8-1.2 4.8-3.6 0-1.9-1-2.8-3.4-3.5l-4.9-1.5c-4.1-1.2-6.8-3.3-6.8-7.7 0-4.7 4.2-8.6 10-8.6 4.3 0 7.8 1.6 10.2 4.1l-3.1 4.1c-2-2.1-4.3-3.3-7.1-3.3-2.6 0-4.4 1.4-4.4 3.3 0 1.7 1.1 2.5 3.1 3.1l4.6 1.5zM130.425 37.726c1-1.6 3.1-3 5.8-3 5.1 0 9.1 4.1 9.1 9.9 0 5.8-4 9.9-9.1 9.9-2.7 0-4.8-1.5-5.7-3h-.1v10h-5.3v-26.4h5.3v2.6zm4.8 12.1c3 0 4.9-2.5 4.9-5.2 0-2.8-2-5.2-4.9-5.2-3 0-4.9 2.5-4.9 5.2s1.9 5.2 4.9 5.2zM155.125 42.726l4.4-.4c0-1.9-1.3-3.1-4-3.1-2 0-4.1.9-5.5 1.9l-1.8-3.9c1.7-1.2 4.9-2.6 8.2-2.6 5.3 0 8.2 3.1 8.2 7.9v11.5h-5.1v-2.4h-.1c-.6 1.2-2.8 2.9-5.5 2.9-3.7 0-6.6-2.1-6.6-5.8.1-3.8 3.9-5.7 7.8-6zm4.5 3.1l-3.5.3c-2.3.2-3.7.8-3.7 2.4 0 1.3 1.3 2.1 2.9 2.1 2.4 0 4.4-1.5 4.4-4.2v-.6h-.1zM173.925 44.426v9.6h-5.3v-18.9h5.3v3.2h.1c.7-2 2.7-3.5 4.8-3.5.4 0 .9 0 1.3.1v5.4c-.6-.2-1.3-.4-2-.4-2.5.1-4.2 1.8-4.2 4.5zM188.525 44.326v9.7h-5.2v-28.7h5.2v18.1l7.4-8.3h6.1l-7.9 8.7 8.1 10.2h-6.3l-7.4-9.7zM221.725 43.726v-1.7h-4.9l4.6-4.9v-1.9h-7v1.7h4.4l-4.6 5v1.8h7.5zm-14.5 0v-4.7c0-.3 0-.6.1-.8.1-.3.2-.5.4-.7.2-.2.4-.4.6-.5.2-.1.5-.2.9-.2.3 0 .6.1.8.2.2.1.4.3.5.5.1.2.2.5.2.7 0 .3.1.5.1.8v4.8h2.1v-5.4c0-.4-.1-.9-.2-1.3s-.3-.8-.6-1.1c-.3-.3-.6-.6-1-.8-.4-.2-.9-.3-1.4-.3-.6 0-1.2.2-1.7.5s-.8.7-1 1.1v-1.4h-2v8.6h2.2zM63.81 41.967s.01-.01 0 0c.019-.01.01-.01 0 0zM3.63 41.55c-.039.066.009.066.047.085.038.019.104.029.123.038 1.253.36 2.58.74 3.814 1.091.038.01.076.038.124.028-1.367-.417-2.742-.815-4.109-1.242zm79.402 10.645c-3.634-.607-12.884-.598-18.558-.532-.313-.142-.617-.294-.92-.436-2.42-1.129-4.858-2.258-7.258-3.396.408-.37.806-.75 1.233-1.11.01 0 .01.009.019.009 3.577 1.328 9.165 3.254 12.827 4.497h.02c.255.057.806-.398 1.024-1.12.218-.72.123-1.423-.114-1.517 0 0-8.245-2.885-11.376-3.995 1.66-1.48 3.387-2.865 5.076-4.298 1.69-1.432 3.369-2.874 5.086-4.288.854-.702 1.708-1.414 2.58-2.106 1.737-1.395 3.473-2.78 5.304-4.061.455-.323.92-.645 1.404-.94.304-.19.617-.388.92-.54.2-.105.418-.171.617-.275.01 0 .01-.01.02-.01 0-.038-.048-.01-.03-.047.03-.02.067-.038.096-.067.019-.123.085-.341-.01-.436-.123-.029-.209.066-.313.076-.019-.029.01-.038.019-.057-.455.247-.92.484-1.385.702-.076.038-.2.076-.266.114-.028.019-.057.028-.095.047-.654.332-1.319.655-1.983.987-.616.313-1.233.617-1.84.94-.608.331-1.224.625-1.831.948-2.43 1.29-4.858 2.562-7.24 3.909.266-.209.522-.436.826-.607.303-.171.617-.332.92-.503 1.84-1.025 3.653-2.03 5.541-3.036 1.233-.655 2.476-1.3 3.748-1.964 1.072-.55 2.2-1.139 3.349-1.651.152-.066.36-.19.56-.161.019 0 .066.019.104.038.095.028.142.056.18.113.067.105.133.427.057.608-.038.076-.076.076-.133.113-.028.02-.038.038-.066.058-.047.028-.105.056-.152.094-.323.18-.617.351-.91.541-.589.38-1.177.778-1.746 1.167-.19.133-.38.275-.57.408a72.356 72.356 0 00-3.31 2.514c-.741.589-1.49 1.196-2.193 1.813-.151.132-.313.256-.465.389-1.584 1.337-3.15 2.694-4.705 4.032-1.044.901-2.078 1.812-3.131 2.704-.01.019-.01.019.01.01a396.136 396.136 0 017.59-6.253 459.283 459.283 0 00-6.14 5.247c-.009.028.03-.01.03-.01.246-.2.502-.427.768-.588-.778.806-1.642 1.556-2.486 2.315a82.585 82.585 0 00-1.879 1.727c-.17.17-.38.341-.53.512-.02.019-.067.076-.039.085.237-.17.446-.37.674-.56 1.1-.958 2.2-1.907 3.311-2.855l2.666-2.268c.446-.38.901-.75 1.347-1.12.01-.009.02-.028.038-.037.048-.038.086-.076.124-.105.844-.711 1.688-1.404 2.533-2.096 1.338-1.11 2.742-2.211 4.117-3.283.703-.541 1.405-1.063 2.116-1.585.237-.17.475-.341.721-.512.75-.522 1.47-.968 2.287-1.414.284-.151.56-.284.711-.521.162-.247.276-.617.219-.978-.057-.332-.2-.588-.484-.74.142.114.256.266.332.456.076.17.142.417.104.683-.01.095-.057.199-.095.303-.085.2-.17.342-.332.465-.076.057-.152.133-.237.171-.17.095-.351.18-.531.275-.532.266-1.034.588-1.518.883-.342.208-.655.436-.996.616a16.107 16.107 0 012.324-1.632c.2-.113.417-.237.626-.36.209-.123.38-.294.465-.512a1.057 1.057 0 00-.028-.816.999.999 0 00-.503-.484c.332-.162.654-.342.968-.532.227-.142.464-.284.635-.465.067-.066.142-.123.19-.19.104-.132.17-.284.247-.445.076-.152.132-.351.142-.541.019-.209-.047-.389-.114-.57a1.355 1.355 0 00-.247-.445 1.481 1.481 0 00-.844-.531 1.649 1.649 0 00-.617-.057c-1.83.227-3.358.787-4.867 1.318.294-.066.693-.246 1.006-.313-1.025.37-2.06.797-3.027 1.215-.588.246-1.1.616-1.622.93.474-.399.93-.797 1.366-1.234.427-.436.816-.92 1.186-1.414.17-.227.36-.474.54-.75.181-.265.342-.55.409-.891.038-.18.057-.436.019-.588-.038-.152-.152-.285-.256-.399-.095-.104-.228-.199-.361-.294-.133-.085-.285-.19-.455-.199-.086 0-.18.028-.276.047-.483.076-.806.294-1.12.503-.132.095-.255.19-.379.275-1.034.75-1.945 1.537-2.884 2.344-1.413 1.214-2.79 2.438-4.184 3.653a754.532 754.532 0 00-4.004 3.51c-.057.047-.123.095-.18.152-1.87 1.622-3.72 3.273-5.579 4.886-1.404 1.215-2.79 2.457-4.174 3.672 1.015-.968 2.011-1.964 3.026-2.932.256-.237.503-.484.76-.721.255-.237.493-.503.749-.74.265-.237.503-.493.759-.73.256-.238.512-.484.759-.731 1.983-1.983 3.985-3.966 5.968-5.949 2.485-2.486 4.98-4.953 7.419-7.476.37-.38.73-.769 1.082-1.148a2.79 2.79 0 00.332-.418c.199-.303.303-.645.303-1.015 0-.114 0-.228-.01-.341-.018-.247-.18-.484-.36-.655a1.014 1.014 0 00-.152-.133 1.014 1.014 0 00-.53-.209c-.229-.038-.437 0-.665.057-.398.105-.674.285-1.015.475 0 0-.39.246-.56.38.123-.134.313-.285.474-.418 0-.02-.01-.029-.019-.038 0 0 0-.01.01-.01.36-.38.446-.91.161-1.224-.294-.332-.882-.294-1.31.095-.066.067-.17.171-.246.266-.673.711-1.252 1.366-1.945 2.059-.19.19-.36.389-.569.569l-1.831 1.603c-.408.36-.816.712-1.224 1.073-.408.36-.816.711-1.224 1.062-.607.531-1.205 1.082-1.812 1.613-.2.17-.408.342-.598.531.493-.37 1.006-.73 1.509-1.09-.892.777-1.794 1.555-2.704 2.333-.911.778-1.794 1.575-2.695 2.353-1.774 1.528-3.53 3.103-5.275 4.659a.23.23 0 01-.095.057c-.01-1.196-.047-3.473-.057-3.587 0-.161-.322-.294-.711-.294-.114 0-.219.01-.314.029.038-1.756.076-3.51.124-5.257v-.01c-.01-.379-.465-.692-1.044-.692-.028 0-.057 0-.085.01-.029 0-.057.01-.086.01-.056.009-.104.009-.16.018-.048.01-.096.02-.153.038-.047.01-.094.038-.133.057-.047.02-.085.048-.123.067a.423.423 0 00-.104.075c-.029.029-.057.057-.086.095a.254.254 0 00-.056.095c-.02.038-.029.076-.038.114-.01.038-.01.076-.02.123V24.301c0 .019 0 .048.01.066v.076c0 .029 0 .048.01.076v.161c0 .029 0 .058.01.086v.095l.009.095c0 .028 0 .066.009.095v.104c0 .038 0 .066.01.104v.105c0 .038 0 .075.009.113v.114l.01.114c0 .038 0 .076.009.114v.123c0 .038 0 .076.01.124 0 .038 0 .085.009.123v.123c0 .038.01.086.01.124v.133c0 .038.009.085.009.132 0 .048.01.086.01.133 0 .048.009.086.009.133l.01.133c0 .047.009.095.009.133l.01.133c0 .038.009.085.009.132l.01.133c0 .048.009.095.009.142 0 .048.01.095.01.143l.009.142c0 .048.01.095.01.143 0 .047 0 .094.009.142 0 .047.01.095.01.142 0 .047 0 .095.009.142 0 .048 0 .095.01.143 0 .047.009.095.009.142 0 .047 0 .095.01.142 0 .048.009.095.009.143.01.047.01.095.01.142 0 .047.009.095.009.142.01.048.01.095.01.143 0 .047.009.095.009.142 0 .047.01.095.01.142l.009.143c0 .047 0 .094.01.142 0 .047.009.095.009.142 0 .048.01.095.01.142 0 .048.009.095.009.133 0 .048.01.086.01.133 0 .048 0 .095.009.133 0 .038 0 .085.009.133 0 .047 0 .085.01.133 0 .038 0 .085.009.133 0 .047.01.085.01.132 0 .038 0 .086.009.124 0 .038 0 .085.01.123 0 .038 0 .085.009.123 0 .038 0 .086.01.124v.123c0 .038.009.076.009.123v.238c0 .038.01.075.01.113 0 .038.009.076.009.114v.105c-.114-.247-.237-.484-.342-.712-.038-.085-.104-.209-.104-.294-.038-.484-.038-.968-.066-1.452a1301.8 1301.8 0 01-.086-1.46c-.057-.969-.114-1.936-.161-2.913-.133-2.686-.323-5.333-.418-8.027 0-.124-.019-.247-.019-.36 0-.114.029-.238.038-.352.294-2.694.892-8.121.892-8.254.029-1.072-.522-1.954-1.233-1.983-.721-.028-1.328.825-1.376 1.888-.01.218.237 4.004.332 5.958.01.152.038.304.029.456-.02.294-.086.579-.114.863a96.817 96.817 0 00-.712-4.355c-.265-1.404-.54-2.799-.854-4.184a7.352 7.352 0 00-.816-2.097c-.37-.626-.93-1.252-1.679-1.404a1.975 1.975 0 00-1.565.37c-.532.323-.911 1.006-1.025 1.566-.142.72.019 1.49.123 2.21.256 1.727.39 3.463.627 5.19.132.968.237 1.945.36 2.913-.237-.474-.465-.968-.693-1.442-1.565-3.425-3.169-6.831-4.734-10.247-.038-.028-.019-.019-.028-.019l-.01.01c.674 1.518 1.404 3.064 2.059 4.63-.769-1.49-1.47-3.046-2.21-4.564-.466.228-.883.389-1.348.617.038-.01-.019.01.019 0 1.916 4.43 3.89 8.833 5.788 13.264.588 1.385 1.195 2.78 1.783 4.174.038.095.095.17.105.275-1.518-3.273-3.036-6.556-4.564-9.82 0-.009-.01-.009-.01 0a510.98 510.98 0 013.274 7.363c.028.076.066.152.095.237-1.414-2.979-2.837-5.94-4.25-8.918-.02-.048-.03-.057-.039-.076-.114.038-.18.095-.275.114-.901-2.173-2.638-6.348-2.723-6.528-.436-.949-1.319-1.499-2.04-1.224-.787.294-.93 1.272-.797 1.983.105.56.332 1.072.541 1.604.209.55.418 1.1.636 1.65.047.133.104.295.17.446.048.133.086.342.171.456-.417-.532-.939-.807-1.356-.645-.522.208-.693 1.043-.437 1.944-.389-.512-.882-.777-1.271-.626-.541.219-.664 1.148-.285 2.097.01.029.029.057.038.085.047.095.085.162.114.238.389 1.005.787 2.002 1.176 3.007-.313-.521-.597-1.081-.91-1.613a1.663 1.663 0 00-.228-.284.685.685 0 00-.76-.114.67.67 0 00-.398.617c0 .151.057.284.095.408.048.123.105.237.152.35.588 1.462 1.195 2.819 1.803 4.27a570.67 570.67 0 003.662 8.482c.768 1.765 1.556 3.53 2.334 5.266.057.114.114.227.142.341-.901-1.926-1.793-3.861-2.704-5.787 1.13 2.59 2.24 5.237 3.387 7.799.038.076.076.151.095.237-.17-.038-.322-.095-.484-.152-.16-.057-.322-.095-.474-.161a646.104 646.104 0 01-3.653-1.822c-.844-.446-11.214-4.886-11.632-5.038-.047-.019-.094-.047-.142-.066-1.233-.55-1.594.692-1.47 1.006a52.392 52.392 0 00-1.3-.475c-.437-.152-1.32-.474-1.32-.474-.208-.076-.502.19-.654.588-.085.228-.104.455-.066.617a16.524 16.524 0 01-1.566-.437c-.275-.095-.55-.199-.844-.284a8.934 8.934 0 00-.901-.228c-.323-.066-.684-.123-1.016-.085-.35.037-.73.151-.967.426-.257.295-.294.693-.2 1.054.095.36.276.664.484.967.067.095.133.18.209.266.076.085.152.161.228.237.095.086.19.18.294.266.104.095.218.18.341.256.124.085.257.161.38.237.152.086.294.171.446.247.161.085.332.17.503.237.19.085.38.152.569.228.218.076.427.152.645.218.057.019.104.038.161.047a15.4 15.4 0 01-.702-.123c-.161.57-.408 1.404-.408 1.433l.01.01s9.924 4.23 14.943 6.299c-2.922-.949-5.91-1.84-8.852-2.78-.987-.313-1.974-.617-2.96-.92-1.955-.598-4.042-1.148-6.3-1.452-.588-.085-1.186-.123-1.774-.161-.294-.019-.579-.067-.873-.095-.294-.038-.579-.076-.864-.104-.142-.02-.284-.029-.417-.067l-.37-.114c-.598-.199-1.243-.407-1.84-.588a2.33 2.33 0 00-.323-.085.072.072 0 00-.048-.02c-.389-.075-.797.304-.901.855-.104.54.114 1.034.503 1.129.028.01.057.01.066.019.029.01.057.01.086.01.901.113 1.783.227 2.666.331.218.029.417.114.626.171.617.19 1.252.37 1.84.57-.123.265-.18.569-.275.863-.066.218-.132.436-.199.645l-.038.133c.674.18 1.338.389 2.002.588 4.706 1.404 9.412 2.79 14.108 4.203-.133.408-.256.816-.389 1.224-1.451-.494-2.903-1.015-4.364-1.5-.73-.246-1.452-.512-2.173-.749-1.499-.493-3.045-1.062-4.506-1.537-.01 0-.152-.057-.067-.019.076.038.18.067.275.095 1.281.456 2.515.883 3.786 1.347.626.228 1.262.446 1.86.693.075.038.17.057.237.114-.608-.142-1.205-.323-1.803-.503-1.176-.36-2.343-.74-3.52-1.091-.598-.18-1.167-.389-1.736-.579-.645-.218-1.29-.446-1.936-.664-.303-.114-.939-.332-1.632-.57-1.024-.36-2.068-.71-3.074-1.071-.066-.029-.132-.067-.199-.095-.322-.095-.683.19-.806.636-.133.436.019.863.322.967.048.02.114.029.114.029.095.019.162.038.256.066 2.43.655 4.849 1.366 7.24 2.04.256.076.502.142.749.228 1.205.417 2.429.863 3.615 1.28-.607-.151-1.196-.303-1.803-.464-.01 0-.01.01.01.01.778.217 1.546.417 2.305.635.37.104.721.256 1.082.38.37.132.73.246 1.09.379 1.462.512 2.914.996 4.365 1.508a339 339 0 004.364 1.509c1.462.484 2.904 1.006 4.374 1.499-3.614 3.283-7.248 6.537-10.474 10.19a41.527 41.527 0 00-1.755 2.115c-.067.086-.114.18-.19.247-.152.133-.323.247-.484.38 0 0-.797.588-.94.797-.142.208.067.645.485.939.417.294.882.36 1.043.142 0 0 0-.01.01-.01s.01-.009.01-.018c.198-.408.445-.75.692-1.11.066-.095.114-.19.2-.266.075-.066.16-.142.255-.209.171-.133.342-.275.513-.408 4.705-3.766 9.392-7.542 14.07-11.337.076-.067.228-.2.275-.2.038 0 .104.038.152.057.161.057.313.114.474.152-1.1 1.233-2.239 2.429-3.34 3.653-.275.303-.56.607-.834.91-.56.617-1.11 1.234-1.66 1.841-.276.304-.551.617-.798.959.076 0 .152-.124.21-.143-1.984 2.125-6.111 6.224-6.102 6.234.124.114.19.19.304.303-.968.902-1.926 1.803-2.894 2.695.095.085.18.19.276.284a64.01 64.01 0 01-1.348 1.148c-.209.18-.047.721.37 1.215.351.417.76.654 1.006.617.01 0 .01.009.019.009-.636.645-1.47 1.376-2.116 2.04-.076.076-.275.266-.294.294-.228.247-.341.94-.2 1.31.03.075.096.265.2.35-.55.475-1.063.883-1.622 1.357-.057.047-.105.104-.124.114-.142.19-.085.512.171.854.275.36.664.531.863.38l.02-.02a.757.757 0 00.142.541c.17.266.436.408.616.351.038-.01.048-.019.067-.028.038-.02.057-.048.085-.086 1.831-1.451 3.653-2.922 5.475-4.374.616-.493 1.233-.996 1.86-1.48-.589.816-1.13 1.632-1.7 2.42-.056.076-.113.133-.18.199-.246.247-.502.493-.758.75-.503.502-1.025.977-1.528 1.47-.417.418-.863.835-1.28 1.252-.086.086-.238.228-.238.228-.408.446-.398 1.139.01 1.5.01.009.019.009.028.018a.13.13 0 00.038.029c.019.019.047.028.066.047.02.01.048.029.067.038.019.01.047.02.066.029.029.009.048.019.076.028.029.01.048.019.076.019.029.01.057.01.076.019.028 0 .057.01.076.01h.085c.029 0 .057 0 .086-.01.028-.01.057-.01.085-.019.028 0 .057-.01.085-.019l.086-.028.085-.029c.029-.01.048-.028.076-.038.029-.01.048-.028.076-.038l.076-.047c.028-.02.047-.038.076-.057.019-.02.047-.038.066-.067.029-.028.057-.047.086-.075.01-.01.01-.02.019-.02a.075.075 0 01.038-.037.074.074 0 01.038-.038c.009-.02.018-.038.037-.048.01-.019.029-.038.038-.057.02-.019.029-.038.048-.057.019-.019.028-.038.047-.066a.29.29 0 00.048-.067c.019-.028.038-.047.057-.075l.056-.086c.02-.028.048-.057.067-.085.019-.029.047-.057.066-.095a.658.658 0 01.076-.095l.076-.104c.029-.038.048-.067.076-.105.029-.038.057-.076.076-.114l.085-.113c.029-.038.057-.086.086-.124.028-.038.057-.076.085-.123.029-.038.057-.085.085-.123.029-.038.057-.086.095-.124.029-.038.057-.085.095-.123l.095-.123c.029-.048.067-.086.095-.133.028-.038.066-.086.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.038.066-.085.095-.133.028-.037.066-.085.094-.132.029-.038.067-.086.095-.133a.608.608 0 01.095-.124c.029-.037.057-.085.095-.123.028-.038.057-.085.085-.123.029-.038.057-.086.086-.124l.085-.113c.029-.038.057-.076.076-.114l.086-.114c.028-.038.047-.076.075-.114a.423.423 0 01.076-.104c.029-.038.048-.076.076-.105l.076-.104c.2-.285.39-.579.636-.806.247-.228.484-.475.72-.712.722-.721 1.472-1.414 2.192-2.135.722-.72 1.471-1.423 2.192-2.135.237-.237.494-.464.73-.711.485-.474.988-.94 1.462-1.414.246-.237.493-.465.73-.702.484-.484.978-.949 1.462-1.414.74-.702 1.451-1.432 2.2-2.115.124-.114.247-.237.361-.351.36-.36.74-.702 1.1-1.063.238-.237.475-.484.722-.712.123-.113.265-.208.398-.322.797-.645 1.594-1.3 2.382-1.945.93-.76 1.869-1.509 2.79-2.258-6.51 6.708-13.018 13.434-19.47 20.2-.028.028-.047.056-.085.085-.01.019-.029.028-.038.047.019-.01.029-.028.047-.038a581.15 581.15 0 005.437-5.38c1.129-1.129 2.248-2.267 3.358-3.387.674-.673 1.338-1.366 2.012-2.04.901-.9 1.774-1.83 2.675-2.732 1.803-1.803 3.568-3.643 5.37-5.446l2.581-2.58a.81.81 0 01.133-.105c.047.142.142.237.18.37.038.123.048.275.076.408.066.332.123.674.18 1.006.342 2.96.826 7.21.873 7.552.162 1.148.332 2.305.494 3.454.38 2.628 2.239 13.13 2.58 13.852.162.35.484.702.892.74.408.037.883-.38.93-.788.066-.531-.142-1.053-.142-1.584v-3.957c0-.408 0-.816-.01-1.224-.019-.73-.057-1.47-.114-2.2-.114-1.48-.341-2.923-.531-4.394a90.661 90.661 0 01-.266-3.055c2.325 4.545 6.964 13.653 6.964 13.653.105.152.494.142.902-.028.436-.18.711-.484.635-.664v-.01c-1.85-4.601-3.69-9.212-5.578-13.785a350.654 350.654 0 013.68 4.933c.077.114.162.2.228.313.076.114.105.237.162.38.73 1.783 1.546 3.53 2.343 5.19-.977-1.699-1.84-3.52-2.647-5.399 0-.01-.01-.01-.01.01.504 1.27.987 2.542 1.538 3.776.54 1.223 1.167 2.4 1.85 3.481.322.522.673 1.063 1.081 1.576.285.35.645.711.987 1.015.332.284.94.55 1.509.398.332-.085.569-.285.768-.56.19-.265.304-.616.285-1.024a3.667 3.667 0 00-.247-1.091c.37-.162.75-.342 1.1-.513.048-.019.115-.038.152-.076-.73-1.556-1.499-3.093-2.22-4.658-.72-1.556-1.499-3.093-2.22-4.658-.73-1.566-1.49-3.103-2.22-4.659-.74-1.547-1.527-3.074-2.249-4.62.285.104.598.18.873.294 3.274 6.764 6.566 13.52 9.934 20.199.01.019.028.019.01 0-3.112-6.68-6.272-13.368-9.384-20.02 3.52 1.158 7.059 2.297 10.607 3.435.02 0 .02-.01 0-.01-1.783-.654-3.586-1.26-5.38-1.897a449.786 449.786 0 00-5.398-1.888c0-.01-.01-.01-.019-.019-.18-.427-.408-.853-.578-1.252 1.584.512 3.216 1.025 4.81 1.518.228.066.455.152.683.218 2.325.702 4.64 1.423 6.992 2.06.465.122.92.293 1.376.435.911.285 1.822.598 2.723.892.901.304 1.803.608 2.685.93.664.247 1.338.474 1.983.75l.465.265c.038.01.085.02.133.01.474-.02 1.1-.854 1.442-1.983.38-1.233.275-2.438-.218-2.58 0 0-.285-.048-.304-.058.114-.54.057-.967-.256-1.062-.028-.01-7.571-2.43-11.243-3.587-.531-.17-1.063-.332-1.603-.503-2.088-.654-4.166-1.309-6.262-1.954.227 0 .455-.01.692-.01.408.133 3.321 1.063 4.222 1.348 1.509.474 2.97.92 4.45 1.395 1.414.455 4.279 1.385 4.298 1.385 0 0 .047.019.095-.01.114-.057.247-.218.313-.427.066-.237.057-.465 0-.569 0 0-.019-.047-.076-.066-.038-.01-.066-.02-.095-.029-.408-.142-.806-.284-1.205-.427-1.404-.474-2.799-.94-4.184-1.423-.92-.323-1.85-.636-2.78-.949-.332-.104-.664-.227-.986-.341 9.108-.313 18.87-1.025 15.123-1.651zM22.605 46.92c-.541-.124-1.063-.323-1.566-.484.143.01.275.076.418.114.275.085.56.17.854.246.133.038.284.067.398.124-.019.038-.066.01-.104 0zm23.7-19.555c.029-.218.047-.455.066-.673.038-.323.086-.626.114-.92.133.806.228 1.641.37 2.447.038.228.086.522.095.807-.19-.399-.389-.825-.588-1.243-.029-.066-.076-.133-.076-.18-.019-.076.01-.152.02-.238zm-.256 2.06c.019-.162.057-.4.076-.55.266.54.54 1.11.806 1.669.038.085.095.152.114.228.02.085.01.19.02.284.018.266.028.55.047.845-.323-.683-.674-1.433-1.016-2.145-.057-.123-.066-.16-.047-.332zm-.36-8.559c-.048.475-.114.987-.162 1.462-.076.702-.152 1.394-.218 2.058.161-1.214.303-2.447.474-3.643.057.228.01.522-.019.788-.114 1.347-.275 2.742-.408 4.08-.066-.134-.133-.257-.199-.4a.886.886 0 01-.057-.141c-.01-.086.02-.2.038-.304.18-1.518.37-3.121.55-4.592.076.2.02.455 0 .692zm-2.676 2.268c-.038-.332-.085-.645-.123-.977.645 1.31 1.261 2.637 1.907 3.947-.029.218-.057.436-.076.664-.58-1.205-1.13-2.42-1.708-3.634zm1.575 4.659a4.136 4.136 0 00-.048.36c-.398-.873-.759-1.755-1.157-2.647-.029-.057-.067-.114-.086-.17-.037-.134-.018-.285-.056-.409.464.949.891 1.917 1.347 2.866zm-2.192-4.725c.17.341.323.702.484 1.043.01.105.028.19.028.304-.17-.37-.332-.76-.502-1.12.01-.095-.02-.152-.01-.227zm.209-1.518c.028.303.066.588.095.882-.18-.36-.342-.75-.522-1.11-.028-.294-.066-.579-.095-.863.18.36.342.74.522 1.09zm-.712-2.59c-.028-.285-.066-.55-.095-.835.2.398.37.816.56 1.223.029.228.048.446.076.684-.18-.352-.351-.721-.54-1.073zm.693.9c.398.883.806 1.756 1.167 2.676-.029.029-.029-.019-.038-.028-.095-.123-.17-.294-.247-.446a81.71 81.71 0 01-.673-1.3c-.048-.085-.114-.17-.133-.256-.029-.085-.029-.209-.038-.313 0-.114-.029-.218-.038-.332zm2.144 8.265c.095.16.161.341.247.502 0 .152-.038.276-.048.418-.085-.17-.151-.351-.237-.522.01-.142.038-.256.038-.398zm.2-.902c-.02-.038-.058-.085-.067-.123-.01-.076.028-.228.038-.323.019-.123.028-.246.047-.341.095.161.162.341.257.503-.029.227-.067.436-.086.673-.076-.114-.133-.256-.19-.389zM33.98 5.402c-.018-.038-.037-.114-.066-.162-.019-.047-.057-.095.029-.114.028-.01.038.038.047.057.076.171.152.36.228.541.588 1.433 1.205 2.922 1.802 4.374-.683-1.547-1.356-3.14-2.04-4.696zm2.183 2.789c-.247-.55-.503-1.12-.769-1.708-.199-.436-.446-1.006-.673-1.49 0-.028-.029-.075-.038-.113-.038-.105-.048-.076.038-.105.057.048.066.133.095.2.702 1.527 1.432 3.083 2.153 4.62.996 2.135 2.002 4.26 3.008 6.414.209.446.436.93.664 1.404.028.066.085.133.095.19.019.057.01.132.019.199.019.18.057.389.076.579-1.585-3.359-3.112-6.774-4.668-10.19zm4.857 2.135c.038.095.048.227.067.35-.01-.255-.057-.521-.086-.777a152.393 152.393 0 01-.341-3.15c-.038-.351-.02-.76.18-1.063.161-.247.493-.493.797-.484.55.02 1.006.712 1.177 1.158.114.265.227.56.313.844.085.285.151.57.246.864.36 1.186.646 2.41.902 3.652.256 1.243.503 2.553.711 3.852.19 1.158.36 2.258.55 3.435.02.17.067.341.067.503 0 .104-.029.218-.038.332-.19 1.603-.417 3.33-.607 4.924-.73-1.556-1.5-3.207-2.249-4.8-.047-.105-.114-.22-.142-.314-.047-.152-.047-.341-.076-.522-.161-1.224-.313-2.429-.474-3.662-.2-1.452-.37-2.856-.56-4.317.01.332.066.664.104.996.275 2.325.522 4.678.788 7.03-.162-.331-.332-.683-.494-1.034-.019-.047-.057-.104-.066-.142-.019-.066-.019-.161-.029-.247-.132-1.176-.246-2.419-.37-3.586-.132-1.3-.275-2.571-.37-3.842zm-3.387 9.43c.076.133.171.39.228.522 1.271 3.065 2.533 6.13 3.824 9.194.17.398.341.825.512 1.243.028.057.057.114.076.17.028.124.019.228.038.37-1.566-3.842-3.103-7.6-4.64-11.394a.594.594 0 00-.038-.086c-.01-.019-.038-.075 0-.019zm2.107 30.408c.142-.142.284-.313.436-.455.114.038.237.066.342.104.028.01-.029.057-.048.067-.161.17-.36.37-.54.531a2.415 2.415 0 00-.314-.104c0-.048.076-.095.124-.143zm-.323-.009c-.019.019-.038.057-.066.057-.038-.02.028-.048.047-.067.152-.16.332-.35.484-.502-.123.133-.304.35-.465.512zm-1.803-30.456c-.028.01-.038-.085-.057-.113-.01 0-.01-.01-.01-.02.03.039.039.096.067.134zm-.085-.18c.01.01.01.02.019.029 0 .019-.019-.02-.019-.029zm0-.019c-.01.02-.019-.01-.019-.028.01.01.01.019.019.028zm-.048-.104c0 .019-.019-.02-.019-.029.01 0 .02.02.02.029zm-.028-.076c.01.01.01.019.019.028-.01.02-.028-.018-.019-.028zm0-.019c-.01.019-.019-.019-.019-.028 0 .009.01.018.02.028zm-.047-.104c0 .019-.02-.01-.02-.029.01.01.01.02.02.029zm.019.038c0 .019-.02-.02-.02-.029.01.01.01.02.02.029zm.996 9.05c.522 1.092.92 2.25 1.395 3.388-.257-.531-.55-1.053-.797-1.594-.247-.56-.465-1.129-.703-1.689-.474-1.12-.939-2.258-1.404-3.377.522 1.081.996 2.182 1.509 3.273zm-1.272.997c.285.57.522 1.167.778 1.755.257.588.513 1.167.76 1.765-.94-1.566-1.86-3.188-2.761-4.81-.152-.275-.304-.541-.456-.816-.152-.275-.275-.57-.398-.864a465.694 465.694 0 01-2.942-7.153c0-.038.048.047.057.066.541 1.082 1.082 2.182 1.632 3.264.57 1.129 1.1 2.267 1.66 3.387.57 1.139 1.11 2.277 1.67 3.406zM31.59 6.037c.342.826.674 1.68 1.016 2.505.047.123.085.247.161.351-.322-.987-.683-1.945-1.043-2.903l.047-.02c.94 2.098 1.85 4.223 2.76 6.348-.142.057-.293.114-.426.19-.351-.807-.683-1.594-1.025-2.4-.114-.266-.218-.541-.322-.817-.219-.54-.465-1.043-.702-1.574-.228-.503-.437-1.035-.484-1.68h.019zm-.37.133l.03-.01c.834 2.002 1.697 4.014 2.551 6.025.029.067.095.2.124.304 0-.01.028.047.028.047 0 .038-.01.029-.038.038-.038.02-.047 0-.066-.047a2.17 2.17 0 01-.114-.313c-.816-2.03-1.68-4.033-2.514-6.044zm-1.574 12.22c.047.038.057.104.095.152.208.38.436.768.616 1.195.2.484.408.978.588 1.48-.455-.92-.863-1.887-1.3-2.827zm.806 1.5c0-.039.01 0 .02 0 .54 1.014 1.09 2.049 1.64 3.064.095.17.2.332.276.512 1.755 4.222 3.52 8.501 5.427 12.59.151.332.322.655.474 1.006 0 .01.047.038.01.047-.038-.019-.095-.038-.143-.056-2.656-5.636-5.209-11.376-7.704-17.164zm1.404 19.013c.294.113.589.246.883.389 1.698.797 3.453 1.584 5.18 2.381l-1.48.958a8.503 8.503 0 01-.513-.246c-.588-.295-1.223-.56-1.84-.826-.418-.17-.825-.36-1.243-.54-1.224-.541-2.467-1.12-3.596-1.746-.303.047-.588-.029-.835-.114-.72-.247-1.385-.617-2.03-.959a1.436 1.436 0 01-.161-.094 79.947 79.947 0 00-1.803-.93c-.228-.114-.446-.228-.693-.313 0-.01 0-.01.01-.01 2.467.503 4.867 1.072 7.201 1.718.304.085.607.218.92.332zm5.598 5.275c-.218-.057-.427-.162-.645-.247l-.512-.2c.038-.018.066-.037.104-.047.37.152.721.314 1.053.494zm-11.528-9.46c.076.01.162.057.247.095.086.038.18.057.247.095.047.029.104.086.152.124.142.123.313.265.455.38-.484-.19-.987-.447-1.49-.655.133-.01.257-.057.39-.038zm-4.544-.635c.408.19.825.389 1.233.57 1.234.54 2.448 1.147 3.7 1.697-2.04-.427-4.136-.806-6.233-1.205-.142-.028-.294-.038-.408-.085-.057-.019-.114-.066-.17-.104l4.345.341s-2.306-1.09-4.962-2.182c.199.066.398.123.588.18.237.067.474.105.683.21.417.189.806.388 1.224.578zm-4.753-3.52c1.12.398 2.239.787 3.32 1.167a6.502 6.502 0 01-.465-.114c-.455-.123-.92-.266-1.366-.398.038-.02-.01 0 .048 0-.18-.048-.247-.076-.427-.105-.18-.028-.37-.038-.541-.095-.142-.038-.285-.133-.437-.199-.076-.038-.151-.057-.227-.085-.209-.095-.408-.2-.646-.304-.16-.066-.341-.114-.445-.228.417.038.854.247 1.186.36zm7.03 8.15c.36.209.768.427 1.139.636-.76-.314-1.519-.646-2.278-.978a649.908 649.908 0 00-6.888-2.922c.152 0 .294.038.446.067h.01l1.584.341c.266.133.56.275.854.36.218.067.475.086.721.086.228 0 .465.01.645.076l1.765 1.195.19.086 3.833 1.613 4.222 1.935c-2.125-.863-4.28-1.708-6.395-2.59.057.028.104.066.152.095zm2.619 6.926c.151.019.303.076.455.123.446.133.92.275 1.376.408-.02.02-.029.01-.048 0-.303-.066-.607-.161-.91-.247-.314-.075-.598-.19-.873-.284zm.958.332c2.353.683 4.706 1.347 7.05 2.03.028.01-.02.038-.02.048-.095.095-.237.199-.341.294-2.23-.788-4.47-1.556-6.69-2.372-.009 0-.009.01 0 0zm2.372 3.397c.816.218 1.613.455 2.429.664a.406.406 0 01-.133.123c-.74-.266-1.556-.522-2.296-.788zm4.004 1.982c-2.77 2.23-5.532 4.46-8.293 6.699-.019.01-.019.01-.01-.01.912-.882 1.803-1.783 2.752-2.637.152-.143.294-.304.456-.446.152-.143.313-.285.455-.437.579-.616 1.205-1.195 1.803-1.793.446-.446.92-.873 1.375-1.319.152-.151.304-.294.475-.427l1.005.342c.02 0-.018.019-.018.028zm.521-.436c-.35-.123-.702-.247-1.062-.36.01-.067.123-.114.161-.18.398.104.778.217 1.176.322-.094.076-.17.161-.275.218zm-.74-5.74c-3.121-.987-6.271-1.955-9.355-2.96 4.156 1.271 8.35 2.514 12.467 3.823-.047.067-.095.076-.17.057-.19-.047-.399-.123-.589-.18-.787-.237-1.584-.493-2.353-.74zm1.651 3.558c0-.048.048-.076.086-.105.094-.085.199-.18.294-.275 0-.01.019-.01.019-.019.474.124.93.266 1.394.399-.17.142-.35.285-.521.427-.427-.133-.845-.294-1.272-.427zm.598 2.704c.114-.105.228-.2.351-.294l.484.142c-.095.114-.19.228-.294.323-.18-.048-.36-.124-.541-.171zM19.37 76.626c.844-.721 1.717-1.452 2.57-2.183 2.913-2.495 5.807-5.047 8.71-7.561-.218.35-.474.692-.72 1.043-.039.048-.067.114-.096.152-.047.057-.142.114-.208.171-1.016.835-2.06 1.727-3.065 2.571.162-.095.313-.209.465-.313-.636.56-1.28 1.1-1.954 1.632-2.002 1.594-4.033 3.188-6.035 4.782.076-.105.21-.19.332-.294zm1.3-.73c-.864.72-1.746 1.48-2.61 2.21-.028.019-.047.047-.076.066 0-.047-.01-.095-.019-.152.029-.038.057-.066.086-.094.066-.058.133-.086.209-.124.056-.038.113-.095.17-.142.864-.693 1.774-1.404 2.628-2.106-.113.123-.256.227-.389.341zm.436-.37c-.067.047.019-.01 0 0zm5.711-4.28c-.702.607-1.442 1.205-2.172 1.812-.968.797-1.945 1.604-2.932 2.382.104-.114.228-.2.351-.294.37-.295.74-.589 1.091-.892.474-.408.949-.816 1.423-1.234.475-.408.93-.844 1.423-1.224.494-.389.987-.778 1.5-1.148-.19.219-.447.399-.684.598zm-.066-.123a.585.585 0 01.133-.133c.332-.294.673-.607 1.043-.892.36-.284.721-.57 1.073-.854-.01.086-.105.124-.18.19-.674.54-1.395 1.129-2.07 1.689zm1.964.531c.133-.209.285-.408.436-.626.048-.067.095-.152.143-.209.057-.057.123-.095.19-.142.417-.332.853-.693 1.261-1.034-.635.673-1.357 1.338-2.03 2.011zm1.508-11.973c-.056.047-.16.17-.18.17-.01 0 .086-.094.105-.113.256-.276.53-.55.768-.816.142-.162.313-.294.446-.456.57-.617 1.186-1.214 1.774-1.84.721-.769 1.49-1.537 2.22-2.296.152-.152.304-.304.446-.465.142-.152.294-.304.446-.465.218-.237.437-.456.664-.683.076-.076.133-.171.228-.219.028.02.066.029.104.038-.408.484-.854.94-1.271 1.423.465-.455.91-.939 1.385-1.385.105.038.209.076.323.105-.456.503-.949.958-1.414 1.46l-.104.105c-.029.038-.048.086-.076.114-.057.057-.133.114-.19.17-1.898 1.728-3.785 3.416-5.674 5.153zm8.16-10.418c-.123.152-.304.313-.446.465-.057-.01-.095-.028-.142-.047.19-.171.398-.323.597-.494.01 0 .01.01.02.01.028.019-.02.047-.03.066zm.076 2.619c0 .038-.038.066-.067.095-.085.095-.199.19-.294.284a1.531 1.531 0 01-.313-.114c-.038-.01.02-.028.02-.038.084-.094.208-.227.303-.322.133.019.227.076.35.095zm-.589-.171c.029.01.067.019.095.028a4.174 4.174 0 01-.332.37c-.038-.009-.057-.028-.095-.028-.009-.038.048-.066.076-.095.086-.076.171-.19.257-.275zm-3.235 12.315c-.085.104-.199.18-.303.275-.313.266-.646.54-.959.816.057-.104.143-.209.219-.313.028-.038.047-.085.066-.114a1.14 1.14 0 01.247-.17c.237-.162.502-.323.73-.494zm3.786-2.495c-1.917 1.499-3.843 3.045-5.76 4.554.143-.2.266-.39.456-.55.626-.541 1.272-1.101 1.898-1.66.227-.2.455-.409.702-.58 1.034-.683 2.059-1.385 3.074-2.077a2.921 2.921 0 01-.37.313zm.664-14.611c-.522-.152-1.044-.304-1.547-.465-.037-.01.038-.057.057-.076.522.152 1.035.323 1.556.474-.019.038-.047.048-.066.067zm.047-3.283c-.019 0-.104-.038-.17-.057a26.486 26.486 0 01-1.31-.455c.484-.219.977-.437 1.386-.636.132.285.275.579.408.863-.029.067-.086.095-.143.152-.047.047-.114.133-.17.133zM39.19 59.7c-.01-.02.02-.029.029-.038.161-.143.332-.285.503-.427a39.532 39.532 0 011.537-1.224 3.52 3.52 0 01-.342.313c1.262-1.053 2.562-2.163 3.843-3.245.18.066.36.123.54.18-2.02 1.49-4.08 2.951-6.11 4.44zm7.116-5.352c-.17.171-.36.38-.55.541-.19-.057-.36-.123-.541-.18.218-.2.455-.389.674-.579.16.038.313.095.483.133.01.038-.047.057-.066.086zm-.37-22.988c-.028-.066-.076-.152-.076-.2-.01-.075.02-.16.029-.246l.028-.266c.437.911.854 1.84 1.29 2.752.02.322.038.645.057.968-.446-.987-.882-1.993-1.328-3.008zm4.82 28.72l.028.976c-.512-.986-1.015-1.992-1.527-2.979.066.067.133.152.19.237.426.58.882 1.177 1.309 1.765zm-1.452-4.896c.057.17.123.313.18.483a7.45 7.45 0 01-.407-.55c.075.019.142.047.227.067zM48.27 32.82c.152.294.285.607.446.901.01.105.01.209.019.313-.152-.322-.294-.664-.456-.986.01-.095-.009-.152-.009-.228zm.218 2.002c-.038-.086-.104-.17-.123-.266-.02-.085-.01-.218-.02-.332-.018-.266-.028-.57-.047-.863.086.17.228.474.333.683.047.085.104.18.113.275.02.123.01.313.02.465 0 .047.018.114.009.142-.02.076-.105.114-.17.162a2.77 2.77 0 00-.115-.266zm.143 22.42c.047.028.075.085.113.123.029.047.086.085.105.142.019.047.038.114.057.161.057.143.133.313.18.465-.161-.285-.294-.598-.455-.892zm1.29 5.995c-.114-.227-.37-.91-.674-1.764-.066-.313-.114-.626-.17-.94.521.959 1.034 2.069 1.574 3.075.076.142.162.294.219.446v.018c.028.133.019.314.019.465 0 .2.01.399.019.598a89.041 89.041 0 01-.987-1.897zm12.77 12.866c.162.218.332.455.494.683.446.598.901 1.186 1.338 1.803.218.303.445.616.578.986-.01.038-.066-.047-.095-.076a15.839 15.839 0 01-1.318-1.622c-.437-.626-.797-1.31-1.177-1.973.076.056.123.123.18.199zM56.6 51.986c.758.2 1.517.399 2.276.588l-.095.086c-.73-.228-1.46-.456-2.182-.674zm1.157 3.662c-.313-.085-.627-.18-.94-.265-.123-.257-.256-.494-.38-.75.324.104.646.2.978.285.114.246.228.484.342.73zm.114-4.857c0 .01.037.019 0 .019a147.73 147.73 0 00-2.192-.693c-.076-.123-.123-.275-.2-.398.105.018.2.085.304.123.683.313 1.395.636 2.088.949zm-1.5-3.729c-.199.18-.398.36-.607.531-.55-.246-1.081-.512-1.632-.759-.17-.389-.36-.778-.54-1.157.095-.114.208-.19.313-.285 1.034.37 2.03.769 3.064 1.13-.19.189-.398.36-.598.54zm-1.375 2.827c-.228-.076-.446-.152-.674-.218.104-.123.228-.228.351-.332.038 0 .048.019.086.029.066.17.16.341.237.521zm-.883-.816c-.066.076-.151.152-.237.228-.028.02-.047.057-.085.057-.066-.18-.152-.341-.218-.512.199.066.36.161.54.227zm3.805-3.377c-1.044-.36-2.087-.702-3.13-1.063-.039-.01.028-.047.047-.066.038-.029.066-.067.104-.095 1.034.37 2.05.75 3.083 1.11 0 .038-.075.076-.104.114zm3.89 1.043c2.173.76 6.338 2.202 8.548 2.932l.219.086c.066.019.16.028.19.094-.058.057-.21.048-.295.02a.381.381 0 01-.152-.096c-2.21-.768-6.356-2.22-8.51-3.036-.019 0-.019.01 0 0zm7.818 2.989c.085.029.17.047.246.076.228.085.475.18.712.266.047.019.114.028.142.075-.863-.303-3.69-1.261-4.554-1.565-2.561-.901-5.133-1.803-7.723-2.704.029-.038.067-.066.095-.095 3.036 1.091 8.055 2.846 11.082 3.947zm6.897-19.526c-.16.152-.36.266-.55.418-1.3.977-2.58 2.002-3.852 3.007-2.903 2.315-5.73 4.735-8.539 7.164-1.357 1.176-2.713 2.353-4.08 3.53-.038.037-.075.075-.132.084-1.034-.35-2.06-.72-3.103-1.072-.028-.028.029-.057.038-.066.142-.142.332-.285.484-.427.54-.484 1.11-.977 1.66-1.461.37-.323.75-.655 1.11-.977.19-.162.36-.342.55-.494.95-.778 1.917-1.565 2.885-2.334.19-.151.427-.265.655-.398 4.155-2.439 8.529-4.697 12.874-6.974zm1.537-2.106c-1.442.797-2.94 1.528-4.402 2.296-.209.105-.408.228-.617.332-1.242.655-2.504 1.319-3.728 2.012.066-.076.151-.114.227-.171 1.234-.845 2.581-1.613 3.947-2.344.36-.199.75-.37 1.12-.56.37-.19.759-.36 1.138-.53.76-.361 1.537-.703 2.306-1.044.047 0 .01 0 .01.01zm2.904-4.8c.123-.03.246-.058.37-.077.256-.038.512-.047.768.01.057.01.105.028.161.038.057.01.124.01.171.028.095.029.209.124.285.2.18.16.313.332.446.53a.942.942 0 01.152.361c.028.152 0 .352-.029.494-.161.854-.892 1.233-1.537 1.613l-.161.104c-.057.028-.142.066-.171.085-.095.057-.237.133-.266.152-.076-.019-.16-.066-.265-.038.095-.047.322-.151.427-.199a9.567 9.567 0 001.556-1.063c.19-.18.332-.502.332-.872 0-.399-.237-.703-.456-.93-.076-.076-.151-.171-.237-.218a1.444 1.444 0 00-.398-.152c-.38-.086-.835-.01-1.205.066-.73.142-1.433.342-2.107.55-.93.285-1.812.608-2.647.902a30.098 30.098 0 014.81-1.585zm-7.325 4.715l.218-.171c-.019-.029-.066-.085-.142-.18.55-.351 1.1-.702 1.717-.978.617-.275 1.29-.483 1.964-.72.987-.361 1.993-.684 3.065-.968.246-.067.484-.143.75-.19.113-.02.237-.038.36-.038.028.01 0 .028-.01.038-.227.17-.531.322-.806.465-.588.313-1.186.607-1.812.892-.313.142-.645.256-.968.389-.323.132-.645.256-.968.389-.939.398-2.656 1.224-2.799 1.309-.692.341-1.366.711-2.02 1.081.227-.237.53-.483.844-.749.17-.17.389-.38.607-.57zM54.332 40.05c.246-.219.512-.446.711-.627a294.06 294.06 0 012.894-2.476c.247-.209.493-.408.73-.617.712-.626 1.405-1.28 2.107-1.916 1.888-1.708 3.738-3.387 5.645-5.085.949-.845 1.898-1.699 2.837-2.534 1.423-1.233 2.846-2.523 4.336-3.719.512-.408 1.034-.816 1.584-1.148-.806 1.385-1.973 2.467-3.207 3.473-.246.199-.474.417-.711.626-.902.778-1.784 1.546-2.695 2.315-.028.028-.066.047-.095.076-.493.427-1.024.863-1.527 1.3-.958.825-1.945 1.622-2.894 2.447-.949.835-1.897 1.66-2.856 2.486l-1.432 1.233-2.856 2.486c-1.423 1.243-2.913 2.42-4.355 3.653-.057-.028-.275-.057-.323-.104-.028-.038-.028-.01 0-.038a.71.71 0 01.133-.114c.664-.57 1.329-1.148 1.974-1.717zm-.959 6.423c-.16-.067-.303-.143-.465-.209.076-.085.171-.142.247-.228.01 0 .02 0 .02.01.056.142.132.275.198.427zm.959-8.634c-.702.702-1.376 1.404-2.088 2.116-.01.01-.047.038-.066.066-.028.029-.028.057-.066.038-.02-.01-.038-.066-.029-.095 0 .01.067-.057.076-.066 1.47-1.414 2.922-2.875 4.383-4.289-.702.702-1.46 1.49-2.21 2.23zm-3.046-3.359c0-.095-.019-.208 0-.294.01-.057.123-.123.2-.19.199-.18.407-.38.607-.54.825-.721 1.64-1.443 2.447-2.164.276-.237.56-.474.826-.711.142-.123.275-.237.408-.36.673-.589 1.366-1.196 2.04-1.784-1.063 1.148-2.163 2.296-3.255 3.453-.816.864-1.631 1.727-2.438 2.61-.266.284-.531.578-.816.844 0-.256-.019-.58-.019-.864zm.066 3.862c.01-.076.21-.237.304-.332.721-.74 1.423-1.528 2.125-2.268.304-.322.598-.654.902-.986.493-.532 1.015-1.082 1.508-1.613.702-.769 1.423-1.509 2.125-2.268.095-.114.21-.209.304-.323.797-.873 1.68-1.67 2.514-2.504.418-.418.854-.816 1.281-1.243 1.253-1.253 2.552-2.467 3.843-3.69l.654-.599c.655-.588 1.3-1.205 1.983-1.783.456-.39.911-.769 1.367-1.148.464-.38.93-.76 1.404-1.12.01-.01.019 0 .01 0-2.458 2.6-5 5.123-7.506 7.685-.626.645-1.252 1.271-1.888 1.907-.104.105-.218.2-.322.304-.057.057-.095.123-.142.17l-9.014 9.014c-.322.313-.645.626-.958.94-.076.075-.152.16-.237.236-.029.02-.048.057-.086.048-.047-.143-.152-.237-.161-.418v-.01h-.01zm.636 17.875l.74 1.062c-.237-.085-.474-.161-.711-.246-.02-.266-.02-.541-.029-.816zm3.9 14.829c-.01.038-.038-.057-.057-.085-.294-.55-.589-1.139-.873-1.699-.304-.607-.617-1.214-.92-1.812-.608-1.214-1.243-2.42-1.85-3.615-.01-.626-.038-1.243-.048-1.878a491.542 491.542 0 013.748 9.089zm1.556-4.526c-.408-.522-.797-1.072-1.186-1.613-1.148-1.584-2.306-3.15-3.463-4.734-.095-.133-.171-.351-.247-.522-.142-.35-.285-.692-.427-1.053-.028-.066-.076-.152-.085-.209-.02-.142 0-.303-.01-.455-.01-.152-.01-.304-.019-.446.37.123.73.247 1.1.36l3.264 4.725c.38 1.329.703 2.647 1.073 3.947.01.01.01.01.019.01 0 .01-.02 0-.02-.01zM57.13 56c-.018-.019-.018-.047-.037-.066 0-.01.01 0 .01 0 .236.066.502.133.758.2.067.018.18.037.19.132-.313-.085-.607-.18-.92-.266zm4.944 16.433c-.845-1.082-1.718-2.182-2.572-3.292-.056-.076-.142-.152-.18-.218-.047-.086-.066-.21-.104-.304-.38-.977-.73-1.973-1.072-2.998l3.928 6.812zM59.72 59.7c-.285-.076-.598-.2-.883-.294-.199-.408-.408-.816-.607-1.234.304.095.588.2.883.275.199.418.389.845.607 1.253zm22.21 2.334c.067-.067.133-.067.19-.067.038.133.038.351.01.513-.02.151-.067.341-.18.379-.086.029-.247-.029-.39-.066-1.84-.465-3.68-.987-5.484-1.49-1.47-.398-2.912-.806-4.373-1.205-3.88-1.063-7.752-2.163-11.632-3.254-.37-.105-.788-.209-1.177-.332-.01-.01-.028-.01-.047-.02-.105-.047-.228-.018-.247-.151.01 0 .01 0 .01.01.483.123.958.265 1.432.388 1.433.37 2.875.769 4.327 1.158 1.926.512 3.87 1.006 5.806 1.499 1.936.493 3.862 1.006 5.788 1.518.474.133.939.275 1.413.408.721.2 1.442.38 2.182.56.247.057.494.114.722.19.464.151.91.313 1.366.455.057-.047.095-.114.085-.18-.01-.105-.133-.143-.246-.171.151.028.303-.029.445-.142zm-.55.104c.02.01.038.019.067.028h.019c-.029-.01-.058-.01-.086-.019v-.01zm-2.998-.91c.17.047.275.084.398.122.845.266 1.708.522 2.562.788a2.4 2.4 0 01-.446-.066c-.095-.029-.199-.076-.294-.114a41.71 41.71 0 00-2.097-.683c.18.066.37.132.55.199-.18-.029-.36-.086-.54-.142-1.234-.37-2.496-.76-3.729-1.158-1.413-.455-2.837-.873-4.25-1.338 2.637.788 5.237 1.585 7.846 2.391zm-14.62-4.422c.18.057.37.123.55.19.901.322 1.85.635 2.77.93 3.017.948 6.044 1.859 9.023 2.827-5.93-1.623-11.84-3.273-17.742-4.934-.057-.038-.057-.114-.085-.17-.086-.171-.18-.352-.257-.541.769.227 1.537.446 2.296.683 1.158.341 2.296.664 3.444 1.015zm2.646-3.824a.763.763 0 00-.151-.398c4.25-.123 11.48-.304 12.931-.162 1.509.143-7.675.418-12.78.56z",
    fill: "#5A12AA"
  })));
}

const NAME_TO_LOGO_SVG_MAP = {
    horizontal_logo: SvgHorizontalLogo,
    horizontal_logo_reverse: SvgHorizontalLogoReverse,
    vertical_logo: SvgVerticalLogo,
    vertical_logo_reverse: SvgVerticalLogoReverse,
    asterisk_logo: SvgAsteriskLogo,
};
const Logo$1 = ({ name, height, width, fill, className }) => {
    const svg = NAME_TO_LOGO_SVG_MAP[name];
    const defaultHorizontalHeight = 88;
    const defaultHorizontalWidth = 224;
    const defaultVerticalHeight = 112;
    const defaultVerticalWidth = 88;
    const definedHeight = () => {
        if (!height) {
            if (name === 'vertical_logo' || name === 'vertical_logo_reverse') {
                return defaultVerticalHeight;
            }
            return defaultHorizontalHeight;
        }
        return height;
    };
    const definedWidth = () => {
        if (!width) {
            if (name === 'vertical_logo' || name === 'vertical_logo_reverse') {
                return defaultVerticalWidth;
            }
            return defaultHorizontalWidth;
        }
        return width;
    };
    return svg ? (React__default.createElement(SvgIcon, { component: svg, className: className, height: definedHeight(), width: definedWidth(), fill: fill })) : null;
};

const Anchor = styled.a `
  text-decoration: none;
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
`;
const baseGoogleMapsLink = 'https://www.google.com/maps?';
const GoogleMapsLink = ({ children, latitude, longitude }) => {
    return (React__default.createElement(Anchor, { href: `${baseGoogleMapsLink}saddr=Current+Location&daddr=${latitude},${longitude}`, target: "_blank", rel: "noreferrer" }, children));
};

const Wrapper$1 = styled.div `
  ${({ theme: { borderRadius, palette } }) => css `
    display: inline-block;
    border-radius: ${borderRadius.r5};
    padding: 2px;

    &:focus-within {
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }
  `}
`;
const SwitchInput = styled.input `
  cursor: inherit;
  height: 100%;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: 1;
  position: absolute;
`;
const Label$1 = styled.label `
  ${({ checked, disabled, theme: { palette, borderRadius } }) => css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 42px;
    height: 24px;
    border-radius: ${borderRadius.r5};
    position: relative;
    transition: background-color 0.2s;
    background-color: ${checked
    ? palette.baseColors.lupin
    : palette.baseColors.mawheranui};
    opacity: ${disabled && 0.5};
  `}
`;
const Indicator$3 = styled.label `
  ${({ checked, theme: { palette, borderRadius } }) => css `
    content: '';
    position: absolute;
    top: 2px;
    left: ${checked ? 'calc(100% - 2px)' : '2px'};
    ${checked && 'transform: translateX(-100%)'};
    height: 20px;
    width: 20px;
    border-radius: ${borderRadius.round};
    transition: 0.2s;
    background: ${palette.baseColors.wairua};
  `}
`;
const CheckIcon = styled(Icon) `
  margin: 2px;
`;
const Switch = React__default.forwardRef((props, ref) => {
    const { checked, onChange, disabled, name, inputProps } = props;
    const { palette } = useTheme();
    // Ensuring only one click is passed
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled)
            return;
        onChange();
    };
    return (React__default.createElement(Wrapper$1, { onClick: handleClick },
        React__default.createElement(Label$1, { checked: checked, disabled: disabled },
            React__default.createElement(SwitchInput, Object.assign({ type: "checkbox", checked: checked, name: name, onChange: handleClick, ref: ref, "aria-label": name }, inputProps)),
            React__default.createElement(Indicator$3, { checked: checked }, checked ? (React__default.createElement(CheckIcon, { name: "check_extra_small", fill: palette.baseColors.lupin, size: 16 })) : null))));
});

const Iframe = styled.iframe `
  ${({ theme: { media, borderRadius }, height, width }) => css `
    height: calc(${height}px - 80px);
    width: ${width ? `${width}px` : '100%'};
    border: none;
    display: flex;
    align-items: center;

    ${media.up('slim')} {
      border-radius: ${borderRadius.r2};
    }
  `}
`;
const MaxWidthWrapper = styled.div `
  ${({ theme: { palette, borderRadius, media, spacing }, isLightMode, isGrey, height, isStorybookLinkVisible, }) => css `
    width: 100%;
    height: ${height}px;

    ${isGrey &&
    css `
      background: ${isLightMode
        ? palette.baseColors.onepu
        : palette.baseColors.greymouth};

      ${isStorybookLinkVisible &&
        css `
        height: calc(${height}px + ${spacing.s5});
      `}
    `}

    ${media.up('slim')} {
      border-radius: ${borderRadius.r2};
      height: ${height}px;
    }
  `}
`;
const CenterIframeWrapper = styled.div `
  ${({ theme: { spacing, media }, isGrey, isStorybookLinkVisible, height, }) => css `
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;

    ${isGrey &&
    css `
      padding: ${spacing.s5};

      ${isStorybookLinkVisible &&
        css `
        height: calc(${height}px + ${spacing.s5});
      `}
    `}

    ${media.up('slim')} {
      ${isStorybookLinkVisible &&
    isGrey &&
    css `
        height: ${height}px;
      `}
    }
  `}
`;
const StyledText$4 = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-right: ${spacing.s0_5};
  `}
`;
const StyledLink$1 = styled(Link$1) `
  ${({ theme: { media, zIndex, palette, borderRadius }, isGrey }) => css `
    ${bodySDemiStyle};
    color: ${isGrey ? palette.baseColors.benLomond : palette.baseColors.lupin};
    bottom: 48px;
    left: 8px;

    &:hover {
      color: ${isGrey
    ? palette.baseColors.wanaka
    : palette.baseColors.poroporo};
    }

    &:focus-visible {
      outline: 2px solid
        ${isGrey ? palette.baseColors.benLomond : palette.baseColors.lupin};
      border-radius: ${borderRadius.rHalf};
    }

    position: relative;
    z-index: ${zIndex.default};

    ${media.up('slim')} {
      bottom: 14px;
    }
  `}
`;
const StyledSwitch = styled(Switch) `
  ${({ theme: { palette } }) => css `
    position: absolute;
    color: ${palette.baseColors.wairua};
  `}
`;
const SwitchAndHeader = styled.div `
  ${({ theme: { media } }) => css `
    position: absolute;
    bottom: 2px;
    left: 8px;
    display: flex;
    align-items: center;

    ${media.up('slim')} {
      left: unset;
      right: 8px;
    }
  `}
`;
const RelativePositionedWrapper = styled.div `
  position: relative;
  display: flex;
  height: 0;
  bottom: 0;
  align-items: center;
`;
const LiveDemo = ({ storybookBaseURL, storyID, viewMode = 'story', height = 200, width, isStorybookLinkVisible, }) => {
    const sanitizedURL = `${storybookBaseURL.replace(/\/$/, '')}/`;
    const fullPath = `${sanitizedURL}iframe.html?id=${storyID}&viewMode=${viewMode}`;
    const storyPath = `${sanitizedURL}?path=/story/${storyID}`;
    const { palette } = useTheme();
    const [isLightMode, setLightMode] = useState(true);
    const isGreyBackground = viewMode === 'story';
    return (React__default.createElement(MaxWidthWrapper, { "data-testid": "max-width-wrapper", isLightMode: isLightMode, isGrey: isGreyBackground, height: height, width: width, isStorybookLinkVisible: isStorybookLinkVisible },
        React__default.createElement(CenterIframeWrapper, { isGrey: isGreyBackground, isStorybookLinkVisible: isStorybookLinkVisible, height: height },
            React__default.createElement(Iframe, { "data-testid": "live-demo", title: "LiveDemo", id: `LiveDemoFor${storyID}`, src: fullPath, height: height, width: width, isGrey: isGreyBackground, isLightMode: isLightMode, isStorybookLinkVisible: isStorybookLinkVisible })),
        React__default.createElement(RelativePositionedWrapper, null,
            isStorybookLinkVisible && (React__default.createElement(StyledLink$1, { href: storyPath, isGrey: !isLightMode }, "Demo component in Storybook")),
            React__default.createElement(SwitchAndHeader, null,
                React__default.createElement(StyledText$4, { color: isLightMode
                        ? palette.baseColors.lupin
                        : palette.baseColors.benLomond, variant: "bodySMedium" }, isLightMode ? 'Light background' : 'Dark background'),
                React__default.createElement(StyledSwitch, { checked: isLightMode, onChange: () => setLightMode(!isLightMode), name: "theme switcher" })))));
};

const PillTextContainer = styled.div `
  ${({ theme: { borderRadius, spacing }, color }) => css `
    background-color: ${color};
    padding: ${spacing.s0_5} ${spacing.s2};
    border-radius: ${borderRadius.r4};
    text-align: center;
    width: fit-content;
    white-space: nowrap;
  `}
`;
function Pill({ text, color }) {
    const { palette: { baseColors }, } = useTheme();
    const pillColor = color ? baseColors[color] : undefined;
    return (React__default.createElement(PillTextContainer, { color: pillColor },
        React__default.createElement(Text, { variant: "footnoteDemi", color: baseColors.wairua }, text)));
}

const StepperContainer = styled(Box) `
  ${({ theme: { media } }) => css `
    max-width: 1500px;

    ${media.down('slim')} {
      width: 367px;
    }
  `}
`;
function Stepper(_a) {
    var { steps, renderStep } = _a, rest = __rest(_a, ["steps", "renderStep"]);
    return (React__default.createElement(StepperContainer, Object.assign({ flexDirection: ['column', 'column', 'row'], pt: "s4", mr: "auto", ml: ['s0', 's0', 'auto'] }, rest), steps.map(renderStep)));
}

const FontStyles = {
    bodyMDemi: bodyMDemiStyle,
    bodyMMedium: bodyMMediumStyle,
    bodySDemi: bodySDemiStyle,
    bodySMedium: bodySMediumStyle,
    footnoteDemi: footNoteDemiStyle,
    footnoteMedium: footNoteMediumStyle,
    codeSnippet: codeSnippetStyle,
    headingL: headingLStyle,
    headingM: headingMStyle,
    headingS: headingSStyle,
    subheadingL: subheadingLStyle,
    subheadingM: subheadingMStyle,
};
const RawText = styled.div `
  ${({ theme: { palette, spacing }, variant, color, bulletColor, linkStyle, customHtmlStyles, isInline, }) => css `
    ${isInline ? 'display: inline;' : ''}

    h2 {
      ${headingMStyle}
    }
    h3 {
      ${headingSStyle}
    }
    h4 {
      ${subheadingLStyle}
    }
    h5 {
      ${subheadingMStyle}
    }
    h6 {
      ${bodyMDemiStyle}
      padding: ${spacing.s3} 0;
    }
    ol,
    ul {
      padding-left: ${spacing.s2};
    }

    p,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${color || palette.textColor};
      margin: 0;
    }

    p:first-child,
    h2:first-child,
    h3:first-child,
    h4:first-child,
    h5:first-child,
    h6:first-child {
      padding-top: 0;
    }
    ${FontStyles[variant]};

    p + p {
      padding-top: ${spacing.s2};
    }

    br {
      line-height: ${spacing.s3};
    }

    ${customHtmlStyles}

    a {
      ${LinkStyle}
      ${linkStyle === 'inverseMode' && InverseModeLinkStyle};
      ${linkStyle === 'inverseAlternateMode' && InverseAlternateLinkStyle}
      ${FontStyles[variant]};

      &:focus-visible {
        outline: 3px solid ${palette.baseColors.lupin};
        outline-offset: 2px;
        border-radius: 2px;
      }
    }

    ul {
      padding-left: ${spacing.s2};
      list-style: none;
      margin: 0;

      > li::before {
        content: '•';
        color: ${bulletColor || palette.textColor};
        display: inline-block;

        width: 16px;
        margin-left: -${spacing.s2};
      }
    }

    li {
      color: ${color || palette.textColor};
      ${bodySMediumStyle};
      margin-bottom: ${spacing.s1_5};
    }
  `}
`;
const RawTextWithCustomSpacing = styled(RawText) `
  ${({ theme: { spacing } }) => css `
    h2 {
      padding: ${spacing.s3} 0;
    }
    h3 {
      padding: ${spacing.s3} 0;
    }
    h4 {
      padding: ${spacing.s3} 0;
    }
    h5 {
      padding: ${spacing.s2} 0;
    }

    h6 {
      padding: ${spacing.s2} 0;
    }

    ol,
    ul {
      padding-left: ${spacing.s5};
    }

    ul {
      padding-top: ${spacing.s2};
    }
  `}
`;

const sanitizeHtml = (html) => {
    return DOMPurify.sanitize(html, {
        ADD_TAGS: ['iframe'],
        ADD_ATTR: ['target'],
    });
};
DOMPurify.addHook('beforeSanitizeAttributes', (node) => {
    // this is to check if the link is local or external as DOMPurify is adding target=_blank to all links after sanitizing
    // see https://github.com/cure53/DOMPurify/issues/782, https://github.com/cure53/DOMPurify/issues/317
    if (node instanceof HTMLAnchorElement) {
        if (node.target !== '_blank') {
            node.setAttribute('data-local-link', 'true');
        }
    }
});
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node instanceof HTMLAnchorElement) {
        // add rel=noopener for security, see https://web.dev/external-anchors-use-rel-noopener/
        node.setAttribute('rel', 'noopener');
        const isLocal = node.hasAttribute('data-local-link') &&
            node.getAttribute('data-local-link') === 'true';
        // all links has target=_blank so we need to replace it with target=_self
        if (isLocal) {
            node.setAttribute('target', '_self');
            node.removeAttribute('data-local-link');
        }
    }
});
const RawHtml = (_a) => {
    var { html, id, variant, componentStyleVariant, color, bulletColor, tableDemoStyle, isInline, children } = _a, rest = __rest(_a, ["html", "id", "variant", "componentStyleVariant", "color", "bulletColor", "tableDemoStyle", "isInline", "children"]);
    const contentProp = html
        ? {
            dangerouslySetInnerHTML: {
                __html: sanitizeHtml(html),
            },
        }
        : { children };
    let StyledRawHtml;
    switch (componentStyleVariant) {
        case 'additionalSpacing':
            StyledRawHtml = RawTextWithCustomSpacing;
            break;
        default:
            StyledRawHtml = RawText;
            break;
    }
    return (React__default.createElement(StyledRawHtml, Object.assign({}, rest, { id: id, html: html, variant: variant, componentStyleVariant: componentStyleVariant, color: color, bulletColor: bulletColor, tableDemoStyle: tableDemoStyle, isInline: isInline }, contentProp)));
};

const rotateCircleAnimation = keyframes `
from {
  transform: rotate(0);
}

to{
  transform: rotate(360deg);
}
`;
const OuterCircle = styled.div `
  ${({ isActive, theme: { palette } }) => css `
    position: relative;
    width: 48px;
    height: 48px;
    border-style: solid;
    border-color: ${isActive
    ? palette.baseColors.lupin
    : palette.baseColors.moeraki};
    border-radius: 50%;
    display: grid;
    justify-content: center;
    background-color: ${palette.baseColors.wairua};
    border-width: 2px;
    z-index: 1;
  `}
`;
const LoadingCircle = styled(OuterCircle) `
  ${({ theme: { palette } }) => css `
    border-color: transparent;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: -2px;
      z-index: -1;
      border-radius: inherit;
      background: linear-gradient(
        to right,
        ${palette.baseColors.lupin} 0%,
        ${palette.baseColors.lupinOpacity50} 10%,
        transparent 55%
      );
      animation: ${rotateCircleAnimation} 2s linear infinite;
    }
  `}
`;
const InnerCircle$1 = styled.div `
  display: grid;
  align-items: center;
  justify-content: center;
  background: white;
  border-color: transparent;
  border-radius: inherit;
  padding: 10px;
`;
const StepItem = styled.div `
  ${({ isActive, isCurrent, circleSize, theme: { media, palette, spacing }, }) => css `
    display: flex;
    flex-direction: column;
    flex: 1;
    text-align: center;
    align-items: center;

    ${media.down('slim')} {
      flex-direction: row;
      flex: 0;
      align-items: flex-start;
      text-align: left;
      gap: ${spacing.s2};
      padding-bottom: ${spacing.s4};
      position: relative;
    }

    &:not(:last-child) {
      &:after {
        content: '';
        position: relative;
        top: calc(${circleSize} / 2);
        width: calc(100% - ${circleSize} - 8px);
        left: calc(50% + calc(${circleSize} / 2) + 4px);
        order: -1;
        align-self: flex-start;

        ${media.up('slim')} {
          border-top-width: 4px;
          border-top-style: dotted;
          border-top-color: ${isActive && !isCurrent
    ? `${palette.baseColors.lupin}`
    : `${palette.baseColors.moeraki}`};
        }

        ${media.down('slim')} {
          position: absolute;
          top: calc(${circleSize} / 2 + ${spacing.s1_5});
          width: 4px;
          left: calc(${circleSize} / 2 - 1px);
          bottom: ${spacing.s0_5};
          border-left-width: 4px;
          border-left-style: dotted;
          border-left-color: ${isActive && !isCurrent
    ? `${palette.baseColors.lupin}`
    : `${palette.baseColors.moeraki}`};
        }
      }
    }
  `}
`;
const StepIcon = styled(Icon) `
  margin: auto;
`;
function Step({ isActive, isCurrent, isLoading, icon, stepName, stepDesc, text, }) {
    const { palette: { baseColors: { lupin, moeraki, mawheranui, newZealandBlack }, }, } = useTheme();
    const CircleWrapper = isCurrent && isLoading ? LoadingCircle : OuterCircle;
    return (React__default.createElement(StepItem, { isActive: isActive, isCurrent: isCurrent, circleSize: "48px" },
        React__default.createElement(CircleWrapper, { isActive: isActive, isCurrent: isCurrent },
            React__default.createElement(InnerCircle$1, null,
                React__default.createElement(StepIcon, { name: icon, fill: isActive ? lupin : moeraki }))),
        React__default.createElement(Box, { ml: ['s2', 's2', 's0'], pt: "s1_5" },
            React__default.createElement(Text, { variant: "bodyMDemi", mb: "s1_5", color: isActive ? newZealandBlack : moeraki }, stepName),
            stepDesc ? (React__default.createElement(Text, { variant: "footnoteDemi", color: mawheranui }, stepDesc)) : null,
            text.html ? React__default.createElement(RawHtml, { html: text.html, variant: "bodySMedium" }) : null)));
}

const ProgressTracker = ({ activeStep, steps, statusHistory, }) => {
    return (React__default.createElement(Stepper, { steps: steps, renderStep: (step, index) => {
            const icon = index > activeStep || activeStep === 1 ? step.icon : 'check_small';
            return (React__default.createElement(Step, Object.assign({}, step, { icon: icon, isActive: index <= activeStep, isLoading: index === statusHistory.length - 1, isCurrent: index === activeStep })));
        } }));
};

const BaseStyle$3 = styled.div ``;
function responsive(breakpoint, height) {
    return css `
    ${({ theme: { spacing, media } }) => css `
      ${media.up(breakpoint)} {
        height: ${spacing[height]};
      }
    `}
  `;
}
const SpacingQuarter = styled(BaseStyle$3) `
  height: 2px;
`;
const SpacingHalf = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s0_5};
`;
const Spacing01 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s1};
`;
const Spacing02 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s2};
`;
const Spacing03 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s2};
  ${responsive('slim', 's3')}
`;
const Spacing04 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s2};
  ${responsive('slim', 's3')}
  ${responsive('big', 's4')}
`;
const Spacing05 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s2};
  ${responsive('slim', 's4')}
  ${responsive('big', 's5')}
`;
const Spacing06 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s3};
  ${responsive('slim', 's4')}
  ${responsive('big', 's6')}
`;
const Spacing07 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s4};
  ${responsive('slim', 's5')}
  ${responsive('big', 's7')}
`;
const Spacing08 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s5};
  ${responsive('slim', 's6')}
  ${responsive('big', 's8')}
`;
const Spacing09 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s5};
  ${responsive('slim', 's7')}
  ${responsive('big', 's9')}
`;
const Spacing10 = styled(BaseStyle$3) `
  height: ${({ theme }) => theme.spacing.s7};
  ${responsive('slim', 's9')}
  ${responsive('big', 's10')}
`;
const SpacingTopOfPage = styled(BaseStyle$3) `
  ${({ theme: { spacing, media } }) => css `
    height: calc(${spacing.s3} + ${spacing.s9});

    ${media.up('slim')} {
      height: calc(${spacing.s5} + ${spacing.s9});
    }

    ${media.up('big')} {
      height: ${spacing.s9};
    }
  `}
`;
const SpacerVariantMap = {
    'spacing-quarter': SpacingQuarter,
    'spacing-half': SpacingHalf,
    'spacing-01': Spacing01,
    'spacing-02': Spacing02,
    'spacing-03': Spacing03,
    'spacing-04': Spacing04,
    'spacing-05': Spacing05,
    'spacing-06': Spacing06,
    'spacing-07': Spacing07,
    'spacing-08': Spacing08,
    'spacing-09': Spacing09,
    'spacing-10': Spacing10,
    'spacing-top-of-page': SpacingTopOfPage,
};
const Spacer = ({ variant }) => {
    const StyledSpacer = SpacerVariantMap[variant] || SpacerVariantMap['spacing-01'];
    return React__default.createElement(StyledSpacer, { variant: variant });
};

const SparkContentLoader = (_a) => {
    var { children, dynamicTargetValue = '' } = _a, props = __rest(_a, ["children", "dynamicTargetValue"]);
    const componentName = 'Spark Content Loader';
    const { palette: { baseColors: { onepu }, }, } = useTheme();
    return (React__default.createElement(ContentLoader, Object.assign({ foregroundColor: "#f7f7f7" // This is an exception. These dont need to be pattern lib colors, as per design system
        , backgroundColor: onepu, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" }, props), children));
};

const ListItem = styled.li `
  display: flex;
  align-items: center;
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s3} 0;
  `}
`;
const List$1 = styled.ul `
  list-style-type: none;
  margin: 0;
  padding: 0;

  ${ListItem}:last-child {
    padding-bottom: 0;
  }
  ${ListItem}:first-child {
    padding-top: 0;
  }
`;
const ListItemContent = styled.div `
  flex: 1;
`;
const ListItemCTA = styled.div `
  justify-content: flex-end;
`;

function AnimatedComponent(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const NewAnimatePresence = AnimatePresence;
    return React__default.createElement(NewAnimatePresence, Object.assign({}, props), children);
}

const ArticleCardWrapper = styled.div `
  ${({ theme: { palette, media, borderRadius } }) => css `
    width: 328px;
    height: 437px;
    border-radius: ${borderRadius.r3};
    border: 1px solid ${palette.baseColors.moeraki};

    ${media.up('slim')} {
      width: 340px;
      height: 454px;
    }

    ${media.up('big')} {
      width: 360px;
      height: 478px;
    }
  `}
`;
const ArticleCardLink = styled.a `
  ${({ disabled }) => css `
    text-decoration: none;
    ${disabled ? `pointer-events: none;` : `pointer-events: auto;`}
  `}
`;
const StyledImage = styled.img `
  ${({ theme: { media } }) => css `
    border-radius: 23px;
    width: 326px;
    height: 208px;

    ${media.up('slim')} {
      width: 338px;
      height: 216px;
    }

    ${media.up('big')} {
      width: 358px;
      height: 227px;
    }
  `}
`;
const ContentSection = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2};
  `}
`;
const TitleText = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s1};
    max-height: 112px;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;
const DescriptionText = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s1};

    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;
const DateText = styled(Text) `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.mawheranui};
  `}
`;
const ArticleCard = ({ title, description, datePosted, hideDatePosted = false, imagePath, articlePath, disabled = false, id, alt, }) => (React__default.createElement(ArticleCardLink, { disabled: disabled, href: articlePath, id: id },
    React__default.createElement(ArticleCardWrapper, null,
        React__default.createElement(StyledImage, { src: imagePath, alt: alt }),
        React__default.createElement(ContentSection, null,
            React__default.createElement(TitleText, { variant: "bodyMDemi" }, title),
            React__default.createElement(DescriptionText, { variant: "footnoteDemi" }, description),
            !hideDatePosted && (React__default.createElement(DateText, { variant: "footnoteDemi" },
                "Posted on ",
                datePosted))))));

const getBorderColor$1 = (palette, selected, disabled) => {
    if (disabled)
        return palette.baseColors.alto;
    if (selected)
        return palette.baseColors.lupin;
    return palette.baseColors.moeraki;
};
const Chip$2 = styled.button `
  ${({ theme: { palette, borderRadius, spacing }, selected, disabled }) => css `
    display: flex;
    flex-direction: row;
    gap: ${spacing.s1};
    cursor: ${!disabled && 'pointer'};
    background: transparent;
    border: 2px solid ${getBorderColor$1(palette, selected, disabled)};
    border-radius: ${borderRadius.r3};
    transition: 0.1s ease-in-out;
    padding: ${spacing.s1} ${spacing.s2};
    color: ${disabled && palette.baseColors.alto};
  `}
`;
const ChoiceChips = ({ options, selectedValue, onChange, isAllDisabled, iconName, }) => {
    const { palette: { baseColors }, } = useTheme();
    const handleClick = (value) => {
        onChange(value);
    };
    return (React__default.createElement(Box, { flexDirection: "row", gap: "s1", flexWrap: "wrap" }, options.map(({ value, label, isChipDisabled }) => {
        const selected = selectedValue === value;
        const isDisabled = Boolean(isAllDisabled) || Boolean(isChipDisabled);
        return (React__default.createElement(Chip$2, { key: label, selected: selected, onClick: () => handleClick(value), disabled: isDisabled },
            iconName ? (React__default.createElement(Icon, { "data-testid": "chip-icon", name: iconName, fill: isDisabled ? baseColors.alto : undefined, size: 24 })) : null,
            React__default.createElement(Text, { variant: "bodySDemi", color: isDisabled ? baseColors.alto : undefined }, label)));
    })));
};

const BaseStyle$2 = styled.div ``;
const FullWidthContainer$1 = styled(BaseStyle$2) `
  width: 100%;
`;
const ContainerVariantMap = {
    'full-width': FullWidthContainer$1,
};
const Container$f = (_a) => {
    var { variant, children } = _a, rest = __rest(_a, ["variant", "children"]);
    const StyledContainer = ContainerVariantMap[variant] || ContainerVariantMap['full-width'];
    return (React__default.createElement(StyledContainer, Object.assign({ variant: variant }, rest), children));
};

const gridMixin = css `
  ${({ theme: { media, spacing } }) => css `
    box-sizing: border-box;
    max-width: 1500px;
    padding: 0 ${spacing.s3};
    margin: 0 auto;

    ${media.up('slim')} {
      padding: 0 ${spacing.s4};
    }

    ${media.up('big')} {
      padding: 0 108px;
    }
  `}
`;
const Grid = styled.div `
  ${gridMixin}
`;

const BaseStyle$1 = styled.div `
  ${({ theme: { media, spacing } }) => css `
    padding: 0 ${spacing.s1};

    ${Grid} {
      padding: 0;
    }

    ${media.up('slim')} {
      padding: 0 ${spacing.s1_5};
    }
  `}
`;
const GridColumnStyle = styled(BaseStyle$1) `
  ${({ theme: { media }, lil, slim, big, lilOffset, slimOffset, bigOffset, }) => css `
    width: calc(${lil} / 2 * 100%);

    ${media.up('slim')} {
      width: ${slim
    ? `calc(${slim} / 6 * 100%)`
    : `calc(${lil * 3} / 6 * 100%)`};
    }

    ${media.up('big')} {
      width: ${big
    ? `calc(${big} / 12 * 100%)`
    : `calc(${lil * 6} / 12 * 100%)`};

      ${bigOffset &&
    css `
        margin-left: calc(${bigOffset} / 12 * 100%);
      `}
    }

    ${media.down('lil')} {
      ${lilOffset &&
    css `
        margin-left: calc(${lilOffset} / 2 * 100%);
      `}
    }

    ${media.between('slim', 'slim')} {
      ${slimOffset &&
    css `
        margin-left: calc(${slimOffset} / 6 * 100%);
      `}
    }
  `}
`;
const GridColumn = ({ className, lil, slim, big, lilOffset, slimOffset, bigOffset, children, }) => {
    return (React__default.createElement(GridColumnStyle, { className: className, lil: lil, slim: slim, big: big, lilOffset: lilOffset, slimOffset: slimOffset, bigOffset: bigOffset }, children));
};

const Row = styled.div `
  ${({ theme: { media, spacing } }) => css `
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    margin-left: -${spacing.s1};
    margin-right: -${spacing.s1};

    ${media.up('slim')} {
      margin-left: -${spacing.s1_5};
      margin-right: -${spacing.s1_5};
    }

    ${media.up('big')} {
      margin: 0;
    }
  `}
`;

const TeaserWrapper = styled.div `
  ${({ theme: { media, borderRadius, palette }, bgImagePath, isRich, cardSize, disabled, }) => css `
    display: flex;
    position: relative;
    ${isRich
    ? `background: url(${bgImagePath}) no-repeat;
      background-size: cover;`
    : `background: ${palette.baseColors.onepu};`}
    ${!isRich && disabled && `background: ${palette.baseColors.alto};`}

    border-radius: ${borderRadius.r2};

    &:hover:after {
      opacity: 0.2;
    }

    &:after {
      transition: opacity ease-in-out 0.1s;
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${palette.baseColors.newZealandBlack};
      opacity: 0;
      ${isRich && disabled
    ? `background-color: ${palette.baseColors.wairua};
          opacity: 0.64;`
    : ''}
      border-radius: ${borderRadius.r2};
    }

    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      outline-offset: 2px;
    }

    &:active:after {
      opacity: 0.4;
    }

    height: 210px;
    /* standard6, standard4, long */
    height: 215px;

    ${cardSize === 'feature4' ? `height: 293px;` : ''}
    ${cardSize === 'feature6' ? `height: 454px;` : ''}
      top: auto;

    ${media.up('slim')} {
      /* standard6 or long */
      height: 356px;

      ${cardSize === 'standard4' ? `height: 227px;` : ''}
      ${cardSize === 'feature4' ? `height: 478px;` : ''}
      ${cardSize === 'feature6' ? `height: 736px;` : ''}
      top: auto;
    }
  `}
`;
const TeaserGradient = styled.div `
  ${({ theme: { spacing, media, borderRadius }, isRich, disabled }) => css `
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;

    padding: ${spacing.s3} ${spacing.s3} ${spacing.s2} ${spacing.s3};
    border-radius: ${borderRadius.r2};

    ${media.up('big')} {
      padding: ${spacing.s4};
    }

    ${isRich && !disabled
    ? `background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.6) 0%,
        rgba(0, 0, 0, 0) 100%
      );`
    : ''}
  `}
`;
const TeaserLink = styled.a `
  ${({ disabled }) => css `
    text-decoration: none;
    ${disabled ? `pointer-events: none;` : `pointer-events: auto;`}
  `}
`;
const IconWrapper$7 = styled.div `
  ${({ theme: { spacing, zIndex } }) => css `
    z-index: ${zIndex.default};
    margin-right: ${spacing.s2};
  `}
`;
const Title$3 = styled(Text) `
  ${({ theme: { media, spacing, zIndex, palette }, hasBottomMargin, hasBiggerMargins, isRich, disabled, }) => css `
    z-index: ${zIndex.default};
    color: ${isRich || disabled
    ? palette.baseColors.wairua
    : palette.baseColors.newZealandBlack};

    margin-top: ${spacing.s1};
    margin-bottom: ${hasBottomMargin ? spacing.s1 : 0};

    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${media.up('big')} {
      ${hasBiggerMargins
    ? `
        margin-top: ${spacing.s2};
        margin-bottom: ${hasBottomMargin ? spacing.s2 : 0};
      `
    : `margin-top: ${spacing.s1};
          margin-bottom: ${hasBottomMargin ? spacing.s1 : 0};
      `}
    }
  `}
`;
const Description = styled(Text) `
  ${({ theme: { palette, zIndex }, isRich, disabled, isFeature }) => css `
    z-index: ${zIndex.default};
    color: ${isRich || disabled
    ? palette.baseColors.wairua
    : palette.baseColors.newZealandBlack};

    display: -webkit-box;
    -webkit-line-clamp: ${isFeature ? 4 : 2};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;
const FeatureImageContainer = styled(Box) `
  height: 100%;
`;
const FeatureImageWrapper = styled.div `
  ${({ theme: { media } }) => css `
    width: 100%;
    height: 224px;

    ${media.up('slim')} {
      height: 422px;
    }
  `}
`;
const FeatureImage = styled.img `
  object-fit: contain;
  display: block;
  height: 100%;
  width: 100%;
`;
const StyledImg = styled.img `
  ${({ theme: { palette }, imagePath, isRich, disabled }) => {
    if (disabled) {
        return css `
        mask: url(${imagePath}) no-repeat center / contain;
        -webkit-mask: url(${imagePath}) no-repeat center / contain;
        background-color: ${palette.baseColors.wairua};
      `;
    }
    // This section is to shade the icon in a flat colour.
    // Original colours are enabled via passing in the imagePath in src, which will take
    // precedent over this css
    return css `
      mask: url(${imagePath}) no-repeat center / contain;
      -webkit-mask: url(${imagePath}) no-repeat center / contain;
      background-color: ${isRich
        ? palette.baseColors.wairua
        : palette.baseColors.newZealandBlack};
    `;
}}
`;
const TeaserCard = (_a) => {
    var { title, description, bgImagePath, imagePath, featureImagePath, // Only used with cardSize feature6
    featureImageAlt, linkURL = '', iconColor, cardSize, cardBackground, disabled = false, target, rel, onClick, dynamicTargetValue = '', alt } = _a, linkAttributes = __rest(_a, ["title", "description", "bgImagePath", "imagePath", "featureImagePath", "featureImageAlt", "linkURL", "iconColor", "cardSize", "cardBackground", "disabled", "target", "rel", "onClick", "dynamicTargetValue", "alt"]);
    const isRich = cardBackground === 'rich';
    const isFeature = cardSize === 'feature4' || cardSize === 'feature6';
    const isLong = cardSize === 'long';
    const componentName = 'Teaser Card';
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.currentTarget.click();
        }
    };
    return (React__default.createElement(TeaserLink, Object.assign({}, linkAttributes, { tabIndex: -1, href: linkURL, target: target, disabled: disabled, onClick: onClick, onKeyDown: handleKeyDown, rel: target === '_blank' ? 'noopener' : '', "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" }),
        React__default.createElement(TeaserWrapper, { tabIndex: 0, bgImagePath: bgImagePath, isRich: isRich, isFeature: isFeature, isLong: isLong, cardSize: cardSize, disabled: disabled },
            React__default.createElement(TeaserGradient, { isRich: isRich, disabled: disabled },
                featureImagePath && cardSize === 'feature6' ? (React__default.createElement(FeatureImageContainer, { flexDirection: "column", justifyContent: "center" },
                    React__default.createElement(FeatureImageWrapper, { cardSize: cardSize },
                        React__default.createElement(FeatureImage, { cardSize: cardSize, alt: featureImageAlt, src: featureImagePath })))) : null,
                React__default.createElement(Box, { flexDirection: "column", justifyContent: "flex-end" },
                    React__default.createElement(IconWrapper$7, null, iconColor === 'color' && !disabled ? (React__default.createElement(StyledImg, { alt: alt, imagePath: imagePath, height: 48, width: 48, iconColor: iconColor, isRich: isRich, disabled: disabled, src: imagePath })) : (React__default.createElement(StyledImg, { alt: alt, imagePath: imagePath, height: 48, width: 48, iconColor: iconColor, isRich: isRich, disabled: disabled }))),
                    React__default.createElement(Title$3, { variant: "subheadingL", component: "h4", hasBottomMargin: !!description, hasBiggerMargins: cardSize === 'feature6' || cardSize === 'long', isRich: isRich, disabled: disabled }, title),
                    React__default.createElement(Description, { variant: "bodyMDemi", isRich: isRich, disabled: disabled, isFeature: isFeature }, description))))));
};

const HEADER_HEIGHT = 80;
const HEADER_WITH_SEGMENT_SWITCHER_HEIGHT = 120;
const SEGMENT_SWITCHER_HEIGHT = 40;
const SCROLL_THROTTLE_DELAY = 300;
const PROFILE_PILL_FADE_OFFSET = 40;

const StyledBannerText$1 = styled(RawHtml) `
  ${({ theme: { media, palette, spacing }, hasDarkText }) => css `
    p {
      color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
      padding-top: 0;
      margin-top: ${spacing.s1};
      ${media.up('slim')} {
        margin-top: ${spacing.s3};
      }
      &:last-child:not(:only-child) {
        ${footNoteMediumStyle}
      }
    }
    p + p {
      padding-top: 0;
    }
    a {
      display: inline-block;
      color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
      ${footNoteMediumStyle};
    }
  `}
`;
const StyledBannerSecondaryText = styled(StyledBannerText$1) `
  ${({ theme: { spacing } }) => css `
    ${footNoteMediumStyle}
    p {
      margin-top: ${spacing.s2};
    }
  `}
`;
const BannerText$1 = ({ text, subText, hasDarkText }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledBannerText$1, { html: text, richText: true, variant: "subheadingM", hasDarkText: hasDarkText }),
        subText ? (React__default.createElement(StyledBannerSecondaryText, { html: subText, richText: true, variant: "subheadingM", hasDarkText: hasDarkText })) : null));
};

const StyledBannerTitle$1 = styled(Text) `
  ${({ theme: { palette }, hasDarkText }) => css `
    color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
  `}
`;
const BannerTitle$1 = ({ title, hasDarkText, titleSize }) => {
    return (React__default.createElement(StyledBannerTitle$1, { variant: "headingM", hasDarkText: hasDarkText, component: titleSize }, title));
};

const StyledBannerText = styled(RawHtml) `
  ${({ theme: { media, palette, spacing }, hasDarkText }) => css `
    p {
      color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
      padding-top: 0;
      margin-top: ${spacing.s3};

      &:last-child:not(:only-child) {
        ${footNoteMediumStyle}
      }
    }
    p + p {
      padding-top: 0;
    }
    a {
      display: inline-block;
      color: ${palette.baseColors.lupin};
      ${footNoteMediumStyle};
    }
    ${media.up('slim')} {
      a {
        color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
      }
    }
  `}
`;
const StyledSubBannerText = styled(StyledBannerText) `
  ${footNoteMediumStyle}
`;
const BannerText = ({ text, subText, hasDarkText }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledBannerText, { html: text, richText: true, variant: "subheadingM", hasDarkText: hasDarkText }),
        subText ? (React__default.createElement(StyledSubBannerText, { html: subText, richText: true, variant: "subheadingM", hasDarkText: hasDarkText })) : null));
};

const StyledBannerTitle = styled(Text) `
  ${({ theme: { palette }, hasDarkText }) => css `
    color: ${hasDarkText
    ? palette.baseColors.newZealandBlack
    : palette.baseColors.wairua};
  `}
`;
const BannerTitle = ({ title, hasDarkText, isH2 }) => {
    return (React__default.createElement(StyledBannerTitle, { variant: "headingM", hasDarkText: hasDarkText, component: isH2 ? 'h2' : 'h1' }, title));
};

const BannerInternalGrid$1 = styled.div `
  ${gridMixin};
`;
const BannerGridContainer$1 = styled(Container$f) `
  ${({ theme: { media, spacing }, bgImagePath, hasGradientOverlay, hasExtendedBackground, hasRoundedCorners, }) => css `
    background: url(${bgImagePath}) no-repeat center / cover;
    background: ${hasGradientOverlay &&
    hasExtendedBackground &&
    `linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%), 
        url(${bgImagePath}) no-repeat center / cover`};
    ${hasRoundedCorners && `border-radius: ${spacing.s3}`};
    ${media.up('slim')} {
      background: ${hasGradientOverlay &&
    `linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%), 
        url(${bgImagePath}) no-repeat center / cover`};
    }
  `}
`;
const BannerGridRow$1 = styled(Row) `
  ${({ theme: { media, spacing }, hasImageOnLeft }) => css `
    align-items: center;
    min-height: 88px;
    margin: 0;
    ${hasImageOnLeft && `flex-direction: row-reverse;`};

    & > :first-child {
      padding: ${spacing.s3} 0;
    }

    ${media.up('slim')} {
      min-height: 450px;
      & > :first-child {
        padding: ${spacing.s4} 0;
      }
    }
    ${media.up('big')} {
      min-height: 600px;
    }
  `}
`;
const BannerImageContainer$1 = styled.div `
  ${({ theme: { media, spacing }, bgImagePath, hasRoundedCorners }) => css `
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url(${bgImagePath}) no-repeat center;
    background-size: cover;
    ${hasRoundedCorners &&
    `
    border-radius: ${spacing.s3};
    & > img {
        border-top-left-radius: ${spacing.s3};
        border-top-right-radius: ${spacing.s3};
        }
    `};
    ${media.up('slim')} {
      min-height: 360px;
    }
  `}
`;
const BannerButton$1 = styled(Button$2) `
  ${({ theme: { palette, spacing, media } }) => css `
    color: ${palette.baseColors.wairua};
    margin-top: ${spacing.s3};
    width: 100%;

    ${media.up('slim')} {
      width: auto;
    }
  `}
`;
const ButtonWrapper$2 = styled.div `
  display: flex;
  flex-direction: column;
  ${({ theme: { media, spacing }, hasImageOnLeft }) => css `
    ${media.up(hasImageOnLeft ? 'big' : 'slim')} {
      flex-direction: row;
      & > :first-child {
        margin-right: ${spacing.s3};
      }
    }
  `}
`;
const FrontImage = styled.img `
  width: 100%;
`;
const BannerContent$1 = ({ imagePath, title, description, subDescription, actions, hasDarkText = false, isH2 = false, hasGradientOverlay = false, bgImagePath = '', hasExtendedBackground = false, hasRoundedCorners = false, hasImageOnLeft = false, }) => {
    return (React__default.createElement(BannerGridContainer$1, { variant: "full-width", hasGradientOverlay: hasGradientOverlay, bgImagePath: bgImagePath, hasExtendedBackground: hasExtendedBackground, hasRoundedCorners: hasRoundedCorners },
        React__default.createElement(BannerInternalGrid$1, null,
            React__default.createElement(BannerGridRow$1, { hasImageOnLeft: hasImageOnLeft },
                React__default.createElement(GridColumn, { lil: 2, slim: 3, big: 6 },
                    title ? (React__default.createElement(BannerTitle, { title: title, hasDarkText: hasDarkText, isH2: isH2 })) : null,
                    description || subDescription ? (React__default.createElement(BannerText, { text: description, subText: subDescription, hasDarkText: hasDarkText })) : null,
                    actions && actions.length > 0 ? (React__default.createElement(ButtonWrapper$2, { hasImageOnLeft: hasImageOnLeft },
                        React__default.createElement(BannerButton$1, { component: "a", href: actions[0].url, variant: "primary", target: actions[0].target }, actions[0].title),
                        actions[1] ? (React__default.createElement(BannerButton$1, { component: "a", href: actions[1].url, variant: "default", target: actions[1].target }, actions[1].title)) : null)) : null),
                imagePath ? (React__default.createElement(GridColumn, { lil: 2, slim: 3, big: 6 },
                    React__default.createElement(FrontImage, { src: imagePath, alt: "Front Image" }))) : null))));
};
const LegacyBanner = ({ title, bgImagePath = '', imagePath, description, subDescription, actions, hasDarkText = true, isH2 = false, dynamicTargetValue = '', hasGradientOverlay = false, hasExtendedBackground = false, hasRoundedCorners = false, hasImageOnLeft = false, }) => {
    const componentName = 'Banner';
    return (React__default.createElement("div", { "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(MediaQuery, { max: "lil" },
            React__default.createElement(BannerImageContainer$1, { bgImagePath: bgImagePath, hasRoundedCorners: hasRoundedCorners, hasGradientOverlay: hasGradientOverlay },
                imagePath ? (React__default.createElement(FrontImage, { src: imagePath, alt: "Front Image" })) : (React__default.createElement(Box, { pt: "s10", pb: "s8" })),
                hasExtendedBackground ? (React__default.createElement(BannerContent$1, { title: title, description: description, subDescription: subDescription, actions: actions, hasDarkText: hasDarkText, isH2: isH2, hasGradientOverlay: hasGradientOverlay, hasRoundedCorners: hasRoundedCorners, hasExtendedBackground: true })) : null),
            hasExtendedBackground ? null : (React__default.createElement(BannerContent$1, { title: title, description: description, subDescription: subDescription, actions: actions, hasDarkText: true, isH2: isH2, hasRoundedCorners: hasRoundedCorners, hasGradientOverlay: hasGradientOverlay }))),
        React__default.createElement(MediaQuery, { min: "slim" },
            React__default.createElement(BannerContent$1, { title: title, bgImagePath: bgImagePath, imagePath: imagePath, description: description, subDescription: subDescription, actions: actions, hasDarkText: hasDarkText, isH2: isH2, hasGradientOverlay: hasGradientOverlay, hasExtendedBackground: hasExtendedBackground, hasRoundedCorners: hasRoundedCorners, hasImageOnLeft: hasImageOnLeft }))));
};

var BannerVariant;
(function (BannerVariant) {
    BannerVariant["LEGACY"] = "legacy";
    BannerVariant["CURRENT"] = "current";
})(BannerVariant || (BannerVariant = {}));
const BannerInternalGrid = styled.div `
  ${gridMixin};
  display: flex;
  height: 100%;
`;
const getBackgroundImage = ({ imagePath, hasGradientOverlay, hasImageOnLeft, }) => {
    return css `
    background: url(${imagePath}) no-repeat center / cover;
    ${hasGradientOverlay &&
        `background: linear-gradient(${hasImageOnLeft ? '270' : '90'}deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%), 
        url(${imagePath}) no-repeat center / cover`};
  `;
};
const BannerGridContainer = styled(Container$f) `
  ${({ theme: { media, spacing }, bgImagePath, bgImagePathTablet, hasGradientOverlay, hasImageOnLeft, hasRoundedCorners, }) => css `
    flex-grow: 1;
    background: url(${bgImagePath}) no-repeat center / cover;
    background: ${hasGradientOverlay &&
    `linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%), 
        url(${bgImagePath}) no-repeat center / cover`};
    ${hasRoundedCorners && `border-radius: ${spacing.s3}`};
    ${media.up('slim')} {
      ${getBackgroundImage({
    imagePath: bgImagePathTablet,
    hasGradientOverlay,
    hasImageOnLeft,
})}
    }
    ${media.up('big')} {
      ${getBackgroundImage({
    imagePath: bgImagePath,
    hasGradientOverlay,
    hasImageOnLeft,
})}
    }
  `}
`;
const BannerGridRow = styled(Row) `
  ${({ theme: { media, spacing }, hasImageOnLeft }) => css `
    align-items: center;
    min-height: 88px;
    margin: 0;
    flex-grow: 1;
    ${hasImageOnLeft && `flex-direction: row-reverse;`};

    & > :first-child {
      padding: ${spacing.s3} 0;
    }

    ${media.up('slim')} {
      min-height: 450px;
      & > :first-child {
        padding: ${spacing.s4} 0;
      }
    }
    ${media.up('big')} {
      min-height: 600px;
    }
  `}
`;
const BannerGridColumn = styled(GridColumn) `
  ${({ theme: { media } }) => css `
    ${media.down('lil')} {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
  `}
`;
const BannerImageContainer = styled.div `
  ${({ theme: { media, spacing }, bgImagePath, hasRoundedCorners }) => css `
    height: calc(100vh - ${HEADER_HEIGHT}px);
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url(${bgImagePath}) no-repeat center;
    background-size: cover;
    ${hasRoundedCorners &&
    `
    border-radius: ${spacing.s3};
    & > img {
        border-top-left-radius: ${spacing.s3};
        border-top-right-radius: ${spacing.s3};
        }
    `};
    ${media.up('slim')} {
      height: auto;
      min-height: 360px;
    }
  `}
`;
const BannerButton = styled(Button$2) `
  ${({ theme: { palette, spacing, media } }) => css `
    color: ${palette.baseColors.wairua};
    margin-top: ${spacing.s1};
    width: 100%;

    ${media.up('slim')} {
      margin-top: ${spacing.s4};
      width: auto;
    }
  `}
`;
const ButtonWrapper$1 = styled.div `
  display: flex;
  flex-direction: column;
  ${({ theme: { media, spacing }, hasImageOnLeft }) => css `
    ${media.up(hasImageOnLeft ? 'big' : 'slim')} {
      flex-direction: row;
      & > :first-child {
        margin-right: ${spacing.s3};
      }
    }
  `}
`;
const LowerContent = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const InnerFlexContainer = styled.div `
  ${({ theme: { media } }) => css `
    height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;

    ${media.up('slim')} {
      display: none;
    }
  `}
`;
const InnerFlexSpacer = styled.div `
  flex-grow: 1;
`;
const ActionsSection = ({ hasImageOnLeft, actions }) => (React__default.createElement(ButtonWrapper$1, { hasImageOnLeft: hasImageOnLeft },
    React__default.createElement(BannerButton, { component: "a", href: actions[0].url, variant: "primary", target: actions[0].target }, actions[0].title),
    actions[1] ? (React__default.createElement(BannerButton, { component: "a", href: actions[1].url, variant: "default", target: actions[1].target }, actions[1].title)) : null));
const BannerContent = ({ title, description, subDescription, actions, hasDarkText = false, titleSize = 'h1', hasGradientOverlay = false, bgImagePath, bgImagePathTablet, hasRoundedCorners = false, hasImageOnLeft = false, }) => {
    return (React__default.createElement(BannerGridContainer, { variant: "full-width", hasGradientOverlay: hasGradientOverlay, bgImagePath: bgImagePath, bgImagePathTablet: bgImagePathTablet, hasRoundedCorners: hasRoundedCorners, hasImageOnLeft: hasImageOnLeft },
        React__default.createElement(BannerInternalGrid, null,
            React__default.createElement(BannerGridRow, { hasImageOnLeft: hasImageOnLeft },
                React__default.createElement(BannerGridColumn, { lil: 2, slim: 3, big: 6 },
                    title ? (React__default.createElement(BannerTitle$1, { title: title, hasDarkText: hasDarkText, titleSize: titleSize })) : null,
                    description ? (React__default.createElement(BannerText$1, { text: description, hasDarkText: hasDarkText })) : null,
                    React__default.createElement(LowerContent, null,
                        React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(InnerFlexContainer, null,
                                React__default.createElement(InnerFlexSpacer, null)),
                            actions && actions.length > 0 ? (React__default.createElement(ActionsSection, { hasImageOnLeft: hasImageOnLeft, actions: actions })) : null),
                        subDescription ? (React__default.createElement(StyledBannerSecondaryText, { html: subDescription, richText: true, variant: "subheadingM", hasDarkText: hasDarkText })) : null))))));
};
const Banner = ({ title, bgImagePath = '', bgImagePathMobile, bgImagePathTablet, imagePath, description, subDescription, actions, hasDarkText = true, titleSize, dynamicTargetValue = '', hasGradientOverlay = false, hasExtendedBackground = false, hasRoundedCorners = false, hasImageOnLeft = false, variant = BannerVariant.LEGACY, }) => {
    if (variant === BannerVariant.LEGACY) {
        return (React__default.createElement(LegacyBanner, { title: title, bgImagePath: bgImagePath, imagePath: imagePath, description: description, subDescription: subDescription, actions: actions, hasDarkText: hasDarkText, isH2: titleSize === 'h2', dynamicTargetValue: dynamicTargetValue, hasGradientOverlay: hasGradientOverlay, hasExtendedBackground: hasExtendedBackground, hasRoundedCorners: hasRoundedCorners, hasImageOnLeft: hasImageOnLeft }));
    }
    const componentName = 'Banner';
    return (React__default.createElement("div", { "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(MediaQuery, { max: "lil" },
            React__default.createElement(BannerImageContainer, { "data-testid": "mobile", bgImagePath: bgImagePathMobile !== null && bgImagePathMobile !== void 0 ? bgImagePathMobile : bgImagePath, hasRoundedCorners: hasRoundedCorners, hasGradientOverlay: hasGradientOverlay },
                React__default.createElement(BannerContent, { title: title, description: description, subDescription: subDescription, actions: actions, hasDarkText: hasDarkText, titleSize: titleSize, hasGradientOverlay: hasGradientOverlay, hasRoundedCorners: hasRoundedCorners }))),
        React__default.createElement(MediaQuery, { min: "slim" },
            React__default.createElement(BannerContent, { "data-testid": "desktop", title: title, bgImagePath: bgImagePath, bgImagePathTablet: bgImagePathTablet !== null && bgImagePathTablet !== void 0 ? bgImagePathTablet : bgImagePath, description: description, subDescription: subDescription, actions: actions, hasDarkText: hasDarkText, titleSize: titleSize, hasGradientOverlay: hasGradientOverlay, hasRoundedCorners: hasRoundedCorners, hasImageOnLeft: hasImageOnLeft }))));
};

const ReactPlayer = lazy(() => import('react-player')); // fix the open issue for react-player lazy loading: https://github.com/cookpete/react-player/issues/1443
const StyledVideoPlayer$2 = styled.video `
  border-radius: 16px;
  box-shadow: 0 16px 24px rgba(0, 0, 0, 0.1);
`;
const SIXTEEN_BY_NINE_RATIO_BOX_PADDING = '28.13%';
const LOADING_SPINNER_SIZE = 36;
const ReactPlayerResponsiveContainer = styled.div `
  position: relative;
  padding: ${SIXTEEN_BY_NINE_RATIO_BOX_PADDING} 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledReactPlayer = styled(ReactPlayer) `
  position: absolute;
  top: 0;
  left: 0;
`;
const handleClick = () => {
    const video = document.getElementById('video');
    video === null || video === void 0 ? void 0 : video.setAttribute('controls', 'controls');
};
function VideoPlayer({ posterUrl, sources, embedUrl, dynamicTargetValue = '', isVisible = true, }) {
    if (embedUrl) {
        return (React__default.createElement(ReactPlayerResponsiveContainer, null,
            React__default.createElement(Suspense, { fallback: React__default.createElement(LoadingSpinner, { size: LOADING_SPINNER_SIZE }) }, isVisible ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(LoadingSpinner, { size: LOADING_SPINNER_SIZE }),
                React__default.createElement(StyledReactPlayer, { url: embedUrl, controls: true, width: "100%", height: "100%" }))) : null)));
    }
    const componentName = 'Video Player';
    return (React__default.createElement(StyledVideoPlayer$2, { id: "video", width: "100%", height: "auto", poster: posterUrl, onClick: handleClick, "data-testid": "video-player", "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement("button", { type: "button" }, "Play"), sources === null || sources === void 0 ? void 0 :
        sources.map((item) => (React__default.createElement("source", { key: item.url, src: item.url, type: item.type })))));
}

/**
 * This is the standard spark palette
 * NOTE: THESE ARE NOT FINALISED YET, PLEASE CONTINUE TO USE baseColors
 */
const palette = {
    grayScale1: colors.wairua,
    grayScale2: colors.onepu,
    grayScale3: colors.alto,
    grayScale4: colors.moeraki,
    grayScale5: colors.mawheranui,
    grayScale6: colors.greymouth,
    grayScale7: colors.greyLynn,
    grayScale8: colors.newZealandBlack,
    linkMain: colors.lupin,
    linkActive: colors.poroporo,
    linkVisited: colors.poroporo,
    linkAlternate: colors.wairua,
    interactiveMain: colors.lupin,
    interactiveSecondary: colors.sparkPurple,
    interactiveTertiary: colors.poroporo,
    interactiveMainInverse: colors.benLomond,
    interactionHover: colors.pukaki,
    interactionActive: colors.wanaka,
    destructiveMain: colors.marangai,
    destructiveSecondary: colors.sparkOrange,
    destructiveTertiary: colors.kowhai,
    destructiveHover: colors.karaka,
    destructiveActive: colors.darkOrange,
    personalisedMain: colors.kiwi,
    personalisedSecondary: colors.sparkGreen,
    personalisedTertiary: colors.aotearoa,
    importantMain: colors.mawhero,
    importantSecondary: colors.sparkPink,
    importantTertiary: colors.darkPink,
    textColor: colors.newZealandBlack,
    inverseTextColor: colors.wairua,
    labelTextColor: colors.newZealandBlack,
    labelDisabledTextColor: colors.moeraki,
    placeholderTextColor: colors.mawheranui,
    helperTextColor: colors.greymouth,
    helperTextDisabledColor: colors.alto,
    optionalTextColor: colors.mawheranui,
    optionalDisabledTextColor: colors.alto,
    primaryButtonDisabledTextColor: colors.wairua,
    disabledComponentColor: colors.alto,
    disabledDefaultButtonColor: colors.wairua,
    disabledButtonColor: colors.alto,
    disabledTextColor: colors.moeraki,
    disabledBackgroundColor: colors.wairua,
    disabledRadioButtonBorder: colors.alto,
    radioButtonBorder: colors.mawheranui,
    codeInputBorder: colors.alto,
    codeInputEmptyBackground: colors.onepu,
    backgroundColour: colors.wairua,
    componentBackgroundColor: colors.wairua,
    ulaContainerBackgroundColor: colors.onepu,
    ulaCardContainerBackgroundColor: colors.moeraki,
    logo: colors.lupin,
    tableBorder: colors.alto,
    tableDataCellBackground: colors.wairua,
    tableHeaderCellBackground: colors.onepu,
    quickLinkBackgroundColor: colors.wairua,
    quickLinkBorderColor: colors.moeraki,
    quickLinkHoverBackgroundColor: colors.alto,
    quickLinkHoverBorderColor: colors.mawheranui,
};
/**
 * This is the inverted (darkMode) standard spark palette
 */
const inversePalette = {
    grayScale1: colors.wairua,
    grayScale2: colors.onepu,
    grayScale3: colors.alto,
    grayScale4: colors.moeraki,
    grayScale5: colors.mawheranui,
    grayScale6: colors.greymouth,
    grayScale7: colors.greyLynn,
    grayScale8: colors.newZealandBlack,
    linkMain: colors.benLomond,
    linkActive: colors.lupin,
    linkVisited: colors.lupin,
    linkAlternate: colors.wairua,
    interactiveMain: colors.lupinDarkMode,
    interactiveSecondary: colors.sparkPurple,
    interactiveTertiary: colors.poroporo,
    interactiveMainInverse: colors.lupin,
    interactionHover: colors.pukaki,
    interactionActive: colors.wanaka,
    destructiveMain: colors.marangai,
    destructiveSecondary: colors.sparkOrange,
    destructiveTertiary: colors.kowhai,
    destructiveHover: colors.karaka,
    destructiveActive: colors.darkOrange,
    personalisedMain: colors.kiwi,
    personalisedSecondary: colors.sparkGreen,
    personalisedTertiary: colors.aotearoa,
    importantMain: colors.mawhero,
    importantSecondary: colors.sparkPink,
    importantTertiary: colors.darkPink,
    textColor: colors.wairua,
    inverseTextColor: colors.newZealandBlack,
    labelTextColor: colors.onepu,
    labelDisabledTextColor: colors.moeraki,
    placeholderTextColor: colors.moeraki,
    helperTextColor: colors.alto,
    helperTextDisabledColor: colors.mawheranui,
    optionalTextColor: colors.mawheranui,
    optionalDisabledTextColor: colors.mawheranui,
    primaryButtonDisabledTextColor: colors.moeraki,
    disabledComponentColor: colors.alto,
    disabledDefaultButtonColor: colors.alto,
    disabledButtonColor: colors.mawheranui,
    disabledTextColor: colors.mawheranui,
    disabledBackgroundColor: colors.mawheranui,
    disabledRadioButtonBorder: colors.greymouth,
    radioButtonBorder: colors.moeraki,
    codeInputBorder: colors.moeraki,
    codeInputEmptyBackground: colors.greyLynn,
    backgroundColour: colors.newZealandBlackDarkMode,
    componentBackgroundColor: colors.newZealandBlackDarkMode,
    ulaContainerBackgroundColor: colors.newZealandBlackDarkMode,
    ulaCardContainerBackgroundColor: colors.greyLynn,
    logo: colors.wairua,
    tableBorder: colors.newZealandBlackDarkMode,
    tableDataCellBackground: colors.greymouth,
    tableHeaderCellBackground: colors.greyLynn,
    quickLinkBackgroundColor: colors.greymouth,
    quickLinkBorderColor: colors.greymouth,
    quickLinkHoverBackgroundColor: colors.newZealandBlack,
    quickLinkHoverBorderColor: colors.newZealandBlack,
};

function createPaletteForTheme(palette) {
    return Object.assign(Object.assign({}, palette), { baseColors: colors });
}
const lightTheme = {
    name: 'lightTheme',
    borderRadius,
    /**
     * Prefer generic theme colors, only use baseColors
     * when you want the color to be non-themeable
     */
    palette: createPaletteForTheme(palette),
    spacing,
    breakpoints,
    media,
    zIndex,
    elevation,
};
function createPaletteForDarkTheme(palette) {
    return Object.assign(Object.assign({}, palette), { baseColors: colors });
}
const darkTheme = {
    name: 'darkTheme',
    borderRadius,
    /**
     * Prefer generic theme colors, only use baseColors
     * when you want the color to be non-themeable
     */
    palette: createPaletteForDarkTheme(inversePalette),
    spacing,
    breakpoints,
    media,
    zIndex,
    elevation,
};

const Dot = styled.div `
  ${({ scale, background }) => css `
    height: 8px;
    width: 8px;
    min-height: 0.5px;
    margin: 0 1px;
    border-radius: 100%;
    background-color: ${background};
    flex-shrink: 0;
    transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    transform: scale(${scale});
  `}
`;
const PaginationContainer = styled.div `
  max-width: 70px;
  overflow: hidden;
`;
const PaginationSlider = styled.div `
  ${({ offset }) => css `
    display: flex;
    flex-wrap: nowrap;
    transform: translate(${offset});
    transition: transform 0.4s;
    transition-timing-function: 'ease-out';
  `}
`;
const dotContainerWidth = 10;
const maxVisibleDots = 7;
const maxVisibleDotsFromCurrentPage = 3;
function calculateSliderOffset(numberOfPages, currentPage) {
    if (numberOfPages <= 6 || currentPage < 4) {
        return '0';
    }
    const maxIndex = numberOfPages - 1;
    let offset = -(currentPage - maxVisibleDotsFromCurrentPage);
    if (currentPage >= maxIndex - maxVisibleDotsFromCurrentPage) {
        offset = maxVisibleDots - numberOfPages;
    }
    return `${offset * dotContainerWidth}px`;
}
const keepInRange = (value, min, max) => Math.max(min, Math.min(max, value));
function getScale(stepsFromCurrentPage, currentPage, numberOfPages) {
    const isFirstIndex = currentPage === 0;
    const isLastIndex = currentPage === numberOfPages - 1;
    const isWithinTwoSteps = stepsFromCurrentPage > 0 && stepsFromCurrentPage < 3;
    const isMoreThanOneStepAway = stepsFromCurrentPage > 1;
    const isMoreThanTwoStepsAway = stepsFromCurrentPage > 2;
    if ((numberOfPages < 4 && isMoreThanOneStepAway) ||
        (isFirstIndex && isWithinTwoSteps)) {
        return 0.75;
    }
    if ((isFirstIndex && isMoreThanTwoStepsAway) ||
        (isLastIndex && isMoreThanOneStepAway)) {
        return 1.25 - stepsFromCurrentPage / 4;
    }
    return 1 - stepsFromCurrentPage / 4;
}
const { palette: { baseColors: { mawheranui, moeraki }, }, } = lightTheme;
function constructDotStyle(numberOfPages, currentPage) {
    const dotsStyle = [];
    for (let i = 0; i < numberOfPages; i += 1) {
        const stepsFromCurrentPage = Math.abs(i - currentPage);
        const isActive = stepsFromCurrentPage === 0;
        const background = isActive ? mawheranui : moeraki;
        const scale = getScale(stepsFromCurrentPage, currentPage, numberOfPages);
        const regulatedScale = keepInRange(scale, 0, 1);
        dotsStyle.push({ background, scale: regulatedScale });
    }
    return dotsStyle;
}
const CarouselPager = ({ currentPage = 1, numberOfPages, className, title, }) => {
    if (numberOfPages < 2) {
        return null;
    }
    const dotsStyle = constructDotStyle(numberOfPages, currentPage);
    const sliderOffset = calculateSliderOffset(numberOfPages, currentPage);
    return (React__default.createElement(Box, { className: className, flexDirection: "row", justifyContent: "center", alignItems: "center" },
        React__default.createElement(PaginationContainer, { title: title, "data-testid": "pagination-container" },
            React__default.createElement(PaginationSlider, { offset: sliderOffset }, dotsStyle.map(({ scale, background }, i) => {
                return (React__default.createElement(Dot
                // eslint-disable-next-line react/no-array-index-key
                , { 
                    // eslint-disable-next-line react/no-array-index-key
                    key: `${title}-pagination-dot-${i}`, "data-testid": "pagination-dot", scale: scale, background: background }));
            })))));
};

const useCarouselControl = (numberOfSlides, slidesToShow) => {
    const sliderRef = useRef(null);
    const [isPrevButtonVisible, setPrevButtonVisible] = useState(false);
    const [isNextButtonVisible, setNextButtonVisible] = useState(true);
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const beforeChangeHandler = (_oldIndex, newIndex) => {
        const newIsRightArrowVisible = numberOfSlides < slidesToShow ||
            newIndex !== numberOfSlides - slidesToShow;
        setCurrentSlideIndex(newIndex);
        setNextButtonVisible(newIsRightArrowVisible);
        setPrevButtonVisible(newIndex > 0);
    };
    return {
        currentSlideIndex,
        setCurrentSlideIndex,
        beforeChangeHandler,
        isPrevButtonVisible,
        isNextButtonVisible,
        sliderRef,
    };
};

const PopupOverlay = styled.div `
  ${({ theme: { palette, zIndex } }) => css `
    background: ${palette.baseColors.wairua};
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${zIndex.overlay};
    padding-top: 104px;
    margin: 0 auto;
    overflow-y: scroll;
  `}
`;
const CloseButton$2 = styled.div `
  ${({ theme: { zIndex, media } }) => css `
    position: fixed;
    display: block;
    top: 16px;
    right: 16px;
    z-index: ${zIndex.modal};

    ${media.up('lil')} {
      right: 40px;
    }
  `}
`;
const MediaContainer = styled.div `
  ${({ theme: { zIndex } }) => css `
    z-index: ${zIndex.modal};
    height: 571px;
    display: flex;
    justify-content: center;
  `}
`;
const GalleryPopup = ({ onClose, children }) => {
    return (React__default.createElement(PopupOverlay, null,
        React__default.createElement(CloseButton$2, null,
            React__default.createElement(IconButton$5, { onClick: onClose, title: "close", icon: "cross_small", variant: "secondary" })),
        React__default.createElement(MediaContainer, null, children)));
};

const ThumbnailsSliderWrapper = styled.div `
  ${({ theme: { media, palette, spacing } }) => css `
    ${slickCarouselStyles};
    width: 216px;
    margin: 0 auto;

    .slick-slide {
      display: flex !important;
      align-items: center;
      justify-content: center;

      & > div {
        padding: 0 ${spacing.s1};
        width: 72px;
        height: 56px;
        object-fit: scale-down;
      }
    }

    .slick-slide .slick-active .slick-current {
      & > div {
        border: 2px solid ${palette.baseColors.lupin};
      }
    }

    .slick-prev,
    .slick-next {
      width: 48px;
      height: 48px;
    }

    .slick-prev {
      left: -48px;
    }
    .slick-next {
      right: -48px;
    }

    ${media.up('slim')} {
      width: 240px;
      .slick-slide {
        & > div {
          width: 80px;
          height: 64px;
        }
      }
    }

    ${media.up('big')} {
      width: 384px;
      .slick-slide {
        & > div {
          width: 96px;
          height: 80px;
        }
      }
    }
  `}
`;
const ThumbnailImage = styled.img `
  ${({ theme: { borderRadius, palette }, isActive }) => css `
    height: 100%;
    object-fit: scale-down;
    border: 2px solid;
    display: block;
    border-color: ${isActive
    ? palette.baseColors.lupin
    : palette.baseColors.moeraki};
    border-radius: ${borderRadius.r0_75};
    cursor: pointer;
  `}
`;
const ThumbnailSlider = React__default.forwardRef(({ className, data, activeIndex, setActiveIndex, onThumbnailClick, primarySliderRef, isPrevButtonVisible, isNextButtonVisible, settings, }, ref) => {
    const { palette } = useTheme();
    const slidesToShow = useMediaQuery({ max: 'slim' }) ? 3 : 4;
    const sliderSettings = Object.assign({ dots: false, infinite: false, swipeToSlide: true, slidesToScroll: 1, slidesToShow, nextArrow: isNextButtonVisible ? (React__default.createElement(Button$2, { variant: "textbutton", type: "button", "data-testid": "next-icon" },
            React__default.createElement(Icon, { name: "chevron_right_small", fill: palette.baseColors.lupin }))) : (React__default.createElement(React__default.Fragment, null)), prevArrow: isPrevButtonVisible ? (React__default.createElement(Button$2, { variant: "textbutton", type: "button", "data-testid": "prev-icon" },
            React__default.createElement(Icon, { name: "chevron_left_small", fill: palette.baseColors.lupin }))) : (React__default.createElement(React__default.Fragment, null)) }, settings);
    return (React__default.createElement(ThumbnailsSliderWrapper, { className: className },
        React__default.createElement(Slider$1, Object.assign({ ref: ref }, sliderSettings), data.map((item, i) => {
            return (React__default.createElement(ThumbnailImage, { key: `thumbnail-${item.id}`, src: item.thumbnailUrl || item.defaultUrl, alt: item.description, isActive: i === activeIndex, onClick: () => {
                    var _a;
                    onThumbnailClick === null || onThumbnailClick === void 0 ? void 0 : onThumbnailClick();
                    setActiveIndex(i);
                    (_a = primarySliderRef === null || primarySliderRef === void 0 ? void 0 : primarySliderRef.current) === null || _a === void 0 ? void 0 : _a.slickGoTo(i);
                } }));
        }))));
});

const OverlayImage = styled(motion.img) `
  max-height: calc(100vh - 340px);
  object-fit: scale-down;
`;
const ZoomableImageContainer = styled.div `
  ${({ isZoomInMode }) => css `
    &:hover {
      cursor: ${isZoomInMode ? 'zoom-in' : 'zoom-out'};
    }
  `}
`;
const ProductGalleryZoomableImage = ({ src, description, onClick, }) => {
    const [isZoomInMode, setZoomInMode] = useState(true);
    return (React__default.createElement(ZoomableImageContainer, { onClick: onClick, isZoomInMode: isZoomInMode },
        React__default.createElement(TransformWrapper, { key: description, onInit: () => setZoomInMode(true), onTransformed: (transformData) => {
                const isZoomIn = transformData.state.scale <= 1;
                setZoomInMode(isZoomIn);
            }, doubleClick: {
                mode: isZoomInMode ? 'zoomIn' : 'reset',
            } },
            React__default.createElement(TransformComponent, null,
                React__default.createElement(OverlayImage, { key: description, animate: { opacity: 1 }, initial: { opacity: 0.5 }, transition: { duration: 0.8 }, src: src, alt: description })))));
};

const PRODUCT_GALLERY_CARD_WIDTH = 340;
const SLIDES_TO_SHOW = 4;

const OverlayContent = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  & > div {
    min-height: calc(100vh - ${PRODUCT_GALLERY_CARD_WIDTH}px);
  }
`;
const StyledVideoPlayer$1 = styled.div `
  position: relative;
  align-content: center;
  object-fit: scale-down;
  aspect-ratio: 1;
`;
const StyledThumbnailSlider = styled(ThumbnailSlider) `
  ${({ theme: { media, spacing } }) => css `
    width: 100%;
    margin: 0 ${spacing.s6};
    padding-top: ${spacing.s8};

    ${media.up('slim')} {
      max-width: 468px;
    }
  `}
`;
const ImageGalleryPopup = ({ setOverlayOpen, activeImage, data, activeIndex, setActiveIndex, primarySliderRef, onCarouselChange, onProductGalleryZoomableImageClick, onSetActiveIndex, }) => {
    var _a;
    const { beforeChangeHandler, isPrevButtonVisible, isNextButtonVisible, sliderRef: thumbnailRef, } = useCarouselControl(data.length, SLIDES_TO_SHOW);
    const handleCarouselChange = (currentIndex, newIndex) => {
        beforeChangeHandler(currentIndex, newIndex);
        onCarouselChange === null || onCarouselChange === void 0 ? void 0 : onCarouselChange();
    };
    return (React__default.createElement(GalleryPopup, { onClose: () => setOverlayOpen(false) },
        React__default.createElement(OverlayContent, null,
            activeImage.mediaType === 'VIDEO' ? (React__default.createElement(StyledVideoPlayer$1, null,
                React__default.createElement(VideoPlayer, { embedUrl: (_a = activeImage.standardUrl) !== null && _a !== void 0 ? _a : '' }))) : (React__default.createElement(ProductGalleryZoomableImage, { src: activeImage.zoomUrl || activeImage.defaultUrl, description: activeImage.description, onClick: onProductGalleryZoomableImageClick })),
            React__default.createElement(StyledThumbnailSlider, { data: data, ref: thumbnailRef, activeIndex: activeIndex, setActiveIndex: (i) => {
                    setActiveIndex(i);
                    onSetActiveIndex === null || onSetActiveIndex === void 0 ? void 0 : onSetActiveIndex(i);
                }, isPrevButtonVisible: isPrevButtonVisible, isNextButtonVisible: isNextButtonVisible, primarySliderRef: primarySliderRef, onOverlayOpen: () => setOverlayOpen(true), settings: {
                    beforeChange: handleCarouselChange,
                } }))));
};

const ProductGalleryStickyWrapper = styled.div `
  ${({ isSticky, isOverlayOpen, theme: { zIndex } }) => css `
    position: ${isSticky && !isOverlayOpen ? 'sticky' : 'static'};
    top: 120px;
    right: 0;
    z-index: ${isOverlayOpen ? zIndex.overlay : zIndex.default};
  `}
`;
const StyledVideoPlayer = styled.div `
  position: relative;
  align-content: center;
  object-fit: scale-down;
  aspect-ratio: 1;
`;
const ProductGalleryPrimaryImage = styled(motion.img) `
  ${({ theme: { spacing }, showPopup }) => css `
    display: block;
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: scale-down;
    margin-bottom: ${spacing.s3};
    &:hover {
      cursor: ${showPopup ? 'zoom-in' : 'default'};
    }
  `}
`;
const ProductGallery = ({ data, className, showPopup = true, showNavigationArrows = true, isSticky = false, onThumbnailClick, dynamicTargetValue = '', onSetActiveIndex, onProductGalleryZoomableImageClick, onCarouselChange, }) => {
    const [isOverlayOpen, setOverlayOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const activeImage = data[activeIndex];
    const primarySliderRef = useRef(null);
    const { beforeChangeHandler, isPrevButtonVisible, isNextButtonVisible, sliderRef: thumbnailRef, } = useCarouselControl(data.length, SLIDES_TO_SHOW);
    const componentName = 'Product Gallery';
    const shouldShowImageGalleryPopup = showPopup && isOverlayOpen;
    const handleAfterChange = (currentSlide) => {
        setActiveIndex(currentSlide);
        onSetActiveIndex === null || onSetActiveIndex === void 0 ? void 0 : onSetActiveIndex(currentSlide);
    };
    useEffect(() => {
        const handleEscPress = (e) => {
            if (e.key === 'Escape') {
                setOverlayOpen(false);
            }
        };
        document.addEventListener('keydown', handleEscPress);
        return () => {
            document.removeEventListener('keydown', handleEscPress);
        };
    }, []);
    return (React__default.createElement(ProductGalleryStickyWrapper, { isSticky: isSticky, isOverlayOpen: isOverlayOpen, className: className, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(Box, null,
            React__default.createElement(Carousel, { ref: primarySliderRef, showNextButton: false, showPrevButton: false, settings: {
                    afterChange: handleAfterChange,
                } }, data.map((item, index) => item.mediaType === 'VIDEO' ? (React__default.createElement(StyledVideoPlayer, { key: `standard-video-${item.id}` },
                React__default.createElement(VideoPlayer, { embedUrl: item.standardUrl, isVisible: !shouldShowImageGalleryPopup && index === activeIndex }))) : (React__default.createElement(ProductGalleryPrimaryImage, { key: `standard-image-${item.id}`, src: item.standardUrl || item.defaultUrl, alt: item.description, showPopup: showPopup, onClick: showPopup
                    ? () => {
                        setOverlayOpen(true);
                    }
                    : () => { } })))),
            React__default.createElement(ThumbnailSlider, { data: data, ref: thumbnailRef, activeIndex: activeIndex, setActiveIndex: (i) => setActiveIndex(i), onThumbnailClick: onThumbnailClick, isPrevButtonVisible: Boolean(showNavigationArrows && isPrevButtonVisible), isNextButtonVisible: Boolean(showNavigationArrows && isNextButtonVisible), primarySliderRef: primarySliderRef, onOverlayOpen: () => {
                    setOverlayOpen(true);
                }, settings: { beforeChange: beforeChangeHandler } }),
            shouldShowImageGalleryPopup ? (React__default.createElement(ImageGalleryPopup, { activeImage: activeImage, activeIndex: activeIndex, setActiveIndex: setActiveIndex, setOverlayOpen: setOverlayOpen, data: data, primarySliderRef: primarySliderRef, onSetActiveIndex: onSetActiveIndex, onProductGalleryZoomableImageClick: onProductGalleryZoomableImageClick, onCarouselChange: onCarouselChange })) : null)));
};

const QuickLinkBox = styled(Box) `
  ${({ theme: { media, palette, spacing, borderRadius } }) => css `
    border-radius: ${borderRadius.r3};
    border: 2px solid ${palette.baseColors.moeraki};
    box-shadow: 0 0 0 2px transparent;
    box-sizing: border-box;
    color: ${palette.textColor};
    cursor: pointer;
    margin-bottom: ${spacing.s2};
    text-align: center;
    transition: ease-in-out 0.1s;

    &:hover {
      background: ${palette.baseColors.onepu};
    }

    &:active {
      background: ${palette.baseColors.alto};
    }

    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      outline-offset: 2px;
    }

    &:last-child {
      margin-bottom: unset;
    }

    ${media.up('slim')} {
      margin-bottom: unset;
    }
  `}
`;
const Content$1 = styled.div `
  max-width: 300px;
`;
const QuickLinkCard = ({ icon, title, description, ctaTitle, dynamicTargetValue, alt, }) => {
    const componentName = 'Quicklink Card';
    return (React__default.createElement(QuickLinkBox, { tabIndex: 0, flexDirection: "column", alignItems: "center", bg: "wairua", py: ['s3', 's3', 's4'], px: "s4", "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(Content$1, null,
            React__default.createElement(Box, { mb: "s0_5" }, icon ? React__default.createElement("img", { src: icon, height: 48, width: 48, alt: alt }) : null),
            React__default.createElement(Text, { variant: "subheadingL", mb: "s1" }, title),
            React__default.createElement(RawHtml, { variant: "bodyMDemi", html: description }),
            React__default.createElement(Box, { pt: "s2" }, ctaTitle ? (React__default.createElement(Button$2, { variant: "textbutton", tabIndex: -1 }, ctaTitle)) : null))));
};

function chooseIconName$1({ iconName, variant }) {
    if (iconName) {
        return iconName;
    }
    if (variant === 'error') {
        return 'warning_small';
    }
    return 'info_small';
}
const SnackbarContainer = styled.div `
  ${({ theme: { borderRadius, elevation, media, palette } }) => css `
    background: ${palette.baseColors.greyLynn};
    border-radius: ${borderRadius.r0_75};
    box-shadow: ${elevation.elevation3};
    display: flex;
    width: 100%;

    ${media.up('slim')} {
      max-width: 407px;
    }
  `}
`;
const ColorStrip$1 = styled.div `
  ${({ theme: { palette }, isError }) => css `
    background-color: ${isError
    ? palette.baseColors.karaka
    : palette.baseColors.kiwi};
    border-top-left-radius: inherit;
    border-bottom-left-radius: inherit;
    width: 8px;
  `}
`;
const IconContainer$4 = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2};
    width: 56px;
  `}
`;
const ContentColumn = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    padding: ${spacing.s2} ${spacing.s3} ${spacing.s2} 0;
  `}
`;
const CloseButton$1 = styled.button `
  ${({ theme: { spacing } }) => css `
    display: flex;
    width: 40px;
    padding: ${spacing.s2} ${spacing.s2} ${spacing.s2} 0;
    background-color: transparent;
    border: none;
    cursor: pointer;
  `}
`;
const InverseTextButton = styled(Button$2) `
  ${({ theme: { palette, spacing } }) => css `
    margin-top: ${spacing.s1};
    & > * {
      color: ${palette.baseColors.benLomond};

      &:hover {
        color: ${palette.baseColors.lupin};
      }
    }
  `}
`;
const EmptyWrapper = ({ children }) => (React__default.createElement(React__default.Fragment, null, children));
function Snackbar({ buttonText, disabled = false, iconName, isDismissible = false, onClick, onCloseClick, text, variant = 'information', wrapper: Wrapper = EmptyWrapper, }) {
    const { palette } = useTheme();
    const shouldShowButton = buttonText && onClick;
    return (React__default.createElement(Wrapper, null,
        React__default.createElement(SnackbarContainer, null,
            React__default.createElement(ColorStrip$1, { isError: variant === 'error' }),
            React__default.createElement(IconContainer$4, null,
                React__default.createElement(Icon, { fill: palette.baseColors.wairua, name: chooseIconName$1({ iconName, variant }) })),
            React__default.createElement(ContentColumn, null,
                React__default.createElement(Text, { color: palette.baseColors.wairua, variant: "bodySMedium" }, text),
                shouldShowButton ? (React__default.createElement(InverseTextButton, { variant: "textbutton", onClick: onClick, disabled: disabled }, buttonText)) : null),
            isDismissible ? (React__default.createElement(CloseButton$1, { onClick: onCloseClick },
                React__default.createElement(Icon, { fill: palette.baseColors.wairua, name: "cross_small" }))) : null)));
}

const DEFAULT_DURATION = 5000;
function useSnackbarAnimation() {
    const { spacing } = useTheme();
    const isDesktop = useMediaQuery({ min: 'big' });
    const isTablet = useMediaQuery({ min: 'slim', max: 'big' });
    const isMobile = useMediaQuery({ max: 'slim' });
    if (isDesktop) {
        return {
            initial: { x: '100%', y: 0 },
            animate: { x: `-${spacing.s2}`, y: 0 },
            exit: { x: '100%', y: 0 },
        };
    }
    if (isTablet) {
        return {
            initial: { x: 0, y: '-100%' },
            animate: { x: 0, y: spacing.s2 },
            exit: { x: 0, y: '-100%' },
        };
    }
    if (isMobile) {
        return {
            initial: { x: 0, y: '100%' },
            animate: { x: 0, y: `-${spacing.s3}` },
            exit: { x: 0, y: '100%' },
        };
    }
    return null;
}
const Container$e = styled.div `
  ${({ theme: { media, spacing, zIndex } }) => css `
    left: 50%;
    position: fixed;
    bottom: 0;
    transform: translateX(-50%);
    padding: 0 ${spacing.s3};
    width: 100%;
    z-index: ${zIndex.snackbar};

    ${media.up('slim')} {
      bottom: unset;
      top: 0;
      width: initial;
    }

    ${media.up('big')} {
      left: unset;
      padding: ${spacing.s2} 0 0 0;
      right: 0;
      transform: none;
    }
  `}
`;
const INITIAL_VALUE = {
    showSnackbar: () => { },
    hideSnackbar: () => { },
};
const SnackbarContext = createContext(INITIAL_VALUE);
function SnackbarProvider({ children }) {
    const [state, setState] = useState(null);
    const snackbarAnimation = useSnackbarAnimation();
    const debounceRef = useRef(null);
    const cancelDelayedHideSnackbar = () => {
        var _a, _b;
        if ((_a = debounceRef.current) === null || _a === void 0 ? void 0 : _a.cancel) {
            (_b = debounceRef.current) === null || _b === void 0 ? void 0 : _b.cancel();
        }
    };
    const hideSnackbar = () => {
        cancelDelayedHideSnackbar();
        setState(null);
    };
    const showSnackbar = (params) => {
        const { duration = DEFAULT_DURATION, isDismissible } = params, args = __rest(params, ["duration", "isDismissible"]);
        setState({ snackbarProps: args, key: Math.random().toString() });
        cancelDelayedHideSnackbar();
        if (!isDismissible) {
            debounceRef.current = debounce(hideSnackbar, duration);
            debounceRef.current();
        }
    };
    const handleButtonClick = (event) => {
        var _a, _b;
        if (state === null || state === void 0 ? void 0 : state.snackbarProps) {
            setState(Object.assign(Object.assign({}, state), { snackbarProps: Object.assign(Object.assign({}, state.snackbarProps), { disabled: true }) }));
            (_b = (_a = state.snackbarProps).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        }
    };
    return (React__default.createElement(SnackbarContext.Provider, { value: { showSnackbar, hideSnackbar } },
        children,
        React__default.createElement(AnimatedComponent, null, state != null && snackbarAnimation != null ? (React__default.createElement(Container$e, { key: state.key },
            React__default.createElement(motion.div, Object.assign({}, snackbarAnimation, { transition: { type: 'linear', duration: 0.2 } }),
                React__default.createElement(Snackbar, Object.assign({}, state.snackbarProps, { onCloseClick: hideSnackbar, onClick: handleButtonClick }))))) : null)));
}
function useSnackbar() {
    const context = useContext(SnackbarContext);
    if (context === undefined) {
        throw new Error('useSnackbar must be used within a SnackbarProvider');
    }
    return context;
}

function chooseIconName({ iconName, variant }) {
    if (iconName) {
        return iconName;
    }
    if (variant === 'ERROR' || variant === 'WARN') {
        return 'warning_small';
    }
    if (variant === 'SUCCESS') {
        return 'check_contained_small';
    }
    if (variant === 'IMPORTANT') {
        return 'gift_small';
    }
    return 'info_small';
}
function getColorBasedOnVariant(variant) {
    const { palette: { baseColors: { sparkPurple, kowhai, marangai, sparkGreen }, importantSecondary, }, } = useTheme();
    // TODO Need to confirm rgba background color codes from design team.
    switch (variant) {
        case 'INFO':
            return { color: sparkPurple, rgba: 'rgba(90, 18, 170, 0.06)' };
        case 'WARN':
            return { color: kowhai, rgba: 'rgba(218, 61, 0, 0.06)' };
        case 'ERROR':
            return { color: marangai, rgba: 'rgba(218, 61, 0, 0.06)' };
        case 'IMPORTANT':
            return { color: importantSecondary, rgba: 'rgba(241, 43, 163, 0.06)' };
        case 'SUCCESS':
            return { color: sparkGreen, rgba: 'rgba(0, 136, 65, 0.06)' };
        default:
            return { color: sparkPurple, rgba: 'rgba(90, 18, 170, 0.06)' };
    }
}
const InfoBannerButton = styled(Button$2) `
  ${({ infoVariant, buttonColor }) => {
    const { color: variantColor } = getColorBasedOnVariant(infoVariant);
    const color = buttonColor || variantColor;
    return css `
      white-space: normal;
      text-align: left;
      display: inline-block;
      & > * {
        color: ${color};

        &:hover {
          color: ${color};
        }

        &:active {
          color: ${color};
        }
      }
    `;
}}
`;
const InfoTextButton = ({ buttonText, onClick, disabled, variant, buttonColor, componentAs, href, target, }) => {
    return (React__default.createElement("div", null,
        React__default.createElement(InfoBannerButton, { variant: "textbutton", onClick: onClick, disabled: disabled, infoVariant: variant, type: "button", buttonColor: buttonColor, component: componentAs, href: href, target: target }, buttonText)));
};
const IconContainer$3 = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2};
    width: 24px;
  `}
`;
const InfoBannerContainer = styled.div `
  ${({ theme: { borderRadius }, infoVariant, hasRoundedCorners }) => css `
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    background: ${getColorBasedOnVariant(infoVariant).rgba};
    border-radius: ${hasRoundedCorners ? borderRadius.r0_75 : 0};
    overflow: hidden;
  `}
`;
const ColorStrip = styled.div `
  ${({ infoVariant }) => css `
    background: ${getColorBasedOnVariant(infoVariant).color};
    width: 8px;
    align-self: stretch;
    flex-shrink: 0;
  `}
`;
const InfoChildrenContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2} ${spacing.s4} ${spacing.s2} 18px;
  `}
`;
const InfoText = styled(Text) `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2} ${spacing.s4} ${spacing.s2} 18px;
  `}
`;
const InfoBanner = ({ className, iconName, variant = 'INFO', disabled = false, onClick, buttonText, text, children, isCustomChildrenEnabled, buttonColor, componentAs = 'button', href, target, hasRoundedCorners = true, }) => {
    const isTextButtonVisible = componentAs === 'button' ? buttonText && onClick : buttonText;
    return (React__default.createElement(InfoBannerContainer, { className: className, infoVariant: variant, hasRoundedCorners: hasRoundedCorners },
        React__default.createElement(ColorStrip, { infoVariant: variant }),
        React__default.createElement(IconContainer$3, null,
            React__default.createElement(Icon, { fill: getColorBasedOnVariant(variant).color, name: chooseIconName({ iconName, variant }) })),
        isCustomChildrenEnabled ? (React__default.createElement(InfoChildrenContainer, null, children)) : (React__default.createElement(InfoText, { variant: "bodySMedium" }, children !== null && children !== void 0 ? children : text,
            isTextButtonVisible ? (React__default.createElement(InfoTextButton, { disabled: disabled, onClick: onClick, componentAs: componentAs, href: href, buttonText: buttonText, variant: variant, buttonColor: buttonColor, target: target })) : null))));
};

const BaseStyle = styled.div `
  ${({ theme: { spacing, palette } }) => css `
    padding: ${spacing.s2};
    color: ${palette.baseColors.wairua};
    border-radius: 6px;
    display: flex;
  `};
`;
const WarningFeedbackAlert = styled(BaseStyle) `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.marangai};
  `};
`;
const InformationFeedbackAlert = styled(BaseStyle) `
  ${({ theme: { palette } }) => css `
    background-color: ${palette.baseColors.sparkGreen};
  `};
`;
const IconWithMargin = styled(Icon) `
  box-sizing: content-box;
  margin-right: ${({ theme }) => theme.spacing.s2};
  flex: 0 0 auto;
`;
const FeedbackAlertVariantMap = {
    information: InformationFeedbackAlert,
    warning: WarningFeedbackAlert,
};
const IconVariantMap = {
    information: 'info_small',
    warning: 'warning_small',
};
/**
 * @deprecated Please use the Snackbar component instead
 */
const FeedbackAlert = ({ variant, children, }) => {
    const StyledFeedbackAlert = FeedbackAlertVariantMap[variant];
    const iconName = IconVariantMap[variant];
    return (React__default.createElement(StyledFeedbackAlert, { "data-testid": "feedback-alert" },
        React__default.createElement(IconWithMargin, { fill: colors.wairua, name: iconName }),
        React__default.createElement(Text, { variant: "bodySDemi" }, children)));
};

const GlobalAlertWrapper = styled.div `
  ${({ theme: { zIndex, palette, spacing }, isVisible, variant }) => css `
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${spacing.s2} ${spacing.s3} ${spacing.s2} 0;
    background-color: ${variant === 'alert'
    ? palette.baseColors.karaka
    : palette.baseColors.poroporo};
    display: ${isVisible ? 'flex' : 'none'};
    z-index: ${zIndex.snackbar};
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  `}
`;
const IconWrapper$6 = styled.div `
  ${({ theme: { spacing } }) => css `
    margin-right: ${spacing.s2};
    margin-left: ${spacing.s3};
    align-self: flex-start;
  `}
`;
const CrossIconWrapper = styled.button `
  ${({ theme: { spacing, palette } }) => css `
    background: transparent;
    margin-left: ${spacing.s1};
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    position: relative;
    width: 24px;
    height: 24px;
    &:hover {
      cursor: pointer;
    }
    &:focus-visible {
      border: 1px dotted ${palette.baseColors.alto};
    }
  `}
`;
const JustifyContentSpaceBetween = styled.div `
  display: flex;
  width: 100%;
`;
const TextAndCrossWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  text-align: left;
`;
const ContentWrapper = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
`;
const GlobalAlert = (_a) => {
    var { variant, children, removeWhenDismissed } = _a, rest = __rest(_a, ["variant", "children", "removeWhenDismissed"]);
    const [isVisible, setIsVisible] = useState(true);
    const handleClose = () => {
        setIsVisible(false);
    };
    const { palette } = useTheme();
    if (!isVisible && removeWhenDismissed)
        return null;
    return (React__default.createElement(GlobalAlertWrapper, Object.assign({ variant: variant, isVisible: isVisible }, rest),
        React__default.createElement(JustifyContentSpaceBetween, null,
            React__default.createElement(ContentWrapper, null,
                React__default.createElement(IconWrapper$6, null,
                    React__default.createElement(Icon, { name: variant === 'information' ? 'info_small' : 'warning_small', fill: palette.baseColors.wairua })),
                React__default.createElement(TextAndCrossWrapper, null, children)),
            React__default.createElement(CrossIconWrapper, { onClick: handleClose },
                React__default.createElement(Icon, { name: "cross_small", fill: palette.baseColors.wairua })))));
};

const InfoContainer = styled.div `
  ${({ theme: { palette, spacing, borderRadius } }) => css `
    background-color: ${palette.baseColors.onepu};
    padding: ${spacing.s2};
    border-radius: ${borderRadius.r1};
  `}
`;
function InfoBox({ title, children }) {
    return (React__default.createElement(InfoContainer, null,
        React__default.createElement(Box, { flexDirection: "row", gap: "s1" },
            React__default.createElement(Icon, { name: "info_small" }),
            React__default.createElement(Text, { variant: "bodySDemi" }, title)),
        children));
}

const InfoBoxContainer = styled(Box) `
  ${({ theme: { palette, spacing }, backgroundColor }) => css `
    background-color: ${backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : palette.baseColors.onepu};
    padding: ${spacing.s2};
  `}
`;
function InfoStrip({ iconName, children, backgroundColor, }) {
    return (React__default.createElement(InfoBoxContainer, { justifyContent: "center", flexDirection: "row", gap: "s1", backgroundColor: backgroundColor },
        iconName ? (React__default.createElement(Box, null,
            React__default.createElement(Icon, { name: iconName }))) : null,
        children));
}

var BarWidth;
(function (BarWidth) {
    BarWidth[BarWidth["FULL"] = 100] = "FULL";
    BarWidth[BarWidth["EMPTY"] = 0] = "EMPTY";
})(BarWidth || (BarWidth = {}));
const BarWrapper = styled.div `
  position: relative;
  width: 100%;
  height: 24px;
`;
const Line$1 = styled.div `
  ${({ theme: { palette } }) => css `
    position: absolute;
    width: 100%;
    background: ${palette.baseColors.alto};
    top: 11px;
    height: 2px;
  `}
`;
const Bar = styled.div `
  ${({ theme: { zIndex, borderRadius }, progressPercentage, color }) => css `
    position: absolute;
    width: ${progressPercentage}%;
    background: ${color};
    z-index: ${zIndex.default};
    border-radius: ${borderRadius.r1};
    top: 6px;
    height: 12px;
  `}
`;
const ProgressBar = ({ animationDirection = 'rightToLeft', color, className, delay = 0.5, isAnimationDisabled = false, progressPercentage, }) => {
    const intialValue = animationDirection === 'rightToLeft' ? BarWidth.FULL : BarWidth.EMPTY;
    const [animatedValue, setAnimatedValue] = useState(intialValue);
    const motionValue = useMotionValue(intialValue);
    useEffect(() => {
        if (isAnimationDisabled) {
            return setAnimatedValue(progressPercentage);
        }
        const controls = animate(motionValue, progressPercentage, {
            type: 'tween',
            onUpdate: (updatedValue) => {
                setAnimatedValue(updatedValue);
            },
            duration: 0.5,
            delay,
        });
        return controls.stop;
    }, [progressPercentage]);
    return (React__default.createElement(BarWrapper, { "aria-valuemin": 0, "aria-valuemax": 100, "aria-valuenow": progressPercentage, className: className },
        React__default.createElement(Bar, { color: color, progressPercentage: animatedValue }),
        React__default.createElement(Line$1, null)));
};

const DropDownContainer$1 = styled.div `
  display: flex;
`;
const Indicators$1 = ({ isDisabled }) => {
    const { palette } = useTheme();
    const iconColor = isDisabled
        ? palette.baseColors.moeraki
        : palette.baseColors.lupin;
    return (React__default.createElement(DropDownContainer$1, null,
        React__default.createElement(Icon, { name: "chevron_down_small", fill: iconColor })));
};

const ClearIndicator = (props) => {
    const { getStyles } = props, _a = props.innerProps, { ref } = _a, restInnerProps = __rest(_a, ["ref"]);
    const { palette } = useTheme();
    return (React__default.createElement("div", Object.assign({}, restInnerProps, { ref: ref, style: getStyles('clearIndicator', props), title: "ClearIndicator" }),
        React__default.createElement(Icon, { name: "cross_small", fill: palette.baseColors.lupin, size: 16 })));
};

const HelperTexts = styled(Text) `
  ${({ theme: { spacing } }) => css `
    padding-top: ${spacing.s0_5};
    margin-left: ${spacing.s1};
  `}
`;
const HelperText = ({ children, isDisabled, }) => {
    const { palette } = useTheme();
    const helperTextColor = isDisabled
        ? palette.baseColors.alto
        : palette.baseColors.mawheranui;
    return children ? (React__default.createElement(HelperTexts, { variant: "footnoteMedium", color: helperTextColor }, children)) : null;
};

function isWhiteColor(color) {
    return new RegExp(/^(?:white|#fff(?:fff)?|rgba?\((\s*255\s*,?){3}(?:,\s*1\s*)?\)|0)$/, 'i').test(color);
}

const Container$d = styled.label `
  ${({ theme: { palette }, isInDropdown }) => css `
    ${bodySMediumStyle}
    position: relative;
    color: ${palette.baseColors.newZealandBlack};
    padding-left: ${isInDropdown ? s3 : s6};
    display: flex;
    justify-content: center;
    height: 24px;
    cursor: pointer;
    width: fit-content;
    align-items: center;
  `}
`;
const CheckboxInput$2 = styled.input `
  opacity: 0;
  cursor: pointer;
`;
const Circle$1 = styled.div `
  ${({ theme: { borderRadius, palette }, backgroundColor = 'transparent', checked, }) => css `
    height: 24px;
    width: 24px;
    border: ${isWhiteColor(backgroundColor)
    ? `1px solid  ${palette.baseColors.moeraki}`
    : 'transparent'};
    border-radius: ${borderRadius.round};
    background-color: ${backgroundColor};
    position: absolute;
    top: 0;
    left: 0;
    box-shadow: ${checked
    ? `0 0 0 2px ${palette.baseColors.wairua},
        0 0 0 4px ${palette.baseColors.lupin} `
    : null};
  `}
`;
const ColorInput = React__default.forwardRef((props, ref) => {
    const { label, name, disabled, onCheck, checked, autofocus, inputProps, color, isInDropdown, } = props;
    return (React__default.createElement(Container$d, { isInDropdown: isInDropdown },
        label,
        React__default.createElement(CheckboxInput$2, Object.assign({ type: "checkbox", ref: ref, name: name, disabled: disabled, onChange: () => onCheck(!checked), checked: checked, autoFocus: autofocus }, inputProps)),
        React__default.createElement(Circle$1, { backgroundColor: color, checked: checked })));
});

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgFilterDropdownCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.48c.287.23.334.65.104.937l-7.112 8.916-4.526-4.175a.667.667 0 11.901-.983l3.475 3.185 6.22-7.776a.667.667 0 01.938-.104z",
    fill: "#fff"
  })));
}

const Container$c = styled.label `
  ${({ theme: { spacing } }) => css `
    position: relative;
    font-style: normal;
    ${footNoteDemiStyle}
    padding-left: ${spacing.s3};
    display: flex;
    height: ${spacing.s3};
    width: fit-content;
    align-items: flex-start;
    cursor: pointer;
    user-select: none;
  `}
`;
const CustomCheck$1 = styled(SvgIcon) `
  position: absolute;
`;
const Checkmark$1 = styled.span `
  ${({ theme: { palette, spacing }, checked }) => css `
    border-color: ${checked
    ? palette.baseColors.lupin
    : palette.baseColors.mawheranui};
    background-color: ${checked
    ? palette.baseColors.lupin
    : palette.baseColors.wairua};

    position: absolute;
    top: 4px;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: ${spacing.s2};
    width: ${spacing.s2};
    border-radius: 2px;
    border-width: 2px;
    border-style: solid;
    box-sizing: border-box;
    border: ${checked ? 'none' : `1px solid ${palette.baseColors.mawheranui}`};
  `};
`;
const CheckboxInput$1 = styled.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:disabled ~ ${Checkmark$1} {
    ${({ theme: { palette }, checked }) => css `
      border-color: ${checked
    ? palette.baseColors.alto
    : palette.baseColors.alto};
      background-color: ${checked
    ? palette.baseColors.alto
    : palette.baseColors.wairua};
    `};
  }
`;
const Circle = styled.div `
  ${({ theme: { borderRadius, palette, spacing }, color }) => css `
    height: 24px;
    width: 24px;
    margin-right: ${spacing.s1};
    border-radius: ${borderRadius.round};
    background-color: ${color};
    box-shadow: 0 0 0 2px
      ${(color === null || color === void 0 ? void 0 : color.toUpperCase()) === '#FFFFFF' || color === 'white'
    ? palette.baseColors.alto
    : palette.baseColors.wairua};
  `}
`;
const FilterDropdownCheckbox = (props) => {
    const { label, disabled, onCheck, checked, isMultiWithCircle, color, inputProps, } = props;
    return (React__default.createElement(Container$c, null,
        label,
        React__default.createElement(CheckboxInput$1, Object.assign({ type: "checkbox", disabled: disabled, onChange: () => onCheck(!checked), checked: checked }, inputProps)),
        isMultiWithCircle ? React__default.createElement(Circle, { color: color }) : null,
        React__default.createElement(Checkmark$1, { checked: checked }, checked ? (React__default.createElement(CustomCheck$1, { component: SvgFilterDropdownCheckbox, fill: "white", height: 16, width: 16 })) : null)));
};

const CheckboxWrapper = styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
function Options(props) {
    const { isMulti, isColorInput, data: { value }, isSelected, isMultiWithCircle, label, } = props;
    return (React__default.createElement(components.Option, Object.assign({}, props),
        React__default.createElement(CheckboxWrapper, null,
            isMulti &&
                (isColorInput ? (React__default.createElement(ColorInput, { color: value, onCheck: () => {
                        return false;
                    }, checked: isSelected, isInDropdown: true })) : (React__default.createElement(FilterDropdownCheckbox, { checked: isSelected, onCheck: () => {
                        return false;
                    }, color: value, isMultiWithCircle: isMultiWithCircle }))),
            React__default.createElement(Text, { variant: "footnoteMedium" }, label))));
}

const CustomScrollbarMixin = css `
  ${({ theme: { spacing } }) => css `
    width: ${spacing.s2};
    height: ${spacing.s8};
  `}
`;
const CustomScrollbarTrackMixin = css `
  ${({ theme: { borderRadius, palette } }) => css `
    background: ${palette.baseColors.wairua};
    border-radius: ${borderRadius.r1};
  `}
`;
const CustomScrollbarThumbMixin = css `
  ${({ theme: { borderRadius, media, palette, spacing } }) => css `
    background: ${palette.baseColors.alto};
    border: 4px solid ${palette.baseColors.wairua};
    border-radius: ${borderRadius.r1};
    min-height: ${spacing.s8};
    ${media.up('slim')} {
      min-height: ${spacing.s9};
    }
  `}
`;
css `
  & ::-webkit-scrollbar {
    ${CustomScrollbarMixin}
  }

  & ::-webkit-scrollbar-track {
    ${CustomScrollbarTrackMixin}
  }

  & ::-webkit-scrollbar-thumb {
    ${CustomScrollbarThumbMixin}
  }
`;

const CustomSingleSelect = styled(ReactSelect) `
  ${({ theme: { palette, spacing, borderRadius, media, zIndex } }) => css `
    /* Input box */
    & .spark__indicators {
      padding-right: 2px;
    }

    & .spark__control {
      border: 2px solid ${palette.baseColors.moeraki};
      box-shadow: none;
      border-radius: ${borderRadius.r3};
      display: flex !important;
      align-content: space-around !important;
      padding: ${spacing.s1} ${spacing.s3};
      height: ${spacing.s5};
      ${media.up('slim')} {
        height: ${spacing.s6};
        padding: ${spacing.s1_5} ${spacing.s3};
      }
      &:hover {
        border: 2px solid ${palette.baseColors.lupin};
      }
    }

    & .spark__control--is-disabled {
      background: ${palette.baseColors.wairua};
    }

    & .spark__value-container {
      ${bodySMediumStyle};
    }

    & .spark__single-value,
    .spark__single-value .spark__menu {
      ${bodySMediumStyle};
      color: ${palette.baseColors.newZealandBlack};
      ${media.only('lil')} {
        max-width: 100%;
      }
    }

    & .spark__control--is-focused {
      border: solid 2px ${palette.baseColors.lupin};
      box-shadow: none;
      &:hover {
        border: 2px solid ${palette.baseColors.lupin};
      }
    }

    /* Menu */
    & .spark__menu {
      z-index: ${zIndex.navigation};
      box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.16);
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r1};
      padding: ${spacing.s1} 1px 0px 1px;
      margin: ${spacing.s0_5} ${spacing.s1} ${spacing.s0_5} 0;
    }

    & .spark__option {
      padding: ${spacing.s1_5} ${spacing.s2};
      cursor: pointer;

      div {
        align-items: center;
      }
    }

    & .spark__option--is-focused {
      background: ${palette.baseColors.onepu};
      color: ${palette.baseColors.newZealandBlack};
      &:active {
        background: ${palette.baseColors.onepu};
      }
    }

    & .spark__option--is-selected,
    .spark__option--is-selected p {
      background: ${palette.baseColors.lupin};
      color: ${palette.baseColors.wairua};
      &:active {
        background: ${palette.baseColors.onepu};
      }
    }

    /* Menu Scroll Bar */
    & .spark__menu-list::-webkit-scrollbar {
      ${CustomScrollbarMixin}
    }
    & .spark__menu-list::-webkit-scrollbar-track {
      ${CustomScrollbarTrackMixin}
    }
    & .spark__menu-list::-webkit-scrollbar-thumb {
      ${CustomScrollbarThumbMixin}
    }

    & .spark__value-container {
      padding: 0 !important; /* use important to override react-select inbuilt padding*/
    }
  `}
`;
const CustomMultiSelect = styled(CustomSingleSelect) `
  ${({ theme: { palette, spacing } }) => css `
    & .spark__option--is-selected {
      background: ${palette.baseColors.wairua};
      color: ${palette.baseColors.newZealandBlack};
      &:active {
        background: ${palette.baseColors.onepu};
      }
      &:hover {
        background: ${palette.baseColors.onepu};
      }
    }

    .spark__option--is-selected p {
      background: transparent;
      color: ${palette.baseColors.newZealandBlack};
    }

    & .spark__control {
      align-content: center !important;
    }

    & .spark__value-container--is-multi {
      color: ${palette.baseColors.newZealandBlack};
      overflow: hidden;
      height: ${spacing.s3};
      /* fade text when overflow */
      -webkit-mask-image: linear-gradient(90deg, #000 50%, transparent);
    }
  `}
`;
const CustomMultiSelectAlternate = styled(CustomSingleSelect) `
  ${({ theme: { palette, spacing } }) => css `
    & .spark__control {
      width: 204px;
    }
    & .spark__menu {
      width: 264px;
    }
    & .spark__option--is-selected {
      background: ${palette.baseColors.wairua};
      color: ${palette.baseColors.newZealandBlack};
      &:active,
      &:hover {
        background: ${palette.baseColors.onepu};
      }
    }

    .spark__option--is-selected p {
      background: transparent;
      color: ${palette.baseColors.newZealandBlack};
    }

    & .spark__value-container--is-multi {
      color: ${palette.baseColors.newZealandBlack};
      overflow: hidden;
      height: ${spacing.s3};
      /* fade text when overflow */
      -webkit-mask-image: linear-gradient(90deg, #000 50%, transparent);
    }
  `}
`;

const CustomReactSelect$1 = styled(CustomSingleSelect) `
  ${({ theme: { borderRadius, elevation, media, palette, spacing } }) => css `
    & .spark__indicators {
      padding: 0;
    }

    & .spark__indicator-separator {
      display: none;
    }

    & .spark__control {
      border: 2px solid ${palette.baseColors.lupin};
      background-color: ${palette.baseColors.wairua};
      height: ${spacing.s5};
      padding: 0 ${spacing.s3};
      ${media.up('slim')} {
        height: ${spacing.s6};
      }

      svg {
        path {
          fill: ${palette.baseColors.lupin};
        }
      }

      &:hover {
        border: 2px solid ${palette.baseColors.sparkPurple};
        background-color: ${palette.baseColors.wanaka};

        svg {
          path {
            fill: ${palette.baseColors.sparkPurple};
          }
        }
      }
    }

    & .spark__control--is-disabled {
      border: 2px solid ${palette.baseColors.alto};

      svg {
        path {
          fill: ${palette.baseColors.alto};
        }
      }
    }

    & .spark__single-value {
      color: ${palette.baseColors.lupin};
    }

    & .spark__single-value--is-disabled {
      color: ${palette.baseColors.alto};
    }

    & .spark__menu {
      ${footNoteMediumStyle}
      background-color: ${palette.baseColors.wairua};
      border-radius: ${borderRadius.rHalf};
      box-shadow: ${elevation.elevation1};
      max-width: 264px;
    }
  `}
`;

function DropdownIndicator(indicatorProps) {
    return React__default.createElement(Indicators$1, Object.assign({}, indicatorProps));
}
function CategorySwitcher(props) {
    const { className, maxMenuHeight = '165px', selectedValue, disabled, isSearchable, name, onChange, options, placeholder } = props, rest = __rest(props, ["className", "maxMenuHeight", "selectedValue", "disabled", "isSearchable", "name", "onChange", "options", "placeholder"]);
    /* List of some props we can alter/customise from react-select */
    const customComponents = {
        DropdownIndicator,
    };
    return (React__default.createElement("div", { className: className },
        React__default.createElement(CustomReactSelect$1, Object.assign({ maxMenuHeight: maxMenuHeight, classNamePrefix: "spark", components: customComponents, defaultValue: selectedValue, isDisabled: disabled, onChange: (value) => onChange === null || onChange === void 0 ? void 0 : onChange(value), options: options, placeholder: placeholder || '', value: selectedValue, closeMenuOnSelect: true, isMulti: false, isSearchable: isSearchable }, rest))));
}

/**
 * Using a empty style component to make it easier to target the correct label in position label function
 */
const Label = styled.label ``;
const labelPositionMixin = css `
  ${({ labelPosition, theme: { spacing } }) => {
    if (labelPosition === 'top-center') {
        return css `
        align-items: center;
        flex-direction: column;
        ${Label} {
          margin-bottom: ${spacing.s2};
        }
      `;
    }
    return css `
      align-items: center;
      ${Label} {
        margin-right: ${spacing.s2};
      }
    `;
}}
`;
const Group = styled.div `
  align-items: flex-start;
  display: flex;
  position: relative;
  width: fit-content;
  ${labelPositionMixin};
`;

const Chips$1 = styled.div `
  display: flex;
  flex-direction: row;
`;
const Chip$1 = styled.button `
  ${({ theme: { palette, spacing, borderRadius, media }, selected }) => css `
    cursor: pointer;

    background: ${selected
    ? palette.baseColors.lupin
    : palette.baseColors.wairua};
    color: ${selected
    ? palette.baseColors.wairua
    : palette.baseColors.newZealandBlack};

    padding: ${spacing.s1} ${spacing.s3};

    border: 2px solid
      ${selected ? palette.baseColors.lupin : palette.baseColors.moeraki};
    border-radius: ${borderRadius.r3};

    margin-left: ${spacing.s1};

    transition: 0.1s ease-in-out;

    &:hover {
      border: 2px solid ${palette.baseColors.lupin};
    }

    &:focus-visible {
      box-shadow:
        0 0 0 1px ${palette.baseColors.wairua},
        0 0 0 4px ${palette.baseColors.lupin};
    }

    ${media.up('slim')} {
      padding: 10px ${spacing.s3};
    }

    ${media.up('big')} {
      padding: ${spacing.s1_5} ${spacing.s4};
    }
  `}
`;
const toggle = (array, itemToToggle) => {
    if (array.includes(itemToToggle)) {
        return array.filter((item) => item !== itemToToggle);
    }
    return [...array, itemToToggle];
};
const FilterChips = ({ id, options, selectedValues, label, labelPosition, onChange, }) => {
    const handleClick = (value) => {
        onChange(toggle(selectedValues, value));
    };
    return (React__default.createElement(Group, { labelPosition: labelPosition },
        React__default.createElement(Label, { htmlFor: id },
            React__default.createElement(Text, { component: "span", variant: "bodySDemi" }, label)),
        React__default.createElement(Chips$1, { id: id }, options.map(({ label: chipLabel, value }) => {
            const selected = selectedValues.includes(value);
            return (React__default.createElement(Chip$1, { key: chipLabel, selected: selected, onClick: () => handleClick(value) }, chipLabel));
        }))));
};

const FilterChip = styled.div `
  ${({ theme: { palette, spacing, borderRadius, media } }) => css `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 40px;

    background-color: ${palette.baseColors.wairua};
    color: ${palette.baseColors.newZealandBlack};

    padding: ${spacing.s1} ${spacing.s3};

    border: 2px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.r3};

    transition: 0.1s ease-in-out;

    &:hover {
      border: 2px solid ${palette.baseColors.lupin};
    }

    &:focus-visible {
      box-shadow:
        0 0 0 1px ${palette.baseColors.wairua},
        0 0 0 4px ${palette.baseColors.lupin};
    }

    ${media.up('slim')} {
      padding: 10px ${spacing.s3};
    }

    ${media.up('big')} {
      padding: ${spacing.s1_5} ${spacing.s3};
    }
  `}
`;
const Container$b = styled(Box) `
  ${({ theme: { spacing } }) => css `
    & > * {
      margin: ${spacing.s1} ${spacing.s1} 0 0;
    }

    & > :last-child {
      margin-right: 0;
    }
  `}
`;
const ChipLabel$1 = styled(Text) `
  ${({ theme: { spacing } }) => css `
    padding-right: ${spacing.s1_5};
  `}
`;
const DismissIcon = styled.button `
  background: none;
  border: none;
  cursor: pointer;
`;
function FilterChipsDismissible({ className, options, enableReset, onReset, onRemoveChip, }) {
    return (React__default.createElement(Container$b, { className: className, flexDirection: "row", flexWrap: "wrap", alignItems: "center" }, options === null || options === void 0 ? void 0 :
        options.map((option) => (React__default.createElement(FilterChip, { key: option.id },
            React__default.createElement(ChipLabel$1, { variant: "bodySDemi" }, option.label),
            React__default.createElement(DismissIcon, { onClick: () => onRemoveChip(option) },
                React__default.createElement(Icon, { name: "cross_extra_small" }))))),
        enableReset && !isEmpty(options) ? (React__default.createElement(Box, null,
            React__default.createElement(Button$2, { variant: "textbutton", onClick: onReset }, "Reset"))) : null));
}

const Chips = styled.div `
  ${({ theme: { palette, borderRadius, media, spacing } }) => css `
    border: 2px solid ${palette.baseColors.moeraki};
    background: ${palette.baseColors.wairua};
    display: flex;
    padding: ${spacing.s0_5};
    border-radius: 20px; /* Designers want figma followed so making exception on tokens to use */

    ${media.up('slim')} {
      border-radius: ${borderRadius.r3};
    }
  `}
`;
const Highlight$4 = styled(motion.div) `
  ${({ theme: { palette, zIndex, media } }) => css `
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    background-color: ${palette.baseColors.lupin};
    z-index: ${zIndex.default};
    border-radius: 14px; /* Designers want figma followed so making exception on tokens to use */

    ${media.up('slim')} {
      border-radius: 18px; /* Designers want figma followed so making exception on tokens to use */
    }
  `}
`;
const Chip = styled.button `
  ${({ theme: { palette, media, spacing } }) => css `
    position: relative;
    cursor: pointer;
    outline: none;
    padding: ${spacing.s0_5} ${spacing.s2};
    background: none;
    border: none;
    border-radius: 14px; /* Designers want figma followed so making exception on tokens to use */

    ${media.up('slim')} {
      border-radius: 18px; /* Designers want figma followed so making exception on tokens to use */
      padding: ${spacing.s1} ${spacing.s2};
    }

    &:last-child {
      margin-right: 0;
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }
  `}
`;
const ChipLabel = styled.div `
  ${({ theme: { zIndex, palette }, selected }) => css `
    position: relative;
    cursor: pointer;
    color: ${selected
    ? palette.baseColors.wairua
    : palette.baseColors.newZealandBlack};
    transition: 0.5s;
    z-index: ${zIndex.dropdown};
    white-space: nowrap;
    ${footNoteMediumStyle}
    &:hover {
      ${!selected && `color: ${palette.baseColors.lupin}`};
    }
  `}
`;
function SegmentedControl(props) {
    const { id, label, labelPosition, options, selectedValue, onChange, dynamicTargetValue = '', } = props;
    const componentName = 'Segmented Control';
    useEffect(() => {
        if (!selectedValue && options[0]) {
            onChange(options[0].value);
        }
    }, []);
    return (React__default.createElement(Group, { labelPosition: labelPosition, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        label ? (React__default.createElement(Label, { htmlFor: id },
            React__default.createElement(Text, { component: "span", variant: "bodySDemi" }, label))) : null,
        React__default.createElement(AnimateSharedLayout, null,
            React__default.createElement(motion.div, { layout: true, transition: {
                    type: 'spring',
                    bounce: 0,
                    duration: 0,
                } },
                React__default.createElement(Chips, { role: "group", id: id }, options.map(({ value, label: chipLabel }) => {
                    const isSelected = value === selectedValue;
                    return (React__default.createElement(Chip, { key: chipLabel, type: "button", tabIndex: 0, onClick: () => {
                            onChange(value);
                        }, selected: isSelected, "aria-selected": isSelected },
                        React__default.createElement(ChipLabel, { selected: isSelected }, chipLabel),
                        isSelected ? (React__default.createElement(Highlight$4, { layoutId: "outline", transition: {
                                type: 'spring',
                                bounce: 0,
                                duration: 0.5,
                            } })) : null));
                }))))));
}

const StyledIndicatorSeperator = styled.span `
  ${({ theme: { palette, spacing } }) => css `
    align-self: stretch;
    background-color: ${palette.baseColors.moeraki};
    margin: ${spacing.s1} ${spacing.s1} ${spacing.s1} 0;
    height: ${spacing.s3};
    width: 1px;
  `}
`;
const MultiValue = styled(Text) `
  ${({ theme: { spacing, palette }, disabled }) => css `
    margin: 2px ${spacing.s0_5};
    color: ${disabled
    ? palette.baseColors.alto
    : palette.baseColors.newZealandBlack};
  `}
`;
function FilterDropdown(props) {
    const { className, selectedValues, disabled = false, helperText, name, onChange, onFocus, options, placeholder, isMulti, isAlternate, isColorInput, isMultiWithCircle, maxMenuHeight, dynamicTargetValue = '' } = props, rest = __rest(props, ["className", "selectedValues", "disabled", "helperText", "name", "onChange", "onFocus", "options", "placeholder", "isMulti", "isAlternate", "isColorInput", "isMultiWithCircle", "maxMenuHeight", "dynamicTargetValue"]);
    const chooseCustomSelectComponent = () => {
        if (!isMulti) {
            return CustomSingleSelect;
        }
        if (isAlternate) {
            return CustomMultiSelectAlternate;
        }
        return CustomMultiSelect;
    };
    const getMaxMenuHeight = () => {
        if (maxMenuHeight)
            return maxMenuHeight;
        if (!isMulti)
            return '160px';
        return '176px';
    };
    const CustomComponent = chooseCustomSelectComponent();
    const { palette } = useTheme();
    const DropdownIndicator = (indicatorProps) => {
        return React__default.createElement(Indicators$1, Object.assign({}, indicatorProps));
    };
    const ClearIndicatorStyles = (base) => (Object.assign(Object.assign({}, base), { cursor: 'pointer', color: `${palette.baseColors.sparkPurple}` }));
    const MultiValueContainer = (multiValueProps) => {
        var _a, _b, _c;
        if (!Array.isArray((_a = multiValueProps === null || multiValueProps === void 0 ? void 0 : multiValueProps.selectProps) === null || _a === void 0 ? void 0 : _a.value)) {
            return null;
        }
        const selectedOptions = ((_b = multiValueProps === null || multiValueProps === void 0 ? void 0 : multiValueProps.selectProps) === null || _b === void 0 ? void 0 : _b.value) || [];
        const currentValue = (_c = multiValueProps === null || multiValueProps === void 0 ? void 0 : multiValueProps.data) === null || _c === void 0 ? void 0 : _c.label;
        const isNotLastValue = selectedOptions
            .map((option) => {
            return option.label;
        })
            .indexOf(currentValue) <
            selectedOptions.length - 1;
        return (React__default.createElement(MultiValue, { variant: "bodySMedium", disabled: disabled },
            multiValueProps.data.label,
            isNotLastValue ? ',' : null));
    };
    const Option = (optionProps) => {
        return (React__default.createElement(Options, Object.assign({}, optionProps, { isColorInput: isColorInput, isMultiWithCircle: isMultiWithCircle })));
    };
    const IndicatorSeparator = () => {
        if (isMulti && selectedValues && (selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.length) > 0) {
            return React__default.createElement(StyledIndicatorSeperator, null);
        }
        return null;
    };
    /* List of some props we can alter/customise from react-select */
    const commonCustomComponents = {
        DropdownIndicator,
        IndicatorSeparator: isAlternate ? () => null : IndicatorSeparator,
        Option,
    };
    const customComponents = isMulti
        ? Object.assign({ ClearIndicator: isAlternate ? () => null : ClearIndicator, MultiValueContainer }, commonCustomComponents) : commonCustomComponents;
    const componentName = 'Filter Dropdown';
    const menuHeight = getMaxMenuHeight();
    return (React__default.createElement("div", { className: className, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(CustomComponent, Object.assign({ maxMenuHeight: menuHeight, classNamePrefix: "spark", components: customComponents, defaultValue: selectedValues, isDisabled: disabled, onChange: (values) => onChange ? onChange(Array.isArray(values) ? values : [values]) : null, onFocus: onFocus, options: options, placeholder: placeholder || '', value: selectedValues, helperText: helperText, isSearchable: false, styles: { clearIndicator: isAlternate ? null : ClearIndicatorStyles }, hideSelectedOptions: false, closeMenuOnSelect: !isMulti, isMulti: isMulti, isMultiWithCircle: isMultiWithCircle, controlShouldRenderValue: !isAlternate }, rest)),
        React__default.createElement(HelperText, { isDisabled: disabled }, helperText)));
}

const InnerCircle = styled.div `
  ${({ theme: { borderRadius, palette } }) => css `
    width: 8px;
    height: 8px;
    background-color: ${palette.baseColors.lupin};
    border-radius: ${borderRadius.round};
    position: absolute;
    top: 8px;
    left: 8px;
    transition: 0.2s ease-in-out;
  `}
`;
const StyledText$3 = styled(Text) `
  ${({ theme: { spacing, palette }, disabled }) => css `
    margin-left: ${spacing.s0_5};
    color: ${disabled ? palette.baseColors.alto : palette.baseColors.lupin};

    &:hover {
      color: ${disabled
    ? palette.baseColors.alto
    : palette.baseColors.sparkPurple};
    }
  `}
`;
const StyledButton$1 = styled.button `
  ${({ theme: { palette, spacing } }) => css `
    color: ${palette.baseColors.lupin};

    margin: ${spacing.s1};
    cursor: pointer;
    outline: none;
    border: none;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: ${palette.baseColors.sparkPurple};
    }

    &:hover ${InnerCircle} {
      transform-origin: center center;
      transform: scale(0.5);

      background-color: ${palette.baseColors.sparkPurple};
    }

    &:hover {
      fill: ${palette.baseColors.sparkPurple};
    }

    :disabled {
      color: ${palette.baseColors.alto};

      ${InnerCircle} {
        background-color: ${palette.baseColors.alto};
      }

      &:hover ${InnerCircle} {
        transform: none;
        background-color: ${palette.baseColors.alto};
      }
    }
  `}
`;
const IconContainer$2 = styled.div `
  position: relative;
`;
const DetectLocation = ({ disabled, handleDetectLocation, }) => {
    const theme = useTheme();
    return (React__default.createElement(StyledButton$1, { onClick: handleDetectLocation, disabled: disabled },
        React__default.createElement(IconContainer$2, null,
            React__default.createElement(Icon, { name: "location_small", fill: disabled
                    ? theme.palette.baseColors.alto
                    : theme.palette.baseColors.lupin }),
            React__default.createElement(InnerCircle, null)),
        React__default.createElement(StyledText$3, { component: "span", variant: "bodySDemi", disabled: disabled }, "Detect my location")));
};

const IconsContainer$2 = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: ${spacing.s2};
  `}
`;
const ClearButton = styled.button `
  cursor: pointer;
  outline: none;
  border: none;
  background: none;
  padding: 0;
`;
const StoreFinderIcons = ({ value, onClearInput, disabled, iconName = 'search_small', }) => {
    const { palette } = useTheme();
    return (React__default.createElement(IconsContainer$2, null,
        value ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ClearButton, { onClick: onClearInput, "aria-label": "Clear input" },
                React__default.createElement(Icon, { name: "cross_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin })),
            React__default.createElement(Divider$1, { orientation: "vertical", height: "24px", color: palette.baseColors.moeraki }))) : null,
        React__default.createElement(Icon, { name: iconName, fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin })));
};

const animateOpacity$3 = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const autoSuggestMixin$1 = css `
  ${({ theme: { spacing, elevation, palette, zIndex, borderRadius } }) => css `
    background-color: ${palette.baseColors.wairua};
    position: absolute;
    top: 44px;
    right: 0;
    left: 0;
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.r1};
    z-index: ${zIndex.popover};
    box-shadow: ${elevation.elevation1};
    padding: ${spacing.s2};

    transition: transform 0.2s ease-in-out;
    transform: translateY(6px);
    animation: ${animateOpacity$3} 0.2s linear;

    ::-webkit-scrollbar {
      ${CustomScrollbarMixin}
    }

    ::-webkit-scrollbar-track {
      ${CustomScrollbarTrackMixin}
    }

    ::-webkit-scrollbar-thumb {
      ${CustomScrollbarThumbMixin}
    }
  `}
`;
const AutoSuggestContainer$1 = styled.div `
  ${({ theme: { borderRadius, palette, spacing }, disabled, rounded, showMask, }) => {
    const BORDER_RADIUS = rounded ? borderRadius.r3 : borderRadius.rHalf;
    return css `
      display: flex;
      position: relative;
      background-color: ${palette.baseColors.wairua};

      width: 100%;

      border: 2px solid
        ${disabled ? palette.baseColors.alto : palette.baseColors.moeraki};
      border-radius: ${BORDER_RADIUS};

      &:hover {
        border: 2px solid
          ${disabled ? palette.baseColors.alto : palette.baseColors.mawheranui};
      }

      &:active,
      &:focus-within {
        border: 2px solid ${palette.baseColors.lupin};
      }

      .react-autosuggest__container {
        width: 100%;
        line-height: 28px;
      }

      .react-autosuggest__input {
        border: none;
        border-radius: ${BORDER_RADIUS};
        width: 100%;
        ${bodySMediumStyle}
        color: ${palette.baseColors.newZealandBlack};
        background-color: ${palette.baseColors.wairua};
        ${showMask &&
        css `
          -webkit-mask-image: linear-gradient(90deg, #000 80%, transparent);
        `}
        padding: ${spacing.s1} ${spacing.s2};
        ::placeholder {
          color: ${disabled
        ? palette.baseColors.alto
        : palette.baseColors.mawheranui};
        }
      }

      .react-autosuggest__suggestions-container--open {
        ${autoSuggestMixin$1};
        margin: 0;
      }

      .react-autosuggest__suggestion {
        cursor: pointer;
        list-style-type: none;
      }

      .react-autosuggest__suggestions-list {
        margin: 0;
        padding: ${spacing.s1} 0;
      }

      .react-autosuggest__suggestion {
        cursor: pointer;
        padding: ${spacing.s1} ${spacing.s2};
      }

      li {
        &:hover {
          background-color: ${palette.baseColors.onepu};
        }
      }
    `;
}}
`;
const NoAddressContainer = styled.div `
  ${autoSuggestMixin$1}
`;
const SuggestionText$1 = ({ textType, children, }) => {
    const { palette } = useTheme();
    switch (textType) {
        case 'matching':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.lupin }, children));
        case 'highlight':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.newZealandBlack }, children));
        default:
            return (React__default.createElement(Text, { component: "span", variant: "bodySMedium", color: palette.baseColors.mawheranui }, children));
    }
};
function splitMatchingText(input, suggestion) {
    const lowerCaseSuggestion = suggestion.toLowerCase();
    const lowerCaseInput = input.toLowerCase();
    const matchingTextStartIndex = lowerCaseSuggestion.indexOf(lowerCaseInput);
    if (matchingTextStartIndex === -1) {
        return {};
    }
    const matchingTextEndIndex = matchingTextStartIndex + lowerCaseInput.length;
    return {
        beforeMatchingText: suggestion.slice(0, matchingTextStartIndex),
        matchingText: suggestion.slice(matchingTextStartIndex, matchingTextEndIndex),
        afterMatchingText: suggestion.slice(matchingTextEndIndex, lowerCaseSuggestion.length),
    };
}
const defaultRenderSuggestion = (suggestion, inputValue) => {
    const { beforeMatchingText, matchingText, afterMatchingText } = splitMatchingText(inputValue, suggestion);
    if (!matchingText)
        return React__default.createElement(SuggestionText$1, null, suggestion);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SuggestionText$1, null, beforeMatchingText),
        React__default.createElement(SuggestionText$1, { textType: "highlight" }, matchingText),
        React__default.createElement(SuggestionText$1, null, afterMatchingText)));
};
const StoreFinder = ({ suggestions, onSuggestionsFetchRequested, onSuggestionsClearRequested, renderSuggestion: renderSuggestionProp, onClearInput, onCurrentLocationDetected, placeholder, value, onChange, disabled, onSelect, detectLocation, rounded, displayIcon, iconName, noResultComponent, }, ref) => {
    const handleDetectLocation = () => {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition((position) => {
                onCurrentLocationDetected({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            }, () => {
                onCurrentLocationDetected(null);
            });
        }
        else {
            onCurrentLocationDetected(null);
        }
    };
    useEffect(() => {
        if (detectLocation) {
            handleDetectLocation();
        }
    }, [detectLocation]);
    const getSuggestionValue = (suggestion) => suggestion;
    const autoSuggestLibSuggestions = suggestions.map(({ label }) => label);
    const handleSuggestionsRequested = ({ value: suggestionValue }) => {
        onSuggestionsFetchRequested(suggestionValue);
    };
    const autoSuggestRef = useRef(null);
    useImperativeHandle(ref, () => autoSuggestRef.current, []);
    const handleSuggestionSelected = (_event, data) => {
        const { suggestionIndex } = data;
        onSelect(suggestions[suggestionIndex]);
        setTimeout(() => {
            if (autoSuggestRef === null || autoSuggestRef === void 0 ? void 0 : autoSuggestRef.current) {
                autoSuggestRef.current.blur();
            }
        }, 0);
    };
    const renderSuggestionCallback = renderSuggestionProp || defaultRenderSuggestion;
    return (React__default.createElement("div", null,
        React__default.createElement(AutoSuggestContainer$1, { disabled: disabled, rounded: rounded, showMask: displayIcon },
            React__default.createElement(Autosuggest, { suggestions: autoSuggestLibSuggestions, onSuggestionsFetchRequested: handleSuggestionsRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: (suggestion) => renderSuggestionCallback(suggestion, value), inputProps: {
                    onChange: (_event, params) => {
                        onChange(params === null || params === void 0 ? void 0 : params.newValue);
                    },
                    placeholder,
                    value,
                    disabled,
                    ref: autoSuggestRef,
                }, onSuggestionSelected: handleSuggestionSelected }),
            displayIcon ? (React__default.createElement(StoreFinderIcons, { value: value, onClearInput: onClearInput, disabled: disabled, iconName: iconName })) : null,
            noResultComponent ? (React__default.createElement(NoAddressContainer, null, noResultComponent)) : null),
        detectLocation ? (React__default.createElement(DetectLocation, { handleDetectLocation: handleDetectLocation, disabled: disabled })) : null));
};
var StoreFinder$1 = React__default.forwardRef(StoreFinder);

const FilterAndTitleSection = styled.div `
  ${({ theme: { palette } }) => css `
    border-bottom: 1px solid ${palette.baseColors.alto};
  `}
`;
const Title$2 = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s3};
  `}
`;
const ArticleCardContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    padding-top: ${spacing.s5};
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    > * {
      margin-right: ${spacing.s3};
      margin-bottom: ${spacing.s3};
    }
  `}
`;
const ArticleGallery = ({ title = '', items }) => {
    return (React__default.createElement(Box, null,
        React__default.createElement(FilterAndTitleSection, null,
            React__default.createElement(Title$2, { variant: "headingM" }, title)),
        React__default.createElement(ArticleCardContainer, null, items === null || items === void 0 ? void 0 : items.map((item) => (React__default.createElement(ArticleCard, { title: item === null || item === void 0 ? void 0 : item.title, description: item === null || item === void 0 ? void 0 : item.description, imagePath: item === null || item === void 0 ? void 0 : item.imagePath, articlePath: item === null || item === void 0 ? void 0 : item.articlePath, datePosted: item === null || item === void 0 ? void 0 : item.datePosted, hideDatePosted: item === null || item === void 0 ? void 0 : item.hideDatePosted, id: item.id, key: item.id, alt: item.alt }))))));
};

const SuggestionText = ({ textType, children, }) => {
    const { palette } = useTheme();
    switch (textType) {
        case 'matching':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.lupin }, children));
        case 'highlight':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.newZealandBlack }, children));
        default:
            return (React__default.createElement(Text, { component: "span", variant: "bodySMedium", color: palette.baseColors.mawheranui }, children));
    }
};
function getStringSections({ length, start, text, }) {
    const end = start + length;
    const precedingText = text.substring(0, start);
    const content = text.substring(start, end);
    const trailingText = text.substring(end);
    return {
        precedingText,
        content,
        trailingText,
    };
}
function Suggestion({ suggestion, inputValue }) {
    var _a;
    const regExPattern = new RegExp(inputValue, 'i');
    const match = suggestion.label.match(regExPattern);
    if (!match) {
        return React__default.createElement(SuggestionText, null, suggestion.label);
    }
    const matchStart = (_a = match === null || match === void 0 ? void 0 : match.index) !== null && _a !== void 0 ? _a : 0;
    const { precedingText, content: matchingText, trailingText, } = getStringSections({
        text: suggestion.label,
        start: matchStart,
        length: inputValue.length,
    });
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SuggestionText, null, precedingText),
        React__default.createElement(SuggestionText, { textType: "matching" }, matchingText),
        React__default.createElement(SuggestionText, null, trailingText)));
}
const animateOpacity$2 = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const Container$a = styled.div `
  ${({ theme: { borderRadius, elevation, palette, spacing, zIndex }, disabled, showError, }) => css `
    display: flex;
    position: relative;
    background-color: ${palette.baseColors.wairua};

    margin-bottom: ${showError ? spacing.s0_5 : 0};

    width: 100%;

    border: 2px solid
      ${disabled ? palette.baseColors.alto : palette.baseColors.moeraki};
    border-radius: ${borderRadius.rHalf};

    &:hover {
      border: 2px solid
        ${disabled ? palette.baseColors.alto : palette.baseColors.mawheranui};
    }

    &:focus-within {
      border: 2px solid ${palette.baseColors.lupin};
    }

    ${showError
    ? css `
          border-color: ${palette.baseColors.marangai};

          &:hover {
            border-color: ${palette.baseColors.marangai};
          }
        `
    : null}

    .react-autosuggest__container {
      width: 100%;
      line-height: 28px;
    }

    .react-autosuggest__input {
      border: none;
      width: 100%;
      ${bodySMediumStyle}
      color: ${palette.baseColors.newZealandBlack};
      background-color: ${palette.baseColors.wairua};

      padding: ${spacing.s1} ${spacing.s2};

      ::placeholder {
        color: ${disabled
    ? palette.baseColors.alto
    : palette.baseColors.mawheranui};
      }
    }

    .react-autosuggest__suggestions-container--open {
      background-color: ${palette.baseColors.wairua};
      position: absolute;
      top: 44px;
      right: 0;
      left: 0;
      max-height: 180px;
      overflow-y: auto;
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r1};
      z-index: ${zIndex.popover};
      box-shadow: ${elevation.elevation1};

      transition: transform 0.2s ease-in-out;
      transform: translateY(6px);
      animation: ${animateOpacity$2} 0.2s linear;

      ::-webkit-scrollbar {
        ${CustomScrollbarMixin}
      }

      ::-webkit-scrollbar-track {
        ${CustomScrollbarTrackMixin}
      }

      ::-webkit-scrollbar-thumb {
        ${CustomScrollbarThumbMixin}
      }
    }

    .react-autosuggest__suggestion {
      cursor: pointer;
      list-style-type: none;
    }

    .react-autosuggest__suggestions-list {
      margin: 0;
      padding: ${spacing.s1} 0;
    }

    .react-autosuggest__suggestion {
      cursor: pointer;
      padding: ${spacing.s1} ${spacing.s2};
    }

    li {
      &:hover {
        background-color: ${palette.baseColors.onepu};
      }
    }
  `}
`;
function AutocompleteInput({ disabled, errorText, inputValue, onSelect, onSuggestionsClearRequested, onSuggestionsFetchRequested, onInputChange, placeholder, suggestions, }) {
    const theme = useTheme();
    const getSuggestionValue = (suggestion) => suggestion.value;
    const handleSuggestionSelected = (_event, data) => {
        onSelect(data.suggestion);
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container$a, { disabled: disabled, showError: Boolean(errorText) },
            React__default.createElement(Autosuggest, { suggestions: suggestions, onSuggestionsFetchRequested: onSuggestionsFetchRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: (suggestion) => (React__default.createElement(Suggestion, { inputValue: inputValue, suggestion: suggestion })), inputProps: {
                    placeholder,
                    value: inputValue,
                    onChange: onInputChange,
                    disabled,
                }, onSuggestionSelected: handleSuggestionSelected })),
        errorText ? (React__default.createElement(Text, { color: theme.palette.baseColors.marangai, variant: "footnoteDemi" }, errorText)) : null));
}

const Container$9 = styled.label `
  ${({ theme: { spacing } }) => css `
    position: relative;
    font-style: normal;
    color: ${({ theme }) => theme.palette.baseColors.newZealandBlack};
    ${bodySDemiStyle};
    display: flex;
    width: fit-content;
    align-items: flex-start;
    gap: ${spacing.s2};
    cursor: pointer;
    user-select: none;
  `}
`;
const CustomCheck = styled(Icon) `
  position: absolute;
`;
const Checkmark = styled.span `
  ${({ theme: { palette }, checked }) => css `
    border-color: ${checked
    ? palette.baseColors.lupin
    : palette.baseColors.mawheranui};
    background-color: ${checked
    ? palette.baseColors.lupin
    : palette.baseColors.wairua};
  `};

  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  border-width: 2px;
  border-style: solid;
  box-sizing: border-box;
`;
const CheckboxInput = styled.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;

  &:disabled ~ ${Checkmark} {
    ${({ theme: { palette }, checked }) => css `
      border-color: ${checked
    ? palette.baseColors.alto
    : palette.baseColors.alto};
      background-color: ${checked
    ? palette.baseColors.alto
    : palette.baseColors.wairua};
    `};
  }

  &:focus-visible ~ ${Checkmark}:before {
    content: ' ';
    position: absolute;
    height: 30px;
    width: 30px;
    border-radius: 7px;
    border: ${({ theme }) => `2px solid ${theme.palette.baseColors.lupin}`};
  }
`;
const Checkbox = React__default.forwardRef((props, ref) => {
    const { label, name, disabled, onCheck, checked, autofocus, inputProps, className, onClick, } = props;
    return (React__default.createElement(Container$9, { className: className, onClick: onClick },
        React__default.createElement(CheckboxInput, Object.assign({ type: "checkbox", ref: ref, name: name, disabled: disabled, onChange: () => onCheck(!checked), checked: checked, autoFocus: autofocus }, inputProps)),
        React__default.createElement(Checkmark, { checked: checked }, checked ? (React__default.createElement(CustomCheck, { size: 24, name: "check_small", fill: "white" })) : null),
        label));
});

const Container$8 = styled.label `
  display: inline-flex;
  cursor: pointer;
`;
const RadioButtonWrapper = styled.div `
  ${({ checked, disabled, theme: { palette, borderRadius } }) => css `
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;
    background-color: ${palette.componentBackgroundColor};
    display: flex;
    align-items: center;
    flex-shrink: 0;
    justify-content: space-around;
    height: 24px;
    width: 24px;
    border-radius: ${borderRadius.round};
    border: 2px solid
      ${checked ? palette.interactiveMain : palette.radioButtonBorder};
    ${disabled && `border-color: ${palette.disabledRadioButtonBorder}`};
    position: relative;
  `}
`;
const RadioButtonInput = styled.input `
  ${({ theme: { palette, borderRadius } }) => css `
    height: 0;
    width: 0;
    border: none;
    opacity: 0;

    &:focus-visible + ${RadioButtonWrapper} :after {
      content: '';
      position: absolute;
      top: -5px;
      bottom: -5px;
      left: -5px;
      right: -5px;
      border-radius: ${borderRadius.round};
      border: 2px solid ${palette.interactiveMain};
    }
  `}
`;
const Indicator$2 = styled.div `
  ${({ checked, disabled, theme: { palette, borderRadius } }) => css `
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;
    height: 12px;
    width: 12px;
    background-color: ${checked
    ? palette.interactiveMain
    : palette.componentBackgroundColor};
    ${disabled &&
    `background-color: ${checked ? palette.baseColors.alto : palette.componentBackgroundColor}`};
    border-radius: ${borderRadius.round};
  `}
`;
const LabelTextWrapper = styled('div') `
  ${({ theme: { spacing }, disabled }) => css `
    margin-left: ${spacing.s2};
    ${disabled && `opacity: 0.3`};
  `}
`;
const RadioButton = React__default.forwardRef((props, ref) => {
    const { checked, onChange, disabled, name, inputProps, text, value, autofocus, subtext, children, } = props;
    return (React__default.createElement(Container$8, null,
        React__default.createElement(RadioButtonInput, Object.assign({ type: "radio", checked: checked, name: name, disabled: disabled, onChange: onChange, ref: ref, value: value, autoFocus: autofocus, tabIndex: 0 }, inputProps)),
        React__default.createElement(RadioButtonWrapper, { checked: checked, disabled: disabled }, checked && React__default.createElement(Indicator$2, { checked: checked, disabled: disabled })),
        React__default.createElement(LabelTextWrapper, { disabled: disabled },
            children || React__default.createElement(Text, { variant: "bodySDemi" }, text),
            subtext ? React__default.createElement(Text, { variant: "footnoteMedium" }, subtext) : null)));
});

const ButtonAndTextWrapper = styled.div `
  ${({ theme: { spacing }, disabled, multiline }) => css `
    display: flex;
    align-items: ${multiline ? null : 'center'};
    padding: ${spacing.s2};
    ${disabled && `opacity: 0.3`};
  `}
`;
const ChoiceBoxWrapper = styled.button `
  ${({ checked, disabled, theme: { palette, borderRadius } }) => css `
    position: relative;
    padding: 0;
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;
    background: ${palette.componentBackgroundColor};
    cursor: pointer;
    text-align: left;

    border: 2px solid
      ${checked ? palette.interactiveMain : palette.baseColors.moeraki};
    border-radius: ${borderRadius.r1};
    ${disabled && `border-color: ${palette.disabledComponentColor}`};

    &:hover {
      ${!disabled && `border: 2px solid ${palette.baseColors.mawheranui}`};
    }
    &:focus-visible {
      ${!disabled &&
    `box-shadow: 0 0 0 1px ${palette.baseColors.wairua},
        0 0 0 4px ${palette.interactiveMain}`};
      border-color: ${palette.baseColors.lupin};
    }
  `}
`;
const ChoiceBox = React__default.forwardRef((props, ref) => {
    const { className, checked, onChange, value, disabled, multiline, children, inputProps, name, label, dynamicTargetValue = '', } = props;
    const componentName = 'Choicebox';
    return (React__default.createElement(ChoiceBoxWrapper, { className: className, checked: checked, disabled: disabled, onClick: onChange, tabIndex: 0, "aria-selected": checked, type: "button", "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(ButtonAndTextWrapper, { disabled: disabled, multiline: multiline },
            React__default.createElement(RadioButton, { checked: checked, onChange: onChange, value: value, ref: ref, disabled: disabled, inputProps: Object.assign(Object.assign({}, inputProps), { tabIndex: -1 }), name: name }, label),
            children)));
});

const CodeContainer = styled.div `
  display: flex;
`;
const CodeTextInput = styled.input `
  ${({ theme: { borderRadius, media, palette, spacing }, codeLength }) => css `
    width: 100%;
    max-width: ${codeLength === 8 ? '34px' : '48px'};
    height: 60px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 600;
    text-align: center;
    caret-color: transparent;
    margin-right: ${spacing.s1};
    border-radius: ${borderRadius.rHalf};
    outline-style: none;
    padding: 0;
    ${media.up('slim')} {
      font-size: 28px;
      line-height: 36px;
    }

    ${media.up('big')} {
      max-width: ${codeLength === 8 ? '37px' : '52px'};
      height: 64px;
      font-size: 40px;
      line-height: 48px;
    }

    &:last-of-type {
      margin-right: 0;
    }

    &::selection {
      background-color: transparent;
    }

    &:valid {
      border: 1px solid ${palette.interactiveMain};
      background-color: ${palette.interactiveMain};
      color: ${palette.baseColors.wairua};
    }

    &:not(:valid) {
      border: 1px solid ${palette.codeInputEmptyBackground};
      background-color: ${palette.codeInputEmptyBackground};
    }

    &:focus-within {
      background-color: ${palette.componentBackgroundColor};
      border-color: ${palette.interactiveMain};
      color: ${palette.textColor};
      &:not(:valid) {
        border-color: ${palette.codeInputBorder};
      }
    }
  `}
`;
const getClipboardData = (event) => {
    if (window.clipboardData) {
        return window.clipboardData.getData('Text');
    }
    if (event.clipboardData && event.clipboardData.getData) {
        return event.clipboardData.getData('text/plain');
    }
    throw new Error('Neither window.clipboard nor event.clipboard was present');
};
function getEmptyCode(codeLength) {
    return fill(Array(codeLength), null).map((_, index) => {
        return {
            index,
            value: null,
        };
    });
}
function transformCodeToString(code) {
    return code
        .map(({ value }) => {
        return value !== null && value !== void 0 ? value : ' ';
    })
        .join('');
}
function transformStringToCode(codeString) {
    return codeString.split('').map((char, index) => {
        const numberValue = parseInt(char, 10);
        const value = isNaN(numberValue) ? null : numberValue;
        return {
            value,
            index,
        };
    });
}
function getEmptyCodeString(codeLength) {
    return repeat(' ', codeLength);
}
/**
 * This SinkInput is a visually hidden but focusable text input that captures
 * the browser's focus once the last CodeInput is entered.
 *
 * This allows for features like backspacing the last value entered and
 * submitting the form while not having the last value focussed.
 */
const SinkInput = styled.input `
  border: none;
  padding: 0;
  width: 0;
  height: 0;
`;
const CodeInput = React__default.forwardRef((props, ref) => {
    const { onChange, inputProps, value } = props;
    const [initialLength] = useState(value.length);
    const VALID_CHARS = '1234567890';
    const inputsRefs = useRef([]);
    const sinkRef = useRef(null);
    const deleteCharAt = (index) => {
        const currentChar = value[index].value;
        if (currentChar !== undefined) {
            const newItems = [...value];
            newItems[index] = { index, value: null };
            onChange(newItems);
        }
    };
    const moveTo = (newIndex) => {
        var _a;
        if (newIndex >= inputsRefs.current.length) {
            (_a = sinkRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        const nextBox = inputsRefs.current[Math.max(0, newIndex)];
        nextBox.focus();
    };
    const handleBackspace = (index) => {
        if (value[index] == null) {
            deleteCharAt(index - 1);
        }
        else {
            deleteCharAt(index);
        }
        moveTo(index - 1);
    };
    const handleKey = (index, key) => {
        if (index >= initialLength) {
            return;
        }
        const newItems = [...value];
        newItems[index] = { index, value: parseInt(key, 10) };
        onChange(newItems);
        moveTo(index + 1);
    };
    const handleKeyDown = (event) => {
        const dataIndex = event.currentTarget.getAttribute('data-index');
        const index = parseInt(dataIndex, 10);
        if (event.key === 'Tab' ||
            event.metaKey ||
            event.ctrlKey ||
            event.key === 'Enter') {
            return;
        }
        if (event.key === 'Backspace') {
            event.preventDefault();
            handleBackspace(index);
        }
        else if (event.key === 'ArrowLeft') {
            moveTo(index - 1);
        }
        else if (event.key === 'ArrowRight') {
            moveTo(index + 1);
        }
        else if (VALID_CHARS.includes(event.key)) {
            event.preventDefault();
            handleKey(index, event.key);
        }
        else {
            event.preventDefault();
        }
    };
    const processPastedCode = (clipboardData, pasteStartIndex) => {
        const chars = clipboardData.replace(/\s/g, '').split('');
        if (!chars.every((char) => VALID_CHARS.includes(char))) {
            return;
        }
        const codeToKeepStart = value.slice(0, pasteStartIndex);
        const codeToKeepEnd = value.slice(pasteStartIndex + chars.length);
        const charsToAppend = chars.slice(0, initialLength - pasteStartIndex);
        const reformattedChars = charsToAppend.map((n, i) => ({
            index: pasteStartIndex + i,
            value: +n,
        }));
        const newCode = [
            ...codeToKeepStart,
            ...reformattedChars,
            ...codeToKeepEnd,
        ];
        moveTo(pasteStartIndex + chars.length);
        onChange(newCode);
    };
    const handlePaste = (event) => {
        event.preventDefault();
        const dataIndex = event.currentTarget.getAttribute('data-index');
        if (dataIndex === null) {
            return;
        }
        const index = parseInt(dataIndex, 10);
        if (index === null) {
            return;
        }
        const clipboardData = getClipboardData(event);
        processPastedCode(clipboardData, index);
    };
    const createRefHandler = (index) => {
        return (el) => {
            inputsRefs.current[index] = el;
        };
    };
    const handleChange = (event, itemIndex) => {
        var _a;
        const nativeEvent = event.nativeEvent;
        const nativeEventData = nativeEvent.data;
        if (nativeEvent.inputType === 'deleteContentBackward') {
            handleBackspace(itemIndex);
            return;
        }
        // OTP autofill from SMS iOS
        const eventTargetValue = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value;
        if (eventTargetValue && VALID_CHARS.includes(eventTargetValue)) {
            handleKey(itemIndex, eventTargetValue);
            return;
        }
        if (VALID_CHARS.includes(nativeEventData)) {
            handleKey(itemIndex, nativeEventData);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(CodeContainer, Object.assign({ ref: ref }, inputProps), value.map((item) => {
            var _a;
            return (React__default.createElement(CodeTextInput, { autoFocus: item.index === 0 && (inputProps === null || inputProps === void 0 ? void 0 : inputProps.autoFocus), "data-index": item.index, key: item.index, onChange: (e) => handleChange(e, item.index), onKeyDown: handleKeyDown, onPaste: handlePaste, ref: createRefHandler(item.index), value: (_a = item.value) !== null && _a !== void 0 ? _a : '', codeLength: initialLength, type: "text", required: true, inputMode: "numeric", autoComplete: "one-time-code" }));
        })),
        React__default.createElement(SinkInput, { ref: sinkRef, "data-index": initialLength, inputMode: "numeric", type: "text", onKeyDown: handleKeyDown })));
});

const LabelRow$1 = styled.div `
  display: flex;
  justify-content: space-between;
`;
const LabelText$2 = styled(Text) `
  padding-bottom: ${(props) => props.theme.spacing.s0_5};
`;
const InputHeader$1 = ({ label, optionalText, disabled = false, }) => {
    if (!label && !optionalText) {
        return null;
    }
    const { palette } = useTheme();
    return (React__default.createElement(LabelRow$1, null,
        React__default.createElement(LabelText$2, { variant: "bodySDemi", color: disabled ? palette.labelDisabledTextColor : palette.labelTextColor }, label),
        React__default.createElement(LabelText$2, { variant: "bodySMedium", color: disabled
                ? palette.optionalDisabledTextColor
                : palette.optionalTextColor }, optionalText)));
};

const DEFAULT_PASSWORD_MINIMUM_LENGTH = 8;
const DEFAULT_ALLOWED_SPECIAL_CHARACTERS = '!"#$%&\'()*+,-./:;<=>?@\\[\\\\\\]^_`{|}~';
const lowerCasePolicy = 'a-z';
const upperCasePolicy = 'A-Z';
const numberPolicy = '0-9';
const specialCharacterPolicy = DEFAULT_ALLOWED_SPECIAL_CHARACTERS;
const passwordHelperText = (minimumLength) => `Must be at least ${minimumLength} characters and contain at least 1 number, 1 capital letter and 1 special character.`;
const PASSWORD_STRENGTH_THRESHOLD = 1;
const defaultPasswordRequirements = {
    passwordPolicies: [
        lowerCasePolicy,
        upperCasePolicy,
        numberPolicy,
        specialCharacterPolicy,
    ],
    minRequiredPolicies: 4,
    minimumLength: DEFAULT_PASSWORD_MINIMUM_LENGTH,
    passwordHelperText: passwordHelperText(DEFAULT_PASSWORD_MINIMUM_LENGTH),
};
const combinePoliciesToRegex = (passwordPolicies) => {
    const combinedPolicies = passwordPolicies.join('');
    return new RegExp(`^[${combinedPolicies}]+$`);
};
const isStrongPassword = (minimumLength, password) => {
    return password.length >= minimumLength + PASSWORD_STRENGTH_THRESHOLD;
};
const isPasswordValid = (passwordRequirements, password) => {
    const { passwordPolicies, minRequiredPolicies, minimumLength } = passwordRequirements;
    const combinedPoliciesRegex = combinePoliciesToRegex(passwordPolicies);
    const onlyHasAllowedCharacters = combinedPoliciesRegex.test(password);
    const fulfilledPolicies = passwordPolicies.filter((policy) => new RegExp(`[${policy}]`).test(password));
    return (onlyHasAllowedCharacters &&
        fulfilledPolicies.length >= minRequiredPolicies &&
        password.length >= minimumLength);
};
const Indicator$1 = styled.div `
  ${({ theme: { borderRadius, palette }, activeColor, isActive }) => css `
    flex: 1;
    height: 4px;
    background-color: ${isActive ? activeColor : palette.baseColors.onepu};

    &:first-child {
      border-radius: ${borderRadius.rHalf} 0 0 ${borderRadius.rHalf};
    }

    &:last-child {
      border-radius: 0 ${borderRadius.rHalf} ${borderRadius.rHalf} 0;
    }
  `}
`;
const Indicators = styled.div `
  display: flex;
  flex-grow: 1;
  margin-right: ${(props) => props.theme.spacing.s1};
`;
const IndicatorContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${spacing.s1};
    height: 20px;
  `};
`;
const LabelContainer$1 = styled.div `
  flex-basis: 44px;
  text-align: right;
`;
const Container$7 = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    margin-top: ${spacing.s0_5};
  `};
`;
const PasswordStrength = ({ password, passwordRequirements = defaultPasswordRequirements, }) => {
    const { palette } = useTheme();
    const calculateStrength = () => {
        if (!password) {
            return {
                value: 0,
                text: '',
                color: palette.baseColors.onepu,
            };
        }
        if (!isPasswordValid(passwordRequirements, password)) {
            return {
                value: 1,
                text: 'Invalid',
                color: palette.baseColors.marangai,
            };
        }
        if (isStrongPassword(passwordRequirements.minimumLength, password)) {
            return {
                value: 3,
                text: 'Strong',
                color: palette.baseColors.kiwi,
            };
        }
        return {
            value: 2,
            text: 'Weak',
            color: palette.baseColors.kowhai,
        };
    };
    const strength = calculateStrength();
    return (React__default.createElement(Container$7, null,
        React__default.createElement(IndicatorContainer, { color: strength.color },
            React__default.createElement(Indicators, null,
                React__default.createElement(Indicator$1, { isActive: strength.value >= 1, activeColor: strength.color }),
                React__default.createElement(Indicator$1, { isActive: strength.value > 1, activeColor: strength.color }),
                React__default.createElement(Indicator$1, { isActive: strength.value > 2, activeColor: strength.color })),
            React__default.createElement(LabelContainer$1, null,
                React__default.createElement(Text, { variant: "footnoteDemi", color: strength.color }, strength.text))),
        React__default.createElement(Text, { variant: "footnoteMedium", color: palette.textColor }, passwordRequirements.passwordHelperText)));
};

const GeneralText$1 = styled(Text) `
  padding-top: ${(props) => props.theme.spacing.s0_5};
`;
const InputFooter$1 = ({ helperText = '', isError = false, errorText = '', disabled = false, value = '', showPasswordStrengthMeter = false, passwordRequirements, }) => {
    const showPasswordStrength = showPasswordStrengthMeter && !disabled && !isError;
    const { palette } = useTheme();
    return (React__default.createElement(React__default.Fragment, null,
        helperText && !isError && (React__default.createElement(GeneralText$1, { variant: "footnoteMedium", color: disabled ? palette.helperTextDisabledColor : palette.helperTextColor }, helperText)),
        isError && (React__default.createElement(GeneralText$1, { variant: "footnoteDemi", color: disabled
                ? palette.helperTextDisabledColor
                : palette.baseColors.marangai }, errorText)),
        showPasswordStrength && (React__default.createElement(PasswordStrength, { password: value, passwordRequirements: passwordRequirements }))));
};

const Input$1 = styled.input `
  ${({ theme: { palette, spacing, borderRadius }, isError, hasIconOnRight, disabled, hasCurrencySymbol, }) => css `
    display: flex;
    width: 100%;
    height: 100%;
    outline: none;
    margin: 0;
    padding: 0 ${hasIconOnRight ? spacing.s6 : spacing.s1} 0 ${spacing.s2};
    color: ${palette.textColor};
    background: ${disabled
    ? palette.disabledBackgroundColor
    : palette.componentBackgroundColor};
    box-sizing: border-box;
    border: 2px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.rHalf};
    text-indent: ${hasCurrencySymbol ? '10px' : 'unset'};
    ${bodySMediumStyle}

    &&[type='number']::-webkit-inner-spin-button,
    &&[type='number']::-webkit-outer-spin-button {
      -webkit-appearance: none;
    }

    &&::-ms-reveal,
    &&::-ms-clear {
      display: none;
    }

    &&[type='number'] {
      -moz-appearance: textfield;
    }

    &::placeholder {
      color: ${palette.placeholderTextColor};
    }

    ${isError &&
    !disabled &&
    css `
      border-color: ${palette.destructiveMain};
    `};

    &:hover {
      border-color: ${palette.baseColors.mawheranui};
    }

    &:active,
    &:focus-within {
      border-color: ${palette.baseColors.lupin};
    }

    &:disabled {
      color: ${palette.disabledComponentColor};
      &:hover,
      &:active,
      &:focus-visible {
        border-color: ${palette.disabledComponentColor};
      }
    }
  `};
`;
const InputMultiline = styled(Input$1) `
  ${({ theme: { spacing } }) => css `
    resize: none;
    padding-top: ${spacing.s1_5};
    padding-bottom: ${spacing.s1_5};
  `}
`;
const InputContainer$1 = styled.div `
  ${({ width, fixedHeight }) => css `
    display: flex;
    margin: 0;
    box-sizing: border-box;
    width: ${width};
    height: ${fixedHeight ? '48px' : 'auto'};
    min-height: 48px;
    position: relative;
  `};
`;
const TogglePassword = styled.button.attrs({
    tabIndex: -1,
}) `
  ${({ theme: { spacing }, isPasswordType }) => css `
    cursor: pointer;
    border: 0;
    background-color: transparent;
    outline: none;
    display: flex;
    padding: 0;
    margin-top: ${(isPasswordType && '10px') || '14px'};
    height: 25px;
    opacity: 0.8;
    position: absolute;
    right: ${spacing.s2};

    &:active {
      opacity: 1;
    }

    &:disabled {
      pointer-events: none;
    }
  `};
`;
const IconWrapper$5 = styled.span `
  ${({ theme: { spacing } }) => css `
    padding: 0;
    position: absolute;
    top: ${spacing.s1};
    right: ${spacing.s2};

    &:disabled {
      pointer-events: none;
    }
  `};
`;
const CurrencySymbolWrapper = styled.span `
  ${({ theme: { palette }, disabled }) => css `
    padding: 0;
    position: absolute;
    top: 50%;
    left: 18px;
    transform: translate(0, -44%);
    color: ${disabled ? palette.disabledComponentColor : palette.textColor};
  `}
`;
const ErrorWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: 0;
    margin-top: ${spacing.s1_5};
    position: absolute;
    right: ${spacing.s2};
  `};
`;
const FormRow = styled.div `
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  width: 100%;
  ${(props) => !!props.centered && 'align-items: center;'}
`;
/**
 * @deprecated
 */
const TextInput = React__default.forwardRef((_a, forwardedRef) => {
    var { className, placeholder = '', 
    /** @deprecated
     * use value instead
     */
    text = '', type = 'text', width = '100%', onChange = undefined, onBlur = undefined, name, label, helperText = '', optionalText, disabled = false, isError = false, errorText = '', inputProps, icon, value } = _a, rest = __rest(_a, ["className", "placeholder", "text", "type", "width", "onChange", "onBlur", "name", "label", "helperText", "optionalText", "disabled", "isError", "errorText", "inputProps", "icon", "value"]);
    // type-specific props
    const { showPasswordStrengthMeter = false, passwordRequirements } = rest;
    const { currencySymbol } = rest;
    const { maskProps = false } = rest;
    const { rows = 4 } = rest;
    const theme = useContext(ThemeContext);
    const [inputType, setInputType] = useState('');
    const valueFallbackToText = value || text;
    useEffect(() => {
        setInputType(type);
    }, [type]);
    const onChanged = (event) => {
        const textValue = event.target.value;
        const fieldName = event.target.name;
        onChange === null || onChange === void 0 ? void 0 : onChange(textValue, fieldName, event);
    };
    const togglePassword = () => {
        setInputType((previousType) => previousType === 'text' ? 'password' : 'text');
    };
    const hasCurrencySymbol = type === 'number' && !!currencySymbol && valueFallbackToText.length > 0;
    return (React__default.createElement(FormRow, { className: className },
        React__default.createElement(InputHeader$1, { label: label, optionalText: optionalText, disabled: disabled }),
        React__default.createElement(InputContainer$1, { width: width, fixedHeight: type !== 'multiline' },
            maskProps ? (React__default.createElement(InputMask, { autoComplete: "off", defaultValue: valueFallbackToText, disabled: disabled, name: name, placeholder: disabled ? '' : placeholder, type: inputType, value: valueFallbackToText, mask: maskProps.format, maskChar: maskProps.maskedCharacter || ' ', onChange: onChanged, onBlur: onBlur }, (forwardedProps) => (React__default.createElement(Input$1, Object.assign({ "aria-label": name, isError: isError }, forwardedProps, inputProps))))) : (React__default.createElement(React__default.Fragment, null, type === 'multiline' ? (React__default.createElement(InputMultiline, Object.assign({ as: "textarea", defaultValue: valueFallbackToText, "aria-label": name, autoComplete: "off", placeholder: disabled ? '' : placeholder, onChange: onChanged, onBlur: onBlur, name: name, disabled: disabled, isError: isError, hasIconOnRight: isError, rows: rows }, inputProps))) : (React__default.createElement(Input$1, Object.assign({ defaultValue: valueFallbackToText, ref: forwardedRef, "aria-label": name, autoComplete: "off", type: inputType, placeholder: disabled ? '' : placeholder, onChange: onChanged, onBlur: onBlur, name: name, disabled: disabled, isError: isError, hasIconOnRight: isError || type === 'password', hasCurrencySymbol: hasCurrencySymbol }, inputProps))))),
            hasCurrencySymbol && (React__default.createElement(CurrencySymbolWrapper, { disabled: disabled }, currencySymbol)),
            type === 'password' && !isError && (React__default.createElement(TogglePassword, { onClick: togglePassword, disabled: disabled, isPasswordType: inputType === 'password', type: "button", "aria-label": inputType === 'text' ? 'Hide Password' : 'Show Password' },
                React__default.createElement(Icon, { name: inputType === 'text'
                        ? 'password_visible_small'
                        : 'password_hidden_small', fill: disabled
                        ? theme.palette.disabledComponentColor
                        : theme.palette.interactiveMain }))),
            isError ? (React__default.createElement(ErrorWrapper, null,
                React__default.createElement(Icon, { name: "warning_small", fill: disabled
                        ? theme.palette.disabledComponentColor
                        : theme.palette.destructiveMain }))) : (React__default.createElement(IconWrapper$5, null, icon))),
        React__default.createElement(InputFooter$1, { helperText: helperText, isError: isError, errorText: errorText, disabled: disabled, value: valueFallbackToText, showPasswordStrengthMeter: showPasswordStrengthMeter, passwordRequirements: passwordRequirements })));
});
/**
 * @deprecated
 */
var TextInput$1 = styled(TextInput).attrs((props) => props) ``;

const MATH_SYMBOLS = ['-', '+', 'e', 'E'];
const preventNonnumericalCharacters = (event) => {
    if (MATH_SYMBOLS.includes(event.key)) {
        event.preventDefault();
    }
};
const CurrencyInput = React__default.forwardRef((_a, forwardedRef) => {
    var { inputProps, value, onChange } = _a, props = __rest(_a, ["inputProps", "value", "onChange"]);
    return (React__default.createElement(TextInput$1, Object.assign({}, props, { inputProps: Object.assign(Object.assign({}, inputProps), { onKeyPress: (event) => {
                preventNonnumericalCharacters(event);
            }, min: 0 }), ref: forwardedRef, type: "number", value: value, onChange: onChange, currencySymbol: "$", placeholder: "$0.00" })));
});

const InputContainer = styled.div.withConfig({
    shouldForwardProp: (props) => !['isError', 'bgColor'].includes(props),
}) `
  ${({ disabled, isError, theme: { borderRadius, palette } }) => css `
    border: 2px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.rHalf};
    height: 48px;
    position: relative;
    width: auto;

    &:hover {
      border-color: ${palette.baseColors.mawheranui};
    }

    &:active,
    &:focus-within {
      border-color: ${palette.baseColors.lupin};
    }

    ${isError &&
    !disabled &&
    css `
      &:focus-within {
        border: 2px solid ${palette.baseColors.marangai};
      }
    `};

    ${disabled &&
    css `
      border-color: ${palette.baseColors.alto};
      color: ${palette.baseColors.alto};

      &:hover,
      &:active {
        border-color: ${palette.baseColors.alto};
      }
    `}
  `};
`;

const GeneralText = styled(Text) `
  padding-top: ${(props) => props.theme.spacing.s0_5};
`;
function InputFooter({ helperText = '', isError = false, errorText = '', disabled = false, showErrorMessage = true, }) {
    const showHelperText = helperText && !isError;
    return (React__default.createElement(React__default.Fragment, null,
        showHelperText ? (React__default.createElement(GeneralText, { variant: "footnoteMedium", color: disabled ? colors.alto : colors.greymouth }, helperText)) : null,
        isError && showErrorMessage ? (React__default.createElement(GeneralText, { variant: "footnoteDemi", color: disabled ? colors.alto : colors.marangai }, errorText)) : null));
}

const LabelRow = styled.div `
  display: flex;
  justify-content: space-between;
`;
const LabelText$1 = styled(Text) `
  padding-bottom: ${(props) => props.theme.spacing.s0_5};
`;
const IconButton$4 = styled(TextButton) `
  position: relative;
  top: 5px;
`;
const InputHeader = ({ label, optionalText, disabled = false, showInfoButton = false, onInfoButtonClick = () => { }, }) => {
    if (!label && !optionalText) {
        return null;
    }
    const { palette } = useTheme();
    return (React__default.createElement(LabelRow, null,
        React__default.createElement(LabelText$1, { variant: "bodySDemi", color: disabled ? colors.alto : colors.newZealandBlack },
            label,
            showInfoButton ? (React__default.createElement(IconButton$4, { type: "button", onClick: onInfoButtonClick, variant: "textbutton" },
                React__default.createElement(Icon, { name: "info_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin }))) : null),
        React__default.createElement(LabelText$1, { variant: "bodySMedium", color: disabled ? colors.alto : colors.mawheranui }, optionalText)));
};

const StyledInput$1 = styled.input.withConfig({
    shouldForwardProp: (props) => !['inputmode', 'bgColor', 'isError'].includes(props),
}) `
  ${({ theme: { palette: { baseColors }, spacing, }, }) => css `
    background: none;
    border: none;
    color: ${baseColors.newZealandBlack};
    height: 100%;
    outline: none;
    padding-left: ${spacing.s1_5};
    width: 100%;
    ${bodySMediumStyle}

    &:disabled {
      color: ${baseColors.alto};
      cursor: not-allowed;
    }
  `}
`;
const StyledIcon$7 = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    padding: 0;
    position: absolute;
    right: ${spacing.s2};
    top: 10px;
  `};
`;
function TextInputV2({ bgColor, className, disabled, errorText, helperText, inputProps, label, name, onBlur, onFocus, onChange, onValueChange, optional, placeholder, showErrorMessage, type = 'text', value, customIcon, showInfoButton = false, onInfoButtonClick = () => { }, }) {
    const { palette } = useTheme();
    const handleInputChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (onValueChange) {
            onValueChange(event.target.value, name);
        }
    };
    const isError = Boolean(errorText);
    const errorIcon = (React__default.createElement(StyledIcon$7, { name: "warning_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.marangai }));
    const icon = isError ? errorIcon : customIcon;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("label", null,
            React__default.createElement(InputHeader, { disabled: disabled, label: label, optionalText: optional ? 'optional' : '', showInfoButton: showInfoButton, onInfoButtonClick: disabled ? () => { } : onInfoButtonClick }),
            React__default.createElement(InputContainer, { bgColor: bgColor, className: className, disabled: disabled, isError: isError },
                React__default.createElement(StyledInput$1, Object.assign({ "aria-label": label, autoComplete: "off", disabled: disabled, name: name, onBlur: onBlur, onFocus: onFocus, onChange: handleInputChange, placeholder: disabled ? '' : placeholder, type: type, value: value }, inputProps)),
                icon),
            React__default.createElement(InputFooter, { showErrorMessage: showErrorMessage, errorText: errorText, disabled: disabled, isError: isError, helperText: helperText }))));
}

/**
 * Coverting the css file from 'react-datepicker/dist/react-datepicker.css';
 * Converted to CSS into JS objects https://transform.tools/css-to-js
 *
 * TODO Test if this works in MySpark and if we finalize this approach write a script
 * to automatically generate this object and add it to global style sheet.
 */
const datePickerStyles = {
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow': {
        marginLeft: '-8px',
        position: 'absolute',
    },
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before': {
        boxSizing: 'content-box',
        position: 'absolute',
        border: '8px solid transparent',
        height: '0',
        width: '1px',
    },
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before': {
        content: '""',
        zIndex: -1,
        borderWidth: '8px',
        left: '-8px',
        borderBottomColor: '#aeaeae',
    },
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle': {
        top: '0',
        marginTop: '-8px',
    },
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before': {
        borderTop: 'none',
        borderBottomColor: '#f0f0f0',
    },
    '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before': {
        top: '-1px',
        borderBottomColor: '#aeaeae',
    },
    '.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow': {
        bottom: '0',
        marginBottom: '-8px',
    },
    '.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before': {
        borderBottom: 'none',
        borderTopColor: '#fff',
    },
    '.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before': {
        bottom: '-1px',
        borderTopColor: '#aeaeae',
    },
    '.react-datepicker-wrapper': {
        display: 'inline-block',
        padding: '0',
        border: '0',
    },
    '.react-datepicker': {
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '0.8rem',
        backgroundColor: '#fff',
        color: '#000',
        border: '1px solid #aeaeae',
        borderRadius: '0.3rem',
        display: 'inline-block',
        position: 'relative',
    },
    '.react-datepicker--time-only .react-datepicker__triangle': { left: '35px' },
    '.react-datepicker--time-only .react-datepicker__time-container': {
        borderLeft: '0',
    },
    '.react-datepicker--time-only .react-datepicker__time,\n.react-datepicker--time-only .react-datepicker__time-box': {
        borderBottomLeftRadius: '0.3rem',
        borderBottomRightRadius: '0.3rem',
    },
    '.react-datepicker__triangle': { position: 'absolute', left: '50px' },
    '.react-datepicker-popper': { zIndex: 1 },
    '.react-datepicker-popper[data-placement^="bottom"]': { marginTop: '10px' },
    '.react-datepicker-popper[data-placement="bottom-end"] .react-datepicker__triangle, .react-datepicker-popper[data-placement="top-end"] .react-datepicker__triangle': {
        left: 'auto',
        right: '50px',
    },
    '.react-datepicker-popper[data-placement^="top"]': { marginBottom: '10px' },
    '.react-datepicker-popper[data-placement^="right"]': { marginLeft: '8px' },
    '.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle': {
        left: 'auto',
        right: '42px',
    },
    '.react-datepicker-popper[data-placement^="left"]': { marginRight: '8px' },
    '.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle': {
        left: '42px',
        right: 'auto',
    },
    '.react-datepicker__header': {
        textAlign: 'center',
        backgroundColor: '#f0f0f0',
        borderBottom: '1px solid #aeaeae',
        borderTopLeftRadius: '0.3rem',
        paddingTop: '8px',
        position: 'relative',
    },
    '.react-datepicker__header--time': {
        paddingBottom: '8px',
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    '.react-datepicker__header--time:not(.react-datepicker__header--time--only)': {
        borderTopLeftRadius: '0',
    },
    '.react-datepicker__header:not(.react-datepicker__header--has-time-select)': {
        borderTopRightRadius: '0.3rem',
    },
    '.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll': {
        display: 'inline-block',
        margin: '0 2px',
    },
    '.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header': {
        marginTop: '0',
        color: '#000',
        fontWeight: 'bold',
        fontSize: '0.944rem',
    },
    '.react-datepicker-time__header': {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    '.react-datepicker__navigation': {
        background: 'none',
        lineHeight: '1.7rem',
        textAlign: 'center',
        cursor: 'pointer',
        position: 'absolute',
        top: '10px',
        width: ['0', '10px'],
        padding: '0',
        border: '0.45rem solid transparent',
        zIndex: 1,
        height: '10px',
        textIndent: '-999em',
        overflow: 'hidden',
    },
    '.react-datepicker__navigation--previous': {
        left: '10px',
        borderRightColor: '#ccc',
    },
    '.react-datepicker__navigation--previous:hover': {
        borderRightColor: '#b3b3b3',
    },
    '.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover': {
        borderRightColor: '#e6e6e6',
        cursor: 'default',
    },
    '.react-datepicker__navigation--next': {
        right: '10px',
        borderLeftColor: '#ccc',
    },
    '.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button)': {
        right: '95px',
    },
    '.react-datepicker__navigation--next:hover': { borderLeftColor: '#b3b3b3' },
    '.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover': {
        borderLeftColor: '#e6e6e6',
        cursor: 'default',
    },
    '.react-datepicker__navigation--years': {
        position: 'relative',
        top: '0',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    '.react-datepicker__navigation--years-previous': {
        top: '4px',
        borderTopColor: '#ccc',
    },
    '.react-datepicker__navigation--years-previous:hover': {
        borderTopColor: '#b3b3b3',
    },
    '.react-datepicker__navigation--years-upcoming': {
        top: '-4px',
        borderBottomColor: '#ccc',
    },
    '.react-datepicker__navigation--years-upcoming:hover': {
        borderBottomColor: '#b3b3b3',
    },
    '.react-datepicker__month-container': { cssFloat: 'left' },
    '.react-datepicker__year': { margin: '0.4rem', textAlign: 'center' },
    '.react-datepicker__year-wrapper': {
        display: 'flex',
        flexWrap: 'wrap',
        maxWidth: '180px',
    },
    '.react-datepicker__year .react-datepicker__year-text': {
        display: 'inline-block',
        width: '4rem',
        margin: '2px',
    },
    '.react-datepicker__month': { margin: '0.4rem', textAlign: 'center' },
    '.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text': {
        display: 'inline-block',
        width: '4rem',
        margin: '2px',
    },
    '.react-datepicker__input-time-container': {
        clear: 'both',
        width: '100%',
        cssFloat: 'left',
        margin: '5px 0 10px 15px',
        textAlign: 'left',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__caption': {
        display: 'inline-block',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container': {
        display: 'inline-block',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input': {
        display: 'inline-block',
        marginLeft: '10px',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input': {
        width: 'auto',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: '0',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]': {
        MozAppearance: 'textfield',
    },
    '.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter': {
        marginLeft: '5px',
        display: 'inline-block',
    },
    '.react-datepicker__time-container': {
        cssFloat: 'right',
        borderLeft: '1px solid #aeaeae',
        width: '85px',
    },
    '.react-datepicker__time-container--with-today-button': {
        display: 'inline',
        border: '1px solid #aeaeae',
        borderRadius: '0.3rem',
        position: 'absolute',
        right: '-72px',
        top: '0',
    },
    '.react-datepicker__time-container .react-datepicker__time': {
        position: 'relative',
        background: 'white',
        borderBottomRightRadius: '0.3rem',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box': {
        width: '85px',
        overflowX: 'hidden',
        margin: '0 auto',
        textAlign: 'center',
        borderBottomRightRadius: '0.3rem',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list': {
        listStyle: 'none',
        margin: '0',
        height: 'calc(195px + (1.7rem / 2))',
        overflowY: 'scroll',
        paddingRight: '0px',
        paddingLeft: '0px',
        width: '100%',
        boxSizing: 'content-box',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item': {
        height: '30px',
        padding: '5px 10px',
        whiteSpace: 'nowrap',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover': {
        cursor: 'pointer',
        backgroundColor: '#f0f0f0',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected': {
        backgroundColor: '#216ba5',
        color: 'white',
        fontWeight: 'bold',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover': {
        backgroundColor: '#216ba5',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled': {
        color: '#ccc',
    },
    '.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover': {
        cursor: 'default',
        backgroundColor: 'transparent',
    },
    '.react-datepicker__week-number': {
        color: '#ccc',
        display: 'inline-block',
        width: '1.7rem',
        lineHeight: '1.7rem',
        textAlign: 'center',
        margin: '0.166rem',
    },
    '.react-datepicker__week-number.react-datepicker__week-number--clickable': {
        cursor: 'pointer',
    },
    '.react-datepicker__week-number.react-datepicker__week-number--clickable:hover': {
        borderRadius: '0.3rem',
        backgroundColor: '#f0f0f0',
    },
    '.react-datepicker__day-names,\n.react-datepicker__week': {
        whiteSpace: 'nowrap',
    },
    '.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name': {
        color: '#000',
        display: 'inline-block',
        width: '1.7rem',
        lineHeight: '1.7rem',
        textAlign: 'center',
        margin: '0.166rem',
    },
    '.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range': {
        borderRadius: '0.3rem',
        backgroundColor: '#216ba5',
        color: '#fff',
    },
    '.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover': {
        backgroundColor: '#1d5d90',
    },
    '.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled': {
        color: '#ccc',
        pointerEvents: 'none',
    },
    '.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover': {
        cursor: 'default',
        backgroundColor: 'transparent',
    },
    '.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text': {
        cursor: 'pointer',
    },
    '.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover': {
        borderRadius: '0.3rem',
        backgroundColor: '#f0f0f0',
    },
    '.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today': {
        fontWeight: 'bold',
    },
    '.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted': {
        borderRadius: '0.3rem',
        backgroundColor: '#3dcc4a',
        color: '#fff',
    },
    '.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover': {
        backgroundColor: '#32be3f',
    },
    '.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1': {
        color: 'magenta',
    },
    '.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2': {
        color: 'green',
    },
    '.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range': {
        borderRadius: '0.3rem',
        backgroundColor: '#216ba5',
        color: '#fff',
    },
    '.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover': {
        backgroundColor: '#1d5d90',
    },
    '.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected': {
        borderRadius: '0.3rem',
        backgroundColor: '#2a87d0',
        color: '#fff',
    },
    '.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover': {
        backgroundColor: '#1d5d90',
    },
    '.react-datepicker__day--in-selecting-range ,\n.react-datepicker__month-text--in-selecting-range ,\n.react-datepicker__quarter-text--in-selecting-range ,\n.react-datepicker__year-text--in-selecting-range': {
        backgroundColor: 'rgba(33, 107, 165, 0.5)',
    },
    '.react-datepicker__month--selecting-range .react-datepicker__day--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__month-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__quarter-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__year-text--in-range': {
        backgroundColor: '#f0f0f0',
        color: '#000',
    },
    '.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled': {
        cursor: 'default',
        color: '#ccc',
    },
    '.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover': {
        backgroundColor: 'transparent',
    },
    '.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover': {
        backgroundColor: '#216ba5',
    },
    '.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover': {
        backgroundColor: '#f0f0f0',
    },
    '.react-datepicker__input-container': {
        position: 'relative',
        display: 'inline-block',
        width: '100%',
    },
    '.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view': {
        border: '1px solid transparent',
        borderRadius: '0.3rem',
    },
    '.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover': {
        cursor: 'pointer',
    },
    '.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow': {
        borderTopColor: '#b3b3b3',
    },
    '.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow': {
        borderTopColor: '#ccc',
        cssFloat: 'right',
        marginLeft: '20px',
        top: '8px',
        position: 'relative',
        borderWidth: '0.45rem',
    },
    '.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown': {
        backgroundColor: '#f0f0f0',
        position: 'absolute',
        width: '50%',
        left: '25%',
        top: '30px',
        zIndex: 1,
        textAlign: 'center',
        borderRadius: '0.3rem',
        border: '1px solid #aeaeae',
    },
    '.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover': {
        cursor: 'pointer',
    },
    '.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable': {
        height: '150px',
        overflowY: 'scroll',
    },
    '.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option': {
        lineHeight: '20px',
        width: '100%',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    '.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type': {
        borderTopLeftRadius: '0.3rem',
        borderTopRightRadius: '0.3rem',
    },
    '.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type': {
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
        userSelect: 'none',
        borderBottomLeftRadius: '0.3rem',
        borderBottomRightRadius: '0.3rem',
    },
    '.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover': {
        backgroundColor: '#ccc',
    },
    '.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming': {
        borderBottomColor: '#b3b3b3',
    },
    '.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous': {
        borderTopColor: '#b3b3b3',
    },
    '.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected': {
        position: 'absolute',
        left: '15px',
    },
    '.react-datepicker__close-icon': {
        cursor: 'pointer',
        backgroundColor: 'transparent',
        border: '0',
        outline: '0',
        padding: '0px 6px 0px 0px',
        position: 'absolute',
        top: '0',
        right: '0',
        height: '100%',
        display: 'table-cell',
        verticalAlign: 'middle',
    },
    '.react-datepicker__close-icon::after': {
        cursor: 'pointer',
        backgroundColor: '#216ba5',
        color: '#fff',
        borderRadius: '50%',
        height: '16px',
        width: '16px',
        padding: '2px',
        fontSize: '12px',
        lineHeight: 1,
        textAlign: 'center',
        display: 'table-cell',
        verticalAlign: 'middle',
        content: '"\\00d7"',
    },
    '.react-datepicker__today-button': {
        background: '#f0f0f0',
        borderTop: '1px solid #aeaeae',
        cursor: 'pointer',
        textAlign: 'center',
        fontWeight: 'bold',
        padding: '5px 0',
        clear: 'left',
    },
    '.react-datepicker__portal': {
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        left: '0',
        top: '0',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        zIndex: 2147483647,
    },
    '.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name': {
        width: '3rem',
        lineHeight: '3rem',
    },
    '@media (max-width: 400px), (max-height: 550px)': {
        '.react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name': {
            width: '2rem',
            lineHeight: '2rem',
        },
    },
    '.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header': {
        fontSize: '1.44rem',
    },
    '.react-datepicker__portal .react-datepicker__navigation': {
        border: '0.81rem solid transparent',
    },
    '.react-datepicker__portal .react-datepicker__navigation--previous': {
        borderRightColor: '#ccc',
    },
    '.react-datepicker__portal .react-datepicker__navigation--previous:hover': {
        borderRightColor: '#b3b3b3',
    },
    '.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover': {
        borderRightColor: '#e6e6e6',
        cursor: 'default',
    },
    '.react-datepicker__portal .react-datepicker__navigation--next': {
        borderLeftColor: '#ccc',
    },
    '.react-datepicker__portal .react-datepicker__navigation--next:hover': {
        borderLeftColor: '#b3b3b3',
    },
    '.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover': {
        borderLeftColor: '#e6e6e6',
        cursor: 'default',
    },
}; // Avoiding issues with styled components ts

registerLocale('en-NZ', enNZ);
const DatePickerContainer = styled.div `
  display: block;
  box-sizing: border-box;

  position: relative;

  input {
    width: 320px;
    height: 44px;
  }

  ${datePickerStyles}

  .react-datepicker {
    ${({ theme: { elevation } }) => css `
      box-shadow: ${elevation.elevation2};
    `}
  }

  .react-datepicker-popper {
    ${({ theme: { zIndex } }) => css `
      z-index: ${zIndex.modal};
    `}
  }

  .react-datepicker-popper[data-placement^='bottom'] {
    ${({ theme: { spacing }, helperText }) => css `
      margin-top: ${helperText ? '-20px' : spacing.s0_5};
    `}
  }

  .react-datepicker__aria-live {
    display: none;
  }

  .react-datepicker__month-container {
    width: 320px;
    font-size: 16px;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__header {
    ${({ theme: { spacing } }) => css `
      background: none;
      border: none;
      margin-top: ${spacing.s2};
    `}
  }

  .react-datepicker__navigation {
    ${({ theme: { palette, spacing } }) => css `
      margin-top: ${spacing.s2};
      border: solid ${palette.baseColors.lupin};
      border-width: 0 2px 2px 0;
      display: inline-block;
      padding: ${spacing.s0_5};
    `}
  }

  .react-datepicker__navigation--previous {
    ${({ theme: { palette } }) => css `
      left: 18px;
      transform: rotate(135deg);
      &:hover {
        border-right-color: ${palette.baseColors.lupin};
      }
    `}
  }

  .react-datepicker__navigation--next {
    right: 18px;
    transform: rotate(-45deg);
  }

  .react-datepicker__current-month {
    ${({ theme: { palette } }) => css `
      color: ${palette.baseColors.greymouth};
      line-height: 24px;
      font-size: 16px;
      font-weight: 600;
    `}
  }

  .react-datepicker__day-names {
    ${({ theme: { palette, spacing } }) => css `
      margin-top: ${spacing.s2};
      color: ${palette.baseColors.greymouth};
      ${footNoteMediumStyle}
    `}
  }

  .react-datepicker__day-name {
    width: 38px;
    height: 20px;
    line-height: 20px;
    ${({ theme: { palette } }) => css `
      color: ${palette.baseColors.greymouth};
    `}
  }

  .react-datepicker__month {
    ${({ theme: { spacing } }) => css `
      margin: ${spacing.s2} 0 ${spacing.s1} 0;
    `}
  }

  .react-datepicker__day {
    ${({ theme: { spacing } }) => css `
      width: 38px;
      height: 32px;
      margin: ${spacing.s1} 2px;
      line-height: 32px;
      font-weight: 500;
    `}
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--keyboard-selected {
    ${({ theme: { palette } }) => css `
      background: ${palette.baseColors.lupin};
      &:hover {
        background: ${palette.baseColors.lupin};
      }
    `}
  }
  .react-datepicker__day--disabled {
    ${({ theme: { palette } }) => css `
      color: ${palette.baseColors.moeraki};
    `}
  }

  .react-datepicker__day--outside-month {
    visibility: hidden;
  }

  .react-datepicker__input-container input {
    ${({ theme: { palette }, disabled }) => css `
      color: ${disabled
    ? palette.baseColors.moeraki
    : palette.baseColors.newZealandBlack};
    `}
  }

  ${({ fullWidth }) => {
    return fullWidth
        ? css `
          .react-datepicker {
            ${({ theme: { spacing } }) => css `
              width: 100%;
              padding: 0 ${spacing.s1};
            `}
          }

          .react-datepicker__month-container,
          .react-datepicker-wrapper,
          .react-datepicker input {
            width: 100%;
          }

          .react-datepicker__day-names,
          .react-datepicker__week {
            display: flex;
            justify-content: space-between;
          }
        `
        : ``;
}}
`;
const StyledIcon$6 = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    padding: 0;
    position: absolute;
    right: ${spacing.s2};
    top: 10px;
    cursor: pointer;
  `};
`;
const TextInputWrapper = styled.div ``;
// There are issues with react-datepicker falling back to mm/dd/yyyy when manually inputting dates
// This allows manual entry in dd/mm/yyyy format without falling back to the default date format
// https://github.com/Hacker0x01/react-datepicker/issues/638
const dateFormats = ['dd/MM/yyyy', 'dd MMMM yyyy', 'dd MM yyyy'];
const transformDisplayValue = (value) => {
    const todaysDates = dateFormats.map((dateFormat) => format(new Date(), dateFormat, { locale: enNZ }));
    return todaysDates.includes(value) ? 'Today' : value;
};
//  All props except disabled, errorText, helperText, label and name are passed from the react-datepicker customInput prop
const CustomInput = ({ disabled, errorText, helperText, label, name, onClick, value = '', onChange, onBlur, optional, autoComplete, autoFocus, className, id, onFocus, onKeyDown, placeholder, }) => {
    const { palette } = useTheme();
    const customIcon = (React__default.createElement(StyledIcon$6, { name: "calendar_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin }));
    const [isEditing, setIsEditing] = useState(false);
    const handleFocus = (e) => {
        setIsEditing(true);
        if (typeof onFocus === 'function') {
            onFocus(e);
        }
    };
    const handleBlur = (e) => {
        setIsEditing(false);
        if (typeof onBlur === 'function') {
            onBlur(e);
        }
    };
    const displayValue = isEditing ? value : transformDisplayValue(value);
    return (React__default.createElement(TextInputWrapper, { onClick: onClick },
        React__default.createElement(TextInputV2, { placeholder: placeholder, disabled: disabled, errorText: errorText, helperText: helperText, customIcon: customIcon, label: label, name: name, optional: optional, onChange: onChange, onBlur: handleBlur, onFocus: handleFocus, value: displayValue, inputProps: {
                autoComplete,
                autoFocus,
                className,
                disabled,
                id,
                onKeyDown,
            } })));
};
const DatePicker = (_a) => {
    var { className, disabled = false, errorText, helperText, inputProps, inputText, label, maxDate, minDate, name, onChange, selected, inline, fullWidth, placeholder, onBlur, optional } = _a, props = __rest(_a, ["className", "disabled", "errorText", "helperText", "inputProps", "inputText", "label", "maxDate", "minDate", "name", "onChange", "selected", "inline", "fullWidth", "placeholder", "onBlur", "optional"]);
    return (React__default.createElement("div", { className: className },
        React__default.createElement(DatePickerContainer, { helperText: helperText, fullWidth: fullWidth, disabled: disabled },
            React__default.createElement(ReactDatePicker, Object.assign({ disabled: disabled, selected: selected, onChange: onChange, dateFormat: dateFormats, onBlur: onBlur, locale: "en-NZ", formatWeekDay: (nameOfDay) => String(nameOfDay).substring(0, 3), customInput: React__default.createElement(CustomInput, { optional: optional, disabled: disabled, errorText: errorText, helperText: helperText, label: label, name: name }), maxDate: maxDate, minDate: minDate, placeholderText: placeholder || inputText, inline: inline }, props)))));
};

const StyledIcon$5 = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    padding: 0;
    position: absolute;
    right: ${spacing.s2};
    top: 10px;
  `};
`;
function InputIcon({ disabled, iconName, isError, }) {
    const { palette } = useTheme();
    if (isError) {
        return (React__default.createElement(StyledIcon$5, { name: "warning_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.marangai }));
    }
    if (!iconName) {
        return null;
    }
    return (React__default.createElement(StyledIcon$5, { name: iconName, fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin }));
}

const StyledInput = styled.input `
  background: none;
  border: none;
  height: 100%;
  outline: none;
  opacity: 0;
  width: 100%;
`;
const FileInputText = styled(Text) `
  ${({ theme: { spacing } }) => css `
    overflow: hidden;
    position: absolute;
    padding-left: ${spacing.s1_5};
    padding-right: ${spacing.s5};
    text-overflow: ellipsis;
    top: 50%;
    transform: translateY(-50%);
    width: 100%;
  `}
`;
function FileInput({ accept, className, disabled, errorText, helperText, file, label, maximumFileSize, name, onBlur, onChange, onError, onFileChange, optional, placeholder, }) {
    const { palette: { baseColors }, } = useTheme();
    const isError = Boolean(errorText);
    const handleInputChange = (event) => {
        var _a, _b, _c;
        if (((_a = event.target.files) === null || _a === void 0 ? void 0 : _a.length) &&
            maximumFileSize &&
            ((_b = event.target.files) === null || _b === void 0 ? void 0 : _b[0].size) > maximumFileSize) {
            if (onError) {
                onError('TOO_LARGE_FILE_SIZE');
            }
            // this should still early-exit if onError prop is not supplied
            return;
        }
        // Handle Chrome cancel
        if (!((_c = event.target.files) === null || _c === void 0 ? void 0 : _c.length)) {
            return;
        }
        if (onChange) {
            onChange(event);
        }
        if (onFileChange) {
            onFileChange(event.target.files[0]);
        }
    };
    const inputRef = useRef(null);
    const clearFile = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        if (onFileChange) {
            onFileChange(null);
        }
    };
    const handleClearButtonClick = (event) => {
        event.stopPropagation();
        event.preventDefault();
        clearFile();
    };
    useEffect(() => {
        if (!file) {
            clearFile();
        }
    }, [file]);
    const hasFileSelected = !!file;
    const textColor = hasFileSelected
        ? baseColors.newZealandBlack
        : baseColors.mawheranui;
    const text = hasFileSelected ? file === null || file === void 0 ? void 0 : file.name : placeholder;
    return (React__default.createElement("label", null,
        React__default.createElement(InputHeader, { disabled: disabled, label: label, optionalText: optional ? 'optional' : '' }),
        React__default.createElement(InputContainer, { className: className, disabled: disabled, isError: isError },
            React__default.createElement(StyledInput, { accept: accept === null || accept === void 0 ? void 0 : accept.join(','), "aria-label": label, autoComplete: "off", disabled: disabled, name: name, onBlur: onBlur, onChange: handleInputChange, type: "file", ref: inputRef }),
            React__default.createElement(FileInputText, { color: textColor, variant: "bodySMedium" }, text),
            hasFileSelected ? (React__default.createElement("button", { type: "button", onClick: handleClearButtonClick, style: { backgroundColor: 'transparent', border: 'none' }, "aria-label": "Clear input" },
                React__default.createElement(InputIcon, { iconName: "cross_small", isError: false }))) : (React__default.createElement(InputIcon, { disabled: disabled, iconName: "camera_small", isError: isError }))),
        React__default.createElement(InputFooter, { errorText: errorText, disabled: disabled, isError: isError, helperText: helperText })));
}

const DropDownContainer = styled.div `
  display: flex;
`;
const ErrorIcon = styled(Icon) `
  margin-right: ${({ theme }) => theme.spacing.s1};
`;
const Indicator = ({ isError, isDisabled }) => {
    const { palette } = useTheme();
    const iconColor = isDisabled
        ? palette.baseColors.alto
        : palette.baseColors.lupin;
    return (React__default.createElement(DropDownContainer, null,
        isError ? (React__default.createElement(ErrorIcon, { name: "warning_small", fill: palette.baseColors.marangai })) : null,
        React__default.createElement(Icon, { name: "chevron_down_small", fill: iconColor })));
};

function getBorderColor({ isDisabled, isError, palette }) {
    if (isDisabled) {
        return palette.baseColors.alto;
    }
    if (isError) {
        return palette.baseColors.marangai;
    }
    return palette.baseColors.moeraki;
}
const CustomReactSelect = styled(ReactSelect) `
  ${({ theme: { palette, spacing, borderRadius, zIndex }, isError, isDisabled, }) => css `
    /* Input box */
    & .spark__indicators {
      padding-right: 2px;
    }

    & .spark__control {
      align-items: center;
      border: 2px solid ${getBorderColor({ isDisabled, isError, palette })};
      box-shadow: none;
      border-radius: ${borderRadius.rHalf};
      display: flex;
      flex-direction: row;
      height: 48px;
      padding: 0 ${spacing.s2} 0 ${spacing.s0_5};
      margin-bottom: ${spacing.s0_5};

      &:hover {
        cursor: pointer;
        border: 2px solid
          ${isError
    ? palette.baseColors.marangai
    : palette.baseColors.mawheranui};
      }
    }

    & .spark__control--is-disabled {
      background: ${palette.baseColors.wairua};
    }

    & .spark__placeholder {
      ${bodySMediumStyle};
    }

    & .spark__single-value {
      ${bodySMediumStyle};
      color: ${palette.baseColors.newZealandBlack};
    }

    & .spark__single-value--is-disabled {
      color: ${palette.baseColors.moeraki};
    }

    & .spark__menu {
      ${bodySMediumStyle};
      color: ${palette.baseColors.newZealandBlack};
    }

    & .spark__control--is-focused {
      border: solid 2px
        ${isError ? palette.baseColors.marangai : palette.baseColors.lupin};
      box-shadow: none;
      &:hover {
        cursor: pointer;
        border: 2px solid
          ${isError ? palette.baseColors.marangai : palette.baseColors.lupin};
      }
    }

    /* Menu */
    & .spark__menu {
      z-index: ${zIndex.navigation};
      box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.16);
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.rHalf};
      margin-top: ${spacing.s0_5};
    }

    & .spark__option--is-focused {
      background: ${palette.baseColors.onepu};
      color: ${palette.baseColors.newZealandBlack};
      &:active {
        background: ${palette.baseColors.onepu};
      }
    }

    & .spark__option--is-selected {
      background: ${palette.baseColors.lupin};
      color: ${palette.baseColors.wairua};
      &:active {
        background: ${palette.baseColors.onepu};
      }
    }
  `}
`;

function FormDropdown(props) {
    const { className, defaultValue, disabled = false, errorText, helperText, maxMenuHeight = '144px', label, name, onChange, onFocus, optional = false, options, placeholder, value, dynamicTargetValue = '' } = props, rest = __rest(props, ["className", "defaultValue", "disabled", "errorText", "helperText", "maxMenuHeight", "label", "name", "onChange", "onFocus", "optional", "options", "placeholder", "value", "dynamicTargetValue"]);
    const isError = Boolean(errorText);
    const isValueValid = options.some((option) => option.value === (value === null || value === void 0 ? void 0 : value.value));
    const componentName = 'Form Dropdown';
    return (React__default.createElement("div", { className: className, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(InputHeader, { label: label, optionalText: optional ? 'optional' : undefined, disabled: disabled }),
        React__default.createElement(CustomReactSelect, Object.assign({ maxMenuHeight: maxMenuHeight, classNamePrefix: "spark", components: {
                DropdownIndicator: (indicatorProps) => {
                    return (React__default.createElement(Indicator, Object.assign({}, indicatorProps, { isDisabled: disabled, isError: isError })));
                },
                IndicatorSeparator: () => null,
            }, defaultValue: defaultValue, isDisabled: disabled, onChange: onChange, onFocus: onFocus, options: options, placeholder: placeholder || '', value: isValueValid ? value : null, isError: isError, isSearchable: false }, rest)),
        React__default.createElement(InputFooter, { isError: isError, errorText: errorText, helperText: helperText, disabled: disabled })));
}

const InputGroupTitle = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s3};
  `}
`;
const Container$6 = styled.fieldset `
  ${({ theme: { media, spacing } }) => css `
    display: flex;
    flex-direction: column;
    padding: 0;
    border: 0;

    label:not(:last-of-type) {
      margin-bottom: ${spacing.s4};

      ${media.up('big')} {
        margin-bottom: ${spacing.s2};
      }
    }
  `}
`;

/**
 * This will be empty until the day the styles for radio group differs from InputGroup's default ones (if they do)
 */
const CheckboxGroupContainer = styled(Container$6) ``;
const CheckboxGroup = ({ title, children, }) => {
    return (React__default.createElement(CheckboxGroupContainer, null,
        title ? (React__default.createElement(InputGroupTitle, { variant: "bodyMDemi" }, title)) : null,
        children));
};

const ChoiceboxGroupContainer = styled(Container$6) `
  button:not(:last-of-type) {
    margin-bottom: ${({ theme }) => theme.spacing.s1};
  }
`;
const ChoiceboxGroup = ({ title, children, }) => {
    return (React__default.createElement(ChoiceboxGroupContainer, null,
        title ? (React__default.createElement(InputGroupTitle, { variant: "bodyMDemi" }, title)) : null,
        children));
};

/**
 * This will be empty until the day the styles for radio group differs from InputGroup's default ones (if they do)
 */
const RadioGroupContainer = styled(Container$6) ``;
const RadioGroup = ({ className, disabled, title, children, }) => {
    return (React__default.createElement(RadioGroupContainer, { className: className, disabled: disabled },
        title ? (React__default.createElement(InputGroupTitle, { variant: "bodyMDemi" }, title)) : null,
        children));
};

const MaskInputContainer = styled.div `
  position: relative;
  display: inline-block;
  width: 100%;
`;
const InputField$1 = styled(StyledInput$1) `
  ${({ theme: { palette, spacing } }) => css `
    background: none;
    border: 2px solid ${palette.baseColors.moeraki};
    color: ${palette.baseColors.newZealandBlack};
    height: 100%;
    outline: none;
    width: 100%;
    padding: ${spacing.s1_5} 87px ${spacing.s1_5} ${spacing.s2};
    &:hover {
      border: 2px solid ${palette.baseColors.mawheranui};
    }
    &:active,
    &:focus-visible {
      border: 2px solid ${palette.baseColors.lupin};
    }
  `}
`;
const IconContainer$1 = styled.div `
  ${({ theme: { spacing } }) => css `
    position: absolute;
    top: 50%;
    right: ${spacing.s1};
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}
`;
const MaskInput = ({ value, onChange, label, name, onValueChange, autoFocus, disabled, optional, iconName, iconFillColour, mask, showErrorMessage, errorText = '', helperText = '', replacement = null, }) => {
    const handleInputChange = (event) => {
        if (disabled) {
            return;
        }
        if (onChange) {
            onChange(event);
        }
        if (onValueChange) {
            onValueChange(event.target.value, name);
        }
    };
    return (React__default.createElement("label", null,
        React__default.createElement(InputHeader, { disabled: Boolean(disabled), label: label, optionalText: optional ? 'optional' : '' }),
        React__default.createElement(MaskInputContainer, null,
            React__default.createElement(InputMask, { autoComplete: "off", defaultValue: value, disabled: disabled, name: name, type: "text", value: value, mask: mask, maskChar: replacement, onChange: handleInputChange }, (forwardedProps) => (React__default.createElement(InputField$1, Object.assign({ "aria-label": label, autoComplete: "off", name: name, type: "text", value: value }, forwardedProps, { autoFocus: autoFocus })))),
            React__default.createElement(IconContainer$1, null, iconName ? React__default.createElement(Icon, { name: iconName, fill: iconFillColour }) : null)),
        React__default.createElement(InputFooter, { showErrorMessage: showErrorMessage, errorText: errorText, disabled: disabled, isError: Boolean(errorText), helperText: helperText })));
};

const REPLACE_REGEX = /[^0-9]+/g;
const REPLACE_REGEX_ALLOW_PERIODS = /[^0-9.]+/g;
function cleanEvent({ allowPeriods, rawEvent, }) {
    const replaceRegex = allowPeriods
        ? REPLACE_REGEX_ALLOW_PERIODS
        : REPLACE_REGEX;
    const cleanedChangeValue = rawEvent.target.value.replaceAll(replaceRegex, '');
    return Object.assign(Object.assign({}, rawEvent), { target: Object.assign(Object.assign({}, rawEvent.target), { value: cleanedChangeValue }) });
}
function NumberInput(_a) {
    var { allowPeriods = false, onChange, onValueChange, inputProps } = _a, rest = __rest(_a, ["allowPeriods", "onChange", "onValueChange", "inputProps"]);
    const handleChange = (rawEvent) => {
        const cleanedEvent = cleanEvent({ allowPeriods, rawEvent });
        if (onChange) {
            onChange(cleanedEvent);
        }
        if (onValueChange) {
            onValueChange(cleanedEvent.target.value);
        }
    };
    const numberInputProps = Object.assign({ pattern: '[0-9]*', inputmode: 'numeric' }, inputProps);
    return (React__default.createElement(TextInputV2, Object.assign({ type: "text" }, rest, { onChange: handleChange, inputProps: numberInputProps })));
}

const StyledRow = styled.div `
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 104px 1fr;
  align-items: start;
`;
const PHONE_INPUT_DEFAULT_MOBILE_PREFIX_OPTIONS = [
    '020',
    '021',
    '022',
    '027',
    '028',
    '029',
];
const PHONE_INPUT_DEFAULT_LANDLINE_PREFIX_OPTIONS = [
    '03',
    '04',
    '06',
    '07',
    '09',
    '00',
];
const PHONE_INPUT_DEFAULT_OPTIONS = [
    ...PHONE_INPUT_DEFAULT_MOBILE_PREFIX_OPTIONS,
    ...PHONE_INPUT_DEFAULT_LANDLINE_PREFIX_OPTIONS,
];
const validationRuleFromPrefixList = (prefixList) => new RegExp(`^(${prefixList.join('|')})[0-9]{6,9}$`);
const PHONE_INPUT_DEFAULT_MOBILE_VALIDATION_RULE = validationRuleFromPrefixList(PHONE_INPUT_DEFAULT_MOBILE_PREFIX_OPTIONS);
const PHONE_INPUT_DEFAULT_LANDLINE_VALIDATION_RULE = validationRuleFromPrefixList(PHONE_INPUT_DEFAULT_LANDLINE_PREFIX_OPTIONS);
const PHONE_INPUT_DEFAULT_VALIDATION_RULE = validationRuleFromPrefixList([
    ...PHONE_INPUT_DEFAULT_MOBILE_PREFIX_OPTIONS,
    ...PHONE_INPUT_DEFAULT_LANDLINE_PREFIX_OPTIONS,
]);
function parsePhoneNumber(value, options) {
    const sortedOptions = [...options].sort((a, b) => Number(b.value) - Number(a.value));
    const matchingOption = sortedOptions.find((option) => {
        return value.startsWith(option.value);
    });
    if (matchingOption) {
        const remainingNumber = value.slice(matchingOption.value.length);
        return {
            prefix: matchingOption,
            remainingNumber,
        };
    }
    return {
        prefix: null,
        remainingNumber: value,
    };
}
function PhoneInput({ label, options, errorText, onChange, placeholder, value, inputProps, prefixPlaceholder = 'Prefix', }) {
    const { prefix, remainingNumber } = parsePhoneNumber(value, options);
    function handleChange(changePrefix, changeRemainingNumber) {
        var _a;
        onChange(`${(_a = changePrefix === null || changePrefix === void 0 ? void 0 : changePrefix.value) !== null && _a !== void 0 ? _a : ''}${changeRemainingNumber}`);
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Text, { variant: "bodySDemi", mb: "s0_5" }, label),
        React__default.createElement(StyledRow, null,
            React__default.createElement(FormDropdown, { options: options, placeholder: prefixPlaceholder, value: prefix, onChange: (changePrefix) => handleChange(changePrefix, remainingNumber) }),
            React__default.createElement(NumberInput, { name: "remainingNumber", placeholder: placeholder, onValueChange: (changeRemainingNumber) => handleChange(prefix, changeRemainingNumber), errorText: errorText, value: remainingNumber, inputProps: inputProps }))));
}

const IconsContainer$1 = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: ${spacing.s2};
  `}
`;
const IconButton$3 = styled.button `
  cursor: pointer;
  outline: none;
  border: none;
  background: none;
  padding: 0;
`;
const StyledDivider = styled(Divider$1) `
  ${({ theme: { palette, spacing } }) => css `
    height: ${spacing.s3};
    background-color: ${palette.baseColors.moeraki};
    margin: 0 ${spacing.s1};
  `}
`;
const SearchAutocompleteIcons = ({ value, onCrossIconClick, onSearchIconClick, disabled, searchIconProps, enableClearInput = true, isSearchIconDisabled, isError, }) => {
    const { palette } = useTheme();
    const shouldShowClearInput = enableClearInput && (value === null || value === void 0 ? void 0 : value.length) > 0;
    return (React__default.createElement(IconsContainer$1, null,
        isError ? (React__default.createElement(Box, { mr: "s0_5" },
            React__default.createElement("title", { id: "warning-title" }, "warning icon"),
            React__default.createElement(Icon, { "aria-labelledby": "warning-title", name: "warning_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.marangai }))) : null,
        shouldShowClearInput ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(IconButton$3, { onClick: onCrossIconClick, "aria-label": "clear" },
                React__default.createElement(Icon, { name: "cross_small", fill: disabled ? palette.baseColors.alto : palette.baseColors.lupin })),
            React__default.createElement(StyledDivider, { orientation: "vertical" }))) : null,
        React__default.createElement(IconButton$3, Object.assign({ onClick: onSearchIconClick, className: "search-icon", "aria-label": "submit" }, searchIconProps),
            React__default.createElement(Icon, { name: "search_small", fill: disabled || isSearchIconDisabled
                    ? palette.baseColors.alto
                    : palette.baseColors.lupin }))));
};

const MIN_LENGTH = 2;
const animateOpacity$1 = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
const autoSuggestMixin = css `
  ${({ theme: { spacing, elevation, palette, zIndex, borderRadius } }) => css `
    background-color: ${palette.baseColors.wairua};
    position: absolute;
    top: 44px;
    right: 0;
    left: 0;
    max-height: 180px;
    overflow-y: auto;
    border: 1px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.r1};
    z-index: ${zIndex.popover};
    box-shadow: ${elevation.elevation1};
    padding: ${spacing.s2};

    transition: transform 0.2s ease-in-out;
    transform: translateY(6px);
    animation: ${animateOpacity$1} 0.2s linear;

    ::-webkit-scrollbar {
      ${CustomScrollbarMixin}
    }

    ::-webkit-scrollbar-track {
      ${CustomScrollbarTrackMixin}
    }

    ::-webkit-scrollbar-thumb {
      ${CustomScrollbarThumbMixin}
    }
  `}
`;
const AutoSuggestContainer = styled.div `
  ${({ theme: { borderRadius, palette, spacing }, disabled, isError, variant, }) => {
    const BORDER_RADIUS = variant === 'underLineInput' ? borderRadius.rHalf : borderRadius.r3;
    return css `
      display: flex;
      position: relative;
      background-color: ${palette.baseColors.wairua};

      width: 100%;

      border: 2px solid
        ${disabled ? palette.baseColors.alto : palette.baseColors.moeraki};
      border-radius: ${BORDER_RADIUS};

      &:hover {
        border: 2px solid
          ${disabled ? palette.baseColors.alto : palette.baseColors.mawheranui};
      }

      ${isError &&
        !disabled &&
        css `
        &:focus-within {
          border: 2px solid ${palette.baseColors.marangai};
        }
      `};

      &:active,
      &:focus-within {
        border: 2px solid
          ${disabled ? palette.baseColors.alto : palette.baseColors.lupin};
      }

      ${variant === 'underLineInput' &&
        css `
        border: none;
        border-bottom: 1px solid ${palette.baseColors.moeraki};
        border-radius: 0;
        &:hover {
          border: none;
          border-bottom: 1px solid ${palette.baseColors.mawheranui};
        }

        &:active,
        &:focus-within {
          border: none;
          border-bottom: 1px solid ${palette.baseColors.lupin};
        }
      `}

      .react-autosuggest__container {
        width: 100%;
        line-height: 28px;
      }

      .react-autosuggest__input {
        border: none;
        border-radius: ${BORDER_RADIUS};
        width: 100%;
        ${bodySMediumStyle}
        color: ${palette.baseColors.newZealandBlack};
        background-color: ${palette.baseColors.wairua};
        -webkit-mask-image: linear-gradient(90deg, #000 80%, transparent);
        padding: ${spacing.s1} ${spacing.s2};
        ::placeholder {
          color: ${disabled
        ? palette.baseColors.alto
        : palette.baseColors.mawheranui};
        }
      }

      .react-autosuggest__suggestions-container--open {
        ${autoSuggestMixin};
        margin: 0;
      }

      .react-autosuggest__suggestion {
        cursor: pointer;
        list-style-type: none;
      }

      .react-autosuggest__suggestions-list {
        margin: 0;
        padding: ${spacing.s1} 0;
      }

      .react-autosuggest__suggestion {
        cursor: pointer;
        padding: ${spacing.s1} ${spacing.s2};
      }

      li {
        &:hover {
          background-color: ${palette.baseColors.onepu};
        }
      }
    `;
}}
`;
const SearchSuggestionText = ({ textType, children, }) => {
    const { palette } = useTheme();
    switch (textType) {
        case 'matching':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.lupin }, children));
        case 'highlight':
            return (React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: palette.baseColors.newZealandBlack }, children));
        default:
            return (React__default.createElement(Text, { component: "span", variant: "bodySMedium", color: palette.baseColors.mawheranui }, children));
    }
};
function splitMatchingSuggestionText(input, suggestion) {
    const lowerCaseSuggestion = suggestion.toLowerCase();
    const lowerCaseInput = input.toLowerCase();
    const matchingTextStartIndex = lowerCaseSuggestion.indexOf(lowerCaseInput);
    if (matchingTextStartIndex === -1) {
        return {};
    }
    const matchingTextEndIndex = matchingTextStartIndex + lowerCaseInput.length;
    return {
        beforeMatchingText: suggestion.slice(0, matchingTextStartIndex),
        matchingText: suggestion.slice(matchingTextStartIndex, matchingTextEndIndex),
        afterMatchingText: suggestion.slice(matchingTextEndIndex, lowerCaseSuggestion.length),
    };
}
const renderSuggestion = (suggestion, inputValue) => {
    const { beforeMatchingText, matchingText, afterMatchingText } = splitMatchingSuggestionText(inputValue, suggestion);
    if (!matchingText)
        return React__default.createElement(SearchSuggestionText, null, suggestion);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SearchSuggestionText, null, beforeMatchingText),
        React__default.createElement(SearchSuggestionText, { textType: "highlight" }, matchingText),
        React__default.createElement(SearchSuggestionText, null, afterMatchingText)));
};
const SearchAutocomplete = ({ suggestions, onSuggestionsFetchRequested, onSuggestionsClearRequested, onCrossIconClick, onSearchIconClick, placeholder, value, onChange: handleOnChange, disabled, onSelect, variant = 'default', searchIconProps, enableClearInput, isSearchIconDisabled, errorText, }, ref) => {
    const getSuggestionValue = (suggestion) => suggestion;
    const autoSuggestLibSuggestions = suggestions.map(({ label }) => label);
    const handleSuggestionsRequested = ({ value: suggestionValue }) => {
        if (onSuggestionsFetchRequested)
            onSuggestionsFetchRequested(suggestionValue);
    };
    const autoSuggestRef = useRef(null);
    const suggestionSelectedRef = useRef(false);
    useImperativeHandle(ref, () => autoSuggestRef.current, []);
    const handleSuggestionSelected = (_event, data) => {
        suggestionSelectedRef.current = true;
        const { suggestionIndex } = data;
        onSelect(suggestions[suggestionIndex]);
        setTimeout(() => {
            if (suggestionSelectedRef.current) {
                suggestionSelectedRef.current = false;
            }
            if (autoSuggestRef === null || autoSuggestRef === void 0 ? void 0 : autoSuggestRef.current) {
                autoSuggestRef.current.blur();
            }
        }, 0);
    };
    const isSearchIconDisabledInternal = isSearchIconDisabled !== null && isSearchIconDisabled !== void 0 ? isSearchIconDisabled : (value === null || value === void 0 ? void 0 : value.length) < MIN_LENGTH;
    const handleSearchIconClick = () => {
        if (!disabled && !isSearchIconDisabledInternal) {
            onSearchIconClick();
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            if (isSearchIconDisabledInternal || disabled) {
                event.preventDefault();
            }
            else if (!suggestionSelectedRef.current) {
                handleSearchIconClick();
            }
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(AutoSuggestContainer, { disabled: disabled, variant: variant, isError: !!errorText },
            React__default.createElement(Autosuggest, { suggestions: autoSuggestLibSuggestions, onSuggestionsFetchRequested: handleSuggestionsRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: (suggestion) => renderSuggestion(suggestion, value), inputProps: {
                    onChange: (_event, params) => {
                        handleOnChange(params === null || params === void 0 ? void 0 : params.newValue);
                    },
                    placeholder,
                    value,
                    disabled,
                    ref: autoSuggestRef,
                    onKeyDown: handleKeyDown,
                }, onSuggestionSelected: handleSuggestionSelected }),
            React__default.createElement(SearchAutocompleteIcons, { value: value, onCrossIconClick: onCrossIconClick, onSearchIconClick: handleSearchIconClick, disabled: disabled, searchIconProps: searchIconProps, enableClearInput: enableClearInput, isSearchIconDisabled: isSearchIconDisabledInternal, isError: !!errorText })),
        React__default.createElement(InputFooter, { isError: true, errorText: errorText, disabled: disabled })));
};
var SearchAutocomplete$1 = React__default.forwardRef(SearchAutocomplete);

const SearchInputContainer = styled.div `
  position: relative;
  display: inline-block;
  width: 100%;
`;
const InputField = styled.input `
  ${({ theme: { palette, spacing, borderRadius }, variant, hasErrorText }) => {
    const defaultBorderColor = palette.baseColors[hasErrorText ? 'marangai' : 'moeraki'];
    return css `
      background: none;
      border: 2px solid ${defaultBorderColor};
      color: ${palette.baseColors.newZealandBlack};
      height: 100%;
      outline: none;
      width: 100%;
      border-radius: ${borderRadius.r3};
      padding: ${spacing.s1_5} ${spacing.s3};

      ${hasErrorText
        ? css `
            &:hover,
            &:active,
            &:focus {
              border-color: ${palette.baseColors.marangai};
            }
          `
        : css `
            &:hover {
              border-color: ${palette.baseColors.mawheranui};
            }
            &:active,
            &:focus {
              border-color: ${palette.baseColors.lupin};
            }
          `}

      /* Hide number input arrows */
      &[type='number']::-webkit-outer-spin-button,
      &[type='number']::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      &[type='number'] {
        -moz-appearance: textfield;
      }

      ${variant === 'nonRounded' &&
        css `
        border-radius: ${borderRadius.r1};
      `}

      ${variant === 'underLineInput' &&
        css `
        border: none;
        border-bottom: 2px solid ${defaultBorderColor};
        border-radius: 0;
        padding: ${spacing.s1} ${spacing.s2};
        &:hover,
        &:active,
        &:focus {
          border-bottom: 2px solid
            ${palette.baseColors[hasErrorText ? 'marangai' : 'mawheranui']};
        }
      `}
    `;
}}
`;
const IconContainer = styled.div `
  ${({ theme: { spacing }, variant }) => css `
    position: absolute;
    top: 50%;
    right: ${spacing.s2};
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${variant === 'underLineInput' &&
    css `
      .search-icon {
        margin-right: 0;
        padding-right: 0;
      }
    `}
  `}
`;
const Divider = styled.div `
  ${({ theme: { palette, spacing } }) => css `
    width: 1px;
    height: ${spacing.s3};
    background-color: ${palette.baseColors.alto};
  `}
`;
const StyledIcon$4 = styled(Icon) `
  cursor: pointer;
`;
const IconButton$2 = styled.button `
  ${({ theme: { spacing } }) => css `
    flex: 1;
    padding: 0 ${spacing.s1};
    background: none;
    border: none;
  `}
`;
const SearchInput = ({ value, onChange, placeholder, type = 'text', label, name, onSearchIconClick, onCrossIconClick, onValueChange, isIconDisabled, inputProps, searchIconProps, enableClearInput = true, variant = 'default', errorText, }) => {
    const { palette } = useTheme();
    const isSearchDisabled = isIconDisabled || !onSearchIconClick;
    const shouldShowClearInput = enableClearInput && (value === null || value === void 0 ? void 0 : value.length) > 0;
    const handleInputChange = (event) => {
        if (onChange) {
            onChange(event);
        }
        if (onValueChange) {
            onValueChange(event.target.value, name);
        }
    };
    const hasErrorText = !!errorText;
    let iconFillColor;
    if (hasErrorText) {
        iconFillColor = palette.baseColors.marangai;
    }
    else if (isIconDisabled) {
        iconFillColor = palette.baseColors.alto;
    }
    else {
        iconFillColor = palette.baseColors.lupin;
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SearchInputContainer, null,
            React__default.createElement(InputField, Object.assign({ "aria-label": label, autoComplete: "off", name: name, type: type, placeholder: placeholder, value: value, onChange: handleInputChange, variant: variant, hasErrorText: hasErrorText }, inputProps)),
            React__default.createElement(IconContainer, { variant: variant },
                shouldShowClearInput ? (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(IconButton$2, { onClick: onCrossIconClick, "aria-label": "Clear Input", type: "button" },
                        React__default.createElement(StyledIcon$4, { name: "cross_small", fill: iconFillColor })),
                    React__default.createElement(Divider, null))) : null,
                React__default.createElement(IconButton$2, Object.assign({ onClick: !isSearchDisabled && !hasErrorText ? onSearchIconClick : () => { }, className: "search-icon", "aria-label": "Search button", "aria-invalid": hasErrorText ? 'true' : 'false', "aria-errormessage": hasErrorText ? `error-${name.replace(/\s+/g, '-')}` : undefined }, searchIconProps),
                    React__default.createElement(StyledIcon$4, { name: hasErrorText ? 'warning_small' : 'search_small', fill: iconFillColor })))),
        React__default.createElement(InputFooter, { isError: true, showErrorMessage: hasErrorText, errorText: errorText })));
};

const SliderTrackStyleMixin = css `
  ${({ theme: { palette }, disabled, progressBarWidth }) => css `
    background: ${disabled
    ? palette.baseColors.alto
    : `linear-gradient( to left,
        ${palette.baseColors.alto} calc(100% - ${progressBarWidth}),
        ${palette.baseColors.sparkPurple} 0%
      )`};
    height: 8px;
    border-radius: 10px;
  `}
`;
const SliderThumbStyleMixin = css `
  ${({ theme: { borderRadius, palette, zIndex, spacing }, disabled }) => css `
    -webkit-appearance: none;
    width: 32px;
    height: 32px;
    border-radius: ${borderRadius.round};
    background: ${palette.baseColors.wairua};
    background-clip: padding-box;
    border: 4px solid
      ${disabled ? palette.baseColors.alto : palette.baseColors.lupin};
    margin-top: -${spacing.s1_5};
    position: relative;
    z-index: ${zIndex.default};
    transition: 0.1s ease-in-out;

    &:hover,
    &:active {
      width: ${disabled ? '32px' : '56px'};
      height: ${disabled ? '32px' : '56px'};
      border: ${disabled
    ? `4px solid ${palette.baseColors.alto}`
    : `8px solid ${palette.baseColors.lupinOpacity50}`};
      margin-top: ${disabled ? `-${spacing.s1_5}` : `-${spacing.s3}`};
    }
  `}
`;
const Input = styled.input `
  ${({ theme: { palette } }) => css `
    -webkit-appearance: none;
    background: none;
    width: 100%;
    height: 8px;
    cursor: pointer;
    &:focus-visible {
      box-shadow:
        0 0 0 1px ${palette.baseColors.wairua},
        0 0 0 4px ${palette.baseColors.lupin};
      border-radius: 10px;
    }
  `}

  ::-webkit-slider-runnable-track {
    ${SliderTrackStyleMixin}
  }

  ::-moz-range-track {
    ${SliderTrackStyleMixin}
  }

  ::-ms-track {
    ${SliderTrackStyleMixin}
  }

  ::-webkit-slider-thumb {
    ${SliderThumbStyleMixin}
  }

  ::-moz-range-thumb {
    ${SliderThumbStyleMixin}
  }

  ::-ms-thumb {
    ${SliderThumbStyleMixin}
  }
`;
const InputWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    margin: 0 ${spacing.s1};
    position: relative;
    width: 100%;
    height: 24px;
    display: flex;
    align-items: center;
  `}
`;
const SliderLabel = styled.label `
  display: flex;
  justify-content: left;
`;
const getProgressBarWidth = (currentValue, maxValue, minValue) => {
    return ((currentValue - minValue) / (maxValue - minValue)) * 100;
};
const Slider = ({ className, disabled = false, formatLabel, formatLimit, max, min, onChange, step, value, inputProps, }) => {
    const progressBarWidth = getProgressBarWidth(value, max, min);
    const handleChange = (event) => {
        const currentValue = parseInt(event.target.value, 10);
        onChange(currentValue);
    };
    const { palette } = useTheme();
    const labelColor = disabled
        ? palette.baseColors.moeraki
        : palette.baseColors.mawheranui;
    return (React__default.createElement("div", { className: className },
        React__default.createElement(SliderLabel, { disabled: disabled },
            React__default.createElement(Text, { component: "span", variant: "subheadingM", color: disabled
                    ? palette.baseColors.moeraki
                    : palette.baseColors.newZealandBlack }, formatLabel(value))),
        React__default.createElement(Box, { pt: "s4", flexDirection: "row" },
            React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: labelColor }, formatLimit(min)),
            React__default.createElement(InputWrapper, null,
                React__default.createElement(Input, Object.assign({ type: "range", disabled: disabled, "aria-valuetext": formatLabel(value), progressBarWidth: `${progressBarWidth}%`, min: min, max: max, step: step, value: value, onChange: handleChange }, inputProps))),
            React__default.createElement(Text, { component: "span", variant: "bodySDemi", color: labelColor }, formatLimit(max)))));
};

const resizableContainerStyles = {
    '.react-resizable': { position: 'relative' },
    '.react-resizable-handle': {
        position: 'absolute',
        width: '20px',
        height: '20px',
        backgroundRepeat: 'no-repeat',
        backgroundOrigin: 'content-box',
        boxSizing: 'border-box',
        backgroundImage: "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+')",
        backgroundPosition: 'bottom right',
        padding: '0 3px 3px 0',
    },
    '.react-resizable-handle-sw': {
        bottom: '0',
        left: '0',
        cursor: 'sw-resize',
        transform: 'rotate(90deg)',
    },
    '.react-resizable-handle-se': {
        bottom: '0',
        right: '0',
        cursor: 'se-resize',
    },
    '.react-resizable-handle-nw': {
        top: '0',
        left: '0',
        cursor: 'nw-resize',
        transform: 'rotate(180deg)',
    },
    '.react-resizable-handle-ne': {
        top: '0',
        right: '0',
        cursor: 'ne-resize',
        transform: 'rotate(270deg)',
    },
    '.react-resizable-handle-w,\n.react-resizable-handle-e': {
        top: '50%',
        marginTop: '-10px',
        cursor: 'ew-resize',
    },
    '.react-resizable-handle-w': { left: '0', transform: 'rotate(135deg)' },
    '.react-resizable-handle-e': { right: '0', transform: 'rotate(315deg)' },
    '.react-resizable-handle-n,\n.react-resizable-handle-s': {
        left: '50%',
        marginLeft: '-10px',
        cursor: 'ns-resize',
    },
    '.react-resizable-handle-n': { top: '0', transform: 'rotate(225deg)' },
    '.react-resizable-handle-s': { bottom: '0', transform: 'rotate(45deg)' },
};

const ResizableStylesContainer = styled.div `
  ${resizableContainerStyles}
`;
const ResizableContainer = ({ width, height, minWidth = 100, maxWidth = Infinity, minHeight = 100, maxHeight = Infinity, style, className, children, resizeDirections, }) => {
    return (React__default.createElement(ResizableStylesContainer, null,
        React__default.createElement(ResizableBox, { width: width, height: height, minConstraints: [minWidth, minHeight], maxConstraints: [maxWidth, maxHeight], resizeHandles: resizeDirections, style: style, className: className },
            React__default.createElement(React__default.Fragment, null, children))));
};

const createToolbarConfig = (editor, selectedConfig) => {
    const allConfigs = [
        {
            name: 'bold',
            icon: React__default.createElement(Bold, { className: 'w-5 h-5' }),
            active: editor.isActive('bold'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleBold().run();
            },
        },
        {
            name: 'italic',
            icon: React__default.createElement(Italic, { className: 'w-5 h-5' }),
            active: editor.isActive('italic'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleItalic().run();
            },
        },
        {
            name: 'underline',
            icon: React__default.createElement(Underline$2, { className: 'w-5 h-5' }),
            active: editor.isActive('underline'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleUnderline().run();
            },
        },
        {
            name: 'strikethrough',
            icon: React__default.createElement(Strikethrough, { className: 'w-5 h-5' }),
            active: editor.isActive('strike'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleStrike().run();
            },
        },
        {
            name: 'heading2',
            icon: React__default.createElement(Heading2, { className: 'w-5 h-5' }),
            active: editor.isActive('heading', { level: 2 }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleHeading({ level: 2 }).run();
            },
        },
        {
            name: 'heading3',
            icon: React__default.createElement(Heading3, { className: 'w-5 h-5' }),
            active: editor.isActive('heading', { level: 3 }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleHeading({ level: 3 }).run();
            },
        },
        {
            name: 'heading4',
            icon: React__default.createElement(Heading4, { className: 'w-5 h-5' }),
            active: editor.isActive('heading', { level: 4 }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleHeading({ level: 4 }).run();
            },
        },
        {
            name: 'heading5',
            icon: React__default.createElement(Heading5, { className: 'w-5 h-5' }),
            active: editor.isActive('heading', { level: 5 }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleHeading({ level: 5 }).run();
            },
        },
        {
            name: 'heading6',
            icon: React__default.createElement(Heading6, { className: 'w-5 h-5' }),
            active: editor.isActive('heading', { level: 6 }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleHeading({ level: 6 }).run();
            },
        },
        {
            name: 'bulletList',
            icon: React__default.createElement(List$2, { className: 'w-5 h-5' }),
            active: editor.isActive('bulletList'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleBulletList().run();
            },
        },
        {
            name: 'orderedList',
            icon: React__default.createElement(ListOrdered, { className: 'w-5 h-5' }),
            active: editor.isActive('orderedList'),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().toggleOrderedList().run();
            },
        },
        {
            name: 'redo',
            icon: React__default.createElement(Redo, { className: 'w-5 h-5' }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().redo().run();
            },
        },
        {
            name: 'undo',
            icon: React__default.createElement(Undo, { className: 'w-5 h-5' }),
            onClick: (e) => {
                e.preventDefault();
                editor.chain().focus().undo().run();
            },
        },
    ];
    return selectedConfig
        ? allConfigs.filter((config) => selectedConfig.includes(config.name))
        : allConfigs;
};
const countCharactersInHtml = (htmlContent) => {
    if (!htmlContent) {
        return 0;
    }
    const textContent = htmlContent.replace(/<[^>]*>/g, '');
    return textContent.replace(/\s/g, '').length;
};

const ToolbarContainer = styled.div `
  ${({ theme: { palette, spacing } }) => css `
    padding: ${spacing.s2};
    border-bottom: 1px solid ${palette.baseColors.alto};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: ${spacing.s1_5};
  `}
`;
const Button$1 = styled.button `
  ${({ theme: { palette, spacing, borderRadius }, disabled }) => css `
    background-color: transparent;
    padding: ${spacing.s0_5};
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    border: none;
    border-radius: ${borderRadius.r1};
    display: flex;
    align-items: center;
    justify-content: center;
    transition:
      background-color 0.2s,
      color 0.2s;

    ${({ active }) => active &&
    css `
        background-color: ${palette.baseColors.lupin};
        color: white;
      `}

    &:hover {
      background-color: ${({ active }) => active ? palette.baseColors.mawheranui : palette.baseColors.alto};
      color: ${({ active }) => active ? 'white' : palette.baseColors.newZealandBlack};
    }
  `}
`;
const Toolbar = ({ editor, configOptions, disabled }) => {
    if (!editor) {
        return null;
    }
    const toolbarConfig = createToolbarConfig(editor, configOptions);
    return (React__default.createElement(ToolbarContainer, null, toolbarConfig.map(({ name, icon, active, onClick }) => (React__default.createElement(Button$1, { disabled: disabled, key: name, active: active, onClick: onClick }, icon)))));
};

const FooterContainer$1 = styled.div `
  ${({ theme: { spacing, palette } }) => css `
    background-color: ${palette.baseColors.onepu};
    padding: ${spacing.s2};
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
  `}
`;
const Footer$1 = ({ maxCharacterLength: maxLength, currentCharacterCount: currentCount, }) => {
    return (React__default.createElement(FooterContainer$1, null,
        React__default.createElement(Text, { variant: "footnoteMedium" },
            "Current Characters Count: ",
            currentCount),
        React__default.createElement(Text, { variant: "footnoteMedium" },
            "Maximum Length: ",
            maxLength,
            " Characters")));
};

const MAX_CHARACTER_LENGTH = 1000;
const DEFAULT_CONTAINER_WIDTH = 800;
const DEFAULT_CONTAINER_HEIGHT = 400;
const FULL_WIDTH_CONTAINER_WIDTH = Infinity;
const EditorContainer = styled.div `
  ${({ theme: { palette, spacing }, disabled }) => css `
    color: ${disabled ? palette.disabledComponentColor : palette.textColor};
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: ${spacing.s4};
  `}
`;
const StyledResizableContainer = styled(ResizableContainer) `
  ${({ theme: { borderRadius, palette } }) => css `
    border: 1px solid ${palette.baseColors.alto};
    border-radius: ${borderRadius.rHalf};
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    width: 100%;
  `}
`;
const LabelContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    position: absolute;
    top: -${spacing.s4};
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `}
`;
const ContentContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s2};
    overflow-y: auto;
    height: 100%;

    ::-webkit-scrollbar {
      ${CustomScrollbarMixin}
    }

    ::-webkit-scrollbar-track {
      ${CustomScrollbarTrackMixin}
    }

    ::-webkit-scrollbar-thumb {
      ${CustomScrollbarThumbMixin}
    }
  `}
`;
const LabelText = styled(Text) `
  padding-bottom: ${(props) => props.theme.spacing.s0_5};
`;
const RichTextEditor = ({ content, onChange, maxCharacterLength = MAX_CHARACTER_LENGTH, configOptions, label, name, disabled = false, optional, fullWidth, }) => {
    const [lastValidContent, setLastValidContent] = useState(content);
    const { palette } = useTheme();
    const customEditor = useEditor({
        content,
        extensions: [StarterKit, Underline$3],
        onUpdate: ({ editor }) => {
            let html = editor.getHTML();
            if (html === '<p></p>') {
                html = '';
            }
            const charCount = countCharactersInHtml(html);
            if (charCount <= maxCharacterLength) {
                onChange(html);
                setLastValidContent(html);
            }
            else {
                editor.commands.setContent(lastValidContent);
            }
        },
    });
    useEffect(() => {
        if (customEditor) {
            customEditor.setEditable(!disabled);
        }
    }, [customEditor, disabled]);
    const handleContainerClick = () => {
        const selection = window.getSelection();
        const isTextSelected = selection && !selection.isCollapsed;
        if (!isTextSelected && customEditor) {
            customEditor.chain().focus().run();
        }
    };
    const currentCharacterCount = countCharactersInHtml(customEditor === null || customEditor === void 0 ? void 0 : customEditor.getHTML()) || 0;
    const styledContainerWidth = fullWidth
        ? FULL_WIDTH_CONTAINER_WIDTH
        : DEFAULT_CONTAINER_WIDTH;
    return (React__default.createElement(EditorContainer, { onClick: handleContainerClick, disabled: disabled },
        React__default.createElement(StyledResizableContainer, { width: styledContainerWidth, height: DEFAULT_CONTAINER_HEIGHT, minWidth: DEFAULT_CONTAINER_WIDTH, minHeight: DEFAULT_CONTAINER_HEIGHT, maxWidth: Infinity, maxHeight: Infinity, resizeDirections: ['se'] },
            React__default.createElement(LabelContainer, null,
                React__default.createElement(LabelText, { variant: "bodySDemi", color: disabled ? palette.disabledComponentColor : palette.labelTextColor }, label),
                optional ? (React__default.createElement(LabelText, { variant: "bodySMedium", color: disabled
                        ? palette.optionalDisabledTextColor
                        : palette.optionalTextColor }, "Optional")) : null),
            React__default.createElement(Toolbar, { editor: customEditor, configOptions: configOptions, disabled: disabled }),
            React__default.createElement(ContentContainer, null,
                React__default.createElement(EditorContent, { style: { whiteSpace: 'pre-line' }, editor: customEditor, name: name, onFocus: () => {
                        if (customEditor && customEditor.getHTML() === '<p></p>') {
                            customEditor.commands.setContent('');
                        }
                    } })),
            React__default.createElement(Footer$1, { maxCharacterLength: MAX_CHARACTER_LENGTH, currentCharacterCount: currentCharacterCount }))));
};

const StyledChoiceBox = styled(ChoiceBox) `
  label {
    display: flex;
    align-items: center;
  }
`;
const FormChoiceBoxGroup = ({ name, title, options, }) => {
    const { field, formState: { isSubmitting }, } = useController({
        name,
    });
    return (React__default.createElement(ChoiceboxGroup, { title: title }, options.map(({ label, value, sublabel, icon, description }) => {
        const isChecked = field.value === value;
        return (React__default.createElement(Fragment, { key: value },
            React__default.createElement(StyledChoiceBox, Object.assign({}, field, { onChange: () => field.onChange(value), checked: isChecked, disabled: isSubmitting, label: React__default.createElement(Box, { flexDirection: "row", alignItems: "center" },
                    icon,
                    React__default.createElement(Box, { ml: icon ? 's2' : undefined },
                        React__default.createElement(Text, { variant: "bodySDemi" }, label),
                        sublabel ? (React__default.createElement(Text, { variant: "footnoteMedium" }, sublabel)) : null)) })),
            description && isChecked ? description : null));
    })));
};

const FormCurrencyInput = (_a) => {
    var { name, defaultValue, disabled } = _a, rest = __rest(_a, ["name", "defaultValue", "disabled"]);
    const { field, fieldState: { error }, formState: { isSubmitting }, } = useController({
        name,
        defaultValue,
    });
    const fieldProps = __rest(field, ["ref"]);
    return (React__default.createElement(CurrencyInput, Object.assign({}, fieldProps, { isError: !!error, errorText: error === null || error === void 0 ? void 0 : error.message, disabled: disabled || isSubmitting }, rest)));
};

const FormDatePicker = (_a) => {
    var _b;
    var { name, onChange: customOnChange, disabled } = _a, datePickerProps = __rest(_a, ["name", "onChange", "disabled"]);
    const { control } = useFormContext();
    const _c = useController({
        name,
        control,
    }), _d = _c.field, { onChange, onBlur, value } = _d, fieldProps = __rest(_d, ["onChange", "onBlur", "value"]), { fieldState: { error }, formState: { isSubmitting } } = _c;
    const handleChange = (date) => {
        if (customOnChange) {
            customOnChange(date);
        }
        onChange(date);
    };
    return (React__default.createElement(DatePicker, Object.assign({}, fieldProps, { name: name, errorText: (_b = error === null || error === void 0 ? void 0 : error.message) !== null && _b !== void 0 ? _b : undefined, selected: value, disabled: disabled || isSubmitting, onChange: handleChange, onBlur: onBlur }, datePickerProps)));
};

const FormNumberInput = (_a) => {
    var { name, defaultValue, disabled } = _a, rest = __rest(_a, ["name", "defaultValue", "disabled"]);
    const { field, fieldState: { error }, formState: { isSubmitting }, } = useController({
        name,
        defaultValue,
    });
    const fieldProps = __rest(field, ["ref"]);
    return (React__default.createElement(NumberInput, Object.assign({}, fieldProps, { errorText: error === null || error === void 0 ? void 0 : error.message, disabled: disabled || isSubmitting }, rest)));
};

const FormTextInput = (_a) => {
    var { name, defaultValue, disabled } = _a, rest = __rest(_a, ["name", "defaultValue", "disabled"]);
    const { field, fieldState: { error }, formState: { isSubmitting }, } = useController({
        name,
        defaultValue,
    });
    const fieldProps = __rest(field, ["ref"]);
    return (React__default.createElement(TextInputV2, Object.assign({}, fieldProps, { errorText: error === null || error === void 0 ? void 0 : error.message, disabled: disabled || isSubmitting }, rest)));
};

const FormSubmitButton = (props) => {
    const { formState: { isValid, isSubmitting }, } = useFormContext();
    return (React__default.createElement(Button$2, Object.assign({ type: "submit", variant: "primary", disabled: !isValid, isLoading: isSubmitting }, props)));
};

const FormCheckBox = ({ name, label, className }) => {
    const { field, formState: { isSubmitting }, } = useController({
        name,
    });
    const isChecked = field.value === true;
    const onCheck = () => {
        if (isSubmitting) {
            return;
        }
        field.onChange(!isChecked);
    };
    return (React__default.createElement(Checkbox, { checked: isChecked, onCheck: onCheck, label: label, className: className }));
};

const FormMaskInput = (_a) => {
    var { name, defaultValue, disabled, getIcon, iconName } = _a, rest = __rest(_a, ["name", "defaultValue", "disabled", "getIcon", "iconName"]);
    const { field, fieldState: { error }, formState: { isSubmitting }, } = useController({
        name,
        defaultValue,
    });
    const computedIconName = (getIcon === null || getIcon === void 0 ? void 0 : getIcon(field.value)) || iconName || null;
    const fieldProps = __rest(field, ["ref"]);
    return (React__default.createElement(MaskInput, Object.assign({}, fieldProps, { errorText: error === null || error === void 0 ? void 0 : error.message, disabled: disabled || isSubmitting, iconName: computedIconName }, rest)));
};

function FormFormDropdown(_a) {
    var { name, label, options, disabled, placeholder, defaultValue } = _a, rest = __rest(_a, ["name", "label", "options", "disabled", "placeholder", "defaultValue"]);
    const { field, fieldState: { error }, formState: { isSubmitting }, } = useController({
        name,
        defaultValue,
    });
    return (React__default.createElement(FormDropdown, Object.assign({}, field, { value: field.value, label: label, options: options, placeholder: placeholder, errorText: error === null || error === void 0 ? void 0 : error.message, disabled: disabled || isSubmitting }, rest)));
}

const Form = ({ children, defaultValues, mode = 'onChange', onSubmit, schema, shouldUnregister = true, }) => {
    const methods = useForm({
        defaultValues,
        mode,
        resolver: zodResolver(schema),
        shouldUnregister,
    });
    return (React__default.createElement(FormProvider, Object.assign({}, methods),
        React__default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) }, children)));
};

const StyledLogo$1 = styled(Logo$1) `
  height: 44px;
  width: 112px;
`;
const Logo = () => {
    const { palette } = useTheme();
    return (React__default.createElement(StyledLogo$1, { name: "horizontal_logo", fill: palette.baseColors.sparkPurple }));
};

const PillContentWrapper$1 = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 62px;
`;
const PillCircleBase = styled.div `
  ${({ theme: { borderRadius } }) => css `
    display: flex;
    border-radius: ${borderRadius.round};
    width: 32px;
    height: 32px;
    justify-content: center;
    align-items: center;
  `}
`;

const HeaderContext = React__default.createContext({
    variant: 'reverse',
    profile: null,
    isStickyNavigation: false,
    isScrollUp: false,
    isSearchBarOpen: true,
    scrollY: 0,
    setIsSearchBarOpen: noop,
});
const HeaderProvider = ({ children, variant, profile, isStickyNavigation = false, hasSegmentSwitcher = true, }) => {
    const [variantAsPerScroll, setVariantAsPerScroll] = useState(variant);
    const [isSearchBarOpen, setIsSearchBarOpen] = useState(false);
    const [scrollY, setScrollY] = useState(0);
    const [isScrollUp, setScrollUp] = useState(false);
    const isDesktop = useMediaQuery({ min: 'big' });
    const handleScroll = throttle(() => {
        const lastScroll = scrollY;
        setScrollUp(window.scrollY < lastScroll);
        setScrollY(window.scrollY);
        if (isStickyNavigation &&
            variant === 'reverse' &&
            window.scrollY > HEADER_WITH_SEGMENT_SWITCHER_HEIGHT &&
            (isDesktop || (!isDesktop && window.scrollY < lastScroll))) {
            setVariantAsPerScroll('positive');
        }
        else {
            setVariantAsPerScroll(variant);
        }
    }, SCROLL_THROTTLE_DELAY);
    useEffect(() => {
        setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return (React__default.createElement(HeaderContext.Provider, { value: {
            variant: variantAsPerScroll,
            profile,
            isStickyNavigation,
            isScrollUp,
            isSearchBarOpen,
            scrollY,
            setIsSearchBarOpen,
            hasSegmentSwitcher,
        } }, children));
};
const useHeader = () => {
    const context = useContext(HeaderContext);
    if (!context) {
        throw new Error('useHeaderAcccess should be used inside HeaderProvider');
    }
    return context;
};

const InitialsCircle$1 = styled(Avatar) `
  ${({ theme: { palette, spacing, borderRadius, media } }) => css `
    width: 34px;
    height: 34px;
    border: 1px solid transparent;
    background: ${palette.baseColors.mawhero};
    border-radius: ${borderRadius.round};
    margin: 0 ${spacing.s0_5} 0 0 !important;

    &:hover {
      box-shadow:
        0 0 0 2px ${palette.baseColors.moeraki},
        0 0 0 3px ${palette.baseColors.onepu};
    }

    &:active {
      border-radius: ${borderRadius.round};
      box-shadow:
        0 0 0 2px ${palette.baseColors.moeraki},
        0 0 0 3px ${palette.baseColors.alto};

      transition: background 100s;
      transform: scale(0.96);

      svg {
        transform: scale(1.04);
      }
    }

    ${media.up('big')} {
      width: 32px;
      height: 32px;
    }
  `}
`;
const InitialsPositiveCircleSmall = styled(InitialsCircle$1) `
  ${({ theme: { palette, borderRadius } }) => css `
    border-radius: ${borderRadius.round};
    box-shadow:
      0 0 0 2px ${palette.baseColors.wairua},
      0 0 0 3px ${palette.baseColors.moeraki};
  `}
`;
const InitialsReverseCircleSmall = styled(InitialsPositiveCircleSmall) `
  ${({ theme: { palette, borderRadius } }) => css `
    border-radius: ${borderRadius.round};
    box-shadow:
      0 0 0 1px ${palette.baseColors.moeraki},
      0 0 0 4px ${palette.baseColors.wairua};
  `}
`;
const NotificationDot$1 = styled.div `
  ${({ theme: { borderRadius, palette } }) => css `
    background-color: ${palette.baseColors.kiwi};
    width: 16px;
    height: 16px;
    border-radius: ${borderRadius.round};
    position: absolute;
    top: -4px;
    left: 24px;
  `}
`;
const NotificationNumber$1 = styled.label `
  ${({ theme: { palette } }) => css `
    display: flex;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: ${palette.baseColors.wairua};
    justify-content: center;
    align-items: center;
  `}
`;
const StyledChevronIcon$1 = styled(Icon) `
  margin: 2px 0 0 2px;
`;
const AuthorisedPill = () => {
    const { variant, profile } = useHeader();
    if (!profile) {
        return null;
    }
    const { firstName, lastName, src, profileNotifications } = profile;
    const { palette } = useTheme();
    const isPositiveVariant = variant !== 'reverse';
    const fillColour = isPositiveVariant
        ? palette.baseColors.newZealandBlack
        : palette.baseColors.wairua;
    const InitialsCircleSmall = isPositiveVariant
        ? InitialsPositiveCircleSmall
        : InitialsReverseCircleSmall;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MediaQuery, { max: "slim" },
            React__default.createElement(PillContentWrapper$1, { "aria-label": `Profile for ${firstName} ${lastName}` },
                React__default.createElement(InitialsCircleSmall, { src: src, size: "small", firstName: firstName, lastName: lastName }),
                profileNotifications > 0 && (React__default.createElement(NotificationDot$1, null,
                    React__default.createElement(NotificationNumber$1, null, profileNotifications))))),
        React__default.createElement(MediaQuery, { min: "big" },
            React__default.createElement(PillContentWrapper$1, { "aria-label": `Profile for ${firstName} ${lastName}` },
                React__default.createElement(InitialsCircle$1, { src: src, size: "small", firstName: firstName, lastName: lastName }),
                React__default.createElement(StyledChevronIcon$1, { name: "chevron_down_extra_small", size: 16, fill: fillColour }),
                profileNotifications > 0 && (React__default.createElement(NotificationDot$1, null,
                    React__default.createElement(NotificationNumber$1, null, profileNotifications)))))));
};

const PositiveSignInPillIcon = styled(PillCircleBase) `
  ${({ theme: { media, spacing, palette, borderRadius } }) => css `
    border: 1px solid ${palette.baseColors.moeraki};
    background: ${palette.baseColors.onepu};
    margin-right: ${spacing.s2};

    &:hover {
      background: ${palette.baseColors.alto};
    }

    &:active {
      border-radius: ${borderRadius.round};
      background: ${palette.baseColors.moeraki};

      transition: background 100s;
      transform: scale(0.96);

      svg {
        transform: scale(1.04);
      }
    }

    ${media.up('big')} {
      margin-right: ${spacing.s1};
    }
  `}
`;
const ReverseSignInPillIcon = styled(PositiveSignInPillIcon) `
  ${({ theme: { palette, borderRadius } }) => css `
    border: 1px solid ${palette.baseColors.wairua};
    background: ${palette.baseColors.wairua};

    &:hover {
      background: ${palette.baseColors.wairuaOpacity12};
    }

    &:active {
      border-radius: ${borderRadius.round};
      background: ${palette.baseColors.wairuaOpacity8};

      transition: background 100s;
      transform: scale(0.96);

      svg {
        transform: scale(1.04);
      }
    }
  `}
`;
const PositiveSignInPillIconSmall = styled(PositiveSignInPillIcon) `
  ${({ theme: { palette } }) => css `
    border: none;
    box-shadow:
      0 0 0 2px ${palette.baseColors.wairua},
      0 0 0 3px ${palette.baseColors.moeraki};
  `}
`;
const ReverseSignInPillIconSmall = styled(ReverseSignInPillIcon) `
  ${({ theme: { palette } }) => css `
    box-shadow:
      0 0 0 1px ${palette.baseColors.moeraki},
      0 0 0 3px ${palette.baseColors.wairua};
  `}
`;
const StyledPositiveText = styled.span `
  ${({ theme: { palette } }) => css `
    ${footNoteDemiStyle};
    color: ${palette.baseColors.newZealandBlack};
    margin-right: 3px;
  `}
`;
const StyledReverseText = styled(StyledPositiveText) `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.wairua};
  `}
`;
const UnauthorisedPill = ({ text }) => {
    const { palette } = useTheme();
    const { variant } = useHeader();
    const isPositiveVariant = variant !== 'reverse';
    const fillColour = isPositiveVariant
        ? palette.baseColors.newZealandBlack
        : palette.baseColors.wairua;
    const StyledSignInPillIcon = isPositiveVariant
        ? PositiveSignInPillIcon
        : ReverseSignInPillIcon;
    const StyledSignInPillIconSmall = isPositiveVariant
        ? PositiveSignInPillIconSmall
        : ReverseSignInPillIconSmall;
    const StyledText = isPositiveVariant ? StyledPositiveText : StyledReverseText;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MediaQuery, { max: "slim" },
            React__default.createElement(PillContentWrapper$1, { role: "button", "aria-label": "Login" },
                React__default.createElement(StyledSignInPillIconSmall, null,
                    React__default.createElement(Icon, { name: "me_extra_small" })))),
        React__default.createElement(MediaQuery, { min: "big" },
            React__default.createElement(PillContentWrapper$1, { role: "button", "aria-label": "Login" },
                React__default.createElement(StyledSignInPillIcon, null,
                    React__default.createElement(Icon, { name: "me_extra_small" })),
                React__default.createElement(StyledText, null, text),
                React__default.createElement(Icon, { name: "chevron_down_extra_small", fill: fillColour })))));
};

const ProfilePillPositive = styled.button `
  ${({ theme: { spacing, palette, borderRadius, media, zIndex } }) => css `
    position: relative;
    display: inline-block;
    border: none;
    cursor: pointer;
    background: none;
    min-height: 40px;
    padding: 0 ${spacing.s0_5};

    &:focus-visible {
      & ${PositiveSignInPillIconSmall}, & ${InitialsPositiveCircleSmall} {
        box-shadow:
          0 0 0 1px ${palette.baseColors.wairua},
          0 0 0 4px ${palette.baseColors.lupin};
      }

      background: {
        variant: ${palette.baseColors.wairua};
      }
    }

    ${media.up('big')} {
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r3};
      position: relative;
      transform-origin: center center;
      background-position: center;
      transition:
        background 0.1s,
        transform scale(0);

      &:before {
        content: '';
        background: ${palette.baseColors.onepu};
        border-radius: inherit;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: ${zIndex.negative};
        transform: scale(0);

        transition: transform 0.2s;
      }

      &:hover {
        &:before {
          transform: scale(1);
        }
      }

      &:active {
        background: ${palette.baseColors.alto};
      }

      &:focus-visible {
        & ${PositiveSignInPillIconSmall}, & ${InitialsPositiveCircleSmall} {
          box-shadow: none;
        }
        box-shadow:
          0 0 0 1px ${palette.baseColors.wairua},
          0 0 0 4px ${palette.baseColors.lupin};
      }
    }
  `}
`;
const ProfilePillReverse = styled(ProfilePillPositive) `
  ${({ theme: { palette, borderRadius, media, zIndex } }) => css `
    &:focus-visible {
      &
        ${PositiveSignInPillIconSmall},
        &
        ${InitialsPositiveCircleSmall},
        &
        ${ReverseSignInPillIconSmall} {
        box-shadow:
          0 0 0 3px ${palette.baseColors.moeraki},
          0 0 0 4px ${palette.baseColors.wairua};
      }
    }

    ${media.up('big')} {
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r3};
      background: none;

      transform-origin: center center;
      background-position: center;
      transition:
        background 0.2s,
        transform 0.2s;

      &:before {
        content: '';
        background: ${palette.baseColors.wairuaOpacity12};
        border-radius: inherit;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: ${zIndex.negative};
        transform: scale(0);

        transition: transform 0.2s;
      }

      &:hover {
        &:before {
          transform: scale(1);
        }
      }

      &:active {
        background: ${palette.baseColors.wairuaOpacity8};
      }

      &:focus-visible {
        & ${PositiveSignInPillIconSmall}, & ${InitialsPositiveCircleSmall} {
          box-shadow: none;
        }
        box-shadow:
          0 0 0 1px ${palette.baseColors.moeraki},
          0 0 0 2px ${palette.baseColors.wairua};
      }
    }
  `}
`;

const PillContentWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    gap: ${spacing.s1};
  `}
`;
const InitialsCircle = styled(InitialsCircle$1) `
  ${({ theme: { palette } }) => css `
    width: 40px;
    height: 40px;
    background: ${palette.baseColors.kiwi};
  `}
`;
const StyledChevronIcon = styled(Icon) `
  margin: 2px 0 0 2px;
`;
const ProfilePillContainer$2 = styled(ProfilePillPositive) `
  ${({ theme: { spacing, palette, zIndex, media, borderRadius } }) => css `
    ${media.up('big')} {
      padding-right: ${spacing.s1_5};
      border: 1px solid ${palette.baseColors.moeraki};
      border-radius: ${borderRadius.r3};
      position: relative;
      transform-origin: center center;
      background-position: center;
      transition:
        background 0.1s,
        transform scale(0);

      &:before {
        content: '';
        background: ${palette.baseColors.onepu};
        border-radius: inherit;
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: ${zIndex.negative};
        transform: scale(0);
        transition: transform 0.2s;
      }

      &:hover:before {
        transform: scale(1);
      }

      &:active {
        background: ${palette.baseColors.alto};
      }

      &:focus-visible {
        box-shadow:
          0 0 0 1px ${palette.baseColors.wairua},
          0 0 0 4px ${palette.baseColors.lupin};
      }
    }
  `}
`;
const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const TextWrapper = styled(Text) `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 104px;
  text-align: left;
`;
const ProfilePill$1 = forwardRef(({ userInfo, onProfilePillClicked, profileMenuPopped }, ref) => {
    const { palette: { baseColors: { mawheranui, newZealandBlack, kiwi }, }, } = useTheme();
    const isDesktop = useMediaQuery({ min: 'big' });
    const { firstName, lastName, role } = userInfo;
    return (React__default.createElement(ProfilePillContainer$2, { ref: ref, type: "button", onClick: onProfilePillClicked },
        React__default.createElement(PillContentWrapper, null,
            React__default.createElement(InitialsCircle, { size: "small", firstName: firstName, lastName: lastName, color: kiwi }),
            isDesktop ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(TitleContainer, null,
                    React__default.createElement(TextWrapper, { variant: "footnoteDemi", color: newZealandBlack }, `${firstName} ${lastName}`),
                    React__default.createElement(TextWrapper, { variant: "footnoteMedium", color: mawheranui }, role)),
                React__default.createElement(motion.div, { animate: { rotate: profileMenuPopped ? 180 : 0 }, transition: { duration: 0.3 } },
                    React__default.createElement(StyledChevronIcon, { name: "chevron_down_extra_small", size: 16, fill: newZealandBlack })))) : null)));
});

const MenuContainer$1 = styled.div `
  ${({ theme: { borderRadius, zIndex, elevation, palette, spacing } }) => css `
    background: ${palette.baseColors.wairua};
    position: fixed;
    right: ${spacing.s4};
    top: 80px;
    overflow: auto;
    margin: 0 auto;
    width: 292px;
    border-radius: ${borderRadius.r2};
    z-index: ${zIndex.modal};
    box-shadow: ${elevation.drawer};
    padding: ${spacing.s2};
    display: flex;
    flex-direction: column;
    gap: ${spacing.s1};
  `}
`;
const SectionContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const TitleSectionContainer = styled(SectionContainer) `
  ${({ theme: { spacing } }) => css `
    padding: 0 ${spacing.s2};
  `}
`;
const LinkSectionContainer = styled(SectionContainer) `
  ${({ theme: { spacing } }) => css `
    gap: ${spacing.s1};
  `}
`;
const ProfileMenuItem = styled.button `
  ${({ theme: { palette, borderRadius, spacing } }) => css `
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    border-radius: ${borderRadius.r1};
    text-decoration: none;
    width: 100%;
    align-items: center;
    border: none;
    background: none;
    padding: ${spacing.s1} ${spacing.s2};
    cursor: pointer;
    &:hover {
      background: ${palette.baseColors.alto};
    }
    &:focus-visible {
      border: 2px solid ${palette.baseColors.lupin};
    }
  `}
`;
const LinkSection = ({ linkComponent, menuItems, }) => {
    const { palette: { baseColors: { newZealandBlack }, }, } = useTheme();
    return (React__default.createElement(LinkSectionContainer, null, menuItems.map((item) => (React__default.createElement(ProfileMenuItem, { key: item.menuItemTitle, as: linkComponent, href: item.menuItemLink },
        React__default.createElement(Text, { variant: "footnoteMedium", color: newZealandBlack }, item.menuItemTitle))))));
};
const TitleSection = ({ organisationName, userInfo, }) => {
    const { palette: { baseColors: { mawheranui, newZealandBlack }, }, } = useTheme();
    const { firstName, lastName, role } = userInfo;
    return (React__default.createElement(TitleSectionContainer, null,
        React__default.createElement(Text, { variant: "footnoteMedium", color: mawheranui, mb: "s1" }, organisationName),
        React__default.createElement(Text, { variant: "footnoteMedium", color: newZealandBlack }, `${firstName} ${lastName}`),
        React__default.createElement(Text, { variant: "footnoteMedium", color: mawheranui }, role)));
};
const ProfileMenu$1 = ({ linkComponent, organisationName, userInfo, menuItems, }) => {
    const { palette: { baseColors: { alto }, }, } = useTheme();
    return (React__default.createElement(MenuContainer$1, null,
        React__default.createElement(TitleSection, { organisationName: organisationName, userInfo: userInfo }),
        React__default.createElement(Divider$1, { color: alto }),
        React__default.createElement(LinkSection, { linkComponent: linkComponent, menuItems: menuItems })));
};

const ActionLayerFeedbackContent = styled.div `
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;
const ActionLayerFeedbackMessage = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s4};
  `}
`;
const ActionLayerFeedbackButton = styled(Button$2) `
  ${({ theme: { spacing } }) => css `
    width: 100%;
    margin-bottom: ${spacing.s3};

    &:last-of-type {
      margin-bottom: 0;
    }
  `}
`;
const ActionLayerFeedback = styled(motion.div) `
  ${({ theme: { media, spacing } }) => css `
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: 0 ${spacing.s3} ${spacing.s6};

    ${media.up('slim')} {
      padding: 0 ${spacing.s4} ${spacing.s6};
    }

    ${media.up('big')} {
      padding: 0 ${spacing.s6} ${spacing.s6};
    }
  `}
`;

const ActionLayerErrorFeedback = styled(ActionLayerFeedback) `
  ${({ theme: { palette } }) => css `
    background: ${palette.baseColors.wairua};
  `}
`;
const IconCircleWrap = styled.div `
  ${({ theme: { palette, borderRadius, spacing } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    margin-bottom: ${spacing.s7};
    padding-bottom: 2px;
    border: 2px solid ${palette.baseColors.moeraki};
    border-radius: ${borderRadius.round};
  `}
`;
const ErrorFeedback = ({ title, description, onClose, label = 'Done', action, children, }) => {
    const { palette: { baseColors }, } = useTheme();
    return (React__default.createElement(ActionLayerErrorFeedback, null,
        React__default.createElement(ActionLayerFeedbackContent, null,
            React__default.createElement(IconCircleWrap, null,
                React__default.createElement(Icon, { name: "warning_large", fill: baseColors.sparkOrange })),
            React__default.createElement(ActionLayerFeedbackMessage, { variant: "headingS", color: baseColors.newZealandBlack }, title),
            React__default.createElement(Text, { variant: "bodySMedium", color: baseColors.newZealandBlack }, description),
            children),
        React__default.createElement("div", null,
            action ? (React__default.createElement(ActionLayerFeedbackButton, { variant: "primary", onClick: action.onAction }, action.label)) : null,
            React__default.createElement(ActionLayerFeedbackButton, { variant: "default", onClick: onClose }, label))));
};

const ActionLayerLoadingFeedbackContainer = styled(ActionLayerFeedback) `
  ${({ theme: { palette } }) => css `
    background: ${palette.baseColors.wairua};
  `}
`;
const LoadingSpinnerContainer = styled(Box) `
  ${({ theme: { spacing } }) => css `
    height: ${spacing.s7};
    width: ${spacing.s7};
  `}
`;
function LoadingFeedback({ children, title, description, }) {
    const { palette: { baseColors }, } = useTheme();
    return (React__default.createElement(ActionLayerLoadingFeedbackContainer, null,
        React__default.createElement(ActionLayerFeedbackContent, null,
            React__default.createElement(LoadingSpinnerContainer, { mb: "s7" },
                React__default.createElement(LoadingSpinner, { size: 64 })),
            React__default.createElement(ActionLayerFeedbackMessage, { variant: "headingS", color: baseColors.newZealandBlack }, title),
            React__default.createElement(Text, { variant: "bodySMedium", color: baseColors.newZealandBlack }, description),
            children)));
}

const BreadcrumbText$1 = styled(Text) `
  white-space: nowrap;
`;
const ChevronIcon = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    width: 16px;
    height: 16px;
    margin: 0 ${spacing.s1};
  `}
`;
function PreviousBreadcrumbTextLink({ children, onClick, }) {
    const { palette } = useTheme();
    return (React__default.createElement(Button$2, { variant: "textbutton", onClick: onClick },
        React__default.createElement(BreadcrumbText$1, { variant: "footnoteMedium", color: palette.baseColors.greymouth }, children)));
}
const Breadcrumb$1 = ({ activeIndex, index, isLastSection, onClick, section, }) => {
    const { palette: { baseColors: { moeraki, poroporo }, }, } = useTheme();
    const isActiveSection = index === activeIndex;
    const color = isActiveSection ? poroporo : moeraki;
    const isPreviousSection = index < activeIndex;
    const handleClick = () => {
        onClick({ section });
    };
    return (React__default.createElement(Box, { flexDirection: "row", alignItems: "center" },
        isPreviousSection ? (React__default.createElement(PreviousBreadcrumbTextLink, { onClick: handleClick }, section.name)) : (React__default.createElement(BreadcrumbText$1, { variant: "footnoteMedium", color: color }, section.name)),
        !isLastSection ? (React__default.createElement(ChevronIcon, { name: "chevron_right_small", fill: moeraki })) : null));
};
const Breadcrumbs$1 = ({ activeSectionId, onClick, sections, }) => {
    const visibleSections = sections.filter((section) => !section.hideBreadCrumb);
    const activeIndex = visibleSections.findIndex((section) => {
        return section.sectionId === activeSectionId;
    }) || 0;
    return (React__default.createElement(Box, { px: ['s3', 's4', 's6'], pb: ['s3', 's4', 's4'], pt: "s1", flexDirection: "row", alignItems: "center" }, visibleSections.map((section, index) => {
        return (React__default.createElement(Breadcrumb$1, { activeIndex: activeIndex, index: index, onClick: onClick, section: section, key: section.sectionId, isLastSection: index >= visibleSections.length - 1 }));
    })));
};

const StyledProgressBar = styled(ProgressBar) `
  div {
    border-radius: 0;
    top: 0;
    height: 3px;
  }
`;
const getProgressionIndicatorValues = ({ activeSectionId, activeStepId, sections, progressionThreshold, }) => {
    const currentSection = sections.find((section) => section.sectionId === activeSectionId) ||
        sections[0];
    const allSteps = sections
        .map(({ sectionId, steps }) => steps.map(({ stepId }) => `${sectionId}/${stepId}`))
        .flat();
    const currentStepIndex = activeStepId
        ? allSteps.findIndex((stepPath) => stepPath === `${activeSectionId}/${activeStepId}`)
        : allSteps.findIndex((stepPath) => stepPath.startsWith(activeSectionId));
    const progressPercentage = (currentStepIndex / allSteps.length) * 100;
    if (progressPercentage <= 0) {
        return { currentSection, progressPercentage: progressionThreshold };
    }
    return { currentSection, progressPercentage };
};
const ProgressIndicator = ({ activeSectionId, activeStepId, sections, onClick: handleClick, progressionThreshold, }) => {
    const { palette } = useTheme();
    const { progressPercentage } = getProgressionIndicatorValues({
        activeSectionId,
        activeStepId,
        sections,
        progressionThreshold,
    });
    return (React__default.createElement("div", null,
        React__default.createElement(Breadcrumbs$1, { activeSectionId: activeSectionId, sections: sections, onClick: handleClick }),
        React__default.createElement(StyledProgressBar, { animationDirection: "leftToRight", color: palette.baseColors.poroporo, isAnimationDisabled: true, progressPercentage: progressPercentage })));
};

const getDimensions = () => ({
    width: window.innerWidth,
    height: window.innerHeight,
});
const useDimensions = () => {
    const [windowWidth, setWindowWidth] = useState(0);
    const [windowHeight, setWindowHeight] = useState(0);
    useEffect(() => {
        const setWindowDimensions = () => {
            const { width, height } = getDimensions();
            setWindowWidth(width);
            setWindowHeight(height);
        };
        setWindowDimensions();
        window.addEventListener('resize', setWindowDimensions);
        return () => window.removeEventListener('resize', setWindowDimensions);
    }, []);
    return { windowWidth, windowHeight };
};

const SuccessContainer = styled.div `
  ${({ theme: { borderRadius, elevation, spacing } }) => css `
    margin-bottom: ${spacing.s7};
    border-radius: ${borderRadius.round};
    box-shadow: ${elevation.elevation2};
    position: relative;
    height: 80px;
    width: 80px;
  `}
`;
const SuccessCircle = styled.div `
  position: absolute;
`;
const SuccessTick = styled.div `
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SuccessIcon = () => {
    const { palette: { baseColors: { sparkPurple }, }, } = useTheme();
    return (React__default.createElement(SuccessContainer, null,
        React__default.createElement(SuccessCircle, null,
            React__default.createElement(Icon, { name: "success_circle", size: 80 })),
        React__default.createElement(SuccessTick, null,
            React__default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React__default.createElement(motion.path, { initial: { pathLength: 0 }, animate: { pathLength: 1 }, transition: {
                        delay: 0.4,
                        duration: 0.4,
                        ease: 'easeInOut',
                        type: 'tween',
                    }, d: "M6 17 14 24.5 28 8", stroke: sparkPurple, strokeWidth: 2, strokeLinecap: "round" })))));
};

const ActionLayerSuccessFeedback = styled(ActionLayerFeedback) `
  ${({ theme: { palette } }) => css `
    background: ${palette.baseColors.sparkPurple};
  `}
`;
const successTransitionProps = {
    duration: 0.6,
    ease: [0.41, 0, 0.175, 1],
    type: 'tween',
};
const SuccessFeedback = ({ title, description, footer: Footer = null, onClose, label = 'Done', action, children, }) => {
    const [actionLayerMidpoint, setActionLayerMidpoint] = useState(0);
    const { windowWidth, windowHeight } = useDimensions();
    const containerRef = useRef(null);
    const { palette: { baseColors }, } = useTheme();
    useEffect(() => {
        var _a, _b;
        const containerWidth = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0;
        setActionLayerMidpoint(containerWidth / 2);
    }, [windowWidth]);
    const closedClipPath = `circle(10px at ${actionLayerMidpoint}px ${windowHeight}px)`;
    const openClipPath = `circle(${Math.hypot(actionLayerMidpoint, windowHeight)}px at ${actionLayerMidpoint}px ${windowHeight}px)`;
    return (React__default.createElement("div", { ref: containerRef, "aria-label": title }, actionLayerMidpoint > 0 ? (React__default.createElement(ActionLayerSuccessFeedback, { initial: {
            clipPath: closedClipPath,
        }, animate: {
            clipPath: openClipPath,
        }, transition: successTransitionProps },
        React__default.createElement(ActionLayerFeedbackContent, null,
            React__default.createElement(motion.div, { animate: {
                    opacity: 1,
                    y: 0,
                }, initial: {
                    opacity: 0,
                    y: 20,
                }, transition: Object.assign({ delay: 0.4 }, successTransitionProps) },
                React__default.createElement(SuccessIcon, null)),
            React__default.createElement(motion.div, { animate: {
                    opacity: 1,
                    y: 0,
                }, initial: {
                    opacity: 0,
                    y: 20,
                }, transition: Object.assign({ delay: 0.2 }, successTransitionProps) },
                React__default.createElement(ActionLayerFeedbackMessage, { variant: "headingS", color: baseColors.wairua }, title),
                React__default.createElement(Text, { variant: "bodySMedium", color: baseColors.wairua }, description),
                children)),
        React__default.createElement(motion.div, { animate: {
                opacity: 1,
            }, initial: {
                opacity: 0,
            }, transition: {
                delay: 0.2,
                duration: 0.2,
                ease: 'easeInOut',
                type: 'tween',
            } },
            action ? (React__default.createElement(ActionLayerFeedbackButton, { variant: "primary", onClick: action.onAction }, action.label)) : null,
            React__default.createElement(ActionLayerFeedbackButton, { variant: "default", onClick: onClose }, label),
            Footer))) : null));
};

const UnderlineContainer = styled.div `
  display: flex;
  width: 100%;
`;
const Line = styled.div `
  height: 3px;
  flex: 1;
`;
const Line1 = styled(Line) `
  background: ${({ theme: { palette } }) => palette.baseColors.sparkGreen};
`;
const Line2 = styled(Line) `
  flex: 1;
  background: ${({ theme: { palette } }) => palette.baseColors.kowhai};
`;
const Line3 = styled(Line) `
  flex: 1;
  background: ${({ theme: { palette } }) => palette.baseColors.sparkPink};
`;
const Line4 = styled(Line) `
  flex: 2.6;
  background: ${({ theme: { palette } }) => palette.baseColors.lupin};
`;
const Underline$1 = () => {
    return (React__default.createElement(UnderlineContainer, null,
        React__default.createElement(Line1, null),
        React__default.createElement(Line2, null),
        React__default.createElement(Line3, null),
        React__default.createElement(Line4, null)));
};

const panel = {
    animate: { x: 0 },
    initial: { x: -500 },
    exit: { x: -500 },
};
const slimPanel = {
    animate: { x: 400 },
    exit: { x: -500 },
    initial: { x: -500 },
};
const bigPanel = {
    animate: { x: 456 },
    exit: { x: -500 },
    initial: { x: -500 },
};
const overlayAnimationValues = {
    animate: { opacity: 0.64 },
    exit: { opacity: 0 },
    initial: { opacity: 0 },
};
const DrawerOverlay = styled(motion.div) `
  ${({ theme: { palette, zIndex } }) => css `
    background: ${palette.baseColors.newZealandBlack};
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${zIndex.overlay};
  `}
`;
const DrawerPanel = styled(motion.div) `
  ${({ theme: { media, zIndex, elevation, palette }, isNested, variant, hasScrollBar = true, }) => css `
    background: ${palette.baseColors.wairua};
    position: fixed;
    left: 0;
    top: 0;
    overflow: auto;
    margin: 0 auto;
    height: 100%;
    width: 100%;
    z-index: ${zIndex.modal};
    box-shadow: ${elevation.drawer};

    ${variant === 'search' &&
    css `
      height: auto;
      z-index: ${zIndex.overlay};
    `}
    ${variant === 'action' &&
    css `
      ${media.up('slim')} {
        width: 400px;
      }

      ${media.up('big')} {
        width: 456px;
      }
    `}

    ${variant === 'content' &&
    css `
      background: ${palette.baseColors.wairua};

      ${media.up('slim')} {
        width: ${'80%'};
      }

      ${media.up('big')} {
        width: ${'66%'};
      }
    `}

    ${variant === 'information' &&
    css `
      background: ${palette.baseColors.onepu};
      z-index: ${isNested
        ? zIndex.aboveModal
        : zIndex.modal}; // special case for z-index. Should show on top of previous action layers if small screen

      ${media.up('slim')} {
        width: 348px;
        z-index: ${isNested
        ? zIndex.belowModal
        : zIndex.modal}; // special case for z-index. needs to be lower than modal but higher than overlay
      }
    `}

    ${!hasScrollBar &&
    css `
      -ms-overflow-style: none; /* IE 10+ */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }
    `}
  `}
`;
const Transition = { bounce: 0 };
function getPanelAnimationValues(isSlim, isBig) {
    if (isBig) {
        return bigPanel;
    }
    if (isSlim) {
        return slimPanel;
    }
    return panel;
}
const DrawerContent = styled.div `
  ${({ theme: { spacing, media } }) => css `
    padding: 0 ${spacing.s3};

    ${media.up('slim')} {
      padding: 0 ${spacing.s4};
    }

    ${media.up('big')} {
      padding: 0 ${spacing.s6};
    }
  `}
`;
function Drawer({ children, isNested, isOpen, onOpen, onClose, hasScrollBar, showOverlay = false, variant = 'action', hasInitialAnimation = true, }) {
    const isSlim = useMediaQuery({ min: 'slim' });
    const isBig = useMediaQuery({ min: 'big' });
    const panelAnimationValues = isNested
        ? getPanelAnimationValues(isSlim, isBig)
        : panel;
    const handleKeydown = (event) => {
        if (event.key === 'Escape') {
            handleClose(); // eslint-disable-line @typescript-eslint/no-use-before-define
        }
    };
    function handleOpen() {
        if (showOverlay)
            document.body.style.overflowY = 'hidden';
        window.addEventListener('keydown', handleKeydown);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }
    function handleClose() {
        if (showOverlay)
            document.body.style.overflowY = 'initial';
        if (isOpen) {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
        else {
            window.removeEventListener('keydown', handleKeydown);
        }
    }
    // when isOpen changes, call handleOpen or handleClose
    useEffect(() => {
        if (isOpen) {
            handleOpen();
        }
        else {
            handleClose();
        }
        // Ensure keydown listener and scroll lock are removed on unmount
        return () => {
            document.body.style.overflowY = 'initial';
            window.removeEventListener('keydown', handleKeydown);
        };
    }, [isOpen]);
    return (React__default.createElement(AnimatedComponent, { initial: hasInitialAnimation },
        isOpen && showOverlay ? (React__default.createElement(DrawerOverlay, Object.assign({ key: "drawerOverlay", "data-testid": "drawer-overlay" }, overlayAnimationValues, { onClick: onClose }))) : null,
        isOpen ? (React__default.createElement(DrawerPanel, Object.assign({ key: "drawerPanel", variant: variant }, panelAnimationValues, { transition: Transition, isNested: isNested, hasScrollBar: hasScrollBar, role: "dialog", "aria-label": "drawer panel", "aria-modal": "true" }), children)) : null));
}

const ActionLayerTitleContainer = styled.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
`;
const ActionLayerSubtitleContainer = styled.div `
  ${({ subtitle, theme: { media, spacing } }) => css `
    margin-top: ${subtitle ? spacing.s2 : 0};
    width: 80%;
    ${media.up('lil')} {
      width: 100%;
    }
  `};
`;
const ActionHeader = styled.div `
  ${({ theme: { spacing, media } }) => css `
    ${media.down('lil')} {
      padding: ${spacing.s3};
    }

    ${media.up('slim')} {
      padding: ${spacing.s4};
    }

    ${media.up('big')} {
      padding: ${spacing.s4} ${spacing.s6};
    }
  `}
`;
const ActionLayerWithLogo = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    height: 80px;
    align-items: center;
    justify-content: space-between;
    padding: ${spacing.s4};
  `}
`;
const ActionTitle = styled(Text) `
  width: 80%;
`;
function ActionLayer({ isOpen, title, subtitle = null, status, errorFeedbackProps = { title: '', description: '' }, loadingFeedbackProps = { title: '', description: '' }, successFeedbackProps = { title: '', description: '' }, onOpen, onClose, hasScrollBar, children, hasLogo, progressIndicatorProps, }) {
    var _a, _b;
    const isSubtitleOfTypeString = typeof subtitle === 'string';
    const { palette } = useTheme();
    useEffect(() => {
        var _a, _b;
        if (status === 'success') {
            (_a = successFeedbackProps.onOpen) === null || _a === void 0 ? void 0 : _a.call(successFeedbackProps);
        }
        else if (status === 'error') {
            (_b = errorFeedbackProps.onOpen) === null || _b === void 0 ? void 0 : _b.call(errorFeedbackProps);
        }
    }, [status]);
    return (React__default.createElement(Drawer, { isOpen: isOpen, onClose: onClose, onOpen: onOpen, hasScrollBar: hasScrollBar, showOverlay: true, variant: "action" },
        status === 'success' ? (React__default.createElement(SuccessFeedback, { title: successFeedbackProps.title, description: successFeedbackProps.description, action: successFeedbackProps === null || successFeedbackProps === void 0 ? void 0 : successFeedbackProps.action, footer: successFeedbackProps === null || successFeedbackProps === void 0 ? void 0 : successFeedbackProps.footer, onClose: (_a = successFeedbackProps === null || successFeedbackProps === void 0 ? void 0 : successFeedbackProps.onClose) !== null && _a !== void 0 ? _a : onClose, label: successFeedbackProps === null || successFeedbackProps === void 0 ? void 0 : successFeedbackProps.label }, successFeedbackProps.children)) : null,
        status === 'error' ? (React__default.createElement(ErrorFeedback, { title: errorFeedbackProps.title, description: errorFeedbackProps.description, action: errorFeedbackProps === null || errorFeedbackProps === void 0 ? void 0 : errorFeedbackProps.action, onClose: (_b = errorFeedbackProps === null || errorFeedbackProps === void 0 ? void 0 : errorFeedbackProps.onClose) !== null && _b !== void 0 ? _b : onClose, label: errorFeedbackProps === null || errorFeedbackProps === void 0 ? void 0 : errorFeedbackProps.label }, errorFeedbackProps.children)) : null,
        status === 'loading' ? (React__default.createElement(LoadingFeedback, { title: loadingFeedbackProps.title, description: loadingFeedbackProps.description }, loadingFeedbackProps.children)) : null,
        status === 'default' ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ActionHeader, null,
                React__default.createElement(ActionLayerTitleContainer, null,
                    React__default.createElement(ActionTitle, { variant: "subheadingM", color: palette.baseColors.newZealandBlack }, title),
                    React__default.createElement(IconButton$5, { onClick: onClose, title: "close", icon: "cross_small", variant: "secondary" })),
                subtitle ? (React__default.createElement(ActionLayerSubtitleContainer, { subtitle: subtitle },
                    isSubtitleOfTypeString ? (React__default.createElement(Text, { variant: "footnoteDemi", color: palette.baseColors.mawheranui }, subtitle)) : null,
                    !isSubtitleOfTypeString ? subtitle : null)) : null),
            progressIndicatorProps ? (React__default.createElement(ProgressIndicator, Object.assign({}, progressIndicatorProps))) : (React__default.createElement(Underline$1, null)),
            React__default.createElement(DrawerContent, null, children))) : null,
        hasLogo ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(ActionLayerWithLogo, null,
                React__default.createElement(Logo, null),
                React__default.createElement(IconButton$5, { onClick: onClose, title: "close", icon: "cross_extra_small", variant: "default" })),
            React__default.createElement(Divider$1, null),
            React__default.createElement(DrawerContent, null, children))) : null));
}

const LayerContainer = styled.div `
  ${({ theme: { spacing, media } }) => css `
    padding: ${spacing.s2} ${spacing.s3};

    ${media.up('slim')} {
      padding: ${spacing.s3} ${spacing.s4};
    }

    ${media.up('big')} {
      padding: ${spacing.s3} ${spacing.s6};
    }
  `}
`;
const LayerHeader = styled.div `
  ${({ theme: { spacing, media } }) => css `
    margin-bottom: ${spacing.s5};

    ${media.up('slim')} {
      margin-bottom: ${spacing.s6};
    }

    ${media.up('big')} {
      margin-bottom: ${spacing.s7};
    }
  `}
`;
const Title$1 = styled(Text) `
  ${({ theme: { spacing, media } }) => css `
    margin-bottom: ${spacing.s2};

    ${media.up('slim')} {
      margin-bottom: ${spacing.s3};
    }

    ${media.up('big')} {
      margin-bottom: ${spacing.s4};
    }
  `}
`;

const InformationLayerTitle = ({ children, }) => {
    return React__default.createElement(Title$1, { variant: "subheadingM" }, children);
};
const InformationLayer = ({ isNested, isOpen, onOpen, onClose, children, dynamicTargetValue = '', }) => {
    const componentName = 'Information Layer';
    return (React__default.createElement(Drawer, { isNested: isNested, isOpen: isOpen, onOpen: onOpen, onClose: onClose, showOverlay: true, variant: "information", "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(LayerContainer, null,
            React__default.createElement(LayerHeader, null,
                React__default.createElement(IconButton$5, { onClick: onClose, icon: "chevron_left_small", title: "back", variant: "secondary", type: "button" })),
            children)));
};

const NOTCH_HEIGHT = '63px';
const THICKNESS = '3px';
const NOTCH_WIDTH = '300px';
const Stripe = styled.div `
  ${({ theme: { palette } }) => css `
    background: linear-gradient(
      to right,
      ${palette.baseColors.sparkPurple} 0vw,
      ${palette.baseColors.sparkPurple} 50vw,
      ${palette.baseColors.kiwi} 50vw,
      ${palette.baseColors.kiwi} 100vw
    );
  `}
`;
const FullScreenContainer = styled.div `
  ${({ zIndex, theme: { zIndex: zIndexTheme } }) => css `
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 0;
    z-index: ${zIndex !== null && zIndex !== void 0 ? zIndex : zIndexTheme.modal};
  `}
`;
const RotateIcon = styled(Icon) ``;
const NotchButtonBar = styled.div `
  display: flex;
  align-items: center;
  height: 0;
`;
const NotchButton = styled(Button$2) `
  ${({ isCurrentlyOpen, theme: { spacing, elevation, palette } }) => css `
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    top: calc(-${NOTCH_HEIGHT} - ${THICKNESS});
    background-clip: padding-box;
    height: calc(${NOTCH_HEIGHT} + ${THICKNESS} * 2);
    padding: ${spacing.s2};
    width: ${NOTCH_WIDTH};
    background-color: white;
    box-shadow: ${isCurrentlyOpen ? 'none' : elevation.menuDropdown};

    &,
    &:focus-visible {
      margin: 0 auto;
      border-radius: ${spacing.s2} ${spacing.s2} 0 0;
      border: solid ${THICKNESS} transparent;
      border-bottom-width: 0;
    }

    &:focus-visible > * {
      border: 1px dotted ${palette.baseColors.greyLynn};
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: -1;
      margin: -${THICKNESS} -${THICKNESS} 0 -${THICKNESS};
      border-radius: inherit;
      background: linear-gradient(
        to right,
        ${palette.baseColors.sparkPurple} 0%,
        ${palette.baseColors.sparkPurple} 40%,
        ${palette.baseColors.sparkPink} 40%,
        ${palette.baseColors.sparkPink} 60%,
        ${palette.baseColors.sparkOrange} 60%,
        ${palette.baseColors.sparkOrange} 80%,
        ${palette.baseColors.kiwi} 80%,
        ${palette.baseColors.kiwi} 100%
      );
    }
    ${RotateIcon} {
      rotate: ${isCurrentlyOpen ? '180deg' : 0};
      transition: rotate 0.2s;
    }
  `}
`;
const NotchContent = styled(motion.div) `
  ${({ isCurrentlyOpen }) => css `
    background-color: white;
    display: grid;
    grid-template-rows: ${THICKNESS} ${isCurrentlyOpen ? '1fr' : '0fr'};
    transition: grid-template-rows 500ms;
    & > div {
      overflow: hidden;
    }
  `}
`;
const NotchContainer = styled.div `
  position: fixed;
  bottom: -${THICKNESS};
  width: 100%;
`;
const NotchText = styled.div `
  flex-grow: 1;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const TextWithOverflow = styled(Text) `
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: calc(${NOTCH_WIDTH} - 65px);
`;
const Backdrop = styled.div `
  ${({ isCurrentlyOpen }) => css `
    position: fixed;
    background-color: black;
    opacity: ${isCurrentlyOpen ? 0.6 : 0};
    pointer-events: ${isCurrentlyOpen ? 'auto' : 'none'};
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    transition: opacity 500ms;
  `}
`;
const Notch = ({ isPending, isOpen, onClose, children, onClick, text1, text2, zIndex, }) => {
    const { palette: { baseColors }, } = useTheme();
    return (React__default.createElement(FullScreenContainer, { zIndex: zIndex },
        React__default.createElement(Backdrop, { isCurrentlyOpen: isOpen, onClick: onClose }),
        React__default.createElement(NotchContainer, { id: "notch" },
            React__default.createElement(NotchButtonBar, null,
                React__default.createElement(NotchButton, { type: "button", variant: "textbutton", isCurrentlyOpen: isOpen, onClick: onClick, rightContent: React__default.createElement(RotateIcon, { fill: baseColors.newZealandBlack, name: "chevron_down_extra_small" }), leftContent: isPending ? React__default.createElement(LoadingSpinner, null) : React__default.createElement("span", null) },
                    React__default.createElement(NotchText, null,
                        typeof text1 === 'string' ? (React__default.createElement(TextWithOverflow, { variant: "bodySDemi", mb: 0, title: text1 }, text1)) : (text1),
                        typeof text2 === 'string' ? (React__default.createElement(TextWithOverflow, { variant: "footnoteMedium", mb: 0, title: text2 }, text2)) : (text2)))),
            React__default.createElement(NotchContent, { "aria-hidden": !isOpen, isCurrentlyOpen: isOpen, animate: isOpen ? 'open' : 'closed', variants: {
                    open: { visibility: 'visible' },
                    closed: {
                        animationDelay: '500ms',
                        transitionEnd: { visibility: 'hidden' },
                    },
                } },
                React__default.createElement(Stripe, null),
                React__default.createElement("div", null, children)))));
};

const ContentLayerTitle = ({ children }) => {
    return React__default.createElement(Title$1, { variant: "subheadingM" }, children);
};
const ContentLayer = ({ isOpen, onOpen, onClose, children, dynamicTargetValue = '', }) => {
    const componentName = 'Content Layer';
    return (React__default.createElement(Drawer, { isOpen: isOpen, onOpen: onOpen, onClose: onClose, showOverlay: true, variant: "content", "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(LayerContainer, null,
            React__default.createElement(LayerHeader, null,
                React__default.createElement(IconButton$5, { onClick: onClose, icon: "cross_small", title: "close", variant: "secondary", type: "button" })),
            children)));
};

const StyledOverlay = styled(DialogOverlay) `
  ${({ theme: { palette, zIndex } }) => css `
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${palette.baseColors.newZealandBlackOpacity64};
    z-index: ${zIndex.modal};
  `}
`;
const StyledDialog = styled(DialogContent) `
  ${({ theme: { borderRadius, media, palette, spacing } }) => css `
    background-color: ${palette.baseColors.wairua};
    border-radius: ${borderRadius.r2};
    padding: ${spacing.s5} ${spacing.s4} ${spacing.s4};
    position: relative;
    width: auto;
    margin: 0;

    ${media.up('big')} {
      padding: ${spacing.s6} ${spacing.s6} ${spacing.s5};
    }
  `}
`;
const CloseButtonWrapper = styled.div `
  ${({ theme: { media } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    position: absolute;
    right: 24px;
    top: 24px;
    border: none;

    ${media.up('slim')} {
      right: -72px;
      top: 0;
    }
  `}
`;
const CloseButton = ({ onClose }) => {
    const { palette: { baseColors: { lupin }, }, } = useTheme();
    const isLil = useMediaQuery({ max: 'lil' });
    return (React__default.createElement(CloseButtonWrapper, { onClick: onClose, title: "Close", "aria-label": "Close" }, isLil ? (React__default.createElement(Icon, { name: "cross_small", fill: lupin })) : (React__default.createElement(IconButton$5, { onClick: onClose, title: "close", icon: "cross_small", variant: "secondary" }))));
};
const Modal = ({ children, onClose, isOpen, showCloseButton, }) => {
    return (React__default.createElement(StyledOverlay, { isOpen: Boolean(isOpen), onDismiss: onClose },
        React__default.createElement(StyledDialog, { "aria-label": "modal-dialog" },
            showCloseButton ? React__default.createElement(CloseButton, { onClose: onClose }) : null,
            children)));
};

const AccordionWrapper = styled(Accordion$1) `
  border: none;
  transition: all 0.3s ease-in-out;
`;
const accordionIconMixin$1 = (placement) => {
    return css `
    ${({ theme: { palette } }) => css `
      background-color: ${palette.baseColors.lupin};
      height: ${placement === 'vertical' ? '12px' : '2px'};
      width: ${placement === 'vertical' ? '2px' : '12px'};
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      transform: rotate(0deg);
      transition: 0.3s all ease-in-out;
    `}
  `;
};
const AccordionHorizontalLine$1 = styled.div `
  ${accordionIconMixin$1('horizontal')};
`;
const AccordionVerticalLine$1 = styled.div `
  ${accordionIconMixin$1('vertical')};
  ${({ isOpen }) => isOpen &&
    css `
      transform: rotate(90deg);
    `}
`;
const CustomizedIcon$1 = styled(Icon) `
  ${({ theme: { palette }, color, isOpen }) => css `
    fill: ${color || palette.baseColors.lupin};

    & path {
      fill: ${color || palette.baseColors.lupin};
    }
    & text {
      fill: ${color || palette.baseColors.lupin};
    }
    margin: auto;
    ${isOpen && 'transform: rotate(180deg);'};
    transition: 0.3s all ease-in-out;
  `}
`;
const StyledAccordionItem$1 = styled(AccordionItem$1) `
  ${({ theme: { palette }, $isOpen, $disableBorder }) => css `
    background: ${palette.baseColors.wairua};
    border-bottom: ${$disableBorder
    ? 'none'
    : `1px solid ${palette.baseColors.alto}`};
    width: 100%;

    ${AccordionVerticalLine$1}:not([data-isolated='true']) {
      ${$isOpen
    ? css `
            transform: rotate(90deg);
          `
    : null}
    }

    ${CustomizedIcon$1}:not([data-isolated='true']) {
      ${$isOpen
    ? css `
            transform: rotate(180deg);
          `
    : null}
    }
  `};
`;
// prevent styled-components from passing `isOpen` thru
const AccordionItem = (_a) => {
    var { isOpen, disableBorder } = _a, props = __rest(_a, ["isOpen", "disableBorder"]);
    return (React__default.createElement(StyledAccordionItem$1, Object.assign({}, props, { "$isOpen": isOpen, "$disableBorder": disableBorder })));
};
const StyledAccordionItemButton = styled(AccordionItemButton) `
  ${({ theme: { media, spacing, palette, borderRadius } }) => css `
    padding: ${spacing.s2} 0;
    color: ${palette.baseColors.newZealandBlack};
    width: 100%;
    ${subheadingMStyle}
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      border-radius: ${borderRadius.rHalf};
    }

    ${media.up('slim')} {
      padding: ${spacing.s3} 0;
    }
  `};
`;
const AccordionTitle = styled.p `
  ${subheadingMStyle}
  margin: unset;
`;
const AccordionItemBody = styled(motion.section) `
  ${({ theme: { spacing, palette } }) => css `
    padding: 0 0 ${spacing.s2} 0;
    background: ${palette.baseColors.wairua};
    animation: all 0.3s ease-in;
    color: ${palette.baseColors.mawheranui};
    ${bodySMediumStyle};
    margin-top: ${spacing.s1};
  `};
`;
const AccordionIcon = styled.div `
  ${({ theme: { borderRadius, palette } }) => css `
    height: 32px;
    width: 32px;
    border-radius: ${borderRadius.round};
    border: 2px solid ${palette.baseColors.lupin};
    display: flex;
    position: relative;
    padding: 14px; // 16px padding with -2px offset of the border;
    cursor: pointer;
    background-color: ${palette.baseColors.wairua};
    flex-shrink: 0;
    align-self: baseline;
    &:hover {
      background-color: ${palette.baseColors.pukaki};
    }
  `}
`;
const IconButton$1 = styled.button `
  ${({ theme: { palette } }) => css `
    display: flex;
    border: none;
    color: ${palette.baseColors.lupin};
    background-color: transparent;
    position: relative;
    cursor: pointer;
  `}
`;
const AccordionItemHeading = ({ children, dynamicTargetValue = '', className, }) => {
    return (React__default.createElement(StyledAccordionItemButton, { "data-target-component-id": dynamicTargetValue
            ? `AccordionHeading-${dynamicTargetValue}`
            : 'AccordionHeading', className: className }, children));
};
const AccordionButton = ({ onChange, iconSize, iconColor, iconName, isOpen, tabIndex, }) => {
    return (React__default.createElement(React__default.Fragment, null, iconName ? (React__default.createElement(IconButton$1, { onClick: onChange, "data-testid": "customized-button-icon", tabIndex: tabIndex },
        React__default.createElement(CustomizedIcon$1, Object.assign({}, (isOpen !== undefined && { isOpen, 'data-isolated': true }), { name: iconName, size: iconSize || 24, color: iconColor })))) : (React__default.createElement(AccordionIcon, { onClick: onChange, tabIndex: tabIndex },
        React__default.createElement(AccordionVerticalLine$1, Object.assign({}, (isOpen !== undefined && { isOpen, 'data-isolated': true }))),
        React__default.createElement(AccordionHorizontalLine$1, null)))));
};
const AccordionItemBodyWithAnimation = ({ children, isOpen, className }) => {
    return (React__default.createElement(AnimatedComponent, { initial: false }, isOpen ? (React__default.createElement(AccordionItemBody, { initial: "collapsed", animate: "open", exit: "collapsed", className: className, variants: {
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
        }, transition: { duration: 0.2 } },
        React__default.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { delay: 0.2 } }, children))) : null));
};
const Accordion = ({ children, allowMultipleExpanded, expandedItems, onChange, className, dynamicTargetValue = '', }) => {
    const componentName = 'Accordion';
    return (React__default.createElement(AccordionWrapper, { className: className, allowMultipleExpanded: allowMultipleExpanded, allowZeroExpanded: true, preExpanded: expandedItems, onChange: onChange, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" }, children));
};

function isSSR() {
    return typeof window === 'undefined';
}

const SwipeableBottomSheetContainer = styled.div `
  ${({ theme: { borderRadius } }) => css `
    .react-swipeable-view-container {
      border-radius: ${borderRadius.r2};
      box-shadow: none !important;
    }
  `}
`;
const Content = styled.div `
  ${({ theme: { spacing, palette } }) => css `
    padding-top: ${spacing.s2};
    background: ${palette.baseColors.wairua};
  `}
`;
const Handle = styled.div `
  ${({ theme: { palette: { baseColors }, borderRadius, spacing, }, }) => css `
    width: 48px;
    height: 6px;
    background: ${baseColors.alto};
    border-radius: ${borderRadius.rHalf};
    margin: 0 auto ${spacing.s2} auto;
  `}
`;
const BottomSheet = ({ isOpen, onClose, children, zIndex, }) => {
    const { borderRadius, palette: { baseColors }, } = useTheme();
    if (isSSR()) {
        return null;
    }
    return (React__default.createElement(SwipeableBottomSheetContainer, null,
        React__default.createElement(SwipeableBottomSheet, { overflowHeight: 0, open: isOpen, style: { zIndex }, bodyStyle: {
                borderTopLeftRadius: borderRadius.r2,
                borderTopRightRadius: borderRadius.r2,
            }, overlayStyle: isOpen
                ? {
                    backgroundColor: baseColors.newZealandBlack,
                    opacity: 0.6,
                }
                : null, onChange: (open) => {
                if (!open) {
                    onClose();
                }
            } },
            React__default.createElement(Content, null,
                React__default.createElement(Handle, null),
                children))));
};

const Container$5 = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    padding: ${spacing.s0_5};
    white-space: nowrap;
    overflow: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    & > * {
      padding: 0 2px;
    }
  `}
`;
const Separator = styled(Text) `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.mawheranui};
  `}
`;
const Breadcrumbs = ({ children }) => {
    const lastBreadcrumbIndex = React__default.Children.count(children) - 1;
    const separatedBreadcrumbs = React__default.Children.map(children, (child, index) => (React__default.createElement(React__default.Fragment, null,
        child,
        index !== lastBreadcrumbIndex ? (React__default.createElement(Separator, { variant: "footnoteMedium" }, "/")) : null)));
    return React__default.createElement(Container$5, null, separatedBreadcrumbs);
};

const BreadcrumbText = styled(Text) `
  ${({ theme: { palette }, isLastBreadcrumb }) => css `
    color: ${isLastBreadcrumb
    ? palette.baseColors.poroporo
    : palette.baseColors.greymouth};
    transition: color 100ms ease-in-out;
  `}
`;
const BreadcrumbLink = styled.a `
  ${({ theme: { borderRadius, palette } }) => css `
    border-radius: ${borderRadius.rHalf};
    text-decoration: none;
    transition: all 100ms ease-in-out;

    &:focus-visible {
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }

    &:hover {
      & > ${BreadcrumbText} {
        color: ${palette.baseColors.lupin};
      }
    }

    &:active {
      & > ${BreadcrumbText} {
        color: ${palette.baseColors.sparkPurple};
      }
    }
  `}
`;
const Breadcrumb = React__default.forwardRef((_a, ref) => {
    var { children, isLastBreadcrumb, component } = _a, anchorProps = __rest(_a, ["children", "isLastBreadcrumb", "component"]);
    return (React__default.createElement(BreadcrumbLink, Object.assign({ ref: ref }, anchorProps, { as: component }),
        React__default.createElement(BreadcrumbText, { variant: "footnoteMedium", isLastBreadcrumb: isLastBreadcrumb }, children)));
});

const NavButton = styled.button `
  ${({ theme: { borderRadius, palette, spacing, zIndex }, variant }) => css `
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
    border-radius: ${borderRadius.round};
    padding: ${spacing.s1};
    transition: transform 0.2s;

    &:before {
      content: '';
      background: ${variant === 'reverse'
    ? palette.baseColors.wairuaOpacity12
    : palette.baseColors.onepu};
      border-radius: 100%;
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: ${zIndex.negative};
      transform: scale(0);

      transition: transform 0.2s;
    }

    &:hover {
      &:before {
        transform: scale(1);
      }
    }

    &:active {
      &:before {
        transform: scale(0.9);
      }
    }

    &:focus-visible {
      border: 2px solid
        ${variant === 'reverse'
    ? palette.baseColors.wairua
    : palette.baseColors.lupin};
    }
  `}
`;

const NotificationDot = styled.div `
  ${({ theme: { borderRadius, palette } }) => css `
    background-color: ${palette.baseColors.kiwi};
    width: 16px;
    height: 16px;
    border-radius: ${borderRadius.round};
    position: absolute;
    top: 2px;
    left: 20px;
  `}
`;
const NotificationNumber = styled.span `
  ${({ theme: { palette } }) => css `
    display: flex;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    color: ${palette.baseColors.wairua};
    justify-content: center;
    align-items: center;
  `}
`;
const CartButtonContainer$1 = styled.div `
  display: flex;
`;
const CartButton = (_a) => {
    var { items = 0, isFocusHeader } = _a, rest = __rest(_a, ["items", "isFocusHeader"]);
    const { variant } = useHeader();
    const { palette: { baseColors: { wairua, newZealandBlack }, }, } = useTheme();
    const fillColor = variant === 'reverse' ? wairua : newZealandBlack;
    return (React__default.createElement(NavButton, Object.assign({ variant: variant }, rest, { "aria-label": "Open cart" }), items > 0 ? (React__default.createElement(CartButtonContainer$1, null,
        React__default.createElement(Icon, { name: "cart_notification_small", fill: isFocusHeader ? newZealandBlack : fillColor }),
        React__default.createElement(NotificationDot, null,
            React__default.createElement(NotificationNumber, null, items)))) : (React__default.createElement(Icon, { name: "cart_small", fill: isFocusHeader ? newZealandBlack : fillColor }))));
};

const FullWidthContainer = styled.div `
  ${({ theme: { palette, zIndex } }) => css `
    background-color: ${palette.baseColors.wairua};
    width: 100%;
    z-index: ${zIndex.navigation};
  `}
`;
const FocusHeaderContainer = styled(FullWidthContainer) `
  ${({ theme: { media, palette, spacing } }) => css `
    top: 0;
    display: flex;
    align-items: center;
    padding: ${spacing.s1} 0;
    position: sticky;
    border-bottom: solid 1px ${palette.baseColors.alto};

    ${media.up('slim')} {
      padding: ${spacing.s2} 0;
    }
  `}
`;
const ActionButtonContainer = styled(FullWidthContainer) `
  ${({ theme: { elevation, spacing, media } }) => css `
    bottom: 0;
    padding: ${spacing.s2} ${spacing.s3};
    box-shadow: ${elevation.topShadow};
    position: fixed;

    ${media.up('slim')} {
      display: none;
    }
  `}
`;
const CartButtonContainer = styled.div `
  ${({ theme: { spacing, media } }) => css `
    position: relative;
    padding-right: 0;

    ${media.up('slim')} {
      padding-right: ${spacing.s3};
    }
  `}
`;
const FocusHeaderItemContainer = styled.div `
  ${({ theme: { media } }) => css `
    ${media.up('slim')} {
      flex: 2 0;
    }
  `}
`;
const FocusHeaderBackButtonContainer = styled(FocusHeaderItemContainer) `
  ${({ theme: { spacing, media } }) => css `
    padding-left: ${spacing.s1_5};

    ${media.up('slim')} {
      padding-left: ${spacing.s4};
    }

    ${media.up('big')} {
      padding-left: ${spacing.s5};
    }
  `}
`;
const FocusHeaderTitleContainer = styled(FocusHeaderItemContainer) `
  flex-grow: 3;
  text-align: center;
  opacity: ${({ show }) => (show ? '1' : '0')};
  transition: opacity 200ms ease-in-out;
`;
const FocusHeaderActionButtonContainer = styled(FocusHeaderItemContainer) `
  ${({ theme: { spacing, media } }) => css `
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: ${spacing.s3};

    ${media.up('slim')} {
      padding-right: ${spacing.s4};
    }

    ${media.up('big')} {
      padding-right: ${spacing.s3};
    }
  `}
`;
const StyledActionButton = styled(Button$2) `
  ${({ theme: { spacing, media } }) => css `
    width: 100%;
    height: ${spacing.s6};

    ${media.up('slim')} {
      width: 150px;
    }
  `}
`;
const MobileFocusHeaderTitle = styled(MediaQuery) `
  ${({ theme: { spacing }, hasCart }) => css `
    padding-right: ${!hasCart ? spacing.s4 : ''};
  `}
`;
const getShowTitleThreshold = (isMobileOnly, isTabletOnly) => {
    if (isMobileOnly) {
        return 80;
    }
    if (isTabletOnly) {
        return 96;
    }
    return 120;
};
const getTitleVariant = (title, titleLengthThreshold) => {
    if (typeof title === 'string' && title.length > titleLengthThreshold) {
        return 'footnoteDemi';
    }
    return 'subheadingM';
};
const FocusHeader = ({ onBack, showTitleOnScroll, title, action, cart, isActionDisabled = false, }) => {
    const [hasScrolledDown, setHasScrolledDown] = useState(false);
    const isMobileOnly = useMediaQuery({ max: 'lil' });
    const isTabletOnly = useMediaQuery({ min: 'slim', max: 'slim' });
    const titleLengthThreshold = 20;
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.pageYOffset;
            const showTitleThreshold = getShowTitleThreshold(isMobileOnly, isTabletOnly);
            if (scrollPosition > showTitleThreshold && !hasScrolledDown) {
                setHasScrolledDown(true);
            }
            if (scrollPosition <= showTitleThreshold && hasScrolledDown) {
                setHasScrolledDown(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [hasScrolledDown]);
    return (React__default.createElement(FocusHeaderContainer, null,
        React__default.createElement(FocusHeaderBackButtonContainer, null,
            React__default.createElement(IconButton$5, { icon: "chevron_left_small", variant: "primary", disabled: !onBack, onClick: onBack, title: "Back" })),
        React__default.createElement(FocusHeaderTitleContainer, { show: showTitleOnScroll ? hasScrolledDown : true },
            React__default.createElement(MobileFocusHeaderTitle, { hasCart: Boolean(cart), max: "lil" },
                React__default.createElement(Text, { variant: getTitleVariant(title, titleLengthThreshold), component: "h5" }, title)),
            React__default.createElement(MediaQuery, { min: "slim" },
                React__default.createElement(Text, { variant: "bodyMDemi" }, title))),
        React__default.createElement(FocusHeaderActionButtonContainer, null,
            cart && cart.onClick ? (React__default.createElement(CartButtonContainer, null,
                React__default.createElement(CartButton, { onClick: cart.onClick, items: cart.items, isFocusHeader: true, "aria-label": "Open Cart" }))) : null,
            action ? (React__default.createElement(MediaQuery, { min: "slim" },
                React__default.createElement(StyledActionButton, { variant: "primary", onClick: action.onClick, disabled: isActionDisabled }, action.label))) : null),
        action ? (React__default.createElement(ActionButtonContainer, null,
            React__default.createElement(StyledActionButton, { variant: "primary", onClick: action.onClick, disabled: isActionDisabled }, action.label))) : null));
};

const FooterLink = styled(Link$1) `
  ${({ theme: { borderRadius, palette } }) => css `
    text-decoration: none;
    background: transparent;
    display: block;
    color: ${palette.baseColors.greymouth};

    &:hover {
      background: transparent;
      color: ${palette.baseColors.lupin};
    }

    &:active {
      color: ${palette.baseColors.sparkPurple};
    }

    &:focus {
      width: fit-content;
      border-radius: ${borderRadius.rHalf};
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }
  `}
`;

const FOOTER_BASE_SECTION = 'FooterBaseSection';
const defaultRenderWithWrapper = (_, element) => element;

const FooterAccordionContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    background: transparent;
    padding: ${spacing.s3} ${spacing.s3} 0 ${spacing.s3};
  `};
`;
const FooterAccordionItemHeadingButton = styled(AccordionItemButton) `
  ${({ theme: { media, spacing, palette } }) => css `
    ${bodySDemiStyle}
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    width: 100%;
    padding: 0 0 ${spacing.s2} 0;
    margin: ${spacing.s2} 0 ${spacing.s2} 0;
    border-bottom: 1px solid ${palette.baseColors.alto};
    color: ${palette.baseColors.newZealandBlack};

    ${media.up('slim')} {
      padding: ${spacing.s3} 0;
    }
  `};
`;
const FooterAccordionItem = styled(AccordionItem$1) `
  ${({ $isOpen }) => css `
    width: 100%;

    ${AccordionVerticalLine$1} {
      ${$isOpen
    ? css `
            transform: rotate(90deg);
          `
    : null}
    }
  `};
`;
const FooterAccordionItemBody = styled(motion.section) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s5};
  `}
`;
const FooterAccordionBodyLink = styled(FooterLink) `
  ${({ theme: { spacing } }) => css `
    ${bodySMediumStyle}
    margin-bottom: ${spacing.s2};
  `}
`;
const StyledFooterAccordionIcon = styled.div `
  ${({ theme: { palette, borderRadius } }) => css `
    height: 22px;
    width: 22px;
    border: none;
    display: flex;
    position: relative;
    cursor: pointer;
    background-color: transparent;

    & > ${AccordionVerticalLine$1}, ${AccordionHorizontalLine$1} {
      background-color: ${palette.baseColors.newZealandBlack};
    }

    &:focus {
      border-radius: ${borderRadius.rHalf};
      border: 2px solid ${palette.baseColors.lupin};
    }

    &:hover {
      & > ${AccordionVerticalLine$1}, ${AccordionHorizontalLine$1} {
        background-color: ${palette.baseColors.lupin};
      }
    }

    &:active {
      border-radius: ${borderRadius.rHalf};
      border: 2px solid ${palette.baseColors.lupin};
      & > ${AccordionVerticalLine$1}, ${AccordionHorizontalLine$1} {
        background-color: ${palette.baseColors.sparkPurple};
      }
    }
  `}
`;
const FooterAccordionScrollEffect = ({ children }) => {
    return (React__default.createElement(FooterAccordionItemBody, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
        }, transition: { duration: 0.2, ease: [0.5, 0.2, 1, 0.8] } },
        React__default.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { delay: 0.2 } }, children)));
};
const FooterAccordionIcon = () => {
    return (React__default.createElement(StyledFooterAccordionIcon, null,
        React__default.createElement(AccordionVerticalLine$1, null),
        React__default.createElement(AccordionHorizontalLine$1, null)));
};
const FooterAccordion = ({ linkMenuData, renderWithWrapper = defaultRenderWithWrapper, }) => {
    const [currentExpandedItems, setCurrentExpandedItems] = useState([]);
    return (React__default.createElement(FooterAccordionContainer, null,
        React__default.createElement(Accordion, { allowMultipleExpanded: true, onChange: (expandedItems) => setCurrentExpandedItems(expandedItems) }, linkMenuData.map(({ heading, items, id }) => {
            const $isOpen = currentExpandedItems.includes(id);
            return (React__default.createElement(FooterAccordionItem, { key: `footer-accordion-heading-${id}`, uuid: id, "$isOpen": $isOpen }, renderWithWrapper(heading, React__default.createElement(React__default.Fragment, null,
                React__default.createElement(FooterAccordionItemHeadingButton, null,
                    heading,
                    React__default.createElement(FooterAccordionIcon, null)),
                React__default.createElement(AnimatedComponent, { initial: false }, $isOpen ? (React__default.createElement(FooterAccordionScrollEffect, null, items.map((item) => (React__default.createElement(FooterAccordionBodyLink, { href: item.url, key: `footer-accordion-body-${item.id}` }, item.label))))) : null)))));
        }))));
};

const FooterLinkMenuContainer = styled.div `
  ${({ theme: { spacing, media, palette } }) => css `
    border-top: 1px solid ${palette.baseColors.alto};

    width: 100%;

    ${media.up('slim')} {
      padding: 0 ${spacing.s4};
    }

    ${media.up('big')} {
      padding: 0 120px;
    }
  `}
`;
const MasonryGrid = styled.div `
  ${({ theme: { spacing, media } }) => css `
    padding-top: ${spacing.s5};
    width: 100%;
    column-count: 3;
    column-gap: ${spacing.s3};

    ${media.up('slim')} {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    ${media.up('big')} {
      display: flex;
      justify-content: space-between;
    }

    > * {
      width: 100%;
      display: inline-block;
      margin-bottom: ${spacing.s5};
    }
  `}
`;
const FooterLinkMenuHeading = styled(Text) `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.newZealandBlack};
  `}
`;
const FooterLinkMenuItem = styled(FooterLink) `
  ${({ theme: { spacing } }) => css `
    ${footNoteMediumStyle}
    margin-bottom: ${spacing.s1_5};
  `}
`;
const LinkMenuItems = ({ items, }) => {
    return (React__default.createElement(React__default.Fragment, null, items.map(({ id, label, url }) => {
        return (React__default.createElement(FooterLinkMenuItem, { href: url, key: `link-menu-item-${id}` }, label));
    })));
};
const LinkMenu = ({ linkMenuData, renderWithWrapper = defaultRenderWithWrapper, }) => {
    return (React__default.createElement(React__default.Fragment, null, linkMenuData.map(({ id, items, heading }) => {
        return (React__default.createElement("div", { key: `link-menu-heading-${id}` }, renderWithWrapper(heading, React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FooterLinkMenuHeading, { variant: "bodySDemi", mb: "s3" }, heading),
            React__default.createElement(LinkMenuItems, { items: items })))));
    })));
};
const FooterLinkMenu = (props) => {
    return (React__default.createElement(FooterLinkMenuContainer, null,
        React__default.createElement(MediaQuery, { min: "slim" },
            React__default.createElement(MasonryGrid, null,
                React__default.createElement(LinkMenu, Object.assign({}, props)))),
        React__default.createElement(MediaQuery, { max: "lil" },
            React__default.createElement(FooterAccordion, Object.assign({}, props)))));
};

const StyledIcon$3 = styled(Icon) `
  ${({ theme: { palette } }) => css `
    &:hover {
      > path {
        fill: ${palette.baseColors.lupin};
      }
    }
  `}
`;
const FooterBaseLinkWithTopNavLayout = styled(FooterLink) `
  ${({ theme: { media, spacing } }) => css `
    ${footNoteMediumStyle}
    margin: ${spacing.s2} ${spacing.s3} 0 0;

    ${media.up('big')} {
      margin: 0 ${spacing.s3} 0 0;
    }
    &:hover {
      cursor: pointer;
    }
  `}
`;
const FooterBaseLinkWithSideNavLayout = styled(FooterLink) `
  ${({ theme: { media, spacing } }) => css `
    ${footNoteMediumStyle}
    margin: 0 ${spacing.s3} 0 0;

    ${media.up('big')} {
      margin: 0 ${spacing.s3} 0 0;
    }
    &:hover {
      cursor: pointer;
    }
  `}
`;
const FooterBaseFullWidthContainer = styled.div `
  ${({ theme: { media, palette, spacing } }) => css `
    width: calc(100% - 48px);
    margin: ${spacing.s2} ${spacing.s3} 120px ${spacing.s3};
    display: flex;
    flex-direction: column;

    > * {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    ${media.up('slim')} {
      width: calc(100% - 64px);
      margin: 0 ${spacing.s4} 120px ${spacing.s4};
      border-top: 1px solid ${palette.baseColors.alto};
    }

    ${media.up('big')} {
      width: calc(100% - 240px);
      margin: 0 120px 120px 120px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;
const FooterBaseContainerWithSideNav = styled.div `
  ${({ theme: { media, palette, spacing } }) => css `
    width: calc(100% - ${spacing.s8});
    margin: 0 ${spacing.s4} ${spacing.s4} ${spacing.s4};
    display: flex;
    flex-direction: column;

    > * {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    ${media.up('slim')} {
      border-top: 1px solid ${palette.baseColors.alto};
    }

    ${media.up('big')} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;
const CopyrightContainer = styled(Box) `
  ${({ theme: { media } }) => css `
    flex: 1;
    justify-content: space-between;
    align-items: center;

    ${media.up('big')} {
      justify-content: flex-end;
    }
  `}
`;
const CopyrightTextWithPadding = styled(Text) `
  ${({ theme: { spacing, palette } }) => css `
    white-space: nowrap;
    padding-right: ${spacing.s3};
    color: ${palette.baseColors.mawheranui};
  `}
`;
const CopyrightTextWithoutPadding = styled(Text) `
  ${({ theme: { palette } }) => css `
    white-space: nowrap;
    color: ${palette.baseColors.mawheranui};
  `}
`;
const SocialMediaLinks = ({ items, }) => {
    return (React__default.createElement(Box, { pt: ['s1', 's1', 's3'] }, items.map(({ iconName, id, label, url }) => {
        return (React__default.createElement(FooterBaseLinkWithTopNavLayout, { href: url, key: `social-media-link-item-${id}`, "aria-label": label }, iconName ? (React__default.createElement(StyledIcon$3, { "data-testid": iconName, name: iconName })) : (label)));
    })));
};
const LegalLinks = ({ items, hasPrintPageLink = true, fitSideNavLayout, }) => {
    const FootBaseLink = fitSideNavLayout
        ? FooterBaseLinkWithSideNavLayout
        : FooterBaseLinkWithTopNavLayout;
    return (React__default.createElement(Box, { flexWrap: "wrap", pt: fitSideNavLayout ? 's4' : ['s1', 's2', 's3'] },
        items.map(({ id, label, url }) => {
            return (React__default.createElement(FootBaseLink, { href: url, key: `legal-link-${id}` }, label));
        }),
        hasPrintPageLink ? (React__default.createElement(FootBaseLink, { tabIndex: 0, onClick: () => {
                window === null || window === void 0 ? void 0 : window.print();
            } }, "Print this page")) : null));
};
const FooterBase = ({ copyrightContent, legalLinks, socialMediaLinks, renderWithWrapper = defaultRenderWithWrapper, hasPrintPageLink, fitSideNavLayout, hasShieldIcon, }) => {
    const FooterBaseContainer = fitSideNavLayout
        ? FooterBaseContainerWithSideNav
        : FooterBaseFullWidthContainer;
    const CopyrightText = hasShieldIcon
        ? CopyrightTextWithPadding
        : CopyrightTextWithoutPadding;
    const hasSocialMediaLinks = socialMediaLinks.length > 0;
    return (React__default.createElement(React__default.Fragment, null, renderWithWrapper(FOOTER_BASE_SECTION, React__default.createElement(FooterBaseContainer, null,
        hasSocialMediaLinks ? (React__default.createElement(SocialMediaLinks, { items: socialMediaLinks })) : null,
        React__default.createElement(LegalLinks, { items: legalLinks, hasPrintPageLink: hasPrintPageLink, fitSideNavLayout: fitSideNavLayout }),
        React__default.createElement(CopyrightContainer, { pt: fitSideNavLayout ? ['s3', 's3', 's4'] : ['s3', 's4', 's3'] },
            React__default.createElement(CopyrightText, { variant: "footnoteMedium" }, copyrightContent ||
                `Copyright © ${new Date().getFullYear()} Spark NZ`),
            hasShieldIcon ? React__default.createElement(Shielded, null) : null)))));
};

const FooterContainer = styled.div `
  ${({ footerBackgroundColor }) => css `
    width: 100%;
    background-color: ${footerBackgroundColor};
  `};
`;
const InvertedBorderDiv = styled.div `
  ${({ borderDivBackgroundColor, theme: { borderRadius, palette, spacing, media }, }) => css `
    box-sizing: border-box;
    border: none;

    ${media.up('slim')} {
      background-color: ${borderDivBackgroundColor};
      border-radius: 0 0 ${borderRadius.r2} ${borderRadius.r2};
      border-top: 1px solid ${palette.baseColors.alto};
      padding-top: ${spacing.s5};
    }
  `};
`;
const InvertedBorderWrapper = ({ borderDivBackgroundColor, children, footerBackgroundColor, }) => {
    return (React__default.createElement(FooterContainer, { footerBackgroundColor: footerBackgroundColor || 'transparent' },
        React__default.createElement(InvertedBorderDiv, { borderDivBackgroundColor: borderDivBackgroundColor || 'transparent' }),
        children));
};

const Footer = ({ copyrightContent, legalLinks = [], linkMenuData = [], socialMediaLinks = [], renderWithWrapper, hasPrintPageLink, fitSideNavLayout = false, hasShieldIcon = true, }) => {
    return (React__default.createElement(React__default.Fragment, null,
        linkMenuData.length > 0 ? (React__default.createElement(FooterLinkMenu, { linkMenuData: linkMenuData, renderWithWrapper: renderWithWrapper })) : null,
        React__default.createElement(FooterBase, { copyrightContent: copyrightContent, legalLinks: legalLinks, socialMediaLinks: socialMediaLinks, renderWithWrapper: renderWithWrapper, hasPrintPageLink: hasPrintPageLink, fitSideNavLayout: fitSideNavLayout, hasShieldIcon: hasShieldIcon })));
};

const StyledButton = styled(Button$2) `
  ${({ theme: { media } }) => css `
    ${media.up('slim')} {
      width: 100%;
    }
  `}
`;
const ButtonWrapper = styled.div `
  ${({ theme: { spacing, media } }) => css `
    padding: 0 ${spacing.s2} ${spacing.s2} ${spacing.s2};
    ${media.up('slim')} {
      padding: ${spacing.s1};
      width: 100%;
    }
  `}
`;
styled.span `
  ${({ theme: { borderRadius, palette, spacing } }) => css `
    background-color: ${palette.baseColors.kiwi};
    width: 8px;
    height: 8px;
    border-radius: ${borderRadius.round};
    margin-left: ${spacing.s2};
    position: absolute;
    top: 28px;
  `}
`;
const CommonStyledMenuItem = styled.a `
  ${({ theme: { palette, borderRadius, media } }) => css `
    border: 1px solid transparent;
    color: ${palette.baseColors.newZealandBlack};
    border-radius: ${borderRadius.r1};
    cursor: pointer;
    background: ${palette.baseColors.wairua};
    position: relative;

    &:hover {
      color: ${palette.baseColors.lupin};
    }

    &:active {
      color: ${palette.baseColors.mawheranui};
    }

    &:focus-visible {
      border: 1px solid ${palette.baseColors.lupin};
    }

    ${media.up('slim')} {
      &:hover,
      &:focus-visible {
        color: ${palette.baseColors.newZealandBlack};
        background: ${palette.baseColors.onepu};
      }
      &:active {
        background: ${palette.baseColors.alto};
      }
      &:focus-visible {
        border: 1px solid ${palette.baseColors.lupin};
      }
    }
  `}
`;
const ProfileAuthPrimaryMenuLink = styled(CommonStyledMenuItem) `
  ${({ theme: { spacing, media } }) => css `
    ${subheadingMStyle};
    padding: ${spacing.s1} ${spacing.s2};
    ${media.up('slim')} {
      ${bodyMDemiStyle};
      padding: ${spacing.s1};
    }
  `}
`;
const ProfileAuthenticatedPrimaryMenuLink = ({ children, onClick }) => {
    return (React__default.createElement(ProfileAuthPrimaryMenuLink, { onClick: onClick, tabIndex: 0 }, children));
};
const ProfileAuthSecondaryMenuLink = styled(CommonStyledMenuItem) `
  ${({ theme: { spacing, media } }) => css `
    ${subheadingMStyle};
    padding: ${spacing.s1} ${spacing.s2};
    ${media.up('slim')} {
      ${bodyMMediumStyle};
      padding: ${spacing.s1};
    }
  `}
`;
const ProfileAuthenticatedSecondaryMenuLink = ({ children, onClick }) => {
    return (React__default.createElement(ProfileAuthSecondaryMenuLink, { onClick: onClick, tabIndex: 0 }, children));
};
const ProfileUnauthMenuLink = styled(CommonStyledMenuItem) `
  ${({ theme: { spacing, media } }) => css `
    ${subheadingMStyle};
    padding: ${spacing.s2};
    ${media.up('slim')} {
      padding: ${spacing.s1};
      ${bodySMediumStyle};
    }
  `}
`;
const ProfileUnauthenticatedMenuLink = ({ children, onClick, }) => {
    return (React__default.createElement(ProfileUnauthMenuLink, { onClick: onClick, tabIndex: 0 }, children));
};
const ProfileMenu = styled.div `
  ${({ theme: { media, borderRadius } }) => css `
    padding: 0;
    min-width: 206px;
    border-radius: ${borderRadius.r4} ${borderRadius.r4} 0 0;

    ${media.up('slim')} {
      border-radius: ${borderRadius.r1};
      width: 100%;
    }
  `}
`;
const Title = styled(Text) `
  ${({ theme: { spacing, media } }) => css `
    padding: ${spacing.s1} ${spacing.s1} ${spacing.s1} ${spacing.s2};
    ${media.up('slim')} {
      padding: ${spacing.s1} ${spacing.s1} ${spacing.s0_5};
    }
  `}
`;
const MenuLinkWrappers = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    padding: ${spacing.s1};
  `}
`;
const ProfileMenuPrimarySection = ({ title, children, }) => {
    const { palette: { baseColors: { greymouth }, }, } = useTheme();
    return (React__default.createElement(MenuLinkWrappers, null,
        title && (React__default.createElement(Title, { variant: "footnoteMedium", color: greymouth }, title)),
        children));
};
const AuthenticatedSectionDivider = styled(MenuLinkWrappers) `
  ${({ theme: { palette, spacing, media } }) => css `
    border-top: 1px solid ${palette.baseColors.alto};
    padding: ${spacing.s2} ${spacing.s1} ${spacing.s1} ${spacing.s1};
    margin-top: ${spacing.s1};
    ${media.up('slim')} {
      padding: ${spacing.s1};
      margin-top: 0;
    }
  `}
`;
const UnauthenticatedSectionDivider = styled(MenuLinkWrappers) `
  ${({ theme: { spacing, media, palette } }) => css `
    border-top: 1px solid ${palette.baseColors.alto};
    padding: 0 ${spacing.s1};
    ${media.up('slim')} {
      padding: ${spacing.s1};
    }
  `}
`;
const ProfileMenuSecondarySection = ({ children }) => {
    const { profile } = useHeader();
    const SectionDivider = profile
        ? AuthenticatedSectionDivider
        : UnauthenticatedSectionDivider;
    return React__default.createElement(SectionDivider, null, children);
};

const defaultAuthenticatedPrimaryMenuOptions = [
    { name: 'Dashboard', code: 'dashboard' },
    { name: 'Usage', code: 'usage' },
    { name: 'Billing', code: 'billing' },
    { name: 'Products', code: 'products' },
];
const defaultAuthenticatedSecondaryMenuOptions = [
    { name: 'Profile', code: 'profile' },
    { name: 'Orders', code: 'orders' },
    { name: 'Sign out', code: 'signout' },
];
function AuthenticatedProfileMenu({ onClick, authenticatedPrimaryMenuOptions = defaultAuthenticatedPrimaryMenuOptions, authenticatedSecondaryMenuOptions = defaultAuthenticatedSecondaryMenuOptions, }) {
    return (React__default.createElement(ProfileMenu, null,
        React__default.createElement(ProfileMenuPrimarySection, { title: "MySpark" }, authenticatedPrimaryMenuOptions.map((item) => {
            return (React__default.createElement(ProfileAuthenticatedPrimaryMenuLink, { key: item.code, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(item.code) }, item.name));
        })),
        React__default.createElement(ProfileMenuSecondarySection, null, authenticatedSecondaryMenuOptions.map((item) => {
            return (React__default.createElement(ProfileAuthenticatedSecondaryMenuLink, { key: item.code, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(item.code) }, item.name));
        }))));
}

const StyledLogo = styled(Logo$1) `
  height: 44px;
  width: 112px;
`;
const StyledATag = styled.a `
  display: block;
  width: fit-content;
`;
const BrandLogo = (_a) => {
    var { overrideColour } = _a, rest = __rest(_a, ["overrideColour"]);
    const { palette } = useTheme();
    const { variant } = useHeader();
    return (React__default.createElement(StyledATag, Object.assign({}, rest),
        React__default.createElement(StyledLogo, { name: "horizontal_logo", fill: overrideColour || variant === 'reverse'
                ? palette.baseColors.wairua
                : palette.baseColors.sparkPurple })));
};

function useOnClickOutside(ref, handler, ignoreRef) {
    useEffect(() => {
        const listener = (event) => {
            const el = ref === null || ref === void 0 ? void 0 : ref.current;
            const ignoreEl = ignoreRef === null || ignoreRef === void 0 ? void 0 : ignoreRef.current;
            if (!el ||
                el.contains(event === null || event === void 0 ? void 0 : event.target) ||
                (ignoreEl === null || ignoreEl === void 0 ? void 0 : ignoreEl.contains(event === null || event === void 0 ? void 0 : event.target))) {
                return;
            }
            handler(event);
        };
        document.addEventListener(`mousedown`, listener);
        document.addEventListener(`touchstart`, listener);
        return () => {
            document.removeEventListener(`mousedown`, listener);
            document.removeEventListener(`touchstart`, listener);
        };
    }, [ref, handler, ignoreRef]);
}

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

function isBrowser() {
    return typeof window !== 'undefined';
}
const AnimateVisible = keyframes `
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
const AnimationVisibleMixin = css `
  animation: ${AnimateVisible} 0.2s;
  transition: none;
`;
const GlobalNavigationContainer = styled.div `
  ${({ theme: { borderRadius, media, palette, spacing, zIndex }, variant, prevVariant, isStickyNavigation, isScrollUp, scrollY, hasSegmentSwitcher, }) => css `
    position: ${isStickyNavigation ? 'fixed' : 'absolute'};
    ${variant !== prevVariant ? AnimationVisibleMixin : null}
    width: 100%;
    display: flex;
    justify-content: space-between;
    z-index: ${zIndex.navigation};
    background: linear-gradient(
      180deg,
      rgba(29, 29, 29, 0.8) 0%,
      rgba(29, 29, 29, 0) 100%
    );
    padding: ${spacing.s2} ${spacing.s5} ${spacing.s2} ${spacing.s3};
    height: 120px;
    top: 0;
    transition: top 0.2s linear;

    ${isStickyNavigation &&
    scrollY > HEADER_WITH_SEGMENT_SWITCHER_HEIGHT &&
    !isScrollUp &&
    css `
      ${media.down('slim')} {
        top: -${HEADER_HEIGHT}px;
      }
    `};

    ${variant !== 'reverse'
    ? css `
          height: 80px;
          background: ${palette.baseColors.wairua};
          border-bottom: 1px solid ${palette.baseColors.alto};
        `
    : null}
    ${media.up('slim')} {
      ${variant !== 'reverse' ? `height: 80px` : `height: 120px`}
    }

    ${media.up('big')} {
      top: ${hasSegmentSwitcher ? SEGMENT_SWITCHER_HEIGHT : 0}px;
      position: absolute;

      ${hasSegmentSwitcher
    ? `border-radius: ${borderRadius.r2} ${borderRadius.r2} 0 0;`
    : null}

      padding: ${spacing.s2} ${spacing.s6};

      ${isStickyNavigation &&
    scrollY > SEGMENT_SWITCHER_HEIGHT &&
    css `
        position: fixed;
        top: 0;
        border-radius: 0;
      `}

      ${isStickyNavigation &&
    isBrowser() &&
    window.scrollY > 120 &&
    css `
        background: ${palette.baseColors.wairua};
        height: 80px;
        border-radius: 0;
        ${variant !== prevVariant ? AnimationVisibleMixin : null}
        border-bottom: 1px solid ${palette.baseColors.alto};
      `}
    }
  `}
`;
const GlobalNavigation = ({ children, hasSegmentSwitcher }) => {
    const { variant, isStickyNavigation, isScrollUp, scrollY } = useHeader();
    const prevVariant = usePrevious(variant);
    return (React__default.createElement(GlobalNavigationContainer, { variant: variant, prevVariant: prevVariant, isStickyNavigation: isStickyNavigation, isScrollUp: isScrollUp, scrollY: scrollY, hasSegmentSwitcher: hasSegmentSwitcher }, children));
};

const HeaderAccordionWrapper = styled(Accordion$1) `
  border: none;
  transition: all 0.3s ease-in-out;
`;
const accordionIconMixin = (placement) => {
    return css `
    ${({ theme: { palette } }) => css `
      background-color: ${palette.baseColors.lupin};
      height: ${placement === 'vertical' ? '12px' : '2px'};
      width: ${placement === 'vertical' ? '2px' : '12px'};
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      transform: rotate(0deg);
      transition: 0.3s all ease-in-out;
    `}
  `;
};
const AccordionHorizontalLine = styled.div `
  ${accordionIconMixin('horizontal')};
`;
const AccordionVerticalLine = styled.div `
  ${accordionIconMixin('vertical')};
`;
const CustomizedIcon = styled(Icon) `
  ${({ theme: { palette }, color }) => css `
    fill: ${color || palette.baseColors.lupin};
    margin: auto;
    transform: rotate(0deg);
    transition: 0.3s all ease-in-out;
  `}
`;
const HeaderAccordionItem = styled(AccordionItem$1) `
  ${({ theme: { palette, spacing, borderRadius }, isOpen }) => css `
    background: ${isOpen
    ? palette.baseColors.sparkPurple
    : palette.baseColors.poroporo};
    padding: 0 ${spacing.s3};
    border-radius: ${borderRadius.r1};
    ${AccordionVerticalLine} {
      ${isOpen
    ? css `
            transform: rotate(90deg);
          `
    : null}
    }

    ${CustomizedIcon} {
      ${isOpen
    ? css `
            transform: rotate(180deg);
          `
    : null}
    }
  `}
`;
const StyledHeaderAccordionItemButton = styled(AccordionItemButton) `
  ${({ theme: { spacing, palette, media } }) => css `
    ${bodyMDemiStyle}
    font-size: 20px;
    ${media.up('lil')} {
      font-size: 20px;
    }
    padding: ${spacing.s2} 0;
    color: ${palette.baseColors.wairua};
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  `};
`;
const HeaderAccordionItemBody = styled(motion.section) `
  ${({ theme: { spacing, palette } }) => css `
    padding: 0 0 ${spacing.s2} 0;
    background: ${palette.baseColors.sparkPurple};
    animation: all 0.3s ease-in;
    color: ${palette.baseColors.mawheranui};
  `};
`;
const Button = styled.button `
  ${({ theme: { borderRadius, palette } }) => css `
    height: 32px;
    width: 32px;
    border-radius: ${borderRadius.round};
    border: 2px solid ${palette.baseColors.lupin};
    display: flex;
    position: relative;
    padding: 14px; // 16px padding with -2px offset of the border;
    cursor: pointer;
    background-color: ${palette.baseColors.wairua};
    flex-shrink: 0;
    align-self: baseline;
    &:hover {
      background-color: ${palette.baseColors.pukaki};
    }

    &:active {
      background-color: ${palette.baseColors.wanaka};
    }

    &:focus-visible {
      box-shadow:
        0 0 0 1px ${palette.baseColors.wairua},
        0 0 0 3px ${palette.baseColors.lupin};
    }
  `}
`;
const IconButton = styled.button `
  ${({ theme: { palette } }) => css `
    display: flex;
    border: none;
    color: ${palette.baseColors.lupin};
    background-color: transparent;
    position: relative;
    cursor: pointer;
  `}
`;
const SubOptionsContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const HeaderAccordionItemHeading = ({ children, }) => {
    return (React__default.createElement(StyledHeaderAccordionItemButton, null, children));
};
const HeaderAccordionButton = ({ onChange, iconSize, iconColor, iconName, }) => {
    return (React__default.createElement(React__default.Fragment, null, iconName ? (React__default.createElement(IconButton, { onClick: onChange, "data-testid": "customized-button-icon" },
        React__default.createElement(CustomizedIcon, { name: iconName, size: iconSize || 24, color: iconColor }))) : (React__default.createElement(Button, { onClick: onChange },
        React__default.createElement(AccordionVerticalLine, null),
        React__default.createElement(AccordionHorizontalLine, null)))));
};
const HeaderAccordionItemBodyWithAnimation = ({ children, isOpen }) => {
    return (React__default.createElement(AnimatedComponent, { initial: false }, isOpen ? (React__default.createElement(HeaderAccordionItemBody, { initial: "collapsed", animate: "open", exit: "collapsed", variants: {
            open: { opacity: 1, height: 'auto' },
            collapsed: { opacity: 0, height: 0 },
        }, transition: { duration: 0.2 } },
        React__default.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { delay: 0.2 } },
            React__default.createElement(SubOptionsContainer, null, children)))) : null));
};
const HeaderAccordion = ({ children, allowMultipleExpanded, expandedItems, onChange, }) => {
    return (React__default.createElement(HeaderAccordionWrapper, { allowMultipleExpanded: allowMultipleExpanded, allowZeroExpanded: true, preExpanded: expandedItems, onChange: onChange }, children));
};

const HoverContext = React__default.createContext(null);
const HoverProvider = ({ children }) => {
    const [hoveredCategoryId, setHoveredCategoryId] = useState('');
    const isHovered = (category) => {
        return category === hoveredCategoryId;
    };
    const hoverCategory = (category) => {
        if (hoveredCategoryId !== category) {
            setHoveredCategoryId(category);
        }
    };
    const unhoverCategories = () => {
        if (hoveredCategoryId) {
            setHoveredCategoryId('');
        }
    };
    return (React__default.createElement(HoverContext.Provider, { value: {
            isHovered,
            unhoverCategories,
            hoverCategory,
        } }, children));
};
const useHover = () => {
    const context = useContext(HoverContext);
    if (!context) {
        throw new Error('useHover should be used inside HoverProvider');
    }
    return context;
};

const Container$4 = styled(motion.div) `
  display: flex;
`;
const HeaderCategories = ({ children, selectedSegment, }) => {
    return (React__default.createElement(HoverProvider, null,
        React__default.createElement(Container$4, { initial: false, animate: selectedSegment }, children)));
};

const Container$3 = styled.div `
  ${({ theme: { media } }) => css `
    width: 100%;
    ${media.up('big')} {
      display: flex;
      width: initial;
    }
  `}
`;
const HeaderCategoriesContainer$1 = ({ children, }) => {
    const { unhoverCategories } = useHover();
    return (React__default.createElement(AnimateSharedLayout, null,
        React__default.createElement(Container$3, { onMouseLeave: unhoverCategories }, children)));
};

const TRANSITION_VALUES$1 = {
    transition: { type: 'tween', duration: 0.2 },
};

const variants$2 = {
    personal: Object.assign({ x: 80, opacity: 0, transitionEnd: { display: 'none' } }, TRANSITION_VALUES$1),
    business: Object.assign({ x: 0, opacity: 1, display: 'block' }, TRANSITION_VALUES$1),
};
const BusinessCategoriesContainer = ({ children, }) => {
    return (React__default.createElement(motion.div, { variants: variants$2 },
        React__default.createElement(HeaderCategoriesContainer$1, null, children)));
};

const Highlight$3 = styled(motion.div) `
  ${({ theme: { borderRadius, palette, media }, headerVariant }) => css `
    ${media.up('big')} {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: ${borderRadius.r3};
      background-color: ${headerVariant === 'reverse'
    ? palette.baseColors.wairuaOpacity12
    : palette.baseColors.onepu};
    }
  `}
`;
const IconWrapper$4 = styled.div `
  ${({ theme: { media, spacing } }) => css `
    width: 32px;
    height: 32px;
    margin-right: ${spacing.s2};

    ${media.up('big')} {
      display: none;
    }
  `}
`;
const HeaderCategoryLabel$1 = styled(Text) `
  ${({ theme: { borderRadius, media, palette, spacing, zIndex }, headerVariant, selected, }) => css `
    font-size: 20px;
    line-height: 28px;
    border-radius: ${borderRadius.rHalf};
    padding: 0 ${spacing.s1};
    transition: all 100ms ease-in-out;
    color: ${palette.baseColors.wairua};
    white-space: nowrap;

    &:active {
      color: ${palette.baseColors.alto};
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px ${palette.baseColors.wairua};
    }

    ${media.up('slim')} {
      color: ${palette.baseColors.newZealandBlack};

      &:hover {
        color: ${palette.baseColors.lupin};
      }

      &:active {
        color: ${palette.baseColors.sparkPurple};
      }

      &:focus-visible {
        box-shadow: 0 0 0 3px ${palette.baseColors.lupin};
      }
    }

    ${media.up('big')} {
      position: relative;
      z-index: ${zIndex.navigation};

      color: ${selected
    ? palette.baseColors.sparkPurple
    : palette.baseColors.newZealandBlack};

      &:hover {
        color: ${palette.baseColors.newZealandBlack};
      }

      ${headerVariant === 'reverse' &&
    css `
        color: ${selected
        ? palette.baseColors.alto
        : palette.baseColors.wairua};

        &:hover {
          color: ${palette.baseColors.wairua};
        }
      `}
    }
  `}
`;
const HeaderCategoryContainer$1 = styled.a `
  ${({ theme: { borderRadius, media, palette, spacing }, headerVariant }) => css `
      display: flex;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      margin-bottom: ${spacing.s3};

      &:last-of-type {
        margin-bottom: 0;
      }

      &:focus-visible {
          ${HeaderCategoryLabel$1} {
            box-shadow: 0 0 0 2px ${palette.baseColors.wairua};
          }
        }

      ${media.up('slim')} {
        &:focus-visible {
          ${HeaderCategoryLabel$1} {
            box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
          }
        }
      }

      ${media.up('big')} {
        position: relative;
        padding: ${spacing.s1} 14px;
        margin: 0;
        border-radius: ${borderRadius.r3};
        transition: all 100ms ease-in-out;

        &:active {
          & > ${Highlight$3} {
            background-color: ${headerVariant === 'reverse'
    ? palette.baseColors.wairuaOpacity8
    : palette.baseColors.alto};
          }
        }

        &:focus-visible {
          ${HeaderCategoryLabel$1} {
            box-shadow: none;
          }

          box-shadow: 0 0 0 3px ${headerVariant === 'reverse'
    ? palette.baseColors.wairua
    : palette.baseColors.lupin};
        }
   `}
`;
const HeaderCategory = (_a) => {
    var { children: category, isSelected, onCategoryClick, iconName } = _a, anchorProps = __rest(_a, ["children", "isSelected", "onCategoryClick", "iconName"]);
    const { variant } = useHeader();
    const { isHovered, hoverCategory } = useHover();
    const { borderRadius, palette: { baseColors: { lupin, mawheranui, wairua, wairuaOpacity40 }, }, } = useTheme();
    const highlightVisible = isHovered(category);
    return (React__default.createElement(HeaderCategoryContainer$1, Object.assign({ headerVariant: variant, onClick: onCategoryClick, onMouseEnter: () => hoverCategory(category), tabIndex: 0 }, anchorProps),
        React__default.createElement(MediaQuery, { max: "lil" },
            React__default.createElement(IconWrapper$4, null,
                React__default.createElement(Icon, { name: iconName, fill: isSelected ? wairua : wairuaOpacity40 }))),
        React__default.createElement(MediaQuery, { min: "slim" },
            React__default.createElement(IconWrapper$4, null,
                React__default.createElement(Icon, { name: iconName, fill: isSelected ? lupin : mawheranui }))),
        React__default.createElement(HeaderCategoryLabel$1, { headerVariant: variant, selected: isSelected, variant: "bodyMDemi" }, category),
        React__default.createElement(AnimatedComponent, null, highlightVisible ? (React__default.createElement(Highlight$3, { headerVariant: variant, layoutId: "background", initial: { opacity: 0 }, animate: { opacity: 1, borderRadius: borderRadius.r3 }, exit: { opacity: 0 }, transition: TRANSITION_VALUES$1.transition })) : null)));
};

const MegaMenuWrapper = styled.div `
  ${({ theme: { palette, spacing, elevation, borderRadius }, isTier2 }) => css `
    border-radius: ${borderRadius.r1};
    display: flex;
    flex-direction: ${isTier2 ? 'row' : 'column'};
    padding: ${spacing.s3};
    box-shadow: ${elevation.elevation1};
    width: fit-content;
    background-color: ${palette.baseColors.wairua};

    transition: transform 1s ease;
    transform: scaleY(1);
  `}
`;
const MegaMenuT1Wrapper = styled.div `
  ${({ theme: { spacing, palette }, isTier2 }) => css `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 240px;

    padding-right: ${isTier2 ? spacing.s3 : 0};
    border-right: ${isTier2 ? `1px solid ${palette.baseColors.alto}` : 'none'};
  `}
`;
const OptionWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: fit-content;
    gap: ${spacing.s1};
  `}
`;
const MegaMenuT1Link = styled.a `
  ${({ theme: { spacing, borderRadius, palette }, isSelected }) => css `
    display: flex;
    text-decoration: none;
    text-wrap: wrap;
    color: ${palette.baseColors.newZealandBlack};
    box-sizing: border-box;
    ${bodyMDemiStyle};
    padding: ${spacing.s1} ${spacing.s2};
    border-radius: ${borderRadius.r5};
    background-color: ${isSelected ? palette.baseColors.pukaki : 'none'};

    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      outline-offset: 2px;
    }
  `}
`;
const Tier1FooterLinkContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    margin-top: ${spacing.s5};
    padding-left: ${spacing.s2};
  `}
`;
const MegaMenuT2Wrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-content: start;
    gap: ${spacing.s2};
    min-width: 311px;
    max-width: 744px;
    padding-left: ${spacing.s3};
  `}
`;
const MegaMenuT2Link = styled.a `
  ${({ theme: { palette, borderRadius } }) => css `
    width: 355px;
    display: flex;
    flex-direction: column;
    text-decoration: none;

    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      outline-offset: 4px;
      border-radius: ${borderRadius.rHalf};
    }
  `}
`;
const MegaMenuT2Title = styled(Text) `
  :hover {
    text-decoration: underline;
  }
`;
const StyledLink = styled(Link$1) `
  ${({ theme: { palette, borderRadius } }) => css `
    text-decoration: none;

    &:focus-visible {
      outline: 3px solid ${palette.baseColors.lupin};
      outline-offset: 4px;
      border-radius: ${borderRadius.rHalf};
    }

    &:hover {
      color: ${palette.baseColors.poroporo};
    }
  `}
`;
const MegaMenuT2Description = styled(Text) ``;
const MegaMenu = ({ optionList, isTier2, renderTier1, renderTier2, renderTier1FooterLink, setIsMegaMenuOpen, headerCategoryRef, tier1FooterLink, }) => {
    var _a;
    const [selectedOption, setSelectedOption] = useState(optionList[0]);
    const [focusState, setFocusState] = useState({
        tier1TabIndex: 0,
        tier2TabIndex: -1,
        tier1FooterLinkTabIndex: -1,
    });
    const tier1Refs = useRef([]);
    const tier2Refs = useRef([]);
    const tier1FooterLinkRef = useRef(null);
    useEffect(() => {
        var _a;
        const ref = focusState.tier2TabIndex >= 0
            ? tier2Refs.current[focusState.tier2TabIndex]
            : tier1Refs.current[focusState.tier1TabIndex];
        if (focusState.tier1FooterLinkTabIndex >= 0) {
            (_a = tier1FooterLinkRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else {
            ref === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [focusState]);
    const handleTier1KeyboardNavigation = useCallback((index, isShiftKey) => {
        var _a, _b;
        if (isShiftKey) {
            if (index > 0) {
                setFocusState({
                    tier1TabIndex: index - 1,
                    tier2TabIndex: -1,
                    tier1FooterLinkTabIndex: -1,
                });
            }
        }
        else if ((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.subOptions) === null || _a === void 0 ? void 0 : _a.length) {
            setFocusState({
                tier1TabIndex: index,
                tier2TabIndex: 0,
                tier1FooterLinkTabIndex: -1,
            });
        }
        else if (index + 1 < optionList.length) {
            setFocusState({
                tier1TabIndex: index + 1,
                tier2TabIndex: -1,
                tier1FooterLinkTabIndex: -1,
            });
        }
        else if (tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url) {
            setFocusState({
                tier1TabIndex: index,
                tier2TabIndex: -1,
                tier1FooterLinkTabIndex: 0,
            });
        }
        else {
            setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
            (_b = headerCategoryRef === null || headerCategoryRef === void 0 ? void 0 : headerCategoryRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [selectedOption, optionList, tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url]);
    const handleKeyDownTier1 = useCallback((evt, index) => {
        var _a;
        switch (evt.key) {
            case 'Tab':
                evt.preventDefault();
                handleTier1KeyboardNavigation(index, evt.shiftKey);
                if (evt.shiftKey && index === 0) {
                    setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
                    (_a = headerCategoryRef === null || headerCategoryRef === void 0 ? void 0 : headerCategoryRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
                break;
            case 'Escape':
                setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
                break;
        }
    }, [selectedOption, optionList, tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url, setIsMegaMenuOpen]);
    const selectedIndex = optionList.indexOf(selectedOption !== null && selectedOption !== void 0 ? selectedOption : optionList[0]);
    const isLastTier1 = optionList.length - 1 === selectedIndex;
    const handleTier2KeyboardNavigation = useCallback((index, isShiftKey) => {
        var _a, _b;
        if (isShiftKey) {
            if (index > 0) {
                setFocusState(Object.assign(Object.assign({}, focusState), { tier2TabIndex: index - 1 }));
            }
            else {
                setFocusState({
                    tier1TabIndex: selectedIndex,
                    tier2TabIndex: -1,
                    tier1FooterLinkTabIndex: -1,
                });
            }
        }
        else if (index + 1 < (((_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.subOptions) === null || _a === void 0 ? void 0 : _a.length) || 0)) {
            setFocusState(Object.assign(Object.assign({}, focusState), { tier2TabIndex: index + 1 }));
        }
        else if (isLastTier1 && (tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url)) {
            setFocusState({
                tier1TabIndex: focusState.tier1TabIndex,
                tier2TabIndex: -1,
                tier1FooterLinkTabIndex: 0,
            });
        }
        else if (isLastTier1 && !(tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url)) {
            setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
            (_b = headerCategoryRef === null || headerCategoryRef === void 0 ? void 0 : headerCategoryRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            setFocusState({
                tier1TabIndex: (focusState.tier1TabIndex + 1) % optionList.length,
                tier2TabIndex: -1,
                tier1FooterLinkTabIndex: -1,
            });
        }
    }, [
        selectedOption,
        tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url,
        isLastTier1,
        focusState,
        setIsMegaMenuOpen,
        headerCategoryRef,
    ]);
    const handleKeyDownTier2 = useCallback((evt, index, subOption) => {
        switch (evt.key) {
            case 'Tab':
                evt.preventDefault();
                handleTier2KeyboardNavigation(index, evt.shiftKey);
                break;
            case ' ':
                evt.preventDefault();
                window.location.href = subOption.url;
                break;
            case 'Escape':
                setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
                break;
        }
    }, [selectedOption, optionList, tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url, setIsMegaMenuOpen]);
    const handleViewAllServicesKeyDown = useCallback((evt) => {
        var _a;
        switch (evt.key) {
            case 'Escape':
                setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
                break;
            case 'Tab':
                evt.preventDefault();
                setIsMegaMenuOpen === null || setIsMegaMenuOpen === void 0 ? void 0 : setIsMegaMenuOpen(false);
                (_a = headerCategoryRef === null || headerCategoryRef === void 0 ? void 0 : headerCategoryRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                break;
        }
    }, [setIsMegaMenuOpen, headerCategoryRef]);
    const setTier1Ref = (index) => (tier1Ref) => {
        tier1Refs.current[index] = tier1Ref;
    };
    const setTier2Ref = (index) => (tier2Ref) => {
        tier2Refs.current[index] = tier2Ref;
    };
    const footerLink = (React__default.createElement(StyledLink, { href: tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url, ref: tier1FooterLinkRef, tabIndex: focusState.tier1FooterLinkTabIndex >= 0 ? 0 : -1, onKeyDown: handleViewAllServicesKeyDown }, tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.label));
    const hasTier1FooterLink = (tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.url) && (tier1FooterLink === null || tier1FooterLink === void 0 ? void 0 : tier1FooterLink.label);
    const hasSubOptions = selectedOption && selectedOption.subOptions
        ? selectedOption.subOptions.length > 0
        : false;
    const ariaExpanded = hasSubOptions ? 'true' : undefined;
    const ariaHasPopup = hasSubOptions ? 'true' : undefined;
    return (React__default.createElement(MegaMenuWrapper, { isTier2: isTier2 },
        React__default.createElement(MegaMenuT1Wrapper, { isTier2: isTier2 },
            React__default.createElement(OptionWrapper, null, optionList.map((option, index) => {
                const tier1Link = (React__default.createElement(MegaMenuT1Link, { href: option.url, onMouseEnter: () => {
                        setSelectedOption(option);
                    }, onMouseLeave: () => {
                        if (!isTier2) {
                            setSelectedOption(null);
                        }
                    }, isSelected: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.name) === option.name, key: option.name, role: "menuitem", ref: setTier1Ref(index), "aria-haspopup": ariaHasPopup, "aria-expanded": ariaExpanded, tabIndex: focusState.tier1TabIndex === index ? 0 : -1, onFocus: () => setSelectedOption(option), onKeyDown: (evt) => handleKeyDownTier1(evt, index) }, option.name));
                return renderTier1
                    ? renderTier1(Object.assign({ children: tier1Link }, option))
                    : tier1Link;
            })),
            hasTier1FooterLink ? (React__default.createElement(Tier1FooterLinkContainer, null, renderTier1FooterLink
                ? renderTier1FooterLink({ children: footerLink })
                : footerLink)) : null),
        isTier2 ? (React__default.createElement(MegaMenuT2Wrapper, null, (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.subOptions) === null || _a === void 0 ? void 0 : _a.map((subOption, index) => {
            const tier2Link = (React__default.createElement(MegaMenuT2Link, { href: subOption.url, key: subOption.name, role: "menuitem", tabIndex: focusState.tier2TabIndex === index ? 0 : -1, ref: setTier2Ref(index), onKeyDown: (evt) => handleKeyDownTier2(evt, index, subOption) },
                React__default.createElement(MegaMenuT2Title, { variant: "bodySDemi" }, subOption.name),
                React__default.createElement(MegaMenuT2Description, { variant: "footnoteMedium" }, subOption.description)));
            return renderTier2
                ? renderTier2(Object.assign(Object.assign({ children: tier2Link }, subOption), { selectedOption }))
                : tier2Link;
        }))) : null));
};

const wrapperVariant$1 = {
    enter: {},
    exit: {},
};
const AnimatedMegaMenu = styled(AnimatedComponent) `
  ${({ theme: { media } }) => css `
    display: none;

    ${media.up('big')} {
      display: block;
    }
  `}
`;
const MegaMenuFixedWrapper = styled(motion.div) `
  ${({ theme: { media }, isTier2 }) => css `
    position: fixed;
    transform: translateY(50%) translateX(-40px);
    margin-top: ${HEADER_HEIGHT}px;
    cursor: default;
    display: none;
    min-width: 240px;
    ${media.up('big')} {
      display: block;
    }

    ${isTier2
    ? css `
          left: calc(50% - 504px);
        `
    : null}
  `}
`;
const Highlight$2 = styled(motion.div) `
  ${({ theme: { borderRadius, palette, media }, headerVariant }) => css `
    ${media.up('big')} {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      border-radius: ${borderRadius.r3};
      background-color: ${headerVariant === 'reverse'
    ? palette.baseColors.wairuaOpacity12
    : palette.baseColors.pukaki};
    }
  `}
`;
const IconWrapper$3 = styled.div `
  ${({ theme: { media, spacing } }) => css `
    width: 32px;
    height: 32px;
    margin-right: ${spacing.s2};

    ${media.up('big')} {
      display: none;
    }
  `}
`;
const HeaderCategoryLabel = styled(Text) `
  ${({ theme: { borderRadius, media, palette, zIndex }, headerVariant, selected, isInHeaderAccordion, }) => css `
    font-size: ${isInHeaderAccordion ? '18px' : '20px'};
    text-wrap: wrap;
    line-height: 28px;
    border-radius: ${borderRadius.rHalf};
    transition: all 100ms ease-in-out;
    color: ${palette.baseColors.wairua};
    white-space: wrap;
    display: flex;
    align-items: center;
    width: 100%;

    &:active {
      color: ${palette.baseColors.alto};
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px ${palette.baseColors.wairua};
    }

    ${media.up('big')} {
      position: relative;
      z-index: ${zIndex.navigation};

      color: ${selected
    ? palette.baseColors.sparkPurple
    : palette.baseColors.newZealandBlack};

      &:hover {
        color: ${palette.baseColors.newZealandBlack};
      }

      &:active {
        color: ${palette.baseColors.sparkPurple};
      }

      &:focus-visible {
        box-shadow: 0 0 0 3px ${palette.baseColors.lupin};
      }

      ${headerVariant === 'reverse' &&
    css `
        color: ${selected
        ? palette.baseColors.alto
        : palette.baseColors.wairua};

        &:hover {
          color: ${palette.baseColors.wairua};
        }
      `}
    }
  `}
`;
const HeaderCategoryWrapper = styled.div `
  ${({ theme: { media, zIndex } }) => css `
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ${media.up('big')} {
      z-index: ${zIndex.navigation};
      justify-content: initial;
    }
  `}
`;
const HeaderContainer$1 = styled.div `
  position: relative;
  display: flex;
  align-items: center;
`;
const HeaderCategoryContainer = styled.a `
  ${({ theme: { borderRadius, media, palette, spacing }, headerVariant, isInHeaderAccordion, }) => css `
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    text-decoration: none;
    padding: ${spacing.s2}
      ${isInHeaderAccordion
    ? `0 ${spacing.s2} ${spacing.s3} `
    : `${spacing.s3}`};
    &:last-of-type {
      margin-bottom: 0;
    }

    &:focus-visible {
      ${HeaderCategoryLabel} {
        box-shadow: 0 0 0 2px ${palette.baseColors.wairua};
      }
    }

    ${media.up('slim')} {
      &:focus-visible {
        ${HeaderCategoryLabel} {
          box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
        }
      }
    }

    ${media.up('big')} {
      position: relative;
      padding: ${spacing.s1} 14px;
      margin: 0;
      border-radius: ${borderRadius.r3};
      transition: all 100ms ease-in-out;

      &:active {
        & > ${Highlight$2} {
          background-color: ${headerVariant === 'reverse'
    ? palette.baseColors.wairuaOpacity8
    : palette.baseColors.alto};
        }
      }

      &:focus-visible {
        ${HeaderCategoryLabel} {
          box-shadow: none;
        }

        box-shadow: 0 0 0 3px
          ${headerVariant === 'reverse'
    ? palette.baseColors.wairua
    : palette.baseColors.lupin};
      }
    }
  `}
`;
const StyledChevron = styled(Icon) `
  ${({ theme: { spacing, media } }) => css `
    ${media.up('big')} {
      margin-left: ${spacing.s1};
    }
  `}
`;
const HeaderCategoryV2 = (_a) => {
    var { children: category, isSelected, onCategoryClick, iconPath, optionList, tier1FooterLink, isInHeaderAccordion, isMobileMegaMenuOpen, renderTier1, renderTier2, renderTier1FooterLink, renderHeaderCategory } = _a, anchorProps = __rest(_a, ["children", "isSelected", "onCategoryClick", "iconPath", "optionList", "tier1FooterLink", "isInHeaderAccordion", "isMobileMegaMenuOpen", "renderTier1", "renderTier2", "renderTier1FooterLink", "renderHeaderCategory"]);
    const { variant } = useHeader();
    const { isHovered, hoverCategory } = useHover();
    const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
    const headerCategoryRef = useRef(null);
    const toggleIsMegaMenuOpen = () => setIsMegaMenuOpen((prevState) => !prevState);
    const handleScroll = () => {
        setIsMegaMenuOpen(false);
    };
    const handleOnClick = () => {
        toggleIsMegaMenuOpen();
        onCategoryClick();
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleOnClick();
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });
    const ref = useRef(null);
    const hideMegaMenu = useCallback(() => setIsMegaMenuOpen(false), []);
    const handleClickOutside = () => {
        return hideMegaMenu();
    };
    useOnClickOutside(ref, handleClickOutside);
    const isTier2 = optionList === null || optionList === void 0 ? void 0 : optionList.map((option) => { var _a; return !!((_a = option === null || option === void 0 ? void 0 : option.subOptions) === null || _a === void 0 ? void 0 : _a.length); }).includes(true);
    const { borderRadius, palette } = useTheme();
    const highlightVisible = isHovered(category);
    const Chevron = ({ isOpen }) => {
        return isOpen ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(MediaQuery, { max: "slim" },
                React__default.createElement(StyledChevron, { name: "chevron_left_small", fill: palette.baseColors.wairua })),
            React__default.createElement(MediaQuery, { min: "big" },
                React__default.createElement(StyledChevron, { name: "chevron_up_small", fill: palette.baseColors.newZealandBlack })))) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(MediaQuery, { max: "slim" },
                React__default.createElement(StyledChevron, { name: "chevron_right_small", fill: palette.baseColors.wairua })),
            React__default.createElement(MediaQuery, { min: "big" },
                React__default.createElement(StyledChevron, { name: "chevron_down_small", fill: palette.baseColors.newZealandBlack }))));
    };
    const headerCategory = (React__default.createElement(HeaderCategoryContainer, Object.assign({ headerVariant: variant, isInHeaderAccordion: isInHeaderAccordion, onMouseEnter: () => hoverCategory(category), onClick: handleOnClick, onKeyDown: handleKeyDown, tabIndex: 0, "aria-haspopup": "true", ref: headerCategoryRef }, anchorProps),
        !isMobileMegaMenuOpen && (React__default.createElement(MediaQuery, { max: "slim" },
            React__default.createElement(IconWrapper$3, null,
                React__default.createElement(IconFromDam, { imagePath: iconPath, iconColor: isSelected ? 'wairua' : 'wairuaOpacity40', height: 32, width: 32 })))),
        React__default.createElement(MediaQuery, { min: "big" },
            React__default.createElement(IconWrapper$3, null,
                React__default.createElement(IconFromDam, { imagePath: iconPath, iconColor: isSelected ? 'lupin' : 'mawheranui', height: 32, width: 32 }))),
        React__default.createElement(HeaderCategoryWrapper, null,
            React__default.createElement(HeaderCategoryLabel, { headerVariant: variant, selected: isSelected, variant: "bodyMDemi", isInHeaderAccordion: isInHeaderAccordion }, category),
            (optionList === null || optionList === void 0 ? void 0 : optionList.length) ? React__default.createElement(Chevron, { isOpen: isMegaMenuOpen }) : null)));
    return (React__default.createElement(HeaderContainer$1, { ref: ref },
        renderHeaderCategory
            ? renderHeaderCategory({ children: headerCategory })
            : headerCategory,
        React__default.createElement(AnimatedMegaMenu, null, (optionList === null || optionList === void 0 ? void 0 : optionList.length) && isMegaMenuOpen ? (React__default.createElement(MegaMenuFixedWrapper, { isTier2: isTier2 || false, variants: wrapperVariant$1, initial: "exit", animate: "enter", exit: "exit", role: "dialog", "aria-modal": "true", "aria-label": "megamenu", transition: { bounce: 0 }, onClick: (event) => {
                event.stopPropagation();
            } },
            React__default.createElement(MegaMenu, { optionList: optionList, tier1FooterLink: tier1FooterLink, isTier2: isTier2 || false, renderTier1: renderTier1, renderTier2: renderTier2, renderTier1FooterLink: renderTier1FooterLink, headerCategoryRef: headerCategoryRef, setIsMegaMenuOpen: setIsMegaMenuOpen }))) : null),
        React__default.createElement(AnimatedComponent, null, highlightVisible ? (React__default.createElement(Highlight$2, { headerVariant: variant, layoutId: "background", initial: { opacity: 0 }, animate: { opacity: 1, borderRadius: borderRadius.r3 }, exit: { opacity: 0 }, transition: TRANSITION_VALUES$1.transition })) : null)));
};

const variants$1 = {
    personal: Object.assign({ x: 0, opacity: 1, display: 'block' }, TRANSITION_VALUES$1),
    business: Object.assign({ x: -80, opacity: 0, transitionEnd: { display: 'none' } }, TRANSITION_VALUES$1),
};
const PersonalCategoriesContainer = ({ children, }) => {
    return (React__default.createElement(motion.div, { variants: variants$1 },
        React__default.createElement(HeaderCategoriesContainer$1, null, children)));
};

const MobileMegaMenuBackButtonContainer = styled.a `
  ${({ theme: { palette, spacing } }) => css `
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    text-decoration: none;
    padding: ${spacing.s1} ${spacing.s6} ${spacing.s2} ${spacing.s2};
    &:last-of-type {
      margin-bottom: 0;
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px ${palette.baseColors.wairua};
    }
  `}
`;
const StyledText$2 = styled(Text) `
  ${({ theme: { borderRadius, palette } }) => css `
    border-radius: ${borderRadius.rHalf};
    transition: all 100ms ease-in-out;
    color: ${palette.baseColors.wairua};
    overflow: hidden;
    text-wrap: wrap;

    display: flex;
    align-items: center;
    width: 100%;

    &:active {
      color: ${palette.baseColors.alto};
    }

    &:focus-visible {
      box-shadow: 0 0 0 3px ${palette.baseColors.wairua};
    }
  `}
`;
const IconWrapper$2 = styled.div `
  ${({ theme: { spacing } }) => css `
    width: 32px;
    height: 32px;
    margin: 0 ${spacing.s2};
  `}
`;
const IconGroupContainer = styled.div `
  display: flex;
  align-items: center;
  height: 28px;
`;
const MobileMegaMenuBackButton = ({ children, iconPath, onMobileMegaMenuBackButtonClick, }) => {
    const { palette } = useTheme();
    return (React__default.createElement(MobileMegaMenuBackButtonContainer, { onClick: onMobileMegaMenuBackButtonClick },
        React__default.createElement(IconGroupContainer, null,
            React__default.createElement(Icon, { name: "chevron_left_extra_small", fill: palette.baseColors.wairua }),
            React__default.createElement(IconWrapper$2, null,
                React__default.createElement(IconFromDam, { imagePath: iconPath, iconColor: "wairua", height: 32, width: 32 }))),
        React__default.createElement(StyledText$2, { variant: "subheadingM" }, children)));
};

const usePostEffect = () => {
    const isFirstRender = useRef(true);
    useEffect(() => {
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
};

const TRANSITION_VALUES = {
    transition: { type: 'tween', duration: 0.1 },
};
const MOBILE_SVG_PATH_VARIANTS = [
    {
        id: 'top-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 12 L 24 12' }, TRANSITION_VALUES),
            open: Object.assign({ stroke: colors.wairua, d: 'M 10 22 L 22 10' }, TRANSITION_VALUES),
        },
    },
    {
        id: 'middle-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 16 L 24 16', opacity: 1 }, TRANSITION_VALUES),
            open: Object.assign({ stroke: colors.wairua, d: 'M 8 16 L 24 16', opacity: 0 }, TRANSITION_VALUES),
        },
    },
    {
        id: 'bottom-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 20 L 24 20' }, TRANSITION_VALUES),
            open: Object.assign({ stroke: colors.wairua, d: 'M 10 10 L 22 22' }, TRANSITION_VALUES),
        },
    },
];
const TABLET_SVG_PATH_VARIANTS = [
    {
        id: 'top-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 12 L 24 12' }, TRANSITION_VALUES),
            open: Object.assign({ d: 'M 12 20 L 20 12' }, TRANSITION_VALUES),
        },
    },
    {
        id: 'middle-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 16 L 24 16', opacity: 1 }, TRANSITION_VALUES),
            open: Object.assign({ d: 'M 10 16 L 22 16', opacity: 0 }, TRANSITION_VALUES),
        },
    },
    {
        id: 'bottom-line',
        variants: {
            closed: Object.assign({ stroke: colors.lupin, d: 'M 8 20 L 24 20' }, TRANSITION_VALUES),
            open: Object.assign({ d: 'M 12 12 L 20 20' }, TRANSITION_VALUES),
        },
    },
];

const Path = (props) => (React__default.createElement(motion.path, Object.assign({ strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, props)));
const IconWrapper$1 = styled.div `
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const MagicBurgerSVG = ({ children, }) => {
    return (React__default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, children));
};
const MagicBurgerSVGContainer = ({ forceMobileInTablet, }) => {
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MediaQuery, { max: forceMobileInTablet ? 'slim' : 'lil' },
            React__default.createElement(IconWrapper$1, null,
                React__default.createElement(MagicBurgerSVG, null, MOBILE_SVG_PATH_VARIANTS.map(({ id, variants }) => (React__default.createElement(Path, { key: id, variants: variants })))))),
        React__default.createElement(MediaQuery, { min: forceMobileInTablet ? 'big' : 'slim' },
            React__default.createElement(IconWrapper$1, null,
                React__default.createElement(MagicBurgerSVG, null, TABLET_SVG_PATH_VARIANTS.map(({ id, variants }) => (React__default.createElement(Path, { key: id, variants: variants }))))))));
};

const MenuOverlayBackground = styled(motion.div) `
  ${({ theme: { palette, zIndex } }) => css `
    position: fixed;
    z-index: ${zIndex.overlay};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: ${palette.baseColors.poroporo};
    overflow: auto;
  `}
`;
const MenuOverlayContainer = styled(motion.div) `
  ${({ theme: { spacing }, isHeaderV2 }) => css `
    display: flex;
    justify-content: center;
    height: 100%;
    padding: ${isHeaderV2
    ? `${spacing.s2} ${spacing.s3} 0;`
    : `${spacing.s5} ${spacing.s4} ${spacing.s7}`};
  `}
`;
const MenuOverlayBottomGradient = styled.div `
  ${({ theme: { palette: { baseColors: { poroporo }, }, }, }) => css `
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    background: linear-gradient(transparent, ${poroporo} 80%);
    height: 80px;
  `}
`;
const menuOverlayTransition = {
    transition: { type: 'tween', duration: 0.2 },
};
const MenuOverlay = ({ children, isOpen, showOverlayGradient = true, isHeaderV2, }) => {
    const [overlayScrollHeight, setOverlayScrollHeight] = useState(0);
    const { windowWidth, windowHeight } = useDimensions();
    const overlayRef = useRef(null);
    useEffect(() => {
        var _a, _b;
        if (isOpen) {
            const scrollHeight = (_b = (_a = overlayRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) !== null && _b !== void 0 ? _b : 0;
            setOverlayScrollHeight(scrollHeight);
        }
    }, [isOpen, windowHeight]);
    const closedClipPath = `circle(20px at ${windowWidth - 40}px 40px)`;
    const openClipPath = `circle(${Math.hypot(windowWidth, windowHeight) / 2}px at ${windowWidth / 2}px ${windowHeight / 2}px)`;
    return (React__default.createElement(AnimatedComponent, null, isOpen ? (React__default.createElement(MenuOverlayBackground, { ref: overlayRef, initial: {
            clipPath: closedClipPath,
        }, animate: Object.assign({ clipPath: openClipPath }, menuOverlayTransition), exit: Object.assign({ clipPath: closedClipPath }, menuOverlayTransition) },
        React__default.createElement(MenuOverlayContainer, { isHeaderV2: isHeaderV2, initial: {
                x: 80,
                opacity: 0,
            }, animate: Object.assign({ x: 0, opacity: 1 }, menuOverlayTransition), exit: Object.assign({ x: 80, opacity: 0 }, menuOverlayTransition) }, children),
        overlayScrollHeight > windowHeight && showOverlayGradient && (React__default.createElement(MenuOverlayBottomGradient, null)))) : null));
};

const Popover$3 = styled(motion.div) `
  ${({ theme: { borderRadius, elevation, palette, zIndex } }) => css `
    position: fixed;
    z-index: ${zIndex.popover};
    right: 20px;
    top: ${HEADER_HEIGHT}px;
    width: 340px;
    max-height: 516px;
    overflow: auto;
    background: ${palette.baseColors.wairua};
    border-radius: ${borderRadius.r2};
    box-shadow: ${elevation.drawer};
  `}
`;
const PopoverContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    height: 100%;
    padding: ${spacing.s4} ${spacing.s4} 0;
  `}
`;
const PopoverBottomGradient = styled.div `
  ${({ theme: { palette } }) => css `
    position: sticky;
    right: 0;
    bottom: 0;
    left: 0;
    background: linear-gradient(transparent, ${palette.baseColors.wairua});
    height: 40px;
  `}
`;
const menuPopoverTransition = {
    transition: { type: 'tween', duration: 0.2 },
};
const MenuPopover = ({ children, isOpen }) => {
    return (React__default.createElement(AnimatedComponent, null, isOpen ? (React__default.createElement(Popover$3, { initial: {
            opacity: 0,
            y: -8,
        }, animate: Object.assign({ opacity: 1, y: 0 }, menuPopoverTransition), exit: Object.assign({ opacity: 0, y: -8 }, menuPopoverTransition) },
        React__default.createElement(PopoverContainer, null, children),
        React__default.createElement(PopoverBottomGradient, null))) : null));
};

const MagicBurgerPositioner = styled.div `
  ${({ theme: { borderRadius, palette, zIndex }, isOpen, isStickyNavigation, disabled, isSideNavigation, }) => css `
    top: 19px;
    right: 19px;
    position: ${isStickyNavigation ? 'fixed' : 'absolute'};
    z-index: ${!isSideNavigation && isOpen
    ? zIndex.overlay + 1
    : zIndex.overlay};
    height: 42px;
    width: 42px;
    border-radius: ${borderRadius.round};
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: ${disabled ? 'none' : 'unset'};
    opacity: ${disabled ? 0.6 : 'unset'};

    &:focus-visible {
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }
  `}
`;
const MagicBurgerContainerOpenLilMixin = css `
  ${({ theme: { palette: { baseColors: { lupin, poroporo, sparkPurple }, }, }, }) => css `
    background: ${lupin};
    &:hover {
      background: ${sparkPurple};
    }
    &:active {
      background: ${poroporo};
    }
  `}
`;
const MagicBurgerContainerOpenSlimMixin = css `
  ${({ theme: { palette: { baseColors: { pukaki, wanaka, wairua }, }, }, }) => css `
    background: ${wairua};
    &:hover {
      background: ${pukaki};
    }
    &:active {
      background: ${wanaka};
    }
  `}
`;
const MagicBurgerContainer$1 = styled(motion.div) `
  ${({ theme: { borderRadius, elevation, media, palette: { baseColors: { pukaki, wanaka, wairua }, }, }, isOpen, isHeaderV2, }) => css `
    position: relative;
    cursor: pointer;
    height: 40px;
    width: 40px;
    border-radius: ${borderRadius.round};
    box-shadow: ${elevation.headerElevation};
    transition: background-color 100ms ease-in-out;
    background: ${wairua};

    &:hover {
      background: ${pukaki};
    }

    &:active {
      background: ${wanaka};
    }

    ${isOpen && MagicBurgerContainerOpenLilMixin}

    ${media.up(isHeaderV2 ? 'big' : 'slim')} {
      ${isOpen && MagicBurgerContainerOpenSlimMixin}
    }
  `}
`;
const HeaderV2ContentWrapper = styled.div `
  width: 100%;
  max-width: 375px;
`;
const MagicBurger = ({ children, isOpen, setOpen, onClose, onOpen, isHeaderV2, isSideNavigation, showOverlayGradient = true, }) => {
    const ref = useRef(null);
    const isFirstRender = usePostEffect();
    const hideMenu = useCallback(() => setOpen(false), []);
    useOnClickOutside(ref, hideMenu);
    const { isStickyNavigation } = useHeader();
    const isMobileOnly = useMediaQuery({
        max: isHeaderV2 ? 'slim' : 'lil',
    });
    const isOverlayOpen = isMobileOnly && isOpen;
    const isPopoverOpen = !isMobileOnly && isOpen;
    useEffect(() => {
        if (isFirstRender)
            return;
        if (onClose && !isOpen)
            onClose();
        if (onOpen && isOpen)
            onOpen();
    }, [isOpen]);
    return (React__default.createElement("div", { ref: ref },
        React__default.createElement(MagicBurgerPositioner, { tabIndex: 0, role: "button", isOpen: isOpen, onClick: () => setOpen(!isOpen), onKeyDown: () => setOpen(!isOpen), isStickyNavigation: isStickyNavigation, "aria-label": "Open menu", disabled: !showOverlayGradient, isSideNavigation: isSideNavigation },
            React__default.createElement(MagicBurgerContainer$1, { animate: isOpen ? 'open' : 'closed', initial: "closed", isOpen: isOpen, isHeaderV2: isHeaderV2 },
                React__default.createElement(MediaQuery, { max: isHeaderV2 ? 'slim' : 'lil' },
                    React__default.createElement(AnimatedComponent, null, !isOpen && (React__default.createElement(motion.div, { initial: { opacity: 0 }, animate: Object.assign({ opacity: 1 }, TRANSITION_VALUES), exit: Object.assign({ opacity: 0 }, TRANSITION_VALUES) },
                        React__default.createElement(Icon, { name: "magic_button_web", size: 40 }))))),
                React__default.createElement(MediaQuery, { min: isHeaderV2 ? 'big' : 'slim' },
                    React__default.createElement(Icon, { name: "magic_button_web", size: 40 })),
                React__default.createElement(MagicBurgerSVGContainer, { forceMobileInTablet: isHeaderV2 }))),
        !isHeaderV2 && !isSideNavigation && (React__default.createElement(MediaQuery, { min: "slim", max: "slim" },
            React__default.createElement(MenuPopover, { isOpen: isPopoverOpen }, children))),
        React__default.createElement(MediaQuery, { max: isHeaderV2 ? 'slim' : 'lil' }, !isSideNavigation && (React__default.createElement(MenuOverlay, { isOpen: isOverlayOpen, showOverlayGradient: showOverlayGradient, isHeaderV2: isHeaderV2 },
            React__default.createElement(HeaderV2ContentWrapper, null, children)))),
        isSideNavigation && (React__default.createElement(MediaQuery, { max: "slim" },
            React__default.createElement(ActionLayer, { showOverlay: isOverlayOpen, isOpen: isOpen, variant: "action", onClose: onClose, onOpen: onOpen, hasLogo: true }, children)))));
};

const StyledText$1 = styled(Text) `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.wairua};
    font-size: 16px;
    overflow: hidden;
    text-wrap: nowrap;
    text-overflow: ellipsis;
  `}
`;
const StyledIcon$2 = styled(Icon) `
  ${({ theme: { palette } }) => css `
    fill: ${palette.baseColors.wairua};
  `}
`;
const HeaderFilterDropdownContainer = styled.div `
  ${({ theme: { borderRadius, palette, spacing } }) => css `
    height: 40px;
    border-radius: ${borderRadius.r3};
    border: 2px solid ${palette.baseColors.wairua};
    background-color: ${palette.baseColors.lupin};

    color: ${palette.baseColors.wairua};
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${spacing.s1} ${spacing.s3};

    :hover {
      cursor: pointer;
    }
  `}
`;
const HeaderFilterDropdownSwitcher = ({ onClick, placeholder }) => {
    return (React__default.createElement(HeaderFilterDropdownContainer, { onClick: onClick },
        React__default.createElement(StyledText$1, { variant: "bodyMMedium" }, placeholder),
        React__default.createElement(StyledIcon$2, { name: "chevron_down_small" })));
};
const HeaderFilterDropdown = ({ children, placeholder, isHeaderFilterBottomSheetOpen, setHeaderFilterBottomSheetOpen, onOpen, onClose, }) => {
    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const isFirstRender = usePostEffect();
    const handleScroll = () => {
        setPopoverOpen(false);
    };
    useEffect(() => {
        if (isFirstRender)
            return;
        if (onClose && !isPopoverOpen)
            onClose();
        if (onOpen && isPopoverOpen)
            onOpen();
    }, [isPopoverOpen]);
    useEffect(() => {
        if (isFirstRender)
            return;
        if (onClose && !isHeaderFilterBottomSheetOpen)
            onClose();
        if (onOpen && isHeaderFilterBottomSheetOpen)
            onOpen();
    }, [isHeaderFilterBottomSheetOpen]);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });
    const { zIndex } = useTheme();
    const ref = useRef(null);
    const hideProfileMenu = useCallback(() => setPopoverOpen(false), []);
    useOnClickOutside(ref, hideProfileMenu);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(HeaderFilterDropdownSwitcher, { onClick: () => setHeaderFilterBottomSheetOpen(!isHeaderFilterBottomSheetOpen), placeholder: placeholder }),
        React__default.createElement(BottomSheet, { isOpen: isHeaderFilterBottomSheetOpen, onClose: () => {
                setHeaderFilterBottomSheetOpen(false);
            }, zIndex: zIndex.overlay }, children)));
};

function HeaderFilterMenu({ onClick, MenuItems = [], }) {
    return (React__default.createElement(ProfileMenu, null,
        React__default.createElement(ProfileMenuPrimarySection, { title: "Switch to:" }, MenuItems.map((item) => {
            return (React__default.createElement(ProfileAuthenticatedPrimaryMenuLink, { key: item.value, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(item.value) }, item.label));
        }))));
}

const wrapperVariant = {
    enter: {},
    exit: {},
};
const Wrapper = styled(motion.div) `
  height: 100%;
`;
const Popover$2 = styled(motion.div) `
  ${({ theme: { borderRadius, media, zIndex, elevation, palette } }) => css `
    background: ${palette.baseColors.wairua};

    position: fixed;
    right: 60px;
    top: 0;
    overflow: auto;
    margin: 0 auto;
    border-radius: ${borderRadius.r2};
    z-index: ${zIndex.modal};
    box-shadow: ${elevation.drawer};

    ${media.up('slim')} {
      width: 206px;
    }
  `}
`;
const ProfilePillContainer$1 = styled.div ``;
const ProfilePillSwitcher = ({ onClick, text, }) => {
    const { profile, variant } = useHeader();
    const ProfilePillResponsive = variant !== 'reverse' ? ProfilePillPositive : ProfilePillReverse;
    return (React__default.createElement(ProfilePillResponsive, { type: "button", onClick: onClick }, profile ? (React__default.createElement(AuthorisedPill, null)) : (React__default.createElement(UnauthorisedPill, { text: text || 'MySpark' }))));
};
const ProfilePill = ({ children, text, onOpen, onClose, }) => {
    const { scrollY } = useHeader();
    const isDesktop = useMediaQuery({ min: 'big' });
    const [isPopoverOpen, setPopoverOpen] = useState(false);
    const [isBottomSheetOpen, setBottomOpen] = useState(false);
    const isFirstRender = usePostEffect();
    const isShowingHeaderWithSegment = scrollY <= SEGMENT_SWITCHER_HEIGHT && isDesktop;
    const handleScroll = () => {
        setPopoverOpen(false);
    };
    useEffect(() => {
        if (isFirstRender)
            return;
        if (onClose && !isPopoverOpen)
            onClose();
        if (onOpen && isPopoverOpen)
            onOpen();
    }, [isPopoverOpen]);
    useEffect(() => {
        if (isFirstRender)
            return;
        if (onClose && !isBottomSheetOpen)
            onClose();
        if (onOpen && isBottomSheetOpen)
            onOpen();
    }, [isBottomSheetOpen]);
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });
    const ref = useRef(null);
    const hideProfileMenu = useCallback(() => setPopoverOpen(false), []);
    useOnClickOutside(ref, hideProfileMenu);
    const panelVariant = {
        enter: {
            y: isShowingHeaderWithSegment
                ? HEADER_WITH_SEGMENT_SWITCHER_HEIGHT
                : HEADER_HEIGHT,
            opacity: 1,
        },
        exit: {
            y: isShowingHeaderWithSegment
                ? HEADER_WITH_SEGMENT_SWITCHER_HEIGHT - PROFILE_PILL_FADE_OFFSET
                : HEADER_HEIGHT - PROFILE_PILL_FADE_OFFSET,
            opacity: 0,
        },
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MediaQuery, { max: "lil" },
            React__default.createElement(ProfilePillSwitcher, { onClick: () => setBottomOpen(!isBottomSheetOpen), text: text }),
            React__default.createElement(BottomSheet, { isOpen: isBottomSheetOpen, onClose: () => {
                    setBottomOpen(false);
                } }, children)),
        React__default.createElement(MediaQuery, { min: "slim" },
            React__default.createElement(ProfilePillContainer$1, { ref: ref },
                React__default.createElement(ProfilePillSwitcher, { onClick: () => setPopoverOpen(!isPopoverOpen), text: text }),
                React__default.createElement(AnimatedComponent, null, isPopoverOpen && (React__default.createElement(Wrapper, { variants: wrapperVariant, initial: "exit", animate: "enter", exit: "exit", role: "dialog", "aria-modal": "true" },
                    React__default.createElement(Popover$2, { variants: panelVariant, transition: { bounce: 0 } }, children))))))));
};

const SEARCH_BAR_HEIGHT = 172;
const SEARCH_PLACE_HOLDER = `I'm looking for`;
const SEARCH_BAR_ANIMATION = {
    transition: { debounce: 0 },
    animate: { opacity: 1, marginTop: 0 },
    initial: {
        marginTop: `-${SEARCH_BAR_HEIGHT}px`,
        opacity: 0.5,
    },
    exit: { opacity: 0, marginTop: `-${SEARCH_BAR_HEIGHT}px` },
};

const StyledSearchBarWrapper = styled(motion.div) `
  ${({ theme: { palette }, variant }) => css `
    width: 100%;
    position: fixed;
    left: 0;
    background-color: ${variant === 'reverse'
    ? palette.baseColors.wairuaOpacity12
    : palette.baseColors.wairua};
  `};
`;
const IconButtonWrapper = styled.div `
  ${({ theme: { spacing } }) => css `
    position: absolute;
    right: ${spacing.s4};
  `}
`;
const SearchInputBox = styled(Box) `
  ${({ theme: { media } }) => css `
    ${media.up('slim')} {
      max-width: 704px;
      margin: 0 auto;
    }

    ${media.up('big')} {
      max-width: 1125px;
    }
  `}
`;
const HideSearchBarWrapper = ({ children, }) => {
    const { isSearchBarOpen, setIsSearchBarOpen } = useHeader();
    const handleOnClick = () => {
        if (isSearchBarOpen)
            setIsSearchBarOpen(false);
    };
    return React__default.createElement(Box, { onClick: handleOnClick }, children);
};
const SearchBar = ({ onSearchSubmit, searchUrl }) => {
    const [value, setValue] = useState('');
    const { variant, isSearchBarOpen, setIsSearchBarOpen } = useHeader();
    const onCrossIconClick = () => {
        setValue('');
    };
    const handleCloseIconClick = () => {
        setIsSearchBarOpen(false);
    };
    const handleSearchSubmit = (e) => {
        onSearchSubmit(value, searchUrl);
        e.preventDefault();
    };
    useEffect(() => {
        if (!isSearchBarOpen)
            setValue('');
        document.body.style.overflow = isSearchBarOpen ? 'hidden' : 'auto';
    }, [isSearchBarOpen]);
    return (React__default.createElement(AnimatedComponent, null, isSearchBarOpen ? (React__default.createElement(StyledSearchBarWrapper, Object.assign({ key: "searchBar" }, SEARCH_BAR_ANIMATION, { variant: variant }),
        React__default.createElement(Box, { py: ['s0', 's5', 's5'], px: ['s0', 's4', 's4'] },
            React__default.createElement(Box, { px: ['s0', 's5', 's5'] },
                React__default.createElement(IconButtonWrapper, null,
                    React__default.createElement(MediaQuery, { min: "slim" },
                        React__default.createElement(IconButton$5, { onClick: handleCloseIconClick, title: "cancel", icon: "cross_small", variant: "secondary" }))),
                React__default.createElement(SearchInputBox, { py: ['s4', 's5', 's5'], px: "s3" },
                    React__default.createElement("form", { onSubmit: handleSearchSubmit },
                        React__default.createElement(SearchInput, { type: "text", name: "searchBar", variant: "underLineInput", onCrossIconClick: onCrossIconClick, enableClearInput: true, value: value, onValueChange: setValue, inputProps: { autoFocus: true }, placeholder: SEARCH_PLACE_HOLDER }))))))) : null));
};

const SearchButton = ({ onClick, title }) => {
    const { palette: { baseColors: { wairua, newZealandBlack }, }, } = useTheme();
    const { variant } = useHeader();
    return (React__default.createElement(NavButton, { onClick: onClick, variant: variant, title: title, "aria-label": "Open search" },
        React__default.createElement(Icon, { name: "search_small", fill: variant === 'reverse' ? wairua : newZealandBlack })));
};

const HeaderSegmentSwitcherContainer = styled.div `
  ${({ theme: { media, spacing } }) => css `
    display: flex;
    margin-bottom: ${spacing.s3};
    height: 40px;

    ${media.up('slim')} {
      margin-bottom: ${spacing.s4};
    }

    ${media.up('big')} {
      padding: ${spacing.s1} ${spacing.s6};
      margin-bottom: 0;
    }
  `}
`;
const BorderBottomPurpleMixin = css `
  ${({ theme: { palette }, selected }) => css `
    border-bottom: 2px solid
      ${selected ? palette.baseColors.wairua : 'transparent'};
  `}
`;
const BorderBottomReverseMixin = css `
  ${({ theme: { palette }, selected }) => css `
    border-bottom: 2px solid
      ${selected ? palette.baseColors.lupin : 'transparent'};
  `}
`;
const BorderBottomMixin = css `
  ${({ theme: { borderRadius } }) => css `
    content: '';
    width: 8px;
    display: block;
    position: relative;
    margin: 0 auto;
    border-radius: ${borderRadius.rHalf};
    transition: border-bottom 0.1s ease-in-out;
  `}
`;
const HideBorderBottomMixin = css `
  &:after {
    display: none;
  }
`;
const LinkPurpleMixin = css `
  ${({ theme: { borderRadius, palette, spacing }, selected }) => css `
    color: ${selected ? palette.baseColors.wairua : palette.baseColors.alto};

    &:hover,
    &:active {
      color: ${palette.baseColors.wairua};

      &:after {
        ${BorderBottomMixin}
        border-bottom: 2px solid ${palette.baseColors.wairua};
      }
    }

    &:focus-visible {
      border: 2px solid ${palette.baseColors.wairua};
      border-radius: ${borderRadius.rHalf};
      padding: 0 ${spacing.s0_5};
      &:after {
        ${BorderBottomMixin}
        border-bottom: 2px solid ${palette.baseColors.wairua};
        top: 5px;
      }
    }
  `}
`;
const LinkReverseMixin = css `
  ${({ theme: { borderRadius, palette, spacing }, selected }) => css `
    color: ${selected
    ? palette.baseColors.lupin
    : palette.baseColors.greymouth};

    &:hover {
      color: ${palette.baseColors.newZealandBlack};

      &:after {
        ${BorderBottomMixin}
        border-bottom: 2px solid ${palette.baseColors.newZealandBlack};
      }
    }

    &:active {
      color: ${palette.baseColors.poroporo};

      &:after {
        ${BorderBottomMixin}
        border-bottom: 2px solid ${palette.baseColors.poroporo};
      }
    }

    &:focus-visible {
      border: 2px solid ${palette.baseColors.lupin};
      border-radius: ${borderRadius.rHalf};
      padding: 0 ${spacing.s0_5};
      &:after {
        ${BorderBottomMixin}
        border-bottom: 2px solid
          ${selected
    ? palette.baseColors.lupin
    : palette.baseColors.newZealandBlack};
        top: 5px;
      }
    }
  `}
`;
const Link = styled.a `
  ${({ theme: { media, palette, spacing, zIndex }, selected, variant }) => css `
    cursor: pointer;
    padding: ${spacing.s1} ${spacing.s3};
    line-height: 24px;
    text-decoration: none;
    border: 2px solid transparent;
    ${HideBorderBottomMixin}
    position: relative;
    z-index: ${zIndex.navigation};
    transition: color 100ms ease-in-out;
    color: ${palette.baseColors.wairua};

    &:active {
      color: ${palette.baseColors.alto};
    }

    ${media.up('slim')} {
      &:active {
        color: ${palette.baseColors.wairua};
      }
      ${!selected &&
    css `
        color: ${palette.baseColors.greymouth};

        &:hover {
          color: ${palette.baseColors.lupin};
        }

        &:active {
          color: ${palette.baseColors.sparkPurple};
        }

        &:focus-visible {
          color: ${palette.baseColors.newZealandBlack};
        }
      `}
    }

    ${media.up('big')} {
      padding: 0;
      line-height: 20px;
      &:after {
        ${BorderBottomMixin}
        ${variant === 'purple'
    ? BorderBottomPurpleMixin
    : BorderBottomReverseMixin}
      }

      ${variant === 'purple' ? LinkPurpleMixin : LinkReverseMixin}
    }
  `}
`;
const Highlight$1 = styled.div `
  ${({ theme: { borderRadius, palette, spacing, media } }) => css `
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    background-color: ${palette.baseColors.lupin};
    padding: ${spacing.s2};
    border-radius: ${borderRadius.r3};

    ${media.up('big')} {
      display: none;
    }
  `}
`;
const LinkContainer = styled.div `
  ${({ theme: { borderRadius, media, palette, spacing } }) => css `
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${borderRadius.r3};
    position: relative;
    transition: background-color 100ms ease-in-out;

    &:hover,
    &:active {
      & > ${Highlight$1} {
        background-color: ${palette.baseColors.sparkPurple};
      }
    }

    &:focus-visible {
      box-shadow:
        0 0 0 1px ${palette.baseColors.poroporo},
        0 0 0 3px ${palette.baseColors.wairua};
    }

    ${media.up('slim')} {
      &:hover {
        & > ${Highlight$1} {
          background-color: ${palette.baseColors.sparkPurple};
        }
      }

      &:active {
        & > ${Highlight$1} {
          background-color: ${palette.baseColors.poroporo};
        }
      }

      &:focus-visible {
        box-shadow:
          0 0 0 1px ${palette.baseColors.wairua},
          0 0 0 3px ${palette.baseColors.lupin};
      }
    }

    ${media.up('big')} {
      padding: 0;
      border-radius: unset;
      background: none;
      margin-right: ${spacing.s3};

      &:hover,
      &:active {
        background: none;
      }

      &:focus-visible {
        box-shadow: none;
        border: none;
      }
    }
  `}
`;
const HeaderSegmentSwitcher = ({ children, }) => (React__default.createElement(HeaderSegmentSwitcherContainer, null,
    React__default.createElement(AnimateSharedLayout, null, children)));
const HeaderSegmentSwitcherItem = (_a) => {
    var { selected, children } = _a, restOfAnchorProps = __rest(_a, ["selected", "children"]);
    const { variant } = useHeader();
    return (React__default.createElement(LinkContainer, { selected: selected, variant: variant, tabIndex: 0 },
        selected ? React__default.createElement(Highlight$1, null) : null,
        React__default.createElement(Link, Object.assign({ selected: selected, variant: variant }, restOfAnchorProps), children)));
};

const defaultUnauthenticatedMenuOptions = [
    { name: 'Top up', code: 'topup' },
    { name: 'Pay a bill', code: 'payabill' },
];
function UnauthenticatedProfileMenu({ onClick, UnauthenticatedMenuOptions = defaultUnauthenticatedMenuOptions, unauthenticatedMenuOptions = defaultUnauthenticatedMenuOptions, showSignInButton = true, }) {
    const menuOptions = unauthenticatedMenuOptions !== null && unauthenticatedMenuOptions !== void 0 ? unauthenticatedMenuOptions : UnauthenticatedMenuOptions;
    return (React__default.createElement(ProfileMenu, null,
        showSignInButton ? (React__default.createElement(ProfileMenuPrimarySection, null,
            React__default.createElement(ButtonWrapper, null,
                React__default.createElement(MediaQuery, { max: "lil" },
                    React__default.createElement(StyledButton, { onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick('signin'), variant: "primary" }, "Sign in to MySpark")),
                React__default.createElement(MediaQuery, { min: "slim" },
                    React__default.createElement(StyledButton, { onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick('signin'), variant: "primary" }, "Sign in"))))) : null,
        React__default.createElement(ProfileMenuSecondarySection, null, menuOptions.map((item) => {
            return (React__default.createElement(ProfileUnauthenticatedMenuLink, { key: item.code, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(item.code) }, item.name));
        }))));
}

const PrintOnlyLogo = styled.div `
  ${({ theme: { spacing } }) => css `
    display: none;
    @media print {
      display: block;
      padding: ${spacing.s2};
    }
  `}
`;
const StyledHeaderInternal = styled.div `
  ${({ isStickyNavigation, scrollY, hasSegmentSwitcher, theme: { media }, }) => css `
    height: ${HEADER_HEIGHT}px;
    header {
      transition: height 0.2s linear;
      height: ${HEADER_HEIGHT}px;
      ${isStickyNavigation &&
    scrollY > HEADER_HEIGHT &&
    css `
        height: 0;
      `}
    }
    ${media.up('big')} {
      height: ${hasSegmentSwitcher && HEADER_WITH_SEGMENT_SWITCHER_HEIGHT}px;
      header {
        height: ${hasSegmentSwitcher && HEADER_WITH_SEGMENT_SWITCHER_HEIGHT}px;
      }
      ${isStickyNavigation &&
    scrollY > SEGMENT_SWITCHER_HEIGHT &&
    css `
        height: ${HEADER_HEIGHT}px;
        header {
          height: ${HEADER_HEIGHT}px;
        }
      `};
    }
    @media print {
      display: none;
    }
  `}
`;
const SegmentSwitcherContainer = styled.div `
  ${({ theme: { media, palette, zIndex }, variant }) => css `
    background-color: ${variant === 'purple'
    ? palette.baseColors.sparkPurple
    : palette.baseColors.onepu};
    ${media.up('big')} {
      position: fixed;
      top: 0;
      height: 54px;
      width: 100%;
      z-index: ${zIndex.popover};
    }
  `}
`;
const IconsContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    align-items: flex-start;
    padding: ${spacing.s0_5} 0;
  `}
`;
const SearchContainer = styled.div `
  display: flex;
  position: relative;
`;
const CartContainer = styled.div `
  position: relative;
`;
const ProfilePillContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    margin: 0 ${spacing.s1_5} 0 ${spacing.s1};
  `}
`;
const MagicBurgerContainer = styled.div `
  ${({ theme: { media } }) => css `
    ${media.up('big')} {
      display: none;
    }
  `}
`;
const HeaderCategoriesContainer = styled.div `
  ${({ theme: { media } }) => css `
    display: none;

    ${media.up('big')} {
      display: block;
    }
  `}
`;
// to make the Header Categories slightly off center as per the requirement
const HeaderCategoriesSpaceLeft = styled.div `
  flex: 1.06;
`;
// to make the Header Categories slightly off center as per the requirement
const HeaderCategoriesSpaceRight = styled.div `
  flex: 0.94;
`;
const HeaderInternal = ({ components, onBurgerClose, onBurgerOpen, isHeaderV2 = false, showOverlayGradient = true, onSearchSubmit = noop, renderMagicBurger, showMagicBurger = true, dynamicTargetValue, searchUrl, }) => {
    const [isOpen, setOpen] = useState(false);
    const { isSearchBarOpen, setIsSearchBarOpen, variant, isStickyNavigation, scrollY, hasSegmentSwitcher, } = useHeader();
    const { SegmentSwitcher, BrandLogo, HeaderCategories, SearchBar: SearchBar$1 = null, SearchButton = null, CartButton, ProfilePill, } = components;
    const magicBurger = (React__default.createElement(MagicBurger, { isOpen: isOpen, setOpen: setOpen, onClose: onBurgerClose, onOpen: onBurgerOpen, isHeaderV2: isHeaderV2, showOverlayGradient: showOverlayGradient },
        SegmentSwitcher,
        HeaderCategories));
    const componentName = 'HeaderV2';
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(PrintOnlyLogo, null, BrandLogo),
        React__default.createElement(StyledHeaderInternal, { isStickyNavigation: isStickyNavigation, scrollY: scrollY, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
                ? `${componentName}-${dynamicTargetValue}`
                : componentName, "data-component-type": "Pattern Library Component", hasSegmentSwitcher: hasSegmentSwitcher },
            React__default.createElement(Drawer, { isOpen: true, onClose: () => {
                    setIsSearchBarOpen(false);
                }, hasScrollBar: true, showOverlay: isSearchBarOpen, hasInitialAnimation: false, variant: "search" },
                React__default.createElement("header", null,
                    hasSegmentSwitcher ? (React__default.createElement(MediaQuery, { min: "big" },
                        React__default.createElement(SegmentSwitcherContainer, { variant: variant }, SegmentSwitcher))) : null,
                    React__default.createElement(GlobalNavigation, { hasSegmentSwitcher: hasSegmentSwitcher },
                        React__default.createElement("div", null, BrandLogo),
                        React__default.createElement(HeaderCategoriesSpaceLeft, null),
                        React__default.createElement(HeaderCategoriesContainer, null, HeaderCategories),
                        React__default.createElement(HeaderCategoriesSpaceRight, null),
                        React__default.createElement(IconsContainer, null,
                            React__default.createElement(SearchContainer, null, SearchButton ? (React__default.createElement(HideSearchBarWrapper, null, SearchButton)) : null),
                            React__default.createElement(CartContainer, null,
                                React__default.createElement(HideSearchBarWrapper, null, CartButton)),
                            React__default.createElement(ProfilePillContainer, null,
                                React__default.createElement(HideSearchBarWrapper, null, ProfilePill)))),
                    showMagicBurger ? (React__default.createElement(MagicBurgerContainer, null,
                        React__default.createElement(HideSearchBarWrapper, null, renderMagicBurger
                            ? renderMagicBurger({ children: magicBurger })
                            : magicBurger))) : null),
                SearchBar$1 || (React__default.createElement(SearchBar, { onSearchSubmit: onSearchSubmit, searchUrl: searchUrl }))))));
};
const Header = (_a) => {
    var { variant, profile, isStickyNavigation = false, renderMagicBurger, hasSegmentSwitcher } = _a, props = __rest(_a, ["variant", "profile", "isStickyNavigation", "renderMagicBurger", "hasSegmentSwitcher"]);
    return (React__default.createElement(HeaderProvider, { variant: variant, profile: profile, isStickyNavigation: isStickyNavigation, hasSegmentSwitcher: hasSegmentSwitcher },
        React__default.createElement(HeaderInternal, Object.assign({ renderMagicBurger: renderMagicBurger }, props))));
};

const NavigationTabs = styled.div ``;

const NavigationTabText = styled(Text) `
  padding: 0;
  transition: all 100ms ease-in-out;
`;
const NavigationTabButton = styled.button `
  ${({ theme: { borderRadius, media, palette, spacing } }) => css `
    position: relative;
    margin: 0 auto;
    padding: ${spacing.s3} 0 0;
    cursor: pointer;
    background: none;
    border: none;
    border-radius: ${borderRadius.rHalf};

    &:focus-visible {
      & ${NavigationTabText} {
        border-radius: ${borderRadius.rHalf};
        box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
      }
    }

    &:hover {
      & ${NavigationTabText} {
        color: ${palette.baseColors.lupin};
      }
    }

    &:active {
      & ${NavigationTabText} {
        color: ${palette.baseColors.sparkPurple};
      }
    }

    ${media.up('slim')} {
      padding: 22px 14px 0;
    }

    ${media.up('big')} {
      padding: 22px 0 0 0;
      margin: 0 ${spacing.s5} 0 0;

      &:last-of-type {
        margin: 0;
      }
    }
  `}
`;
const Container$2 = styled.div `
  ${({ theme: { spacing } }) => css `
    position: relative;
    padding-bottom: ${spacing.s3};
  `}
`;
const SelectedUnderline = styled(motion.div) `
  ${({ theme: { borderRadius, palette, zIndex } }) => css `
    position: absolute;
    z-index: ${zIndex.default};
    right: 0;
    bottom: 0;
    left: 0;
    height: 4px;
    background: ${palette.baseColors.lupin};
    border-radius: ${borderRadius.rHalf};
  `}
`;
const NavigationTab = ({ children, isSelected, onClick, }) => {
    return (React__default.createElement(NavigationTabButton, { "aria-selected": isSelected, onClick: onClick },
        React__default.createElement(Container$2, null,
            React__default.createElement(NavigationTabText, { variant: "bodyMDemi" }, children),
            isSelected ? (React__default.createElement(SelectedUnderline, { layoutId: "underline", transition: { type: 'tween', duration: 0.2 } })) : null)));
};

const List = styled.div `
  ${({ theme: { borderRadius, media, palette } }) => css `
    display: flex;
    background: ${palette.baseColors.wairua};
    border-radius: ${borderRadius.r2} ${borderRadius.r2} 0 0;
    transition: border-radius 100ms ease-in-out;
    overflow: auto;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }

    ${media.up('big')} {
      border-radius: 0;
      background: ${palette.baseColors.onepu};
    }
  `}
`;
const OverflowGradient = styled(motion.div) `
  ${({ theme: { borderRadius, palette } }) => css `
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 20%;
    background: linear-gradient(
      to right,
      transparent,
      ${palette.baseColors.wairua} 70%
    );
    border-radius: 0 ${borderRadius.r2} 0 0;
    pointer-events: none;
  `}
`;
const Underline = styled.div `
  ${({ theme: { borderRadius, palette, media }, isSticky }) => css `
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 4px;
    background: ${palette.baseColors.alto};

    ${media.up('big')} {
      border-radius: ${borderRadius.rHalf};
      ${!isSticky &&
    css `
        margin: 0 120px;
      `}
      ${isSticky &&
    css `
        border-radius: 0;
      `}
    }
  `}
`;
const Container$1 = styled.div `
  ${({ theme: { media, palette, zIndex }, isSticky }) => css `
    position: sticky;
    top: 0;
    z-index: ${zIndex.sticky};
    & ${List} {
      ${media.up('big')} {
        padding: 0 120px;
      }
    }
    ${isSticky &&
    css `
      & ${List} {
        border-radius: 0;
        ${media.up('big')} {
          background: ${palette.baseColors.wairua};
          transition: background-color 100ms ease-in-out;
        }
      }
    `}
  `}
`;
const NavigationTabList = ({ children, }) => {
    const [isOverflow, setOverflow] = useState(false);
    const [isSticky, setSticky] = useState(false);
    const { windowWidth } = useDimensions();
    const tabListRef = useRef(null);
    const tabListContainerRef = useRef(null);
    useLayoutEffect(() => {
        if (tabListRef.current) {
            setOverflow(tabListRef.current.scrollWidth > windowWidth);
        }
    }, [windowWidth]);
    useLayoutEffect(() => {
        var _a;
        const tabList = (_a = tabListRef.current) !== null && _a !== void 0 ? _a : new HTMLDivElement();
        const handleTabListScroll = () => {
            const hasScrolledToEnd = tabList.scrollLeft + windowWidth >= tabList.scrollWidth;
            if (!isOverflow && !hasScrolledToEnd) {
                setOverflow(true);
            }
            if (isOverflow && hasScrolledToEnd) {
                setOverflow(false);
            }
        };
        tabList.addEventListener('scroll', handleTabListScroll);
        return () => tabList.removeEventListener('scroll', handleTabListScroll);
    }, [windowWidth, isOverflow]);
    useLayoutEffect(() => {
        const handleWindowScroll = () => {
            var _a, _b;
            const distanceToTopOfScreen = (_b = (_a = tabListContainerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) !== null && _b !== void 0 ? _b : 0;
            if (!isSticky && distanceToTopOfScreen === 0) {
                setSticky(true);
            }
            if (isSticky && distanceToTopOfScreen > 0) {
                setSticky(false);
            }
        };
        window.addEventListener('scroll', handleWindowScroll);
        return () => window.removeEventListener('scroll', handleWindowScroll);
    }, [windowWidth, isSticky]);
    return (React__default.createElement(AnimateSharedLayout, null,
        React__default.createElement(Container$1, { isSticky: isSticky, ref: tabListContainerRef },
            React__default.createElement(List, { role: "tablist", "aria-label": "Navigation Tabs", ref: tabListRef },
                React__default.createElement(AnimatedComponent, null, children)),
            React__default.createElement(AnimatedComponent, null, isOverflow ? (React__default.createElement(MediaQuery, { max: "slim" },
                React__default.createElement(OverflowGradient, { initial: {
                        opacity: 0,
                    }, animate: {
                        opacity: 1,
                        transition: { type: 'tween', duration: 0.1 },
                    }, exit: {
                        opacity: 0,
                        transition: { type: 'tween', duration: 0.1 },
                    } }))) : null),
            React__default.createElement(Underline, { isSticky: isSticky }))));
};

const StyledTabContainer = styled.div `
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  position: relative;
  ${({ isInTransition }) => css `
    overflow: ${isInTransition ? 'hidden' : 'unset'};
  `}
`;
const StyledTabPanel = styled.div `
  width: 100%;
  ${({ theme: { media, spacing } }) => css `
    padding-top: ${spacing.s2};

    ${media.up('slim')} {
      padding-top: ${spacing.s3};
    }

    ${media.up('big')} {
      padding-top: ${spacing.s5};
    }
  `}
`;
const StyledMotionDiv = styled(motion.div) `
  display: flex;
  flex: 1 0 100%;
  width: 100%;
  ${({ isInTransition }) => css `
    position: ${isInTransition ? 'absolute' : 'relative'};
  `}
`;
const SLIDE_DISTANCE = 300;
const variants = {
    enter: (direction) => {
        return {
            x: direction === 'right' ? SLIDE_DISTANCE : -SLIDE_DISTANCE,
            opacity: 0,
        };
    },
    center: {
        x: 0,
        opacity: 1,
    },
    exit: (direction) => {
        return {
            x: direction === 'left' ? SLIDE_DISTANCE : -SLIDE_DISTANCE,
            opacity: 0,
        };
    },
};
const usePreviousSelectedTab = (tab) => {
    const ref = useRef(tab);
    useEffect(() => {
        ref.current = tab;
    }, [tab]);
    return ref.current;
};
const NavigationTabPanel = ({ selectedTab, tabContents, }) => {
    const previousSelectedTab = usePreviousSelectedTab(selectedTab);
    const [tabKeys, setTabKeys] = useState(Object.keys(tabContents));
    const [isInTransition, setIsInTransition] = useState(false);
    useEffect(() => {
        setTabKeys(Object.keys(tabContents));
    }, [tabContents]);
    const direction = tabKeys.indexOf(selectedTab) > tabKeys.indexOf(previousSelectedTab)
        ? 'right'
        : 'left';
    return (React__default.createElement(StyledTabContainer, { isInTransition: isInTransition },
        React__default.createElement(AnimatedComponent, { initial: false, custom: direction },
            React__default.createElement(StyledMotionDiv, { key: selectedTab, custom: direction, variants: variants, initial: "enter", animate: "center", exit: "exit", transition: {
                    duration: 1,
                    ease: 'easeInOut',
                }, isInTransition: isInTransition, onAnimationStart: () => setIsInTransition(true), onAnimationComplete: () => setIsInTransition(false) },
                React__default.createElement(StyledTabPanel, null, tabContents[selectedTab])))));
};

const Body = styled.div `
  ${({ theme: { palette, borderRadius, zIndex, elevation } }) => css `
    border: 1px solid ${palette.baseColors.alto};
    border-radius: ${borderRadius.r1};
    box-shadow: ${elevation.menuDropdown};
    background-color: ${palette.baseColors.wairua};
    z-index: ${zIndex.dropdown};
    min-height: 50px;
    overflow-y: auto;
  `}
`;
function Popover$1(_a) {
    var { children, position = 'bottom', onClose, body } = _a, rest = __rest(_a, ["children", "position", "onClose", "body"]);
    return (React__default.createElement(Popover$4, Object.assign({ positions: [position], content: React__default.createElement(Body, null, body), onClickOutside: onClose }, rest), children));
}

const SecondaryNavigationLink = styled.a `
  ${({ active, theme: { palette: { baseColors: { sparkPurple, newZealandBlack, lupin }, }, spacing, borderRadius, }, }) => css `
    ${bodySMediumStyle};
    background: transparent;
    border: 1px solid transparent;
    color: ${active ? sparkPurple : newZealandBlack};
    cursor: pointer;
    font-weight: 700;
    text-decoration: none;

    &:hover {
      ${!active && `color: ${lupin}`};
    }

    &:focus-visible {
      border: 1px solid ${lupin};
      box-shadow: 0 0 0 2px ${lupin};
      border-radius: ${borderRadius.rHalf};
    }

    ${active &&
    css `
      padding-bottom: ${spacing.s1};
      border-bottom: 2px solid ${lupin};
    `}
  `}
`;
const SecondaryNavigationGradient = styled.div `
  ${({ theme: { palette: { baseColors }, }, }) => css `
    background: linear-gradient(
      180deg,
      ${baseColors.onepu} 0%,
      ${baseColors.wairua} 100%
    );
  `}
`;
const SecondaryNavigation = styled.div `
  ${({ theme: { media, spacing } }) => css `
    ${gridMixin};
    padding: ${spacing.s2} ${spacing.s1} ${spacing.s2} ${spacing.s3};
    display: flex;
    gap: ${spacing.s3};

    ${media.up('slim')} {
      padding: ${spacing.s2} 36px;
    }

    ${media.up('big')} {
      padding: ${spacing.s3} 148px;
    }
  `}
`;

const Container = styled.div `
  max-width: 300px;
`;
const MenuList = styled.ul `
  margin: 0;
  padding: 0;
`;
const MenuItem = styled.li `
  position: relative;
  display: flex;
  flex-direction: column;
`;
const MenuText = styled.div `
  ${({ theme: { spacing, zIndex } }) => css `
    padding: ${spacing.s3};
    cursor: pointer;
    z-index: ${zIndex.dropdown};
  `}
`;
const Highlight = styled(motion.div) `
  ${({ theme: { palette, borderRadius, zIndex } }) => css `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${palette.baseColors.onepu};
    z-index: ${zIndex.default};
    border-radius: ${borderRadius.r3};
  `}
`;
const TRANSITION = {
    type: 'easeInOut',
};
const SideMenu = ({ items, selected, onClick }) => {
    const { palette: { baseColors: { newZealandBlack, lupin }, }, } = useTheme();
    return (React__default.createElement(Container, null,
        React__default.createElement(AnimateSharedLayout, null,
            React__default.createElement(MenuList, null, items.map(({ subtitle, value, title }, index) => {
                const isSelected = selected === value;
                const titleColor = isSelected ? lupin : newZealandBlack;
                return (React__default.createElement(MenuItem, { key: value, onClick: () => onClick(value), "aria-controls": `Menu${index}`, "aria-selected": isSelected, role: "tab", tabIndex: index },
                    React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(MenuText, null,
                            React__default.createElement(Text, { variant: "bodyMDemi", color: titleColor }, title),
                            React__default.createElement(Text, { variant: "bodySMedium", color: newZealandBlack }, subtitle)),
                        isSelected && (React__default.createElement(Highlight, { layoutId: "outline", initial: {
                                x: -400,
                            }, transition: TRANSITION, animate: {
                                x: 0,
                            } })))));
            })))));
};

const TabsWrapper = styled.div `
  ${({ theme: { palette } }) => css `
    display: flex;
    width: 100%;
    overflow-x: auto;
    box-shadow:
      inset 0 -1px 0 ${palette.baseColors.wairua},
      inset 0 -5px 0 ${palette.baseColors.alto};
    border-radius: 2px;
    ::-webkit-scrollbar {
      display: none;
    }
  `}
`;
const TextStyleMixin = styled.div `
  ${({ theme: { palette }, selected }) => css `
    color: ${selected
    ? palette.baseColors.lupin
    : palette.baseColors.newZealandBlack};
    ${subheadingMStyle};

    &:hover {
      ${!selected && `color: ${palette.baseColors.lupin}`};
    }
  `}
`;
const UnderlineAnimation = styled(motion.div) `
  ${({ theme: { palette } }) => css `
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 2px;
    border-bottom: 4px solid ${palette.baseColors.lupin};
  `}
`;
const Tab = styled.button `
  ${({ theme: { media, spacing, borderRadius } }) => css `
    position: relative;
    cursor: pointer;
    white-space: nowrap;
    background: transparent;
    border: 1px solid transparent;
    border-radius: ${borderRadius.rHalf};
    outline: none;
    padding: 0 0 ${spacing.s1_5};
    margin-right: ${spacing.s4};

    &:last-child {
      margin-right: 0;
    }

    ${media.up('slim')} {
      padding-bottom: 20px;
      margin-right: ${spacing.s5};
    }

    ${media.up('big')} {
      padding-bottom: 28px;
      margin-right: ${spacing.s8};
    }
  `}
`;
const StyledIcon$1 = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    margin-right: ${spacing.s1};
  `}
`;
const IconImage = styled.img `
  ${({ theme: { spacing, media } }) => css `
    margin-right: ${spacing.s1};
    width: auto;
    height: 24px;

    ${media.up('big')} {
      height: 32px;
    }
  `}
`;
const TabOptionWrapper = styled.div `
  display: flex;
  align-items: center;
`;
const TabLabel = styled.div `
  ${({ theme: { palette, borderRadius } }) => css `
    position: relative;
    cursor: pointer;
    border-radius: ${borderRadius.rHalf};
    &:focus-visible {
      border: 1px solid ${palette.baseColors.lupin};
      box-shadow: 0 0 0 2px ${palette.baseColors.lupin};
    }
  `}
`;
function Tabs(props) {
    const { className, options, selected, onTabSelected, dynamicTargetValue = '', } = props;
    const componentName = 'Tabs';
    return (React__default.createElement(AnimateSharedLayout, null,
        React__default.createElement(TabsWrapper, { role: "tablist", className: className, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
                ? `${componentName}-${dynamicTargetValue}`
                : componentName, "data-component-type": "Pattern Library Component" }, options.map((_a) => {
            var { value, label } = _a, rest = __rest(_a, ["value", "label"]);
            const isSelected = value === selected;
            const icon = 'icon' in rest ? rest === null || rest === void 0 ? void 0 : rest.icon : null;
            const iconUrl = 'iconUrl' in rest ? rest === null || rest === void 0 ? void 0 : rest.iconUrl : null;
            return (React__default.createElement(Tab, { key: label, type: "button", onClick: () => {
                    onTabSelected(value);
                }, role: "tab", selected: isSelected, tabIndex: -1, "aria-selected": isSelected, "aria-label": label },
                React__default.createElement(TabOptionWrapper, null,
                    icon ? (React__default.createElement(React__default.Fragment, null,
                        React__default.createElement(MediaQuery, { max: "slim" }, icon.smallIconName ? (React__default.createElement(StyledIcon$1, { name: icon.smallIconName })) : null),
                        React__default.createElement(MediaQuery, { min: "big" }, icon.largeIconName ? (React__default.createElement(StyledIcon$1, { name: icon.largeIconName })) : null))) : null,
                    iconUrl ? (React__default.createElement("div", null,
                        React__default.createElement(IconImage, { src: iconUrl, alt: `${label} logo` }))) : null,
                    React__default.createElement(TabLabel, { selected: isSelected, tabIndex: 0 },
                        React__default.createElement(TextStyleMixin, { selected: isSelected }, label))),
                isSelected ? (React__default.createElement(UnderlineAnimation, { layoutId: "underline", transition: {
                        type: 'spring',
                        bounce: 0,
                        duration: 0.5,
                    } })) : null));
        }))));
}

const HeaderContainer = styled.div `
  ${({ theme: { spacing, palette, media } }) => css `
    display: flex;
    flex-direction: column;
    gap: ${spacing.s2};
    color: ${palette.baseColors.newZealandBlack};
    ${media.up('big')} {
      padding: 0 ${spacing.s2};
    }
  `}
`;
const LeftNavigationHeader = ({ headerTitle, headerSubTitle, changeText, changeLink, linkComponent, }) => {
    const { palette } = useTheme();
    return (React__default.createElement(HeaderContainer, null,
        React__default.createElement(Box, { flexDirection: "column", gap: "s1", px: "s2" },
            React__default.createElement(Text, { variant: "bodyMDemi" }, headerTitle),
            headerSubTitle ? (React__default.createElement(Text, { variant: "footnoteMedium", color: palette.baseColors.mawheranui }, headerSubTitle)) : null),
        changeLink ? (React__default.createElement(Box, { pl: "s2" },
            React__default.createElement(Button$2, { variant: "textbutton", component: linkComponent, href: changeLink, textStyle: "footNoteDemi" }, changeText))) : null,
        React__default.createElement(Divider$1, null)));
};

const MotionWrapper = ({ children, action }) => {
    const animationX = (action === null || action === void 0 ? void 0 : action.action) === 'drill-down' ? [0, -50, 50, 0] : [0, 50, -50, 0];
    if (action === null) {
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return (React__default.createElement(motion.div, { key: `${action.action}-${action.counter}`, initial: { x: 0 }, animate: { x: animationX, opacity: [1, 0, 0, 1] }, transition: { duration: 0.3 } }, children));
};

const ItemContainer = styled.button `
  ${({ theme: { spacing, palette, borderRadius }, isSelected }) => css `
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    border-radius: ${borderRadius.r2};
    padding: ${spacing.s1} ${spacing.s2};
    text-decoration: none;
    width: 100%;
    cursor: pointer;
    border: none;
    background-color: ${isSelected
    ? palette.baseColors.wanaka
    : palette.baseColors.wairua};

    &:hover {
      background-color: ${isSelected
    ? palette.baseColors.wanaka
    : palette.baseColors.pukaki};
    }

    &:focus-visible {
      outline: 2px solid ${palette.baseColors.lupin};
    }
  `}
`;
const ItemTitleWithIcon = ({ item, isChildTier = false }) => (React__default.createElement(React__default.Fragment, null,
    React__default.createElement(Box, { flexDirection: "row", justifyContent: "flex-start", gap: "s1" },
        'menuItemIcon' in item && item.menuItemIcon.trim().length > 0 ? (React__default.createElement(IconFromDam, { imagePath: item.menuItemIconLink, height: 24, width: 24, iconColor: "newZealandBlack" })) : null,
        isChildTier ? (React__default.createElement(Text, { variant: "bodySMedium" }, item.menuItemTitle)) : (React__default.createElement(Text, { variant: "bodySDemi" }, item.menuItemTitle))),
    item.openInNewTab === 'true' ? (React__default.createElement(IconFromDam, { imagePath: DAM_SVG_ICON_EXTERNAL_LINK, height: 16, width: 16, iconColor: "newZealandBlack" })) : null));
const Item = ({ children, item, onItemClick, isSelected, linkComponent, isParentTitle = false, }) => {
    const commonItemProps = {
        isSelected,
        onClick: () => onItemClick(item),
        tabIndex: 0,
    };
    if (item.openInNewTab === 'true') {
        return (React__default.createElement(ItemContainer, Object.assign({ as: "a", href: item.menuItemLink, target: "_blank", rel: "noopener noreferrer" }, commonItemProps), children));
    }
    if (item.subOptions.length > 0 || isParentTitle === true) {
        return (React__default.createElement(ItemContainer, Object.assign({ as: "button" }, commonItemProps), children));
    }
    return (React__default.createElement(ItemContainer, Object.assign({ as: linkComponent, href: item.menuItemLink }, commonItemProps), children));
};

const MenuItemsContainer = styled.div `
  ${({ theme: { spacing, media }, scrollableHeight }) => css `
    ${media.up('big')} {
      max-height: ${scrollableHeight};
      overflow-y: auto;
    }
    padding-right: ${spacing.s2};

    ::-webkit-scrollbar {
      ${CustomScrollbarMixin}
    }

    ::-webkit-scrollbar-track {
      ${CustomScrollbarTrackMixin}
    }

    ::-webkit-scrollbar-thumb {
      ${CustomScrollbarThumbMixin}
    }
  `}
`;
const MenuItemsList = styled.ul `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    gap: ${spacing.s2};
    list-style-type: none;
    margin: 0;
    padding-left: 0;
  `}
`;
const ItemWrapper = styled.li `
  list-style-type: none;
  width: 100%;
  height: 100%;
`;
const InnerItemLayout = styled(Box) `
  width: 100%;
`;
const MenuItems = ({ menuItems, onItemClick, selectedOptionTitle, isShowingChildTier, scrollableHeight, linkComponent, }) => {
    const isMobile = useMediaQuery({ max: 'slim' });
    return (React__default.createElement(MenuItemsContainer, { scrollableHeight: scrollableHeight, isMobile: isMobile },
        React__default.createElement(MenuItemsList, null, menuItems.map((item) => (React__default.createElement(ItemWrapper, { key: item.menuItemTitle, "aria-current": selectedOptionTitle === item.menuItemTitle ? 'page' : undefined },
            React__default.createElement(Item, { item: item, onItemClick: onItemClick, isSelected: selectedOptionTitle === item.menuItemTitle, linkComponent: linkComponent },
                React__default.createElement(InnerItemLayout, { flexDirection: "row", justifyContent: "space-between", alignItems: "center", ml: isShowingChildTier ? 's3' : 's0' },
                    React__default.createElement(ItemTitleWithIcon, { item: item, isChildTier: isShowingChildTier }),
                    item.subOptions.length > 0 ? (React__default.createElement(IconFromDam, { imagePath: DAM_SVG_ICON_CHEVRON_RIGHT, height: 24, width: 16, iconColor: "newZealandBlack" })) : null))))))));
};

const PreviousTierItem = ({ previousTierItem, drillUp, linkComponent, }) => {
    const isMobile = useMediaQuery({ max: 'slim' });
    return (React__default.createElement(Box, { pr: !isMobile ? 's2' : 's0' },
        React__default.createElement(Item, { item: previousTierItem, onItemClick: drillUp, isSelected: false, isParentTitle: true, linkComponent: linkComponent },
            React__default.createElement(Box, { justifyContent: "flex-start", flexDirection: "row", gap: "s1" },
                React__default.createElement(IconFromDam, { imagePath: DAM_SVG_ICON_CHEVRON_LEFT, height: 24, width: 16, iconColor: "newZealandBlack" }),
                React__default.createElement(ItemTitleWithIcon, { item: previousTierItem })))));
};

const calculateScrollableHeight = ({ topNavigationHeight, headerSubTitle, changeText, singleSpacingBlock, }) => {
    // might need to update if the side navigation design changes
    // https://www.figma.com/file/C924CDZwYmn2sbhFMH0aL6/My-Spark-Business-Navigation?type=design&node-id=5411-4743&mode=design&t=8hqTOdTzhfTgIBxn-0
    const topNavHeightValue = topNavigationHeight
        ? parseInt(topNavigationHeight, 10)
        : 0;
    const singleSpacingValue = parseInt(singleSpacingBlock, 10);
    const topMarginSpacingValue = 3 * singleSpacingValue;
    const headerSpacingValue = 3 * singleSpacingValue;
    const subtitleSpacingValue = headerSubTitle ? 4 * singleSpacingValue : 0;
    const changeTextSpacingValue = changeText ? 5 * singleSpacingValue : 0;
    const dividerSpacingValue = 4 * singleSpacingValue;
    const parentTitleSpacingValue = 5 * singleSpacingValue;
    const occupiesSpacingValue = topNavHeightValue +
        topMarginSpacingValue +
        headerSpacingValue +
        subtitleSpacingValue +
        changeTextSpacingValue +
        dividerSpacingValue +
        parentTitleSpacingValue;
    return `calc(100vh - ${occupiesSpacingValue}px)`;
};

const LeftNavigationContainer = styled.div `
  ${({ theme: { spacing, palette, media }, width }) => css `
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    width: ${width};
    background-color: ${palette.baseColors.wairua};
    padding: ${spacing.s3} 0;
    gap: ${spacing.s2};
    ${media.up('big')} {
      border-right: 1px solid ${palette.baseColors.alto};
    }
  `}
`;
const MenuContainer = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    flex-direction: column;
    gap: ${spacing.s1};
    margin: 0;
    padding-left: ${spacing.s2};
    list-style-type: none;
  `}
`;
const LeftNavigation = ({ width = '280px', topNavigationHeight, headerTitle, headerSubTitle, changeText, changeLink, menuItems, linkComponent, }) => {
    var _a;
    const [navStack, setNavStack] = useState([]);
    const [selectedOptionTitle, setSelectedOptionTitle] = useState(null);
    const [motionAction, setMotionAction] = useState(null);
    const { spacing } = useTheme();
    useEffect(() => {
        if (menuItems.length > 0) {
            setNavStack([{ title: '', items: menuItems }]);
        }
    }, [menuItems]);
    const drillDown = (item) => {
        setMotionAction((prev) => ({
            action: 'drill-down',
            counter: prev ? prev.counter + 1 : 0,
        }));
        setNavStack([
            ...navStack,
            {
                title: item.menuItemTitle,
                titleIcon: 'menuItemIcon' in item ? item.menuItemIcon : '',
                titleIconLink: 'menuItemIcon' in item ? item.menuItemIconLink : '',
                items: item.subOptions,
            },
        ]);
    };
    const drillUp = () => {
        setSelectedOptionTitle(null);
        if (navStack.length > 1) {
            setMotionAction((prev) => ({
                action: 'drill-up',
                counter: prev ? prev.counter + 1 : 0,
            }));
            setNavStack(navStack.slice(0, -1));
        }
    };
    const handleMenuItemClick = (item) => {
        setSelectedOptionTitle(item.menuItemTitle);
        if (item.subOptions.length > 0) {
            drillDown(item);
        }
    };
    const { items: currentMenu, title: currentTitle } = (_a = navStack[navStack.length - 1]) !== null && _a !== void 0 ? _a : {};
    const previousTierItem = {
        menuItemTitle: currentTitle,
        menuItemLink: '',
        openInNewTab: 'false',
        subOptions: [],
    };
    const isShowingChildTier = navStack.length > 1;
    const scrollableHeight = calculateScrollableHeight({
        topNavigationHeight,
        headerSubTitle,
        changeText,
        singleSpacingBlock: spacing.s1,
    });
    return (React__default.createElement(LeftNavigationContainer, { width: width },
        React__default.createElement(LeftNavigationHeader, { headerTitle: headerTitle, headerSubTitle: headerSubTitle, changeText: changeText, changeLink: changeLink, linkComponent: linkComponent }),
        React__default.createElement(MotionWrapper, { action: motionAction },
            React__default.createElement(MenuContainer, null,
                isShowingChildTier ? (React__default.createElement(PreviousTierItem, { drillUp: drillUp, previousTierItem: previousTierItem, linkComponent: linkComponent })) : null,
                React__default.createElement(MenuItems, { menuItems: currentMenu !== null && currentMenu !== void 0 ? currentMenu : [], onItemClick: handleMenuItemClick, selectedOptionTitle: selectedOptionTitle, isShowingChildTier: isShowingChildTier, scrollableHeight: scrollableHeight, linkComponent: linkComponent })))));
};

const TopNavigationContainer = styled.div `
  ${({ theme: { spacing, palette }, height }) => css `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: ${height};
    padding: ${spacing.s2} ${spacing.s4};
    border-bottom: 1px solid ${palette.baseColors.alto};
  `}
`;
const Popover = styled(motion.div) `
  ${({ theme: { borderRadius, zIndex, elevation, palette } }) => css `
    background: ${palette.baseColors.wairua};
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 10px;
    border-radius: ${borderRadius.r2};
    z-index: ${zIndex.modal};
    box-shadow: ${elevation.drawer};
  `}
`;
const TopNavigation = ({ height = '80px', linkComponent, organisationName, userInfo, menuItems, LeftNavigation, }) => {
    const [profileMenuPopped, setProfileMenuPopped] = useState(false);
    const [isOpen, setOpen] = useState(false);
    const menuRef = useRef(null);
    const pillRef = useRef(null);
    const hideProfileMenu = useCallback(() => setProfileMenuPopped(false), []);
    useOnClickOutside(menuRef, hideProfileMenu, pillRef);
    useEffect(() => {
        const handleScroll = () => setProfileMenuPopped(false);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const isMobile = useMediaQuery({ max: 'slim' });
    return (React__default.createElement(TopNavigationContainer, { height: height },
        React__default.createElement(Logo, null),
        React__default.createElement(Box, { flexDirection: "row", gap: "s3" },
            React__default.createElement(ProfilePill$1, { ref: pillRef, userInfo: userInfo, profileMenuPopped: profileMenuPopped, onProfilePillClicked: () => setProfileMenuPopped((prevState) => !prevState) }),
            isMobile ? (React__default.createElement(MagicBurger, { isOpen: isOpen, setOpen: setOpen, onClose: () => setOpen(false), isSideNavigation: true }, LeftNavigation)) : null),
        React__default.createElement(AnimatedComponent, null, profileMenuPopped ? (React__default.createElement(Popover, { ref: menuRef, key: "profile-menu", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.3 } },
            React__default.createElement(ProfileMenu$1, { organisationName: organisationName, userInfo: userInfo, menuItems: menuItems, linkComponent: linkComponent }))) : null)));
};

const IconWrapper = styled.div `
  width: 24px;
  height: 24px;
`;
const ClickableTextWrapper = styled.button `
  ${({ theme: { spacing } }) => css `
    width: 100%;
    display: flex;
    align-items: center;
    border: 2px solid transparent;
    text-decoration: none;
    gap: ${spacing.s1};
  `};
`;
const menuItemActiveStyle = css `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.sparkPurple};
    ${bodySDemiStyle}
  `};
`;
const menuItemInactiveStyle = css `
  ${({ theme: { palette } }) => css `
    color: ${palette.baseColors.greymouth};
  `};
`;
const DropdownNavigationMenuItemText = styled(Text) `
  ${({ isActive }) => (isActive ? menuItemActiveStyle : menuItemInactiveStyle)};
`;
const dropdownNavigationMenuItemTextDemiStyle = css `
  ${DropdownNavigationMenuItemText} {
    ${bodySDemiStyle}
  }
`;
const dropdownNavigationMenuItemTextSMediumStyle = css `
  ${DropdownNavigationMenuItemText} {
    ${bodySMediumStyle}
  }
`;
const categoryItemTextStyle = css `
  ${({ theme: { borderRadius, spacing } }) => css `
    border-radius: ${borderRadius.r2};
    padding: ${spacing.s1} ${spacing.s2};
  `};
`;
const hoveredCategoryItemTextStyle = css `
  ${({ theme: { palette } }) => css `
    border-color: ${palette.baseColors.onepu};
    background-color: ${palette.baseColors.onepu};
  `};
`;
const LastLevelItemIndicator = styled.div `
  ${({ theme: { palette, borderRadius }, isActive }) => `
      width: 4px;
      border-radius: ${borderRadius.rQuarter};
      background-color: ${isActive ? palette.baseColors.sparkPurple : palette.baseColors.alto};
    `};
`;
const lastLevelItemWithIndicatorStyle = css `
  ${({ theme: { spacing, palette: { baseColors }, borderRadius, }, }) => css `
    padding-left: ${spacing.s0_5};
    padding-right: ${spacing.s0_5};
    &:first-child {
      padding-top: ${spacing.s1};
    }
    ${ClickableTextWrapper} {
      border-top-right-radius: ${borderRadius.r2};
      border-bottom-right-radius: ${borderRadius.r2};
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      padding: ${spacing.s1} ${spacing.s2};
    }

    &:hover {
      ${ClickableTextWrapper} {
        text-decoration-line: underline;
        text-decoration-style: solid;
        text-decoration-skip-ink: none;
        text-decoration-thickness: auto;
        text-underline-offset: auto;
        text-underline-position: from-font;
        text-decoration-color: ${baseColors.greymouth};
      }
    }
  `};
`;
const lastLevelItemWithOutIndicatorStyle = css `
  ${ClickableTextWrapper} {
    ${categoryItemTextStyle}
  }

  &:hover {
    ${ClickableTextWrapper} {
      ${hoveredCategoryItemTextStyle}
    }
  }
`;
const LastLevelItem = styled.div `
  ${({ useIndicatorStyle = false, useLooseStyle = false, isRootCategory = false, isActive = false, theme: { spacing, palette: { baseColors }, }, }) => css `
    display: flex;
    position: relative;
    justify-content: space-between;
    padding-bottom: ${useLooseStyle ? spacing.s1 : 0};
    ${useIndicatorStyle
    ? lastLevelItemWithIndicatorStyle
    : lastLevelItemWithOutIndicatorStyle}
    &:hover {
      ${ClickableTextWrapper} {
        ${isRootCategory || isActive
    ? dropdownNavigationMenuItemTextDemiStyle
    : dropdownNavigationMenuItemTextSMediumStyle}
      }
    }
    &:focus,
    &:focus-visible {
      ${ClickableTextWrapper} {
        border-color: ${baseColors.sparkPurple};
      }
    }
  `};
`;
const SublevelItem = styled.section `
  ${({ theme: { spacing, media }, showIcon = false }) => css `
    padding-left: ${showIcon ? spacing.s8 : spacing.s2};
    ${media.up('slim')} {
      padding-left: ${showIcon ? spacing.s6 : spacing.s2};
    }
  `}
`;
const StyledAccordionItemBodyWithAnimation = styled(AccordionItemBodyWithAnimation) `
  margin-top: 0px;
  padding: 0px;
`;
const DropdownNavigationAccordionItemHeading = styled(AccordionItemHeading) `
  ${({ theme: { spacing, palette, borderRadius }, disableFocus = false, isRootCategory = false, isActive = false, }) => css `
    padding: 0px ${spacing.s2} 0px 0px;
    border: 2px solid transparent;
    border-radius: ${borderRadius.r2};
    ${ClickableTextWrapper} {
      margin-right: ${spacing.s1};
      border-width: 0;
      padding: ${spacing.s1} ${spacing.s2};
    }

    &:hover {
      ${hoveredCategoryItemTextStyle}
      ${isRootCategory || isActive
    ? dropdownNavigationMenuItemTextDemiStyle
    : dropdownNavigationMenuItemTextSMediumStyle}
    }

    ${!disableFocus
    ? css `
          &:focus {
            border-color: ${palette.baseColors.sparkPurple};
            ${isRootCategory || isActive
        ? dropdownNavigationMenuItemTextDemiStyle
        : dropdownNavigationMenuItemTextSMediumStyle}
            svg,
            svg path,
            svg text {
              fill: ${palette.baseColors.sparkPurple};
            }
          }
        `
    : ''}

    &:focus-visible {
      border-color: ${palette.baseColors.sparkPurple};
      border-radius: ${borderRadius.r2};
      outline: none;
    }
  `}
`;
const StyledAccordionItem = styled(AccordionItem) `
  ${({ theme: { spacing }, useLooseStyle = false }) => css `
    padding-bottom: ${useLooseStyle ? spacing.s1 : 0};
  `}
`;
const DropdownNavigationMenuGroup = ({ iconName = 'chevron_down_small', maxLevel, levelsUsingIndicatorStyle = [3], linkComponent, maxSubItems, item, useCategoryTitleAsLink = false, onItemClicked, hasIcon, }) => {
    const { palette: { baseColors: { newZealandBlack, sparkPurple }, }, } = useTheme();
    const getMenuItemsToRender = () => {
        const menuItems = item.children || [];
        if (maxSubItems && menuItems.length > maxSubItems) {
            return [
                ...menuItems.slice(0, maxSubItems),
                {
                    title: 'View more',
                    path: item.path,
                    active: false,
                    level: menuItems[0].level,
                    children: [],
                },
            ];
        }
        return menuItems;
    };
    const menuItemsToRender = getMenuItemsToRender();
    const [currentExpandedItems, setCurrentExpandedItems] = useState(menuItemsToRender
        .filter((menuItem) => menuItem.active)
        .map((menuItem) => menuItem.path));
    const handleTitleClick = (menuItem, isLastLevel) => (event) => {
        if (!isLastLevel) {
            if (useCategoryTitleAsLink) {
                event.stopPropagation();
            }
            else {
                event.preventDefault();
            }
        }
        onItemClicked === null || onItemClicked === void 0 ? void 0 : onItemClicked(menuItem, useCategoryTitleAsLink || isLastLevel);
    };
    const renderIcon = (isActive, iconPath) => {
        return (React__default.createElement(IconWrapper, null, iconPath ? (React__default.createElement(IconFromDam, { imagePath: iconPath, height: 24, width: 24, iconColor: isActive ? 'sparkPurple' : 'newZealandBlack' })) : null));
    };
    const renderMenuTitle = (child, isLastLevel = false, showIndicator = false) => {
        const showIcon = hasIcon && child.level === 1 && !showIndicator;
        return (React__default.createElement(ClickableTextWrapper, { as: linkComponent, href: child.path, onClick: handleTitleClick(child, isLastLevel), tabIndex: -1 },
            showIcon && renderIcon(child.active, child.iconPath),
            React__default.createElement(DropdownNavigationMenuItemText, { isActive: child.active, variant: "bodySMedium" }, child.title)));
    };
    return (React__default.createElement(Accordion, { onChange: (expandedItems) => {
            setCurrentExpandedItems(expandedItems);
        } }, menuItemsToRender.map((child) => {
        const key = child.path;
        const isOpen = currentExpandedItems.includes(child.path);
        const isLastLevel = child.level === maxLevel ||
            !child.children ||
            child.children.length === 0;
        const isRootCategory = child.level === 1;
        if (isLastLevel) {
            const showIndicatorStyle = levelsUsingIndicatorStyle.includes(child.level);
            return (React__default.createElement(LastLevelItem, { useIndicatorStyle: showIndicatorStyle, key: key, useLooseStyle: isRootCategory, isActive: child.active, tabIndex: 0 },
                showIndicatorStyle && (React__default.createElement(LastLevelItemIndicator, { isActive: child.active })),
                renderMenuTitle(child, true, showIndicatorStyle)));
        }
        return (React__default.createElement(StyledAccordionItem, { key: key, uuid: key, isOpen: isOpen, "data-target-id": `Accordion-${key}`, disableBorder: true, useLooseStyle: isRootCategory },
            React__default.createElement(DropdownNavigationAccordionItemHeading, { disableFocus: true, isRootCategory: isRootCategory, isActive: child.active },
                renderMenuTitle(child),
                React__default.createElement(AccordionButton, { isOpen: isOpen, iconName: iconName, iconSize: 16, tabIndex: -1, iconColor: child.active ? sparkPurple : newZealandBlack })),
            React__default.createElement(StyledAccordionItemBodyWithAnimation, { isOpen: isOpen },
                React__default.createElement(SublevelItem, { showIcon: hasIcon },
                    React__default.createElement(DropdownNavigationMenuGroup, { maxLevel: maxLevel, linkComponent: linkComponent, iconName: iconName, maxSubItems: maxSubItems || 10, onItemClicked: onItemClicked, useCategoryTitleAsLink: useCategoryTitleAsLink, item: child })))));
    })));
};

const DEFAULT_WIDTH = '600px';
const StyledIconButton = styled(IconButton$5) `
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  width: 24px;
  height: 24px;
  &:hover {
    background: transparent;
    border: none;
  }

  &:active {
    background: transparent;
    border: none;
  }

  &:focus-within {
    outline: none;
    background: transparent;
    border: none;
  }

  &:focus-within:before {
    border: none;
    border-radius: inherit;
    content: '';
  }
  ${({ theme: { media } }) => css `
    ${media.up('big')} {
      display: none;
    }
  `}
`;
const DropdownNavigationHeaderInner = styled.div `
  ${({ theme: { spacing } }) => css `
    display: flex;
    gap: ${spacing.s1};
  `}
`;
const DropdownNavigationWrapper = styled.div `
  ${({ theme: { spacing, palette, media }, width, shouldHideRightDivider, }) => css `
    width: ${width};
    padding: ${spacing.s3} ${spacing.s4};

    background-color: ${palette.baseColors.wairua};
    display: flex;
    flex-direction: column;
    gap: ${spacing.s1};
    overflow: hidden;
    ${media.up('big')} {
      padding: ${spacing.s1} ${spacing.s3} ${spacing.s1} ${spacing.s1};
      ${shouldHideRightDivider
    ? ``
    : `border-right: 2px solid ${palette.baseColors.alto};`}
    }
  `}
`;
const DropdownNavigationMenuGroupWrapper = styled.div `
  ${({ theme: { media }, isOpen }) => css `
    ${isOpen ? `display: block;` : `display: none;`}
    flex: 1 1 auto;
    overflow-y: auto;
    ${media.up('big')} {
      display: block;
    }
  `}
`;
const DropdownNavigationHeader = styled.div `
  ${({ theme: { palette, spacing, media } }) => css `
    padding: ${spacing.s1} ${spacing.s2};
    background-color: ${palette.baseColors.alto};
    border: 2px solid ${palette.baseColors.alto};
    border-radius: ${spacing.s2};
    display: flex;
    gap: ${spacing.s1};
    align-items: center;

    ${media.up('big')} {
      border-radius: none;
      background-color: transparent;
      border-color: transparent;
    }
  `}
`;
const DropdownNavigation = ({ item, linkComponent, iconName, maxLevel = 3, width = DEFAULT_WIDTH, useCategoryTitleAsLink, onItemClicked, shouldHideRightDivider = false, }) => {
    var _a;
    const { iconPath } = item;
    const [isMenuOpen, setIsMenuOpen] = React__default.useState(false);
    const { palette: { baseColors: { newZealandBlack }, }, } = useTheme();
    const hasIcon = (_a = item.children) === null || _a === void 0 ? void 0 : _a.some((child) => !!child.iconPath && child.level === 1);
    return (React__default.createElement(DropdownNavigationWrapper, { width: width, shouldHideRightDivider: shouldHideRightDivider },
        React__default.createElement(DropdownNavigationHeader, null,
            React__default.createElement(StyledIconButton, { icon: isMenuOpen ? 'cross_extra_small' : 'burger_small', onClick: () => setIsMenuOpen(!isMenuOpen), iconFillColor: newZealandBlack }),
            React__default.createElement(MediaQuery, { max: "slim" },
                React__default.createElement(Text, { variant: "subheadingL" }, item.title)),
            React__default.createElement(MediaQuery, { min: "big" },
                React__default.createElement(DropdownNavigationHeaderInner, null,
                    iconPath ? (React__default.createElement(IconFromDam, { imagePath: iconPath, height: 24, width: 24, iconColor: "newZealandBlack" })) : null,
                    React__default.createElement(Text, { variant: "bodyMDemi" }, item.title)))),
        React__default.createElement(DropdownNavigationMenuGroupWrapper, { isOpen: isMenuOpen }, item.children && (React__default.createElement(DropdownNavigationMenuGroup, { maxLevel: maxLevel, iconName: iconName, linkComponent: linkComponent, item: item, useCategoryTitleAsLink: useCategoryTitleAsLink, onItemClicked: onItemClicked, hasIcon: hasIcon })))));
};

const FeatureTitle = styled.div `
  display: flex;
`;
const FeatureDescription = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-left: ${spacing.s4};
  `}
`;
const StyledIcon = styled(Icon) `
  ${({ theme: { spacing } }) => css `
    margin-right: ${spacing.s1};
  `}
`;
const FeatureIcon = styled.img `
  ${({ theme: { spacing } }) => css `
    display: flex;
    align-items: center;
    height: 24px;
    width: 24px;
    margin-right: ${spacing.s1};
  `}
`;
const InfoIconWrapper = styled(Clickable) `
  position: absolute;
`;
const TextWithIcon = styled(Text) `
  position: relative;
`;
const TextWithMargin = styled.span `
  ${({ theme: { spacing } }) => css `
    margin-right: ${spacing.s1};
  `}
`;
const ProductCardFeature = ({ iconName, iconUrl, title, description, fillColor, textColor, disabled, className, handleInfoIconClick, }) => {
    const { palette: { baseColors }, } = useTheme();
    const textWithIconColor = disabled
        ? baseColors.moeraki
        : textColor || baseColors.newZealandBlack;
    return (React__default.createElement("div", { className: className },
        React__default.createElement(FeatureTitle, null,
            iconName ? (React__default.createElement(StyledIcon, { name: iconName, fill: disabled ? baseColors.moeraki : fillColor })) : null,
            iconUrl ? React__default.createElement(FeatureIcon, { src: iconUrl, alt: "feature-icon" }) : null,
            React__default.createElement(TextWithIcon, { variant: "bodySMedium", color: textWithIconColor },
                React__default.createElement(TextWithMargin, null, title),
                handleInfoIconClick ? (React__default.createElement(InfoIconWrapper, { title: `${title} information icon`, onClick: handleInfoIconClick, hasRoundedFocus: true },
                    React__default.createElement(Icon, { name: "info_small", fill: baseColors.lupin }))) : null)),
        description ? (React__default.createElement(FeatureDescription, { variant: "footnoteMedium", color: disabled ? baseColors.moeraki : baseColors.mawheranui }, description)) : null));
};

// TODO: replace { style: 'decimal' } with 'currency' and 'narrowSymbol' after getting intl polyfill working.
function formatNZD(value, numDecimals = 2) {
    const formmattedDecimalNumber = new Intl.NumberFormat('en-NZ', {
        style: 'decimal',
        maximumFractionDigits: numDecimals,
        minimumFractionDigits: numDecimals,
    }).format(value);
    return `$${formmattedDecimalNumber}`;
}

const StyledText = styled(Text) `
  white-space: pre;
`;
const ProductPrice = ({ price, conditionsApply, disabled, }) => {
    const { palette: { baseColors }, } = useTheme();
    const { priceValue, pricePeriod, isGstExcl } = price;
    return (React__default.createElement(Box, { flexDirection: "row", alignItems: "baseline" },
        React__default.createElement(Text, { variant: "headingS", color: disabled ? baseColors.moeraki : baseColors.newZealandBlack }, formatNZD(priceValue)),
        conditionsApply ? (React__default.createElement(Text, { variant: "headingS", color: disabled ? baseColors.moeraki : baseColors.newZealandBlack }, "*")) : null,
        pricePeriod ? (React__default.createElement(StyledText, { variant: "bodySMedium", color: disabled ? baseColors.moeraki : baseColors.newZealandBlack }, `/${pricePeriod}`)) : null,
        isGstExcl ? (React__default.createElement(StyledText, { variant: "bodySMedium", color: disabled ? baseColors.moeraki : baseColors.mawheranui }, ` (excl. GST)`)) : null));
};

const BannerContainer = styled(Box) `
  ${({ theme: { spacing } }) => css `
    margin: ${spacing.s2} -${spacing.s4} 0;
  `}
`;
const StyledInfoBanner = styled(InfoBanner) `
  border-radius: 0;
`;
const ProductCardPromotion = ({ title, description, variant = 'text', }) => {
    const { palette: { baseColors }, } = useTheme();
    return variant === 'text' ? (React__default.createElement(Text, { variant: "footnoteMedium", color: baseColors.mawhero }, title)) : (React__default.createElement(BannerContainer, null,
        React__default.createElement(StyledInfoBanner, { variant: "IMPORTANT", isCustomChildrenEnabled: true },
            React__default.createElement(Text, { variant: "bodySMedium", color: baseColors.sparkPink }, title),
            description ? (React__default.createElement(Text, { variant: "footnoteMedium" }, description)) : null)));
};

const getBackgroundColor = ({ hasMessage, disabled, palette, }) => {
    if (hasMessage) {
        if (disabled) {
            return palette.baseColors.moeraki;
        }
        return palette.baseColors.sparkPink;
    }
    return 'transparent';
};
const TabContainer = styled.div `
  ${({ theme: { palette, zIndex, spacing, borderRadius, media }, hasMessage, disabled, isSingleProduct, displayMessage, }) => css `
    height: 40px;
    background: ${getBackgroundColor({ hasMessage, disabled, palette })};
    border-radius: ${borderRadius.r0_75};
    z-index: ${zIndex.negative};
    width: 100%;
    display: ${hasMessage ? 'flex' : 'none'};
    justify-content: center;
    align-items: center;
    margin-bottom: -${spacing.s1};
    padding: 0 ${spacing.s4};

    ${media.up('slim')} {
      display: ${displayMessage ? 'flex' : 'none'};
      width: ${isSingleProduct ? 'fit-content' : 'auto'};
    }
  `}
`;
const MarketingTitleText = styled(Text) `
  ${({ theme: { spacing } }) => css `
    margin-bottom: ${spacing.s1};
  `}
`;
const ProductCardMarketingTab = ({ disabled, children, isSingleProduct, keepMarketingTabHeight, }) => {
    const { palette: { baseColors }, } = useTheme();
    return (React__default.createElement(TabContainer, { displayMessage: keepMarketingTabHeight || Boolean(children), hasMessage: Boolean(children), disabled: disabled, isSingleProduct: isSingleProduct },
        React__default.createElement(MarketingTitleText, { variant: "footnoteDemi", color: baseColors.wairua }, children)));
};

const animateOpacity = keyframes `
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
/**
 * Action Button needs to be 100% on all view ports
 */
const ProductCardButton = styled(Button$2) `
  width: 100%;
`;
const ProductCardMedia = styled.div `
  ${({ theme: { palette }, disabled, backgroundUrl }) => css `
    align-items: center;
    background: ${backgroundUrl
    ? `url(${backgroundUrl})`
    : palette.baseColors.newZealandBlack};
    background-size: cover;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    height: 200px;
    justify-content: center;
    opacity: ${disabled ? 0.5 : 1};
  `}
`;
const ProductCardContainer = styled.div `
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const ProductCardContent = styled.div `
  ${({ theme: { borderRadius, elevation, palette } }) => css `
    background: ${palette.baseColors.wairua};
    box-shadow: ${elevation.elevation1};
    border-radius: ${borderRadius.r0_75};
    z-index: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    animation: ${animateOpacity} 0.2s linear;
  `}
`;
const ProductCardSection = styled.div `
  ${({ theme: { spacing } }) => css `
    padding: ${spacing.s4};
  `}
`;
const BaseProductCard = ({ children, className, marketingMessage, title, disabled, isSingleProduct = false, keepMarketingTabHeight = true, dynamicTargetValue = '', }) => {
    const componentName = 'Base Product Card';
    return (React__default.createElement(ProductCardContainer, { className: className, "data-testid": "base-product-card", title: title, "data-component-name": componentName, "data-target-component-id": dynamicTargetValue
            ? `${componentName}-${dynamicTargetValue}`
            : componentName, "data-component-type": "Pattern Library Component" },
        React__default.createElement(FloatUp, { delay: 0.3 },
            React__default.createElement(ProductCardMarketingTab, { disabled: disabled, isSingleProduct: isSingleProduct, keepMarketingTabHeight: keepMarketingTabHeight }, marketingMessage)),
        React__default.createElement(ProductCardContent, null, children)));
};

const CenterComponents = css `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const CenterComponentWrapper = styled.div `
  ${CenterComponents}
`;
const CenterComponentColumn = css `
  display: 'flex';
  flex-direction: 'column';
  justify-content: 'center';
  align-items: 'center';
  width: '100%';
`;
const CenterComponentColumnWrapper = styled.div `
  ${CenterComponentColumn}
`;
const FixedWidthWrapper = styled.div `
  ${({ theme: { media } }) => css `
    width: 280px;

    ${media.up('slim')} {
      width: 360px;
    }
  `}
`;
const FixedWidthWrapperWithMargins = styled(FixedWidthWrapper) `
  ${({ theme: { spacing } }) => css `
    > * {
      margin-bottom: ${spacing.s4};
    }
  `}
`;

const fontPathInDam = '/content/dam/patternlibrary/fonts/avenir-next/';
const createSparkGlobalStyle = (baseFontPath) => createGlobalStyle `
  ${normalize}

  @font-face {
    font-family: "Avenir Next";
    src: url("${baseFontPath}AvenirNextW05-Medium.woff2");
    src: url("${baseFontPath}AvenirNextW05-Medium.woff2") format("woff2");
  }

  @font-face {
    font-family: "Avenir Next";
    src: url("${baseFontPath}AvenirNextW05-Demi.woff2");
    src: url("${baseFontPath}AvenirNextW05-Demi.woff2") format("woff2");
    font-weight: bold;
  }

  @font-face {
    font-family: "Avenir Next";
    src: url("${baseFontPath}AvenirNextW05-MediumItalic.woff2");
    src: url("${baseFontPath}AvenirNextW05-MediumItalic.woff2") format("woff2");
    font-style: italic;
  }

  @font-face {
    font-family: "Avenir Next";
    src: url("${baseFontPath}AvenirNextW05-MediumItalic.woff2");
    src: url("${baseFontPath}AvenirNextW05-MediumItalic.woff2") format("woff2");
    font-style: oblique;
  }

  html {
    box-sizing: border-box;
    scroll-behavior: smooth;
  }

  *, *:before, *:after {
    font-family: 'Avenir Next', Helvetica, Arial, sans-serif;
    box-sizing: inherit;
    outline: none;
  }
`;
const SparkThemeProvider = ({ children, domain, theme = lightTheme, }) => {
    const baseFontPath = `${domain}${fontPathInDam}`;
    const GlobalStyle = createSparkGlobalStyle(baseFontPath);
    return (React__default.createElement(ThemeProvider, { theme: theme },
        React__default.createElement(GlobalStyle, null),
        children));
};

export { Accordion, AccordionButton, AccordionHorizontalLine$1 as AccordionHorizontalLine, AccordionItem, AccordionItemBody, AccordionItemBodyWithAnimation, AccordionItemHeading, AccordionTitle, AccordionVerticalLine$1 as AccordionVerticalLine, AccordionWrapper, ActionHeader, ActionLayer, ActionLayerFeedbackButton, ActionLayerFeedbackContent, ActionLayerFeedbackMessage, ActionLayerSubtitleContainer, ActionLayerTitleContainer, ActionLayerWithLogo, ActionTitle, AnimatedComponent, ArticleCard, ArticleGallery, AuthenticatedProfileMenu, AutocompleteInput, Avatar, Banner, BannerVariant, BaseProductCard, BottomSheet, Box, BrandLogo, Breadcrumb, Breadcrumbs, BusinessCategoriesContainer, Button$2 as Button, ButtonStyles, ButtonVariantMap, Card, CardHeader, Carousel, CarouselNextButton, CarouselPager, CarouselPrevButton, CartButton, CategorySwitcher, CenterComponentColumn, CenterComponentColumnWrapper, CenterComponentWrapper, CenterComponents, Checkbox, CheckboxGroup, ChoiceBox, ChoiceChips, ChoiceboxGroup, Clickable, CodeInput, ColorInput, ContentLayer, ContentLayerTitle, CurrencyInput, CustomScrollbarMixin, CustomScrollbarThumbMixin, CustomScrollbarTrackMixin, DAM_SPARK_PURPLE_LOGO, DAM_SVG_ICON_CHEVRON_DOWN, DAM_SVG_ICON_CHEVRON_LEFT, DAM_SVG_ICON_CHEVRON_RIGHT, DAM_SVG_ICON_EXTERNAL_LINK, DatePicker, Default, Destructive, Divider$1 as Divider, Drawer, DrawerContent, DrawerOverlay, DrawerPanel, DropdownNavigation, ErrorFeedback, FOOTER_BASE_SECTION, FeedbackAlert, FileInput, Filter, FilterChip, FilterChips, FilterChipsDismissible, FilterDropdown, FixedWidthWrapper, FixedWidthWrapperWithMargins, FloatUp, FocusHeader, Footer, FooterAccordion, FooterAccordionBodyLink, FooterAccordionContainer, FooterAccordionIcon, FooterAccordionItem, FooterAccordionItemBody, FooterAccordionItemHeadingButton, FooterAccordionScrollEffect, FooterBase, FooterBaseContainerWithSideNav, FooterBaseFullWidthContainer, FooterBaseLinkWithSideNavLayout, FooterBaseLinkWithTopNavLayout, FooterContainer, FooterLink, FooterLinkMenu, FooterLinkMenuHeading, FooterLinkMenuItem, Form, FormCheckBox, FormChoiceBoxGroup, FormCurrencyInput, FormDatePicker, FormDropdown, FormMaskInput, FormNumberInput, FormSubmitButton, FormTextInput, FormFormDropdown as FormWrappedDropdown, GalleryPopup as FullScreenPopup, GlobalAlert, GoogleMapsLink, Grid, GridColumn, Container$f as GridContainer, Row as GridRow, Header, HeaderAccordion, HeaderAccordionButton, HeaderAccordionItem, HeaderAccordionItemBodyWithAnimation, HeaderAccordionItemHeading, HeaderCategories, HeaderCategoriesContainer$1 as HeaderCategoriesContainer, HeaderCategory, HeaderCategoryV2, HeaderFilterDropdown, HeaderFilterMenu, HeaderSegmentSwitcher, HeaderSegmentSwitcherItem, Icon, IconButton$5 as IconButton, IconFromDam, Image, ImageGalleryPopup, InfoBanner, InfoBox, InfoStrip, InfoTextButton, InformationLayer, InformationLayerTitle, InputContainer, InputFooter, InputHeader, InvertedBorderDiv, InvertedBorderWrapper, ItemTitleWithIcon, LeftNavigation, LegalLinks, Link$1 as Link, LinkMenu, LinkMenuItems, LinkStyle, List$1 as List, ListItem, ListItemCTA, ListItemContent, LiveDemo, LoadingFeedback, LoadingSpinner, Logo$1 as Logo, MagicBurger, MaskInput, MediaQuery, MegaMenu, MobileMegaMenuBackButton, Modal, NavigationTab, NavigationTabList, NavigationTabPanel, NavigationTabs, Notch, NumberInput, PHONE_INPUT_DEFAULT_LANDLINE_PREFIX_OPTIONS, PHONE_INPUT_DEFAULT_LANDLINE_VALIDATION_RULE, PHONE_INPUT_DEFAULT_MOBILE_PREFIX_OPTIONS, PHONE_INPUT_DEFAULT_MOBILE_VALIDATION_RULE, PHONE_INPUT_DEFAULT_OPTIONS, PHONE_INPUT_DEFAULT_VALIDATION_RULE, PersonalCategoriesContainer, PhoneInput, Pill, Popover$1 as Popover, Primary, ProductCardButton, ProductCardFeature, ProductCardMarketingTab, ProductCardMedia, ProductPrice as ProductCardPrice, ProductCardPromotion, ProductCardSection, ProductGallery, ProductGalleryPrimaryImage, ProductGalleryStickyWrapper, ProductGalleryZoomableImage, ProfilePill, ProgressBar, ProgressIndicator, ProgressTracker, QuickLinkCard, RadioButton, RadioGroup, RawHtml, RawText, RawTextWithCustomSpacing, RichTextEditor, SearchAutocomplete$1 as SearchAutocomplete, SearchBar, SearchButton, SearchInput, SearchSuggestionText, SecondaryNavigation, SecondaryNavigationGradient, SecondaryNavigationLink, SegmentedControl, SideMenu, Slider, Snackbar, SnackbarProvider, SocialMediaLinks, Spacer, SparkContentLoader, SparkThemeProvider, Step, Stepper, StoreFinder$1 as StoreFinder, StyledAccordionItemButton, StyledFooterAccordionIcon, StyledInput$1 as StyledInput, StyledVideoPlayer, SuccessFeedback, SuggestionText$1 as SuggestionText, SvgIcon, Switch, Tabs, TeaserCard, Text, TextButton, TextInput$1 as TextInput, TextInputV2, TextVariantMap, ThumbnailImage, ThumbnailSlider, ThumbnailsSliderWrapper, TopNavigation, UnauthenticatedProfileMenu, Underline$1 as Underline, VideoPlayer, ZoomableImageContainer, bodyMDemiStyle, bodyMMediumStyle, bodySDemiStyle, bodySMediumStyle, borderRadius, breakpoints, codeSnippetStyle, colors, darkTheme, defaultRenderSuggestion, defaultRenderWithWrapper, elevation, footNoteDemiStyle, footNoteMediumStyle, getEmptyCode, getEmptyCodeString, getPanelAnimationValues, getResponsiveSpacing, getResponsiveValue, gridMixin, headingLStyle, headingMStyle, headingSStyle, lightTheme, parsePhoneNumber, renderSuggestion, spacing, splitMatchingSuggestionText, splitMatchingText, subheadingLStyle, subheadingMStyle, transformCodeToString, transformStringToCode, useCarouselControl, useHeader, useMediaQuery, useSnackbar, zIndex };
//# sourceMappingURL=index.esm.js.map
